import * as i0 from '@angular/core';
import { Injectable, NgModule, input, Directive, inject, EnvironmentInjector, output, computed, signal, model, runInInjectionContext, Component, viewChild, effect, Pipe } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i2 from '@angular/forms';
import { NG_VALIDATORS, FormsModule, ReactiveFormsModule, NonNullableFormBuilder, Validators, FormGroup } from '@angular/forms';
import * as i6 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import * as i4 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i3 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i4$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i11 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i5 from '@angular/material/timepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i9 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i8 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i5$1 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i7 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import * as i10 from '@angular/material/tooltip';
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { debounceTime } from 'rxjs';
import * as i2$2 from '@angular/router';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import * as i2$1 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
function VulcanDateTimePickerComponent_Conditional_1_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date outside of minimum range ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date is invalid ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date outside of maximum range ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Start Date cannot be after End Date ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date and Time cannot match ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Value isn't a valid time ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Time is too early ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Time is too late ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" Time must be in ", ctx_r2.friendlyInterval(), " intervals ");
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 15)(1, "mat-label");
    i0.ɵɵtext(2, "Start Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 16, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.startValue, $event) || (ctx_r2.startValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-timepicker-toggle", 11)(6, "mat-timepicker", 17, 3);
    i0.ɵɵelementStart(8, "mat-error");
    i0.ɵɵtemplate(9, VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_9_Template, 1, 0)(10, VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_10_Template, 1, 0)(11, VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_11_Template, 1, 0)(12, VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Conditional_12_Template, 1, 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_11_0;
    const startTimePicker_r5 = i0.ɵɵreference(4);
    const startTime_r6 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("flex-grow", ctx_r2.config().grow ? 1 : 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.startValue);
    i0.ɵɵproperty("matTimepicker", startTime_r6)("matTimepickerMin", ctx_r2.startTimeMinimum())("matTimepickerMax", ctx_r2.startTimeMaximum())("outOfRangeOtherDate", (tmp_11_0 = ctx_r2.dateForm().controls.end) == null ? null : tmp_11_0.value)("coerceInterval", ctx_r2.config().timeInterval);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", startTime_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("interval", ctx_r2.config().timeInterval || "15m");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional((startTimePicker_r5.errors == null ? null : startTimePicker_r5.errors["matTimepickerParse"]) ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((startTimePicker_r5.errors == null ? null : startTimePicker_r5.errors["matTimepickerMin"]) ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((startTimePicker_r5.errors == null ? null : startTimePicker_r5.errors["matTimepickerMax"]) ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((startTimePicker_r5.errors == null ? null : startTimePicker_r5.errors["coerceInterval"]) ? 12 : -1);
  }
}
function VulcanDateTimePickerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 9);
    i0.ɵɵlistener("click", function VulcanDateTimePickerComponent_Conditional_1_Template_mat_form_field_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const startDate_r2 = i0.ɵɵreference(9);
      return i0.ɵɵresetView(startDate_r2.open());
    });
    i0.ɵɵelementStart(1, "mat-label");
    i0.ɵɵtext(2, "Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 10, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function VulcanDateTimePickerComponent_Conditional_1_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.startValue, $event) || (ctx_r2.startValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-datepicker-toggle", 11)(6, "mat-icon", 12);
    i0.ɵɵtext(7, "calendar_month");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(8, "mat-datepicker", 13, 1);
    i0.ɵɵelementStart(10, "mat-error");
    i0.ɵɵtemplate(11, VulcanDateTimePickerComponent_Conditional_1_Conditional_11_Template, 1, 0)(12, VulcanDateTimePickerComponent_Conditional_1_Conditional_12_Template, 1, 0)(13, VulcanDateTimePickerComponent_Conditional_1_Conditional_13_Template, 1, 0)(14, VulcanDateTimePickerComponent_Conditional_1_Conditional_14_Template, 1, 0)(15, VulcanDateTimePickerComponent_Conditional_1_Conditional_15_Template, 1, 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, VulcanDateTimePickerComponent_Conditional_1_Conditional_16_Template, 13, 14, "mat-form-field", 14);
  }
  if (rf & 2) {
    let tmp_8_0;
    const startDateInput_r7 = i0.ɵɵreference(4);
    const startDate_r2 = i0.ɵɵreference(9);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("flex-grow", ctx_r2.config().grow ? 1 : 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.startValue);
    i0.ɵɵproperty("matDatepicker", startDate_r2)("min", ctx_r2.config().startMinDate)("max", ctx_r2.config().startMaxDate)("outOfRangeOtherDate", (tmp_8_0 = ctx_r2.dateForm().controls.end) == null ? null : tmp_8_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", startDate_r2);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional((startDateInput_r7.errors == null ? null : startDateInput_r7.errors["matDatepickerMin"]) ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((startDateInput_r7.errors == null ? null : startDateInput_r7.errors["matDatepickerParse"]) ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((startDateInput_r7.errors == null ? null : startDateInput_r7.errors["matDatepickerMax"]) ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((startDateInput_r7.errors == null ? null : startDateInput_r7.errors["outOfRange"]) ? 14 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((startDateInput_r7.errors == null ? null : startDateInput_r7.errors["timesMatch"]) ? 15 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showTimePicker() ? 16 : -1);
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date outside of minimum range ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date is invalid ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date outside of maximum range ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " End Date cannot be before Start Date ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Date and Time cannot match ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Value isn't a valid time ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Time is too early ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Time is too late ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" Time must be in ", ctx_r2.friendlyInterval(), " intervals ");
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 15)(1, "mat-label");
    i0.ɵɵtext(2, "End Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 19, 6);
    i0.ɵɵtwoWayListener("ngModelChange", function VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.endValue, $event) || (ctx_r2.endValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-timepicker-toggle", 11)(6, "mat-timepicker", 17, 7);
    i0.ɵɵelementStart(8, "mat-error");
    i0.ɵɵtemplate(9, VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_9_Template, 1, 0)(10, VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_10_Template, 1, 0)(11, VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_11_Template, 1, 0)(12, VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Conditional_12_Template, 1, 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const endTimePicker_r11 = i0.ɵɵreference(4);
    const endTime_r12 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("flex-grow", ctx_r2.config().grow ? 1 : 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matTimepicker", endTime_r12);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.endValue);
    i0.ɵɵproperty("matTimepickerMin", ctx_r2.endTimeMinimum())("matTimepickerMax", ctx_r2.endTimeMaximum())("coerceInterval", ctx_r2.config().timeInterval);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", endTime_r12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("interval", ctx_r2.config().timeInterval || "15m");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional((endTimePicker_r11.errors == null ? null : endTimePicker_r11.errors["matTimepickerParse"]) ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((endTimePicker_r11.errors == null ? null : endTimePicker_r11.errors["matTimepickerMin"]) ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((endTimePicker_r11.errors == null ? null : endTimePicker_r11.errors["matTimepickerMax"]) ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((endTimePicker_r11.errors == null ? null : endTimePicker_r11.errors["coerceInterval"]) ? 12 : -1);
  }
}
function VulcanDateTimePickerComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 9);
    i0.ɵɵlistener("click", function VulcanDateTimePickerComponent_Conditional_2_Template_mat_form_field_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const endDate_r9 = i0.ɵɵreference(9);
      return i0.ɵɵresetView(endDate_r9.open());
    });
    i0.ɵɵelementStart(1, "mat-label");
    i0.ɵɵtext(2, "End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 18, 4);
    i0.ɵɵtwoWayListener("ngModelChange", function VulcanDateTimePickerComponent_Conditional_2_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.endValue, $event) || (ctx_r2.endValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-datepicker-toggle", 11)(6, "mat-icon", 12);
    i0.ɵɵtext(7, "calendar_month");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(8, "mat-datepicker", 13, 5);
    i0.ɵɵelementStart(10, "mat-error");
    i0.ɵɵtemplate(11, VulcanDateTimePickerComponent_Conditional_2_Conditional_11_Template, 1, 0)(12, VulcanDateTimePickerComponent_Conditional_2_Conditional_12_Template, 1, 0)(13, VulcanDateTimePickerComponent_Conditional_2_Conditional_13_Template, 1, 0)(14, VulcanDateTimePickerComponent_Conditional_2_Conditional_14_Template, 1, 0)(15, VulcanDateTimePickerComponent_Conditional_2_Conditional_15_Template, 1, 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, VulcanDateTimePickerComponent_Conditional_2_Conditional_16_Template, 13, 13, "mat-form-field", 14);
  }
  if (rf & 2) {
    let tmp_8_0;
    const endDateInput_r13 = i0.ɵɵreference(4);
    const endDate_r9 = i0.ɵɵreference(9);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("flex-grow", ctx_r2.config().grow ? 1 : 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("min", ctx_r2.config().endMinDate || ctx_r2.startValue())("max", ctx_r2.config().endMaxDate)("matDatepicker", endDate_r9);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.endValue);
    i0.ɵɵproperty("outOfRangeOtherDate", (tmp_8_0 = ctx_r2.dateForm().controls.start) == null ? null : tmp_8_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", endDate_r9);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional((endDateInput_r13.errors == null ? null : endDateInput_r13.errors["matDatepickerMin"]) ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((endDateInput_r13.errors == null ? null : endDateInput_r13.errors["matDatepickerParse"]) ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((endDateInput_r13.errors == null ? null : endDateInput_r13.errors["matDatepickerMax"]) ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((endDateInput_r13.errors == null ? null : endDateInput_r13.errors["outOfRange"]) ? 14 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((endDateInput_r13.errors == null ? null : endDateInput_r13.errors["timesMatch"]) ? 15 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showTimePicker() ? 16 : -1);
  }
}
const _c0 = a0 => ({
  "--divider-color": a0
});
const _c1 = (a0, a1) => [a0, a1];
const _c2 = a0 => ({
  "--icon-size": a0
});
const _c3 = ["tabGroup"];
function VulcanLocationFilterComponent_Conditional_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const level_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", level_r1)("id", "aggregation-level-option-" + level_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 3, level_r1.toString()), " ");
  }
}
function VulcanLocationFilterComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 6)(2, "mat-form-field", 7)(3, "mat-label");
    i0.ɵɵtext(4, " Aggregation Level");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-select", 8);
    i0.ɵɵrepeaterCreate(6, VulcanLocationFilterComponent_Conditional_2_For_7_Template, 3, 5, "mat-option", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mat-error");
    i0.ɵɵtext(9, " An aggregation level is required.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "p");
    i0.ɵɵtext(11, " Aggregation Level will determine which codes are used to get data. All levels will utilize a state's FIPS Code except County, which uses its own code. ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵrepeater(ctx_r1.aggregationLevels());
  }
}
function VulcanLocationFilterComponent_Conditional_3_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 19);
    i0.ɵɵtext(1, "At least one state must be selected");
    i0.ɵɵelementEnd();
  }
}
function VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-checkbox", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const county_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("color", ctx_r1.m2CheckboxColor())("id", "county-checkbox-" + county_r6.value.geoid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", county_r6.value.name, " ");
  }
}
function VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵtemplate(1, VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Conditional_1_Template, 2, 3, "mat-checkbox", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const county_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", county_r6);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.matchesSearch(county_r6.value.name, true) ? 1 : -1);
  }
}
function VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 23)(3, "h3");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16)(6, "button", 24);
    i0.ɵɵlistener("click", function VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_Template_button_click_6_listener() {
      const state_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleAll(true, state_r5.value.state));
    });
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "done_all");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "button", 25);
    i0.ɵɵlistener("click", function VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_Template_button_click_9_listener() {
      const state_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleAll(false, state_r5.value.state));
    });
    i0.ɵɵelementStart(10, "mat-icon");
    i0.ɵɵtext(11, "cancel");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(12, "div", 20);
    i0.ɵɵelementContainerStart(13, 26);
    i0.ɵɵrepeaterCreate(14, VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Template, 2, 2, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const state_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", state_r5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(state_r5.value.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "select-all-for-state-" + state_r5.value.name)("matTooltip", "Select All: " + state_r5.value.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", "clear-all-for-state-" + state_r5.value.name)("matTooltip", "Clear All: " + state_r5.value.name);
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r1.getCounties(state_r5).controls);
  }
}
function VulcanLocationFilterComponent_Conditional_3_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementContainerStart(1, 21);
    i0.ɵɵrepeaterCreate(2, VulcanLocationFilterComponent_Conditional_3_Conditional_23_For_3_Template, 16, 6, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.countiesThatMatchSearch);
  }
}
function VulcanLocationFilterComponent_Conditional_3_Conditional_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("No county names match \"", ctx_r1.countySearchValue, "\"");
  }
}
function VulcanLocationFilterComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab-group", 10, 1);
    i0.ɵɵtwoWayListener("selectedIndexChange", function VulcanLocationFilterComponent_Conditional_3_Template_mat_tab_group_selectedIndexChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.tabIndex, $event) || (ctx_r1.tabIndex = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(2, "mat-tab", 11);
    i0.ɵɵelementContainer(3, 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-tab", 12)(5, "div", 13)(6, "mat-form-field", 14)(7, "mat-label");
    i0.ɵɵtext(8, "Search County Names");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 16)(11, "button", 17);
    i0.ɵɵlistener("click", function VulcanLocationFilterComponent_Conditional_3_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(true));
    });
    i0.ɵɵtext(12, " Select All ");
    i0.ɵɵelementStart(13, "mat-icon");
    i0.ɵɵtext(14, "done_all");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "button", 18);
    i0.ɵɵlistener("click", function VulcanLocationFilterComponent_Conditional_3_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(false));
    });
    i0.ɵɵtext(16, " Clear All ");
    i0.ɵɵelementStart(17, "mat-icon");
    i0.ɵɵtext(18, "cancel");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(19, "div")(20, "h2");
    i0.ɵɵtext(21, "States/Territories");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, VulcanLocationFilterComponent_Conditional_3_Conditional_22_Template, 2, 0, "h3", 19)(23, VulcanLocationFilterComponent_Conditional_3_Conditional_23_Template, 4, 0, "div", 20)(24, VulcanLocationFilterComponent_Conditional_3_Conditional_24_Template, 2, 1, "h3");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const states_r7 = i0.ɵɵreference(6);
    i0.ɵɵtwoWayProperty("selectedIndex", ctx_r1.tabIndex);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", states_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.countiesDisabled);
    i0.ɵɵadvance(18);
    i0.ɵɵconditional(ctx_r1.selectedStateControlsCount === 0 ? 22 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.countiesThatMatchSearch.length ? 23 : 24);
  }
}
function VulcanLocationFilterComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const states_r7 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", states_r7);
  }
}
function VulcanLocationFilterComponent_ng_template_5_Conditional_14_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "mat-checkbox", 35);
    i0.ɵɵlistener("change", function VulcanLocationFilterComponent_ng_template_5_Conditional_14_For_6_Template_mat_checkbox_change_1_listener($event) {
      const region_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleFemaToggle($event, region_r10.value.region));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const region_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", region_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r1.m2CheckboxColor())("id", "fema-region-checkbox-" + region_r10.value.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", region_r10.value.name, " ");
  }
}
function VulcanLocationFilterComponent_ng_template_5_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31)(1, "h2");
    i0.ɵɵtext(2, "FEMA Regions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelementContainerStart(4, 34);
    i0.ɵɵrepeaterCreate(5, VulcanLocationFilterComponent_ng_template_5_Conditional_14_For_6_Template, 3, 4, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r1.femaControls.controls);
  }
}
function VulcanLocationFilterComponent_ng_template_5_Conditional_19_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "mat-checkbox", 35);
    i0.ɵɵlistener("change", function VulcanLocationFilterComponent_ng_template_5_Conditional_19_For_3_Template_mat_checkbox_change_1_listener($event) {
      const state_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleStateToggle($event.checked, state_r12));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const state_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", state_r12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r1.m2CheckboxColor())("id", "state-checkbox-" + state_r12.value.geoid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", state_r12.value.name, " ");
  }
}
function VulcanLocationFilterComponent_ng_template_5_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementContainerStart(1, 21);
    i0.ɵɵrepeaterCreate(2, VulcanLocationFilterComponent_ng_template_5_Conditional_19_For_3_Template, 3, 4, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.statesThatMatchSearch);
  }
}
function VulcanLocationFilterComponent_ng_template_5_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("No states match \"", ctx_r1.stateSearchValue, "\"");
  }
}
function VulcanLocationFilterComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "mat-form-field", 14)(2, "mat-label");
    i0.ɵɵtext(3, "Search State Names");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16)(6, "button", 29);
    i0.ɵɵlistener("click", function VulcanLocationFilterComponent_ng_template_5_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(true));
    });
    i0.ɵɵtext(7, " Select All ");
    i0.ɵɵelementStart(8, "mat-icon");
    i0.ɵɵtext(9, "done_all");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "button", 30);
    i0.ɵɵlistener("click", function VulcanLocationFilterComponent_ng_template_5_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(false));
    });
    i0.ɵɵtext(11, " Clear All ");
    i0.ɵɵelementStart(12, "mat-icon");
    i0.ɵɵtext(13, "cancel");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(14, VulcanLocationFilterComponent_ng_template_5_Conditional_14_Template, 7, 0, "div", 31);
    i0.ɵɵelementStart(15, "div", 32)(16, "h2", 33);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, VulcanLocationFilterComponent_ng_template_5_Conditional_19_Template, 4, 0, "div", 20)(20, VulcanLocationFilterComponent_ng_template_5_Conditional_20_Template, 2, 1, "h3");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(14);
    i0.ɵɵconditional(ctx_r1.showFemaRegions() ? 14 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" States/Territories ", ctx_r1.selectedStateControlsCount > 0 ? "(" + i0.ɵɵpipeBind1(18, 3, ctx_r1.selectedStateControlsCount) + " selected)" : "", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.statesThatMatchSearch.length ? 19 : 20);
  }
}
function LocationFilterComponent_Conditional_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const level_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", level_r1)("id", "aggregation-level-option-" + level_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 3, level_r1.toString()), " ");
  }
}
function LocationFilterComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 6)(2, "mat-form-field", 7)(3, "mat-label");
    i0.ɵɵtext(4, " Aggregation Level");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-select", 8);
    i0.ɵɵrepeaterCreate(6, LocationFilterComponent_Conditional_2_For_7_Template, 3, 5, "mat-option", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mat-error");
    i0.ɵɵtext(9, " An aggregation level is required.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "p");
    i0.ɵɵtext(11, " Aggregation Level will determine which codes are used to get data. All levels will utilize a state's FIPS Code except County, which uses its own code. ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵrepeater(ctx_r1.aggregationLevels());
  }
}
function LocationFilterComponent_Conditional_3_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 19);
    i0.ɵɵtext(1, "At least one state must be selected");
    i0.ɵɵelementEnd();
  }
}
function LocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-checkbox", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const county_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("color", ctx_r1.m2CheckboxColor())("id", "county-checkbox-" + county_r6.value.geoid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", county_r6.value.name, " ");
  }
}
function LocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵtemplate(1, LocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Conditional_1_Template, 2, 3, "mat-checkbox", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const county_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", county_r6);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.matchesSearch(county_r6.value.name, true) ? 1 : -1);
  }
}
function LocationFilterComponent_Conditional_3_Conditional_23_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 23)(3, "h3");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16)(6, "button", 24);
    i0.ɵɵlistener("click", function LocationFilterComponent_Conditional_3_Conditional_23_For_3_Template_button_click_6_listener() {
      const state_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleAll(true, state_r5.value.state));
    });
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "done_all");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "button", 25);
    i0.ɵɵlistener("click", function LocationFilterComponent_Conditional_3_Conditional_23_For_3_Template_button_click_9_listener() {
      const state_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleAll(false, state_r5.value.state));
    });
    i0.ɵɵelementStart(10, "mat-icon");
    i0.ɵɵtext(11, "cancel");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(12, "div", 20);
    i0.ɵɵelementContainerStart(13, 26);
    i0.ɵɵrepeaterCreate(14, LocationFilterComponent_Conditional_3_Conditional_23_For_3_For_15_Template, 2, 2, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const state_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", state_r5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(state_r5.value.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "select-all-for-state-" + state_r5.value.name)("matTooltip", "Select All: " + state_r5.value.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", "clear-all-for-state-" + state_r5.value.name)("matTooltip", "Clear All: " + state_r5.value.name);
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r1.getCounties(state_r5).controls);
  }
}
function LocationFilterComponent_Conditional_3_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementContainerStart(1, 21);
    i0.ɵɵrepeaterCreate(2, LocationFilterComponent_Conditional_3_Conditional_23_For_3_Template, 16, 6, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.countiesThatMatchSearch);
  }
}
function LocationFilterComponent_Conditional_3_Conditional_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("No county names match \"", ctx_r1.countySearchValue, "\"");
  }
}
function LocationFilterComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab-group", 10, 1);
    i0.ɵɵtwoWayListener("selectedIndexChange", function LocationFilterComponent_Conditional_3_Template_mat_tab_group_selectedIndexChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.tabIndex, $event) || (ctx_r1.tabIndex = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(2, "mat-tab", 11);
    i0.ɵɵelementContainer(3, 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-tab", 12)(5, "div", 13)(6, "mat-form-field", 14)(7, "mat-label");
    i0.ɵɵtext(8, "Search County Names");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 16)(11, "button", 17);
    i0.ɵɵlistener("click", function LocationFilterComponent_Conditional_3_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(true));
    });
    i0.ɵɵtext(12, " Select All ");
    i0.ɵɵelementStart(13, "mat-icon");
    i0.ɵɵtext(14, "done_all");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "button", 18);
    i0.ɵɵlistener("click", function LocationFilterComponent_Conditional_3_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(false));
    });
    i0.ɵɵtext(16, " Clear All ");
    i0.ɵɵelementStart(17, "mat-icon");
    i0.ɵɵtext(18, "cancel");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(19, "div")(20, "h2");
    i0.ɵɵtext(21, "States/Territories");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, LocationFilterComponent_Conditional_3_Conditional_22_Template, 2, 0, "h3", 19)(23, LocationFilterComponent_Conditional_3_Conditional_23_Template, 4, 0, "div", 20)(24, LocationFilterComponent_Conditional_3_Conditional_24_Template, 2, 1, "h3");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const states_r7 = i0.ɵɵreference(6);
    i0.ɵɵtwoWayProperty("selectedIndex", ctx_r1.tabIndex);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", states_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.countiesDisabled);
    i0.ɵɵadvance(18);
    i0.ɵɵconditional(ctx_r1.selectedStateControlsCount === 0 ? 22 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.countiesThatMatchSearch.length ? 23 : 24);
  }
}
function LocationFilterComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const states_r7 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", states_r7);
  }
}
function LocationFilterComponent_ng_template_5_Conditional_14_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "mat-checkbox", 35);
    i0.ɵɵlistener("change", function LocationFilterComponent_ng_template_5_Conditional_14_For_6_Template_mat_checkbox_change_1_listener($event) {
      const region_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleFemaToggle($event, region_r10.value.region));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const region_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", region_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r1.m2CheckboxColor())("id", "fema-region-checkbox-" + region_r10.value.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", region_r10.value.name, " ");
  }
}
function LocationFilterComponent_ng_template_5_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31)(1, "h2");
    i0.ɵɵtext(2, "FEMA Regions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelementContainerStart(4, 34);
    i0.ɵɵrepeaterCreate(5, LocationFilterComponent_ng_template_5_Conditional_14_For_6_Template, 3, 4, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵrepeater(ctx_r1.femaControls.controls);
  }
}
function LocationFilterComponent_ng_template_5_Conditional_19_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵelementStart(1, "mat-checkbox", 35);
    i0.ɵɵlistener("change", function LocationFilterComponent_ng_template_5_Conditional_19_For_3_Template_mat_checkbox_change_1_listener($event) {
      const state_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleStateToggle($event.checked, state_r12));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const state_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", state_r12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r1.m2CheckboxColor())("id", "state-checkbox-" + state_r12.value.geoid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", state_r12.value.name, " ");
  }
}
function LocationFilterComponent_ng_template_5_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementContainerStart(1, 21);
    i0.ɵɵrepeaterCreate(2, LocationFilterComponent_ng_template_5_Conditional_19_For_3_Template, 3, 4, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.statesThatMatchSearch);
  }
}
function LocationFilterComponent_ng_template_5_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("No states match \"", ctx_r1.stateSearchValue, "\"");
  }
}
function LocationFilterComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "mat-form-field", 14)(2, "mat-label");
    i0.ɵɵtext(3, "Search State Names");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16)(6, "button", 29);
    i0.ɵɵlistener("click", function LocationFilterComponent_ng_template_5_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(true));
    });
    i0.ɵɵtext(7, " Select All ");
    i0.ɵɵelementStart(8, "mat-icon");
    i0.ɵɵtext(9, "done_all");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "button", 30);
    i0.ɵɵlistener("click", function LocationFilterComponent_ng_template_5_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleAll(false));
    });
    i0.ɵɵtext(11, " Clear All ");
    i0.ɵɵelementStart(12, "mat-icon");
    i0.ɵɵtext(13, "cancel");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(14, LocationFilterComponent_ng_template_5_Conditional_14_Template, 7, 0, "div", 31);
    i0.ɵɵelementStart(15, "div", 32)(16, "h2", 33);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, LocationFilterComponent_ng_template_5_Conditional_19_Template, 4, 0, "div", 20)(20, LocationFilterComponent_ng_template_5_Conditional_20_Template, 2, 1, "h3");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(14);
    i0.ɵɵconditional(ctx_r1.showFemaRegions() ? 14 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" States/Territories ", ctx_r1.selectedStateControlsCount > 0 ? "(" + i0.ɵɵpipeBind1(18, 3, ctx_r1.selectedStateControlsCount) + " selected)" : "", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.statesThatMatchSearch.length ? 19 : 20);
  }
}
const _c4 = ".state-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:100%}.aggregation-info[_ngcontent-%COMP%]{display:flex;justify-content:space-between;flex-wrap:wrap;gap:1rem;margin-bottom:1.5rem}.aggregation-info[_ngcontent-%COMP%]   .controls[_ngcontent-%COMP%]{display:flex;flex-direction:column}.aggregation-info[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{width:60%;margin:0}.checkbox-list[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;flex-wrap:wrap}.checkbox-list[_ngcontent-%COMP%]   mat-checkbox[_ngcontent-%COMP%]{flex-basis:18%;flex-grow:1;margin:.5rem 0;max-width:160px}.checkbox-list[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-of-type{margin-left:1rem}.header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin-top:1rem;gap:1rem}.header[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{flex-grow:1}.header[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex;gap:1rem;height:3.65rem}.county-header[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;margin-right:1rem}";
const _c5 = ["*"];
const _c6 = (a0, a1) => ({
  open: a0,
  "icon-only": a1
});
function HeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.headerImagePath(), i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpureFunction2(2, _c6, ctx_r0.open(), !ctx_r0.displayText()));
  }
}
function HeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayText(), " ");
  }
}
function HeaderComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.textInitial(), " ");
  }
}
const _c7 = a0 => ({
  open: a0
});
function MenuNavHeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vulcan-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.icon())("weight", ctx_r0.iconWeight())("size", ctx_r0.iconFontSize());
  }
}
function MenuNavHeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayText(), " ");
  }
}
function MenuNavHeaderComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.textInitial(), " ");
  }
}
const _c8 = [[["vulcan-menu-nav-header"]], [["vulcan-nav-menu-item"]]];
const _c9 = ["vulcan-menu-nav-header", "vulcan-nav-menu-item"];
const _c10 = a0 => ({
  "active-nav": a0
});
function MenuNavComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuNavComponent_Conditional_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuNavComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function MenuNavComponent_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleMenu());
    });
    i0.ɵɵtemplate(1, MenuNavComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelement(2, "vulcan-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtemplate(4, MenuNavComponent_Conditional_0_ng_container_4_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const menuHeader_r3 = i0.ɵɵreference(3);
    const navItems_r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c10, ctx_r1.parentRouteActive()));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", menuHeader_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.menuOpen() ? "caret-up" : "caret-down");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c7, ctx_r1.menuOpen()));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", navItems_r4);
  }
}
function MenuNavComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuNavComponent_Conditional_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuNavComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵtemplate(1, MenuNavComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "mat-menu", 8, 2);
    i0.ɵɵtemplate(4, MenuNavComponent_Conditional_1_ng_container_4_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menuItems_r5 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    const menuHeader_r3 = i0.ɵɵreference(3);
    const navItems_r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c10, ctx_r1.parentRouteActive()))("matMenuTriggerFor", menuItems_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", menuHeader_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", navItems_r4);
  }
}
function MenuNavComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function MenuNavComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c11 = "a[_ngcontent-%COMP%], .nav-item-context[_ngcontent-%COMP%], button[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;font-family:Mulish,Roboto,sans-serif;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);font-size:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) + .15rem);font-weight:700;background-color:transparent}a[_ngcontent-%COMP%]{width:100%;text-decoration:none;height:100%}a[_ngcontent-%COMP%]   vulcan-icon[_ngcontent-%COMP%]{margin-right:.5rem}a.open[_ngcontent-%COMP%]   vulcan-icon[_ngcontent-%COMP%]{margin-right:0;margin-left:.25rem}.nav-item-context[_ngcontent-%COMP%], button[_ngcontent-%COMP%]{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);margin:.5rem 0;width:100%;text-align:left;border:none;cursor:pointer;border:1px solid transparent;transition:background-color .25s ease}.nav-item-context[_ngcontent-%COMP%]:hover, button[_ngcontent-%COMP%]:hover{border-radius:0 5px 5px 0;background-color:var(--vulcan-side-nav-hover-color, --vulcan-secondary-subtle);--border: 1px solid var(--vulcan-side-nav-hover-border-color, --vulcan-secondary-gentle)}.nav-item-context[_ngcontent-%COMP%]:hover:not(.active-nav), button[_ngcontent-%COMP%]:hover:not(.active-nav){border:var(--border)}.nav-item-context[_ngcontent-%COMP%]:hover:has(.active-nav), button[_ngcontent-%COMP%]:hover:has(.active-nav){border-top:var(--border);border-bottom:var(--border);border-right:var(--border)}";
const _c12 = a0 => ({
  "has-icon": a0
});
const _c13 = a0 => ({
  "no-icon": a0
});
function NavItemComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vulcan-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.icon())("weight", ctx_r0.iconWeight())("size", ctx_r0.iconFontSize());
  }
}
function NavItemComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayText(), " ");
  }
}
function NavItemComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.textInitial(), " ");
  }
}
function NavMenuItemComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vulcan-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("weight", ctx_r0.iconWeight())("size", ctx_r0.iconFontSize())("icon", ctx_r0.icon());
  }
}
const _c14 = [[["vulcan-side-nav-header"]], "*", [["vulcan-content"]]];
const _c15 = ["vulcan-side-nav-header", "*", "vulcan-content"];
const _c16 = (a0, a1, a2, a3, a4, a5, a6) => ({
  "--vulcan-side-nav-base-font-size": a0,
  "--vulcan-side-nav-background-color": a1,
  "--vulcan-side-nav-active-route-color": a2,
  "--vulcan-side-nav-font-color": a3,
  "--vulcan-side-nav-side-nav-open-width": a4,
  "--vulcan-side-nav-hover-color": a5,
  "--vulcan-side-nav-hover-border-color": a6
});
const _c17 = a0 => ({
  "nav-open": a0
});
function SideNavComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function SideNavComponent_Conditional_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleSideNav());
    });
    i0.ɵɵelement(1, "vulcan-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.open() ? "caret-left" : "caret-right");
  }
}
var MaxLogLevel;
(function (MaxLogLevel) {
  MaxLogLevel[MaxLogLevel["None"] = 0] = "None";
  MaxLogLevel[MaxLogLevel["Error"] = 1] = "Error";
  MaxLogLevel[MaxLogLevel["Info"] = 2] = "Info";
  MaxLogLevel[MaxLogLevel["Function"] = 3] = "Function";
})(MaxLogLevel || (MaxLogLevel = {}));
class VulcanLoggerService {
  constructor() {
    this.config = {
      environment: 'development',
      logLevel: MaxLogLevel.Function,
      logName: 'Vulcan Log'
    };
    this.dev = this.config.environment !== 'development';
  }
  func(header, message) {
    if (this.dev && this.config.logLevel === MaxLogLevel.Function) {
      console.groupCollapsed(`%c[${this.config.logName} Function]%c [ %c${header}%c ]`, 'color: white; background-color: green; border-radius: 15%', 'color: unset', 'font-style: italic', 'font-style: unset', message);
      console.trace();
      console.groupEnd();
    }
  }
  log(header, message) {
    if (this.dev && this.config.logLevel >= MaxLogLevel.Info) {
      console.groupCollapsed(`%c[${this.config.logName} Log]%c [ %c${header}%c ]`, 'color: white; background-color: #0288f3; border-radius: 15%', 'color: unset', 'font-style: italic', 'font-style: unset', message);
      console.trace();
      console.groupEnd();
    }
  }
  error(header, message) {
    if (this.dev && this.config.logLevel >= MaxLogLevel.Error) {
      console.groupCollapsed(`%c[${this.config.logName} ERROR]%c [ %c${header}%c ]`, 'color: white; background-color: #f3615a; border-radius: 15%', 'color: unset', 'font-style: italic', 'font-style: unset', message);
      console.trace();
      console.groupEnd();
    }
  }
  infoGroup(header, startMessage, messages) {
    if (this.dev && this.config.logLevel >= MaxLogLevel.Info) {
      console.groupCollapsed(`%c[${this.config.logName} Group]%c [ %c${header}%c ]`, 'color: white; background-color: #0288f3; border-radius: 15%', 'color: unset', 'font-style: italic', 'font-style: unset', startMessage);
      console.trace();
      messages.forEach(message => console.log(message));
      console.groupEnd();
    }
  }
  static {
    this.ɵfac = function VulcanLoggerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VulcanLoggerService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: VulcanLoggerService,
      factory: VulcanLoggerService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VulcanLoggerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class VulcanLoggerModule {
  static forRoot(configuration) {
    return {
      ngModule: VulcanLoggerModule,
      providers: [VulcanLoggerService, {
        provide: 'config',
        useValue: configuration
      }]
    };
  }
  static {
    this.ɵfac = function VulcanLoggerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VulcanLoggerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: VulcanLoggerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VulcanLoggerModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [CommonModule]
    }]
  }], null, null);
})();
class UtilsService {
  /**
   * Gets a valid time string from a Date object and rounds it to the nearest
   * 15 min interval
   */
  getTimeFromDate(date, adjust = 0, nearest = 15) {
    if (!date) {
      return '';
    }
    let hours = date.getHours();
    let min = date.getMinutes();
    if (min === 0 && !!adjust) {
      if (adjust === 1) {
        min += nearest;
      } else {
        min -= nearest;
      }
    } else {
      min = min === 0 ? 0 : this.incrementNumberToNearest(min, nearest, adjust);
    }
    if (min === 60) {
      min = 0;
      hours++;
    }
    if (hours === 24) {
      hours = 23;
    }
    return `${hours.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
  }
  incrementNumberToNearest(num, nearest, adjust) {
    let value = Math.round(num / nearest) * nearest;
    if (!!adjust) {
      if (adjust === -1) {
        value -= nearest;
      } else {
        value += nearest;
      }
    }
    return value;
  }
  static {
    this.ɵfac = function UtilsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UtilsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UtilsService,
      factory: UtilsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class CoerceIntervalValidatorDirective {
  constructor() {
    this.coerceInterval = input();
  }
  validate(control) {
    if (!control.value) {
      return null;
    }
    const minutes = control.value.getMinutes();
    const hours = control.value.getHours();
    let error = false;
    switch (this.coerceInterval()) {
      case '30m':
        error = minutes !== 0 && minutes % 30 !== 0;
        break;
      case '1h':
        error = minutes !== 0;
        break;
      case '2h':
        error = minutes !== 0 || hours % 2 !== 0;
        break;
      default:
        // 15m
        error = minutes !== 0 && minutes % 15 !== 0;
        break;
    }
    if (error) {
      return {
        coerceInterval: true
      };
    }
    return null;
  }
  static {
    this.ɵfac = function CoerceIntervalValidatorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CoerceIntervalValidatorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CoerceIntervalValidatorDirective,
      selectors: [["", "coerceInterval", ""]],
      inputs: {
        coerceInterval: [1, "coerceInterval"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: CoerceIntervalValidatorDirective,
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoerceIntervalValidatorDirective, [{
    type: Directive,
    args: [{
      selector: '[coerceInterval]',
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: CoerceIntervalValidatorDirective,
        multi: true
      }],
      standalone: true
    }]
  }], null, null);
})();
class OutOfRangeValidatorDirective {
  constructor() {
    this.outOfRangeOtherDate = input();
    this.outOfRangeType = input();
  }
  validate(control) {
    if (!this.outOfRangeOtherDate() || !control.value) {
      return null;
    }
    const thisTime = control.value.getTime();
    const otherTime = this.outOfRangeOtherDate().getTime();
    const ifStartIsGreaterThanEnd = this.outOfRangeType() === 'start' && thisTime > otherTime;
    const ifEndIsLessThanStart = this.outOfRangeType() === 'end' && thisTime < otherTime;
    const timesMatch = thisTime === otherTime;
    if (ifStartIsGreaterThanEnd || ifEndIsLessThanStart) {
      return {
        outOfRange: true
      };
    }
    if (timesMatch) {
      return {
        timesMatch: true
      };
    }
    return null;
  }
  static {
    this.ɵfac = function OutOfRangeValidatorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutOfRangeValidatorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OutOfRangeValidatorDirective,
      selectors: [["", "outOfRange", ""]],
      inputs: {
        outOfRangeOtherDate: [1, "outOfRangeOtherDate"],
        outOfRangeType: [1, "outOfRangeType"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: OutOfRangeValidatorDirective,
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutOfRangeValidatorDirective, [{
    type: Directive,
    args: [{
      selector: '[outOfRange]',
      providers: [{
        provide: NG_VALIDATORS,
        useExisting: OutOfRangeValidatorDirective,
        multi: true
      }],
      standalone: true
    }]
  }], null, null);
})();
class VulcanDateTimePickerComponent {
  constructor() {
    this.envInjector = inject(EnvironmentInjector);
    this.utilService = inject(UtilsService);
    this.dateForm = input.required();
    this.config = input.required();
    this.dateChange = output();
    this.pickerType = computed(() => {
      return this.config().dateType;
    });
    this.showTimePicker = computed(() => {
      const config = this.config();
      return config.includeTime;
    });
    this.showStartDate = computed(() => {
      const type = this.pickerType();
      return type === 'start' || type === 'range';
    });
    this.showEndDate = computed(() => {
      const type = this.pickerType();
      return type === 'end' || type === 'range';
    });
    this.startTimeMinimum = signal('00:00');
    this.startTimeMaximum = signal('23:45');
    this.endTimeMinimum = signal('00:00');
    this.endTimeMaximum = signal('23:45');
    this.friendlyInterval = computed(() => {
      switch (this.config().timeInterval) {
        case '30m':
          return '30 minute';
        case '1h':
          return '1 hour';
        case '2h':
          return '2 hour';
        default:
          return '15 minute';
      }
    });
    /**
     * Theres a know bug with angular where using the same form control multiple times
     * isnt updating correctly. This is a simple hack around it.
     * All methods and properties prefixed by "bugFix_" directly relate to it
     * https://github.com/angular/angular/issues/58522
     */
    this.startValue = model(new Date());
    this.endValue = model(new Date());
  }
  ngOnInit() {
    this.startValue.set(this.dateForm().controls.start?.value || new Date());
    this.endValue.set(this.dateForm().controls.end?.value || new Date());
    this.updateTimePickerMinAndMax();
    this.validateInputs();
    this.trackAndUpdateChangesBetweenForms();
  }
  trackAndUpdateChangesBetweenForms() {
    runInInjectionContext(this.envInjector, () => {
      // manually get the injection context to use `takeUntilDestroyed`
      // Update the start and end values if the form values change externally
      this.dateForm().valueChanges.pipe(takeUntilDestroyed()).subscribe(change => {
        if (change.start) {
          this.startValue.set(change.start);
        }
        if (change.end) {
          this.endValue.set(change.end);
        }
        this.updateTimePickerMinAndMax();
      });
      // Model signals are automatically cleaned up
      this.startValue.subscribe(value => {
        if (this.config().syncData !== false) {
          this.dateForm().controls.start?.setValue(value);
        }
        this.updateTimePickerMinAndMax();
        this.emitChanges();
      });
      this.endValue.subscribe(value => {
        if (this.config().syncData !== false) {
          this.dateForm().controls.end?.setValue(value);
        }
        this.updateTimePickerMinAndMax();
        this.emitChanges();
      });
    });
  }
  /**
   * Run simple checks to make sure the consuming app has the required config and form inputs
   * necessary to run things. This way it will fail violently and communicate to the
   * developer what to fix.
   */
  validateInputs() {
    if (this.config().dateType === 'range' && (!this.dateForm().controls.end || !this.dateForm().controls.start)) {
      throw 'VulcanDateTimePicker: A dateType of "range" requires a two form controls names "start" and "end"';
    }
    if (this.config().dateType === 'start' && !this.dateForm().controls.start) {
      throw 'VulcanDateTimePicker: A dateType of "start" requires a form control named "start"';
    }
    if (this.config().dateType === 'end' && !this.dateForm().controls.end) {
      throw 'VulcanDateTimePicker: A dateType of "end" requires a form control named "end"';
    }
  }
  /**
   *
   * We need to update the options for the time dropdown based on the selection of the other option.
   *
   * If the user changes the dates of the start or end to the same day as the end date then we cant let the
   * time options dropdown overlap.
   *
   * This runs twice for each control that has changed (so four when the type is a range). It will first set the
   * min time (defaults to: 00:00) and the max time (defaults to: 23:45)
   */
  updateTimePickerMinAndMax() {
    const {
      startMinDate,
      startMaxDate,
      endMinDate,
      endMaxDate
    } = this.config();
    const startValue = this.startValue();
    const endValue = this.endValue();
    // See if the selected day matches the other control or the min option
    // Turn the different dates into a string because you can have weird false positives
    // if you're simply adding up the numbers
    const compareDay = date => {
      if (!date) {
        return null;
      }
      return `${date.getFullYear()}${date.getMonth()}${date.getDate()}`;
    };
    const startAndEndDayMatch = compareDay(startValue) === compareDay(endValue);
    const startIsOnMinDay = compareDay(startValue) === compareDay(startMinDate);
    const startIsOnMaxDay = compareDay(startValue) === compareDay(startMaxDate);
    const endIsOnMinDay = compareDay(endValue) === compareDay(endMinDate);
    const endIsOnMaxDay = compareDay(endValue) === compareDay(endMaxDate);
    // if start and end match
    if (startAndEndDayMatch) {
      const startMin = startMinDate && this.utilService.getTimeFromDate(startMinDate) > '00:00' ? this.utilService.getTimeFromDate(startMinDate) : '00:00';
      const startMax = this.utilService.getTimeFromDate(endValue, -1);
      this.startTimeMinimum.set(startMin);
      this.startTimeMaximum.set(startMax);
      const endMin = this.utilService.getTimeFromDate(startValue, 1);
      const endMax = endMaxDate && this.utilService.getTimeFromDate(endMaxDate) < '23:45' ? this.utilService.getTimeFromDate(endMaxDate) : '23:45';
      this.endTimeMinimum.set(endMin);
      this.endTimeMaximum.set(endMax);
      // If its the same day for start and end we dont want to recalculate things
      return;
    }
    // if start is min day
    if (startIsOnMinDay) {
      this.startTimeMinimum.set(this.utilService.getTimeFromDate(startMinDate));
      this.startTimeMaximum.set('23:45');
    } else {
      this.startTimeMaximum.set('00:00');
    }
    // if start is max day
    if (startIsOnMaxDay) {
      this.startTimeMinimum.set('00:00');
      this.startTimeMaximum.set(this.utilService.getTimeFromDate(startMaxDate));
    } else {
      this.startTimeMaximum.set('23:45');
    }
    // if end is min day
    if (endIsOnMinDay) {
      this.endTimeMinimum.set(this.utilService.getTimeFromDate(endMinDate));
      this.endTimeMaximum.set('23:45');
    } else {
      this.endTimeMinimum.set('00:00');
    }
    // if end is max day
    if (endIsOnMaxDay) {
      this.endTimeMinimum.set('00:00');
      this.endTimeMaximum.set(this.utilService.getTimeFromDate(endMaxDate));
    } else {
      this.endTimeMaximum.set('23:45');
    }
  }
  // Standardize emitting the changes
  emitChanges() {
    this.dateChange.emit({
      start: this.startValue(),
      end: this.endValue()
    });
  }
  static {
    this.ɵfac = function VulcanDateTimePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VulcanDateTimePickerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VulcanDateTimePickerComponent,
      selectors: [["vulcan-date-time-picker"]],
      inputs: {
        dateForm: [1, "dateForm"],
        config: [1, "config"],
        startValue: [1, "startValue"],
        endValue: [1, "endValue"]
      },
      outputs: {
        dateChange: "dateChange",
        startValue: "startValueChange",
        endValue: "endValueChange"
      },
      decls: 3,
      vars: 2,
      consts: [["startDateInput", "ngModel"], ["startDate", ""], ["startTimePicker", "ngModel"], ["startTime", ""], ["endDateInput", "ngModel"], ["endDate", ""], ["endTimePicker", "ngModel"], ["endTime", ""], [1, "vulcan-date-time-picker"], ["appearance", "outline", "floatLabel", "always", "subscriptSizing", "fixed", 3, "click"], ["id", "startDateInput", "name", "startDateInput", "placeholder", "Start Date", "matInput", "", "outOfRange", "", "outOfRangeType", "start", 3, "ngModelChange", "ngModel", "matDatepicker", "min", "max", "outOfRangeOtherDate"], ["matIconSuffix", "", 3, "for"], ["matDatepickerToggleIcon", ""], ["yPosition", "below"], ["appearance", "outline", "floatLabel", "always", "subscriptSizing", "fixed", 3, "flex-grow"], ["appearance", "outline", "floatLabel", "always", "subscriptSizing", "fixed"], ["id", "startTimeInput", "placeholder", "Start Time", "matInput", "", "outOfRange", "", "outOfRangeType", "start", 3, "ngModelChange", "ngModel", "matTimepicker", "matTimepickerMin", "matTimepickerMax", "outOfRangeOtherDate", "coerceInterval"], [3, "interval"], ["matInput", "", "id", "endDateInput", "name", "endDateInput", "placeholder", "End Date", "outOfRange", "", "outOfRangeType", "end", 3, "ngModelChange", "min", "max", "matDatepicker", "ngModel", "outOfRangeOtherDate"], ["matInput", "", "id", "endTimeInput", "placeholder", "End Time", "name", "endTimePicker", "outOfRange", "", "outOfRangeType", "end", 3, "ngModelChange", "matTimepicker", "ngModel", "matTimepickerMin", "matTimepickerMax", "coerceInterval"]],
      template: function VulcanDateTimePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 8);
          i0.ɵɵtemplate(1, VulcanDateTimePickerComponent_Conditional_1_Template, 17, 14)(2, VulcanDateTimePickerComponent_Conditional_2_Template, 17, 14);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showStartDate() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showEndDate() ? 2 : -1);
        }
      },
      dependencies: [FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, ReactiveFormsModule, MatFormFieldModule, i3.MatFormField, i3.MatLabel, i3.MatError, i3.MatSuffix, MatInputModule, i11.MatInput, MatDatepickerModule, i4.MatDatepicker, i4.MatDatepickerInput, i4.MatDatepickerToggle, i4.MatDatepickerToggleIcon, MatNativeDateModule, MatTimepickerModule, i5.MatTimepicker, i5.MatTimepickerInput, i5.MatTimepickerToggle, MatIconModule, i4$1.MatIcon, OutOfRangeValidatorDirective, CoerceIntervalValidatorDirective],
      styles: [".vulcan-date-time-picker[_ngcontent-%COMP%]{display:flex;gap:1rem;flex-wrap:wrap}.vulcan-date-time-picker[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{min-width:320px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VulcanDateTimePickerComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-date-time-picker',
      imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatTimepickerModule, MatIconModule, OutOfRangeValidatorDirective, CoerceIntervalValidatorDirective],
      standalone: true,
      template: "<div class=\"vulcan-date-time-picker\">\n  @if (showStartDate()) {\n    <mat-form-field\n      [style.flex-grow]=\"config().grow ? 1 : 0\"\n      appearance=\"outline\"\n      floatLabel=\"always\"\n      (click)=\"startDate.open()\"\n      subscriptSizing=\"fixed\">\n      <mat-label>Start Date</mat-label>\n      <input\n        id=\"startDateInput\"\n        name=\"startDateInput\"\n        placeholder=\"Start Date\"\n        #startDateInput=\"ngModel\"\n        matInput\n        [(ngModel)]=\"startValue\"\n        [matDatepicker]=\"startDate\"\n        [min]=\"config().startMinDate\"\n        [max]=\"config().startMaxDate\"\n        outOfRange\n        [outOfRangeOtherDate]=\"dateForm().controls.end?.value\"\n        outOfRangeType=\"start\" />\n\n      <mat-datepicker-toggle matIconSuffix [for]=\"startDate\">\n        <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>\n      </mat-datepicker-toggle>\n      <mat-datepicker #startDate yPosition=\"below\"></mat-datepicker>\n      <mat-error>\n        @if (startDateInput.errors?.[\"matDatepickerMin\"]) {\n          Date outside of minimum range\n        }\n        @if (startDateInput.errors?.[\"matDatepickerParse\"]) {\n          Date is invalid\n        }\n        @if (startDateInput.errors?.[\"matDatepickerMax\"]) {\n          Date outside of maximum range\n        }\n        @if (startDateInput.errors?.[\"outOfRange\"]) {\n          Start Date cannot be after End Date\n        }\n\n        @if (startDateInput.errors?.[\"timesMatch\"]) {\n          Date and Time cannot match\n        }\n      </mat-error>\n    </mat-form-field>\n\n    @if (showTimePicker()) {\n      <mat-form-field\n        [style.flex-grow]=\"config().grow ? 1 : 0\"\n        appearance=\"outline\"\n        floatLabel=\"always\"\n        subscriptSizing=\"fixed\">\n        <mat-label>Start Time</mat-label>\n        <input\n          id=\"startTimeInput\"\n          placeholder=\"Start Time\"\n          #startTimePicker=\"ngModel\"\n          matInput\n          [(ngModel)]=\"startValue\"\n          [matTimepicker]=\"startTime\"\n          [matTimepickerMin]=\"startTimeMinimum()\"\n          [matTimepickerMax]=\"startTimeMaximum()\"\n          outOfRange\n          [outOfRangeOtherDate]=\"dateForm().controls.end?.value\"\n          [coerceInterval]=\"config().timeInterval\"\n          outOfRangeType=\"start\" />\n\n        <mat-timepicker-toggle matIconSuffix [for]=\"startTime\" />\n        <mat-timepicker #startTime [interval]=\"config().timeInterval || '15m'\" />\n        <mat-error>\n          @if (startTimePicker.errors?.[\"matTimepickerParse\"]) {\n            Value isn't a valid time\n          }\n\n          @if (startTimePicker.errors?.[\"matTimepickerMin\"]) {\n            Time is too early\n          }\n\n          @if (startTimePicker.errors?.[\"matTimepickerMax\"]) {\n            Time is too late\n          }\n          @if (startTimePicker.errors?.[\"coerceInterval\"]) {\n            Time must be in {{ friendlyInterval() }} intervals\n          }\n        </mat-error>\n      </mat-form-field>\n    }\n  }\n\n  @if (showEndDate()) {\n    <mat-form-field\n      [style.flex-grow]=\"config().grow ? 1 : 0\"\n      appearance=\"outline\"\n      floatLabel=\"always\"\n      (click)=\"endDate.open()\"\n      subscriptSizing=\"fixed\">\n      <mat-label>End Date</mat-label>\n\n      <input\n        matInput\n        id=\"endDateInput\"\n        name=\"endDateInput\"\n        placeholder=\"End Date\"\n        #endDateInput=\"ngModel\"\n        [min]=\"config().endMinDate || startValue()\"\n        [max]=\"config().endMaxDate\"\n        [matDatepicker]=\"endDate\"\n        [(ngModel)]=\"endValue\"\n        outOfRange\n        [outOfRangeOtherDate]=\"dateForm().controls.start?.value\"\n        outOfRangeType=\"end\" />\n      <mat-datepicker-toggle matIconSuffix [for]=\"endDate\">\n        <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>\n      </mat-datepicker-toggle>\n      <mat-datepicker #endDate yPosition=\"below\"></mat-datepicker>\n      <mat-error>\n        @if (endDateInput.errors?.[\"matDatepickerMin\"]) {\n          Date outside of minimum range\n        }\n        @if (endDateInput.errors?.[\"matDatepickerParse\"]) {\n          Date is invalid\n        }\n        @if (endDateInput.errors?.[\"matDatepickerMax\"]) {\n          Date outside of maximum range\n        }\n        @if (endDateInput.errors?.[\"outOfRange\"]) {\n          End Date cannot be before Start Date\n        }\n        @if (endDateInput.errors?.[\"timesMatch\"]) {\n          Date and Time cannot match\n        }\n      </mat-error>\n    </mat-form-field>\n\n    @if (showTimePicker()) {\n      <mat-form-field\n        [style.flex-grow]=\"config().grow ? 1 : 0\"\n        appearance=\"outline\"\n        floatLabel=\"always\"\n        subscriptSizing=\"fixed\">\n        <mat-label>End Time</mat-label>\n        <input\n          matInput\n          id=\"endTimeInput\"\n          [matTimepicker]=\"endTime\"\n          placeholder=\"End Time\"\n          #endTimePicker=\"ngModel\"\n          name=\"endTimePicker\"\n          [(ngModel)]=\"endValue\"\n          [matTimepickerMin]=\"endTimeMinimum()\"\n          [matTimepickerMax]=\"endTimeMaximum()\"\n          outOfRange\n          outOfRangeType=\"end\"\n          [coerceInterval]=\"config().timeInterval\" />\n\n        <mat-timepicker-toggle matIconSuffix [for]=\"endTime\" />\n        <mat-timepicker #endTime [interval]=\"config().timeInterval || '15m'\" />\n        <mat-error>\n          @if (endTimePicker.errors?.[\"matTimepickerParse\"]) {\n            Value isn't a valid time\n          }\n\n          @if (endTimePicker.errors?.[\"matTimepickerMin\"]) {\n            Time is too early\n          }\n\n          @if (endTimePicker.errors?.[\"matTimepickerMax\"]) {\n            Time is too late\n          }\n          @if (endTimePicker.errors?.[\"coerceInterval\"]) {\n            Time must be in {{ friendlyInterval() }} intervals\n          }\n        </mat-error>\n      </mat-form-field>\n    }\n  }\n</div>\n",
      styles: [".vulcan-date-time-picker{display:flex;gap:1rem;flex-wrap:wrap}.vulcan-date-time-picker mat-form-field{min-width:320px}\n"]
    }]
  }], null, null);
})();
const VULCAN_DEFAULT_DATE_TIME_PICKER_CONFIG = {
  dateType: 'range',
  includeTime: true
};
class VulcanDividerComponent {
  constructor() {
    this.color = input('gray');
  }
  static {
    this.ɵfac = function VulcanDividerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VulcanDividerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VulcanDividerComponent,
      selectors: [["vulcan-divider"]],
      inputs: {
        color: [1, "color"]
      },
      decls: 1,
      vars: 3,
      consts: [[1, "divider", 3, "ngStyle"]],
      template: function VulcanDividerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c0, ctx.color()));
        }
      },
      dependencies: [CommonModule, i1.NgStyle],
      styles: [".divider[_ngcontent-%COMP%]{--divider-color: gray;--divider-width: calc(var(--divider-width, 100%) - 1rem);border-top:1px solid var(--divider-color);display:block;margin:1rem .5rem;width:var(--divider-width);min-width:var(--divider-width);max-width:var(--divider-width)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VulcanDividerComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-divider',
      standalone: true,
      imports: [CommonModule],
      template: "<div class=\"divider\" [ngStyle]=\"{ '--divider-color': color() }\"></div>\n",
      styles: [".divider{--divider-color: gray;--divider-width: calc(var(--divider-width, 100%) - 1rem);border-top:1px solid var(--divider-color);display:block;margin:1rem .5rem;width:var(--divider-width);min-width:var(--divider-width);max-width:var(--divider-width)}\n"]
    }]
  }], null, null);
})();
class VulcanIconComponent {
  constructor() {
    /**
     * The Phosphor icon name. Can be the name of the icon or the name prefixed by "ph-"
     * exe: 'smiley' | 'ph-smiley'
     */
    this.icon = input();
    this.weight = input('regular');
    this.size = input('1rem');
    this.formattedIcon = computed(() => {
      const icon = this.icon();
      if (!icon) {
        return '';
      }
      if (/^ph-/.test(icon)) {
        return icon;
      }
      return `ph-${icon}`;
    });
    this.formattedWeight = computed(() => {
      const weight = this.weight();
      if (weight === 'regular') {
        return 'ph';
      }
      return `ph-${weight}`;
    });
  }
  static {
    this.ɵfac = function VulcanIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VulcanIconComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VulcanIconComponent,
      selectors: [["vulcan-icon"]],
      inputs: {
        icon: [1, "icon"],
        weight: [1, "weight"],
        size: [1, "size"]
      },
      decls: 1,
      vars: 7,
      consts: [[3, "ngClass", "ngStyle"]],
      template: function VulcanIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "i", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1, ctx.formattedWeight(), ctx.formattedIcon()))("ngStyle", i0.ɵɵpureFunction1(5, _c2, ctx.size()));
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgStyle],
      styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   i[_ngcontent-%COMP%]{--icon-size: 1rem;height:var(--icon-size);width:var(--icon-size);font-size:var(--icon-size)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VulcanIconComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-icon',
      imports: [CommonModule],
      template: "<i [ngClass]=\"[formattedWeight(), formattedIcon()]\" [ngStyle]=\"{ '--icon-size': size() }\"></i>\n",
      styles: [":host{display:block}:host i{--icon-size: 1rem;height:var(--icon-size);width:var(--icon-size);font-size:var(--icon-size)}\n"]
    }]
  }], null, null);
})();
const VULCAN_DEFAULT_AGGREGATION_LEVELS = ['state', 'county', 'zip', 'utility'];
const VULCAN_DEFAULT_FEMA_REGIONS = [{
  id: 1,
  name: 'FEMA I',
  fipsCode: '1',
  indeterminateState: false,
  selected: false
}, {
  id: 2,
  name: 'FEMA II',
  fipsCode: '2',
  indeterminateState: false,
  selected: false
}, {
  id: 3,
  name: 'FEMA III',
  fipsCode: '3',
  indeterminateState: false,
  selected: false
}, {
  id: 4,
  name: 'FEMA IV',
  fipsCode: '4',
  indeterminateState: false,
  selected: false
}, {
  id: 5,
  name: 'FEMA V',
  fipsCode: '5',
  indeterminateState: false,
  selected: false
}, {
  id: 6,
  name: 'FEMA VI',
  fipsCode: '6',
  indeterminateState: false,
  selected: false
}, {
  id: 7,
  name: 'FEMA VII',
  fipsCode: '7',
  indeterminateState: false,
  selected: false
}, {
  id: 8,
  name: 'FEMA VIII',
  fipsCode: '8',
  indeterminateState: false,
  selected: false
}, {
  id: 9,
  name: 'FEMA IX',
  fipsCode: '9',
  indeterminateState: false,
  selected: false
}, {
  id: 10,
  name: 'FEMA X',
  fipsCode: '10',
  indeterminateState: false,
  selected: false
}];
const VULCAN_DEFAULT_STATE_AND_COUNTIES = [{
  "id": 38,
  "abbreviation": "AL",
  "affgeoid": "0400000US01",
  "aland": 131173369432,
  "awater": 4593984687,
  "dotregion": 4,
  "geoid": "01",
  "lsad": "00",
  "name": "Alabama",
  "stateAbbreviation": "AL",
  "statefp": "01",
  "statens": "01779775",
  "counties": [{
    "id": 2520,
    "affgeoid": "0500000US01001",
    "aland": 1539589643,
    "awater": 25769317,
    "countyfp": "001",
    "countyns": "00161526",
    "dotregion": 4,
    "geoid": "01001",
    "lsad": "06",
    "name": "Autauga",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2028,
    "affgeoid": "0500000US01003",
    "aland": 4117584013,
    "awater": 1133129224,
    "countyfp": "003",
    "countyns": "00161527",
    "dotregion": 4,
    "geoid": "01003",
    "lsad": "06",
    "name": "Baldwin",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2930,
    "affgeoid": "0500000US01005",
    "aland": 2291820706,
    "awater": 50864677,
    "countyfp": "005",
    "countyns": "00161528",
    "dotregion": 4,
    "geoid": "01005",
    "lsad": "06",
    "name": "Barbour",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1838,
    "affgeoid": "0500000US01007",
    "aland": 1612481559,
    "awater": 9287974,
    "countyfp": "007",
    "countyns": "00161529",
    "dotregion": 4,
    "geoid": "01007",
    "lsad": "06",
    "name": "Bibb",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1793,
    "affgeoid": "0500000US01009",
    "aland": 1670041875,
    "awater": 15077458,
    "countyfp": "009",
    "countyns": "00161530",
    "dotregion": 4,
    "geoid": "01009",
    "lsad": "06",
    "name": "Blount",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 952,
    "affgeoid": "0500000US01011",
    "aland": 1613059135,
    "awater": 6055023,
    "countyfp": "011",
    "countyns": "00161531",
    "dotregion": 4,
    "geoid": "01011",
    "lsad": "06",
    "name": "Bullock",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 564,
    "affgeoid": "0500000US01013",
    "aland": 2011976232,
    "awater": 2727475,
    "countyfp": "013",
    "countyns": "00161532",
    "dotregion": 4,
    "geoid": "01013",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1921,
    "affgeoid": "0500000US01015",
    "aland": 1569245411,
    "awater": 16568577,
    "countyfp": "015",
    "countyns": "00161533",
    "dotregion": 4,
    "geoid": "01015",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 243,
    "affgeoid": "0500000US01017",
    "aland": 1545009121,
    "awater": 17048126,
    "countyfp": "017",
    "countyns": "00161534",
    "dotregion": 4,
    "geoid": "01017",
    "lsad": "06",
    "name": "Chambers",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1664,
    "affgeoid": "0500000US01019",
    "aland": 1434128031,
    "awater": 119806782,
    "countyfp": "019",
    "countyns": "00161535",
    "dotregion": 4,
    "geoid": "01019",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1074,
    "affgeoid": "0500000US01021",
    "aland": 1794482899,
    "awater": 20586310,
    "countyfp": "021",
    "countyns": "00161536",
    "dotregion": 4,
    "geoid": "01021",
    "lsad": "06",
    "name": "Chilton",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 691,
    "affgeoid": "0500000US01023",
    "aland": 2365954971,
    "awater": 19059247,
    "countyfp": "023",
    "countyns": "00161537",
    "dotregion": 4,
    "geoid": "01023",
    "lsad": "06",
    "name": "Choctaw",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1348,
    "affgeoid": "0500000US01025",
    "aland": 3207612185,
    "awater": 36542657,
    "countyfp": "025",
    "countyns": "00161538",
    "dotregion": 4,
    "geoid": "01025",
    "lsad": "06",
    "name": "Clarke",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 104,
    "affgeoid": "0500000US01027",
    "aland": 1564252367,
    "awater": 5284573,
    "countyfp": "027",
    "countyns": "00161539",
    "dotregion": 4,
    "geoid": "01027",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1129,
    "affgeoid": "0500000US01029",
    "aland": 1450663941,
    "awater": 2354898,
    "countyfp": "029",
    "countyns": "00161540",
    "dotregion": 4,
    "geoid": "01029",
    "lsad": "06",
    "name": "Cleburne",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2097,
    "affgeoid": "0500000US01031",
    "aland": 1758565487,
    "awater": 3907876,
    "countyfp": "031",
    "countyns": "00161541",
    "dotregion": 4,
    "geoid": "01031",
    "lsad": "06",
    "name": "Coffee",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2126,
    "affgeoid": "0500000US01033",
    "aland": 1534878331,
    "awater": 80030048,
    "countyfp": "033",
    "countyns": "00161542",
    "dotregion": 4,
    "geoid": "01033",
    "lsad": "06",
    "name": "Colbert",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1616,
    "affgeoid": "0500000US01035",
    "aland": 2201896058,
    "awater": 6643480,
    "countyfp": "035",
    "countyns": "00161543",
    "dotregion": 4,
    "geoid": "01035",
    "lsad": "06",
    "name": "Conecuh",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2190,
    "affgeoid": "0500000US01037",
    "aland": 1685891509,
    "awater": 39946563,
    "countyfp": "037",
    "countyns": "00161544",
    "dotregion": 4,
    "geoid": "01037",
    "lsad": "06",
    "name": "Coosa",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1923,
    "affgeoid": "0500000US01039",
    "aland": 2668870080,
    "awater": 34526155,
    "countyfp": "039",
    "countyns": "00161545",
    "dotregion": 4,
    "geoid": "01039",
    "lsad": "06",
    "name": "Covington",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2276,
    "affgeoid": "0500000US01041",
    "aland": 1576887783,
    "awater": 5376390,
    "countyfp": "041",
    "countyns": "00161546",
    "dotregion": 4,
    "geoid": "01041",
    "lsad": "06",
    "name": "Crenshaw",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 701,
    "affgeoid": "0500000US01043",
    "aland": 1903376556,
    "awater": 52118974,
    "countyfp": "043",
    "countyns": "00161547",
    "dotregion": 4,
    "geoid": "01043",
    "lsad": "06",
    "name": "Cullman",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 643,
    "affgeoid": "0500000US01045",
    "aland": 1453371189,
    "awater": 4016457,
    "countyfp": "045",
    "countyns": "00161548",
    "dotregion": 4,
    "geoid": "01045",
    "lsad": "06",
    "name": "Dale",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2893,
    "affgeoid": "0500000US01047",
    "aland": 2534807220,
    "awater": 39134809,
    "countyfp": "047",
    "countyns": "00161549",
    "dotregion": 4,
    "geoid": "01047",
    "lsad": "06",
    "name": "Dallas",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1987,
    "affgeoid": "0500000US01049",
    "aland": 2012664317,
    "awater": 4121538,
    "countyfp": "049",
    "countyns": "00161550",
    "dotregion": 4,
    "geoid": "01049",
    "lsad": "06",
    "name": "DeKalb",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 770,
    "affgeoid": "0500000US01051",
    "aland": 1601876535,
    "awater": 99850740,
    "countyfp": "051",
    "countyns": "00161551",
    "dotregion": 4,
    "geoid": "01051",
    "lsad": "06",
    "name": "Elmore",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1965,
    "affgeoid": "0500000US01053",
    "aland": 2447747106,
    "awater": 20872955,
    "countyfp": "053",
    "countyns": "00161552",
    "dotregion": 4,
    "geoid": "01053",
    "lsad": "06",
    "name": "Escambia",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1903,
    "affgeoid": "0500000US01055",
    "aland": 1386379576,
    "awater": 34562865,
    "countyfp": "055",
    "countyns": "00161553",
    "dotregion": 4,
    "geoid": "01055",
    "lsad": "06",
    "name": "Etowah",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 166,
    "affgeoid": "0500000US01057",
    "aland": 1625693286,
    "awater": 4330881,
    "countyfp": "057",
    "countyns": "00161554",
    "dotregion": 4,
    "geoid": "01057",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2416,
    "affgeoid": "0500000US01059",
    "aland": 1641578182,
    "awater": 32907210,
    "countyfp": "059",
    "countyns": "00161555",
    "dotregion": 4,
    "geoid": "01059",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 721,
    "affgeoid": "0500000US01061",
    "aland": 1487710773,
    "awater": 11765077,
    "countyfp": "061",
    "countyns": "00161556",
    "dotregion": 4,
    "geoid": "01061",
    "lsad": "06",
    "name": "Geneva",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1783,
    "affgeoid": "0500000US01063",
    "aland": 1675993309,
    "awater": 33244743,
    "countyfp": "063",
    "countyns": "00161557",
    "dotregion": 4,
    "geoid": "01063",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 942,
    "affgeoid": "0500000US01065",
    "aland": 1667804583,
    "awater": 32525874,
    "countyfp": "065",
    "countyns": "00161558",
    "dotregion": 4,
    "geoid": "01065",
    "lsad": "06",
    "name": "Hale",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2963,
    "affgeoid": "0500000US01067",
    "aland": 1454926615,
    "awater": 16986823,
    "countyfp": "067",
    "countyns": "00161559",
    "dotregion": 4,
    "geoid": "01067",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 929,
    "affgeoid": "0500000US01069",
    "aland": 1501741356,
    "awater": 4736086,
    "countyfp": "069",
    "countyns": "00161560",
    "dotregion": 4,
    "geoid": "01069",
    "lsad": "06",
    "name": "Houston",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 3063,
    "affgeoid": "0500000US01071",
    "aland": 2791663770,
    "awater": 126657151,
    "countyfp": "071",
    "countyns": "00161561",
    "dotregion": 4,
    "geoid": "01071",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1322,
    "affgeoid": "0500000US01073",
    "aland": 2878198239,
    "awater": 32472131,
    "countyfp": "073",
    "countyns": "00161562",
    "dotregion": 4,
    "geoid": "01073",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 284,
    "affgeoid": "0500000US01075",
    "aland": 1566544639,
    "awater": 1600679,
    "countyfp": "075",
    "countyns": "00161563",
    "dotregion": 4,
    "geoid": "01075",
    "lsad": "06",
    "name": "Lamar",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 844,
    "affgeoid": "0500000US01077",
    "aland": 1729334078,
    "awater": 134420924,
    "countyfp": "077",
    "countyns": "00161564",
    "dotregion": 4,
    "geoid": "01077",
    "lsad": "06",
    "name": "Lauderdale",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1374,
    "affgeoid": "0500000US01079",
    "aland": 1788846346,
    "awater": 68687359,
    "countyfp": "079",
    "countyns": "00161565",
    "dotregion": 4,
    "geoid": "01079",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2047,
    "affgeoid": "0500000US01081",
    "aland": 1573552324,
    "awater": 21488937,
    "countyfp": "081",
    "countyns": "00161566",
    "dotregion": 4,
    "geoid": "01081",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2838,
    "affgeoid": "0500000US01083",
    "aland": 1450234553,
    "awater": 122373517,
    "countyfp": "083",
    "countyns": "00161567",
    "dotregion": 4,
    "geoid": "01083",
    "lsad": "06",
    "name": "Limestone",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1774,
    "affgeoid": "0500000US01085",
    "aland": 1854202072,
    "awater": 23721045,
    "countyfp": "085",
    "countyns": "00161568",
    "dotregion": 4,
    "geoid": "01085",
    "lsad": "06",
    "name": "Lowndes",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2786,
    "affgeoid": "0500000US01087",
    "aland": 1577005077,
    "awater": 11195999,
    "countyfp": "087",
    "countyns": "00161569",
    "dotregion": 4,
    "geoid": "01087",
    "lsad": "06",
    "name": "Macon",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2189,
    "affgeoid": "0500000US01089",
    "aland": 2076115403,
    "awater": 28770844,
    "countyfp": "089",
    "countyns": "00161570",
    "dotregion": 4,
    "geoid": "01089",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2669,
    "affgeoid": "0500000US01091",
    "aland": 2530112315,
    "awater": 14994544,
    "countyfp": "091",
    "countyns": "00161572",
    "dotregion": 4,
    "geoid": "01091",
    "lsad": "06",
    "name": "Marengo",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 117,
    "affgeoid": "0500000US01093",
    "aland": 1922527480,
    "awater": 3313159,
    "countyfp": "093",
    "countyns": "00161573",
    "dotregion": 4,
    "geoid": "01093",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1295,
    "affgeoid": "0500000US01095",
    "aland": 1465524083,
    "awater": 148503229,
    "countyfp": "095",
    "countyns": "00161574",
    "dotregion": 4,
    "geoid": "01095",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1964,
    "affgeoid": "0500000US01097",
    "aland": 3184121204,
    "awater": 1073852495,
    "countyfp": "097",
    "countyns": "00161575",
    "dotregion": 4,
    "geoid": "01097",
    "lsad": "06",
    "name": "Mobile",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1350,
    "affgeoid": "0500000US01099",
    "aland": 2656521232,
    "awater": 22609677,
    "countyfp": "099",
    "countyns": "00161576",
    "dotregion": 4,
    "geoid": "01099",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 3200,
    "affgeoid": "0500000US01101",
    "aland": 2031369248,
    "awater": 40392803,
    "countyfp": "101",
    "countyns": "00161577",
    "dotregion": 4,
    "geoid": "01101",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 282,
    "affgeoid": "0500000US01103",
    "aland": 1500534815,
    "awater": 51006061,
    "countyfp": "103",
    "countyns": "00161578",
    "dotregion": 4,
    "geoid": "01103",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2663,
    "affgeoid": "0500000US01105",
    "aland": 1863919953,
    "awater": 10918482,
    "countyfp": "105",
    "countyns": "00161579",
    "dotregion": 4,
    "geoid": "01105",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 292,
    "affgeoid": "0500000US01107",
    "aland": 2282893857,
    "awater": 22521211,
    "countyfp": "107",
    "countyns": "00161580",
    "dotregion": 4,
    "geoid": "01107",
    "lsad": "06",
    "name": "Pickens",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2235,
    "affgeoid": "0500000US01109",
    "aland": 1740741211,
    "awater": 2336975,
    "countyfp": "109",
    "countyns": "00161581",
    "dotregion": 4,
    "geoid": "01109",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1640,
    "affgeoid": "0500000US01111",
    "aland": 1503616100,
    "awater": 9285296,
    "countyfp": "111",
    "countyns": "00161582",
    "dotregion": 4,
    "geoid": "01111",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2814,
    "affgeoid": "0500000US01113",
    "aland": 1660584041,
    "awater": 15635292,
    "countyfp": "113",
    "countyns": "00161583",
    "dotregion": 4,
    "geoid": "01113",
    "lsad": "06",
    "name": "Russell",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2261,
    "affgeoid": "0500000US01117",
    "aland": 2034095311,
    "awater": 62562159,
    "countyfp": "117",
    "countyns": "00161584",
    "dotregion": 4,
    "geoid": "01117",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 3188,
    "affgeoid": "0500000US01115",
    "aland": 1636625209,
    "awater": 56293578,
    "countyfp": "115",
    "countyns": "00164997",
    "dotregion": 4,
    "geoid": "01115",
    "lsad": "06",
    "name": "St. Clair",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1352,
    "affgeoid": "0500000US01119",
    "aland": 2341060793,
    "awater": 24432727,
    "countyfp": "119",
    "countyns": "00161585",
    "dotregion": 4,
    "geoid": "01119",
    "lsad": "06",
    "name": "Sumter",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2643,
    "affgeoid": "0500000US01121",
    "aland": 1908244139,
    "awater": 60939223,
    "countyfp": "121",
    "countyns": "00161586",
    "dotregion": 4,
    "geoid": "01121",
    "lsad": "06",
    "name": "Talladega",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2788,
    "affgeoid": "0500000US01123",
    "aland": 1855779799,
    "awater": 128809185,
    "countyfp": "123",
    "countyns": "00161587",
    "dotregion": 4,
    "geoid": "01123",
    "lsad": "06",
    "name": "Tallapoosa",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1325,
    "affgeoid": "0500000US01125",
    "aland": 3423119895,
    "awater": 76604723,
    "countyfp": "125",
    "countyns": "00161588",
    "dotregion": 4,
    "geoid": "01125",
    "lsad": "06",
    "name": "Tuscaloosa",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 1353,
    "affgeoid": "0500000US01127",
    "aland": 2049182057,
    "awater": 36258716,
    "countyfp": "127",
    "countyns": "00161589",
    "dotregion": 4,
    "geoid": "01127",
    "lsad": "06",
    "name": "Walker",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2776,
    "affgeoid": "0500000US01129",
    "aland": 2797722220,
    "awater": 21650835,
    "countyfp": "129",
    "countyns": "00161590",
    "dotregion": 4,
    "geoid": "01129",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 2373,
    "affgeoid": "0500000US01131",
    "aland": 2301199922,
    "awater": 48985143,
    "countyfp": "131",
    "countyns": "00161591",
    "dotregion": 4,
    "geoid": "01131",
    "lsad": "06",
    "name": "Wilcox",
    "stateAbbreviation": "AL",
    "stateId": 38
  }, {
    "id": 283,
    "affgeoid": "0500000US01133",
    "aland": 1587616107,
    "awater": 48922726,
    "countyfp": "133",
    "countyns": "00161592",
    "dotregion": 4,
    "geoid": "01133",
    "lsad": "06",
    "name": "Winston",
    "stateAbbreviation": "AL",
    "stateId": 38
  }]
}, {
  "id": 14,
  "abbreviation": "AK",
  "affgeoid": "0400000US02",
  "aland": 1477946338495,
  "awater": 245391672906,
  "dotregion": 10,
  "geoid": "02",
  "lsad": "00",
  "name": "Alaska",
  "stateAbbreviation": "AK",
  "statefp": "02",
  "statens": "01785533",
  "counties": [{
    "id": 547,
    "affgeoid": "0500000US02013",
    "aland": 18082872046,
    "awater": 20793145623,
    "countyfp": "013",
    "countyns": "01419964",
    "dotregion": 10,
    "geoid": "02013",
    "lsad": "04",
    "name": "Aleutians East",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 3190,
    "affgeoid": "0500000US02016",
    "aland": 11370495309,
    "awater": 25190642181,
    "countyfp": "016",
    "countyns": "01419965",
    "dotregion": 10,
    "geoid": "02016",
    "lsad": "05",
    "name": "Aleutians West",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 1507,
    "affgeoid": "0500000US02020",
    "aland": 4420343302,
    "awater": 663023276,
    "countyfp": "020",
    "countyns": "01416061",
    "dotregion": 10,
    "geoid": "02020",
    "lsad": "12",
    "name": "Anchorage",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 565,
    "affgeoid": "0500000US02050",
    "aland": 105075885504,
    "awater": 12779538666,
    "countyfp": "050",
    "countyns": "01419966",
    "dotregion": 10,
    "geoid": "02050",
    "lsad": "05",
    "name": "Bethel",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 274,
    "affgeoid": "0500000US02060",
    "aland": 1304962195,
    "awater": 993834934,
    "countyfp": "060",
    "countyns": "01419967",
    "dotregion": 10,
    "geoid": "02060",
    "lsad": "04",
    "name": "Bristol Bay",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 7070,
    "dotregion": 10,
    "geoid": "02063",
    "name": "Chugach",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 8313,
    "dotregion": 10,
    "geoid": "02066",
    "name": "Copper River",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2388,
    "affgeoid": "0500000US02068",
    "aland": 33015947847,
    "awater": 66068782,
    "countyfp": "068",
    "countyns": "01419988",
    "dotregion": 10,
    "geoid": "02068",
    "lsad": "04",
    "name": "Denali",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2085,
    "affgeoid": "0500000US02070",
    "aland": 48093448272,
    "awater": 6077139167,
    "countyfp": "070",
    "countyns": "01419968",
    "dotregion": 10,
    "geoid": "02070",
    "lsad": "05",
    "name": "Dillingham",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2834,
    "affgeoid": "0500000US02090",
    "aland": 19019023800,
    "awater": 275189755,
    "countyfp": "090",
    "countyns": "01419969",
    "dotregion": 10,
    "geoid": "02090",
    "lsad": "04",
    "name": "Fairbanks North Star",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2132,
    "affgeoid": "0500000US02100",
    "aland": 6009021796,
    "awater": 1049986571,
    "countyfp": "100",
    "countyns": "01419970",
    "dotregion": 10,
    "geoid": "02100",
    "lsad": "04",
    "name": "Haines",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2195,
    "affgeoid": "0500000US02105",
    "aland": 16966364044,
    "awater": 7799665707,
    "countyfp": "105",
    "countyns": "02371430",
    "dotregion": 10,
    "geoid": "02105",
    "lsad": "05",
    "name": "Hoonah-Angoon",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2305,
    "affgeoid": "0500000US02110",
    "aland": 6998182120,
    "awater": 1429472851,
    "countyfp": "110",
    "countyns": "01419971",
    "dotregion": 10,
    "geoid": "02110",
    "lsad": "03",
    "name": "Juneau",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 1237,
    "affgeoid": "0500000US02122",
    "aland": 41634738098,
    "awater": 22473667447,
    "countyfp": "122",
    "countyns": "01419972",
    "dotregion": 10,
    "geoid": "02122",
    "lsad": "04",
    "name": "Kenai Peninsula",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2105,
    "affgeoid": "0500000US02130",
    "aland": 12583284815,
    "awater": 4649397284,
    "countyfp": "130",
    "countyns": "01419973",
    "dotregion": 10,
    "geoid": "02130",
    "lsad": "04",
    "name": "Ketchikan Gateway",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 807,
    "affgeoid": "0500000US02150",
    "aland": 16965364377,
    "awater": 14171111659,
    "countyfp": "150",
    "countyns": "01419974",
    "dotregion": 10,
    "geoid": "02150",
    "lsad": "04",
    "name": "Kodiak Island",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2160,
    "affgeoid": "0500000US02158",
    "aland": 44240303738,
    "awater": 6712008759,
    "countyfp": "158",
    "countyns": "01419985",
    "dotregion": 10,
    "geoid": "02158",
    "lsad": "05",
    "name": "Kusilvak",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 1238,
    "affgeoid": "0500000US02164",
    "aland": 60735993529,
    "awater": 24532276414,
    "countyfp": "164",
    "countyns": "01419975",
    "dotregion": 10,
    "geoid": "02164",
    "lsad": "04",
    "name": "Lake and Peninsula",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 3173,
    "affgeoid": "0500000US02170",
    "aland": 63734631763,
    "awater": 1682661470,
    "countyfp": "170",
    "countyns": "01419976",
    "dotregion": 10,
    "geoid": "02170",
    "lsad": "04",
    "name": "Matanuska-Susitna",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 736,
    "affgeoid": "0500000US02180",
    "aland": 59473768672,
    "awater": 13767977491,
    "countyfp": "180",
    "countyns": "01419977",
    "dotregion": 10,
    "geoid": "02180",
    "lsad": "05",
    "name": "Nome",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2799,
    "affgeoid": "0500000US02185",
    "aland": 230092740514,
    "awater": 15795362153,
    "countyfp": "185",
    "countyns": "01419978",
    "dotregion": 10,
    "geoid": "02185",
    "lsad": "04",
    "name": "North Slope",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2718,
    "affgeoid": "0500000US02188",
    "aland": 92295122743,
    "awater": 12906736753,
    "countyfp": "188",
    "countyns": "01419979",
    "dotregion": 10,
    "geoid": "02188",
    "lsad": "04",
    "name": "Northwest Arctic",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2900,
    "affgeoid": "0500000US02195",
    "aland": 7556529587,
    "awater": 2399243232,
    "countyfp": "195",
    "countyns": "02516404",
    "dotregion": 10,
    "geoid": "02195",
    "lsad": "04",
    "name": "Petersburg",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2870,
    "affgeoid": "0500000US02198",
    "aland": 13628542078,
    "awater": 14538534959,
    "countyfp": "198",
    "countyns": "01419980",
    "dotregion": 10,
    "geoid": "02198",
    "lsad": "05",
    "name": "Prince of Wales-Hyder",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2106,
    "affgeoid": "0500000US02220",
    "aland": 7434275351,
    "awater": 5027235337,
    "countyfp": "220",
    "countyns": "01419981",
    "dotregion": 10,
    "geoid": "02220",
    "lsad": "03",
    "name": "Sitka",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 208,
    "affgeoid": "0500000US02230",
    "aland": 1171510537,
    "awater": 30331285,
    "countyfp": "230",
    "countyns": "02339479",
    "dotregion": 10,
    "geoid": "02230",
    "lsad": "12",
    "name": "Skagway",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2918,
    "affgeoid": "0500000US02240",
    "aland": 64147802443,
    "awater": 752268780,
    "countyfp": "240",
    "countyns": "01419983",
    "dotregion": 10,
    "geoid": "02240",
    "lsad": "05",
    "name": "Southeast Fairbanks",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2043,
    "affgeoid": "0500000US02261",
    "aland": 88676741086,
    "awater": 15799448122,
    "countyfp": "261",
    "countyns": "01419984",
    "dotregion": 10,
    "geoid": "02261",
    "lsad": "05",
    "name": "Valdez-Cordova",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 3169,
    "affgeoid": "0500000US02275",
    "aland": 6582396275,
    "awater": 2384301874,
    "countyfp": "275",
    "countyns": "02516402",
    "dotregion": 10,
    "geoid": "02275",
    "lsad": "03",
    "name": "Wrangell",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2172,
    "affgeoid": "0500000US02282",
    "aland": 19811664933,
    "awater": 4696568493,
    "countyfp": "282",
    "countyns": "01419986",
    "dotregion": 10,
    "geoid": "02282",
    "lsad": "03",
    "name": "Yakutat",
    "stateAbbreviation": "AK",
    "stateId": 14
  }, {
    "id": 2880,
    "affgeoid": "0500000US02290",
    "aland": 376824381721,
    "awater": 5954833881,
    "countyfp": "290",
    "countyns": "01419987",
    "dotregion": 10,
    "geoid": "02290",
    "lsad": "05",
    "name": "Yukon-Koyukuk",
    "stateAbbreviation": "AK",
    "stateId": 14
  }]
}, {
  "id": 55,
  "abbreviation": "AS",
  "dotregion": 9,
  "geoid": "60",
  "name": "American Samoa",
  "stateAbbreviation": "AS",
  "statefp": "60",
  "counties": [{
    "id": 3228,
    "countyfp": "010",
    "countyns": "01805240",
    "dotregion": 9,
    "geoid": "60010",
    "name": "Eastern",
    "stateAbbreviation": "AS",
    "stateId": 55
  }, {
    "id": 3224,
    "countyfp": "020",
    "countyns": "01805242",
    "dotregion": 9,
    "geoid": "60020",
    "name": "Manu'a",
    "stateAbbreviation": "AS",
    "stateId": 55
  }, {
    "id": 3233,
    "countyfp": "030",
    "countyns": "01805243",
    "dotregion": 9,
    "geoid": "60030",
    "name": "Rose Island",
    "stateAbbreviation": "AS",
    "stateId": 55
  }, {
    "id": 3232,
    "countyfp": "040",
    "countyns": "01805244",
    "dotregion": 9,
    "geoid": "60040",
    "name": "Swains Island",
    "stateAbbreviation": "AS",
    "stateId": 55
  }, {
    "id": 3229,
    "countyfp": "050",
    "countyns": "01805241",
    "dotregion": 9,
    "geoid": "60050",
    "name": "Western",
    "stateAbbreviation": "AS",
    "stateId": 55
  }]
}, {
  "id": 43,
  "abbreviation": "AZ",
  "affgeoid": "0400000US04",
  "aland": 294204474990,
  "awater": 1027559124,
  "dotregion": 9,
  "geoid": "04",
  "lsad": "00",
  "name": "Arizona",
  "stateAbbreviation": "AZ",
  "statefp": "04",
  "statens": "01779777",
  "counties": [{
    "id": 3139,
    "affgeoid": "0500000US04001",
    "aland": 29001812294,
    "awater": 54170779,
    "countyfp": "001",
    "countyns": "00025441",
    "dotregion": 9,
    "geoid": "04001",
    "lsad": "06",
    "name": "Apache",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 1109,
    "affgeoid": "0500000US04003",
    "aland": 15968982233,
    "awater": 137024922,
    "countyfp": "003",
    "countyns": "00025442",
    "dotregion": 9,
    "geoid": "04003",
    "lsad": "06",
    "name": "Cochise",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 2082,
    "affgeoid": "0500000US04005",
    "aland": 48222080889,
    "awater": 110096951,
    "countyfp": "005",
    "countyns": "00025443",
    "dotregion": 9,
    "geoid": "04005",
    "lsad": "06",
    "name": "Coconino",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 589,
    "affgeoid": "0500000US04007",
    "aland": 12323041468,
    "awater": 97111975,
    "countyfp": "007",
    "countyns": "00040471",
    "dotregion": 9,
    "geoid": "04007",
    "lsad": "06",
    "name": "Gila",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 2269,
    "affgeoid": "0500000US04009",
    "aland": 11972305015,
    "awater": 47705575,
    "countyfp": "009",
    "countyns": "00025444",
    "dotregion": 9,
    "geoid": "04009",
    "lsad": "06",
    "name": "Graham",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 2127,
    "affgeoid": "0500000US04011",
    "aland": 4773671883,
    "awater": 13745242,
    "countyfp": "011",
    "countyns": "00042807",
    "dotregion": 9,
    "geoid": "04011",
    "lsad": "06",
    "name": "Greenlee",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 2008,
    "affgeoid": "0500000US04012",
    "aland": 11654000682,
    "awater": 36568021,
    "countyfp": "012",
    "countyns": "00043540",
    "dotregion": 9,
    "geoid": "04012",
    "lsad": "06",
    "name": "La Paz",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 2707,
    "affgeoid": "0500000US04013",
    "aland": 23826751660,
    "awater": 64344166,
    "countyfp": "013",
    "countyns": "00037026",
    "dotregion": 9,
    "geoid": "04013",
    "lsad": "06",
    "name": "Maricopa",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 2046,
    "affgeoid": "0500000US04015",
    "aland": 34475714657,
    "awater": 387347771,
    "countyfp": "015",
    "countyns": "00025445",
    "dotregion": 9,
    "geoid": "04015",
    "lsad": "06",
    "name": "Mohave",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 3041,
    "affgeoid": "0500000US04017",
    "aland": 25770082478,
    "awater": 24078111,
    "countyfp": "017",
    "countyns": "00042808",
    "dotregion": 9,
    "geoid": "04017",
    "lsad": "06",
    "name": "Navajo",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 70,
    "affgeoid": "0500000US04019",
    "aland": 23794325411,
    "awater": 5273054,
    "countyfp": "019",
    "countyns": "00025446",
    "dotregion": 9,
    "geoid": "04019",
    "lsad": "06",
    "name": "Pima",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 2631,
    "affgeoid": "0500000US04021",
    "aland": 13897001099,
    "awater": 22331619,
    "countyfp": "021",
    "countyns": "00025447",
    "dotregion": 9,
    "geoid": "04021",
    "lsad": "06",
    "name": "Pinal",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 539,
    "affgeoid": "0500000US04023",
    "aland": 3203593349,
    "awater": 3088047,
    "countyfp": "023",
    "countyns": "00040472",
    "dotregion": 9,
    "geoid": "04023",
    "lsad": "06",
    "name": "Santa Cruz",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 1634,
    "affgeoid": "0500000US04025",
    "aland": 21039920080,
    "awater": 11501575,
    "countyfp": "025",
    "countyns": "00042809",
    "dotregion": 9,
    "geoid": "04025",
    "lsad": "06",
    "name": "Yavapai",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }, {
    "id": 918,
    "affgeoid": "0500000US04027",
    "aland": 14281191792,
    "awater": 13171316,
    "countyfp": "027",
    "countyns": "00023901",
    "dotregion": 9,
    "geoid": "04027",
    "lsad": "06",
    "name": "Yuma",
    "stateAbbreviation": "AZ",
    "stateId": 43
  }]
}, {
  "id": 24,
  "abbreviation": "AR",
  "affgeoid": "0400000US05",
  "aland": 134769279101,
  "awater": 2962525273,
  "dotregion": 6,
  "geoid": "05",
  "lsad": "00",
  "name": "Arkansas",
  "stateAbbreviation": "AR",
  "statefp": "05",
  "statens": "00068085",
  "counties": [{
    "id": 566,
    "affgeoid": "0500000US05001",
    "aland": 2560983546,
    "awater": 116414557,
    "countyfp": "001",
    "countyns": "00063755",
    "dotregion": 6,
    "geoid": "05001",
    "lsad": "06",
    "name": "Arkansas",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 845,
    "affgeoid": "0500000US05003",
    "aland": 2396641860,
    "awater": 39310599,
    "countyfp": "003",
    "countyns": "00063756",
    "dotregion": 6,
    "geoid": "05003",
    "lsad": "06",
    "name": "Ashley",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1301,
    "affgeoid": "0500000US05005",
    "aland": 1435587425,
    "awater": 84022334,
    "countyfp": "005",
    "countyns": "00069895",
    "dotregion": 6,
    "geoid": "05005",
    "lsad": "06",
    "name": "Baxter",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 716,
    "affgeoid": "0500000US05007",
    "aland": 2194786302,
    "awater": 94519642,
    "countyfp": "007",
    "countyns": "00069896",
    "dotregion": 6,
    "geoid": "05007",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 339,
    "affgeoid": "0500000US05009",
    "aland": 1528950329,
    "awater": 30222243,
    "countyfp": "009",
    "countyns": "00069897",
    "dotregion": 6,
    "geoid": "05009",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1394,
    "affgeoid": "0500000US05011",
    "aland": 1681514473,
    "awater": 9532926,
    "countyfp": "011",
    "countyns": "00063757",
    "dotregion": 6,
    "geoid": "05011",
    "lsad": "06",
    "name": "Bradley",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 738,
    "affgeoid": "0500000US05013",
    "aland": 1627959403,
    "awater": 9926147,
    "countyfp": "013",
    "countyns": "00063758",
    "dotregion": 6,
    "geoid": "05013",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1823,
    "affgeoid": "0500000US05015",
    "aland": 1631639780,
    "awater": 22384066,
    "countyfp": "015",
    "countyns": "00066975",
    "dotregion": 6,
    "geoid": "05015",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1939,
    "affgeoid": "0500000US05017",
    "aland": 1668755471,
    "awater": 120391646,
    "countyfp": "017",
    "countyns": "00069160",
    "dotregion": 6,
    "geoid": "05017",
    "lsad": "06",
    "name": "Chicot",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 737,
    "affgeoid": "0500000US05019",
    "aland": 2243121980,
    "awater": 43395986,
    "countyfp": "019",
    "countyns": "00066845",
    "dotregion": 6,
    "geoid": "05019",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1396,
    "affgeoid": "0500000US05021",
    "aland": 1656162400,
    "awater": 5149783,
    "countyfp": "021",
    "countyns": "00063759",
    "dotregion": 6,
    "geoid": "05021",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 3054,
    "affgeoid": "0500000US05023",
    "aland": 1434051759,
    "awater": 99015208,
    "countyfp": "023",
    "countyns": "00066983",
    "dotregion": 6,
    "geoid": "05023",
    "lsad": "06",
    "name": "Cleburne",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1954,
    "affgeoid": "0500000US05025",
    "aland": 1548252554,
    "awater": 2500346,
    "countyfp": "025",
    "countyns": "00063760",
    "dotregion": 6,
    "geoid": "05025",
    "lsad": "06",
    "name": "Cleveland",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1749,
    "affgeoid": "0500000US05027",
    "aland": 1984105628,
    "awater": 1774699,
    "countyfp": "027",
    "countyns": "00063761",
    "dotregion": 6,
    "geoid": "05027",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2856,
    "affgeoid": "0500000US05029",
    "aland": 1430338375,
    "awater": 37323934,
    "countyfp": "029",
    "countyns": "00066846",
    "dotregion": 6,
    "geoid": "05029",
    "lsad": "06",
    "name": "Conway",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 551,
    "affgeoid": "0500000US05031",
    "aland": 1831770494,
    "awater": 14166014,
    "countyfp": "031",
    "countyns": "00066847",
    "dotregion": 6,
    "geoid": "05031",
    "lsad": "06",
    "name": "Craighead",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1380,
    "affgeoid": "0500000US05033",
    "aland": 1531185851,
    "awater": 31078912,
    "countyfp": "033",
    "countyns": "00069161",
    "dotregion": 6,
    "geoid": "05033",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2438,
    "affgeoid": "0500000US05035",
    "aland": 1579530069,
    "awater": 68675498,
    "countyfp": "035",
    "countyns": "00069162",
    "dotregion": 6,
    "geoid": "05035",
    "lsad": "06",
    "name": "Crittenden",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2472,
    "affgeoid": "0500000US05037",
    "aland": 1596418375,
    "awater": 15348632,
    "countyfp": "037",
    "countyns": "00066848",
    "dotregion": 6,
    "geoid": "05037",
    "lsad": "06",
    "name": "Cross",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2540,
    "affgeoid": "0500000US05039",
    "aland": 1728522517,
    "awater": 1864048,
    "countyfp": "039",
    "countyns": "00066849",
    "dotregion": 6,
    "geoid": "05039",
    "lsad": "06",
    "name": "Dallas",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2937,
    "affgeoid": "0500000US05041",
    "aland": 1989488184,
    "awater": 133059776,
    "countyfp": "041",
    "countyns": "00066850",
    "dotregion": 6,
    "geoid": "05041",
    "lsad": "06",
    "name": "Desha",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1437,
    "affgeoid": "0500000US05043",
    "aland": 2145506718,
    "awater": 18920680,
    "countyfp": "043",
    "countyns": "00066851",
    "dotregion": 6,
    "geoid": "05043",
    "lsad": "06",
    "name": "Drew",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1013,
    "affgeoid": "0500000US05045",
    "aland": 1678084569,
    "awater": 41857893,
    "countyfp": "045",
    "countyns": "00066852",
    "dotregion": 6,
    "geoid": "05045",
    "lsad": "06",
    "name": "Faulkner",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 341,
    "affgeoid": "0500000US05047",
    "aland": 1576934896,
    "awater": 27931424,
    "countyfp": "047",
    "countyns": "00066853",
    "dotregion": 6,
    "geoid": "05047",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2576,
    "affgeoid": "0500000US05049",
    "aland": 1601113473,
    "awater": 5527446,
    "countyfp": "049",
    "countyns": "00066854",
    "dotregion": 6,
    "geoid": "05049",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 184,
    "affgeoid": "0500000US05051",
    "aland": 1755505406,
    "awater": 147165424,
    "countyfp": "051",
    "countyns": "00066855",
    "dotregion": 6,
    "geoid": "05051",
    "lsad": "06",
    "name": "Garland",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1945,
    "affgeoid": "0500000US05053",
    "aland": 1636383569,
    "awater": 2897719,
    "countyfp": "053",
    "countyns": "00066856",
    "dotregion": 6,
    "geoid": "05053",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2954,
    "affgeoid": "0500000US05055",
    "aland": 1496205816,
    "awater": 4789584,
    "countyfp": "055",
    "countyns": "00066857",
    "dotregion": 6,
    "geoid": "05055",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1709,
    "affgeoid": "0500000US05057",
    "aland": 1884268834,
    "awater": 35371745,
    "countyfp": "057",
    "countyns": "00066858",
    "dotregion": 6,
    "geoid": "05057",
    "lsad": "06",
    "name": "Hempstead",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2886,
    "affgeoid": "0500000US05059",
    "aland": 1593379456,
    "awater": 18035696,
    "countyfp": "059",
    "countyns": "00066859",
    "dotregion": 6,
    "geoid": "05059",
    "lsad": "06",
    "name": "Hot Spring",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1179,
    "affgeoid": "0500000US05061",
    "aland": 1524346473,
    "awater": 17509484,
    "countyfp": "061",
    "countyns": "00066872",
    "dotregion": 6,
    "geoid": "05061",
    "lsad": "06",
    "name": "Howard",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1403,
    "affgeoid": "0500000US05063",
    "aland": 1978630975,
    "awater": 19594198,
    "countyfp": "063",
    "countyns": "00069163",
    "dotregion": 6,
    "geoid": "05063",
    "lsad": "06",
    "name": "Independence",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 5,
    "affgeoid": "0500000US05065",
    "aland": 1503685418,
    "awater": 8912603,
    "countyfp": "065",
    "countyns": "00066860",
    "dotregion": 6,
    "geoid": "05065",
    "lsad": "06",
    "name": "Izard",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1201,
    "affgeoid": "0500000US05067",
    "aland": 1641888774,
    "awater": 19587819,
    "countyfp": "067",
    "countyns": "00066861",
    "dotregion": 6,
    "geoid": "05067",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2797,
    "affgeoid": "0500000US05069",
    "aland": 2255220496,
    "awater": 111446634,
    "countyfp": "069",
    "countyns": "00066862",
    "dotregion": 6,
    "geoid": "05069",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 3127,
    "affgeoid": "0500000US05071",
    "aland": 1708890431,
    "awater": 59408531,
    "countyfp": "071",
    "countyns": "00066863",
    "dotregion": 6,
    "geoid": "05071",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2820,
    "affgeoid": "0500000US05073",
    "aland": 1368278117,
    "awater": 43469501,
    "countyfp": "073",
    "countyns": "00066864",
    "dotregion": 6,
    "geoid": "05073",
    "lsad": "06",
    "name": "Lafayette",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1521,
    "affgeoid": "0500000US05075",
    "aland": 1521921890,
    "awater": 12244924,
    "countyfp": "075",
    "countyns": "00066865",
    "dotregion": 6,
    "geoid": "05075",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1213,
    "affgeoid": "0500000US05077",
    "aland": 1560781751,
    "awater": 43720910,
    "countyfp": "077",
    "countyns": "00066866",
    "dotregion": 6,
    "geoid": "05077",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2183,
    "affgeoid": "0500000US05079",
    "aland": 1454438336,
    "awater": 27514921,
    "countyfp": "079",
    "countyns": "00066873",
    "dotregion": 6,
    "geoid": "05079",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 631,
    "affgeoid": "0500000US05081",
    "aland": 1378539246,
    "awater": 84198999,
    "countyfp": "081",
    "countyns": "00066874",
    "dotregion": 6,
    "geoid": "05081",
    "lsad": "06",
    "name": "Little River",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 471,
    "affgeoid": "0500000US05083",
    "aland": 1834025159,
    "awater": 60692619,
    "countyfp": "083",
    "countyns": "00082850",
    "dotregion": 6,
    "geoid": "05083",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 792,
    "affgeoid": "0500000US05085",
    "aland": 1996702719,
    "awater": 82664855,
    "countyfp": "085",
    "countyns": "00069164",
    "dotregion": 6,
    "geoid": "05085",
    "lsad": "06",
    "name": "Lonoke",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1383,
    "affgeoid": "0500000US05087",
    "aland": 2160703614,
    "awater": 7323063,
    "countyfp": "087",
    "countyns": "00069165",
    "dotregion": 6,
    "geoid": "05087",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2263,
    "affgeoid": "0500000US05089",
    "aland": 1546245372,
    "awater": 112149491,
    "countyfp": "089",
    "countyns": "00069898",
    "dotregion": 6,
    "geoid": "05089",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2961,
    "affgeoid": "0500000US05091",
    "aland": 1620264349,
    "awater": 31239265,
    "countyfp": "091",
    "countyns": "00069166",
    "dotregion": 6,
    "geoid": "05091",
    "lsad": "06",
    "name": "Miller",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 3189,
    "affgeoid": "0500000US05093",
    "aland": 2332480064,
    "awater": 49826361,
    "countyfp": "093",
    "countyns": "00069899",
    "dotregion": 6,
    "geoid": "05093",
    "lsad": "06",
    "name": "Mississippi",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2205,
    "affgeoid": "0500000US05095",
    "aland": 1572464643,
    "awater": 36715078,
    "countyfp": "095",
    "countyns": "00069167",
    "dotregion": 6,
    "geoid": "05095",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 403,
    "affgeoid": "0500000US05097",
    "aland": 2019881691,
    "awater": 52856416,
    "countyfp": "097",
    "countyns": "00069168",
    "dotregion": 6,
    "geoid": "05097",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2055,
    "affgeoid": "0500000US05099",
    "aland": 1600189574,
    "awater": 7257493,
    "countyfp": "099",
    "countyns": "00069169",
    "dotregion": 6,
    "geoid": "05099",
    "lsad": "06",
    "name": "Nevada",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2615,
    "affgeoid": "0500000US05101",
    "aland": 2126135098,
    "awater": 5931441,
    "countyfp": "101",
    "countyns": "00069900",
    "dotregion": 6,
    "geoid": "05101",
    "lsad": "06",
    "name": "Newton",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1826,
    "affgeoid": "0500000US05103",
    "aland": 1897900178,
    "awater": 18050428,
    "countyfp": "103",
    "countyns": "00069170",
    "dotregion": 6,
    "geoid": "05103",
    "lsad": "06",
    "name": "Ouachita",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2203,
    "affgeoid": "0500000US05105",
    "aland": 1428557830,
    "awater": 23206838,
    "countyfp": "105",
    "countyns": "00069171",
    "dotregion": 6,
    "geoid": "05105",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2206,
    "affgeoid": "0500000US05107",
    "aland": 1801659695,
    "awater": 82148488,
    "countyfp": "107",
    "countyns": "00069172",
    "dotregion": 6,
    "geoid": "05107",
    "lsad": "06",
    "name": "Phillips",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 221,
    "affgeoid": "0500000US05109",
    "aland": 1555596258,
    "awater": 34992296,
    "countyfp": "109",
    "countyns": "00069173",
    "dotregion": 6,
    "geoid": "05109",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1870,
    "affgeoid": "0500000US05111",
    "aland": 1964145925,
    "awater": 13522955,
    "countyfp": "111",
    "countyns": "00069174",
    "dotregion": 6,
    "geoid": "05111",
    "lsad": "06",
    "name": "Poinsett",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1972,
    "affgeoid": "0500000US05113",
    "aland": 2221380609,
    "awater": 12384829,
    "countyfp": "113",
    "countyns": "00069175",
    "dotregion": 6,
    "geoid": "05113",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2578,
    "affgeoid": "0500000US05115",
    "aland": 2104507243,
    "awater": 47189891,
    "countyfp": "115",
    "countyns": "00069901",
    "dotregion": 6,
    "geoid": "05115",
    "lsad": "06",
    "name": "Pope",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1214,
    "affgeoid": "0500000US05117",
    "aland": 1678092312,
    "awater": 71735056,
    "countyfp": "117",
    "countyns": "00069176",
    "dotregion": 6,
    "geoid": "05117",
    "lsad": "06",
    "name": "Prairie",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1204,
    "affgeoid": "0500000US05119",
    "aland": 1964546492,
    "awater": 127273982,
    "countyfp": "119",
    "countyns": "00069177",
    "dotregion": 6,
    "geoid": "05119",
    "lsad": "06",
    "name": "Pulaski",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 540,
    "affgeoid": "0500000US05121",
    "aland": 1689282528,
    "awater": 9858844,
    "countyfp": "121",
    "countyns": "00069178",
    "dotregion": 6,
    "geoid": "05121",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2306,
    "affgeoid": "0500000US05125",
    "aland": 1874165722,
    "awater": 17792843,
    "countyfp": "125",
    "countyns": "00067102",
    "dotregion": 6,
    "geoid": "05125",
    "lsad": "06",
    "name": "Saline",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2964,
    "affgeoid": "0500000US05127",
    "aland": 2311062119,
    "awater": 14900927,
    "countyfp": "127",
    "countyns": "00069179",
    "dotregion": 6,
    "geoid": "05127",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1784,
    "affgeoid": "0500000US05129",
    "aland": 1725176990,
    "awater": 6256693,
    "countyfp": "129",
    "countyns": "00069180",
    "dotregion": 6,
    "geoid": "05129",
    "lsad": "06",
    "name": "Searcy",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1847,
    "affgeoid": "0500000US05131",
    "aland": 1377584005,
    "awater": 39702610,
    "countyfp": "131",
    "countyns": "00069181",
    "dotregion": 6,
    "geoid": "05131",
    "lsad": "06",
    "name": "Sebastian",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2414,
    "affgeoid": "0500000US05133",
    "aland": 1463672048,
    "awater": 41829039,
    "countyfp": "133",
    "countyns": "00069182",
    "dotregion": 6,
    "geoid": "05133",
    "lsad": "06",
    "name": "Sevier",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 18,
    "affgeoid": "0500000US05135",
    "aland": 1565489620,
    "awater": 5172585,
    "countyfp": "135",
    "countyns": "00069183",
    "dotregion": 6,
    "geoid": "05135",
    "lsad": "06",
    "name": "Sharp",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1789,
    "affgeoid": "0500000US05123",
    "aland": 1644111375,
    "awater": 20049932,
    "countyfp": "123",
    "countyns": "00083331",
    "dotregion": 6,
    "geoid": "05123",
    "lsad": "06",
    "name": "St. Francis",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 332,
    "affgeoid": "0500000US05137",
    "aland": 1570579427,
    "awater": 7841929,
    "countyfp": "137",
    "countyns": "00069902",
    "dotregion": 6,
    "geoid": "05137",
    "lsad": "06",
    "name": "Stone",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2659,
    "affgeoid": "0500000US05139",
    "aland": 2691561515,
    "awater": 41401587,
    "countyfp": "139",
    "countyns": "00069903",
    "dotregion": 6,
    "geoid": "05139",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 328,
    "affgeoid": "0500000US05141",
    "aland": 1838267640,
    "awater": 37620450,
    "countyfp": "141",
    "countyns": "00069904",
    "dotregion": 6,
    "geoid": "05141",
    "lsad": "06",
    "name": "Van Buren",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 1744,
    "affgeoid": "0500000US05143",
    "aland": 2439803373,
    "awater": 26926563,
    "countyfp": "143",
    "countyns": "00069905",
    "dotregion": 6,
    "geoid": "05143",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2708,
    "affgeoid": "0500000US05145",
    "aland": 2680883279,
    "awater": 18261873,
    "countyfp": "145",
    "countyns": "00069906",
    "dotregion": 6,
    "geoid": "05145",
    "lsad": "06",
    "name": "White",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 3128,
    "affgeoid": "0500000US05147",
    "aland": 1519723218,
    "awater": 18704035,
    "countyfp": "147",
    "countyns": "00069907",
    "dotregion": 6,
    "geoid": "05147",
    "lsad": "06",
    "name": "Woodruff",
    "stateAbbreviation": "AR",
    "stateId": 24
  }, {
    "id": 2301,
    "affgeoid": "0500000US05149",
    "aland": 2408665998,
    "awater": 48861387,
    "countyfp": "149",
    "countyns": "00069908",
    "dotregion": 6,
    "geoid": "05149",
    "lsad": "06",
    "name": "Yell",
    "stateAbbreviation": "AR",
    "stateId": 24
  }]
}, {
  "id": 2,
  "abbreviation": "CA",
  "affgeoid": "0400000US06",
  "aland": 403488955894,
  "awater": 20477992907,
  "dotregion": 9,
  "geoid": "06",
  "lsad": "00",
  "name": "California",
  "stateAbbreviation": "CA",
  "statefp": "06",
  "statens": "01779778",
  "counties": [{
    "id": 776,
    "affgeoid": "0500000US06001",
    "aland": 1914240928,
    "awater": 212981785,
    "countyfp": "001",
    "countyns": "01675839",
    "dotregion": 9,
    "geoid": "06001",
    "lsad": "06",
    "name": "Alameda",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1603,
    "affgeoid": "0500000US06003",
    "aland": 1912243121,
    "awater": 12557304,
    "countyfp": "003",
    "countyns": "01675840",
    "dotregion": 9,
    "geoid": "06003",
    "lsad": "06",
    "name": "Alpine",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2490,
    "affgeoid": "0500000US06005",
    "aland": 1539947599,
    "awater": 29470568,
    "countyfp": "005",
    "countyns": "01675841",
    "dotregion": 9,
    "geoid": "06005",
    "lsad": "06",
    "name": "Amador",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 739,
    "affgeoid": "0500000US06007",
    "aland": 4238422715,
    "awater": 105325812,
    "countyfp": "007",
    "countyns": "01675842",
    "dotregion": 9,
    "geoid": "06007",
    "lsad": "06",
    "name": "Butte",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1851,
    "affgeoid": "0500000US06009",
    "aland": 2641819830,
    "awater": 43808937,
    "countyfp": "009",
    "countyns": "01675885",
    "dotregion": 9,
    "geoid": "06009",
    "lsad": "06",
    "name": "Calaveras",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2113,
    "affgeoid": "0500000US06011",
    "aland": 2980372943,
    "awater": 14581043,
    "countyfp": "011",
    "countyns": "01675902",
    "dotregion": 9,
    "geoid": "06011",
    "lsad": "06",
    "name": "Colusa",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2512,
    "affgeoid": "0500000US06013",
    "aland": 1871895181,
    "awater": 209854843,
    "countyfp": "013",
    "countyns": "01675903",
    "dotregion": 9,
    "geoid": "06013",
    "lsad": "06",
    "name": "Contra Costa",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1270,
    "affgeoid": "0500000US06015",
    "aland": 2606282680,
    "awater": 578761025,
    "countyfp": "015",
    "countyns": "01682074",
    "dotregion": 9,
    "geoid": "06015",
    "lsad": "06",
    "name": "Del Norte",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 3078,
    "affgeoid": "0500000US06017",
    "aland": 4423442340,
    "awater": 203356517,
    "countyfp": "017",
    "countyns": "00277273",
    "dotregion": 9,
    "geoid": "06017",
    "lsad": "06",
    "name": "El Dorado",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2888,
    "affgeoid": "0500000US06019",
    "aland": 15433278958,
    "awater": 135402551,
    "countyfp": "019",
    "countyns": "00277274",
    "dotregion": 9,
    "geoid": "06019",
    "lsad": "06",
    "name": "Fresno",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2946,
    "affgeoid": "0500000US06021",
    "aland": 3403106647,
    "awater": 33749275,
    "countyfp": "021",
    "countyns": "00277275",
    "dotregion": 9,
    "geoid": "06021",
    "lsad": "06",
    "name": "Glenn",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1181,
    "affgeoid": "0500000US06023",
    "aland": 9241007147,
    "awater": 1254299668,
    "countyfp": "023",
    "countyns": "01681908",
    "dotregion": 9,
    "geoid": "06023",
    "lsad": "06",
    "name": "Humboldt",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2176,
    "affgeoid": "0500000US06025",
    "aland": 10817378445,
    "awater": 790204917,
    "countyfp": "025",
    "countyns": "00277277",
    "dotregion": 9,
    "geoid": "06025",
    "lsad": "06",
    "name": "Imperial",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2570,
    "affgeoid": "0500000US06027",
    "aland": 26368485935,
    "awater": 119089390,
    "countyfp": "027",
    "countyns": "01804637",
    "dotregion": 9,
    "geoid": "06027",
    "lsad": "06",
    "name": "Inyo",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1566,
    "affgeoid": "0500000US06029",
    "aland": 21061723516,
    "awater": 79488735,
    "countyfp": "029",
    "countyns": "02054176",
    "dotregion": 9,
    "geoid": "06029",
    "lsad": "06",
    "name": "Kern",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1222,
    "affgeoid": "0500000US06031",
    "aland": 3598582456,
    "awater": 5468555,
    "countyfp": "031",
    "countyns": "00277280",
    "dotregion": 9,
    "geoid": "06031",
    "lsad": "06",
    "name": "Kings",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2178,
    "affgeoid": "0500000US06033",
    "aland": 3254288304,
    "awater": 188912510,
    "countyfp": "033",
    "countyns": "00277281",
    "dotregion": 9,
    "geoid": "06033",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2715,
    "affgeoid": "0500000US06035",
    "aland": 11761620852,
    "awater": 463438654,
    "countyfp": "035",
    "countyns": "01693324",
    "dotregion": 9,
    "geoid": "06035",
    "lsad": "06",
    "name": "Lassen",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2083,
    "affgeoid": "0500000US06037",
    "aland": 10510433235,
    "awater": 1794939537,
    "countyfp": "037",
    "countyns": "00277283",
    "dotregion": 9,
    "geoid": "06037",
    "lsad": "06",
    "name": "Los Angeles",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2258,
    "affgeoid": "0500000US06039",
    "aland": 5535058332,
    "awater": 41957139,
    "countyfp": "039",
    "countyns": "00277284",
    "dotregion": 9,
    "geoid": "06039",
    "lsad": "06",
    "name": "Madera",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2713,
    "affgeoid": "0500000US06041",
    "aland": 1348069363,
    "awater": 796944863,
    "countyfp": "041",
    "countyns": "00277285",
    "dotregion": 9,
    "geoid": "06041",
    "lsad": "06",
    "name": "Marin",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2733,
    "affgeoid": "0500000US06043",
    "aland": 3752425654,
    "awater": 36268135,
    "countyfp": "043",
    "countyns": "00277286",
    "dotregion": 9,
    "geoid": "06043",
    "lsad": "06",
    "name": "Mariposa",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2944,
    "affgeoid": "0500000US06045",
    "aland": 9081415725,
    "awater": 962953346,
    "countyfp": "045",
    "countyns": "00277287",
    "dotregion": 9,
    "geoid": "06045",
    "lsad": "06",
    "name": "Mendocino",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1819,
    "affgeoid": "0500000US06047",
    "aland": 5011540709,
    "awater": 112771056,
    "countyfp": "047",
    "countyns": "00277288",
    "dotregion": 9,
    "geoid": "06047",
    "lsad": "06",
    "name": "Merced",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 846,
    "affgeoid": "0500000US06049",
    "aland": 10140841282,
    "awater": 745929084,
    "countyfp": "049",
    "countyns": "00277289",
    "dotregion": 9,
    "geoid": "06049",
    "lsad": "06",
    "name": "Modoc",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1192,
    "affgeoid": "0500000US06051",
    "aland": 7896722400,
    "awater": 214695408,
    "countyfp": "051",
    "countyns": "00277290",
    "dotregion": 9,
    "geoid": "06051",
    "lsad": "06",
    "name": "Mono",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 692,
    "affgeoid": "0500000US06053",
    "aland": 8496731189,
    "awater": 1270747397,
    "countyfp": "053",
    "countyns": "00277291",
    "dotregion": 9,
    "geoid": "06053",
    "lsad": "06",
    "name": "Monterey",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 793,
    "affgeoid": "0500000US06055",
    "aland": 1938262912,
    "awater": 104154062,
    "countyfp": "055",
    "countyns": "00277292",
    "dotregion": 9,
    "geoid": "06055",
    "lsad": "06",
    "name": "Napa",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1220,
    "affgeoid": "0500000US06057",
    "aland": 2480638607,
    "awater": 41513172,
    "countyfp": "057",
    "countyns": "01682927",
    "dotregion": 9,
    "geoid": "06057",
    "lsad": "06",
    "name": "Nevada",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 722,
    "affgeoid": "0500000US06059",
    "aland": 2048156380,
    "awater": 407152512,
    "countyfp": "059",
    "countyns": "00277294",
    "dotregion": 9,
    "geoid": "06059",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2660,
    "affgeoid": "0500000US06061",
    "aland": 3644332280,
    "awater": 246390570,
    "countyfp": "061",
    "countyns": "00277295",
    "dotregion": 9,
    "geoid": "06061",
    "lsad": "06",
    "name": "Placer",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 548,
    "affgeoid": "0500000US06063",
    "aland": 6612371702,
    "awater": 156389436,
    "countyfp": "063",
    "countyns": "00277296",
    "dotregion": 9,
    "geoid": "06063",
    "lsad": "06",
    "name": "Plumas",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1962,
    "affgeoid": "0500000US06065",
    "aland": 18664463540,
    "awater": 250908223,
    "countyfp": "065",
    "countyns": "00277297",
    "dotregion": 9,
    "geoid": "06065",
    "lsad": "06",
    "name": "Riverside",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 791,
    "affgeoid": "0500000US06067",
    "aland": 2499183604,
    "awater": 76073827,
    "countyfp": "067",
    "countyns": "00277298",
    "dotregion": 9,
    "geoid": "06067",
    "lsad": "06",
    "name": "Sacramento",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 3123,
    "affgeoid": "0500000US06069",
    "aland": 3596741869,
    "awater": 4555000,
    "countyfp": "069",
    "countyns": "00277299",
    "dotregion": 9,
    "geoid": "06069",
    "lsad": "06",
    "name": "San Benito",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2104,
    "affgeoid": "0500000US06071",
    "aland": 51947553553,
    "awater": 123844759,
    "countyfp": "071",
    "countyns": "00277300",
    "dotregion": 9,
    "geoid": "06071",
    "lsad": "06",
    "name": "San Bernardino",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2974,
    "affgeoid": "0500000US06073",
    "aland": 10895227071,
    "awater": 826282961,
    "countyfp": "073",
    "countyns": "00277301",
    "dotregion": 9,
    "geoid": "06073",
    "lsad": "06",
    "name": "San Diego",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 363,
    "affgeoid": "0500000US06075",
    "aland": 121455687,
    "awater": 479135404,
    "countyfp": "075",
    "countyns": "00277302",
    "dotregion": 9,
    "geoid": "06075",
    "lsad": "06",
    "name": "San Francisco",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1859,
    "affgeoid": "0500000US06077",
    "aland": 3603647025,
    "awater": 91127543,
    "countyfp": "077",
    "countyns": "00277303",
    "dotregion": 9,
    "geoid": "06077",
    "lsad": "06",
    "name": "San Joaquin",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2042,
    "affgeoid": "0500000US06079",
    "aland": 8548549787,
    "awater": 815580311,
    "countyfp": "079",
    "countyns": "00277304",
    "dotregion": 9,
    "geoid": "06079",
    "lsad": "06",
    "name": "San Luis Obispo",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2051,
    "affgeoid": "0500000US06081",
    "aland": 1161542720,
    "awater": 757525243,
    "countyfp": "081",
    "countyns": "00277305",
    "dotregion": 9,
    "geoid": "06081",
    "lsad": "06",
    "name": "San Mateo",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1961,
    "affgeoid": "0500000US06083",
    "aland": 7083927512,
    "awater": 2729816973,
    "countyfp": "083",
    "countyns": "00277306",
    "dotregion": 9,
    "geoid": "06083",
    "lsad": "06",
    "name": "Santa Barbara",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2455,
    "affgeoid": "0500000US06085",
    "aland": 3341645574,
    "awater": 35831344,
    "countyfp": "085",
    "countyns": "00277307",
    "dotregion": 9,
    "geoid": "06085",
    "lsad": "06",
    "name": "Santa Clara",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 923,
    "affgeoid": "0500000US06087",
    "aland": 1152967332,
    "awater": 419570851,
    "countyfp": "087",
    "countyns": "00277308",
    "dotregion": 9,
    "geoid": "06087",
    "lsad": "06",
    "name": "Santa Cruz",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1956,
    "affgeoid": "0500000US06089",
    "aland": 9778188572,
    "awater": 186530168,
    "countyfp": "089",
    "countyns": "01682610",
    "dotregion": 9,
    "geoid": "06089",
    "lsad": "06",
    "name": "Shasta",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 925,
    "affgeoid": "0500000US06091",
    "aland": 2468686374,
    "awater": 23299110,
    "countyfp": "091",
    "countyns": "00277310",
    "dotregion": 9,
    "geoid": "06091",
    "lsad": "06",
    "name": "Sierra",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2979,
    "affgeoid": "0500000US06093",
    "aland": 16259635638,
    "awater": 179864756,
    "countyfp": "093",
    "countyns": "00277311",
    "dotregion": 9,
    "geoid": "06093",
    "lsad": "06",
    "name": "Siskiyou",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1975,
    "affgeoid": "0500000US06095",
    "aland": 2128379537,
    "awater": 218647641,
    "countyfp": "095",
    "countyns": "00277312",
    "dotregion": 9,
    "geoid": "06095",
    "lsad": "06",
    "name": "Solano",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1266,
    "affgeoid": "0500000US06097",
    "aland": 4081401191,
    "awater": 497545934,
    "countyfp": "097",
    "countyns": "01657246",
    "dotregion": 9,
    "geoid": "06097",
    "lsad": "06",
    "name": "Sonoma",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1874,
    "affgeoid": "0500000US06099",
    "aland": 3870867629,
    "awater": 51101821,
    "countyfp": "099",
    "countyns": "00277314",
    "dotregion": 9,
    "geoid": "06099",
    "lsad": "06",
    "name": "Stanislaus",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1936,
    "affgeoid": "0500000US06101",
    "aland": 1560236924,
    "awater": 15745939,
    "countyfp": "101",
    "countyns": "00277315",
    "dotregion": 9,
    "geoid": "06101",
    "lsad": "06",
    "name": "Sutter",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1191,
    "affgeoid": "0500000US06103",
    "aland": 7639716445,
    "awater": 32276063,
    "countyfp": "103",
    "countyns": "01692767",
    "dotregion": 9,
    "geoid": "06103",
    "lsad": "06",
    "name": "Tehama",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 3182,
    "affgeoid": "0500000US06105",
    "aland": 8234308182,
    "awater": 73407949,
    "countyfp": "105",
    "countyns": "00277317",
    "dotregion": 9,
    "geoid": "06105",
    "lsad": "06",
    "name": "Trinity",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 2453,
    "affgeoid": "0500000US06107",
    "aland": 12494776875,
    "awater": 37391591,
    "countyfp": "107",
    "countyns": "00277318",
    "dotregion": 9,
    "geoid": "06107",
    "lsad": "06",
    "name": "Tulare",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1721,
    "affgeoid": "0500000US06109",
    "aland": 5752116004,
    "awater": 138684372,
    "countyfp": "109",
    "countyns": "00277319",
    "dotregion": 9,
    "geoid": "06109",
    "lsad": "06",
    "name": "Tuolumne",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 1940,
    "affgeoid": "0500000US06111",
    "aland": 4773381391,
    "awater": 945947791,
    "countyfp": "111",
    "countyns": "00277320",
    "dotregion": 9,
    "geoid": "06111",
    "lsad": "06",
    "name": "Ventura",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 3011,
    "affgeoid": "0500000US06113",
    "aland": 2628233324,
    "awater": 22752821,
    "countyfp": "113",
    "countyns": "00277321",
    "dotregion": 9,
    "geoid": "06113",
    "lsad": "06",
    "name": "Yolo",
    "stateAbbreviation": "CA",
    "stateId": 2
  }, {
    "id": 23,
    "affgeoid": "0500000US06115",
    "aland": 1636983167,
    "awater": 30986706,
    "countyfp": "115",
    "countyns": "00277322",
    "dotregion": 9,
    "geoid": "06115",
    "lsad": "06",
    "name": "Yuba",
    "stateAbbreviation": "CA",
    "stateId": 2
  }]
}, {
  "id": 26,
  "abbreviation": "CO",
  "affgeoid": "0400000US08",
  "aland": 268428431772,
  "awater": 1175462574,
  "dotregion": 8,
  "geoid": "08",
  "lsad": "00",
  "name": "Colorado",
  "stateAbbreviation": "CO",
  "statefp": "08",
  "statens": "01779779",
  "counties": [{
    "id": 2583,
    "affgeoid": "0500000US08001",
    "aland": 3023271310,
    "awater": 41765940,
    "countyfp": "001",
    "countyns": "00198116",
    "dotregion": 8,
    "geoid": "08001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 425,
    "affgeoid": "0500000US08003",
    "aland": 1871620060,
    "awater": 1847609,
    "countyfp": "003",
    "countyns": "00198117",
    "dotregion": 8,
    "geoid": "08003",
    "lsad": "06",
    "name": "Alamosa",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2389,
    "affgeoid": "0500000US08005",
    "aland": 2066625076,
    "awater": 19498045,
    "countyfp": "005",
    "countyns": "00198118",
    "dotregion": 8,
    "geoid": "08005",
    "lsad": "06",
    "name": "Arapahoe",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2634,
    "affgeoid": "0500000US08007",
    "aland": 3496919043,
    "awater": 13827548,
    "countyfp": "007",
    "countyns": "00198119",
    "dotregion": 8,
    "geoid": "08007",
    "lsad": "06",
    "name": "Archuleta",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1102,
    "affgeoid": "0500000US08009",
    "aland": 6617316188,
    "awater": 6142193,
    "countyfp": "009",
    "countyns": "00198120",
    "dotregion": 8,
    "geoid": "08009",
    "lsad": "06",
    "name": "Baca",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2382,
    "affgeoid": "0500000US08011",
    "aland": 3918305859,
    "awater": 73093279,
    "countyfp": "011",
    "countyns": "00198121",
    "dotregion": 8,
    "geoid": "08011",
    "lsad": "06",
    "name": "Bent",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1305,
    "affgeoid": "0500000US08013",
    "aland": 1881212055,
    "awater": 36592000,
    "countyfp": "013",
    "countyns": "00198122",
    "dotregion": 8,
    "geoid": "08013",
    "lsad": "06",
    "name": "Boulder",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1303,
    "affgeoid": "0500000US08014",
    "aland": 85478497,
    "awater": 1411781,
    "countyfp": "014",
    "countyns": "01945881",
    "dotregion": 8,
    "geoid": "08014",
    "lsad": "06",
    "name": "Broomfield",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3032,
    "affgeoid": "0500000US08015",
    "aland": 2624707749,
    "awater": 4008555,
    "countyfp": "015",
    "countyns": "00198123",
    "dotregion": 8,
    "geoid": "08015",
    "lsad": "06",
    "name": "Chaffee",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1127,
    "affgeoid": "0500000US08017",
    "aland": 4605714129,
    "awater": 8166134,
    "countyfp": "017",
    "countyns": "00198124",
    "dotregion": 8,
    "geoid": "08017",
    "lsad": "06",
    "name": "Cheyenne",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2868,
    "affgeoid": "0500000US08019",
    "aland": 1023554877,
    "awater": 3279667,
    "countyfp": "019",
    "countyns": "00198125",
    "dotregion": 8,
    "geoid": "08019",
    "lsad": "06",
    "name": "Clear Creek",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 297,
    "affgeoid": "0500000US08021",
    "aland": 3334118523,
    "awater": 9235291,
    "countyfp": "021",
    "countyns": "00198126",
    "dotregion": 8,
    "geoid": "08021",
    "lsad": "06",
    "name": "Conejos",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1833,
    "affgeoid": "0500000US08023",
    "aland": 3177806137,
    "awater": 8828906,
    "countyfp": "023",
    "countyns": "00198127",
    "dotregion": 8,
    "geoid": "08023",
    "lsad": "06",
    "name": "Costilla",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1328,
    "affgeoid": "0500000US08025",
    "aland": 2039409698,
    "awater": 33430385,
    "countyfp": "025",
    "countyns": "00198128",
    "dotregion": 8,
    "geoid": "08025",
    "lsad": "06",
    "name": "Crowley",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2383,
    "affgeoid": "0500000US08027",
    "aland": 1913033446,
    "awater": 3364761,
    "countyfp": "027",
    "countyns": "00198129",
    "dotregion": 8,
    "geoid": "08027",
    "lsad": "06",
    "name": "Custer",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1989,
    "affgeoid": "0500000US08029",
    "aland": 2958007403,
    "awater": 16886462,
    "countyfp": "029",
    "countyns": "00198130",
    "dotregion": 8,
    "geoid": "08029",
    "lsad": "06",
    "name": "Delta",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3034,
    "affgeoid": "0500000US08031",
    "aland": 397136421,
    "awater": 4225831,
    "countyfp": "031",
    "countyns": "00198131",
    "dotregion": 8,
    "geoid": "08031",
    "lsad": "06",
    "name": "Denver",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 914,
    "affgeoid": "0500000US08033",
    "aland": 2763872222,
    "awater": 2716141,
    "countyfp": "033",
    "countyns": "00198132",
    "dotregion": 8,
    "geoid": "08033",
    "lsad": "06",
    "name": "Dolores",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 567,
    "affgeoid": "0500000US08035",
    "aland": 2176213467,
    "awater": 6752511,
    "countyfp": "035",
    "countyns": "00198133",
    "dotregion": 8,
    "geoid": "08035",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 808,
    "affgeoid": "0500000US08037",
    "aland": 4362874440,
    "awater": 18843976,
    "countyfp": "037",
    "countyns": "00198134",
    "dotregion": 8,
    "geoid": "08037",
    "lsad": "06",
    "name": "Eagle",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 772,
    "affgeoid": "0500000US08041",
    "aland": 5508553622,
    "awater": 7108817,
    "countyfp": "041",
    "countyns": "00198135",
    "dotregion": 8,
    "geoid": "08041",
    "lsad": "06",
    "name": "El Paso",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2319,
    "affgeoid": "0500000US08039",
    "aland": 4793695462,
    "awater": 442148,
    "countyfp": "039",
    "countyns": "00198136",
    "dotregion": 8,
    "geoid": "08039",
    "lsad": "06",
    "name": "Elbert",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2609,
    "affgeoid": "0500000US08043",
    "aland": 3970640129,
    "awater": 2235368,
    "countyfp": "043",
    "countyns": "00198137",
    "dotregion": 8,
    "geoid": "08043",
    "lsad": "06",
    "name": "Fremont",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3186,
    "affgeoid": "0500000US08045",
    "aland": 7634486761,
    "awater": 21422730,
    "countyfp": "045",
    "countyns": "00198138",
    "dotregion": 8,
    "geoid": "08045",
    "lsad": "06",
    "name": "Garfield",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1331,
    "affgeoid": "0500000US08047",
    "aland": 388228973,
    "awater": 942056,
    "countyfp": "047",
    "countyns": "00198139",
    "dotregion": 8,
    "geoid": "08047",
    "lsad": "06",
    "name": "Gilpin",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1372,
    "affgeoid": "0500000US08049",
    "aland": 4782244665,
    "awater": 59902382,
    "countyfp": "049",
    "countyns": "00198140",
    "dotregion": 8,
    "geoid": "08049",
    "lsad": "06",
    "name": "Grand",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2657,
    "affgeoid": "0500000US08051",
    "aland": 8389606575,
    "awater": 53067068,
    "countyfp": "051",
    "countyns": "00198141",
    "dotregion": 8,
    "geoid": "08051",
    "lsad": "06",
    "name": "Gunnison",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2377,
    "affgeoid": "0500000US08053",
    "aland": 2893561630,
    "awater": 15324686,
    "countyfp": "053",
    "countyns": "00198142",
    "dotregion": 8,
    "geoid": "08053",
    "lsad": "06",
    "name": "Hinsdale",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3112,
    "affgeoid": "0500000US08055",
    "aland": 4120807998,
    "awater": 5792101,
    "countyfp": "055",
    "countyns": "00198143",
    "dotregion": 8,
    "geoid": "08055",
    "lsad": "06",
    "name": "Huerfano",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 928,
    "affgeoid": "0500000US08057",
    "aland": 4179536193,
    "awater": 18750017,
    "countyfp": "057",
    "countyns": "00198144",
    "dotregion": 8,
    "geoid": "08057",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3018,
    "affgeoid": "0500000US08059",
    "aland": 1979311263,
    "awater": 25444831,
    "countyfp": "059",
    "countyns": "00198145",
    "dotregion": 8,
    "geoid": "08059",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1333,
    "affgeoid": "0500000US08061",
    "aland": 4578597112,
    "awater": 47032919,
    "countyfp": "061",
    "countyns": "00198146",
    "dotregion": 8,
    "geoid": "08061",
    "lsad": "06",
    "name": "Kiowa",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 242,
    "affgeoid": "0500000US08063",
    "aland": 5596501602,
    "awater": 2251930,
    "countyfp": "063",
    "countyns": "00198147",
    "dotregion": 8,
    "geoid": "08063",
    "lsad": "06",
    "name": "Kit Carson",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2135,
    "affgeoid": "0500000US08067",
    "aland": 4376816404,
    "awater": 25396402,
    "countyfp": "067",
    "countyns": "00198148",
    "dotregion": 8,
    "geoid": "08067",
    "lsad": "06",
    "name": "La Plata",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2610,
    "affgeoid": "0500000US08065",
    "aland": 976206802,
    "awater": 18111565,
    "countyfp": "065",
    "countyns": "00198149",
    "dotregion": 8,
    "geoid": "08065",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 960,
    "affgeoid": "0500000US08069",
    "aland": 6723986975,
    "awater": 98048035,
    "countyfp": "069",
    "countyns": "00198150",
    "dotregion": 8,
    "geoid": "08069",
    "lsad": "06",
    "name": "Larimer",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1334,
    "affgeoid": "0500000US08071",
    "aland": 12361209113,
    "awater": 6929970,
    "countyfp": "071",
    "countyns": "00198151",
    "dotregion": 8,
    "geoid": "08071",
    "lsad": "06",
    "name": "Las Animas",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3113,
    "affgeoid": "0500000US08073",
    "aland": 6676208039,
    "awater": 22780366,
    "countyfp": "073",
    "countyns": "00198152",
    "dotregion": 8,
    "geoid": "08073",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2098,
    "affgeoid": "0500000US08075",
    "aland": 4761983526,
    "awater": 16363553,
    "countyfp": "075",
    "countyns": "00198153",
    "dotregion": 8,
    "geoid": "08075",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2039,
    "affgeoid": "0500000US08077",
    "aland": 8621965147,
    "awater": 31428362,
    "countyfp": "077",
    "countyns": "00198154",
    "dotregion": 8,
    "geoid": "08077",
    "lsad": "06",
    "name": "Mesa",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 926,
    "affgeoid": "0500000US08079",
    "aland": 2268152612,
    "awater": 5222161,
    "countyfp": "079",
    "countyns": "00198155",
    "dotregion": 8,
    "geoid": "08079",
    "lsad": "06",
    "name": "Mineral",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 621,
    "affgeoid": "0500000US08081",
    "aland": 12284800386,
    "awater": 19803413,
    "countyfp": "081",
    "countyns": "00198156",
    "dotregion": 8,
    "geoid": "08081",
    "lsad": "06",
    "name": "Moffat",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2479,
    "affgeoid": "0500000US08083",
    "aland": 5255909595,
    "awater": 27403242,
    "countyfp": "083",
    "countyns": "00198157",
    "dotregion": 8,
    "geoid": "08083",
    "lsad": "06",
    "name": "Montezuma",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1027,
    "affgeoid": "0500000US08085",
    "aland": 5804077510,
    "awater": 4923261,
    "countyfp": "085",
    "countyns": "00198158",
    "dotregion": 8,
    "geoid": "08085",
    "lsad": "06",
    "name": "Montrose",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 499,
    "affgeoid": "0500000US08087",
    "aland": 3316439900,
    "awater": 34663099,
    "countyfp": "087",
    "countyns": "00198159",
    "dotregion": 8,
    "geoid": "08087",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 15,
    "affgeoid": "0500000US08089",
    "aland": 3268485050,
    "awater": 20052339,
    "countyfp": "089",
    "countyns": "00198160",
    "dotregion": 8,
    "geoid": "08089",
    "lsad": "06",
    "name": "Otero",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 129,
    "affgeoid": "0500000US08091",
    "aland": 1402657135,
    "awater": 1599543,
    "countyfp": "091",
    "countyns": "00198161",
    "dotregion": 8,
    "geoid": "08091",
    "lsad": "06",
    "name": "Ouray",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3010,
    "affgeoid": "0500000US08093",
    "aland": 5682126654,
    "awater": 43530449,
    "countyfp": "093",
    "countyns": "00198162",
    "dotregion": 8,
    "geoid": "08093",
    "lsad": "06",
    "name": "Park",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 247,
    "affgeoid": "0500000US08095",
    "aland": 1781724991,
    "awater": 301808,
    "countyfp": "095",
    "countyns": "00198163",
    "dotregion": 8,
    "geoid": "08095",
    "lsad": "06",
    "name": "Phillips",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3049,
    "affgeoid": "0500000US08097",
    "aland": 2514046292,
    "awater": 6472574,
    "countyfp": "097",
    "countyns": "00198164",
    "dotregion": 8,
    "geoid": "08097",
    "lsad": "06",
    "name": "Pitkin",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 994,
    "affgeoid": "0500000US08099",
    "aland": 4243420040,
    "awater": 15352639,
    "countyfp": "099",
    "countyns": "00198165",
    "dotregion": 8,
    "geoid": "08099",
    "lsad": "06",
    "name": "Prowers",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 335,
    "affgeoid": "0500000US08101",
    "aland": 6179911297,
    "awater": 30284241,
    "countyfp": "101",
    "countyns": "00198166",
    "dotregion": 8,
    "geoid": "08101",
    "lsad": "06",
    "name": "Pueblo",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2114,
    "affgeoid": "0500000US08103",
    "aland": 8342320873,
    "awater": 4868111,
    "countyfp": "103",
    "countyns": "00198167",
    "dotregion": 8,
    "geoid": "08103",
    "lsad": "06",
    "name": "Rio Blanco",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2559,
    "affgeoid": "0500000US08105",
    "aland": 2361939881,
    "awater": 984917,
    "countyfp": "105",
    "countyns": "00198168",
    "dotregion": 8,
    "geoid": "08105",
    "lsad": "06",
    "name": "Rio Grande",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1969,
    "affgeoid": "0500000US08107",
    "aland": 6117617719,
    "awater": 15831744,
    "countyfp": "107",
    "countyns": "00198169",
    "dotregion": 8,
    "geoid": "08107",
    "lsad": "06",
    "name": "Routt",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 337,
    "affgeoid": "0500000US08109",
    "aland": 8207137045,
    "awater": 4454510,
    "countyfp": "109",
    "countyns": "00198170",
    "dotregion": 8,
    "geoid": "08109",
    "lsad": "06",
    "name": "Saguache",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1023,
    "affgeoid": "0500000US08111",
    "aland": 1003638261,
    "awater": 2035929,
    "countyfp": "111",
    "countyns": "00198171",
    "dotregion": 8,
    "geoid": "08111",
    "lsad": "06",
    "name": "San Juan",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1726,
    "affgeoid": "0500000US08113",
    "aland": 3332711756,
    "awater": 5204095,
    "countyfp": "113",
    "countyns": "00198172",
    "dotregion": 8,
    "geoid": "08113",
    "lsad": "06",
    "name": "San Miguel",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 250,
    "affgeoid": "0500000US08115",
    "aland": 1419419282,
    "awater": 3530746,
    "countyfp": "115",
    "countyns": "00198173",
    "dotregion": 8,
    "geoid": "08115",
    "lsad": "06",
    "name": "Sedgwick",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 3152,
    "affgeoid": "0500000US08117",
    "aland": 1575579877,
    "awater": 28287709,
    "countyfp": "117",
    "countyns": "00198174",
    "dotregion": 8,
    "geoid": "08117",
    "lsad": "06",
    "name": "Summit",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1645,
    "affgeoid": "0500000US08119",
    "aland": 1442748659,
    "awater": 4944578,
    "countyfp": "119",
    "countyns": "00198175",
    "dotregion": 8,
    "geoid": "08119",
    "lsad": "06",
    "name": "Teller",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 518,
    "affgeoid": "0500000US08121",
    "aland": 6521814069,
    "awater": 15207400,
    "countyfp": "121",
    "countyns": "00198176",
    "dotregion": 8,
    "geoid": "08121",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 2507,
    "affgeoid": "0500000US08123",
    "aland": 10326656276,
    "awater": 76677079,
    "countyfp": "123",
    "countyns": "00198177",
    "dotregion": 8,
    "geoid": "08123",
    "lsad": "06",
    "name": "Weld",
    "stateAbbreviation": "CO",
    "stateId": 26
  }, {
    "id": 1694,
    "affgeoid": "0500000US08125",
    "aland": 6123752021,
    "awater": 11134666,
    "countyfp": "125",
    "countyns": "00198178",
    "dotregion": 8,
    "geoid": "08125",
    "lsad": "06",
    "name": "Yuma",
    "stateAbbreviation": "CO",
    "stateId": 26
  }]
}, {
  "id": 53,
  "abbreviation": "MP",
  "dotregion": 9,
  "geoid": "69",
  "name": "Commonwealth of the Northern Mariana Islands",
  "stateAbbreviation": "MP",
  "statefp": "69",
  "counties": [{
    "id": 3230,
    "countyfp": "085",
    "countyns": "01805245",
    "dotregion": 9,
    "geoid": "69085",
    "name": "Northern Islands",
    "stateAbbreviation": "MP",
    "stateId": 53
  }, {
    "id": 3223,
    "countyfp": "100",
    "countyns": "01805246",
    "dotregion": 9,
    "geoid": "69100",
    "name": "Rota",
    "stateAbbreviation": "MP",
    "stateId": 53
  }, {
    "id": 3231,
    "countyfp": "110",
    "countyns": "01805247",
    "dotregion": 9,
    "geoid": "69110",
    "name": "Saipan",
    "stateAbbreviation": "MP",
    "stateId": 53
  }, {
    "id": 3225,
    "countyfp": "120",
    "countyns": "01805248",
    "dotregion": 9,
    "geoid": "69120",
    "name": "Tinian",
    "stateAbbreviation": "MP",
    "stateId": 53
  }]
}, {
  "id": 35,
  "abbreviation": "CT",
  "affgeoid": "0400000US09",
  "aland": 12542452026,
  "awater": 1814924099,
  "dotregion": 1,
  "geoid": "09",
  "lsad": "00",
  "name": "Connecticut",
  "stateAbbreviation": "CT",
  "statefp": "09",
  "statens": "01779780",
  "counties": [{
    "id": 3167,
    "affgeoid": "0500000US09001",
    "aland": 1618664455,
    "awater": 548955210,
    "countyfp": "001",
    "countyns": "00212794",
    "dotregion": 1,
    "geoid": "09001",
    "lsad": "06",
    "name": "Fairfield",
    "stateAbbreviation": "CT",
    "stateId": 35
  }, {
    "id": 2645,
    "affgeoid": "0500000US09003",
    "aland": 1903947639,
    "awater": 40133958,
    "countyfp": "003",
    "countyns": "00212338",
    "dotregion": 1,
    "geoid": "09003",
    "lsad": "06",
    "name": "Hartford",
    "stateAbbreviation": "CT",
    "stateId": 35
  }, {
    "id": 2282,
    "affgeoid": "0500000US09005",
    "aland": 2384262297,
    "awater": 62138320,
    "countyfp": "005",
    "countyns": "00212796",
    "dotregion": 1,
    "geoid": "09005",
    "lsad": "06",
    "name": "Litchfield",
    "stateAbbreviation": "CT",
    "stateId": 35
  }, {
    "id": 2215,
    "affgeoid": "0500000US09007",
    "aland": 956491412,
    "awater": 180679144,
    "countyfp": "007",
    "countyns": "00212797",
    "dotregion": 1,
    "geoid": "09007",
    "lsad": "06",
    "name": "Middlesex",
    "stateAbbreviation": "CT",
    "stateId": 35
  }, {
    "id": 2310,
    "affgeoid": "0500000US09009",
    "aland": 1565645638,
    "awater": 667096946,
    "countyfp": "009",
    "countyns": "00212798",
    "dotregion": 1,
    "geoid": "09009",
    "lsad": "06",
    "name": "New Haven",
    "stateAbbreviation": "CT",
    "stateId": 35
  }, {
    "id": 2036,
    "affgeoid": "0500000US09011",
    "aland": 1722641876,
    "awater": 276619712,
    "countyfp": "011",
    "countyns": "00212799",
    "dotregion": 1,
    "geoid": "09011",
    "lsad": "06",
    "name": "New London",
    "stateAbbreviation": "CT",
    "stateId": 35
  }, {
    "id": 2940,
    "affgeoid": "0500000US09013",
    "aland": 1062613133,
    "awater": 17533745,
    "countyfp": "013",
    "countyns": "00212668",
    "dotregion": 1,
    "geoid": "09013",
    "lsad": "06",
    "name": "Tolland",
    "stateAbbreviation": "CT",
    "stateId": 35
  }, {
    "id": 2754,
    "affgeoid": "0500000US09015",
    "aland": 1328185576,
    "awater": 21767064,
    "countyfp": "015",
    "countyns": "00212801",
    "dotregion": 1,
    "geoid": "09015",
    "lsad": "06",
    "name": "Windham",
    "stateAbbreviation": "CT",
    "stateId": 35
  }]
}, {
  "id": 46,
  "abbreviation": "DE",
  "affgeoid": "0400000US10",
  "aland": 5047105127,
  "awater": 1398742998,
  "dotregion": 3,
  "geoid": "10",
  "lsad": "00",
  "name": "Delaware",
  "stateAbbreviation": "DE",
  "statefp": "10",
  "statens": "01779781",
  "counties": [{
    "id": 3177,
    "affgeoid": "0500000US10001",
    "aland": 1518565081,
    "awater": 549102079,
    "countyfp": "001",
    "countyns": "00217271",
    "dotregion": 3,
    "geoid": "10001",
    "lsad": "06",
    "name": "Kent",
    "stateAbbreviation": "DE",
    "stateId": 46
  }, {
    "id": 3037,
    "affgeoid": "0500000US10003",
    "aland": 1104074671,
    "awater": 175385786,
    "countyfp": "003",
    "countyns": "00217270",
    "dotregion": 3,
    "geoid": "10003",
    "lsad": "06",
    "name": "New Castle",
    "stateAbbreviation": "DE",
    "stateId": 46
  }, {
    "id": 2271,
    "affgeoid": "0500000US10005",
    "aland": 2424465375,
    "awater": 674255133,
    "countyfp": "005",
    "countyns": "00217269",
    "dotregion": 3,
    "geoid": "10005",
    "lsad": "06",
    "name": "Sussex",
    "stateAbbreviation": "DE",
    "stateId": 46
  }]
}, {
  "id": 36,
  "abbreviation": "DC",
  "affgeoid": "0400000US11",
  "aland": 158364990,
  "awater": 18633403,
  "dotregion": 3,
  "geoid": "11",
  "lsad": "00",
  "name": "District of Columbia",
  "stateAbbreviation": "DC",
  "statefp": "11",
  "statens": "01702382",
  "counties": [{
    "id": 136,
    "affgeoid": "0500000US11001",
    "aland": 158364990,
    "awater": 18633403,
    "countyfp": "001",
    "countyns": "01702382",
    "dotregion": 3,
    "geoid": "11001",
    "lsad": "00",
    "name": "District of Columbia",
    "stateAbbreviation": "DC",
    "stateId": 36
  }]
}, {
  "id": 13,
  "abbreviation": "FL",
  "affgeoid": "0400000US12",
  "aland": 138904831800,
  "awater": 31406193924,
  "dotregion": 4,
  "geoid": "12",
  "lsad": "00",
  "name": "Florida",
  "stateAbbreviation": "FL",
  "statefp": "12",
  "statens": "00294478",
  "counties": [{
    "id": 1997,
    "affgeoid": "0500000US12001",
    "aland": 2266378728,
    "awater": 242823265,
    "countyfp": "001",
    "countyns": "00308548",
    "dotregion": 4,
    "geoid": "12001",
    "lsad": "06",
    "name": "Alachua",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2950,
    "affgeoid": "0500000US12003",
    "aland": 1515740957,
    "awater": 9686120,
    "countyfp": "003",
    "countyns": "00306920",
    "dotregion": 4,
    "geoid": "12003",
    "lsad": "06",
    "name": "Baker",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2587,
    "affgeoid": "0500000US12005",
    "aland": 1964402061,
    "awater": 711451659,
    "countyfp": "005",
    "countyns": "00295738",
    "dotregion": 4,
    "geoid": "12005",
    "lsad": "06",
    "name": "Bay",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1077,
    "affgeoid": "0500000US12007",
    "aland": 761365424,
    "awater": 16904945,
    "countyfp": "007",
    "countyns": "00303634",
    "dotregion": 4,
    "geoid": "12007",
    "lsad": "06",
    "name": "Bradford",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1280,
    "affgeoid": "0500000US12009",
    "aland": 2629960540,
    "awater": 1402786334,
    "countyfp": "009",
    "countyns": "00295749",
    "dotregion": 4,
    "geoid": "12009",
    "lsad": "06",
    "name": "Brevard",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1517,
    "affgeoid": "0500000US12011",
    "aland": 3126184877,
    "awater": 300028343,
    "countyfp": "011",
    "countyns": "00295753",
    "dotregion": 4,
    "geoid": "12011",
    "lsad": "06",
    "name": "Broward",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1609,
    "affgeoid": "0500000US12013",
    "aland": 1469389206,
    "awater": 18074798,
    "countyfp": "013",
    "countyns": "00306919",
    "dotregion": 4,
    "geoid": "12013",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 913,
    "affgeoid": "0500000US12015",
    "aland": 1764034033,
    "awater": 458806771,
    "countyfp": "015",
    "countyns": "00295742",
    "dotregion": 4,
    "geoid": "12015",
    "lsad": "06",
    "name": "Charlotte",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2299,
    "affgeoid": "0500000US12017",
    "aland": 1507100924,
    "awater": 495589452,
    "countyfp": "017",
    "countyns": "00295752",
    "dotregion": 4,
    "geoid": "12017",
    "lsad": "06",
    "name": "Citrus",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 794,
    "affgeoid": "0500000US12019",
    "aland": 1566445254,
    "awater": 100334057,
    "countyfp": "019",
    "countyns": "00295726",
    "dotregion": 4,
    "geoid": "12019",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1653,
    "affgeoid": "0500000US12021",
    "aland": 5176959832,
    "awater": 792901545,
    "countyfp": "021",
    "countyns": "00295754",
    "dotregion": 4,
    "geoid": "12021",
    "lsad": "06",
    "name": "Collier",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1098,
    "affgeoid": "0500000US12023",
    "aland": 2065626671,
    "awater": 9773963,
    "countyfp": "023",
    "countyns": "00306909",
    "dotregion": 4,
    "geoid": "12023",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1815,
    "affgeoid": "0500000US12027",
    "aland": 1649970328,
    "awater": 6247257,
    "countyfp": "027",
    "countyns": "00294452",
    "dotregion": 4,
    "geoid": "12027",
    "lsad": "06",
    "name": "DeSoto",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2078,
    "affgeoid": "0500000US12029",
    "aland": 1826212267,
    "awater": 410631158,
    "countyfp": "029",
    "countyns": "00295725",
    "dotregion": 4,
    "geoid": "12029",
    "lsad": "06",
    "name": "Dixie",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 73,
    "affgeoid": "0500000US12031",
    "aland": 1975212116,
    "awater": 403585670,
    "countyfp": "031",
    "countyns": "00293656",
    "dotregion": 4,
    "geoid": "12031",
    "lsad": "06",
    "name": "Duval",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2503,
    "affgeoid": "0500000US12033",
    "aland": 1701332835,
    "awater": 564141200,
    "countyfp": "033",
    "countyns": "00295737",
    "dotregion": 4,
    "geoid": "12033",
    "lsad": "06",
    "name": "Escambia",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1040,
    "affgeoid": "0500000US12035",
    "aland": 1257381103,
    "awater": 221047161,
    "countyfp": "035",
    "countyns": "00308547",
    "dotregion": 4,
    "geoid": "12035",
    "lsad": "06",
    "name": "Flagler",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3204,
    "affgeoid": "0500000US12037",
    "aland": 1411918810,
    "awater": 1275526881,
    "countyfp": "037",
    "countyns": "00306911",
    "dotregion": 4,
    "geoid": "12037",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1767,
    "affgeoid": "0500000US12039",
    "aland": 1337193226,
    "awater": 31687293,
    "countyfp": "039",
    "countyns": "00306918",
    "dotregion": 4,
    "geoid": "12039",
    "lsad": "06",
    "name": "Gadsden",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1262,
    "affgeoid": "0500000US12041",
    "aland": 905705522,
    "awater": 14362154,
    "countyfp": "041",
    "countyns": "00303633",
    "dotregion": 4,
    "geoid": "12041",
    "lsad": "06",
    "name": "Gilchrist",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2781,
    "affgeoid": "0500000US12043",
    "aland": 2087857862,
    "awater": 468345881,
    "countyfp": "043",
    "countyns": "00295743",
    "dotregion": 4,
    "geoid": "12043",
    "lsad": "06",
    "name": "Glades",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 285,
    "affgeoid": "0500000US12045",
    "aland": 1433780459,
    "awater": 494266823,
    "countyfp": "045",
    "countyns": "00306917",
    "dotregion": 4,
    "geoid": "12045",
    "lsad": "06",
    "name": "Gulf",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 388,
    "affgeoid": "0500000US12047",
    "aland": 1330689578,
    "awater": 13659798,
    "countyfp": "047",
    "countyns": "00295736",
    "dotregion": 4,
    "geoid": "12047",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1057,
    "affgeoid": "0500000US12049",
    "aland": 1651878523,
    "awater": 1439673,
    "countyfp": "049",
    "countyns": "00295746",
    "dotregion": 4,
    "geoid": "12049",
    "lsad": "06",
    "name": "Hardee",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 980,
    "affgeoid": "0500000US12051",
    "aland": 2986009287,
    "awater": 96120136,
    "countyfp": "051",
    "countyns": "00307626",
    "dotregion": 4,
    "geoid": "12051",
    "lsad": "06",
    "name": "Hendry",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1758,
    "affgeoid": "0500000US12053",
    "aland": 1224611025,
    "awater": 300943246,
    "countyfp": "053",
    "countyns": "00295751",
    "dotregion": 4,
    "geoid": "12053",
    "lsad": "06",
    "name": "Hernando",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 237,
    "affgeoid": "0500000US12055",
    "aland": 2632923680,
    "awater": 231677932,
    "countyfp": "055",
    "countyns": "00295756",
    "dotregion": 4,
    "geoid": "12055",
    "lsad": "06",
    "name": "Highlands",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1062,
    "affgeoid": "0500000US12057",
    "aland": 2642601093,
    "awater": 635570785,
    "countyfp": "057",
    "countyns": "00295757",
    "dotregion": 4,
    "geoid": "12057",
    "lsad": "06",
    "name": "Hillsborough",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1376,
    "affgeoid": "0500000US12059",
    "aland": 1239970210,
    "awater": 26656232,
    "countyfp": "059",
    "countyns": "00295735",
    "dotregion": 4,
    "geoid": "12059",
    "lsad": "06",
    "name": "Holmes",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1371,
    "affgeoid": "0500000US12061",
    "aland": 1302340528,
    "awater": 295574851,
    "countyfp": "061",
    "countyns": "00307624",
    "dotregion": 4,
    "geoid": "12061",
    "lsad": "06",
    "name": "Indian River",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3205,
    "affgeoid": "0500000US12063",
    "aland": 2376988508,
    "awater": 95321393,
    "countyfp": "063",
    "countyns": "00295734",
    "dotregion": 4,
    "geoid": "12063",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1377,
    "affgeoid": "0500000US12065",
    "aland": 1549064068,
    "awater": 99559047,
    "countyfp": "065",
    "countyns": "00295733",
    "dotregion": 4,
    "geoid": "12065",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1264,
    "affgeoid": "0500000US12067",
    "aland": 1407427927,
    "awater": 11646352,
    "countyfp": "067",
    "countyns": "00295732",
    "dotregion": 4,
    "geoid": "12067",
    "lsad": "06",
    "name": "Lafayette",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1006,
    "affgeoid": "0500000US12069",
    "aland": 2432320587,
    "awater": 564194105,
    "countyfp": "069",
    "countyns": "00308551",
    "dotregion": 4,
    "geoid": "12069",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2280,
    "affgeoid": "0500000US12071",
    "aland": 2031443679,
    "awater": 1108606586,
    "countyfp": "071",
    "countyns": "00295758",
    "dotregion": 4,
    "geoid": "12071",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 286,
    "affgeoid": "0500000US12073",
    "aland": 1727171503,
    "awater": 90454011,
    "countyfp": "073",
    "countyns": "00306916",
    "dotregion": 4,
    "geoid": "12073",
    "lsad": "06",
    "name": "Leon",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3206,
    "affgeoid": "0500000US12075",
    "aland": 2896185793,
    "awater": 762933268,
    "countyfp": "075",
    "countyns": "00295724",
    "dotregion": 4,
    "geoid": "12075",
    "lsad": "06",
    "name": "Levy",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 590,
    "affgeoid": "0500000US12077",
    "aland": 2164095689,
    "awater": 19582444,
    "countyfp": "077",
    "countyns": "00308549",
    "dotregion": 4,
    "geoid": "12077",
    "lsad": "06",
    "name": "Liberty",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2247,
    "affgeoid": "0500000US12079",
    "aland": 1802874009,
    "awater": 50729943,
    "countyfp": "079",
    "countyns": "00295731",
    "dotregion": 4,
    "geoid": "12079",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 959,
    "affgeoid": "0500000US12081",
    "aland": 1924779544,
    "awater": 387447453,
    "countyfp": "081",
    "countyns": "00295744",
    "dotregion": 4,
    "geoid": "12081",
    "lsad": "06",
    "name": "Manatee",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2968,
    "affgeoid": "0500000US12083",
    "aland": 4112985503,
    "awater": 193293405,
    "countyfp": "083",
    "countyns": "00306922",
    "dotregion": 4,
    "geoid": "12083",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2417,
    "affgeoid": "0500000US12085",
    "aland": 1408245188,
    "awater": 542261303,
    "countyfp": "085",
    "countyns": "00308550",
    "dotregion": 4,
    "geoid": "12085",
    "lsad": "06",
    "name": "Martin",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3070,
    "affgeoid": "0500000US12086",
    "aland": 4917324056,
    "awater": 1379396151,
    "countyfp": "086",
    "countyns": "00295755",
    "dotregion": 4,
    "geoid": "12086",
    "lsad": "06",
    "name": "Miami-Dade",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2717,
    "affgeoid": "0500000US12087",
    "aland": 2546040739,
    "awater": 7133347242,
    "countyfp": "087",
    "countyns": "00295759",
    "dotregion": 4,
    "geoid": "12087",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3159,
    "affgeoid": "0500000US12089",
    "aland": 1679962718,
    "awater": 200159392,
    "countyfp": "089",
    "countyns": "00295730",
    "dotregion": 4,
    "geoid": "12089",
    "lsad": "06",
    "name": "Nassau",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1378,
    "affgeoid": "0500000US12091",
    "aland": 2409367476,
    "awater": 393201926,
    "countyfp": "091",
    "countyns": "00306915",
    "dotregion": 4,
    "geoid": "12091",
    "lsad": "06",
    "name": "Okaloosa",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1598,
    "affgeoid": "0500000US12093",
    "aland": 1991730024,
    "awater": 318560291,
    "countyfp": "093",
    "countyns": "00295760",
    "dotregion": 4,
    "geoid": "12093",
    "lsad": "06",
    "name": "Okeechobee",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2458,
    "affgeoid": "0500000US12095",
    "aland": 2339574474,
    "awater": 258790917,
    "countyfp": "095",
    "countyns": "00295750",
    "dotregion": 4,
    "geoid": "12095",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2439,
    "affgeoid": "0500000US12097",
    "aland": 3438608053,
    "awater": 461983619,
    "countyfp": "097",
    "countyns": "00295748",
    "dotregion": 4,
    "geoid": "12097",
    "lsad": "06",
    "name": "Osceola",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 552,
    "affgeoid": "0500000US12099",
    "aland": 5101944591,
    "awater": 1070020998,
    "countyfp": "099",
    "countyns": "00295761",
    "dotregion": 4,
    "geoid": "12099",
    "lsad": "06",
    "name": "Palm Beach",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3143,
    "affgeoid": "0500000US12101",
    "aland": 1936599224,
    "awater": 312708420,
    "countyfp": "101",
    "countyns": "00295739",
    "dotregion": 4,
    "geoid": "12101",
    "lsad": "06",
    "name": "Pasco",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2498,
    "affgeoid": "0500000US12103",
    "aland": 709120966,
    "awater": 865924096,
    "countyfp": "103",
    "countyns": "00295745",
    "dotregion": 4,
    "geoid": "12103",
    "lsad": "06",
    "name": "Pinellas",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2393,
    "affgeoid": "0500000US12105",
    "aland": 4653250695,
    "awater": 553800050,
    "countyfp": "105",
    "countyns": "00295747",
    "dotregion": 4,
    "geoid": "12105",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3046,
    "affgeoid": "0500000US12107",
    "aland": 1885199824,
    "awater": 256515596,
    "countyfp": "107",
    "countyns": "00306910",
    "dotregion": 4,
    "geoid": "12107",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2423,
    "affgeoid": "0500000US12113",
    "aland": 2620446204,
    "awater": 419623382,
    "countyfp": "113",
    "countyns": "00306914",
    "dotregion": 4,
    "geoid": "12113",
    "lsad": "06",
    "name": "Santa Rosa",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 717,
    "affgeoid": "0500000US12115",
    "aland": 1439467414,
    "awater": 438988188,
    "countyfp": "115",
    "countyns": "00295741",
    "dotregion": 4,
    "geoid": "12115",
    "lsad": "06",
    "name": "Sarasota",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1785,
    "affgeoid": "0500000US12117",
    "aland": 801546672,
    "awater": 92810898,
    "countyfp": "117",
    "countyns": "00303665",
    "dotregion": 4,
    "geoid": "12117",
    "lsad": "06",
    "name": "Seminole",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1236,
    "affgeoid": "0500000US12109",
    "aland": 1555777526,
    "awater": 571964717,
    "countyfp": "109",
    "countyns": "00308371",
    "dotregion": 4,
    "geoid": "12109",
    "lsad": "06",
    "name": "St. Johns",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 684,
    "affgeoid": "0500000US12111",
    "aland": 1480637109,
    "awater": 300862878,
    "countyfp": "111",
    "countyns": "00308372",
    "dotregion": 4,
    "geoid": "12111",
    "lsad": "06",
    "name": "St. Lucie",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1697,
    "affgeoid": "0500000US12119",
    "aland": 1417596662,
    "awater": 84144128,
    "countyfp": "119",
    "countyns": "00295740",
    "dotregion": 4,
    "geoid": "12119",
    "lsad": "06",
    "name": "Sumter",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2912,
    "affgeoid": "0500000US12121",
    "aland": 1783341102,
    "awater": 9594316,
    "countyfp": "121",
    "countyns": "00295729",
    "dotregion": 4,
    "geoid": "12121",
    "lsad": "06",
    "name": "Suwannee",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2192,
    "affgeoid": "0500000US12123",
    "aland": 2702176496,
    "awater": 489262125,
    "countyfp": "123",
    "countyns": "00295728",
    "dotregion": 4,
    "geoid": "12123",
    "lsad": "06",
    "name": "Taylor",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1288,
    "affgeoid": "0500000US12125",
    "aland": 630807238,
    "awater": 16049079,
    "countyfp": "125",
    "countyns": "00306913",
    "dotregion": 4,
    "geoid": "12125",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 1660,
    "affgeoid": "0500000US12127",
    "aland": 2851713758,
    "awater": 858278452,
    "countyfp": "127",
    "countyns": "00306921",
    "dotregion": 4,
    "geoid": "12127",
    "lsad": "06",
    "name": "Volusia",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 3207,
    "affgeoid": "0500000US12129",
    "aland": 1570621273,
    "awater": 334901394,
    "countyfp": "129",
    "countyns": "00306912",
    "dotregion": 4,
    "geoid": "12129",
    "lsad": "06",
    "name": "Wakulla",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 930,
    "affgeoid": "0500000US12131",
    "aland": 2687690444,
    "awater": 522844944,
    "countyfp": "131",
    "countyns": "00295727",
    "dotregion": 4,
    "geoid": "12131",
    "lsad": "06",
    "name": "Walton",
    "stateAbbreviation": "FL",
    "stateId": 13
  }, {
    "id": 2444,
    "affgeoid": "0500000US12133",
    "aland": 1509528105,
    "awater": 85786032,
    "countyfp": "133",
    "countyns": "00295762",
    "dotregion": 4,
    "geoid": "12133",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "FL",
    "stateId": 13
  }]
}, {
  "id": 4,
  "abbreviation": "GA",
  "affgeoid": "0400000US13",
  "aland": 149169759045,
  "awater": 4740824950,
  "dotregion": 4,
  "geoid": "13",
  "lsad": "00",
  "name": "Georgia",
  "stateAbbreviation": "GA",
  "statefp": "13",
  "statens": "01705317",
  "counties": [{
    "id": 3129,
    "affgeoid": "0500000US13001",
    "aland": 1313437498,
    "awater": 13313808,
    "countyfp": "001",
    "countyns": "00349113",
    "dotregion": 4,
    "geoid": "13001",
    "lsad": "06",
    "name": "Appling",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 224,
    "affgeoid": "0500000US13003",
    "aland": 879043416,
    "awater": 13294218,
    "countyfp": "003",
    "countyns": "00345784",
    "dotregion": 4,
    "geoid": "13003",
    "lsad": "06",
    "name": "Atkinson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2561,
    "affgeoid": "0500000US13005",
    "aland": 735650478,
    "awater": 4626042,
    "countyfp": "005",
    "countyns": "00344784",
    "dotregion": 4,
    "geoid": "13005",
    "lsad": "06",
    "name": "Bacon",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 435,
    "affgeoid": "0500000US13007",
    "aland": 885629899,
    "awater": 18634137,
    "countyfp": "007",
    "countyns": "00342832",
    "dotregion": 4,
    "geoid": "13007",
    "lsad": "06",
    "name": "Baker",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 455,
    "affgeoid": "0500000US13009",
    "aland": 669822350,
    "awater": 25008172,
    "countyfp": "009",
    "countyns": "00345255",
    "dotregion": 4,
    "geoid": "13009",
    "lsad": "06",
    "name": "Baldwin",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2094,
    "affgeoid": "0500000US13011",
    "aland": 601112274,
    "awater": 4651151,
    "countyfp": "011",
    "countyns": "00349230",
    "dotregion": 4,
    "geoid": "13011",
    "lsad": "06",
    "name": "Banks",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2965,
    "affgeoid": "0500000US13013",
    "aland": 415349721,
    "awater": 6642220,
    "countyfp": "013",
    "countyns": "00356976",
    "dotregion": 4,
    "geoid": "13013",
    "lsad": "06",
    "name": "Barrow",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2237,
    "affgeoid": "0500000US13015",
    "aland": 1190219024,
    "awater": 27368325,
    "countyfp": "015",
    "countyns": "00351604",
    "dotregion": 4,
    "geoid": "13015",
    "lsad": "06",
    "name": "Bartow",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 517,
    "affgeoid": "0500000US13017",
    "aland": 647809457,
    "awater": 9807028,
    "countyfp": "017",
    "countyns": "00351606",
    "dotregion": 4,
    "geoid": "13017",
    "lsad": "06",
    "name": "Ben Hill",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2059,
    "affgeoid": "0500000US13019",
    "aland": 1170534736,
    "awater": 15375915,
    "countyfp": "019",
    "countyns": "00326638",
    "dotregion": 4,
    "geoid": "13019",
    "lsad": "06",
    "name": "Berrien",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1991,
    "affgeoid": "0500000US13021",
    "aland": 645714764,
    "awater": 14488557,
    "countyfp": "021",
    "countyns": "01672039",
    "dotregion": 4,
    "geoid": "13021",
    "lsad": "06",
    "name": "Bibb",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2209,
    "affgeoid": "0500000US13023",
    "aland": 559100198,
    "awater": 8447343,
    "countyfp": "023",
    "countyns": "00347451",
    "dotregion": 4,
    "geoid": "13023",
    "lsad": "06",
    "name": "Bleckley",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2644,
    "affgeoid": "0500000US13025",
    "aland": 1145716267,
    "awater": 12532588,
    "countyfp": "025",
    "countyns": "00351605",
    "dotregion": 4,
    "geoid": "13025",
    "lsad": "06",
    "name": "Brantley",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2931,
    "affgeoid": "0500000US13027",
    "aland": 1277108508,
    "awater": 12188514,
    "countyfp": "027",
    "countyns": "00345518",
    "dotregion": 4,
    "geoid": "13027",
    "lsad": "06",
    "name": "Brooks",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2037,
    "affgeoid": "0500000US13029",
    "aland": 1130059118,
    "awater": 46976389,
    "countyfp": "029",
    "countyns": "00350496",
    "dotregion": 4,
    "geoid": "13029",
    "lsad": "06",
    "name": "Bryan",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2676,
    "affgeoid": "0500000US13031",
    "aland": 1743037409,
    "awater": 40494139,
    "countyfp": "031",
    "countyns": "00350302",
    "dotregion": 4,
    "geoid": "13031",
    "lsad": "06",
    "name": "Bulloch",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 963,
    "affgeoid": "0500000US13033",
    "aland": 2141835933,
    "awater": 20758800,
    "countyfp": "033",
    "countyns": "00347944",
    "dotregion": 4,
    "geoid": "13033",
    "lsad": "06",
    "name": "Burke",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 246,
    "affgeoid": "0500000US13035",
    "aland": 475937514,
    "awater": 11086906,
    "countyfp": "035",
    "countyns": "00352295",
    "dotregion": 4,
    "geoid": "13035",
    "lsad": "06",
    "name": "Butts",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 384,
    "affgeoid": "0500000US13037",
    "aland": 726147258,
    "awater": 8315719,
    "countyfp": "037",
    "countyns": "00344074",
    "dotregion": 4,
    "geoid": "13037",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1900,
    "affgeoid": "0500000US13039",
    "aland": 1588171684,
    "awater": 436849667,
    "countyfp": "039",
    "countyns": "01671316",
    "dotregion": 4,
    "geoid": "13039",
    "lsad": "06",
    "name": "Camden",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2879,
    "affgeoid": "0500000US13043",
    "aland": 629495413,
    "awater": 15043697,
    "countyfp": "043",
    "countyns": "00342852",
    "dotregion": 4,
    "geoid": "13043",
    "lsad": "06",
    "name": "Candler",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 419,
    "affgeoid": "0500000US13045",
    "aland": 1292492346,
    "awater": 12284897,
    "countyfp": "045",
    "countyns": "00326650",
    "dotregion": 4,
    "geoid": "13045",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2915,
    "affgeoid": "0500000US13047",
    "aland": 419999438,
    "awater": 771159,
    "countyfp": "047",
    "countyns": "00353230",
    "dotregion": 4,
    "geoid": "13047",
    "lsad": "06",
    "name": "Catoosa",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 3119,
    "affgeoid": "0500000US13049",
    "aland": 2003652394,
    "awater": 22681775,
    "countyfp": "049",
    "countyns": "00357747",
    "dotregion": 4,
    "geoid": "13049",
    "lsad": "06",
    "name": "Charlton",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 996,
    "affgeoid": "0500000US13051",
    "aland": 1110634444,
    "awater": 526916835,
    "countyfp": "051",
    "countyns": "01694477",
    "dotregion": 4,
    "geoid": "13051",
    "lsad": "06",
    "name": "Chatham",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2394,
    "affgeoid": "0500000US13053",
    "aland": 644222671,
    "awater": 6292704,
    "countyfp": "053",
    "countyns": "00351012",
    "dotregion": 4,
    "geoid": "13053",
    "lsad": "06",
    "name": "Chattahoochee",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2471,
    "affgeoid": "0500000US13055",
    "aland": 811512405,
    "awater": 570806,
    "countyfp": "055",
    "countyns": "00352213",
    "dotregion": 4,
    "geoid": "13055",
    "lsad": "06",
    "name": "Chattooga",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1677,
    "affgeoid": "0500000US13057",
    "aland": 1092190453,
    "awater": 32938535,
    "countyfp": "057",
    "countyns": "01685718",
    "dotregion": 4,
    "geoid": "13057",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 249,
    "affgeoid": "0500000US13059",
    "aland": 308738453,
    "awater": 4741286,
    "countyfp": "059",
    "countyns": "01672699",
    "dotregion": 4,
    "geoid": "13059",
    "lsad": "06",
    "name": "Clarke",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1941,
    "affgeoid": "0500000US13061",
    "aland": 506035802,
    "awater": 56603707,
    "countyfp": "061",
    "countyns": "00344805",
    "dotregion": 4,
    "geoid": "13061",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 458,
    "affgeoid": "0500000US13063",
    "aland": 366862138,
    "awater": 7057627,
    "countyfp": "063",
    "countyns": "01672399",
    "dotregion": 4,
    "geoid": "13063",
    "lsad": "06",
    "name": "Clayton",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2494,
    "affgeoid": "0500000US13065",
    "aland": 2072566668,
    "awater": 61565560,
    "countyfp": "065",
    "countyns": "00351285",
    "dotregion": 4,
    "geoid": "13065",
    "lsad": "06",
    "name": "Clinch",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 371,
    "affgeoid": "0500000US13067",
    "aland": 879701643,
    "awater": 12597293,
    "countyfp": "067",
    "countyns": "01686112",
    "dotregion": 4,
    "geoid": "13067",
    "lsad": "06",
    "name": "Cobb",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2061,
    "affgeoid": "0500000US13069",
    "aland": 1490103280,
    "awater": 70753625,
    "countyfp": "069",
    "countyns": "00347456",
    "dotregion": 4,
    "geoid": "13069",
    "lsad": "06",
    "name": "Coffee",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2060,
    "affgeoid": "0500000US13071",
    "aland": 1416686380,
    "awater": 25002138,
    "countyfp": "071",
    "countyns": "00343936",
    "dotregion": 4,
    "geoid": "13071",
    "lsad": "06",
    "name": "Colquitt",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2128,
    "affgeoid": "0500000US13073",
    "aland": 751327584,
    "awater": 45369171,
    "countyfp": "073",
    "countyns": "00348865",
    "dotregion": 4,
    "geoid": "13073",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2501,
    "affgeoid": "0500000US13075",
    "aland": 588446812,
    "awater": 15546061,
    "countyfp": "075",
    "countyns": "00343878",
    "dotregion": 4,
    "geoid": "13075",
    "lsad": "06",
    "name": "Cook",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2802,
    "affgeoid": "0500000US13077",
    "aland": 1141971255,
    "awater": 12730357,
    "countyfp": "077",
    "countyns": "00326666",
    "dotregion": 4,
    "geoid": "13077",
    "lsad": "06",
    "name": "Coweta",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 680,
    "affgeoid": "0500000US13079",
    "aland": 841521432,
    "awater": 3989504,
    "countyfp": "079",
    "countyns": "00342918",
    "dotregion": 4,
    "geoid": "13079",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 644,
    "affgeoid": "0500000US13081",
    "aland": 706002618,
    "awater": 21657691,
    "countyfp": "081",
    "countyns": "00351607",
    "dotregion": 4,
    "geoid": "13081",
    "lsad": "06",
    "name": "Crisp",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 287,
    "affgeoid": "0500000US13083",
    "aland": 450605327,
    "awater": 467844,
    "countyfp": "083",
    "countyns": "00347465",
    "dotregion": 4,
    "geoid": "13083",
    "lsad": "06",
    "name": "Dade",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 836,
    "affgeoid": "0500000US13085",
    "aland": 546042942,
    "awater": 9271910,
    "countyfp": "085",
    "countyns": "00351312",
    "dotregion": 4,
    "geoid": "13085",
    "lsad": "06",
    "name": "Dawson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1885,
    "affgeoid": "0500000US13089",
    "aland": 693055897,
    "awater": 9198256,
    "countyfp": "089",
    "countyns": "01687424",
    "dotregion": 4,
    "geoid": "13089",
    "lsad": "06",
    "name": "DeKalb",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 932,
    "affgeoid": "0500000US13087",
    "aland": 1546584747,
    "awater": 67412755,
    "countyfp": "087",
    "countyns": "00352234",
    "dotregion": 4,
    "geoid": "13087",
    "lsad": "06",
    "name": "Decatur",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1026,
    "affgeoid": "0500000US13091",
    "aland": 1284365331,
    "awater": 18692950,
    "countyfp": "091",
    "countyns": "00348116",
    "dotregion": 4,
    "geoid": "13091",
    "lsad": "06",
    "name": "Dodge",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2148,
    "affgeoid": "0500000US13093",
    "aland": 1015120153,
    "awater": 13841085,
    "countyfp": "093",
    "countyns": "00351608",
    "dotregion": 4,
    "geoid": "13093",
    "lsad": "06",
    "name": "Dooly",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2662,
    "affgeoid": "0500000US13095",
    "aland": 851140302,
    "awater": 15396056,
    "countyfp": "095",
    "countyns": "00351259",
    "dotregion": 4,
    "geoid": "13095",
    "lsad": "06",
    "name": "Dougherty",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2858,
    "affgeoid": "0500000US13097",
    "aland": 518293193,
    "awater": 2485429,
    "countyfp": "097",
    "countyns": "01686467",
    "dotregion": 4,
    "geoid": "13097",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2343,
    "affgeoid": "0500000US13099",
    "aland": 1327612129,
    "awater": 9717177,
    "countyfp": "099",
    "countyns": "00345041",
    "dotregion": 4,
    "geoid": "13099",
    "lsad": "06",
    "name": "Early",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 226,
    "affgeoid": "0500000US13101",
    "aland": 1074571646,
    "awater": 15087403,
    "countyfp": "101",
    "countyns": "00348092",
    "dotregion": 4,
    "geoid": "13101",
    "lsad": "06",
    "name": "Echols",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1600,
    "affgeoid": "0500000US13103",
    "aland": 1237247956,
    "awater": 13536096,
    "countyfp": "103",
    "countyns": "00350219",
    "dotregion": 4,
    "geoid": "13103",
    "lsad": "06",
    "name": "Effingham",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2650,
    "affgeoid": "0500000US13105",
    "aland": 909234534,
    "awater": 59980940,
    "countyfp": "105",
    "countyns": "00347828",
    "dotregion": 4,
    "geoid": "13105",
    "lsad": "06",
    "name": "Elbert",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2077,
    "affgeoid": "0500000US13107",
    "aland": 1762760538,
    "awater": 24802077,
    "countyfp": "107",
    "countyns": "00347508",
    "dotregion": 4,
    "geoid": "13107",
    "lsad": "06",
    "name": "Emanuel",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 519,
    "affgeoid": "0500000US13109",
    "aland": 473613883,
    "awater": 10376147,
    "countyfp": "109",
    "countyns": "00345923",
    "dotregion": 4,
    "geoid": "13109",
    "lsad": "06",
    "name": "Evans",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 693,
    "affgeoid": "0500000US13111",
    "aland": 1002370114,
    "awater": 13560718,
    "countyfp": "111",
    "countyns": "00351094",
    "dotregion": 4,
    "geoid": "13111",
    "lsad": "06",
    "name": "Fannin",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2688,
    "affgeoid": "0500000US13113",
    "aland": 503398796,
    "awater": 12846500,
    "countyfp": "113",
    "countyns": "01687740",
    "dotregion": 4,
    "geoid": "13113",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2256,
    "affgeoid": "0500000US13115",
    "aland": 1320694741,
    "awater": 22123843,
    "countyfp": "115",
    "countyns": "00353665",
    "dotregion": 4,
    "geoid": "13115",
    "lsad": "06",
    "name": "Floyd",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 520,
    "affgeoid": "0500000US13117",
    "aland": 580297280,
    "awater": 59743068,
    "countyfp": "117",
    "countyns": "01673358",
    "dotregion": 4,
    "geoid": "13117",
    "lsad": "06",
    "name": "Forsyth",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 428,
    "affgeoid": "0500000US13119",
    "aland": 677301813,
    "awater": 12803554,
    "countyfp": "119",
    "countyns": "00349324",
    "dotregion": 4,
    "geoid": "13119",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 809,
    "affgeoid": "0500000US13121",
    "aland": 1364178479,
    "awater": 19792701,
    "countyfp": "121",
    "countyns": "01694833",
    "dotregion": 4,
    "geoid": "13121",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1829,
    "affgeoid": "0500000US13123",
    "aland": 1103983751,
    "awater": 12186837,
    "countyfp": "123",
    "countyns": "00351260",
    "dotregion": 4,
    "geoid": "13123",
    "lsad": "06",
    "name": "Gilmer",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 271,
    "affgeoid": "0500000US13125",
    "aland": 372284127,
    "awater": 1847843,
    "countyfp": "125",
    "countyns": "00345642",
    "dotregion": 4,
    "geoid": "13125",
    "lsad": "06",
    "name": "Glascock",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1681,
    "affgeoid": "0500000US13127",
    "aland": 1087272600,
    "awater": 428512639,
    "countyfp": "127",
    "countyns": "01671513",
    "dotregion": 4,
    "geoid": "13127",
    "lsad": "06",
    "name": "Glynn",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1245,
    "affgeoid": "0500000US13129",
    "aland": 921538728,
    "awater": 5787828,
    "countyfp": "129",
    "countyns": "00356672",
    "dotregion": 4,
    "geoid": "13129",
    "lsad": "06",
    "name": "Gordon",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 777,
    "affgeoid": "0500000US13131",
    "aland": 1177231778,
    "awater": 14846318,
    "countyfp": "131",
    "countyns": "00351261",
    "dotregion": 4,
    "geoid": "13131",
    "lsad": "06",
    "name": "Grady",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 272,
    "affgeoid": "0500000US13133",
    "aland": 1003451715,
    "awater": 48630004,
    "countyfp": "133",
    "countyns": "00348672",
    "dotregion": 4,
    "geoid": "13133",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1186,
    "affgeoid": "0500000US13135",
    "aland": 1114908667,
    "awater": 16358522,
    "countyfp": "135",
    "countyns": "01688166",
    "dotregion": 4,
    "geoid": "13135",
    "lsad": "06",
    "name": "Gwinnett",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1687,
    "affgeoid": "0500000US13137",
    "aland": 716754762,
    "awater": 5917259,
    "countyfp": "137",
    "countyns": "00351383",
    "dotregion": 4,
    "geoid": "13137",
    "lsad": "06",
    "name": "Habersham",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 3144,
    "affgeoid": "0500000US13139",
    "aland": 1017306098,
    "awater": 94561948,
    "countyfp": "139",
    "countyns": "01686953",
    "dotregion": 4,
    "geoid": "13139",
    "lsad": "06",
    "name": "Hall",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1436,
    "affgeoid": "0500000US13141",
    "aland": 1220058031,
    "awater": 17479750,
    "countyfp": "141",
    "countyns": "00348209",
    "dotregion": 4,
    "geoid": "13141",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 503,
    "affgeoid": "0500000US13143",
    "aland": 730805104,
    "awater": 2616000,
    "countyfp": "143",
    "countyns": "00350637",
    "dotregion": 4,
    "geoid": "13143",
    "lsad": "06",
    "name": "Haralson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2136,
    "affgeoid": "0500000US13145",
    "aland": 1201462494,
    "awater": 23488477,
    "countyfp": "145",
    "countyns": "00326700",
    "dotregion": 4,
    "geoid": "13145",
    "lsad": "06",
    "name": "Harris",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 971,
    "affgeoid": "0500000US13147",
    "aland": 601903610,
    "awater": 63588441,
    "countyfp": "147",
    "countyns": "01687995",
    "dotregion": 4,
    "geoid": "13147",
    "lsad": "06",
    "name": "Hart",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1750,
    "affgeoid": "0500000US13149",
    "aland": 766718985,
    "awater": 13112095,
    "countyfp": "149",
    "countyns": "00347067",
    "dotregion": 4,
    "geoid": "13149",
    "lsad": "06",
    "name": "Heard",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 990,
    "affgeoid": "0500000US13151",
    "aland": 825200366,
    "awater": 20443876,
    "countyfp": "151",
    "countyns": "01671894",
    "dotregion": 4,
    "geoid": "13151",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1601,
    "affgeoid": "0500000US13153",
    "aland": 972671315,
    "awater": 11319340,
    "countyfp": "153",
    "countyns": "01671693",
    "dotregion": 4,
    "geoid": "13153",
    "lsad": "06",
    "name": "Houston",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 232,
    "affgeoid": "0500000US13155",
    "aland": 917793241,
    "awater": 21758147,
    "countyfp": "155",
    "countyns": "00352302",
    "dotregion": 4,
    "geoid": "13155",
    "lsad": "06",
    "name": "Irwin",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2558,
    "affgeoid": "0500000US13157",
    "aland": 879716380,
    "awater": 8906549,
    "countyfp": "157",
    "countyns": "00349570",
    "dotregion": 4,
    "geoid": "13157",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 550,
    "affgeoid": "0500000US13159",
    "aland": 953541347,
    "awater": 13727188,
    "countyfp": "159",
    "countyns": "00346144",
    "dotregion": 4,
    "geoid": "13159",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 121,
    "affgeoid": "0500000US13161",
    "aland": 856690607,
    "awater": 11986249,
    "countyfp": "161",
    "countyns": "01687999",
    "dotregion": 4,
    "geoid": "13161",
    "lsad": "06",
    "name": "Jeff Davis",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1765,
    "affgeoid": "0500000US13163",
    "aland": 1363589116,
    "awater": 8241829,
    "countyfp": "163",
    "countyns": "00345714",
    "dotregion": 4,
    "geoid": "13163",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 350,
    "affgeoid": "0500000US13165",
    "aland": 899449594,
    "awater": 13452206,
    "countyfp": "165",
    "countyns": "00342985",
    "dotregion": 4,
    "geoid": "13165",
    "lsad": "06",
    "name": "Jenkins",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 294,
    "affgeoid": "0500000US13167",
    "aland": 784793325,
    "awater": 9278537,
    "countyfp": "167",
    "countyns": "00346664",
    "dotregion": 4,
    "geoid": "13167",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1185,
    "affgeoid": "0500000US13169",
    "aland": 1020291683,
    "awater": 3832666,
    "countyfp": "169",
    "countyns": "00345367",
    "dotregion": 4,
    "geoid": "13169",
    "lsad": "06",
    "name": "Jones",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2154,
    "affgeoid": "0500000US13171",
    "aland": 475262774,
    "awater": 6046030,
    "countyfp": "171",
    "countyns": "00326713",
    "dotregion": 4,
    "geoid": "13171",
    "lsad": "06",
    "name": "Lamar",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1863,
    "affgeoid": "0500000US13173",
    "aland": 479903182,
    "awater": 37546562,
    "countyfp": "173",
    "countyns": "00348102",
    "dotregion": 4,
    "geoid": "13173",
    "lsad": "06",
    "name": "Lanier",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2401,
    "affgeoid": "0500000US13175",
    "aland": 2090902573,
    "awater": 28925938,
    "countyfp": "175",
    "countyns": "00346568",
    "dotregion": 4,
    "geoid": "13175",
    "lsad": "06",
    "name": "Laurens",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 810,
    "affgeoid": "0500000US13177",
    "aland": 921722909,
    "awater": 15318763,
    "countyfp": "177",
    "countyns": "00343390",
    "dotregion": 4,
    "geoid": "13177",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2155,
    "affgeoid": "0500000US13179",
    "aland": 1337285587,
    "awater": 223252811,
    "countyfp": "179",
    "countyns": "00357095",
    "dotregion": 4,
    "geoid": "13179",
    "lsad": "06",
    "name": "Liberty",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1942,
    "affgeoid": "0500000US13181",
    "aland": 544880787,
    "awater": 121516946,
    "countyfp": "181",
    "countyns": "01688000",
    "dotregion": 4,
    "geoid": "13181",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2537,
    "affgeoid": "0500000US13183",
    "aland": 1037095171,
    "awater": 8776467,
    "countyfp": "183",
    "countyns": "00326719",
    "dotregion": 4,
    "geoid": "13183",
    "lsad": "06",
    "name": "Long",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2823,
    "affgeoid": "0500000US13185",
    "aland": 1284858631,
    "awater": 37525413,
    "countyfp": "185",
    "countyns": "00326720",
    "dotregion": 4,
    "geoid": "13185",
    "lsad": "06",
    "name": "Lowndes",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2120,
    "affgeoid": "0500000US13187",
    "aland": 732793278,
    "awater": 3273370,
    "countyfp": "187",
    "countyns": "00357196",
    "dotregion": 4,
    "geoid": "13187",
    "lsad": "06",
    "name": "Lumpkin",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1243,
    "affgeoid": "0500000US13193",
    "aland": 1037654069,
    "awater": 13859152,
    "countyfp": "193",
    "countyns": "00346957",
    "dotregion": 4,
    "geoid": "13193",
    "lsad": "06",
    "name": "Macon",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2848,
    "affgeoid": "0500000US13195",
    "aland": 731184844,
    "awater": 8484618,
    "countyfp": "195",
    "countyns": "01688004",
    "dotregion": 4,
    "geoid": "13195",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 3089,
    "affgeoid": "0500000US13197",
    "aland": 947978204,
    "awater": 3791374,
    "countyfp": "197",
    "countyns": "00344107",
    "dotregion": 4,
    "geoid": "13197",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1629,
    "affgeoid": "0500000US13189",
    "aland": 666816637,
    "awater": 23116292,
    "countyfp": "189",
    "countyns": "00348794",
    "dotregion": 4,
    "geoid": "13189",
    "lsad": "06",
    "name": "McDuffie",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 3157,
    "affgeoid": "0500000US13191",
    "aland": 1099050235,
    "awater": 387326533,
    "countyfp": "191",
    "countyns": "00356886",
    "dotregion": 4,
    "geoid": "13191",
    "lsad": "06",
    "name": "McIntosh",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2156,
    "affgeoid": "0500000US13199",
    "aland": 1298160991,
    "awater": 10834086,
    "countyfp": "199",
    "countyns": "00346892",
    "dotregion": 4,
    "geoid": "13199",
    "lsad": "06",
    "name": "Meriwether",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 59,
    "affgeoid": "0500000US13201",
    "aland": 731466841,
    "awater": 3216290,
    "countyfp": "201",
    "countyns": "00344088",
    "dotregion": 4,
    "geoid": "13201",
    "lsad": "06",
    "name": "Miller",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 288,
    "affgeoid": "0500000US13205",
    "aland": 1326293152,
    "awater": 4504150,
    "countyfp": "205",
    "countyns": "00343645",
    "dotregion": 4,
    "geoid": "13205",
    "lsad": "06",
    "name": "Mitchell",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2123,
    "affgeoid": "0500000US13207",
    "aland": 1025912893,
    "awater": 5603382,
    "countyfp": "207",
    "countyns": "00343073",
    "dotregion": 4,
    "geoid": "13207",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2400,
    "affgeoid": "0500000US13209",
    "aland": 620370693,
    "awater": 13383014,
    "countyfp": "209",
    "countyns": "00352276",
    "dotregion": 4,
    "geoid": "13209",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 837,
    "affgeoid": "0500000US13211",
    "aland": 899647678,
    "awater": 18815669,
    "countyfp": "211",
    "countyns": "00346008",
    "dotregion": 4,
    "geoid": "13211",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1580,
    "affgeoid": "0500000US13213",
    "aland": 892278138,
    "awater": 5719645,
    "countyfp": "213",
    "countyns": "01688005",
    "dotregion": 4,
    "geoid": "13213",
    "lsad": "06",
    "name": "Murray",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 632,
    "affgeoid": "0500000US13215",
    "aland": 560530243,
    "awater": 11873622,
    "countyfp": "215",
    "countyns": "00357428",
    "dotregion": 4,
    "geoid": "13215",
    "lsad": "06",
    "name": "Muscogee",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 773,
    "affgeoid": "0500000US13217",
    "aland": 704988503,
    "awater": 18130753,
    "countyfp": "217",
    "countyns": "01673547",
    "dotregion": 4,
    "geoid": "13217",
    "lsad": "06",
    "name": "Newton",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 754,
    "affgeoid": "0500000US13219",
    "aland": 477395751,
    "awater": 5305707,
    "countyfp": "219",
    "countyns": "00356774",
    "dotregion": 4,
    "geoid": "13219",
    "lsad": "06",
    "name": "Oconee",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1717,
    "affgeoid": "0500000US13221",
    "aland": 1137034040,
    "awater": 7839366,
    "countyfp": "221",
    "countyns": "00351262",
    "dotregion": 4,
    "geoid": "13221",
    "lsad": "06",
    "name": "Oglethorpe",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2994,
    "affgeoid": "0500000US13223",
    "aland": 808832044,
    "awater": 5309331,
    "countyfp": "223",
    "countyns": "00349912",
    "dotregion": 4,
    "geoid": "13223",
    "lsad": "06",
    "name": "Paulding",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2560,
    "affgeoid": "0500000US13225",
    "aland": 389190275,
    "awater": 2676569,
    "countyfp": "225",
    "countyns": "00343153",
    "dotregion": 4,
    "geoid": "13225",
    "lsad": "06",
    "name": "Peach",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2738,
    "affgeoid": "0500000US13227",
    "aland": 601027938,
    "awater": 1693768,
    "countyfp": "227",
    "countyns": "01673011",
    "dotregion": 4,
    "geoid": "13227",
    "lsad": "06",
    "name": "Pickens",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 3071,
    "affgeoid": "0500000US13229",
    "aland": 881051116,
    "awater": 7910038,
    "countyfp": "229",
    "countyns": "00349086",
    "dotregion": 4,
    "geoid": "13229",
    "lsad": "06",
    "name": "Pierce",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2224,
    "affgeoid": "0500000US13231",
    "aland": 559659551,
    "awater": 8596853,
    "countyfp": "231",
    "countyns": "00346482",
    "dotregion": 4,
    "geoid": "13231",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 35,
    "affgeoid": "0500000US13233",
    "aland": 803772833,
    "awater": 4667496,
    "countyfp": "233",
    "countyns": "00343585",
    "dotregion": 4,
    "geoid": "13233",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1452,
    "affgeoid": "0500000US13235",
    "aland": 645061948,
    "awater": 5560186,
    "countyfp": "235",
    "countyns": "00347593",
    "dotregion": 4,
    "geoid": "13235",
    "lsad": "06",
    "name": "Pulaski",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 591,
    "affgeoid": "0500000US13237",
    "aland": 892634162,
    "awater": 41539480,
    "countyfp": "237",
    "countyns": "00347246",
    "dotregion": 4,
    "geoid": "13237",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 258,
    "affgeoid": "0500000US13239",
    "aland": 391703078,
    "awater": 24158294,
    "countyfp": "239",
    "countyns": "00350547",
    "dotregion": 4,
    "geoid": "13239",
    "lsad": "06",
    "name": "Quitman",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 3156,
    "affgeoid": "0500000US13241",
    "aland": 958280735,
    "awater": 17841177,
    "countyfp": "241",
    "countyns": "00351489",
    "dotregion": 4,
    "geoid": "13241",
    "lsad": "06",
    "name": "Rabun",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1089,
    "affgeoid": "0500000US13243",
    "aland": 1109126239,
    "awater": 6830041,
    "countyfp": "243",
    "countyns": "00352242",
    "dotregion": 4,
    "geoid": "13243",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 847,
    "affgeoid": "0500000US13245",
    "aland": 840008393,
    "awater": 11042219,
    "countyfp": "245",
    "countyns": "00358024",
    "dotregion": 4,
    "geoid": "13245",
    "lsad": "06",
    "name": "Richmond",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1510,
    "affgeoid": "0500000US13247",
    "aland": 336205278,
    "awater": 5926396,
    "countyfp": "247",
    "countyns": "00357592",
    "dotregion": 4,
    "geoid": "13247",
    "lsad": "06",
    "name": "Rockdale",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2589,
    "affgeoid": "0500000US13249",
    "aland": 432284457,
    "awater": 2376387,
    "countyfp": "249",
    "countyns": "00344129",
    "dotregion": 4,
    "geoid": "13249",
    "lsad": "06",
    "name": "Schley",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1602,
    "affgeoid": "0500000US13251",
    "aland": 1670803486,
    "awater": 27888992,
    "countyfp": "251",
    "countyns": "00350204",
    "dotregion": 4,
    "geoid": "13251",
    "lsad": "06",
    "name": "Screven",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 704,
    "affgeoid": "0500000US13253",
    "aland": 609245340,
    "awater": 55231605,
    "countyfp": "253",
    "countyns": "00351263",
    "dotregion": 4,
    "geoid": "13253",
    "lsad": "06",
    "name": "Seminole",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2244,
    "affgeoid": "0500000US13255",
    "aland": 507333988,
    "awater": 9602978,
    "countyfp": "255",
    "countyns": "00353055",
    "dotregion": 4,
    "geoid": "13255",
    "lsad": "06",
    "name": "Spalding",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 260,
    "affgeoid": "0500000US13257",
    "aland": 463948062,
    "awater": 13121983,
    "countyfp": "257",
    "countyns": "00350028",
    "dotregion": 4,
    "geoid": "13257",
    "lsad": "06",
    "name": "Stephens",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2225,
    "affgeoid": "0500000US13259",
    "aland": 1188153047,
    "awater": 12599265,
    "countyfp": "259",
    "countyns": "00347360",
    "dotregion": 4,
    "geoid": "13259",
    "lsad": "06",
    "name": "Stewart",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1905,
    "affgeoid": "0500000US13261",
    "aland": 1250175714,
    "awater": 25791716,
    "countyfp": "261",
    "countyns": "00343504",
    "dotregion": 4,
    "geoid": "13261",
    "lsad": "06",
    "name": "Sumter",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1775,
    "affgeoid": "0500000US13263",
    "aland": 1013691982,
    "awater": 8737088,
    "countyfp": "263",
    "countyns": "00326757",
    "dotregion": 4,
    "geoid": "13263",
    "lsad": "06",
    "name": "Talbot",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1735,
    "affgeoid": "0500000US13265",
    "aland": 504031039,
    "awater": 1915743,
    "countyfp": "265",
    "countyns": "00347654",
    "dotregion": 4,
    "geoid": "13265",
    "lsad": "06",
    "name": "Taliaferro",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1093,
    "affgeoid": "0500000US13267",
    "aland": 1241953433,
    "awater": 22864021,
    "countyfp": "267",
    "countyns": "00347445",
    "dotregion": 4,
    "geoid": "13267",
    "lsad": "06",
    "name": "Tattnall",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1500,
    "affgeoid": "0500000US13269",
    "aland": 975611442,
    "awater": 7803733,
    "countyfp": "269",
    "countyns": "00344156",
    "dotregion": 4,
    "geoid": "13269",
    "lsad": "06",
    "name": "Taylor",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1432,
    "affgeoid": "0500000US13271",
    "aland": 1132610582,
    "awater": 17366926,
    "countyfp": "271",
    "countyns": "00356958",
    "dotregion": 4,
    "geoid": "13271",
    "lsad": "06",
    "name": "Telfair",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 105,
    "affgeoid": "0500000US13273",
    "aland": 868785319,
    "awater": 5861795,
    "countyfp": "273",
    "countyns": "00352238",
    "dotregion": 4,
    "geoid": "13273",
    "lsad": "06",
    "name": "Terrell",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 835,
    "affgeoid": "0500000US13275",
    "aland": 1410510137,
    "awater": 19728196,
    "countyfp": "275",
    "countyns": "00343835",
    "dotregion": 4,
    "geoid": "13275",
    "lsad": "06",
    "name": "Thomas",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1904,
    "affgeoid": "0500000US13277",
    "aland": 675661214,
    "awater": 20499404,
    "countyfp": "277",
    "countyns": "00344090",
    "dotregion": 4,
    "geoid": "13277",
    "lsad": "06",
    "name": "Tift",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2145,
    "affgeoid": "0500000US13279",
    "aland": 942770570,
    "awater": 18093855,
    "countyfp": "279",
    "countyns": "00345220",
    "dotregion": 4,
    "geoid": "13279",
    "lsad": "06",
    "name": "Toombs",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1119,
    "affgeoid": "0500000US13281",
    "aland": 431395520,
    "awater": 14037933,
    "countyfp": "281",
    "countyns": "00351252",
    "dotregion": 4,
    "geoid": "13281",
    "lsad": "06",
    "name": "Towns",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 40,
    "affgeoid": "0500000US13283",
    "aland": 516536217,
    "awater": 7805621,
    "countyfp": "283",
    "countyns": "00347505",
    "dotregion": 4,
    "geoid": "13283",
    "lsad": "06",
    "name": "Treutlen",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1731,
    "affgeoid": "0500000US13285",
    "aland": 1072232618,
    "awater": 82803338,
    "countyfp": "285",
    "countyns": "01673298",
    "dotregion": 4,
    "geoid": "13285",
    "lsad": "06",
    "name": "Troup",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2938,
    "affgeoid": "0500000US13287",
    "aland": 739164629,
    "awater": 11881239,
    "countyfp": "287",
    "countyns": "00343238",
    "dotregion": 4,
    "geoid": "13287",
    "lsad": "06",
    "name": "Turner",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1736,
    "affgeoid": "0500000US13289",
    "aland": 928284540,
    "awater": 10933791,
    "countyfp": "289",
    "countyns": "00345456",
    "dotregion": 4,
    "geoid": "13289",
    "lsad": "06",
    "name": "Twiggs",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 480,
    "affgeoid": "0500000US13291",
    "aland": 833844747,
    "awater": 18273554,
    "countyfp": "291",
    "countyns": "00353193",
    "dotregion": 4,
    "geoid": "13291",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 755,
    "affgeoid": "0500000US13293",
    "aland": 837696991,
    "awater": 10663279,
    "countyfp": "293",
    "countyns": "00346759",
    "dotregion": 4,
    "geoid": "13293",
    "lsad": "06",
    "name": "Upson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1548,
    "affgeoid": "0500000US13295",
    "aland": 1156146017,
    "awater": 1672676,
    "countyfp": "295",
    "countyns": "00354216",
    "dotregion": 4,
    "geoid": "13295",
    "lsad": "06",
    "name": "Walker",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1628,
    "affgeoid": "0500000US13297",
    "aland": 843525615,
    "awater": 11170130,
    "countyfp": "297",
    "countyns": "00351264",
    "dotregion": 4,
    "geoid": "13297",
    "lsad": "06",
    "name": "Walton",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1433,
    "affgeoid": "0500000US13299",
    "aland": 2312574726,
    "awater": 39103677,
    "countyfp": "299",
    "countyns": "00357722",
    "dotregion": 4,
    "geoid": "13299",
    "lsad": "06",
    "name": "Ware",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 268,
    "affgeoid": "0500000US13301",
    "aland": 736332037,
    "awater": 6186048,
    "countyfp": "301",
    "countyns": "00347777",
    "dotregion": 4,
    "geoid": "13301",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2139,
    "affgeoid": "0500000US13303",
    "aland": 1757188472,
    "awater": 15284511,
    "countyfp": "303",
    "countyns": "00348428",
    "dotregion": 4,
    "geoid": "13303",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 586,
    "affgeoid": "0500000US13305",
    "aland": 1662237980,
    "awater": 18136147,
    "countyfp": "305",
    "countyns": "00350608",
    "dotregion": 4,
    "geoid": "13305",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 1585,
    "affgeoid": "0500000US13307",
    "aland": 541613277,
    "awater": 2965865,
    "countyfp": "307",
    "countyns": "00352287",
    "dotregion": 4,
    "geoid": "13307",
    "lsad": "06",
    "name": "Webster",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2278,
    "affgeoid": "0500000US13309",
    "aland": 765301200,
    "awater": 12390212,
    "countyfp": "309",
    "countyns": "00351278",
    "dotregion": 4,
    "geoid": "13309",
    "lsad": "06",
    "name": "Wheeler",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 122,
    "affgeoid": "0500000US13311",
    "aland": 623402120,
    "awater": 3912787,
    "countyfp": "311",
    "countyns": "00326781",
    "dotregion": 4,
    "geoid": "13311",
    "lsad": "06",
    "name": "White",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2025,
    "affgeoid": "0500000US13313",
    "aland": 752293531,
    "awater": 1533754,
    "countyfp": "313",
    "countyns": "00353513",
    "dotregion": 4,
    "geoid": "13313",
    "lsad": "06",
    "name": "Whitfield",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 933,
    "affgeoid": "0500000US13315",
    "aland": 978250127,
    "awater": 11444179,
    "countyfp": "315",
    "countyns": "00345499",
    "dotregion": 4,
    "geoid": "13315",
    "lsad": "06",
    "name": "Wilcox",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 549,
    "affgeoid": "0500000US13317",
    "aland": 1215973896,
    "awater": 11924769,
    "countyfp": "317",
    "countyns": "00351265",
    "dotregion": 4,
    "geoid": "13317",
    "lsad": "06",
    "name": "Wilkes",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 2142,
    "affgeoid": "0500000US13319",
    "aland": 1158541304,
    "awater": 12003359,
    "countyfp": "319",
    "countyns": "00346824",
    "dotregion": 4,
    "geoid": "13319",
    "lsad": "06",
    "name": "Wilkinson",
    "stateAbbreviation": "GA",
    "stateId": 4
  }, {
    "id": 170,
    "affgeoid": "0500000US13321",
    "aland": 1478123915,
    "awater": 10485470,
    "countyfp": "321",
    "countyns": "00343365",
    "dotregion": 4,
    "geoid": "13321",
    "lsad": "06",
    "name": "Worth",
    "stateAbbreviation": "GA",
    "stateId": 4
  }]
}, {
  "id": 54,
  "abbreviation": "GU",
  "dotregion": 9,
  "geoid": "66",
  "name": "Guam",
  "stateAbbreviation": "GU",
  "statefp": "66",
  "counties": [{
    "id": 3222,
    "countyfp": "010",
    "countyns": "01802705",
    "dotregion": 9,
    "geoid": "66010",
    "name": "Guam",
    "stateAbbreviation": "GU",
    "stateId": 54
  }]
}, {
  "id": 42,
  "abbreviation": "HI",
  "affgeoid": "0400000US15",
  "aland": 16634133472,
  "awater": 11777724416,
  "dotregion": 9,
  "geoid": "15",
  "lsad": "00",
  "name": "Hawaii",
  "stateAbbreviation": "HI",
  "statefp": "15",
  "statens": "01779782",
  "counties": [{
    "id": 2216,
    "affgeoid": "0500000US15001",
    "aland": 10433651107,
    "awater": 2739477691,
    "countyfp": "001",
    "countyns": "00365280",
    "dotregion": 9,
    "geoid": "15001",
    "lsad": "06",
    "name": "Hawaii",
    "stateAbbreviation": "HI",
    "stateId": 42
  }, {
    "id": 602,
    "affgeoid": "0500000US15003",
    "aland": 1555505156,
    "awater": 4054940027,
    "countyfp": "003",
    "countyns": "00365281",
    "dotregion": 9,
    "geoid": "15003",
    "lsad": "06",
    "name": "Honolulu",
    "stateAbbreviation": "HI",
    "stateId": 42
  }, {
    "id": 568,
    "affgeoid": "0500000US15005",
    "aland": 31057602,
    "awater": 105769486,
    "countyfp": "005",
    "countyns": "01702380",
    "dotregion": 9,
    "geoid": "15005",
    "lsad": "06",
    "name": "Kalawao",
    "stateAbbreviation": "HI",
    "stateId": 42
  }, {
    "id": 1316,
    "affgeoid": "0500000US15007",
    "aland": 1605560469,
    "awater": 1674243566,
    "countyfp": "007",
    "countyns": "00365282",
    "dotregion": 9,
    "geoid": "15007",
    "lsad": "06",
    "name": "Kauai",
    "stateAbbreviation": "HI",
    "stateId": 42
  }, {
    "id": 2853,
    "affgeoid": "0500000US15009",
    "aland": 3008359138,
    "awater": 3203293646,
    "countyfp": "009",
    "countyns": "00365283",
    "dotregion": 9,
    "geoid": "15009",
    "lsad": "06",
    "name": "Maui",
    "stateAbbreviation": "HI",
    "stateId": 42
  }]
}, {
  "id": 12,
  "abbreviation": "ID",
  "affgeoid": "0400000US16",
  "aland": 214042831252,
  "awater": 2397619893,
  "dotregion": 10,
  "geoid": "16",
  "lsad": "00",
  "name": "Idaho",
  "stateAbbreviation": "ID",
  "statefp": "16",
  "statens": "01779783",
  "counties": [{
    "id": 1370,
    "affgeoid": "0500000US16001",
    "aland": 2726291052,
    "awater": 20291587,
    "countyfp": "001",
    "countyns": "00395066",
    "dotregion": 10,
    "geoid": "16001",
    "lsad": "06",
    "name": "Ada",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1968,
    "affgeoid": "0500000US16003",
    "aland": 3530315271,
    "awater": 17384865,
    "countyfp": "003",
    "countyns": "00395067",
    "dotregion": 10,
    "geoid": "16003",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 825,
    "affgeoid": "0500000US16005",
    "aland": 2880037048,
    "awater": 91799953,
    "countyfp": "005",
    "countyns": "00395091",
    "dotregion": 10,
    "geoid": "16005",
    "lsad": "06",
    "name": "Bannock",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2038,
    "affgeoid": "0500000US16007",
    "aland": 2524917724,
    "awater": 193276295,
    "countyfp": "007",
    "countyns": "00395090",
    "dotregion": 10,
    "geoid": "16007",
    "lsad": "06",
    "name": "Bear Lake",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 532,
    "affgeoid": "0500000US16009",
    "aland": 2011429525,
    "awater": 18987952,
    "countyfp": "009",
    "countyns": "00395190",
    "dotregion": 10,
    "geoid": "16009",
    "lsad": "06",
    "name": "Benewah",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1471,
    "affgeoid": "0500000US16011",
    "aland": 5423127704,
    "awater": 68447504,
    "countyfp": "011",
    "countyns": "00400593",
    "dotregion": 10,
    "geoid": "16011",
    "lsad": "06",
    "name": "Bingham",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2217,
    "affgeoid": "0500000US16013",
    "aland": 6837372799,
    "awater": 44347641,
    "countyfp": "013",
    "countyns": "00395696",
    "dotregion": 10,
    "geoid": "16013",
    "lsad": "06",
    "name": "Blaine",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1967,
    "affgeoid": "0500000US16015",
    "aland": 4919005836,
    "awater": 19293635,
    "countyfp": "015",
    "countyns": "00395157",
    "dotregion": 10,
    "geoid": "16015",
    "lsad": "06",
    "name": "Boise",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2652,
    "affgeoid": "0500000US16017",
    "aland": 4494094339,
    "awater": 478953307,
    "countyfp": "017",
    "countyns": "00395158",
    "dotregion": 10,
    "geoid": "16017",
    "lsad": "06",
    "name": "Bonner",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2658,
    "affgeoid": "0500000US16019",
    "aland": 4833106288,
    "awater": 89505250,
    "countyfp": "019",
    "countyns": "00395407",
    "dotregion": 10,
    "geoid": "16019",
    "lsad": "06",
    "name": "Bonneville",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 893,
    "affgeoid": "0500000US16021",
    "aland": 3285786073,
    "awater": 24097890,
    "countyfp": "021",
    "countyns": "00395159",
    "dotregion": 10,
    "geoid": "16021",
    "lsad": "06",
    "name": "Boundary",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 98,
    "affgeoid": "0500000US16023",
    "aland": 5791731101,
    "awater": 5258025,
    "countyfp": "023",
    "countyns": "00401703",
    "dotregion": 10,
    "geoid": "16023",
    "lsad": "06",
    "name": "Butte",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 820,
    "affgeoid": "0500000US16025",
    "aland": 2782922931,
    "awater": 11535218,
    "countyfp": "025",
    "countyns": "00399408",
    "dotregion": 10,
    "geoid": "16025",
    "lsad": "06",
    "name": "Camas",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 118,
    "affgeoid": "0500000US16027",
    "aland": 1521269418,
    "awater": 41912557,
    "countyfp": "027",
    "countyns": "00399406",
    "dotregion": 10,
    "geoid": "16027",
    "lsad": "06",
    "name": "Canyon",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1314,
    "affgeoid": "0500000US16029",
    "aland": 4568789280,
    "awater": 89170385,
    "countyfp": "029",
    "countyns": "00395406",
    "dotregion": 10,
    "geoid": "16029",
    "lsad": "06",
    "name": "Caribou",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 633,
    "affgeoid": "0500000US16031",
    "aland": 6642382760,
    "awater": 39370054,
    "countyfp": "031",
    "countyns": "00395698",
    "dotregion": 10,
    "geoid": "16031",
    "lsad": "06",
    "name": "Cassia",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 859,
    "affgeoid": "0500000US16033",
    "aland": 4567262180,
    "awater": 2476454,
    "countyfp": "033",
    "countyns": "00399755",
    "dotregion": 10,
    "geoid": "16033",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2231,
    "affgeoid": "0500000US16035",
    "aland": 6364125459,
    "awater": 79537930,
    "countyfp": "035",
    "countyns": "00395697",
    "dotregion": 10,
    "geoid": "16035",
    "lsad": "06",
    "name": "Clearwater",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2084,
    "affgeoid": "0500000US16037",
    "aland": 12743076925,
    "awater": 42380283,
    "countyfp": "037",
    "countyns": "00399758",
    "dotregion": 10,
    "geoid": "16037",
    "lsad": "06",
    "name": "Custer",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1624,
    "affgeoid": "0500000US16039",
    "aland": 7963532452,
    "awater": 67386793,
    "countyfp": "039",
    "countyns": "00400252",
    "dotregion": 10,
    "geoid": "16039",
    "lsad": "06",
    "name": "Elmore",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2312,
    "affgeoid": "0500000US16041",
    "aland": 1718705847,
    "awater": 12165111,
    "countyfp": "041",
    "countyns": "00395585",
    "dotregion": 10,
    "geoid": "16041",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1561,
    "affgeoid": "0500000US16043",
    "aland": 4827127231,
    "awater": 83291789,
    "countyfp": "043",
    "countyns": "00395408",
    "dotregion": 10,
    "geoid": "16043",
    "lsad": "06",
    "name": "Fremont",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 756,
    "affgeoid": "0500000US16045",
    "aland": 1452712966,
    "awater": 12443645,
    "countyfp": "045",
    "countyns": "00395442",
    "dotregion": 10,
    "geoid": "16045",
    "lsad": "06",
    "name": "Gem",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 144,
    "affgeoid": "0500000US16047",
    "aland": 1888032003,
    "awater": 12289363,
    "countyfp": "047",
    "countyns": "00395441",
    "dotregion": 10,
    "geoid": "16047",
    "lsad": "06",
    "name": "Gooding",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 780,
    "affgeoid": "0500000US16049",
    "aland": 21955991187,
    "awater": 67312413,
    "countyfp": "049",
    "countyns": "00395699",
    "dotregion": 10,
    "geoid": "16049",
    "lsad": "06",
    "name": "Idaho",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1246,
    "affgeoid": "0500000US16051",
    "aland": 2832172395,
    "awater": 31262706,
    "countyfp": "051",
    "countyns": "00399751",
    "dotregion": 10,
    "geoid": "16051",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2035,
    "affgeoid": "0500000US16053",
    "aland": 1546717189,
    "awater": 12848163,
    "countyfp": "053",
    "countyns": "00395662",
    "dotregion": 10,
    "geoid": "16053",
    "lsad": "06",
    "name": "Jerome",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 3030,
    "affgeoid": "0500000US16055",
    "aland": 3222281604,
    "awater": 185181742,
    "countyfp": "055",
    "countyns": "00395661",
    "dotregion": 10,
    "geoid": "16055",
    "lsad": "06",
    "name": "Kootenai",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 778,
    "affgeoid": "0500000US16057",
    "aland": 2786818332,
    "awater": 2370271,
    "countyfp": "057",
    "countyns": "00395613",
    "dotregion": 10,
    "geoid": "16057",
    "lsad": "06",
    "name": "Latah",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 883,
    "affgeoid": "0500000US16059",
    "aland": 11818873960,
    "awater": 13954037,
    "countyfp": "059",
    "countyns": "00399754",
    "dotregion": 10,
    "geoid": "16059",
    "lsad": "06",
    "name": "Lemhi",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 655,
    "affgeoid": "0500000US16061",
    "aland": 1240073701,
    "awater": 2444525,
    "countyfp": "061",
    "countyns": "00395622",
    "dotregion": 10,
    "geoid": "16061",
    "lsad": "06",
    "name": "Lewis",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1248,
    "affgeoid": "0500000US16063",
    "aland": 3111594425,
    "awater": 11607021,
    "countyfp": "063",
    "countyns": "00395624",
    "dotregion": 10,
    "geoid": "16063",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2898,
    "affgeoid": "0500000US16065",
    "aland": 1215286572,
    "awater": 10389484,
    "countyfp": "065",
    "countyns": "00394803",
    "dotregion": 10,
    "geoid": "16065",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 656,
    "affgeoid": "0500000US16067",
    "aland": 1962152579,
    "awater": 13820849,
    "countyfp": "067",
    "countyns": "00394807",
    "dotregion": 10,
    "geoid": "16067",
    "lsad": "06",
    "name": "Minidoka",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1239,
    "affgeoid": "0500000US16069",
    "aland": 2196548061,
    "awater": 21212964,
    "countyfp": "069",
    "countyns": "00399394",
    "dotregion": 10,
    "geoid": "16069",
    "lsad": "06",
    "name": "Nez Perce",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1935,
    "affgeoid": "0500000US16071",
    "aland": 3107437565,
    "awater": 3995238,
    "countyfp": "071",
    "countyns": "00399759",
    "dotregion": 10,
    "geoid": "16071",
    "lsad": "06",
    "name": "Oneida",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2563,
    "affgeoid": "0500000US16073",
    "aland": 19853654513,
    "awater": 81456108,
    "countyfp": "073",
    "countyns": "00399760",
    "dotregion": 10,
    "geoid": "16073",
    "lsad": "06",
    "name": "Owyhee",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1834,
    "affgeoid": "0500000US16075",
    "aland": 1053779632,
    "awater": 8827431,
    "countyfp": "075",
    "countyns": "00394896",
    "dotregion": 10,
    "geoid": "16075",
    "lsad": "06",
    "name": "Payette",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 1219,
    "affgeoid": "0500000US16077",
    "aland": 3637036616,
    "awater": 99453168,
    "countyfp": "077",
    "countyns": "00394951",
    "dotregion": 10,
    "geoid": "16077",
    "lsad": "06",
    "name": "Power",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2538,
    "affgeoid": "0500000US16079",
    "aland": 6811078681,
    "awater": 14130785,
    "countyfp": "079",
    "countyns": "01702379",
    "dotregion": 10,
    "geoid": "16079",
    "lsad": "06",
    "name": "Shoshone",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2259,
    "affgeoid": "0500000US16081",
    "aland": 1164084061,
    "awater": 2860443,
    "countyfp": "081",
    "countyns": "00399297",
    "dotregion": 10,
    "geoid": "16081",
    "lsad": "06",
    "name": "Teton",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 481,
    "affgeoid": "0500000US16083",
    "aland": 4975933315,
    "awater": 18401638,
    "countyfp": "083",
    "countyns": "00399334",
    "dotregion": 10,
    "geoid": "16083",
    "lsad": "06",
    "name": "Twin Falls",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 2316,
    "affgeoid": "0500000US16085",
    "aland": 9491065306,
    "awater": 177274388,
    "countyfp": "085",
    "countyns": "00399756",
    "dotregion": 10,
    "geoid": "16085",
    "lsad": "06",
    "name": "Valley",
    "stateAbbreviation": "ID",
    "stateId": 12
  }, {
    "id": 3214,
    "affgeoid": "0500000US16087",
    "aland": 3763097346,
    "awater": 53213033,
    "countyfp": "087",
    "countyns": "00399757",
    "dotregion": 10,
    "geoid": "16087",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "ID",
    "stateId": 12
  }]
}, {
  "id": 20,
  "abbreviation": "IL",
  "affgeoid": "0400000US17",
  "aland": 143794894211,
  "awater": 6200606440,
  "dotregion": 5,
  "geoid": "17",
  "lsad": "00",
  "name": "Illinois",
  "stateAbbreviation": "IL",
  "statefp": "17",
  "statens": "01779784",
  "counties": [{
    "id": 2153,
    "affgeoid": "0500000US17001",
    "aland": 2214972286,
    "awater": 41784365,
    "countyfp": "001",
    "countyns": "00424202",
    "dotregion": 5,
    "geoid": "17001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1840,
    "affgeoid": "0500000US17003",
    "aland": 609996942,
    "awater": 44237191,
    "countyfp": "003",
    "countyns": "00424203",
    "dotregion": 5,
    "geoid": "17003",
    "lsad": "06",
    "name": "Alexander",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 91,
    "affgeoid": "0500000US17005",
    "aland": 984918652,
    "awater": 6426353,
    "countyfp": "005",
    "countyns": "00424204",
    "dotregion": 5,
    "geoid": "17005",
    "lsad": "06",
    "name": "Bond",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1468,
    "affgeoid": "0500000US17007",
    "aland": 727101583,
    "awater": 3339043,
    "countyfp": "007",
    "countyns": "00424205",
    "dotregion": 5,
    "geoid": "17007",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 381,
    "affgeoid": "0500000US17009",
    "aland": 791518279,
    "awater": 4139308,
    "countyfp": "009",
    "countyns": "00424206",
    "dotregion": 5,
    "geoid": "17009",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2923,
    "affgeoid": "0500000US17011",
    "aland": 2250785992,
    "awater": 11578416,
    "countyfp": "011",
    "countyns": "00424207",
    "dotregion": 5,
    "geoid": "17011",
    "lsad": "06",
    "name": "Bureau",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1943,
    "affgeoid": "0500000US17013",
    "aland": 657402916,
    "awater": 77057164,
    "countyfp": "013",
    "countyns": "00424208",
    "dotregion": 5,
    "geoid": "17013",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 255,
    "affgeoid": "0500000US17015",
    "aland": 1152707885,
    "awater": 55841451,
    "countyfp": "015",
    "countyns": "00424209",
    "dotregion": 5,
    "geoid": "17015",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1226,
    "affgeoid": "0500000US17017",
    "aland": 973345804,
    "awater": 20581547,
    "countyfp": "017",
    "countyns": "00424210",
    "dotregion": 5,
    "geoid": "17017",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2860,
    "affgeoid": "0500000US17019",
    "aland": 2580293767,
    "awater": 5531832,
    "countyfp": "019",
    "countyns": "00424211",
    "dotregion": 5,
    "geoid": "17019",
    "lsad": "06",
    "name": "Champaign",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1854,
    "affgeoid": "0500000US17021",
    "aland": 1837278859,
    "awater": 16221514,
    "countyfp": "021",
    "countyns": "00424212",
    "dotregion": 5,
    "geoid": "17021",
    "lsad": "06",
    "name": "Christian",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2685,
    "affgeoid": "0500000US17023",
    "aland": 1298666607,
    "awater": 8806917,
    "countyfp": "023",
    "countyns": "00424213",
    "dotregion": 5,
    "geoid": "17023",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1390,
    "affgeoid": "0500000US17025",
    "aland": 1212958829,
    "awater": 3278251,
    "countyfp": "025",
    "countyns": "00424214",
    "dotregion": 5,
    "geoid": "17025",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 169,
    "affgeoid": "0500000US17027",
    "aland": 1227874119,
    "awater": 75592335,
    "countyfp": "027",
    "countyns": "00424215",
    "dotregion": 5,
    "geoid": "17027",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 984,
    "affgeoid": "0500000US17029",
    "aland": 1316459190,
    "awater": 4631834,
    "countyfp": "029",
    "countyns": "00424216",
    "dotregion": 5,
    "geoid": "17029",
    "lsad": "06",
    "name": "Coles",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2133,
    "affgeoid": "0500000US17031",
    "aland": 2448400204,
    "awater": 1785626819,
    "countyfp": "031",
    "countyns": "01784766",
    "dotregion": 5,
    "geoid": "17031",
    "lsad": "06",
    "name": "Cook",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1824,
    "affgeoid": "0500000US17033",
    "aland": 1148997685,
    "awater": 5667188,
    "countyfp": "033",
    "countyns": "00424218",
    "dotregion": 5,
    "geoid": "17033",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 60,
    "affgeoid": "0500000US17035",
    "aland": 896203114,
    "awater": 2531272,
    "countyfp": "035",
    "countyns": "00424219",
    "dotregion": 5,
    "geoid": "17035",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 740,
    "affgeoid": "0500000US17039",
    "aland": 1029643577,
    "awater": 19519851,
    "countyfp": "039",
    "countyns": "00426598",
    "dotregion": 5,
    "geoid": "17039",
    "lsad": "06",
    "name": "De Witt",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1035,
    "affgeoid": "0500000US17037",
    "aland": 1635193208,
    "awater": 8568342,
    "countyfp": "037",
    "countyns": "00422190",
    "dotregion": 5,
    "geoid": "17037",
    "lsad": "06",
    "name": "DeKalb",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 67,
    "affgeoid": "0500000US17041",
    "aland": 1079156612,
    "awater": 1448702,
    "countyfp": "041",
    "countyns": "00424222",
    "dotregion": 5,
    "geoid": "17041",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2241,
    "affgeoid": "0500000US17043",
    "aland": 848258564,
    "awater": 22857568,
    "countyfp": "043",
    "countyns": "00422191",
    "dotregion": 5,
    "geoid": "17043",
    "lsad": "06",
    "name": "DuPage",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1927,
    "affgeoid": "0500000US17045",
    "aland": 1614531795,
    "awater": 1610634,
    "countyfp": "045",
    "countyns": "00424224",
    "dotregion": 5,
    "geoid": "17045",
    "lsad": "06",
    "name": "Edgar",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1670,
    "affgeoid": "0500000US17047",
    "aland": 576061731,
    "awater": 781203,
    "countyfp": "047",
    "countyns": "00424225",
    "dotregion": 5,
    "geoid": "17047",
    "lsad": "06",
    "name": "Edwards",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1526,
    "affgeoid": "0500000US17049",
    "aland": 1240027660,
    "awater": 3183217,
    "countyfp": "049",
    "countyns": "00424226",
    "dotregion": 5,
    "geoid": "17049",
    "lsad": "06",
    "name": "Effingham",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2959,
    "affgeoid": "0500000US17051",
    "aland": 1855687602,
    "awater": 22942188,
    "countyfp": "051",
    "countyns": "00424227",
    "dotregion": 5,
    "geoid": "17051",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 400,
    "affgeoid": "0500000US17053",
    "aland": 1257719717,
    "awater": 1640286,
    "countyfp": "053",
    "countyns": "00424228",
    "dotregion": 5,
    "geoid": "17053",
    "lsad": "06",
    "name": "Ford",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 201,
    "affgeoid": "0500000US17055",
    "aland": 1059021102,
    "awater": 58413469,
    "countyfp": "055",
    "countyns": "00424229",
    "dotregion": 5,
    "geoid": "17055",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2076,
    "affgeoid": "0500000US17057",
    "aland": 2241880791,
    "awater": 43973316,
    "countyfp": "057",
    "countyns": "00424230",
    "dotregion": 5,
    "geoid": "17057",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1051,
    "affgeoid": "0500000US17059",
    "aland": 836749960,
    "awater": 13238356,
    "countyfp": "059",
    "countyns": "00424231",
    "dotregion": 5,
    "geoid": "17059",
    "lsad": "06",
    "name": "Gallatin",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1052,
    "affgeoid": "0500000US17061",
    "aland": 1406413313,
    "awater": 8425393,
    "countyfp": "061",
    "countyns": "00424232",
    "dotregion": 5,
    "geoid": "17061",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 212,
    "affgeoid": "0500000US17063",
    "aland": 1082749559,
    "awater": 32106092,
    "countyfp": "063",
    "countyns": "00424233",
    "dotregion": 5,
    "geoid": "17063",
    "lsad": "06",
    "name": "Grundy",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1527,
    "affgeoid": "0500000US17065",
    "aland": 1125778616,
    "awater": 3174312,
    "countyfp": "065",
    "countyns": "00424234",
    "dotregion": 5,
    "geoid": "17065",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2508,
    "affgeoid": "0500000US17067",
    "aland": 2055740567,
    "awater": 53535827,
    "countyfp": "067",
    "countyns": "00424235",
    "dotregion": 5,
    "geoid": "17067",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2855,
    "affgeoid": "0500000US17069",
    "aland": 459795959,
    "awater": 10489596,
    "countyfp": "069",
    "countyns": "00424236",
    "dotregion": 5,
    "geoid": "17069",
    "lsad": "06",
    "name": "Hardin",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1487,
    "affgeoid": "0500000US17071",
    "aland": 981273714,
    "awater": 42340542,
    "countyfp": "071",
    "countyns": "00424237",
    "dotregion": 5,
    "geoid": "17071",
    "lsad": "06",
    "name": "Henderson",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 645,
    "affgeoid": "0500000US17073",
    "aland": 2131552058,
    "awater": 6862245,
    "countyfp": "073",
    "countyns": "00424238",
    "dotregion": 5,
    "geoid": "17073",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 370,
    "affgeoid": "0500000US17075",
    "aland": 2893771415,
    "awater": 4235076,
    "countyfp": "075",
    "countyns": "00424239",
    "dotregion": 5,
    "geoid": "17075",
    "lsad": "06",
    "name": "Iroquois",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1913,
    "affgeoid": "0500000US17077",
    "aland": 1512739085,
    "awater": 47416201,
    "countyfp": "077",
    "countyns": "00424240",
    "dotregion": 5,
    "geoid": "17077",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1159,
    "affgeoid": "0500000US17079",
    "aland": 1280788077,
    "awater": 9334509,
    "countyfp": "079",
    "countyns": "00424241",
    "dotregion": 5,
    "geoid": "17079",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 657,
    "affgeoid": "0500000US17081",
    "aland": 1479284991,
    "awater": 32709408,
    "countyfp": "081",
    "countyns": "00424242",
    "dotregion": 5,
    "geoid": "17081",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 912,
    "affgeoid": "0500000US17083",
    "aland": 956433111,
    "awater": 20324168,
    "countyfp": "083",
    "countyns": "00424243",
    "dotregion": 5,
    "geoid": "17083",
    "lsad": "06",
    "name": "Jersey",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 779,
    "affgeoid": "0500000US17085",
    "aland": 1556339199,
    "awater": 45776828,
    "countyfp": "085",
    "countyns": "00424244",
    "dotregion": 5,
    "geoid": "17085",
    "lsad": "06",
    "name": "Jo Daviess",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2885,
    "affgeoid": "0500000US17087",
    "aland": 890741065,
    "awater": 12811451,
    "countyfp": "087",
    "countyns": "00424245",
    "dotregion": 5,
    "geoid": "17087",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 3164,
    "affgeoid": "0500000US17089",
    "aland": 1347216444,
    "awater": 10775726,
    "countyfp": "089",
    "countyns": "00424246",
    "dotregion": 5,
    "geoid": "17089",
    "lsad": "06",
    "name": "Kane",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2908,
    "affgeoid": "0500000US17091",
    "aland": 1752310524,
    "awater": 12413735,
    "countyfp": "091",
    "countyns": "00424247",
    "dotregion": 5,
    "geoid": "17091",
    "lsad": "06",
    "name": "Kankakee",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 467,
    "affgeoid": "0500000US17093",
    "aland": 829537625,
    "awater": 5118525,
    "countyfp": "093",
    "countyns": "00424248",
    "dotregion": 5,
    "geoid": "17093",
    "lsad": "06",
    "name": "Kendall",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 821,
    "affgeoid": "0500000US17095",
    "aland": 1855506549,
    "awater": 8834348,
    "countyfp": "095",
    "countyns": "00424249",
    "dotregion": 5,
    "geoid": "17095",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 475,
    "affgeoid": "0500000US17099",
    "aland": 2939990010,
    "awater": 33693280,
    "countyfp": "099",
    "countyns": "00422247",
    "dotregion": 5,
    "geoid": "17099",
    "lsad": "06",
    "name": "LaSalle",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2969,
    "affgeoid": "0500000US17097",
    "aland": 1149077255,
    "awater": 2395036797,
    "countyfp": "097",
    "countyns": "01784796",
    "dotregion": 5,
    "geoid": "17097",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2283,
    "affgeoid": "0500000US17101",
    "aland": 963936881,
    "awater": 5077778,
    "countyfp": "101",
    "countyns": "00424252",
    "dotregion": 5,
    "geoid": "17101",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 862,
    "affgeoid": "0500000US17103",
    "aland": 1877371243,
    "awater": 10599322,
    "countyfp": "103",
    "countyns": "00424253",
    "dotregion": 5,
    "geoid": "17103",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 77,
    "affgeoid": "0500000US17105",
    "aland": 2704687496,
    "awater": 4252884,
    "countyfp": "105",
    "countyns": "00424254",
    "dotregion": 5,
    "geoid": "17105",
    "lsad": "06",
    "name": "Livingston",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2427,
    "affgeoid": "0500000US17107",
    "aland": 1600758860,
    "awater": 2252736,
    "countyfp": "107",
    "countyns": "00424255",
    "dotregion": 5,
    "geoid": "17107",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2390,
    "affgeoid": "0500000US17115",
    "aland": 1503973502,
    "awater": 13409564,
    "countyfp": "115",
    "countyns": "00424256",
    "dotregion": 5,
    "geoid": "17115",
    "lsad": "06",
    "name": "Macon",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 113,
    "affgeoid": "0500000US17117",
    "aland": 2234952632,
    "awater": 12252649,
    "countyfp": "117",
    "countyns": "00424257",
    "dotregion": 5,
    "geoid": "17117",
    "lsad": "06",
    "name": "Macoupin",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 868,
    "affgeoid": "0500000US17119",
    "aland": 1853742057,
    "awater": 64302909,
    "countyfp": "119",
    "countyns": "00424258",
    "dotregion": 5,
    "geoid": "17119",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2099,
    "affgeoid": "0500000US17121",
    "aland": 1482442356,
    "awater": 9487928,
    "countyfp": "121",
    "countyns": "00424259",
    "dotregion": 5,
    "geoid": "17121",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 6,
    "affgeoid": "0500000US17123",
    "aland": 1001787871,
    "awater": 30368315,
    "countyfp": "123",
    "countyns": "00424260",
    "dotregion": 5,
    "geoid": "17123",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 3048,
    "affgeoid": "0500000US17125",
    "aland": 1396619096,
    "awater": 62745252,
    "countyfp": "125",
    "countyns": "00424261",
    "dotregion": 5,
    "geoid": "17125",
    "lsad": "06",
    "name": "Mason",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1832,
    "affgeoid": "0500000US17127",
    "aland": 614390802,
    "awater": 11904133,
    "countyfp": "127",
    "countyns": "01784730",
    "dotregion": 5,
    "geoid": "17127",
    "lsad": "06",
    "name": "Massac",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 426,
    "affgeoid": "0500000US17109",
    "aland": 1526558088,
    "awater": 2012555,
    "countyfp": "109",
    "countyns": "01784729",
    "dotregion": 5,
    "geoid": "17109",
    "lsad": "06",
    "name": "McDonough",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2697,
    "affgeoid": "0500000US17111",
    "aland": 1562336303,
    "awater": 19832927,
    "countyfp": "111",
    "countyns": "01784815",
    "dotregion": 5,
    "geoid": "17111",
    "lsad": "06",
    "name": "McHenry",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2667,
    "affgeoid": "0500000US17113",
    "aland": 3064861155,
    "awater": 7562638,
    "countyfp": "113",
    "countyns": "01784833",
    "dotregion": 5,
    "geoid": "17113",
    "lsad": "06",
    "name": "McLean",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 991,
    "affgeoid": "0500000US17129",
    "aland": 814389207,
    "awater": 2641080,
    "countyfp": "129",
    "countyns": "00424266",
    "dotregion": 5,
    "geoid": "17129",
    "lsad": "06",
    "name": "Menard",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1873,
    "affgeoid": "0500000US17131",
    "aland": 1453500382,
    "awater": 19409929,
    "countyfp": "131",
    "countyns": "01784750",
    "dotregion": 5,
    "geoid": "17131",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2714,
    "affgeoid": "0500000US17133",
    "aland": 997188935,
    "awater": 33718659,
    "countyfp": "133",
    "countyns": "01784865",
    "dotregion": 5,
    "geoid": "17133",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1315,
    "affgeoid": "0500000US17135",
    "aland": 1822539613,
    "awater": 15512963,
    "countyfp": "135",
    "countyns": "01784866",
    "dotregion": 5,
    "geoid": "17135",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 795,
    "affgeoid": "0500000US17137",
    "aland": 1473194865,
    "awater": 9064992,
    "countyfp": "137",
    "countyns": "00424270",
    "dotregion": 5,
    "geoid": "17137",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 982,
    "affgeoid": "0500000US17139",
    "aland": 870088914,
    "awater": 22102476,
    "countyfp": "139",
    "countyns": "01784885",
    "dotregion": 5,
    "geoid": "17139",
    "lsad": "06",
    "name": "Moultrie",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 322,
    "affgeoid": "0500000US17141",
    "aland": 1964706942,
    "awater": 11425029,
    "countyfp": "141",
    "countyns": "01784894",
    "dotregion": 5,
    "geoid": "17141",
    "lsad": "06",
    "name": "Ogle",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1776,
    "affgeoid": "0500000US17143",
    "aland": 1603693530,
    "awater": 29505061,
    "countyfp": "143",
    "countyns": "01784920",
    "dotregion": 5,
    "geoid": "17143",
    "lsad": "06",
    "name": "Peoria",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 757,
    "affgeoid": "0500000US17145",
    "aland": 1144186123,
    "awater": 13416186,
    "countyfp": "145",
    "countyns": "01784940",
    "dotregion": 5,
    "geoid": "17145",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 3196,
    "affgeoid": "0500000US17147",
    "aland": 1137445095,
    "awater": 756346,
    "countyfp": "147",
    "countyns": "00424275",
    "dotregion": 5,
    "geoid": "17147",
    "lsad": "06",
    "name": "Piatt",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1540,
    "affgeoid": "0500000US17149",
    "aland": 2153317670,
    "awater": 45283711,
    "countyfp": "149",
    "countyns": "01784941",
    "dotregion": 5,
    "geoid": "17149",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1925,
    "affgeoid": "0500000US17151",
    "aland": 955109670,
    "awater": 14328523,
    "countyfp": "151",
    "countyns": "00424277",
    "dotregion": 5,
    "geoid": "17151",
    "lsad": "06",
    "name": "Pope",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 430,
    "affgeoid": "0500000US17153",
    "aland": 515887464,
    "awater": 10473563,
    "countyfp": "153",
    "countyns": "01784966",
    "dotregion": 5,
    "geoid": "17153",
    "lsad": "06",
    "name": "Pulaski",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 378,
    "affgeoid": "0500000US17155",
    "aland": 414813859,
    "awater": 31243032,
    "countyfp": "155",
    "countyns": "00424279",
    "dotregion": 5,
    "geoid": "17155",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 995,
    "affgeoid": "0500000US17157",
    "aland": 1490546072,
    "awater": 56207428,
    "countyfp": "157",
    "countyns": "01784967",
    "dotregion": 5,
    "geoid": "17157",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 151,
    "affgeoid": "0500000US17159",
    "aland": 932423425,
    "awater": 4884901,
    "countyfp": "159",
    "countyns": "00424281",
    "dotregion": 5,
    "geoid": "17159",
    "lsad": "06",
    "name": "Richland",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2260,
    "affgeoid": "0500000US17161",
    "aland": 1107115474,
    "awater": 61715046,
    "countyfp": "161",
    "countyns": "00424282",
    "dotregion": 5,
    "geoid": "17161",
    "lsad": "06",
    "name": "Rock Island",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 873,
    "affgeoid": "0500000US17165",
    "aland": 983746631,
    "awater": 18008533,
    "countyfp": "165",
    "countyns": "00424283",
    "dotregion": 5,
    "geoid": "17165",
    "lsad": "06",
    "name": "Saline",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1845,
    "affgeoid": "0500000US17167",
    "aland": 2248891494,
    "awater": 22577723,
    "countyfp": "167",
    "countyns": "01785010",
    "dotregion": 5,
    "geoid": "17167",
    "lsad": "06",
    "name": "Sangamon",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 533,
    "affgeoid": "0500000US17169",
    "aland": 1132531697,
    "awater": 10511619,
    "countyfp": "169",
    "countyns": "01785037",
    "dotregion": 5,
    "geoid": "17169",
    "lsad": "06",
    "name": "Schuyler",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 495,
    "affgeoid": "0500000US17171",
    "aland": 649861236,
    "awater": 4812706,
    "countyfp": "171",
    "countyns": "00424286",
    "dotregion": 5,
    "geoid": "17171",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2830,
    "affgeoid": "0500000US17173",
    "aland": 1964598132,
    "awater": 24693146,
    "countyfp": "173",
    "countyns": "01785051",
    "dotregion": 5,
    "geoid": "17173",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 723,
    "affgeoid": "0500000US17163",
    "aland": 1703650703,
    "awater": 42081592,
    "countyfp": "163",
    "countyns": "01784987",
    "dotregion": 5,
    "geoid": "17163",
    "lsad": "06",
    "name": "St. Clair",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 106,
    "affgeoid": "0500000US17175",
    "aland": 746121489,
    "awater": 708705,
    "countyfp": "175",
    "countyns": "00424288",
    "dotregion": 5,
    "geoid": "17175",
    "lsad": "06",
    "name": "Stark",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 3194,
    "affgeoid": "0500000US17177",
    "aland": 1462175613,
    "awater": 1385929,
    "countyfp": "177",
    "countyns": "01785076",
    "dotregion": 5,
    "geoid": "17177",
    "lsad": "06",
    "name": "Stephenson",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1025,
    "affgeoid": "0500000US17179",
    "aland": 1681105118,
    "awater": 22941954,
    "countyfp": "179",
    "countyns": "01785094",
    "dotregion": 5,
    "geoid": "17179",
    "lsad": "06",
    "name": "Tazewell",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 251,
    "affgeoid": "0500000US17181",
    "aland": 1070855937,
    "awater": 22502264,
    "countyfp": "181",
    "countyns": "01785113",
    "dotregion": 5,
    "geoid": "17181",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1032,
    "affgeoid": "0500000US17183",
    "aland": 2326763526,
    "awater": 7534491,
    "countyfp": "183",
    "countyns": "01785114",
    "dotregion": 5,
    "geoid": "17183",
    "lsad": "06",
    "name": "Vermilion",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2481,
    "affgeoid": "0500000US17185",
    "aland": 578224627,
    "awater": 11012015,
    "countyfp": "185",
    "countyns": "00424293",
    "dotregion": 5,
    "geoid": "17185",
    "lsad": "06",
    "name": "Wabash",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 309,
    "affgeoid": "0500000US17187",
    "aland": 1404823489,
    "awater": 1674135,
    "countyfp": "187",
    "countyns": "01785134",
    "dotregion": 5,
    "geoid": "17187",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2881,
    "affgeoid": "0500000US17189",
    "aland": 1457058111,
    "awater": 3454759,
    "countyfp": "189",
    "countyns": "01785150",
    "dotregion": 5,
    "geoid": "17189",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2118,
    "affgeoid": "0500000US17191",
    "aland": 1848769742,
    "awater": 4331009,
    "countyfp": "191",
    "countyns": "00424296",
    "dotregion": 5,
    "geoid": "17191",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 155,
    "affgeoid": "0500000US17193",
    "aland": 1281439561,
    "awater": 18374883,
    "countyfp": "193",
    "countyns": "00424297",
    "dotregion": 5,
    "geoid": "17193",
    "lsad": "06",
    "name": "White",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2883,
    "affgeoid": "0500000US17195",
    "aland": 1772198883,
    "awater": 31796423,
    "countyfp": "195",
    "countyns": "01785167",
    "dotregion": 5,
    "geoid": "17195",
    "lsad": "06",
    "name": "Whiteside",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 881,
    "affgeoid": "0500000US17197",
    "aland": 2167652507,
    "awater": 31840804,
    "countyfp": "197",
    "countyns": "01785190",
    "dotregion": 5,
    "geoid": "17197",
    "lsad": "06",
    "name": "Will",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 620,
    "affgeoid": "0500000US17199",
    "aland": 1088235237,
    "awater": 62630460,
    "countyfp": "199",
    "countyns": "01785215",
    "dotregion": 5,
    "geoid": "17199",
    "lsad": "06",
    "name": "Williamson",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 2854,
    "affgeoid": "0500000US17201",
    "aland": 1329745720,
    "awater": 15107861,
    "countyfp": "201",
    "countyns": "01785216",
    "dotregion": 5,
    "geoid": "17201",
    "lsad": "06",
    "name": "Winnebago",
    "stateAbbreviation": "IL",
    "stateId": 20
  }, {
    "id": 1058,
    "affgeoid": "0500000US17203",
    "aland": 1367025008,
    "awater": 38410923,
    "countyfp": "203",
    "countyns": "01785231",
    "dotregion": 5,
    "geoid": "17203",
    "lsad": "06",
    "name": "Woodford",
    "stateAbbreviation": "IL",
    "stateId": 20
  }]
}, {
  "id": 32,
  "abbreviation": "IN",
  "affgeoid": "0400000US18",
  "aland": 92790537698,
  "awater": 1535887357,
  "dotregion": 5,
  "geoid": "18",
  "lsad": "00",
  "name": "Indiana",
  "stateAbbreviation": "IN",
  "statefp": "18",
  "statens": "00448508",
  "counties": [{
    "id": 1751,
    "affgeoid": "0500000US18001",
    "aland": 878078799,
    "awater": 2430642,
    "countyfp": "001",
    "countyns": "00450401",
    "dotregion": 5,
    "geoid": "18001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1617,
    "affgeoid": "0500000US18003",
    "aland": 1702454352,
    "awater": 6999604,
    "countyfp": "003",
    "countyns": "00450402",
    "dotregion": 5,
    "geoid": "18003",
    "lsad": "06",
    "name": "Allen",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2171,
    "affgeoid": "0500000US18005",
    "aland": 1053850604,
    "awater": 6814131,
    "countyfp": "005",
    "countyns": "00451683",
    "dotregion": 5,
    "geoid": "18005",
    "lsad": "06",
    "name": "Bartholomew",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 500,
    "affgeoid": "0500000US18007",
    "aland": 1052616452,
    "awater": 236033,
    "countyfp": "007",
    "countyns": "00450403",
    "dotregion": 5,
    "geoid": "18007",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2545,
    "affgeoid": "0500000US18009",
    "aland": 427554635,
    "awater": 1303566,
    "countyfp": "009",
    "countyns": "00450404",
    "dotregion": 5,
    "geoid": "18009",
    "lsad": "06",
    "name": "Blackford",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 75,
    "affgeoid": "0500000US18011",
    "aland": 1095336144,
    "awater": 877936,
    "countyfp": "011",
    "countyns": "00450405",
    "dotregion": 5,
    "geoid": "18011",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1567,
    "affgeoid": "0500000US18013",
    "aland": 808029632,
    "awater": 12040223,
    "countyfp": "013",
    "countyns": "00451684",
    "dotregion": 5,
    "geoid": "18013",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2376,
    "affgeoid": "0500000US18015",
    "aland": 964066247,
    "awater": 7227489,
    "countyfp": "015",
    "countyns": "00450406",
    "dotregion": 5,
    "geoid": "18015",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1043,
    "affgeoid": "0500000US18017",
    "aland": 1067475955,
    "awater": 6974424,
    "countyfp": "017",
    "countyns": "00450339",
    "dotregion": 5,
    "geoid": "18017",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2285,
    "affgeoid": "0500000US18019",
    "aland": 965626431,
    "awater": 9244302,
    "countyfp": "019",
    "countyns": "00450340",
    "dotregion": 5,
    "geoid": "18019",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 130,
    "affgeoid": "0500000US18021",
    "aland": 926094203,
    "awater": 7133798,
    "countyfp": "021",
    "countyns": "00450341",
    "dotregion": 5,
    "geoid": "18021",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 168,
    "affgeoid": "0500000US18023",
    "aland": 1049119208,
    "awater": 461117,
    "countyfp": "023",
    "countyns": "00450342",
    "dotregion": 5,
    "geoid": "18023",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1842,
    "affgeoid": "0500000US18025",
    "aland": 791601707,
    "awater": 7974816,
    "countyfp": "025",
    "countyns": "00451674",
    "dotregion": 5,
    "geoid": "18025",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1559,
    "affgeoid": "0500000US18027",
    "aland": 1112370962,
    "awater": 19127827,
    "countyfp": "027",
    "countyns": "00450343",
    "dotregion": 5,
    "geoid": "18027",
    "lsad": "06",
    "name": "Daviess",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 438,
    "affgeoid": "0500000US18033",
    "aland": 939732067,
    "awater": 2657420,
    "countyfp": "033",
    "countyns": "00450346",
    "dotregion": 5,
    "geoid": "18033",
    "lsad": "06",
    "name": "DeKalb",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2740,
    "affgeoid": "0500000US18029",
    "aland": 790033700,
    "awater": 6168665,
    "countyfp": "029",
    "countyns": "00450344",
    "dotregion": 5,
    "geoid": "18029",
    "lsad": "06",
    "name": "Dearborn",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1807,
    "affgeoid": "0500000US18031",
    "aland": 964946213,
    "awater": 1955471,
    "countyfp": "031",
    "countyns": "00450345",
    "dotregion": 5,
    "geoid": "18031",
    "lsad": "06",
    "name": "Decatur",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2843,
    "affgeoid": "0500000US18035",
    "aland": 1015607268,
    "awater": 9792758,
    "countyfp": "035",
    "countyns": "00450347",
    "dotregion": 5,
    "geoid": "18035",
    "lsad": "06",
    "name": "Delaware",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2565,
    "affgeoid": "0500000US18037",
    "aland": 1106624776,
    "awater": 20884562,
    "countyfp": "037",
    "countyns": "00451675",
    "dotregion": 5,
    "geoid": "18037",
    "lsad": "06",
    "name": "Dubois",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 915,
    "affgeoid": "0500000US18039",
    "aland": 1199614703,
    "awater": 12423390,
    "countyfp": "039",
    "countyns": "00450348",
    "dotregion": 5,
    "geoid": "18039",
    "lsad": "06",
    "name": "Elkhart",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 525,
    "affgeoid": "0500000US18041",
    "aland": 556901540,
    "awater": 366408,
    "countyfp": "041",
    "countyns": "00450349",
    "dotregion": 5,
    "geoid": "18041",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2737,
    "affgeoid": "0500000US18043",
    "aland": 383288306,
    "awater": 2645487,
    "countyfp": "043",
    "countyns": "00450350",
    "dotregion": 5,
    "geoid": "18043",
    "lsad": "06",
    "name": "Floyd",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1564,
    "affgeoid": "0500000US18045",
    "aland": 1024769250,
    "awater": 5734092,
    "countyfp": "045",
    "countyns": "00450351",
    "dotregion": 5,
    "geoid": "18045",
    "lsad": "06",
    "name": "Fountain",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 634,
    "affgeoid": "0500000US18047",
    "aland": 995670497,
    "awater": 17143494,
    "countyfp": "047",
    "countyns": "00450352",
    "dotregion": 5,
    "geoid": "18047",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1231,
    "affgeoid": "0500000US18049",
    "aland": 954118209,
    "awater": 7454415,
    "countyfp": "049",
    "countyns": "00450353",
    "dotregion": 5,
    "geoid": "18049",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 554,
    "affgeoid": "0500000US18051",
    "aland": 1262606257,
    "awater": 30223916,
    "countyfp": "051",
    "countyns": "00450354",
    "dotregion": 5,
    "geoid": "18051",
    "lsad": "06",
    "name": "Gibson",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 443,
    "affgeoid": "0500000US18053",
    "aland": 1072452767,
    "awater": 2133507,
    "countyfp": "053",
    "countyns": "00450355",
    "dotregion": 5,
    "geoid": "18053",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1554,
    "affgeoid": "0500000US18055",
    "aland": 1405058705,
    "awater": 8861022,
    "countyfp": "055",
    "countyns": "00451676",
    "dotregion": 5,
    "geoid": "18055",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 528,
    "affgeoid": "0500000US18057",
    "aland": 1021268168,
    "awater": 21038494,
    "countyfp": "057",
    "countyns": "00450356",
    "dotregion": 5,
    "geoid": "18057",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 896,
    "affgeoid": "0500000US18059",
    "aland": 792580867,
    "awater": 2610512,
    "countyfp": "059",
    "countyns": "00450357",
    "dotregion": 5,
    "geoid": "18059",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2129,
    "affgeoid": "0500000US18061",
    "aland": 1254889453,
    "awater": 5193189,
    "countyfp": "061",
    "countyns": "00451677",
    "dotregion": 5,
    "geoid": "18061",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 646,
    "affgeoid": "0500000US18063",
    "aland": 1053849184,
    "awater": 4880845,
    "countyfp": "063",
    "countyns": "00450358",
    "dotregion": 5,
    "geoid": "18063",
    "lsad": "06",
    "name": "Hendricks",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 999,
    "affgeoid": "0500000US18065",
    "aland": 1014954777,
    "awater": 7655158,
    "countyfp": "065",
    "countyns": "00450359",
    "dotregion": 5,
    "geoid": "18065",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 319,
    "affgeoid": "0500000US18067",
    "aland": 758858971,
    "awater": 2394185,
    "countyfp": "067",
    "countyns": "00450360",
    "dotregion": 5,
    "geoid": "18067",
    "lsad": "06",
    "name": "Howard",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 389,
    "affgeoid": "0500000US18069",
    "aland": 991056505,
    "awater": 13133894,
    "countyfp": "069",
    "countyns": "00450361",
    "dotregion": 5,
    "geoid": "18069",
    "lsad": "06",
    "name": "Huntington",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2207,
    "affgeoid": "0500000US18071",
    "aland": 1319119292,
    "awater": 11910481,
    "countyfp": "071",
    "countyns": "00451678",
    "dotregion": 5,
    "geoid": "18071",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1814,
    "affgeoid": "0500000US18073",
    "aland": 1449431946,
    "awater": 4560470,
    "countyfp": "073",
    "countyns": "00450494",
    "dotregion": 5,
    "geoid": "18073",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 706,
    "affgeoid": "0500000US18075",
    "aland": 994310101,
    "awater": 458556,
    "countyfp": "075",
    "countyns": "00450362",
    "dotregion": 5,
    "geoid": "18075",
    "lsad": "06",
    "name": "Jay",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2736,
    "affgeoid": "0500000US18077",
    "aland": 934033344,
    "awater": 5844616,
    "countyfp": "077",
    "countyns": "00450363",
    "dotregion": 5,
    "geoid": "18077",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 741,
    "affgeoid": "0500000US18079",
    "aland": 975364217,
    "awater": 4546213,
    "countyfp": "079",
    "countyns": "00450364",
    "dotregion": 5,
    "geoid": "18079",
    "lsad": "06",
    "name": "Jennings",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1419,
    "affgeoid": "0500000US18081",
    "aland": 829909418,
    "awater": 3525572,
    "countyfp": "081",
    "countyns": "00450365",
    "dotregion": 5,
    "geoid": "18081",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 553,
    "affgeoid": "0500000US18083",
    "aland": 1336514522,
    "awater": 20754774,
    "countyfp": "083",
    "countyns": "00450366",
    "dotregion": 5,
    "geoid": "18083",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 472,
    "affgeoid": "0500000US18085",
    "aland": 1376372907,
    "awater": 59498372,
    "countyfp": "085",
    "countyns": "00450367",
    "dotregion": 5,
    "geoid": "18085",
    "lsad": "06",
    "name": "Kosciusko",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1611,
    "affgeoid": "0500000US18087",
    "aland": 983237252,
    "awater": 18317909,
    "countyfp": "087",
    "countyns": "00450368",
    "dotregion": 5,
    "geoid": "18087",
    "lsad": "06",
    "name": "LaGrange",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 143,
    "affgeoid": "0500000US18091",
    "aland": 1549659085,
    "awater": 38675577,
    "countyfp": "091",
    "countyns": "00450507",
    "dotregion": 5,
    "geoid": "18091",
    "lsad": "06",
    "name": "LaPorte",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1251,
    "affgeoid": "0500000US18089",
    "aland": 1292514974,
    "awater": 330463488,
    "countyfp": "089",
    "countyns": "00450495",
    "dotregion": 5,
    "geoid": "18089",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 299,
    "affgeoid": "0500000US18093",
    "aland": 1163367041,
    "awater": 7122898,
    "countyfp": "093",
    "countyns": "00451703",
    "dotregion": 5,
    "geoid": "18093",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 466,
    "affgeoid": "0500000US18095",
    "aland": 1170457650,
    "awater": 2559342,
    "countyfp": "095",
    "countyns": "00450370",
    "dotregion": 5,
    "geoid": "18095",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 74,
    "affgeoid": "0500000US18097",
    "aland": 1026600417,
    "awater": 17191063,
    "countyfp": "097",
    "countyns": "00450371",
    "dotregion": 5,
    "geoid": "18097",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 860,
    "affgeoid": "0500000US18099",
    "aland": 1148993902,
    "awater": 15834723,
    "countyfp": "099",
    "countyns": "00450372",
    "dotregion": 5,
    "geoid": "18099",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 342,
    "affgeoid": "0500000US18101",
    "aland": 869615716,
    "awater": 12033249,
    "countyfp": "101",
    "countyns": "00451679",
    "dotregion": 5,
    "geoid": "18101",
    "lsad": "06",
    "name": "Martin",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1690,
    "affgeoid": "0500000US18103",
    "aland": 968246955,
    "awater": 9184625,
    "countyfp": "103",
    "countyns": "00450373",
    "dotregion": 5,
    "geoid": "18103",
    "lsad": "06",
    "name": "Miami",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2324,
    "affgeoid": "0500000US18105",
    "aland": 1021811758,
    "awater": 43504254,
    "countyfp": "105",
    "countyns": "00451680",
    "dotregion": 5,
    "geoid": "18105",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2828,
    "affgeoid": "0500000US18107",
    "aland": 1306954206,
    "awater": 2144021,
    "countyfp": "107",
    "countyns": "00450374",
    "dotregion": 5,
    "geoid": "18107",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2381,
    "affgeoid": "0500000US18109",
    "aland": 1046324518,
    "awater": 14089948,
    "countyfp": "109",
    "countyns": "00450375",
    "dotregion": 5,
    "geoid": "18109",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 240,
    "affgeoid": "0500000US18111",
    "aland": 1040539916,
    "awater": 4349506,
    "countyfp": "111",
    "countyns": "00450376",
    "dotregion": 5,
    "geoid": "18111",
    "lsad": "06",
    "name": "Newton",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 865,
    "affgeoid": "0500000US18113",
    "aland": 1064079612,
    "awater": 17066449,
    "countyfp": "113",
    "countyns": "00450377",
    "dotregion": 5,
    "geoid": "18113",
    "lsad": "06",
    "name": "Noble",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 83,
    "affgeoid": "0500000US18115",
    "aland": 223101879,
    "awater": 3352213,
    "countyfp": "115",
    "countyns": "00450378",
    "dotregion": 5,
    "geoid": "18115",
    "lsad": "06",
    "name": "Ohio",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2193,
    "affgeoid": "0500000US18117",
    "aland": 1031818419,
    "awater": 25393791,
    "countyfp": "117",
    "countyns": "00451681",
    "dotregion": 5,
    "geoid": "18117",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1710,
    "affgeoid": "0500000US18119",
    "aland": 997921791,
    "awater": 6541718,
    "countyfp": "119",
    "countyns": "00450379",
    "dotregion": 5,
    "geoid": "18119",
    "lsad": "06",
    "name": "Owen",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 375,
    "affgeoid": "0500000US18121",
    "aland": 1151747431,
    "awater": 13683945,
    "countyfp": "121",
    "countyns": "00450380",
    "dotregion": 5,
    "geoid": "18121",
    "lsad": "06",
    "name": "Parke",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2835,
    "affgeoid": "0500000US18123",
    "aland": 988668629,
    "awater": 11817655,
    "countyfp": "123",
    "countyns": "00451682",
    "dotregion": 5,
    "geoid": "18123",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2839,
    "affgeoid": "0500000US18125",
    "aland": 865677126,
    "awater": 17752830,
    "countyfp": "125",
    "countyns": "00450381",
    "dotregion": 5,
    "geoid": "18125",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1894,
    "affgeoid": "0500000US18127",
    "aland": 1082777927,
    "awater": 268632959,
    "countyfp": "127",
    "countyns": "00450382",
    "dotregion": 5,
    "geoid": "18127",
    "lsad": "06",
    "name": "Porter",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2629,
    "affgeoid": "0500000US18129",
    "aland": 1060787800,
    "awater": 25259380,
    "countyfp": "129",
    "countyns": "00450383",
    "dotregion": 5,
    "geoid": "18129",
    "lsad": "06",
    "name": "Posey",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 361,
    "affgeoid": "0500000US18131",
    "aland": 1123146088,
    "awater": 2291536,
    "countyfp": "131",
    "countyns": "00446852",
    "dotregion": 5,
    "geoid": "18131",
    "lsad": "06",
    "name": "Pulaski",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1194,
    "affgeoid": "0500000US18133",
    "aland": 1244586416,
    "awater": 5585380,
    "countyfp": "133",
    "countyns": "00450384",
    "dotregion": 5,
    "geoid": "18133",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2462,
    "affgeoid": "0500000US18135",
    "aland": 1171656634,
    "awater": 2420286,
    "countyfp": "135",
    "countyns": "00446853",
    "dotregion": 5,
    "geoid": "18135",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 61,
    "affgeoid": "0500000US18137",
    "aland": 1156236796,
    "awater": 4237459,
    "countyfp": "137",
    "countyns": "00450385",
    "dotregion": 5,
    "geoid": "18137",
    "lsad": "06",
    "name": "Ripley",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 25,
    "affgeoid": "0500000US18139",
    "aland": 1057035490,
    "awater": 872270,
    "countyfp": "139",
    "countyns": "00446854",
    "dotregion": 5,
    "geoid": "18139",
    "lsad": "06",
    "name": "Rush",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 796,
    "affgeoid": "0500000US18143",
    "aland": 493126044,
    "awater": 6089001,
    "countyfp": "143",
    "countyns": "00450386",
    "dotregion": 5,
    "geoid": "18143",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2727,
    "affgeoid": "0500000US18145",
    "aland": 1064866371,
    "awater": 4167805,
    "countyfp": "145",
    "countyns": "00450387",
    "dotregion": 5,
    "geoid": "18145",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2533,
    "affgeoid": "0500000US18147",
    "aland": 1027689677,
    "awater": 12000002,
    "countyfp": "147",
    "countyns": "00450388",
    "dotregion": 5,
    "geoid": "18147",
    "lsad": "06",
    "name": "Spencer",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 3000,
    "affgeoid": "0500000US18141",
    "aland": 1185912671,
    "awater": 9070408,
    "countyfp": "141",
    "countyns": "00452855",
    "dotregion": 5,
    "geoid": "18141",
    "lsad": "06",
    "name": "St. Joseph",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1608,
    "affgeoid": "0500000US18149",
    "aland": 800657647,
    "awater": 7951314,
    "countyfp": "149",
    "countyns": "00450389",
    "dotregion": 5,
    "geoid": "18149",
    "lsad": "06",
    "name": "Starke",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2661,
    "affgeoid": "0500000US18151",
    "aland": 799725144,
    "awater": 35458838,
    "countyfp": "151",
    "countyns": "00450390",
    "dotregion": 5,
    "geoid": "18151",
    "lsad": "06",
    "name": "Steuben",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2395,
    "affgeoid": "0500000US18153",
    "aland": 1157992150,
    "awater": 18162494,
    "countyfp": "153",
    "countyns": "00450391",
    "dotregion": 5,
    "geoid": "18153",
    "lsad": "06",
    "name": "Sullivan",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1688,
    "affgeoid": "0500000US18155",
    "aland": 571436384,
    "awater": 7267095,
    "countyfp": "155",
    "countyns": "00450392",
    "dotregion": 5,
    "geoid": "18155",
    "lsad": "06",
    "name": "Switzerland",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 479,
    "affgeoid": "0500000US18157",
    "aland": 1294484149,
    "awater": 8910176,
    "countyfp": "157",
    "countyns": "00450393",
    "dotregion": 5,
    "geoid": "18157",
    "lsad": "06",
    "name": "Tippecanoe",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 422,
    "affgeoid": "0500000US18159",
    "aland": 674797595,
    "awater": 68028,
    "countyfp": "159",
    "countyns": "00450394",
    "dotregion": 5,
    "geoid": "18159",
    "lsad": "06",
    "name": "Tipton",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 32,
    "affgeoid": "0500000US18161",
    "aland": 417568568,
    "awater": 10238515,
    "countyfp": "161",
    "countyns": "00450395",
    "dotregion": 5,
    "geoid": "18161",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1122,
    "affgeoid": "0500000US18163",
    "aland": 604741974,
    "awater": 7352001,
    "countyfp": "163",
    "countyns": "00450396",
    "dotregion": 5,
    "geoid": "18163",
    "lsad": "06",
    "name": "Vanderburgh",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 141,
    "affgeoid": "0500000US18165",
    "aland": 665311752,
    "awater": 7904759,
    "countyfp": "165",
    "countyns": "00450397",
    "dotregion": 5,
    "geoid": "18165",
    "lsad": "06",
    "name": "Vermillion",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 683,
    "affgeoid": "0500000US18167",
    "aland": 1044993096,
    "awater": 18068475,
    "countyfp": "167",
    "countyns": "00450398",
    "dotregion": 5,
    "geoid": "18167",
    "lsad": "06",
    "name": "Vigo",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2307,
    "affgeoid": "0500000US18169",
    "aland": 1068206218,
    "awater": 22115988,
    "countyfp": "169",
    "countyns": "00450399",
    "dotregion": 5,
    "geoid": "18169",
    "lsad": "06",
    "name": "Wabash",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 463,
    "affgeoid": "0500000US18171",
    "aland": 944520565,
    "awater": 4466121,
    "countyfp": "171",
    "countyns": "00450400",
    "dotregion": 5,
    "geoid": "18171",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 895,
    "affgeoid": "0500000US18173",
    "aland": 996945714,
    "awater": 15874469,
    "countyfp": "173",
    "countyns": "00450335",
    "dotregion": 5,
    "geoid": "18173",
    "lsad": "06",
    "name": "Warrick",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2784,
    "affgeoid": "0500000US18175",
    "aland": 1330542687,
    "awater": 7441757,
    "countyfp": "175",
    "countyns": "00451665",
    "dotregion": 5,
    "geoid": "18175",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 1448,
    "affgeoid": "0500000US18177",
    "aland": 1040508997,
    "awater": 6732251,
    "countyfp": "177",
    "countyns": "00450336",
    "dotregion": 5,
    "geoid": "18177",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 317,
    "affgeoid": "0500000US18179",
    "aland": 953341274,
    "awater": 5596376,
    "countyfp": "179",
    "countyns": "00450337",
    "dotregion": 5,
    "geoid": "18179",
    "lsad": "06",
    "name": "Wells",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 2342,
    "affgeoid": "0500000US18181",
    "aland": 1308269852,
    "awater": 9203227,
    "countyfp": "181",
    "countyns": "00450338",
    "dotregion": 5,
    "geoid": "18181",
    "lsad": "06",
    "name": "White",
    "stateAbbreviation": "IN",
    "stateId": 32
  }, {
    "id": 3028,
    "affgeoid": "0500000US18183",
    "aland": 869120480,
    "awater": 6073937,
    "countyfp": "183",
    "countyns": "00450369",
    "dotregion": 5,
    "geoid": "18183",
    "lsad": "06",
    "name": "Whitley",
    "stateAbbreviation": "IN",
    "stateId": 32
  }]
}, {
  "id": 22,
  "abbreviation": "IA",
  "affgeoid": "0400000US19",
  "aland": 144667481633,
  "awater": 1077969087,
  "dotregion": 7,
  "geoid": "19",
  "lsad": "00",
  "name": "Iowa",
  "stateAbbreviation": "IA",
  "statefp": "19",
  "statens": "01779785",
  "counties": [{
    "id": 910,
    "affgeoid": "0500000US19001",
    "aland": 1474404192,
    "awater": 2597996,
    "countyfp": "001",
    "countyns": "00465190",
    "dotregion": 7,
    "geoid": "19001",
    "lsad": "06",
    "name": "Adair",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2746,
    "affgeoid": "0500000US19003",
    "aland": 1096700776,
    "awater": 5353404,
    "countyfp": "003",
    "countyns": "00465191",
    "dotregion": 7,
    "geoid": "19003",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1267,
    "affgeoid": "0500000US19005",
    "aland": 1655214181,
    "awater": 50995532,
    "countyfp": "005",
    "countyns": "00465192",
    "dotregion": 7,
    "geoid": "19005",
    "lsad": "06",
    "name": "Allamakee",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2696,
    "affgeoid": "0500000US19007",
    "aland": 1287983053,
    "awater": 49083874,
    "countyfp": "007",
    "countyns": "00465193",
    "dotregion": 7,
    "geoid": "19007",
    "lsad": "06",
    "name": "Appanoose",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2522,
    "affgeoid": "0500000US19009",
    "aland": 1147264555,
    "awater": 1152260,
    "countyfp": "009",
    "countyns": "00465194",
    "dotregion": 7,
    "geoid": "19009",
    "lsad": "06",
    "name": "Audubon",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 7,
    "affgeoid": "0500000US19011",
    "aland": 1855117304,
    "awater": 5760770,
    "countyfp": "011",
    "countyns": "00465195",
    "dotregion": 7,
    "geoid": "19011",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1892,
    "affgeoid": "0500000US19013",
    "aland": 1465331814,
    "awater": 17900142,
    "countyfp": "013",
    "countyns": "00465196",
    "dotregion": 7,
    "geoid": "19013",
    "lsad": "06",
    "name": "Black Hawk",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1193,
    "affgeoid": "0500000US19015",
    "aland": 1480356901,
    "awater": 5364808,
    "countyfp": "015",
    "countyns": "00465197",
    "dotregion": 7,
    "geoid": "19015",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2294,
    "affgeoid": "0500000US19017",
    "aland": 1127879045,
    "awater": 10172987,
    "countyfp": "017",
    "countyns": "00465198",
    "dotregion": 7,
    "geoid": "19017",
    "lsad": "06",
    "name": "Bremer",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1522,
    "affgeoid": "0500000US19019",
    "aland": 1478934774,
    "awater": 5427659,
    "countyfp": "019",
    "countyns": "00465199",
    "dotregion": 7,
    "geoid": "19019",
    "lsad": "06",
    "name": "Buchanan",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1883,
    "affgeoid": "0500000US19021",
    "aland": 1488989044,
    "awater": 13791664,
    "countyfp": "021",
    "countyns": "00465200",
    "dotregion": 7,
    "geoid": "19021",
    "lsad": "06",
    "name": "Buena Vista",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 878,
    "affgeoid": "0500000US19023",
    "aland": 1502536072,
    "awater": 4209735,
    "countyfp": "023",
    "countyns": "00465201",
    "dotregion": 7,
    "geoid": "19023",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1560,
    "affgeoid": "0500000US19025",
    "aland": 1475895476,
    "awater": 5873828,
    "countyfp": "025",
    "countyns": "00465202",
    "dotregion": 7,
    "geoid": "19025",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 512,
    "affgeoid": "0500000US19027",
    "aland": 1474835090,
    "awater": 2145349,
    "countyfp": "027",
    "countyns": "00465203",
    "dotregion": 7,
    "geoid": "19027",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2592,
    "affgeoid": "0500000US19029",
    "aland": 1461450805,
    "awater": 1758815,
    "countyfp": "029",
    "countyns": "00465204",
    "dotregion": 7,
    "geoid": "19029",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 318,
    "affgeoid": "0500000US19031",
    "aland": 1500730738,
    "awater": 6385842,
    "countyfp": "031",
    "countyns": "00465205",
    "dotregion": 7,
    "geoid": "19031",
    "lsad": "06",
    "name": "Cedar",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 464,
    "affgeoid": "0500000US19033",
    "aland": 1471881729,
    "awater": 17668265,
    "countyfp": "033",
    "countyns": "00465206",
    "dotregion": 7,
    "geoid": "19033",
    "lsad": "06",
    "name": "Cerro Gordo",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 569,
    "affgeoid": "0500000US19035",
    "aland": 1494180445,
    "awater": 423160,
    "countyfp": "035",
    "countyns": "00465207",
    "dotregion": 7,
    "geoid": "19035",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 154,
    "affgeoid": "0500000US19037",
    "aland": 1306338755,
    "awater": 3309323,
    "countyfp": "037",
    "countyns": "00465208",
    "dotregion": 7,
    "geoid": "19037",
    "lsad": "06",
    "name": "Chickasaw",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1661,
    "affgeoid": "0500000US19039",
    "aland": 1116716065,
    "awater": 1524746,
    "countyfp": "039",
    "countyns": "00465209",
    "dotregion": 7,
    "geoid": "19039",
    "lsad": "06",
    "name": "Clarke",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 359,
    "affgeoid": "0500000US19041",
    "aland": 1469139469,
    "awater": 13866649,
    "countyfp": "041",
    "countyns": "00465625",
    "dotregion": 7,
    "geoid": "19041",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1268,
    "affgeoid": "0500000US19043",
    "aland": 2016303676,
    "awater": 36687945,
    "countyfp": "043",
    "countyns": "00465210",
    "dotregion": 7,
    "geoid": "19043",
    "lsad": "06",
    "name": "Clayton",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2527,
    "affgeoid": "0500000US19045",
    "aland": 1799830897,
    "awater": 39514681,
    "countyfp": "045",
    "countyns": "00465211",
    "dotregion": 7,
    "geoid": "19045",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2795,
    "affgeoid": "0500000US19047",
    "aland": 1849742968,
    "awater": 2194272,
    "countyfp": "047",
    "countyns": "00465212",
    "dotregion": 7,
    "geoid": "19047",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 811,
    "affgeoid": "0500000US19049",
    "aland": 1524025934,
    "awater": 8466442,
    "countyfp": "049",
    "countyns": "00465213",
    "dotregion": 7,
    "geoid": "19049",
    "lsad": "06",
    "name": "Dallas",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 241,
    "affgeoid": "0500000US19051",
    "aland": 1300661881,
    "awater": 6904096,
    "countyfp": "051",
    "countyns": "00465214",
    "dotregion": 7,
    "geoid": "19051",
    "lsad": "06",
    "name": "Davis",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 987,
    "affgeoid": "0500000US19053",
    "aland": 1377567359,
    "awater": 4140764,
    "countyfp": "053",
    "countyns": "00465215",
    "dotregion": 7,
    "geoid": "19053",
    "lsad": "06",
    "name": "Decatur",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 958,
    "affgeoid": "0500000US19055",
    "aland": 1496381678,
    "awater": 3082462,
    "countyfp": "055",
    "countyns": "00465216",
    "dotregion": 7,
    "geoid": "19055",
    "lsad": "06",
    "name": "Delaware",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1802,
    "affgeoid": "0500000US19057",
    "aland": 1077714762,
    "awater": 35334208,
    "countyfp": "057",
    "countyns": "00465217",
    "dotregion": 7,
    "geoid": "19057",
    "lsad": "06",
    "name": "Des Moines",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1456,
    "affgeoid": "0500000US19059",
    "aland": 985764407,
    "awater": 60490790,
    "countyfp": "059",
    "countyns": "00465218",
    "dotregion": 7,
    "geoid": "19059",
    "lsad": "06",
    "name": "Dickinson",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2646,
    "affgeoid": "0500000US19061",
    "aland": 1575488097,
    "awater": 21138791,
    "countyfp": "061",
    "countyns": "00465219",
    "dotregion": 7,
    "geoid": "19061",
    "lsad": "06",
    "name": "Dubuque",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 190,
    "affgeoid": "0500000US19063",
    "aland": 1025328493,
    "awater": 17196398,
    "countyfp": "063",
    "countyns": "00465220",
    "dotregion": 7,
    "geoid": "19063",
    "lsad": "06",
    "name": "Emmet",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1650,
    "affgeoid": "0500000US19065",
    "aland": 1892804711,
    "awater": 1320705,
    "countyfp": "065",
    "countyns": "00465221",
    "dotregion": 7,
    "geoid": "19065",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2729,
    "affgeoid": "0500000US19067",
    "aland": 1296631083,
    "awater": 1942548,
    "countyfp": "067",
    "countyns": "00465222",
    "dotregion": 7,
    "geoid": "19067",
    "lsad": "06",
    "name": "Floyd",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 244,
    "affgeoid": "0500000US19069",
    "aland": 1507301130,
    "awater": 1428932,
    "countyfp": "069",
    "countyns": "00465223",
    "dotregion": 7,
    "geoid": "19069",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 848,
    "affgeoid": "0500000US19071",
    "aland": 1323873002,
    "awater": 14214134,
    "countyfp": "071",
    "countyns": "00465224",
    "dotregion": 7,
    "geoid": "19071",
    "lsad": "06",
    "name": "Fremont",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1678,
    "affgeoid": "0500000US19073",
    "aland": 1475183368,
    "awater": 4255552,
    "countyfp": "073",
    "countyns": "00465225",
    "dotregion": 7,
    "geoid": "19073",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1986,
    "affgeoid": "0500000US19075",
    "aland": 1299797760,
    "awater": 94406,
    "countyfp": "075",
    "countyns": "00465226",
    "dotregion": 7,
    "geoid": "19075",
    "lsad": "06",
    "name": "Grundy",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2686,
    "affgeoid": "0500000US19077",
    "aland": 1529698838,
    "awater": 6355533,
    "countyfp": "077",
    "countyns": "00465227",
    "dotregion": 7,
    "geoid": "19077",
    "lsad": "06",
    "name": "Guthrie",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 962,
    "affgeoid": "0500000US19079",
    "aland": 1493776469,
    "awater": 1965341,
    "countyfp": "079",
    "countyns": "00465228",
    "dotregion": 7,
    "geoid": "19079",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2895,
    "affgeoid": "0500000US19081",
    "aland": 1478895000,
    "awater": 5265568,
    "countyfp": "081",
    "countyns": "00465229",
    "dotregion": 7,
    "geoid": "19081",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 897,
    "affgeoid": "0500000US19083",
    "aland": 1474507924,
    "awater": 1773877,
    "countyfp": "083",
    "countyns": "00465230",
    "dotregion": 7,
    "geoid": "19083",
    "lsad": "06",
    "name": "Hardin",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 974,
    "affgeoid": "0500000US19085",
    "aland": 1804808356,
    "awater": 12417701,
    "countyfp": "085",
    "countyns": "00465231",
    "dotregion": 7,
    "geoid": "19085",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1387,
    "affgeoid": "0500000US19087",
    "aland": 1124896597,
    "awater": 5780301,
    "countyfp": "087",
    "countyns": "00465232",
    "dotregion": 7,
    "geoid": "19087",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2836,
    "affgeoid": "0500000US19089",
    "aland": 1225706340,
    "awater": 927963,
    "countyfp": "089",
    "countyns": "00465233",
    "dotregion": 7,
    "geoid": "19089",
    "lsad": "06",
    "name": "Howard",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2499,
    "affgeoid": "0500000US19091",
    "aland": 1124967269,
    "awater": 3406147,
    "countyfp": "091",
    "countyns": "00465234",
    "dotregion": 7,
    "geoid": "19091",
    "lsad": "06",
    "name": "Humboldt",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 131,
    "affgeoid": "0500000US19093",
    "aland": 1117599800,
    "awater": 1406461,
    "countyfp": "093",
    "countyns": "00465235",
    "dotregion": 7,
    "geoid": "19093",
    "lsad": "06",
    "name": "Ida",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 123,
    "affgeoid": "0500000US19095",
    "aland": 1518916016,
    "awater": 2686847,
    "countyfp": "095",
    "countyns": "00465236",
    "dotregion": 7,
    "geoid": "19095",
    "lsad": "06",
    "name": "Iowa",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1741,
    "affgeoid": "0500000US19097",
    "aland": 1647332516,
    "awater": 35141502,
    "countyfp": "097",
    "countyns": "00465237",
    "dotregion": 7,
    "geoid": "19097",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1893,
    "affgeoid": "0500000US19099",
    "aland": 1891773574,
    "awater": 6565706,
    "countyfp": "099",
    "countyns": "00465238",
    "dotregion": 7,
    "geoid": "19099",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2391,
    "affgeoid": "0500000US19101",
    "aland": 1127979900,
    "awater": 3523325,
    "countyfp": "101",
    "countyns": "00465239",
    "dotregion": 7,
    "geoid": "19101",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 944,
    "affgeoid": "0500000US19103",
    "aland": 1590355508,
    "awater": 23595209,
    "countyfp": "103",
    "countyns": "00465240",
    "dotregion": 7,
    "geoid": "19103",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1864,
    "affgeoid": "0500000US19105",
    "aland": 1490850795,
    "awater": 3582589,
    "countyfp": "105",
    "countyns": "00465241",
    "dotregion": 7,
    "geoid": "19105",
    "lsad": "06",
    "name": "Jones",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1056,
    "affgeoid": "0500000US19107",
    "aland": 1500067251,
    "awater": 1929323,
    "countyfp": "107",
    "countyns": "00465242",
    "dotregion": 7,
    "geoid": "19107",
    "lsad": "06",
    "name": "Keokuk",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 139,
    "affgeoid": "0500000US19109",
    "aland": 2519361801,
    "awater": 4125592,
    "countyfp": "109",
    "countyns": "00465243",
    "dotregion": 7,
    "geoid": "19109",
    "lsad": "06",
    "name": "Kossuth",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1158,
    "affgeoid": "0500000US19111",
    "aland": 1340377291,
    "awater": 55290807,
    "countyfp": "111",
    "countyns": "00465244",
    "dotregion": 7,
    "geoid": "19111",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 997,
    "affgeoid": "0500000US19113",
    "aland": 1856718344,
    "awater": 19740334,
    "countyfp": "113",
    "countyns": "00465245",
    "dotregion": 7,
    "geoid": "19113",
    "lsad": "06",
    "name": "Linn",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1641,
    "affgeoid": "0500000US19115",
    "aland": 1040583104,
    "awater": 40784329,
    "countyfp": "115",
    "countyns": "00465246",
    "dotregion": 7,
    "geoid": "19115",
    "lsad": "06",
    "name": "Louisa",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1944,
    "affgeoid": "0500000US19117",
    "aland": 1115257710,
    "awater": 9852833,
    "countyfp": "117",
    "countyns": "00465247",
    "dotregion": 7,
    "geoid": "19117",
    "lsad": "06",
    "name": "Lucas",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 724,
    "affgeoid": "0500000US19119",
    "aland": 1522007061,
    "awater": 334465,
    "countyfp": "119",
    "countyns": "00465248",
    "dotregion": 7,
    "geoid": "19119",
    "lsad": "06",
    "name": "Lyon",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2119,
    "affgeoid": "0500000US19121",
    "aland": 1452999201,
    "awater": 2983840,
    "countyfp": "121",
    "countyns": "00465249",
    "dotregion": 7,
    "geoid": "19121",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1711,
    "affgeoid": "0500000US19123",
    "aland": 1478527868,
    "awater": 6564804,
    "countyfp": "123",
    "countyns": "00465250",
    "dotregion": 7,
    "geoid": "19123",
    "lsad": "06",
    "name": "Mahaska",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 592,
    "affgeoid": "0500000US19125",
    "aland": 1436252823,
    "awater": 41358358,
    "countyfp": "125",
    "countyns": "00465251",
    "dotregion": 7,
    "geoid": "19125",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2075,
    "affgeoid": "0500000US19127",
    "aland": 1482776067,
    "awater": 1803080,
    "countyfp": "127",
    "countyns": "00465252",
    "dotregion": 7,
    "geoid": "19127",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1488,
    "affgeoid": "0500000US19129",
    "aland": 1132950326,
    "awater": 8306492,
    "countyfp": "129",
    "countyns": "00465253",
    "dotregion": 7,
    "geoid": "19129",
    "lsad": "06",
    "name": "Mills",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1759,
    "affgeoid": "0500000US19131",
    "aland": 1215049037,
    "awater": 1118416,
    "countyfp": "131",
    "countyns": "00465254",
    "dotregion": 7,
    "geoid": "19131",
    "lsad": "06",
    "name": "Mitchell",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2228,
    "affgeoid": "0500000US19133",
    "aland": 1797637863,
    "awater": 12592242,
    "countyfp": "133",
    "countyns": "00465255",
    "dotregion": 7,
    "geoid": "19133",
    "lsad": "06",
    "name": "Monona",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1808,
    "affgeoid": "0500000US19135",
    "aland": 1123317229,
    "awater": 1522790,
    "countyfp": "135",
    "countyns": "00465256",
    "dotregion": 7,
    "geoid": "19135",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2902,
    "affgeoid": "0500000US19137",
    "aland": 1098405694,
    "awater": 2410445,
    "countyfp": "137",
    "countyns": "00465257",
    "dotregion": 7,
    "geoid": "19137",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2072,
    "affgeoid": "0500000US19139",
    "aland": 1132986201,
    "awater": 30253390,
    "countyfp": "139",
    "countyns": "00465258",
    "dotregion": 7,
    "geoid": "19139",
    "lsad": "06",
    "name": "Muscatine",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 146,
    "affgeoid": "0500000US19141",
    "aland": 1484154164,
    "awater": 447448,
    "countyfp": "141",
    "countyns": "00465259",
    "dotregion": 7,
    "geoid": "19141",
    "lsad": "06",
    "name": "O'Brien",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 483,
    "affgeoid": "0500000US19143",
    "aland": 1032593827,
    "awater": 1835265,
    "countyfp": "143",
    "countyns": "00465260",
    "dotregion": 7,
    "geoid": "19143",
    "lsad": "06",
    "name": "Osceola",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1217,
    "affgeoid": "0500000US19145",
    "aland": 1385497562,
    "awater": 1359120,
    "countyfp": "145",
    "countyns": "00465261",
    "dotregion": 7,
    "geoid": "19145",
    "lsad": "06",
    "name": "Page",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 505,
    "affgeoid": "0500000US19147",
    "aland": 1460349236,
    "awater": 14480046,
    "countyfp": "147",
    "countyns": "00465262",
    "dotregion": 7,
    "geoid": "19147",
    "lsad": "06",
    "name": "Palo Alto",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1024,
    "affgeoid": "0500000US19149",
    "aland": 2234715168,
    "awater": 2176851,
    "countyfp": "149",
    "countyns": "00465263",
    "dotregion": 7,
    "geoid": "19149",
    "lsad": "06",
    "name": "Plymouth",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 509,
    "affgeoid": "0500000US19151",
    "aland": 1495047132,
    "awater": 3666526,
    "countyfp": "151",
    "countyns": "00465264",
    "dotregion": 7,
    "geoid": "19151",
    "lsad": "06",
    "name": "Pocahontas",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2117,
    "affgeoid": "0500000US19153",
    "aland": 1485563114,
    "awater": 46504048,
    "countyfp": "153",
    "countyns": "00465265",
    "dotregion": 7,
    "geoid": "19153",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1090,
    "affgeoid": "0500000US19155",
    "aland": 2461943632,
    "awater": 22221146,
    "countyfp": "155",
    "countyns": "00465266",
    "dotregion": 7,
    "geoid": "19155",
    "lsad": "06",
    "name": "Pottawattamie",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2116,
    "affgeoid": "0500000US19157",
    "aland": 1514929487,
    "awater": 2977605,
    "countyfp": "157",
    "countyns": "00465267",
    "dotregion": 7,
    "geoid": "19157",
    "lsad": "06",
    "name": "Poweshiek",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 147,
    "affgeoid": "0500000US19159",
    "aland": 1386934325,
    "awater": 8721169,
    "countyfp": "159",
    "countyns": "00465268",
    "dotregion": 7,
    "geoid": "19159",
    "lsad": "06",
    "name": "Ringgold",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 460,
    "affgeoid": "0500000US19161",
    "aland": 1489300179,
    "awater": 8569441,
    "countyfp": "161",
    "countyns": "00465269",
    "dotregion": 7,
    "geoid": "19161",
    "lsad": "06",
    "name": "Sac",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1165,
    "affgeoid": "0500000US19163",
    "aland": 1186445449,
    "awater": 26214593,
    "countyfp": "163",
    "countyns": "00465270",
    "dotregion": 7,
    "geoid": "19163",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 439,
    "affgeoid": "0500000US19165",
    "aland": 1530110538,
    "awater": 1486125,
    "countyfp": "165",
    "countyns": "00465271",
    "dotregion": 7,
    "geoid": "19165",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1733,
    "affgeoid": "0500000US19167",
    "aland": 1988761281,
    "awater": 2921071,
    "countyfp": "167",
    "countyns": "00465272",
    "dotregion": 7,
    "geoid": "19167",
    "lsad": "06",
    "name": "Sioux",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 148,
    "affgeoid": "0500000US19169",
    "aland": 1483235260,
    "awater": 2509634,
    "countyfp": "169",
    "countyns": "00465273",
    "dotregion": 7,
    "geoid": "19169",
    "lsad": "06",
    "name": "Story",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1190,
    "affgeoid": "0500000US19171",
    "aland": 1867411153,
    "awater": 2769421,
    "countyfp": "171",
    "countyns": "00465274",
    "dotregion": 7,
    "geoid": "19171",
    "lsad": "06",
    "name": "Tama",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2413,
    "affgeoid": "0500000US19173",
    "aland": 1377618828,
    "awater": 7133364,
    "countyfp": "173",
    "countyns": "00465275",
    "dotregion": 7,
    "geoid": "19173",
    "lsad": "06",
    "name": "Taylor",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 41,
    "affgeoid": "0500000US19175",
    "aland": 1097235771,
    "awater": 5575853,
    "countyfp": "175",
    "countyns": "00465276",
    "dotregion": 7,
    "geoid": "19175",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1128,
    "affgeoid": "0500000US19177",
    "aland": 1255597360,
    "awater": 14839917,
    "countyfp": "177",
    "countyns": "00465277",
    "dotregion": 7,
    "geoid": "19177",
    "lsad": "06",
    "name": "Van Buren",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 149,
    "affgeoid": "0500000US19179",
    "aland": 1118460313,
    "awater": 10829143,
    "countyfp": "179",
    "countyns": "00465278",
    "dotregion": 7,
    "geoid": "19179",
    "lsad": "06",
    "name": "Wapello",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1524,
    "affgeoid": "0500000US19181",
    "aland": 1475844940,
    "awater": 9125342,
    "countyfp": "181",
    "countyns": "00465279",
    "dotregion": 7,
    "geoid": "19181",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 2744,
    "affgeoid": "0500000US19183",
    "aland": 1473322601,
    "awater": 5353718,
    "countyfp": "183",
    "countyns": "00465280",
    "dotregion": 7,
    "geoid": "19183",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 457,
    "affgeoid": "0500000US19185",
    "aland": 1360940441,
    "awater": 4347639,
    "countyfp": "185",
    "countyns": "00465281",
    "dotregion": 7,
    "geoid": "19185",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 114,
    "affgeoid": "0500000US19187",
    "aland": 1853443705,
    "awater": 7277624,
    "countyfp": "187",
    "countyns": "00465282",
    "dotregion": 7,
    "geoid": "19187",
    "lsad": "06",
    "name": "Webster",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1547,
    "affgeoid": "0500000US19189",
    "aland": 1037261948,
    "awater": 3182052,
    "countyfp": "189",
    "countyns": "00465283",
    "dotregion": 7,
    "geoid": "19189",
    "lsad": "06",
    "name": "Winnebago",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 449,
    "affgeoid": "0500000US19191",
    "aland": 1786750039,
    "awater": 698598,
    "countyfp": "191",
    "countyns": "00465284",
    "dotregion": 7,
    "geoid": "19191",
    "lsad": "06",
    "name": "Winneshiek",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 1990,
    "affgeoid": "0500000US19193",
    "aland": 2260791000,
    "awater": 12793693,
    "countyfp": "193",
    "countyns": "00465285",
    "dotregion": 7,
    "geoid": "19193",
    "lsad": "06",
    "name": "Woodbury",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 193,
    "affgeoid": "0500000US19195",
    "aland": 1036314932,
    "awater": 4709127,
    "countyfp": "195",
    "countyns": "00465286",
    "dotregion": 7,
    "geoid": "19195",
    "lsad": "06",
    "name": "Worth",
    "stateAbbreviation": "IA",
    "stateId": 22
  }, {
    "id": 310,
    "affgeoid": "0500000US19197",
    "aland": 1503286986,
    "awater": 4703964,
    "countyfp": "197",
    "countyns": "00465287",
    "dotregion": 7,
    "geoid": "19197",
    "lsad": "06",
    "name": "Wright",
    "stateAbbreviation": "IA",
    "stateId": 22
  }]
}, {
  "id": 48,
  "abbreviation": "KS",
  "affgeoid": "0400000US20",
  "aland": 211752682810,
  "awater": 1346896791,
  "dotregion": 7,
  "geoid": "20",
  "lsad": "00",
  "name": "Kansas",
  "stateAbbreviation": "KS",
  "statefp": "20",
  "statens": "00481813",
  "counties": [{
    "id": 954,
    "affgeoid": "0500000US20001",
    "aland": 1295778918,
    "awater": 13007243,
    "countyfp": "001",
    "countyns": "00484970",
    "dotregion": 7,
    "geoid": "20001",
    "lsad": "06",
    "name": "Allen",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2357,
    "affgeoid": "0500000US20003",
    "aland": 1501277202,
    "awater": 10586462,
    "countyfp": "003",
    "countyns": "00484971",
    "dotregion": 7,
    "geoid": "20003",
    "lsad": "06",
    "name": "Anderson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 234,
    "affgeoid": "0500000US20005",
    "aland": 1116730109,
    "awater": 6857567,
    "countyfp": "005",
    "countyns": "00484972",
    "dotregion": 7,
    "geoid": "20005",
    "lsad": "06",
    "name": "Atchison",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 753,
    "affgeoid": "0500000US20007",
    "aland": 2937251506,
    "awater": 5403867,
    "countyfp": "007",
    "countyns": "00484973",
    "dotregion": 7,
    "geoid": "20007",
    "lsad": "06",
    "name": "Barber",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2469,
    "affgeoid": "0500000US20009",
    "aland": 2319076868,
    "awater": 13555398,
    "countyfp": "009",
    "countyns": "00484974",
    "dotregion": 7,
    "geoid": "20009",
    "lsad": "06",
    "name": "Barton",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 293,
    "affgeoid": "0500000US20011",
    "aland": 1645861839,
    "awater": 9377657,
    "countyfp": "011",
    "countyns": "00484975",
    "dotregion": 7,
    "geoid": "20011",
    "lsad": "06",
    "name": "Bourbon",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 220,
    "affgeoid": "0500000US20013",
    "aland": 1478552720,
    "awater": 3196147,
    "countyfp": "013",
    "countyns": "00484976",
    "dotregion": 7,
    "geoid": "20013",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 107,
    "affgeoid": "0500000US20015",
    "aland": 3703340014,
    "awater": 43150097,
    "countyfp": "015",
    "countyns": "00484977",
    "dotregion": 7,
    "geoid": "20015",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1474,
    "affgeoid": "0500000US20017",
    "aland": 2002216770,
    "awater": 12087996,
    "countyfp": "017",
    "countyns": "00484978",
    "dotregion": 7,
    "geoid": "20017",
    "lsad": "06",
    "name": "Chase",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 531,
    "affgeoid": "0500000US20019",
    "aland": 1654693848,
    "awater": 15243783,
    "countyfp": "019",
    "countyns": "00484979",
    "dotregion": 7,
    "geoid": "20019",
    "lsad": "06",
    "name": "Chautauqua",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 3057,
    "affgeoid": "0500000US20021",
    "aland": 1521793566,
    "awater": 8948924,
    "countyfp": "021",
    "countyns": "00484980",
    "dotregion": 7,
    "geoid": "20021",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2130,
    "affgeoid": "0500000US20023",
    "aland": 2641501925,
    "awater": 2738021,
    "countyfp": "023",
    "countyns": "00484981",
    "dotregion": 7,
    "geoid": "20023",
    "lsad": "06",
    "name": "Cheyenne",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2186,
    "affgeoid": "0500000US20025",
    "aland": 2524286233,
    "awater": 6604959,
    "countyfp": "025",
    "countyns": "00484982",
    "dotregion": 7,
    "geoid": "20025",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 529,
    "affgeoid": "0500000US20027",
    "aland": 1671328254,
    "awater": 26673841,
    "countyfp": "027",
    "countyns": "00484983",
    "dotregion": 7,
    "geoid": "20027",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 167,
    "affgeoid": "0500000US20029",
    "aland": 1852726621,
    "awater": 6859887,
    "countyfp": "029",
    "countyns": "00484984",
    "dotregion": 7,
    "geoid": "20029",
    "lsad": "06",
    "name": "Cloud",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 983,
    "affgeoid": "0500000US20031",
    "aland": 1623643199,
    "awater": 70451643,
    "countyfp": "031",
    "countyns": "00484985",
    "dotregion": 7,
    "geoid": "20031",
    "lsad": "06",
    "name": "Coffey",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 707,
    "affgeoid": "0500000US20033",
    "aland": 2041681125,
    "awater": 3604153,
    "countyfp": "033",
    "countyns": "00484986",
    "dotregion": 7,
    "geoid": "20033",
    "lsad": "06",
    "name": "Comanche",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1459,
    "affgeoid": "0500000US20035",
    "aland": 2915656992,
    "awater": 17314108,
    "countyfp": "035",
    "countyns": "00484987",
    "dotregion": 7,
    "geoid": "20035",
    "lsad": "06",
    "name": "Cowley",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 187,
    "affgeoid": "0500000US20037",
    "aland": 1527463434,
    "awater": 13609426,
    "countyfp": "037",
    "countyns": "00484988",
    "dotregion": 7,
    "geoid": "20037",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 892,
    "affgeoid": "0500000US20039",
    "aland": 2314199312,
    "awater": 1631670,
    "countyfp": "039",
    "countyns": "00484989",
    "dotregion": 7,
    "geoid": "20039",
    "lsad": "06",
    "name": "Decatur",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 408,
    "affgeoid": "0500000US20041",
    "aland": 2193892430,
    "awater": 12634272,
    "countyfp": "041",
    "countyns": "00484990",
    "dotregion": 7,
    "geoid": "20041",
    "lsad": "06",
    "name": "Dickinson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2446,
    "affgeoid": "0500000US20043",
    "aland": 1018914915,
    "awater": 12614908,
    "countyfp": "043",
    "countyns": "00484991",
    "dotregion": 7,
    "geoid": "20043",
    "lsad": "06",
    "name": "Doniphan",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1469,
    "affgeoid": "0500000US20045",
    "aland": 1180720703,
    "awater": 48581683,
    "countyfp": "045",
    "countyns": "00484992",
    "dotregion": 7,
    "geoid": "20045",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1508,
    "affgeoid": "0500000US20047",
    "aland": 1610699190,
    "awater": 206413,
    "countyfp": "047",
    "countyns": "00484993",
    "dotregion": 7,
    "geoid": "20047",
    "lsad": "06",
    "name": "Edwards",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 191,
    "affgeoid": "0500000US20049",
    "aland": 1668638185,
    "awater": 16061128,
    "countyfp": "049",
    "countyns": "00484994",
    "dotregion": 7,
    "geoid": "20049",
    "lsad": "06",
    "name": "Elk",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2875,
    "affgeoid": "0500000US20051",
    "aland": 2330762263,
    "awater": 1197085,
    "countyfp": "051",
    "countyns": "00484995",
    "dotregion": 7,
    "geoid": "20051",
    "lsad": "06",
    "name": "Ellis",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2546,
    "affgeoid": "0500000US20053",
    "aland": 1854030766,
    "awater": 19270049,
    "countyfp": "053",
    "countyns": "00484996",
    "dotregion": 7,
    "geoid": "20053",
    "lsad": "06",
    "name": "Ellsworth",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1228,
    "affgeoid": "0500000US20055",
    "aland": 3372118248,
    "awater": 1794398,
    "countyfp": "055",
    "countyns": "00485326",
    "dotregion": 7,
    "geoid": "20055",
    "lsad": "06",
    "name": "Finney",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1912,
    "affgeoid": "0500000US20057",
    "aland": 2844508241,
    "awater": 2097359,
    "countyfp": "057",
    "countyns": "00484997",
    "dotregion": 7,
    "geoid": "20057",
    "lsad": "06",
    "name": "Ford",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 145,
    "affgeoid": "0500000US20059",
    "aland": 1480858186,
    "awater": 13918274,
    "countyfp": "059",
    "countyns": "00484998",
    "dotregion": 7,
    "geoid": "20059",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 478,
    "affgeoid": "0500000US20061",
    "aland": 996162685,
    "awater": 51451918,
    "countyfp": "061",
    "countyns": "00484999",
    "dotregion": 7,
    "geoid": "20061",
    "lsad": "06",
    "name": "Geary",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 702,
    "affgeoid": "0500000US20063",
    "aland": 2775599149,
    "awater": 245369,
    "countyfp": "063",
    "countyns": "00485000",
    "dotregion": 7,
    "geoid": "20063",
    "lsad": "06",
    "name": "Gove",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 323,
    "affgeoid": "0500000US20065",
    "aland": 2327173519,
    "awater": 599356,
    "countyfp": "065",
    "countyns": "00481811",
    "dotregion": 7,
    "geoid": "20065",
    "lsad": "06",
    "name": "Graham",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 703,
    "affgeoid": "0500000US20067",
    "aland": 1488724887,
    "awater": 892323,
    "countyfp": "067",
    "countyns": "00485099",
    "dotregion": 7,
    "geoid": "20067",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1676,
    "affgeoid": "0500000US20069",
    "aland": 2250356168,
    "awater": 1113338,
    "countyfp": "069",
    "countyns": "00485001",
    "dotregion": 7,
    "geoid": "20069",
    "lsad": "06",
    "name": "Gray",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 344,
    "affgeoid": "0500000US20071",
    "aland": 2016057984,
    "awater": 0,
    "countyfp": "071",
    "countyns": "00485002",
    "dotregion": 7,
    "geoid": "20071",
    "lsad": "06",
    "name": "Greeley",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1453,
    "affgeoid": "0500000US20073",
    "aland": 2961133007,
    "awater": 24155643,
    "countyfp": "073",
    "countyns": "00485003",
    "dotregion": 7,
    "geoid": "20073",
    "lsad": "06",
    "name": "Greenwood",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 36,
    "affgeoid": "0500000US20075",
    "aland": 2580947447,
    "awater": 2904549,
    "countyfp": "075",
    "countyns": "00485327",
    "dotregion": 7,
    "geoid": "20075",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2311,
    "affgeoid": "0500000US20077",
    "aland": 2075276144,
    "awater": 3913474,
    "countyfp": "077",
    "countyns": "00485004",
    "dotregion": 7,
    "geoid": "20077",
    "lsad": "06",
    "name": "Harper",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 489,
    "affgeoid": "0500000US20079",
    "aland": 1397961197,
    "awater": 2503283,
    "countyfp": "079",
    "countyns": "00485005",
    "dotregion": 7,
    "geoid": "20079",
    "lsad": "06",
    "name": "Harvey",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1482,
    "affgeoid": "0500000US20081",
    "aland": 1495773052,
    "awater": 910409,
    "countyfp": "081",
    "countyns": "00485328",
    "dotregion": 7,
    "geoid": "20081",
    "lsad": "06",
    "name": "Haskell",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2265,
    "affgeoid": "0500000US20083",
    "aland": 2227369160,
    "awater": 826344,
    "countyfp": "083",
    "countyns": "00485006",
    "dotregion": 7,
    "geoid": "20083",
    "lsad": "06",
    "name": "Hodgeman",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 3058,
    "affgeoid": "0500000US20085",
    "aland": 1699600369,
    "awater": 4666514,
    "countyfp": "085",
    "countyns": "00485007",
    "dotregion": 7,
    "geoid": "20085",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1187,
    "affgeoid": "0500000US20087",
    "aland": 1379361374,
    "awater": 62426286,
    "countyfp": "087",
    "countyns": "00485008",
    "dotregion": 7,
    "geoid": "20087",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1581,
    "affgeoid": "0500000US20089",
    "aland": 2356321281,
    "awater": 11859451,
    "countyfp": "089",
    "countyns": "00485009",
    "dotregion": 7,
    "geoid": "20089",
    "lsad": "06",
    "name": "Jewell",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2095,
    "affgeoid": "0500000US20091",
    "aland": 1226234393,
    "awater": 16691945,
    "countyfp": "091",
    "countyns": "00485010",
    "dotregion": 7,
    "geoid": "20091",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 474,
    "affgeoid": "0500000US20093",
    "aland": 2254696586,
    "awater": 1133601,
    "countyfp": "093",
    "countyns": "00485011",
    "dotregion": 7,
    "geoid": "20093",
    "lsad": "06",
    "name": "Kearny",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2549,
    "affgeoid": "0500000US20095",
    "aland": 2236099555,
    "awater": 8536500,
    "countyfp": "095",
    "countyns": "00485012",
    "dotregion": 7,
    "geoid": "20095",
    "lsad": "06",
    "name": "Kingman",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 593,
    "affgeoid": "0500000US20097",
    "aland": 1871626651,
    "awater": 596764,
    "countyfp": "097",
    "countyns": "00485013",
    "dotregion": 7,
    "geoid": "20097",
    "lsad": "06",
    "name": "Kiowa",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 239,
    "affgeoid": "0500000US20099",
    "aland": 1671305806,
    "awater": 20261080,
    "countyfp": "099",
    "countyns": "00485014",
    "dotregion": 7,
    "geoid": "20099",
    "lsad": "06",
    "name": "Labette",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 324,
    "affgeoid": "0500000US20101",
    "aland": 1858093492,
    "awater": 551220,
    "countyfp": "101",
    "countyns": "00485015",
    "dotregion": 7,
    "geoid": "20101",
    "lsad": "06",
    "name": "Lane",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2826,
    "affgeoid": "0500000US20103",
    "aland": 1198762670,
    "awater": 15869351,
    "countyfp": "103",
    "countyns": "00485016",
    "dotregion": 7,
    "geoid": "20103",
    "lsad": "06",
    "name": "Leavenworth",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 311,
    "affgeoid": "0500000US20105",
    "aland": 1863226676,
    "awater": 2748359,
    "countyfp": "105",
    "countyns": "00485017",
    "dotregion": 7,
    "geoid": "20105",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 877,
    "affgeoid": "0500000US20107",
    "aland": 1538618893,
    "awater": 31937036,
    "countyfp": "107",
    "countyns": "00485018",
    "dotregion": 7,
    "geoid": "20107",
    "lsad": "06",
    "name": "Linn",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1777,
    "affgeoid": "0500000US20109",
    "aland": 2779042518,
    "awater": 274632,
    "countyfp": "109",
    "countyns": "00485019",
    "dotregion": 7,
    "geoid": "20109",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 585,
    "affgeoid": "0500000US20111",
    "aland": 2194958185,
    "awater": 20561715,
    "countyfp": "111",
    "countyns": "00485020",
    "dotregion": 7,
    "geoid": "20111",
    "lsad": "06",
    "name": "Lyon",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1458,
    "affgeoid": "0500000US20115",
    "aland": 2445701271,
    "awater": 24448816,
    "countyfp": "115",
    "countyns": "00485022",
    "dotregion": 7,
    "geoid": "20115",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 412,
    "affgeoid": "0500000US20117",
    "aland": 2331449973,
    "awater": 12753730,
    "countyfp": "117",
    "countyns": "00485023",
    "dotregion": 7,
    "geoid": "20117",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2167,
    "affgeoid": "0500000US20113",
    "aland": 2326520576,
    "awater": 6030190,
    "countyfp": "113",
    "countyns": "00485021",
    "dotregion": 7,
    "geoid": "20113",
    "lsad": "06",
    "name": "McPherson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2284,
    "affgeoid": "0500000US20119",
    "aland": 2533234398,
    "awater": 3258258,
    "countyfp": "119",
    "countyns": "00485024",
    "dotregion": 7,
    "geoid": "20119",
    "lsad": "06",
    "name": "Meade",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2096,
    "affgeoid": "0500000US20121",
    "aland": 1490957045,
    "awater": 37798210,
    "countyfp": "121",
    "countyns": "00485025",
    "dotregion": 7,
    "geoid": "20121",
    "lsad": "06",
    "name": "Miami",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2553,
    "affgeoid": "0500000US20123",
    "aland": 1817632928,
    "awater": 44979981,
    "countyfp": "123",
    "countyns": "00485026",
    "dotregion": 7,
    "geoid": "20123",
    "lsad": "06",
    "name": "Mitchell",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 695,
    "affgeoid": "0500000US20125",
    "aland": 1666728644,
    "awater": 20601461,
    "countyfp": "125",
    "countyns": "00485027",
    "dotregion": 7,
    "geoid": "20125",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2101,
    "affgeoid": "0500000US20127",
    "aland": 1800764521,
    "awater": 19710513,
    "countyfp": "127",
    "countyns": "00485028",
    "dotregion": 7,
    "geoid": "20127",
    "lsad": "06",
    "name": "Morris",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1618,
    "affgeoid": "0500000US20129",
    "aland": 1889988362,
    "awater": 507796,
    "countyfp": "129",
    "countyns": "00485135",
    "dotregion": 7,
    "geoid": "20129",
    "lsad": "06",
    "name": "Morton",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 3111,
    "affgeoid": "0500000US20131",
    "aland": 1858124408,
    "awater": 5208990,
    "countyfp": "131",
    "countyns": "00485029",
    "dotregion": 7,
    "geoid": "20131",
    "lsad": "06",
    "name": "Nemaha",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1786,
    "affgeoid": "0500000US20133",
    "aland": 1480106508,
    "awater": 16374123,
    "countyfp": "133",
    "countyns": "00485030",
    "dotregion": 7,
    "geoid": "20133",
    "lsad": "06",
    "name": "Neosho",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1764,
    "affgeoid": "0500000US20135",
    "aland": 2783590403,
    "awater": 667491,
    "countyfp": "135",
    "countyns": "00485031",
    "dotregion": 7,
    "geoid": "20135",
    "lsad": "06",
    "name": "Ness",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 100,
    "affgeoid": "0500000US20137",
    "aland": 2274122701,
    "awater": 8421464,
    "countyfp": "137",
    "countyns": "00485032",
    "dotregion": 7,
    "geoid": "20137",
    "lsad": "06",
    "name": "Norton",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 245,
    "affgeoid": "0500000US20139",
    "aland": 1827283237,
    "awater": 37107138,
    "countyfp": "139",
    "countyns": "00485033",
    "dotregion": 7,
    "geoid": "20139",
    "lsad": "06",
    "name": "Osage",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2597,
    "affgeoid": "0500000US20141",
    "aland": 2311575395,
    "awater": 4806274,
    "countyfp": "141",
    "countyns": "00485034",
    "dotregion": 7,
    "geoid": "20141",
    "lsad": "06",
    "name": "Osborne",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1511,
    "affgeoid": "0500000US20143",
    "aland": 1866689484,
    "awater": 1561331,
    "countyfp": "143",
    "countyns": "00485035",
    "dotregion": 7,
    "geoid": "20143",
    "lsad": "06",
    "name": "Ottawa",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2080,
    "affgeoid": "0500000US20145",
    "aland": 1953531683,
    "awater": 992041,
    "countyfp": "145",
    "countyns": "00485036",
    "dotregion": 7,
    "geoid": "20145",
    "lsad": "06",
    "name": "Pawnee",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 171,
    "affgeoid": "0500000US20147",
    "aland": 2294398019,
    "awater": 22493382,
    "countyfp": "147",
    "countyns": "00485037",
    "dotregion": 7,
    "geoid": "20147",
    "lsad": "06",
    "name": "Phillips",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 882,
    "affgeoid": "0500000US20149",
    "aland": 2178231530,
    "awater": 54102536,
    "countyfp": "149",
    "countyns": "00485038",
    "dotregion": 7,
    "geoid": "20149",
    "lsad": "06",
    "name": "Pottawatomie",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 570,
    "affgeoid": "0500000US20151",
    "aland": 1903738841,
    "awater": 1772008,
    "countyfp": "151",
    "countyns": "00485039",
    "dotregion": 7,
    "geoid": "20151",
    "lsad": "06",
    "name": "Pratt",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2100,
    "affgeoid": "0500000US20153",
    "aland": 2769775729,
    "awater": 415527,
    "countyfp": "153",
    "countyns": "00485040",
    "dotregion": 7,
    "geoid": "20153",
    "lsad": "06",
    "name": "Rawlins",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 880,
    "affgeoid": "0500000US20155",
    "aland": 3251332271,
    "awater": 43417478,
    "countyfp": "155",
    "countyns": "00485041",
    "dotregion": 7,
    "geoid": "20155",
    "lsad": "06",
    "name": "Reno",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1649,
    "affgeoid": "0500000US20157",
    "aland": 1857983298,
    "awater": 7966959,
    "countyfp": "157",
    "countyns": "00485042",
    "dotregion": 7,
    "geoid": "20157",
    "lsad": "06",
    "name": "Republic",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1434,
    "affgeoid": "0500000US20159",
    "aland": 1880933851,
    "awater": 4484689,
    "countyfp": "159",
    "countyns": "00485043",
    "dotregion": 7,
    "geoid": "20159",
    "lsad": "06",
    "name": "Rice",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1044,
    "affgeoid": "0500000US20161",
    "aland": 1579317982,
    "awater": 31537411,
    "countyfp": "161",
    "countyns": "00485044",
    "dotregion": 7,
    "geoid": "20161",
    "lsad": "06",
    "name": "Riley",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 92,
    "affgeoid": "0500000US20163",
    "aland": 2306481663,
    "awater": 11962259,
    "countyfp": "163",
    "countyns": "00485045",
    "dotregion": 7,
    "geoid": "20163",
    "lsad": "06",
    "name": "Rooks",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 603,
    "affgeoid": "0500000US20165",
    "aland": 1858997545,
    "awater": 544720,
    "countyfp": "165",
    "countyns": "00485358",
    "dotregion": 7,
    "geoid": "20165",
    "lsad": "06",
    "name": "Rush",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1588,
    "affgeoid": "0500000US20167",
    "aland": 2295402918,
    "awater": 34126777,
    "countyfp": "167",
    "countyns": "00485046",
    "dotregion": 7,
    "geoid": "20167",
    "lsad": "06",
    "name": "Russell",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 395,
    "affgeoid": "0500000US20169",
    "aland": 1865381415,
    "awater": 2809966,
    "countyfp": "169",
    "countyns": "00485047",
    "dotregion": 7,
    "geoid": "20169",
    "lsad": "06",
    "name": "Saline",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1959,
    "affgeoid": "0500000US20171",
    "aland": 1858536845,
    "awater": 306079,
    "countyfp": "171",
    "countyns": "00485048",
    "dotregion": 7,
    "geoid": "20171",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1008,
    "affgeoid": "0500000US20173",
    "aland": 2583572692,
    "awater": 30038008,
    "countyfp": "173",
    "countyns": "00485049",
    "dotregion": 7,
    "geoid": "20173",
    "lsad": "06",
    "name": "Sedgwick",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1,
    "affgeoid": "0500000US20175",
    "aland": 1655865960,
    "awater": 2777350,
    "countyfp": "175",
    "countyns": "00485050",
    "dotregion": 7,
    "geoid": "20175",
    "lsad": "06",
    "name": "Seward",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1801,
    "affgeoid": "0500000US20177",
    "aland": 1409000695,
    "awater": 30325984,
    "countyfp": "177",
    "countyns": "00485051",
    "dotregion": 7,
    "geoid": "20177",
    "lsad": "06",
    "name": "Shawnee",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1411,
    "affgeoid": "0500000US20179",
    "aland": 2320518302,
    "awater": 647342,
    "countyfp": "179",
    "countyns": "00485052",
    "dotregion": 7,
    "geoid": "20179",
    "lsad": "06",
    "name": "Sheridan",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1745,
    "affgeoid": "0500000US20181",
    "aland": 2735193469,
    "awater": 548248,
    "countyfp": "181",
    "countyns": "00485053",
    "dotregion": 7,
    "geoid": "20181",
    "lsad": "06",
    "name": "Sherman",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 972,
    "affgeoid": "0500000US20183",
    "aland": 2319241842,
    "awater": 3884267,
    "countyfp": "183",
    "countyns": "00484969",
    "dotregion": 7,
    "geoid": "20183",
    "lsad": "06",
    "name": "Smith",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 452,
    "affgeoid": "0500000US20185",
    "aland": 2051389760,
    "awater": 7435417,
    "countyfp": "185",
    "countyns": "00485054",
    "dotregion": 7,
    "geoid": "20185",
    "lsad": "06",
    "name": "Stafford",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2977,
    "affgeoid": "0500000US20187",
    "aland": 1762104517,
    "awater": 178555,
    "countyfp": "187",
    "countyns": "00485055",
    "dotregion": 7,
    "geoid": "20187",
    "lsad": "06",
    "name": "Stanton",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 19,
    "affgeoid": "0500000US20189",
    "aland": 1883604192,
    "awater": 464936,
    "countyfp": "189",
    "countyns": "00485056",
    "dotregion": 7,
    "geoid": "20189",
    "lsad": "06",
    "name": "Stevens",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2837,
    "affgeoid": "0500000US20191",
    "aland": 3060391148,
    "awater": 8627526,
    "countyfp": "191",
    "countyns": "00481812",
    "dotregion": 7,
    "geoid": "20191",
    "lsad": "06",
    "name": "Sumner",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 81,
    "affgeoid": "0500000US20193",
    "aland": 2783425155,
    "awater": 288241,
    "countyfp": "193",
    "countyns": "00485057",
    "dotregion": 7,
    "geoid": "20193",
    "lsad": "06",
    "name": "Thomas",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 50,
    "affgeoid": "0500000US20195",
    "aland": 2303731641,
    "awater": 26281951,
    "countyfp": "195",
    "countyns": "00485058",
    "dotregion": 7,
    "geoid": "20195",
    "lsad": "06",
    "name": "Trego",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2941,
    "affgeoid": "0500000US20197",
    "aland": 2057225072,
    "awater": 13781477,
    "countyfp": "197",
    "countyns": "00485059",
    "dotregion": 7,
    "geoid": "20197",
    "lsad": "06",
    "name": "Wabaunsee",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1877,
    "affgeoid": "0500000US20199",
    "aland": 2366348107,
    "awater": 140932,
    "countyfp": "199",
    "countyns": "00485060",
    "dotregion": 7,
    "geoid": "20199",
    "lsad": "06",
    "name": "Wallace",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 482,
    "affgeoid": "0500000US20201",
    "aland": 2317419409,
    "awater": 10139631,
    "countyfp": "201",
    "countyns": "00485061",
    "dotregion": 7,
    "geoid": "20201",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 2901,
    "affgeoid": "0500000US20203",
    "aland": 1861078210,
    "awater": 61987,
    "countyfp": "203",
    "countyns": "00485062",
    "dotregion": 7,
    "geoid": "20203",
    "lsad": "06",
    "name": "Wichita",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 1014,
    "affgeoid": "0500000US20205",
    "aland": 1477377648,
    "awater": 12056867,
    "countyfp": "205",
    "countyns": "00485063",
    "dotregion": 7,
    "geoid": "20205",
    "lsad": "06",
    "name": "Wilson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 399,
    "affgeoid": "0500000US20207",
    "aland": 1289347402,
    "awater": 19251488,
    "countyfp": "207",
    "countyns": "00485064",
    "dotregion": 7,
    "geoid": "20207",
    "lsad": "06",
    "name": "Woodson",
    "stateAbbreviation": "KS",
    "stateId": 48
  }, {
    "id": 898,
    "affgeoid": "0500000US20209",
    "aland": 392647715,
    "awater": 11890108,
    "countyfp": "209",
    "countyns": "00485065",
    "dotregion": 7,
    "geoid": "20209",
    "lsad": "06",
    "name": "Wyandotte",
    "stateAbbreviation": "KS",
    "stateId": 48
  }]
}, {
  "id": 3,
  "abbreviation": "KY",
  "affgeoid": "0400000US21",
  "aland": 102266253024,
  "awater": 2389483091,
  "dotregion": 4,
  "geoid": "21",
  "lsad": "00",
  "name": "Kentucky",
  "stateAbbreviation": "KY",
  "statefp": "21",
  "statens": "01779786",
  "counties": [{
    "id": 2591,
    "affgeoid": "0500000US21001",
    "aland": 1049678094,
    "awater": 18430783,
    "countyfp": "001",
    "countyns": "00516847",
    "dotregion": 4,
    "geoid": "21001",
    "lsad": "06",
    "name": "Adair",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 711,
    "affgeoid": "0500000US21003",
    "aland": 891830403,
    "awater": 19492346,
    "countyfp": "003",
    "countyns": "00516848",
    "dotregion": 4,
    "geoid": "21003",
    "lsad": "06",
    "name": "Allen",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3024,
    "affgeoid": "0500000US21005",
    "aland": 522745701,
    "awater": 6311536,
    "countyfp": "005",
    "countyns": "00516849",
    "dotregion": 4,
    "geoid": "21005",
    "lsad": "06",
    "name": "Anderson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 903,
    "affgeoid": "0500000US21007",
    "aland": 638843940,
    "awater": 70008724,
    "countyfp": "007",
    "countyns": "00516850",
    "dotregion": 4,
    "geoid": "21007",
    "lsad": "06",
    "name": "Ballard",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 62,
    "affgeoid": "0500000US21009",
    "aland": 1262728183,
    "awater": 32263857,
    "countyfp": "009",
    "countyns": "00516851",
    "dotregion": 4,
    "geoid": "21009",
    "lsad": "06",
    "name": "Barren",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1537,
    "affgeoid": "0500000US21011",
    "aland": 722081571,
    "awater": 13486212,
    "countyfp": "011",
    "countyns": "00516852",
    "dotregion": 4,
    "geoid": "21011",
    "lsad": "06",
    "name": "Bath",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2009,
    "affgeoid": "0500000US21013",
    "aland": 929806701,
    "awater": 5480741,
    "countyfp": "013",
    "countyns": "00516853",
    "dotregion": 4,
    "geoid": "21013",
    "lsad": "06",
    "name": "Bell",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1752,
    "affgeoid": "0500000US21015",
    "aland": 637462183,
    "awater": 26777115,
    "countyfp": "015",
    "countyns": "00516854",
    "dotregion": 4,
    "geoid": "21015",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1528,
    "affgeoid": "0500000US21017",
    "aland": 750369636,
    "awater": 4850382,
    "countyfp": "017",
    "countyns": "00516855",
    "dotregion": 4,
    "geoid": "21017",
    "lsad": "06",
    "name": "Bourbon",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2353,
    "affgeoid": "0500000US21019",
    "aland": 414053932,
    "awater": 5581247,
    "countyfp": "019",
    "countyns": "00516856",
    "dotregion": 4,
    "geoid": "21019",
    "lsad": "06",
    "name": "Boyd",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 761,
    "affgeoid": "0500000US21021",
    "aland": 467270907,
    "awater": 6460537,
    "countyfp": "021",
    "countyns": "00516857",
    "dotregion": 4,
    "geoid": "21021",
    "lsad": "06",
    "name": "Boyle",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1543,
    "affgeoid": "0500000US21023",
    "aland": 532533653,
    "awater": 8636823,
    "countyfp": "023",
    "countyns": "00516858",
    "dotregion": 4,
    "geoid": "21023",
    "lsad": "06",
    "name": "Bracken",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 669,
    "affgeoid": "0500000US21025",
    "aland": 1275350089,
    "awater": 7392268,
    "countyfp": "025",
    "countyns": "00516859",
    "dotregion": 4,
    "geoid": "21025",
    "lsad": "06",
    "name": "Breathitt",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1082,
    "affgeoid": "0500000US21027",
    "aland": 1469049378,
    "awater": 47702032,
    "countyfp": "027",
    "countyns": "00516860",
    "dotregion": 4,
    "geoid": "21027",
    "lsad": "06",
    "name": "Breckinridge",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 814,
    "affgeoid": "0500000US21029",
    "aland": 769295034,
    "awater": 8386208,
    "countyfp": "029",
    "countyns": "00516861",
    "dotregion": 4,
    "geoid": "21029",
    "lsad": "06",
    "name": "Bullitt",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 204,
    "affgeoid": "0500000US21031",
    "aland": 1103562551,
    "awater": 13947933,
    "countyfp": "031",
    "countyns": "00516862",
    "dotregion": 4,
    "geoid": "21031",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1085,
    "affgeoid": "0500000US21033",
    "aland": 893006769,
    "awater": 8700648,
    "countyfp": "033",
    "countyns": "00516863",
    "dotregion": 4,
    "geoid": "21033",
    "lsad": "06",
    "name": "Caldwell",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 694,
    "affgeoid": "0500000US21035",
    "aland": 997205947,
    "awater": 66492726,
    "countyfp": "035",
    "countyns": "00516864",
    "dotregion": 4,
    "geoid": "21035",
    "lsad": "06",
    "name": "Calloway",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2396,
    "affgeoid": "0500000US21037",
    "aland": 391914324,
    "awater": 20981940,
    "countyfp": "037",
    "countyns": "00516865",
    "dotregion": 4,
    "geoid": "21037",
    "lsad": "06",
    "name": "Campbell",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1672,
    "affgeoid": "0500000US21039",
    "aland": 490632724,
    "awater": 24722530,
    "countyfp": "039",
    "countyns": "00516866",
    "dotregion": 4,
    "geoid": "21039",
    "lsad": "06",
    "name": "Carlisle",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 497,
    "affgeoid": "0500000US21041",
    "aland": 332993896,
    "awater": 22650069,
    "countyfp": "041",
    "countyns": "00516867",
    "dotregion": 4,
    "geoid": "21041",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2575,
    "affgeoid": "0500000US21043",
    "aland": 1060590189,
    "awater": 6800548,
    "countyfp": "043",
    "countyns": "00516868",
    "dotregion": 4,
    "geoid": "21043",
    "lsad": "06",
    "name": "Carter",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1589,
    "affgeoid": "0500000US21045",
    "aland": 1150557995,
    "awater": 3892620,
    "countyfp": "045",
    "countyns": "00516869",
    "dotregion": 4,
    "geoid": "21045",
    "lsad": "06",
    "name": "Casey",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2666,
    "affgeoid": "0500000US21047",
    "aland": 1858332177,
    "awater": 16928286,
    "countyfp": "047",
    "countyns": "00516870",
    "dotregion": 4,
    "geoid": "21047",
    "lsad": "06",
    "name": "Christian",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 813,
    "affgeoid": "0500000US21049",
    "aland": 653878186,
    "awater": 6973063,
    "countyfp": "049",
    "countyns": "00516871",
    "dotregion": 4,
    "geoid": "21049",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 866,
    "affgeoid": "0500000US21051",
    "aland": 1215348970,
    "awater": 4763609,
    "countyfp": "051",
    "countyns": "00516872",
    "dotregion": 4,
    "geoid": "21051",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3199,
    "affgeoid": "0500000US21053",
    "aland": 510864252,
    "awater": 21164150,
    "countyfp": "053",
    "countyns": "00516873",
    "dotregion": 4,
    "geoid": "21053",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 852,
    "affgeoid": "0500000US21055",
    "aland": 932275445,
    "awater": 28974077,
    "countyfp": "055",
    "countyns": "00516874",
    "dotregion": 4,
    "geoid": "21055",
    "lsad": "06",
    "name": "Crittenden",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1643,
    "affgeoid": "0500000US21057",
    "aland": 790416910,
    "awater": 14830126,
    "countyfp": "057",
    "countyns": "00516875",
    "dotregion": 4,
    "geoid": "21057",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3195,
    "affgeoid": "0500000US21059",
    "aland": 1187163563,
    "awater": 47158146,
    "countyfp": "059",
    "countyns": "00516876",
    "dotregion": 4,
    "geoid": "21059",
    "lsad": "06",
    "name": "Daviess",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1712,
    "affgeoid": "0500000US21061",
    "aland": 784468319,
    "awater": 13258106,
    "countyfp": "061",
    "countyns": "00516877",
    "dotregion": 4,
    "geoid": "21061",
    "lsad": "06",
    "name": "Edmonson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2510,
    "affgeoid": "0500000US21063",
    "aland": 606875340,
    "awater": 2609005,
    "countyfp": "063",
    "countyns": "00516878",
    "dotregion": 4,
    "geoid": "21063",
    "lsad": "06",
    "name": "Elliott",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1610,
    "affgeoid": "0500000US21065",
    "aland": 655468669,
    "awater": 6557897,
    "countyfp": "065",
    "countyns": "00516879",
    "dotregion": 4,
    "geoid": "21065",
    "lsad": "06",
    "name": "Estill",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 124,
    "affgeoid": "0500000US21067",
    "aland": 734657049,
    "awater": 4922243,
    "countyfp": "067",
    "countyns": "00516880",
    "dotregion": 4,
    "geoid": "21067",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2619,
    "affgeoid": "0500000US21069",
    "aland": 902720569,
    "awater": 7183992,
    "countyfp": "069",
    "countyns": "00516881",
    "dotregion": 4,
    "geoid": "21069",
    "lsad": "06",
    "name": "Fleming",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1091,
    "affgeoid": "0500000US21071",
    "aland": 1018763009,
    "awater": 6108909,
    "countyfp": "071",
    "countyns": "00516882",
    "dotregion": 4,
    "geoid": "21071",
    "lsad": "06",
    "name": "Floyd",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1850,
    "affgeoid": "0500000US21073",
    "aland": 538073032,
    "awater": 11025563,
    "countyfp": "073",
    "countyns": "00516883",
    "dotregion": 4,
    "geoid": "21073",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 885,
    "affgeoid": "0500000US21075",
    "aland": 533214536,
    "awater": 64084949,
    "countyfp": "075",
    "countyns": "00516884",
    "dotregion": 4,
    "geoid": "21075",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 849,
    "affgeoid": "0500000US21077",
    "aland": 254699487,
    "awater": 16518571,
    "countyfp": "077",
    "countyns": "00516885",
    "dotregion": 4,
    "geoid": "21077",
    "lsad": "06",
    "name": "Gallatin",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 604,
    "affgeoid": "0500000US21079",
    "aland": 595898797,
    "awater": 10017658,
    "countyfp": "079",
    "countyns": "00516886",
    "dotregion": 4,
    "geoid": "21079",
    "lsad": "06",
    "name": "Garrard",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2212,
    "affgeoid": "0500000US21081",
    "aland": 668126447,
    "awater": 7253734,
    "countyfp": "081",
    "countyns": "00516887",
    "dotregion": 4,
    "geoid": "21081",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1846,
    "affgeoid": "0500000US21083",
    "aland": 1429026036,
    "awater": 13047565,
    "countyfp": "083",
    "countyns": "00516888",
    "dotregion": 4,
    "geoid": "21083",
    "lsad": "06",
    "name": "Graves",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2146,
    "affgeoid": "0500000US21085",
    "aland": 1291451120,
    "awater": 32112260,
    "countyfp": "085",
    "countyns": "00516889",
    "dotregion": 4,
    "geoid": "21085",
    "lsad": "06",
    "name": "Grayson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 647,
    "affgeoid": "0500000US21087",
    "aland": 740837706,
    "awater": 7123457,
    "countyfp": "087",
    "countyns": "00516890",
    "dotregion": 4,
    "geoid": "21087",
    "lsad": "06",
    "name": "Green",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 876,
    "affgeoid": "0500000US21089",
    "aland": 892115249,
    "awater": 25894139,
    "countyfp": "089",
    "countyns": "00516891",
    "dotregion": 4,
    "geoid": "21089",
    "lsad": "06",
    "name": "Greenup",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2929,
    "affgeoid": "0500000US21091",
    "aland": 486020463,
    "awater": 29093100,
    "countyfp": "091",
    "countyns": "00516892",
    "dotregion": 4,
    "geoid": "21091",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 54,
    "affgeoid": "0500000US21093",
    "aland": 1614335125,
    "awater": 17702152,
    "countyfp": "093",
    "countyns": "00516893",
    "dotregion": 4,
    "geoid": "21093",
    "lsad": "06",
    "name": "Hardin",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2425,
    "affgeoid": "0500000US21095",
    "aland": 1206487448,
    "awater": 6016646,
    "countyfp": "095",
    "countyns": "00516894",
    "dotregion": 4,
    "geoid": "21095",
    "lsad": "06",
    "name": "Harlan",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1075,
    "affgeoid": "0500000US21097",
    "aland": 793479179,
    "awater": 9058517,
    "countyfp": "097",
    "countyns": "00516895",
    "dotregion": 4,
    "geoid": "21097",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3097,
    "affgeoid": "0500000US21099",
    "aland": 1068314374,
    "awater": 13912256,
    "countyfp": "099",
    "countyns": "00516896",
    "dotregion": 4,
    "geoid": "21099",
    "lsad": "06",
    "name": "Hart",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1123,
    "affgeoid": "0500000US21101",
    "aland": 1130968907,
    "awater": 76690323,
    "countyfp": "101",
    "countyns": "00516897",
    "dotregion": 4,
    "geoid": "21101",
    "lsad": "06",
    "name": "Henderson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3104,
    "affgeoid": "0500000US21103",
    "aland": 741450767,
    "awater": 12552366,
    "countyfp": "103",
    "countyns": "00516898",
    "dotregion": 4,
    "geoid": "21103",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 22,
    "affgeoid": "0500000US21105",
    "aland": 627487971,
    "awater": 27882017,
    "countyfp": "105",
    "countyns": "00516899",
    "dotregion": 4,
    "geoid": "21105",
    "lsad": "06",
    "name": "Hickman",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2818,
    "affgeoid": "0500000US21107",
    "aland": 1403763235,
    "awater": 32165560,
    "countyfp": "107",
    "countyns": "00516900",
    "dotregion": 4,
    "geoid": "21107",
    "lsad": "06",
    "name": "Hopkins",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 985,
    "affgeoid": "0500000US21109",
    "aland": 894055728,
    "awater": 3407438,
    "countyfp": "109",
    "countyns": "00516901",
    "dotregion": 4,
    "geoid": "21109",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1571,
    "affgeoid": "0500000US21111",
    "aland": 985372730,
    "awater": 44620445,
    "countyfp": "111",
    "countyns": "00516902",
    "dotregion": 4,
    "geoid": "21111",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 823,
    "affgeoid": "0500000US21113",
    "aland": 445778395,
    "awater": 6166287,
    "countyfp": "113",
    "countyns": "00516903",
    "dotregion": 4,
    "geoid": "21113",
    "lsad": "06",
    "name": "Jessamine",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1728,
    "affgeoid": "0500000US21115",
    "aland": 678468094,
    "awater": 5639298,
    "countyfp": "115",
    "countyns": "00516904",
    "dotregion": 4,
    "geoid": "21115",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 66,
    "affgeoid": "0500000US21117",
    "aland": 415052358,
    "awater": 10603975,
    "countyfp": "117",
    "countyns": "00516905",
    "dotregion": 4,
    "geoid": "21117",
    "lsad": "06",
    "name": "Kenton",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2698,
    "affgeoid": "0500000US21119",
    "aland": 910435499,
    "awater": 3453309,
    "countyfp": "119",
    "countyns": "00516906",
    "dotregion": 4,
    "geoid": "21119",
    "lsad": "06",
    "name": "Knott",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 76,
    "affgeoid": "0500000US21121",
    "aland": 1000508841,
    "awater": 3753811,
    "countyfp": "121",
    "countyns": "00516907",
    "dotregion": 4,
    "geoid": "21121",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1938,
    "affgeoid": "0500000US21123",
    "aland": 677353849,
    "awater": 5448082,
    "countyfp": "123",
    "countyns": "00516908",
    "dotregion": 4,
    "geoid": "21123",
    "lsad": "06",
    "name": "Larue",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2709,
    "affgeoid": "0500000US21125",
    "aland": 1123945992,
    "awater": 25218354,
    "countyfp": "125",
    "countyns": "00516909",
    "dotregion": 4,
    "geoid": "21125",
    "lsad": "06",
    "name": "Laurel",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2675,
    "affgeoid": "0500000US21127",
    "aland": 1076386125,
    "awater": 11584860,
    "countyfp": "127",
    "countyns": "00516910",
    "dotregion": 4,
    "geoid": "21127",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2721,
    "affgeoid": "0500000US21129",
    "aland": 540937712,
    "awater": 6215038,
    "countyfp": "129",
    "countyns": "00516911",
    "dotregion": 4,
    "geoid": "21129",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2711,
    "affgeoid": "0500000US21131",
    "aland": 1038212394,
    "awater": 9331182,
    "countyfp": "131",
    "countyns": "00516912",
    "dotregion": 4,
    "geoid": "21131",
    "lsad": "06",
    "name": "Leslie",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2712,
    "affgeoid": "0500000US21133",
    "aland": 875193080,
    "awater": 2898571,
    "countyfp": "133",
    "countyns": "00516913",
    "dotregion": 4,
    "geoid": "21133",
    "lsad": "06",
    "name": "Letcher",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 771,
    "affgeoid": "0500000US21135",
    "aland": 1250570705,
    "awater": 32492708,
    "countyfp": "135",
    "countyns": "00516914",
    "dotregion": 4,
    "geoid": "21135",
    "lsad": "06",
    "name": "Lewis",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 742,
    "affgeoid": "0500000US21137",
    "aland": 861773600,
    "awater": 9315415,
    "countyfp": "137",
    "countyns": "00516915",
    "dotregion": 4,
    "geoid": "21137",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 546,
    "affgeoid": "0500000US21139",
    "aland": 810982677,
    "awater": 75657800,
    "countyfp": "139",
    "countyns": "00516916",
    "dotregion": 4,
    "geoid": "21139",
    "lsad": "06",
    "name": "Livingston",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1460,
    "affgeoid": "0500000US21141",
    "aland": 1430014653,
    "awater": 12688607,
    "countyfp": "141",
    "countyns": "00516917",
    "dotregion": 4,
    "geoid": "21141",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2289,
    "affgeoid": "0500000US21143",
    "aland": 553844796,
    "awater": 110561084,
    "countyfp": "143",
    "countyns": "00516918",
    "dotregion": 4,
    "geoid": "21143",
    "lsad": "06",
    "name": "Lyon",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1247,
    "affgeoid": "0500000US21151",
    "aland": 1132604735,
    "awater": 15425716,
    "countyfp": "151",
    "countyns": "00516919",
    "dotregion": 4,
    "geoid": "21151",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2290,
    "affgeoid": "0500000US21153",
    "aland": 798866499,
    "awater": 1847051,
    "countyfp": "153",
    "countyns": "00516920",
    "dotregion": 4,
    "geoid": "21153",
    "lsad": "06",
    "name": "Magoffin",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 440,
    "affgeoid": "0500000US21155",
    "aland": 888389528,
    "awater": 9969078,
    "countyfp": "155",
    "countyns": "00516921",
    "dotregion": 4,
    "geoid": "21155",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2291,
    "affgeoid": "0500000US21157",
    "aland": 780275879,
    "awater": 100762014,
    "countyfp": "157",
    "countyns": "00516922",
    "dotregion": 4,
    "geoid": "21157",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1887,
    "affgeoid": "0500000US21159",
    "aland": 594682183,
    "awater": 2564962,
    "countyfp": "159",
    "countyns": "00516923",
    "dotregion": 4,
    "geoid": "21159",
    "lsad": "06",
    "name": "Martin",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2292,
    "affgeoid": "0500000US21161",
    "aland": 621929411,
    "awater": 16276288,
    "countyfp": "161",
    "countyns": "00516924",
    "dotregion": 4,
    "geoid": "21161",
    "lsad": "06",
    "name": "Mason",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2408,
    "affgeoid": "0500000US21145",
    "aland": 644250942,
    "awater": 50306574,
    "countyfp": "145",
    "countyns": "00516925",
    "dotregion": 4,
    "geoid": "21145",
    "lsad": "06",
    "name": "McCracken",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3215,
    "affgeoid": "0500000US21147",
    "aland": 1105417080,
    "awater": 10730756,
    "countyfp": "147",
    "countyns": "00516926",
    "dotregion": 4,
    "geoid": "21147",
    "lsad": "06",
    "name": "McCreary",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 195,
    "affgeoid": "0500000US21149",
    "aland": 653906322,
    "awater": 9735021,
    "countyfp": "149",
    "countyns": "00516927",
    "dotregion": 4,
    "geoid": "21149",
    "lsad": "06",
    "name": "McLean",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2972,
    "affgeoid": "0500000US21163",
    "aland": 791043369,
    "awater": 49414663,
    "countyfp": "163",
    "countyns": "00516928",
    "dotregion": 4,
    "geoid": "21163",
    "lsad": "06",
    "name": "Meade",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 939,
    "affgeoid": "0500000US21165",
    "aland": 527282799,
    "awater": 6085060,
    "countyfp": "165",
    "countyns": "00516929",
    "dotregion": 4,
    "geoid": "21165",
    "lsad": "06",
    "name": "Menifee",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3130,
    "affgeoid": "0500000US21167",
    "aland": 644472908,
    "awater": 11601324,
    "countyfp": "167",
    "countyns": "00516930",
    "dotregion": 4,
    "geoid": "21167",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2757,
    "affgeoid": "0500000US21169",
    "aland": 750178413,
    "awater": 3999881,
    "countyfp": "169",
    "countyns": "00516931",
    "dotregion": 4,
    "geoid": "21169",
    "lsad": "06",
    "name": "Metcalfe",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2329,
    "affgeoid": "0500000US21171",
    "aland": 853073346,
    "awater": 6949352,
    "countyfp": "171",
    "countyns": "00516932",
    "dotregion": 4,
    "geoid": "21171",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 196,
    "affgeoid": "0500000US21173",
    "aland": 511177440,
    "awater": 3859635,
    "countyfp": "173",
    "countyns": "00516933",
    "dotregion": 4,
    "geoid": "21173",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 975,
    "affgeoid": "0500000US21175",
    "aland": 987115107,
    "awater": 6889992,
    "countyfp": "175",
    "countyns": "00516934",
    "dotregion": 4,
    "geoid": "21175",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1036,
    "affgeoid": "0500000US21177",
    "aland": 1209734539,
    "awater": 31906703,
    "countyfp": "177",
    "countyns": "00516935",
    "dotregion": 4,
    "geoid": "21177",
    "lsad": "06",
    "name": "Muhlenberg",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 917,
    "affgeoid": "0500000US21179",
    "aland": 1081354529,
    "awater": 16997328,
    "countyfp": "179",
    "countyns": "00516936",
    "dotregion": 4,
    "geoid": "21179",
    "lsad": "06",
    "name": "Nelson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1047,
    "affgeoid": "0500000US21181",
    "aland": 505491181,
    "awater": 4305022,
    "countyfp": "181",
    "countyns": "00516937",
    "dotregion": 4,
    "geoid": "21181",
    "lsad": "06",
    "name": "Nicholas",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 800,
    "affgeoid": "0500000US21183",
    "aland": 1521032971,
    "awater": 23187647,
    "countyfp": "183",
    "countyns": "00516938",
    "dotregion": 4,
    "geoid": "21183",
    "lsad": "06",
    "name": "Ohio",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3062,
    "affgeoid": "0500000US21185",
    "aland": 484931826,
    "awater": 23831365,
    "countyfp": "185",
    "countyns": "00516939",
    "dotregion": 4,
    "geoid": "21185",
    "lsad": "06",
    "name": "Oldham",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1647,
    "affgeoid": "0500000US21187",
    "aland": 909364851,
    "awater": 8130388,
    "countyfp": "187",
    "countyns": "00516940",
    "dotregion": 4,
    "geoid": "21187",
    "lsad": "06",
    "name": "Owen",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2904,
    "affgeoid": "0500000US21189",
    "aland": 511282949,
    "awater": 2285945,
    "countyfp": "189",
    "countyns": "00516941",
    "dotregion": 4,
    "geoid": "21189",
    "lsad": "06",
    "name": "Owsley",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 87,
    "affgeoid": "0500000US21191",
    "aland": 717839313,
    "awater": 12325351,
    "countyfp": "191",
    "countyns": "00516942",
    "dotregion": 4,
    "geoid": "21191",
    "lsad": "06",
    "name": "Pendleton",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 624,
    "affgeoid": "0500000US21193",
    "aland": 879750124,
    "awater": 7603771,
    "countyfp": "193",
    "countyns": "00516943",
    "dotregion": 4,
    "geoid": "21193",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2348,
    "affgeoid": "0500000US21195",
    "aland": 2037848118,
    "awater": 4756854,
    "countyfp": "195",
    "countyns": "00516944",
    "dotregion": 4,
    "geoid": "21195",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1525,
    "affgeoid": "0500000US21197",
    "aland": 463555578,
    "awater": 2957592,
    "countyfp": "197",
    "countyns": "00516945",
    "dotregion": 4,
    "geoid": "21197",
    "lsad": "06",
    "name": "Powell",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2734,
    "affgeoid": "0500000US21199",
    "aland": 1705274603,
    "awater": 48546597,
    "countyfp": "199",
    "countyns": "00516946",
    "dotregion": 4,
    "geoid": "21199",
    "lsad": "06",
    "name": "Pulaski",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2640,
    "affgeoid": "0500000US21201",
    "aland": 258768323,
    "awater": 484952,
    "countyfp": "201",
    "countyns": "00516947",
    "dotregion": 4,
    "geoid": "21201",
    "lsad": "06",
    "name": "Robertson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1651,
    "affgeoid": "0500000US21203",
    "aland": 819848738,
    "awater": 4016362,
    "countyfp": "203",
    "countyns": "00516948",
    "dotregion": 4,
    "geoid": "21203",
    "lsad": "06",
    "name": "Rockcastle",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 884,
    "affgeoid": "0500000US21205",
    "aland": 724672202,
    "awater": 16753503,
    "countyfp": "205",
    "countyns": "00516949",
    "dotregion": 4,
    "geoid": "21205",
    "lsad": "06",
    "name": "Rowan",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3061,
    "affgeoid": "0500000US21207",
    "aland": 656969515,
    "awater": 75674970,
    "countyfp": "207",
    "countyns": "00516950",
    "dotregion": 4,
    "geoid": "21207",
    "lsad": "06",
    "name": "Russell",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 3101,
    "affgeoid": "0500000US21209",
    "aland": 729782629,
    "awater": 9486394,
    "countyfp": "209",
    "countyns": "00516951",
    "dotregion": 4,
    "geoid": "21209",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 623,
    "affgeoid": "0500000US21211",
    "aland": 983256993,
    "awater": 15627949,
    "countyfp": "211",
    "countyns": "00516952",
    "dotregion": 4,
    "geoid": "21211",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 781,
    "affgeoid": "0500000US21213",
    "aland": 606584184,
    "awater": 5857356,
    "countyfp": "213",
    "countyns": "00516953",
    "dotregion": 4,
    "geoid": "21213",
    "lsad": "06",
    "name": "Simpson",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2328,
    "affgeoid": "0500000US21215",
    "aland": 483493838,
    "awater": 12896776,
    "countyfp": "215",
    "countyns": "00516954",
    "dotregion": 4,
    "geoid": "21215",
    "lsad": "06",
    "name": "Spencer",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2218,
    "affgeoid": "0500000US21217",
    "aland": 689791804,
    "awater": 27162481,
    "countyfp": "217",
    "countyns": "00516955",
    "dotregion": 4,
    "geoid": "21217",
    "lsad": "06",
    "name": "Taylor",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1049,
    "affgeoid": "0500000US21219",
    "aland": 969942075,
    "awater": 6629425,
    "countyfp": "219",
    "countyns": "00516956",
    "dotregion": 4,
    "geoid": "21219",
    "lsad": "06",
    "name": "Todd",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2349,
    "affgeoid": "0500000US21221",
    "aland": 1143307644,
    "awater": 103330290,
    "countyfp": "221",
    "countyns": "00516957",
    "dotregion": 4,
    "geoid": "21221",
    "lsad": "06",
    "name": "Trigg",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 368,
    "affgeoid": "0500000US21223",
    "aland": 392766220,
    "awater": 11833390,
    "countyfp": "223",
    "countyns": "00516958",
    "dotregion": 4,
    "geoid": "21223",
    "lsad": "06",
    "name": "Trimble",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2107,
    "affgeoid": "0500000US21225",
    "aland": 887974690,
    "awater": 53167465,
    "countyfp": "225",
    "countyns": "00516959",
    "dotregion": 4,
    "geoid": "21225",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1000,
    "affgeoid": "0500000US21227",
    "aland": 1402743751,
    "awater": 15441365,
    "countyfp": "227",
    "countyns": "00516960",
    "dotregion": 4,
    "geoid": "21227",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1762,
    "affgeoid": "0500000US21229",
    "aland": 769917001,
    "awater": 10190751,
    "countyfp": "229",
    "countyns": "00516961",
    "dotregion": 4,
    "geoid": "21229",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2672,
    "affgeoid": "0500000US21231",
    "aland": 1186685565,
    "awater": 67286710,
    "countyfp": "231",
    "countyns": "00516962",
    "dotregion": 4,
    "geoid": "21231",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1397,
    "affgeoid": "0500000US21233",
    "aland": 859730028,
    "awater": 9613035,
    "countyfp": "233",
    "countyns": "00516963",
    "dotregion": 4,
    "geoid": "21233",
    "lsad": "06",
    "name": "Webster",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 2268,
    "affgeoid": "0500000US21235",
    "aland": 1133976298,
    "awater": 18875138,
    "countyfp": "235",
    "countyns": "00516964",
    "dotregion": 4,
    "geoid": "21235",
    "lsad": "06",
    "name": "Whitley",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 1078,
    "affgeoid": "0500000US21237",
    "aland": 575419338,
    "awater": 1505210,
    "countyfp": "237",
    "countyns": "00516965",
    "dotregion": 4,
    "geoid": "21237",
    "lsad": "06",
    "name": "Wolfe",
    "stateAbbreviation": "KY",
    "stateId": 3
  }, {
    "id": 490,
    "affgeoid": "0500000US21239",
    "aland": 489062280,
    "awater": 8309108,
    "countyfp": "239",
    "countyns": "00516966",
    "dotregion": 4,
    "geoid": "21239",
    "lsad": "06",
    "name": "Woodford",
    "stateAbbreviation": "KY",
    "stateId": 3
  }]
}, {
  "id": 9,
  "abbreviation": "LA",
  "affgeoid": "0400000US22",
  "aland": 111903220951,
  "awater": 23747902252,
  "dotregion": 6,
  "geoid": "22",
  "lsad": "00",
  "name": "Louisiana",
  "stateAbbreviation": "LA",
  "statefp": "22",
  "statens": "01629543",
  "counties": [{
    "id": 1447,
    "affgeoid": "0500000US22001",
    "aland": 1696777753,
    "awater": 6021519,
    "countyfp": "001",
    "countyns": "00558389",
    "dotregion": 6,
    "geoid": "22001",
    "lsad": "15",
    "name": "Acadia",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2620,
    "affgeoid": "0500000US22003",
    "aland": 1973084287,
    "awater": 10634064,
    "countyfp": "003",
    "countyns": "00558397",
    "dotregion": 6,
    "geoid": "22003",
    "lsad": "15",
    "name": "Allen",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1347,
    "affgeoid": "0500000US22005",
    "aland": 751029431,
    "awater": 33194722,
    "countyfp": "005",
    "countyns": "00558403",
    "dotregion": 6,
    "geoid": "22005",
    "lsad": "15",
    "name": "Ascension",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1242,
    "affgeoid": "0500000US22007",
    "aland": 877123530,
    "awater": 67006149,
    "countyfp": "007",
    "countyns": "00558414",
    "dotregion": 6,
    "geoid": "22007",
    "lsad": "15",
    "name": "Assumption",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 628,
    "affgeoid": "0500000US22009",
    "aland": 2156226385,
    "awater": 85990266,
    "countyfp": "009",
    "countyns": "00558424",
    "dotregion": 6,
    "geoid": "22009",
    "lsad": "15",
    "name": "Avoyelles",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 662,
    "affgeoid": "0500000US22011",
    "aland": 2997502171,
    "awater": 21999001,
    "countyfp": "011",
    "countyns": "00558436",
    "dotregion": 6,
    "geoid": "22011",
    "lsad": "15",
    "name": "Beauregard",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1844,
    "affgeoid": "0500000US22013",
    "aland": 2101202068,
    "awater": 27951294,
    "countyfp": "013",
    "countyns": "00558445",
    "dotregion": 6,
    "geoid": "22013",
    "lsad": "15",
    "name": "Bienville",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1896,
    "affgeoid": "0500000US22015",
    "aland": 2176181456,
    "awater": 70514387,
    "countyfp": "015",
    "countyns": "00558453",
    "dotregion": 6,
    "geoid": "22015",
    "lsad": "15",
    "name": "Bossier",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2511,
    "affgeoid": "0500000US22017",
    "aland": 2275354742,
    "awater": 150399603,
    "countyfp": "017",
    "countyns": "00558458",
    "dotregion": 6,
    "geoid": "22017",
    "lsad": "15",
    "name": "Caddo",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2505,
    "affgeoid": "0500000US22019",
    "aland": 2754925000,
    "awater": 79222012,
    "countyfp": "019",
    "countyns": "00558468",
    "dotregion": 6,
    "geoid": "22019",
    "lsad": "15",
    "name": "Calcasieu",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2602,
    "affgeoid": "0500000US22021",
    "aland": 1371203816,
    "awater": 29277303,
    "countyfp": "021",
    "countyns": "00558477",
    "dotregion": 6,
    "geoid": "22021",
    "lsad": "15",
    "name": "Caldwell",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3040,
    "affgeoid": "0500000US22023",
    "aland": 3327839224,
    "awater": 1688122259,
    "countyfp": "023",
    "countyns": "00558488",
    "dotregion": 6,
    "geoid": "22023",
    "lsad": "15",
    "name": "Cameron",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1973,
    "affgeoid": "0500000US22025",
    "aland": 1833782911,
    "awater": 81308667,
    "countyfp": "025",
    "countyns": "00558495",
    "dotregion": 6,
    "geoid": "22025",
    "lsad": "15",
    "name": "Catahoula",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1472,
    "affgeoid": "0500000US22027",
    "aland": 1955125390,
    "awater": 32473222,
    "countyfp": "027",
    "countyns": "00558505",
    "dotregion": 6,
    "geoid": "22027",
    "lsad": "15",
    "name": "Claiborne",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1974,
    "affgeoid": "0500000US22029",
    "aland": 1805172280,
    "awater": 130329991,
    "countyfp": "029",
    "countyns": "00558515",
    "dotregion": 6,
    "geoid": "22029",
    "lsad": "15",
    "name": "Concordia",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 886,
    "affgeoid": "0500000US22031",
    "aland": 2269878444,
    "awater": 47049426,
    "countyfp": "031",
    "countyns": "00558521",
    "dotregion": 6,
    "geoid": "22031",
    "lsad": "15",
    "name": "De Soto",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 664,
    "affgeoid": "0500000US22033",
    "aland": 1179346048,
    "awater": 38556751,
    "countyfp": "033",
    "countyns": "00558530",
    "dotregion": 6,
    "geoid": "22033",
    "lsad": "15",
    "name": "East Baton Rouge",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2665,
    "affgeoid": "0500000US22035",
    "aland": 1089619259,
    "awater": 56273972,
    "countyfp": "035",
    "countyns": "00558534",
    "dotregion": 6,
    "geoid": "22035",
    "lsad": "15",
    "name": "East Carroll",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3150,
    "affgeoid": "0500000US22037",
    "aland": 1174307243,
    "awater": 6151756,
    "countyfp": "037",
    "countyns": "00558542",
    "dotregion": 6,
    "geoid": "22037",
    "lsad": "15",
    "name": "East Feliciana",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 595,
    "affgeoid": "0500000US22039",
    "aland": 1715552083,
    "awater": 44665790,
    "countyfp": "039",
    "countyns": "00558551",
    "dotregion": 6,
    "geoid": "22039",
    "lsad": "15",
    "name": "Evangeline",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1788,
    "affgeoid": "0500000US22041",
    "aland": 1617667694,
    "awater": 28107882,
    "countyfp": "041",
    "countyns": "00558557",
    "dotregion": 6,
    "geoid": "22041",
    "lsad": "15",
    "name": "Franklin",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2452,
    "affgeoid": "0500000US22043",
    "aland": 1665429795,
    "awater": 56013947,
    "countyfp": "043",
    "countyns": "00558567",
    "dotregion": 6,
    "geoid": "22043",
    "lsad": "15",
    "name": "Grant",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3081,
    "affgeoid": "0500000US22045",
    "aland": 1486941068,
    "awater": 1182115462,
    "countyfp": "045",
    "countyns": "00558576",
    "dotregion": 6,
    "geoid": "22045",
    "lsad": "15",
    "name": "Iberia",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1865,
    "affgeoid": "0500000US22047",
    "aland": 1602209065,
    "awater": 88655982,
    "countyfp": "047",
    "countyns": "00558582",
    "dotregion": 6,
    "geoid": "22047",
    "lsad": "15",
    "name": "Iberville",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1269,
    "affgeoid": "0500000US22049",
    "aland": 1474195901,
    "awater": 28714912,
    "countyfp": "049",
    "countyns": "00558592",
    "dotregion": 6,
    "geoid": "22049",
    "lsad": "15",
    "name": "Jackson",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2699,
    "affgeoid": "0500000US22051",
    "aland": 765682141,
    "awater": 897184732,
    "countyfp": "051",
    "countyns": "00558027",
    "dotregion": 6,
    "geoid": "22051",
    "lsad": "15",
    "name": "Jefferson",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 571,
    "affgeoid": "0500000US22053",
    "aland": 1687025362,
    "awater": 18718206,
    "countyfp": "053",
    "countyns": "00558039",
    "dotregion": 6,
    "geoid": "22053",
    "lsad": "15",
    "name": "Jefferson Davis",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3043,
    "affgeoid": "0500000US22059",
    "aland": 1617924843,
    "awater": 97664776,
    "countyfp": "059",
    "countyns": "00558049",
    "dotregion": 6,
    "geoid": "22059",
    "lsad": "15",
    "name": "LaSalle",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2308,
    "affgeoid": "0500000US22055",
    "aland": 696045251,
    "awater": 1204114,
    "countyfp": "055",
    "countyns": "00558059",
    "dotregion": 6,
    "geoid": "22055",
    "lsad": "15",
    "name": "Lafayette",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1034,
    "affgeoid": "0500000US22057",
    "aland": 2766822935,
    "awater": 1037697180,
    "countyfp": "057",
    "countyns": "00558065",
    "dotregion": 6,
    "geoid": "22057",
    "lsad": "15",
    "name": "Lafourche",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2812,
    "affgeoid": "0500000US22061",
    "aland": 1221806132,
    "awater": 1897709,
    "countyfp": "061",
    "countyns": "00558077",
    "dotregion": 6,
    "geoid": "22061",
    "lsad": "15",
    "name": "Lincoln",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 410,
    "affgeoid": "0500000US22063",
    "aland": 1678747394,
    "awater": 112119238,
    "countyfp": "063",
    "countyns": "00558083",
    "dotregion": 6,
    "geoid": "22063",
    "lsad": "15",
    "name": "Livingston",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1302,
    "affgeoid": "0500000US22065",
    "aland": 1617282459,
    "awater": 68539547,
    "countyfp": "065",
    "countyns": "00558088",
    "dotregion": 6,
    "geoid": "22065",
    "lsad": "15",
    "name": "Madison",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 484,
    "affgeoid": "0500000US22067",
    "aland": 2058870191,
    "awater": 28878805,
    "countyfp": "067",
    "countyns": "00558097",
    "dotregion": 6,
    "geoid": "22067",
    "lsad": "15",
    "name": "Morehouse",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1342,
    "affgeoid": "0500000US22069",
    "aland": 3243341073,
    "awater": 121033892,
    "countyfp": "069",
    "countyns": "00558108",
    "dotregion": 6,
    "geoid": "22069",
    "lsad": "15",
    "name": "Natchitoches",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3124,
    "affgeoid": "0500000US22071",
    "aland": 438792720,
    "awater": 467306395,
    "countyfp": "071",
    "countyns": "00558113",
    "dotregion": 6,
    "geoid": "22071",
    "lsad": "15",
    "name": "Orleans",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 815,
    "affgeoid": "0500000US22073",
    "aland": 1580931662,
    "awater": 55294552,
    "countyfp": "073",
    "countyns": "00558114",
    "dotregion": 6,
    "geoid": "22073",
    "lsad": "15",
    "name": "Ouachita",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3096,
    "affgeoid": "0500000US22075",
    "aland": 2020765755,
    "awater": 4628160494,
    "countyfp": "075",
    "countyns": "00558125",
    "dotregion": 6,
    "geoid": "22075",
    "lsad": "15",
    "name": "Plaquemines",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3069,
    "affgeoid": "0500000US22077",
    "aland": 1443519857,
    "awater": 86418272,
    "countyfp": "077",
    "countyns": "00559449",
    "dotregion": 6,
    "geoid": "22077",
    "lsad": "15",
    "name": "Pointe Coupee",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 367,
    "affgeoid": "0500000US22079",
    "aland": 3413632520,
    "awater": 113043213,
    "countyfp": "079",
    "countyns": "00559460",
    "dotregion": 6,
    "geoid": "22079",
    "lsad": "15",
    "name": "Rapides",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 887,
    "affgeoid": "0500000US22081",
    "aland": 1007739207,
    "awater": 34327512,
    "countyfp": "081",
    "countyns": "00559472",
    "dotregion": 6,
    "geoid": "22081",
    "lsad": "15",
    "name": "Red River",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3114,
    "affgeoid": "0500000US22083",
    "aland": 1448537069,
    "awater": 13551678,
    "countyfp": "083",
    "countyns": "00559481",
    "dotregion": 6,
    "geoid": "22083",
    "lsad": "15",
    "name": "Richland",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2981,
    "affgeoid": "0500000US22085",
    "aland": 2244628537,
    "awater": 375417244,
    "countyfp": "085",
    "countyns": "00559489",
    "dotregion": 6,
    "geoid": "22085",
    "lsad": "15",
    "name": "Sabine",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3036,
    "affgeoid": "0500000US22087",
    "aland": 977743046,
    "awater": 4604215126,
    "countyfp": "087",
    "countyns": "01629542",
    "dotregion": 6,
    "geoid": "22087",
    "lsad": "15",
    "name": "St. Bernard",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1357,
    "affgeoid": "0500000US22089",
    "aland": 719646243,
    "awater": 308361669,
    "countyfp": "089",
    "countyns": "01629449",
    "dotregion": 6,
    "geoid": "22089",
    "lsad": "15",
    "name": "St. Charles",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1188,
    "affgeoid": "0500000US22091",
    "aland": 1057772592,
    "awater": 2796218,
    "countyfp": "091",
    "countyns": "01629457",
    "dotregion": 6,
    "geoid": "22091",
    "lsad": "15",
    "name": "St. Helena",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 235,
    "affgeoid": "0500000US22093",
    "aland": 625582188,
    "awater": 42168610,
    "countyfp": "093",
    "countyns": "01629464",
    "dotregion": 6,
    "geoid": "22093",
    "lsad": "15",
    "name": "St. James",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 665,
    "affgeoid": "0500000US22095",
    "aland": 555050486,
    "awater": 506472491,
    "countyfp": "095",
    "countyns": "01629472",
    "dotregion": 6,
    "geoid": "22095",
    "lsad": "15",
    "name": "St. John the Baptist",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3002,
    "affgeoid": "0500000US22097",
    "aland": 2392904510,
    "awater": 39047412,
    "countyfp": "097",
    "countyns": "01629479",
    "dotregion": 6,
    "geoid": "22097",
    "lsad": "15",
    "name": "St. Landry",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3201,
    "affgeoid": "0500000US22099",
    "aland": 1910535374,
    "awater": 204161448,
    "countyfp": "099",
    "countyns": "01629486",
    "dotregion": 6,
    "geoid": "22099",
    "lsad": "15",
    "name": "St. Martin",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3080,
    "affgeoid": "0500000US22101",
    "aland": 1438844850,
    "awater": 1460448190,
    "countyfp": "101",
    "countyns": "01629492",
    "dotregion": 6,
    "geoid": "22101",
    "lsad": "15",
    "name": "St. Mary",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3014,
    "affgeoid": "0500000US22103",
    "aland": 2190289201,
    "awater": 647245544,
    "countyfp": "103",
    "countyns": "01629503",
    "dotregion": 6,
    "geoid": "22103",
    "lsad": "15",
    "name": "St. Tammany",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2986,
    "affgeoid": "0500000US22105",
    "aland": 2049504791,
    "awater": 136674364,
    "countyfp": "105",
    "countyns": "00559500",
    "dotregion": 6,
    "geoid": "22105",
    "lsad": "15",
    "name": "Tangipahoa",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3148,
    "affgeoid": "0500000US22107",
    "aland": 1561204545,
    "awater": 99471079,
    "countyfp": "107",
    "countyns": "00559509",
    "dotregion": 6,
    "geoid": "22107",
    "lsad": "15",
    "name": "Tensas",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 3137,
    "affgeoid": "0500000US22109",
    "aland": 3190255110,
    "awater": 2202158274,
    "countyfp": "109",
    "countyns": "00559517",
    "dotregion": 6,
    "geoid": "22109",
    "lsad": "15",
    "name": "Terrebonne",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1278,
    "affgeoid": "0500000US22111",
    "aland": 2271389438,
    "awater": 73594418,
    "countyfp": "111",
    "countyns": "00559528",
    "dotregion": 6,
    "geoid": "22111",
    "lsad": "15",
    "name": "Union",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1121,
    "affgeoid": "0500000US22113",
    "aland": 3038610957,
    "awater": 955342069,
    "countyfp": "113",
    "countyns": "00559538",
    "dotregion": 6,
    "geoid": "22113",
    "lsad": "15",
    "name": "Vermilion",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1536,
    "affgeoid": "0500000US22115",
    "aland": 3439275943,
    "awater": 35153783,
    "countyfp": "115",
    "countyns": "00559548",
    "dotregion": 6,
    "geoid": "22115",
    "lsad": "15",
    "name": "Vernon",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2970,
    "affgeoid": "0500000US22117",
    "aland": 1734071719,
    "awater": 16460917,
    "countyfp": "117",
    "countyns": "00559557",
    "dotregion": 6,
    "geoid": "22117",
    "lsad": "15",
    "name": "Washington",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1875,
    "affgeoid": "0500000US22119",
    "aland": 1535941083,
    "awater": 56486633,
    "countyfp": "119",
    "countyns": "00559567",
    "dotregion": 6,
    "geoid": "22119",
    "lsad": "15",
    "name": "Webster",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2548,
    "affgeoid": "0500000US22121",
    "aland": 498293891,
    "awater": 29602238,
    "countyfp": "121",
    "countyns": "00559570",
    "dotregion": 6,
    "geoid": "22121",
    "lsad": "15",
    "name": "West Baton Rouge",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 1654,
    "affgeoid": "0500000US22123",
    "aland": 931478638,
    "awater": 2386193,
    "countyfp": "123",
    "countyns": "00559578",
    "dotregion": 6,
    "geoid": "22123",
    "lsad": "15",
    "name": "West Carroll",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2468,
    "affgeoid": "0500000US22125",
    "aland": 1044342212,
    "awater": 58999603,
    "countyfp": "125",
    "countyns": "00559584",
    "dotregion": 6,
    "geoid": "22125",
    "lsad": "15",
    "name": "West Feliciana",
    "stateAbbreviation": "LA",
    "stateId": 9
  }, {
    "id": 2924,
    "affgeoid": "0500000US22127",
    "aland": 2460711982,
    "awater": 17448075,
    "countyfp": "127",
    "countyns": "00559594",
    "dotregion": 6,
    "geoid": "22127",
    "lsad": "15",
    "name": "Winn",
    "stateAbbreviation": "LA",
    "stateId": 9
  }]
}, {
  "id": 41,
  "abbreviation": "ME",
  "affgeoid": "0400000US23",
  "aland": 79885774936,
  "awater": 11748561064,
  "dotregion": 1,
  "geoid": "23",
  "lsad": "00",
  "name": "Maine",
  "stateAbbreviation": "ME",
  "statefp": "23",
  "statens": "01779787",
  "counties": [{
    "id": 1455,
    "affgeoid": "0500000US23001",
    "aland": 1211937419,
    "awater": 75599699,
    "countyfp": "001",
    "countyns": "00581286",
    "dotregion": 1,
    "geoid": "23001",
    "lsad": "06",
    "name": "Androscoggin",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 762,
    "affgeoid": "0500000US23003",
    "aland": 17278047428,
    "awater": 405253178,
    "countyfp": "003",
    "countyns": "00581287",
    "dotregion": 1,
    "geoid": "23003",
    "lsad": "06",
    "name": "Aroostook",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2313,
    "affgeoid": "0500000US23005",
    "aland": 2164390945,
    "awater": 988822127,
    "countyfp": "005",
    "countyns": "00581288",
    "dotregion": 1,
    "geoid": "23005",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2678,
    "affgeoid": "0500000US23007",
    "aland": 4395175202,
    "awater": 121369620,
    "countyfp": "007",
    "countyns": "00581289",
    "dotregion": 1,
    "geoid": "23007",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2473,
    "affgeoid": "0500000US23009",
    "aland": 4110275786,
    "awater": 1963073951,
    "countyfp": "009",
    "countyns": "00581290",
    "dotregion": 1,
    "geoid": "23009",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2242,
    "affgeoid": "0500000US23011",
    "aland": 2246806175,
    "awater": 216724439,
    "countyfp": "011",
    "countyns": "00581291",
    "dotregion": 1,
    "geoid": "23011",
    "lsad": "06",
    "name": "Kennebec",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2309,
    "affgeoid": "0500000US23013",
    "aland": 945693971,
    "awater": 2017108221,
    "countyfp": "013",
    "countyns": "00581292",
    "dotregion": 1,
    "geoid": "23013",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2466,
    "affgeoid": "0500000US23015",
    "aland": 1180625664,
    "awater": 631363741,
    "countyfp": "015",
    "countyns": "00581293",
    "dotregion": 1,
    "geoid": "23015",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2198,
    "affgeoid": "0500000US23017",
    "aland": 5379039602,
    "awater": 256039720,
    "countyfp": "017",
    "countyns": "00581294",
    "dotregion": 1,
    "geoid": "23017",
    "lsad": "06",
    "name": "Oxford",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2364,
    "affgeoid": "0500000US23019",
    "aland": 8799074164,
    "awater": 413603851,
    "countyfp": "019",
    "countyns": "00581295",
    "dotregion": 1,
    "geoid": "23019",
    "lsad": "06",
    "name": "Penobscot",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 3067,
    "affgeoid": "0500000US23021",
    "aland": 10258678459,
    "awater": 1080563045,
    "countyfp": "021",
    "countyns": "00581296",
    "dotregion": 1,
    "geoid": "23021",
    "lsad": "06",
    "name": "Piscataquis",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2034,
    "affgeoid": "0500000US23023",
    "aland": 657803474,
    "awater": 300569626,
    "countyfp": "023",
    "countyns": "00581297",
    "dotregion": 1,
    "geoid": "23023",
    "lsad": "06",
    "name": "Sagadahoc",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2919,
    "affgeoid": "0500000US23025",
    "aland": 10164314642,
    "awater": 437895944,
    "countyfp": "025",
    "countyns": "00581298",
    "dotregion": 1,
    "geoid": "23025",
    "lsad": "06",
    "name": "Somerset",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 1072,
    "affgeoid": "0500000US23027",
    "aland": 1890504130,
    "awater": 318126866,
    "countyfp": "027",
    "countyns": "00581299",
    "dotregion": 1,
    "geoid": "23027",
    "lsad": "06",
    "name": "Waldo",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2103,
    "affgeoid": "0500000US23029",
    "aland": 6637321519,
    "awater": 1799989402,
    "countyfp": "029",
    "countyns": "00581300",
    "dotregion": 1,
    "geoid": "23029",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "ME",
    "stateId": 41
  }, {
    "id": 2063,
    "affgeoid": "0500000US23031",
    "aland": 2566086356,
    "awater": 722457634,
    "countyfp": "031",
    "countyns": "00581301",
    "dotregion": 1,
    "geoid": "23031",
    "lsad": "06",
    "name": "York",
    "stateAbbreviation": "ME",
    "stateId": 41
  }]
}, {
  "id": 45,
  "abbreviation": "MD",
  "affgeoid": "0400000US24",
  "aland": 25147417568,
  "awater": 6983598596,
  "dotregion": 3,
  "geoid": "24",
  "lsad": "00",
  "name": "Maryland",
  "stateAbbreviation": "MD",
  "statefp": "24",
  "statens": "01714934",
  "counties": [{
    "id": 1351,
    "affgeoid": "0500000US24001",
    "aland": 1098572104,
    "awater": 14940164,
    "countyfp": "001",
    "countyns": "01713506",
    "dotregion": 3,
    "geoid": "24001",
    "lsad": "06",
    "name": "Allegany",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2647,
    "affgeoid": "0500000US24003",
    "aland": 1074549020,
    "awater": 447837723,
    "countyfp": "003",
    "countyns": "01710958",
    "dotregion": 3,
    "geoid": "24003",
    "lsad": "06",
    "name": "Anne Arundel",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1924,
    "affgeoid": "0500000US24005",
    "aland": 1549750692,
    "awater": 215989606,
    "countyfp": "005",
    "countyns": "01695314",
    "dotregion": 3,
    "geoid": "24005",
    "lsad": "06",
    "name": "Baltimore",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2187,
    "affgeoid": "0500000US24510",
    "aland": 209643555,
    "awater": 28767622,
    "countyfp": "510",
    "countyns": "01702381",
    "dotregion": 3,
    "geoid": "24510",
    "lsad": "25",
    "name": "Baltimore",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2692,
    "affgeoid": "0500000US24009",
    "aland": 552134151,
    "awater": 341605063,
    "countyfp": "009",
    "countyns": "01676636",
    "dotregion": 3,
    "geoid": "24009",
    "lsad": "06",
    "name": "Calvert",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1884,
    "affgeoid": "0500000US24011",
    "aland": 827350233,
    "awater": 16777062,
    "countyfp": "011",
    "countyns": "00595737",
    "dotregion": 3,
    "geoid": "24011",
    "lsad": "06",
    "name": "Caroline",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 850,
    "affgeoid": "0500000US24013",
    "aland": 1159279157,
    "awater": 13186232,
    "countyfp": "013",
    "countyns": "01696228",
    "dotregion": 3,
    "geoid": "24013",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1872,
    "affgeoid": "0500000US24015",
    "aland": 896861126,
    "awater": 185332636,
    "countyfp": "015",
    "countyns": "00596115",
    "dotregion": 3,
    "geoid": "24015",
    "lsad": "06",
    "name": "Cecil",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1680,
    "affgeoid": "0500000US24017",
    "aland": 1185653700,
    "awater": 479519793,
    "countyfp": "017",
    "countyns": "01676992",
    "dotregion": 3,
    "geoid": "24017",
    "lsad": "06",
    "name": "Charles",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1706,
    "affgeoid": "0500000US24019",
    "aland": 1400542045,
    "awater": 1145386121,
    "countyfp": "019",
    "countyns": "00596495",
    "dotregion": 3,
    "geoid": "24019",
    "lsad": "06",
    "name": "Dorchester",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2752,
    "affgeoid": "0500000US24021",
    "aland": 1710554388,
    "awater": 18041931,
    "countyfp": "021",
    "countyns": "01711211",
    "dotregion": 3,
    "geoid": "24021",
    "lsad": "06",
    "name": "Frederick",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1477,
    "affgeoid": "0500000US24023",
    "aland": 1675988217,
    "awater": 22363868,
    "countyfp": "023",
    "countyns": "01711058",
    "dotregion": 3,
    "geoid": "24023",
    "lsad": "06",
    "name": "Garrett",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2457,
    "affgeoid": "0500000US24025",
    "aland": 1132091443,
    "awater": 231907633,
    "countyfp": "025",
    "countyns": "01698178",
    "dotregion": 3,
    "geoid": "24025",
    "lsad": "06",
    "name": "Harford",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2936,
    "affgeoid": "0500000US24027",
    "aland": 649942749,
    "awater": 6345542,
    "countyfp": "027",
    "countyns": "01709077",
    "dotregion": 3,
    "geoid": "24027",
    "lsad": "06",
    "name": "Howard",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1620,
    "affgeoid": "0500000US24029",
    "aland": 717510795,
    "awater": 353308111,
    "countyfp": "029",
    "countyns": "00593907",
    "dotregion": 3,
    "geoid": "24029",
    "lsad": "06",
    "name": "Kent",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 555,
    "affgeoid": "0500000US24031",
    "aland": 1276634446,
    "awater": 36245371,
    "countyfp": "031",
    "countyns": "01712500",
    "dotregion": 3,
    "geoid": "24031",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1665,
    "affgeoid": "0500000US24033",
    "aland": 1250211154,
    "awater": 41768855,
    "countyfp": "033",
    "countyns": "01714670",
    "dotregion": 3,
    "geoid": "24033",
    "lsad": "06",
    "name": "Prince George's",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 1120,
    "affgeoid": "0500000US24035",
    "aland": 962645491,
    "awater": 360037121,
    "countyfp": "035",
    "countyns": "00596089",
    "dotregion": 3,
    "geoid": "24035",
    "lsad": "06",
    "name": "Queen Anne's",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 879,
    "affgeoid": "0500000US24039",
    "aland": 828090980,
    "awater": 752713771,
    "countyfp": "039",
    "countyns": "00596907",
    "dotregion": 3,
    "geoid": "24039",
    "lsad": "06",
    "name": "Somerset",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2480,
    "affgeoid": "0500000US24037",
    "aland": 925648069,
    "awater": 1053753865,
    "countyfp": "037",
    "countyns": "01697853",
    "dotregion": 3,
    "geoid": "24037",
    "lsad": "06",
    "name": "St. Mary's",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 774,
    "affgeoid": "0500000US24041",
    "aland": 695511462,
    "awater": 539408789,
    "countyfp": "041",
    "countyns": "00592947",
    "dotregion": 3,
    "geoid": "24041",
    "lsad": "06",
    "name": "Talbot",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2483,
    "affgeoid": "0500000US24043",
    "aland": 1185686686,
    "awater": 24726569,
    "countyfp": "043",
    "countyns": "01714220",
    "dotregion": 3,
    "geoid": "24043",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 2484,
    "affgeoid": "0500000US24045",
    "aland": 969732871,
    "awater": 66801500,
    "countyfp": "045",
    "countyns": "01668606",
    "dotregion": 3,
    "geoid": "24045",
    "lsad": "06",
    "name": "Wicomico",
    "stateAbbreviation": "MD",
    "stateId": 45
  }, {
    "id": 386,
    "affgeoid": "0500000US24047",
    "aland": 1212833034,
    "awater": 586833648,
    "countyfp": "047",
    "countyns": "01668802",
    "dotregion": 3,
    "geoid": "24047",
    "lsad": "06",
    "name": "Worcester",
    "stateAbbreviation": "MD",
    "stateId": 45
  }]
}, {
  "id": 33,
  "abbreviation": "MA",
  "affgeoid": "0400000US25",
  "aland": 20205425910,
  "awater": 7130316321,
  "dotregion": 1,
  "geoid": "25",
  "lsad": "00",
  "name": "Massachusetts",
  "stateAbbreviation": "MA",
  "statefp": "25",
  "statens": "00606926",
  "counties": [{
    "id": 3084,
    "affgeoid": "0500000US25001",
    "aland": 1019719638,
    "awater": 2361606119,
    "countyfp": "001",
    "countyns": "00606927",
    "dotregion": 1,
    "geoid": "25001",
    "lsad": "06",
    "name": "Barnstable",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 2131,
    "affgeoid": "0500000US25003",
    "aland": 2400491048,
    "awater": 50746697,
    "countyfp": "003",
    "countyns": "00606928",
    "dotregion": 1,
    "geoid": "25003",
    "lsad": "06",
    "name": "Berkshire",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 2958,
    "affgeoid": "0500000US25005",
    "aland": 1432602435,
    "awater": 357662687,
    "countyfp": "005",
    "countyns": "00606929",
    "dotregion": 1,
    "geoid": "25005",
    "lsad": "06",
    "name": "Bristol",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 2066,
    "affgeoid": "0500000US25007",
    "aland": 267455894,
    "awater": 1004127633,
    "countyfp": "007",
    "countyns": "00606930",
    "dotregion": 1,
    "geoid": "25007",
    "lsad": "06",
    "name": "Dukes",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 2467,
    "affgeoid": "0500000US25009",
    "aland": 1275669707,
    "awater": 870068134,
    "countyfp": "009",
    "countyns": "00606931",
    "dotregion": 1,
    "geoid": "25009",
    "lsad": "06",
    "name": "Essex",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 1169,
    "affgeoid": "0500000US25011",
    "aland": 1811271672,
    "awater": 65368074,
    "countyfp": "011",
    "countyns": "00606932",
    "dotregion": 1,
    "geoid": "25011",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 1410,
    "affgeoid": "0500000US25013",
    "aland": 1598409204,
    "awater": 44293472,
    "countyfp": "013",
    "countyns": "00606933",
    "dotregion": 1,
    "geoid": "25013",
    "lsad": "06",
    "name": "Hampden",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 1627,
    "affgeoid": "0500000US25015",
    "aland": 1365598019,
    "awater": 46487557,
    "countyfp": "015",
    "countyns": "00606934",
    "dotregion": 1,
    "geoid": "25015",
    "lsad": "06",
    "name": "Hampshire",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 2679,
    "affgeoid": "0500000US25017",
    "aland": 2118147279,
    "awater": 75727649,
    "countyfp": "017",
    "countyns": "00606935",
    "dotregion": 1,
    "geoid": "25017",
    "lsad": "06",
    "name": "Middlesex",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 2200,
    "affgeoid": "0500000US25019",
    "aland": 119431671,
    "awater": 667032212,
    "countyfp": "019",
    "countyns": "00606936",
    "dotregion": 1,
    "geoid": "25019",
    "lsad": "06",
    "name": "Nantucket",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 1638,
    "affgeoid": "0500000US25021",
    "aland": 1025927532,
    "awater": 124925285,
    "countyfp": "021",
    "countyns": "00606937",
    "dotregion": 1,
    "geoid": "25021",
    "lsad": "06",
    "name": "Norfolk",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 1621,
    "affgeoid": "0500000US25023",
    "aland": 1707122280,
    "awater": 1124387947,
    "countyfp": "023",
    "countyns": "00606938",
    "dotregion": 1,
    "geoid": "25023",
    "lsad": "06",
    "name": "Plymouth",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 1682,
    "affgeoid": "0500000US25025",
    "aland": 150881016,
    "awater": 160487602,
    "countyfp": "025",
    "countyns": "00606939",
    "dotregion": 1,
    "geoid": "25025",
    "lsad": "06",
    "name": "Suffolk",
    "stateAbbreviation": "MA",
    "stateId": 33
  }, {
    "id": 2254,
    "affgeoid": "0500000US25027",
    "aland": 3912698515,
    "awater": 177395253,
    "countyfp": "027",
    "countyns": "00606940",
    "dotregion": 1,
    "geoid": "25027",
    "lsad": "06",
    "name": "Worcester",
    "stateAbbreviation": "MA",
    "stateId": 33
  }]
}, {
  "id": 11,
  "abbreviation": "MI",
  "affgeoid": "0400000US26",
  "aland": 146455475554,
  "awater": 104031185771,
  "dotregion": 5,
  "geoid": "26",
  "lsad": "00",
  "name": "Michigan",
  "stateAbbreviation": "MI",
  "statefp": "26",
  "statens": "01779789",
  "counties": [{
    "id": 2521,
    "affgeoid": "0500000US26001",
    "aland": 1747174455,
    "awater": 2890419446,
    "countyfp": "001",
    "countyns": "01622943",
    "dotregion": 5,
    "geoid": "26001",
    "lsad": "06",
    "name": "Alcona",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2351,
    "affgeoid": "0500000US26003",
    "aland": 2370036406,
    "awater": 10703536628,
    "countyfp": "003",
    "countyns": "01622944",
    "dotregion": 5,
    "geoid": "26003",
    "lsad": "06",
    "name": "Alger",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1406,
    "affgeoid": "0500000US26005",
    "aland": 2137343989,
    "awater": 2610850577,
    "countyfp": "005",
    "countyns": "01622945",
    "dotregion": 5,
    "geoid": "26005",
    "lsad": "06",
    "name": "Allegan",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 312,
    "affgeoid": "0500000US26007",
    "aland": 1481125307,
    "awater": 2908714555,
    "countyfp": "007",
    "countyns": "01622946",
    "dotregion": 5,
    "geoid": "26007",
    "lsad": "06",
    "name": "Alpena",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 782,
    "affgeoid": "0500000US26009",
    "aland": 1232064099,
    "awater": 326513028,
    "countyfp": "009",
    "countyns": "01622947",
    "dotregion": 5,
    "geoid": "26009",
    "lsad": "06",
    "name": "Antrim",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2857,
    "affgeoid": "0500000US26011",
    "aland": 940660643,
    "awater": 822319186,
    "countyfp": "011",
    "countyns": "01622948",
    "dotregion": 5,
    "geoid": "26011",
    "lsad": "06",
    "name": "Arenac",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2079,
    "affgeoid": "0500000US26013",
    "aland": 2326499634,
    "awater": 441604270,
    "countyfp": "013",
    "countyns": "01622949",
    "dotregion": 5,
    "geoid": "26013",
    "lsad": "06",
    "name": "Baraga",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 423,
    "affgeoid": "0500000US26015",
    "aland": 1432507992,
    "awater": 62021603,
    "countyfp": "015",
    "countyns": "01622950",
    "dotregion": 5,
    "geoid": "26015",
    "lsad": "06",
    "name": "Barry",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1160,
    "affgeoid": "0500000US26017",
    "aland": 1145557660,
    "awater": 487987306,
    "countyfp": "017",
    "countyns": "01622951",
    "dotregion": 5,
    "geoid": "26017",
    "lsad": "06",
    "name": "Bay",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1033,
    "affgeoid": "0500000US26019",
    "aland": 828029229,
    "awater": 1398237661,
    "countyfp": "019",
    "countyns": "01622952",
    "dotregion": 5,
    "geoid": "26019",
    "lsad": "06",
    "name": "Benzie",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1642,
    "affgeoid": "0500000US26021",
    "aland": 1470458178,
    "awater": 2625533765,
    "countyfp": "021",
    "countyns": "01622953",
    "dotregion": 5,
    "geoid": "26021",
    "lsad": "06",
    "name": "Berrien",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2742,
    "affgeoid": "0500000US26023",
    "aland": 1311513993,
    "awater": 34440013,
    "countyfp": "023",
    "countyns": "01622954",
    "dotregion": 5,
    "geoid": "26023",
    "lsad": "06",
    "name": "Branch",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1703,
    "affgeoid": "0500000US26025",
    "aland": 1829249871,
    "awater": 31275675,
    "countyfp": "025",
    "countyns": "01622955",
    "dotregion": 5,
    "geoid": "26025",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 55,
    "affgeoid": "0500000US26027",
    "aland": 1269354633,
    "awater": 47180822,
    "countyfp": "027",
    "countyns": "01622956",
    "dotregion": 5,
    "geoid": "26027",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 696,
    "affgeoid": "0500000US26029",
    "aland": 1078323548,
    "awater": 2522960209,
    "countyfp": "029",
    "countyns": "01622957",
    "dotregion": 5,
    "geoid": "26029",
    "lsad": "06",
    "name": "Charlevoix",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 71,
    "affgeoid": "0500000US26031",
    "aland": 1852528267,
    "awater": 440605204,
    "countyfp": "031",
    "countyns": "01622958",
    "dotregion": 5,
    "geoid": "26031",
    "lsad": "06",
    "name": "Cheboygan",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2338,
    "affgeoid": "0500000US26033",
    "aland": 4036315605,
    "awater": 2952483920,
    "countyfp": "033",
    "countyns": "01622959",
    "dotregion": 5,
    "geoid": "26033",
    "lsad": "06",
    "name": "Chippewa",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1435,
    "affgeoid": "0500000US26035",
    "aland": 1461621714,
    "awater": 28500716,
    "countyfp": "035",
    "countyns": "01622960",
    "dotregion": 5,
    "geoid": "26035",
    "lsad": "06",
    "name": "Clare",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 596,
    "affgeoid": "0500000US26037",
    "aland": 1466991666,
    "awater": 21105919,
    "countyfp": "037",
    "countyns": "01622961",
    "dotregion": 5,
    "geoid": "26037",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2745,
    "affgeoid": "0500000US26039",
    "aland": 1440763922,
    "awater": 18025856,
    "countyfp": "039",
    "countyns": "01622962",
    "dotregion": 5,
    "geoid": "26039",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 697,
    "affgeoid": "0500000US26041",
    "aland": 3033127424,
    "awater": 2124385259,
    "countyfp": "041",
    "countyns": "01622963",
    "dotregion": 5,
    "geoid": "26041",
    "lsad": "06",
    "name": "Delta",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1457,
    "affgeoid": "0500000US26043",
    "aland": 1972018116,
    "awater": 40533053,
    "countyfp": "043",
    "countyns": "01622964",
    "dotregion": 5,
    "geoid": "26043",
    "lsad": "06",
    "name": "Dickinson",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1860,
    "affgeoid": "0500000US26045",
    "aland": 1489703575,
    "awater": 11020019,
    "countyfp": "045",
    "countyns": "01622965",
    "dotregion": 5,
    "geoid": "26045",
    "lsad": "06",
    "name": "Eaton",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2985,
    "affgeoid": "0500000US26047",
    "aland": 1210886743,
    "awater": 1073476049,
    "countyfp": "047",
    "countyns": "01622966",
    "dotregion": 5,
    "geoid": "26047",
    "lsad": "06",
    "name": "Emmet",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 314,
    "affgeoid": "0500000US26049",
    "aland": 1649729501,
    "awater": 32693085,
    "countyfp": "049",
    "countyns": "01622967",
    "dotregion": 5,
    "geoid": "26049",
    "lsad": "06",
    "name": "Genesee",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2302,
    "affgeoid": "0500000US26051",
    "aland": 1299615519,
    "awater": 36636103,
    "countyfp": "051",
    "countyns": "01622968",
    "dotregion": 5,
    "geoid": "26051",
    "lsad": "06",
    "name": "Gladwin",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 783,
    "affgeoid": "0500000US26053",
    "aland": 2853838065,
    "awater": 969877827,
    "countyfp": "053",
    "countyns": "01622969",
    "dotregion": 5,
    "geoid": "26053",
    "lsad": "06",
    "name": "Gogebic",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 973,
    "affgeoid": "0500000US26055",
    "aland": 1202643276,
    "awater": 354756662,
    "countyfp": "055",
    "countyns": "01622970",
    "dotregion": 5,
    "geoid": "26055",
    "lsad": "06",
    "name": "Grand Traverse",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 192,
    "affgeoid": "0500000US26057",
    "aland": 1472309905,
    "awater": 8154670,
    "countyfp": "057",
    "countyns": "01622971",
    "dotregion": 5,
    "geoid": "26057",
    "lsad": "06",
    "name": "Gratiot",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 450,
    "affgeoid": "0500000US26059",
    "aland": 1549199572,
    "awater": 22938608,
    "countyfp": "059",
    "countyns": "01622972",
    "dotregion": 5,
    "geoid": "26059",
    "lsad": "06",
    "name": "Hillsdale",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2397,
    "affgeoid": "0500000US26061",
    "aland": 2613583292,
    "awater": 1275285979,
    "countyfp": "061",
    "countyns": "01622973",
    "dotregion": 5,
    "geoid": "26061",
    "lsad": "06",
    "name": "Houghton",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2124,
    "affgeoid": "0500000US26063",
    "aland": 2165436315,
    "awater": 3368858123,
    "countyfp": "063",
    "countyns": "01622974",
    "dotregion": 5,
    "geoid": "26063",
    "lsad": "06",
    "name": "Huron",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2955,
    "affgeoid": "0500000US26065",
    "aland": 1440346360,
    "awater": 11891440,
    "countyfp": "065",
    "countyns": "01622975",
    "dotregion": 5,
    "geoid": "26065",
    "lsad": "06",
    "name": "Ingham",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 194,
    "affgeoid": "0500000US26067",
    "aland": 1479671935,
    "awater": 22641047,
    "countyfp": "067",
    "countyns": "01622976",
    "dotregion": 5,
    "geoid": "26067",
    "lsad": "06",
    "name": "Ionia",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 379,
    "affgeoid": "0500000US26069",
    "aland": 1422205035,
    "awater": 3473021481,
    "countyfp": "069",
    "countyns": "01622977",
    "dotregion": 5,
    "geoid": "26069",
    "lsad": "06",
    "name": "Iosco",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1015,
    "affgeoid": "0500000US26071",
    "aland": 3020278459,
    "awater": 116739058,
    "countyfp": "071",
    "countyns": "01622978",
    "dotregion": 5,
    "geoid": "26071",
    "lsad": "06",
    "name": "Iron",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1423,
    "affgeoid": "0500000US26073",
    "aland": 1483226456,
    "awater": 12959626,
    "countyfp": "073",
    "countyns": "01622979",
    "dotregion": 5,
    "geoid": "26073",
    "lsad": "06",
    "name": "Isabella",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1016,
    "affgeoid": "0500000US26075",
    "aland": 1817308302,
    "awater": 56538564,
    "countyfp": "075",
    "countyns": "01622980",
    "dotregion": 5,
    "geoid": "26075",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1886,
    "affgeoid": "0500000US26077",
    "aland": 1456103637,
    "awater": 46859098,
    "countyfp": "077",
    "countyns": "01622981",
    "dotregion": 5,
    "geoid": "26077",
    "lsad": "06",
    "name": "Kalamazoo",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2767,
    "affgeoid": "0500000US26079",
    "aland": 1450060290,
    "awater": 28061562,
    "countyfp": "079",
    "countyns": "01622982",
    "dotregion": 5,
    "geoid": "26079",
    "lsad": "06",
    "name": "Kalkaska",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1979,
    "affgeoid": "0500000US26081",
    "aland": 2195539075,
    "awater": 62785371,
    "countyfp": "081",
    "countyns": "01622983",
    "dotregion": 5,
    "geoid": "26081",
    "lsad": "06",
    "name": "Kent",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2606,
    "affgeoid": "0500000US26083",
    "aland": 1398883129,
    "awater": 14053672881,
    "countyfp": "083",
    "countyns": "01622984",
    "dotregion": 5,
    "geoid": "26083",
    "lsad": "06",
    "name": "Keweenaw",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1514,
    "affgeoid": "0500000US26085",
    "aland": 1469857281,
    "awater": 17521848,
    "countyfp": "085",
    "countyns": "01622985",
    "dotregion": 5,
    "geoid": "26085",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 605,
    "affgeoid": "0500000US26087",
    "aland": 1668449547,
    "awater": 48310219,
    "countyfp": "087",
    "countyns": "01622986",
    "dotregion": 5,
    "geoid": "26087",
    "lsad": "06",
    "name": "Lapeer",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1753,
    "affgeoid": "0500000US26089",
    "aland": 899207291,
    "awater": 5659140179,
    "countyfp": "089",
    "countyns": "01622987",
    "dotregion": 5,
    "geoid": "26089",
    "lsad": "06",
    "name": "Leelanau",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 527,
    "affgeoid": "0500000US26091",
    "aland": 1941339768,
    "awater": 30699189,
    "countyfp": "091",
    "countyns": "01622988",
    "dotregion": 5,
    "geoid": "26091",
    "lsad": "06",
    "name": "Lenawee",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 173,
    "affgeoid": "0500000US26093",
    "aland": 1463871721,
    "awater": 52324362,
    "countyfp": "093",
    "countyns": "01622989",
    "dotregion": 5,
    "geoid": "26093",
    "lsad": "06",
    "name": "Livingston",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 413,
    "affgeoid": "0500000US26095",
    "aland": 2328606518,
    "awater": 2624712415,
    "countyfp": "095",
    "countyns": "01622990",
    "dotregion": 5,
    "geoid": "26095",
    "lsad": "06",
    "name": "Luce",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1354,
    "affgeoid": "0500000US26097",
    "aland": 2646868006,
    "awater": 2793795355,
    "countyfp": "097",
    "countyns": "01622991",
    "dotregion": 5,
    "geoid": "26097",
    "lsad": "06",
    "name": "Mackinac",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2336,
    "affgeoid": "0500000US26099",
    "aland": 1240901427,
    "awater": 237591221,
    "countyfp": "099",
    "countyns": "01622992",
    "dotregion": 5,
    "geoid": "26099",
    "lsad": "06",
    "name": "Macomb",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 20,
    "affgeoid": "0500000US26101",
    "aland": 1404203522,
    "awater": 1912441594,
    "countyfp": "101",
    "countyns": "01622993",
    "dotregion": 5,
    "geoid": "26101",
    "lsad": "06",
    "name": "Manistee",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1695,
    "affgeoid": "0500000US26103",
    "aland": 4683958912,
    "awater": 4185358957,
    "countyfp": "103",
    "countyns": "01622994",
    "dotregion": 5,
    "geoid": "26103",
    "lsad": "06",
    "name": "Marquette",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2352,
    "affgeoid": "0500000US26105",
    "aland": 1282237606,
    "awater": 1935670696,
    "countyfp": "105",
    "countyns": "01622995",
    "dotregion": 5,
    "geoid": "26105",
    "lsad": "06",
    "name": "Mason",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 197,
    "affgeoid": "0500000US26107",
    "aland": 1437626843,
    "awater": 41759538,
    "countyfp": "107",
    "countyns": "01622996",
    "dotregion": 5,
    "geoid": "26107",
    "lsad": "06",
    "name": "Mecosta",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 718,
    "affgeoid": "0500000US26109",
    "aland": 2704052106,
    "awater": 761789485,
    "countyfp": "109",
    "countyns": "01622997",
    "dotregion": 5,
    "geoid": "26109",
    "lsad": "06",
    "name": "Menominee",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2722,
    "affgeoid": "0500000US26111",
    "aland": 1337099821,
    "awater": 30589807,
    "countyfp": "111",
    "countyns": "01622998",
    "dotregion": 5,
    "geoid": "26111",
    "lsad": "06",
    "name": "Midland",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1454,
    "affgeoid": "0500000US26113",
    "aland": 1462638197,
    "awater": 23575303,
    "countyfp": "113",
    "countyns": "01622999",
    "dotregion": 5,
    "geoid": "26113",
    "lsad": "06",
    "name": "Missaukee",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2544,
    "affgeoid": "0500000US26115",
    "aland": 1422996308,
    "awater": 338244021,
    "countyfp": "115",
    "countyns": "01623000",
    "dotregion": 5,
    "geoid": "26115",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1491,
    "affgeoid": "0500000US26117",
    "aland": 1826967225,
    "awater": 39965450,
    "countyfp": "117",
    "countyns": "01623001",
    "dotregion": 5,
    "geoid": "26117",
    "lsad": "06",
    "name": "Montcalm",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 26,
    "affgeoid": "0500000US26119",
    "aland": 1415851591,
    "awater": 41410946,
    "countyfp": "119",
    "countyns": "01623002",
    "dotregion": 5,
    "geoid": "26119",
    "lsad": "06",
    "name": "Montmorency",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2347,
    "affgeoid": "0500000US26121",
    "aland": 1295054226,
    "awater": 2486391831,
    "countyfp": "121",
    "countyns": "01623003",
    "dotregion": 5,
    "geoid": "26121",
    "lsad": "06",
    "name": "Muskegon",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1595,
    "affgeoid": "0500000US26123",
    "aland": 2112559446,
    "awater": 119204427,
    "countyfp": "123",
    "countyns": "01623004",
    "dotregion": 5,
    "geoid": "26123",
    "lsad": "06",
    "name": "Newaygo",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1586,
    "affgeoid": "0500000US26125",
    "aland": 2246696132,
    "awater": 103177684,
    "countyfp": "125",
    "countyns": "01623005",
    "dotregion": 5,
    "geoid": "26125",
    "lsad": "06",
    "name": "Oakland",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 200,
    "affgeoid": "0500000US26127",
    "aland": 1326431590,
    "awater": 2055963381,
    "countyfp": "127",
    "countyns": "01623006",
    "dotregion": 5,
    "geoid": "26127",
    "lsad": "06",
    "name": "Oceana",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 494,
    "affgeoid": "0500000US26129",
    "aland": 1459438803,
    "awater": 29680532,
    "countyfp": "129",
    "countyns": "01623007",
    "dotregion": 5,
    "geoid": "26129",
    "lsad": "06",
    "name": "Ogemaw",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 3079,
    "affgeoid": "0500000US26131",
    "aland": 3396123450,
    "awater": 6292463437,
    "countyfp": "131",
    "countyns": "01623008",
    "dotregion": 5,
    "geoid": "26131",
    "lsad": "06",
    "name": "Ontonagon",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2794,
    "affgeoid": "0500000US26133",
    "aland": 1467044587,
    "awater": 17266828,
    "countyfp": "133",
    "countyns": "01623009",
    "dotregion": 5,
    "geoid": "26133",
    "lsad": "06",
    "name": "Osceola",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1133,
    "affgeoid": "0500000US26135",
    "aland": 1465256290,
    "awater": 15133747,
    "countyfp": "135",
    "countyns": "01623010",
    "dotregion": 5,
    "geoid": "26135",
    "lsad": "06",
    "name": "Oscoda",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 436,
    "affgeoid": "0500000US26137",
    "aland": 1333826438,
    "awater": 28997113,
    "countyfp": "137",
    "countyns": "01623011",
    "dotregion": 5,
    "geoid": "26137",
    "lsad": "06",
    "name": "Otsego",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 689,
    "affgeoid": "0500000US26139",
    "aland": 1459627687,
    "awater": 2765704204,
    "countyfp": "139",
    "countyns": "01623012",
    "dotregion": 5,
    "geoid": "26139",
    "lsad": "06",
    "name": "Ottawa",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 3044,
    "affgeoid": "0500000US26141",
    "aland": 1706067767,
    "awater": 4957327560,
    "countyfp": "141",
    "countyns": "01623013",
    "dotregion": 5,
    "geoid": "26141",
    "lsad": "06",
    "name": "Presque Isle",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 174,
    "affgeoid": "0500000US26143",
    "aland": 1345852869,
    "awater": 156421369,
    "countyfp": "143",
    "countyns": "01623014",
    "dotregion": 5,
    "geoid": "26143",
    "lsad": "06",
    "name": "Roscommon",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2380,
    "affgeoid": "0500000US26145",
    "aland": 2073181634,
    "awater": 40159719,
    "countyfp": "145",
    "countyns": "01623015",
    "dotregion": 5,
    "geoid": "26145",
    "lsad": "06",
    "name": "Saginaw",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1952,
    "affgeoid": "0500000US26151",
    "aland": 2493045862,
    "awater": 1624884331,
    "countyfp": "151",
    "countyns": "01623016",
    "dotregion": 5,
    "geoid": "26151",
    "lsad": "06",
    "name": "Sanilac",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1473,
    "affgeoid": "0500000US26153",
    "aland": 3033812332,
    "awater": 1845664319,
    "countyfp": "153",
    "countyns": "01623017",
    "dotregion": 5,
    "geoid": "26153",
    "lsad": "06",
    "name": "Schoolcraft",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1162,
    "affgeoid": "0500000US26155",
    "aland": 1374710888,
    "awater": 26336215,
    "countyfp": "155",
    "countyns": "01623018",
    "dotregion": 5,
    "geoid": "26155",
    "lsad": "06",
    "name": "Shiawassee",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1799,
    "affgeoid": "0500000US26147",
    "aland": 1867861161,
    "awater": 298681039,
    "countyfp": "147",
    "countyns": "01625033",
    "dotregion": 5,
    "geoid": "26147",
    "lsad": "06",
    "name": "St. Clair",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2859,
    "affgeoid": "0500000US26149",
    "aland": 1296553521,
    "awater": 52912990,
    "countyfp": "149",
    "countyns": "01625034",
    "dotregion": 5,
    "geoid": "26149",
    "lsad": "06",
    "name": "St. Joseph",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2070,
    "affgeoid": "0500000US26157",
    "aland": 2080717684,
    "awater": 286300255,
    "countyfp": "157",
    "countyns": "01623019",
    "dotregion": 5,
    "geoid": "26157",
    "lsad": "06",
    "name": "Tuscola",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 2862,
    "affgeoid": "0500000US26159",
    "aland": 1574150150,
    "awater": 1248671260,
    "countyfp": "159",
    "countyns": "01623020",
    "dotregion": 5,
    "geoid": "26159",
    "lsad": "06",
    "name": "Van Buren",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 24,
    "affgeoid": "0500000US26161",
    "aland": 1828433678,
    "awater": 42623578,
    "countyfp": "161",
    "countyns": "01623021",
    "dotregion": 5,
    "geoid": "26161",
    "lsad": "06",
    "name": "Washtenaw",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 1993,
    "affgeoid": "0500000US26163",
    "aland": 1585112018,
    "awater": 157118499,
    "countyfp": "163",
    "countyns": "01623022",
    "dotregion": 5,
    "geoid": "26163",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "MI",
    "stateId": 11
  }, {
    "id": 630,
    "affgeoid": "0500000US26165",
    "aland": 1463348859,
    "awater": 27098944,
    "countyfp": "165",
    "countyns": "01623023",
    "dotregion": 5,
    "geoid": "26165",
    "lsad": "06",
    "name": "Wexford",
    "stateAbbreviation": "MI",
    "stateId": 11
  }]
}, {
  "id": 16,
  "abbreviation": "MN",
  "affgeoid": "0400000US27",
  "aland": 206236191895,
  "awater": 18924724649,
  "dotregion": 5,
  "geoid": "27",
  "lsad": "00",
  "name": "Minnesota",
  "stateAbbreviation": "MN",
  "statefp": "27",
  "statens": "00662849",
  "counties": [{
    "id": 1345,
    "affgeoid": "0500000US27001",
    "aland": 4718284856,
    "awater": 449546489,
    "countyfp": "001",
    "countyns": "00663198",
    "dotregion": 5,
    "geoid": "27001",
    "lsad": "06",
    "name": "Aitkin",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1648,
    "affgeoid": "0500000US27003",
    "aland": 1095504873,
    "awater": 59822796,
    "countyfp": "003",
    "countyns": "00659447",
    "dotregion": 5,
    "geoid": "27003",
    "lsad": "06",
    "name": "Anoka",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1587,
    "affgeoid": "0500000US27005",
    "aland": 3406264578,
    "awater": 336742434,
    "countyfp": "005",
    "countyns": "00659448",
    "dotregion": 5,
    "geoid": "27005",
    "lsad": "06",
    "name": "Becker",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 797,
    "affgeoid": "0500000US27007",
    "aland": 6487143193,
    "awater": 1426179537,
    "countyfp": "007",
    "countyns": "00659449",
    "dotregion": 5,
    "geoid": "27007",
    "lsad": "06",
    "name": "Beltrami",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 202,
    "affgeoid": "0500000US27009",
    "aland": 1057496597,
    "awater": 12318136,
    "countyfp": "009",
    "countyns": "00659450",
    "dotregion": 5,
    "geoid": "27009",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1053,
    "affgeoid": "0500000US27011",
    "aland": 1292448774,
    "awater": 75371016,
    "countyfp": "011",
    "countyns": "00659451",
    "dotregion": 5,
    "geoid": "27011",
    "lsad": "06",
    "name": "Big Stone",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1698,
    "affgeoid": "0500000US27013",
    "aland": 1936902312,
    "awater": 45972889,
    "countyfp": "013",
    "countyns": "00659452",
    "dotregion": 5,
    "geoid": "27013",
    "lsad": "06",
    "name": "Blue Earth",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2805,
    "affgeoid": "0500000US27015",
    "aland": 1582681677,
    "awater": 18634366,
    "countyfp": "015",
    "countyns": "00659453",
    "dotregion": 5,
    "geoid": "27015",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 230,
    "affgeoid": "0500000US27017",
    "aland": 2230966542,
    "awater": 36005417,
    "countyfp": "017",
    "countyns": "00659454",
    "dotregion": 5,
    "geoid": "27017",
    "lsad": "06",
    "name": "Carlton",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2787,
    "affgeoid": "0500000US27019",
    "aland": 917699930,
    "awater": 56427530,
    "countyfp": "019",
    "countyns": "00659455",
    "dotregion": 5,
    "geoid": "27019",
    "lsad": "06",
    "name": "Carver",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3073,
    "affgeoid": "0500000US27021",
    "aland": 5235900814,
    "awater": 1016495050,
    "countyfp": "021",
    "countyns": "00659456",
    "dotregion": 5,
    "geoid": "27021",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1669,
    "affgeoid": "0500000US27023",
    "aland": 1505098055,
    "awater": 17235498,
    "countyfp": "023",
    "countyns": "00659457",
    "dotregion": 5,
    "geoid": "27023",
    "lsad": "06",
    "name": "Chippewa",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1046,
    "affgeoid": "0500000US27025",
    "aland": 1074262488,
    "awater": 71518841,
    "countyfp": "025",
    "countyns": "00659458",
    "dotregion": 5,
    "geoid": "27025",
    "lsad": "06",
    "name": "Chisago",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1565,
    "affgeoid": "0500000US27027",
    "aland": 2707501055,
    "awater": 18844992,
    "countyfp": "027",
    "countyns": "00659459",
    "dotregion": 5,
    "geoid": "27027",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1319,
    "affgeoid": "0500000US27029",
    "aland": 2586782424,
    "awater": 79766122,
    "countyfp": "029",
    "countyns": "00659460",
    "dotregion": 5,
    "geoid": "27029",
    "lsad": "06",
    "name": "Clearwater",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2180,
    "affgeoid": "0500000US27031",
    "aland": 3761415800,
    "awater": 4887981182,
    "countyfp": "031",
    "countyns": "00659461",
    "dotregion": 5,
    "geoid": "27031",
    "lsad": "06",
    "name": "Cook",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2330,
    "affgeoid": "0500000US27033",
    "aland": 1657424970,
    "awater": 22339747,
    "countyfp": "033",
    "countyns": "00659462",
    "dotregion": 5,
    "geoid": "27033",
    "lsad": "06",
    "name": "Cottonwood",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1340,
    "affgeoid": "0500000US27035",
    "aland": 2585754150,
    "awater": 409628716,
    "countyfp": "035",
    "countyns": "00659463",
    "dotregion": 5,
    "geoid": "27035",
    "lsad": "06",
    "name": "Crow Wing",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3134,
    "affgeoid": "0500000US27037",
    "aland": 1456666540,
    "awater": 63307077,
    "countyfp": "037",
    "countyns": "00659464",
    "dotregion": 5,
    "geoid": "27037",
    "lsad": "06",
    "name": "Dakota",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 199,
    "affgeoid": "0500000US27039",
    "aland": 1137721065,
    "awater": 800245,
    "countyfp": "039",
    "countyns": "00659465",
    "dotregion": 5,
    "geoid": "27039",
    "lsad": "06",
    "name": "Dodge",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 203,
    "affgeoid": "0500000US27041",
    "aland": 1650537353,
    "awater": 214266358,
    "countyfp": "041",
    "countyns": "00659466",
    "dotregion": 5,
    "geoid": "27041",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 477,
    "affgeoid": "0500000US27043",
    "aland": 1845303782,
    "awater": 24420178,
    "countyfp": "043",
    "countyns": "00659467",
    "dotregion": 5,
    "geoid": "27043",
    "lsad": "06",
    "name": "Faribault",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 347,
    "affgeoid": "0500000US27045",
    "aland": 2230757060,
    "awater": 2045272,
    "countyfp": "045",
    "countyns": "00659468",
    "dotregion": 5,
    "geoid": "27045",
    "lsad": "06",
    "name": "Fillmore",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1518,
    "affgeoid": "0500000US27047",
    "aland": 1831347092,
    "awater": 39714579,
    "countyfp": "047",
    "countyns": "00659469",
    "dotregion": 5,
    "geoid": "27047",
    "lsad": "06",
    "name": "Freeborn",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1198,
    "affgeoid": "0500000US27049",
    "aland": 1960200377,
    "awater": 61025248,
    "countyfp": "049",
    "countyns": "00659470",
    "dotregion": 5,
    "geoid": "27049",
    "lsad": "06",
    "name": "Goodhue",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1050,
    "affgeoid": "0500000US27051",
    "aland": 1418804318,
    "awater": 71686632,
    "countyfp": "051",
    "countyns": "00659471",
    "dotregion": 5,
    "geoid": "27051",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2903,
    "affgeoid": "0500000US27053",
    "aland": 1434288887,
    "awater": 136660122,
    "countyfp": "053",
    "countyns": "00659472",
    "dotregion": 5,
    "geoid": "27053",
    "lsad": "06",
    "name": "Hennepin",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 635,
    "affgeoid": "0500000US27055",
    "aland": 1429818691,
    "awater": 43461981,
    "countyfp": "055",
    "countyns": "00659473",
    "dotregion": 5,
    "geoid": "27055",
    "lsad": "06",
    "name": "Houston",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 406,
    "affgeoid": "0500000US27057",
    "aland": 2397701681,
    "awater": 191118298,
    "countyfp": "057",
    "countyns": "00659474",
    "dotregion": 5,
    "geoid": "27057",
    "lsad": "06",
    "name": "Hubbard",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 295,
    "affgeoid": "0500000US27059",
    "aland": 1128701200,
    "awater": 41082815,
    "countyfp": "059",
    "countyns": "00659475",
    "dotregion": 5,
    "geoid": "27059",
    "lsad": "06",
    "name": "Isanti",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3008,
    "affgeoid": "0500000US27061",
    "aland": 6909302399,
    "awater": 674041238,
    "countyfp": "061",
    "countyns": "00659476",
    "dotregion": 5,
    "geoid": "27061",
    "lsad": "06",
    "name": "Itasca",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2337,
    "affgeoid": "0500000US27063",
    "aland": 1820713955,
    "awater": 42095891,
    "countyfp": "063",
    "countyns": "00659477",
    "dotregion": 5,
    "geoid": "27063",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 708,
    "affgeoid": "0500000US27065",
    "aland": 1350905393,
    "awater": 31326830,
    "countyfp": "065",
    "countyns": "00659478",
    "dotregion": 5,
    "geoid": "27065",
    "lsad": "06",
    "name": "Kanabec",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1462,
    "affgeoid": "0500000US27067",
    "aland": 2064994134,
    "awater": 168490993,
    "countyfp": "067",
    "countyns": "00659479",
    "dotregion": 5,
    "geoid": "27067",
    "lsad": "06",
    "name": "Kandiyohi",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 211,
    "affgeoid": "0500000US27069",
    "aland": 2845891400,
    "awater": 12430303,
    "countyfp": "069",
    "countyns": "00659480",
    "dotregion": 5,
    "geoid": "27069",
    "lsad": "06",
    "name": "Kittson",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3219,
    "affgeoid": "0500000US27071",
    "aland": 8039688989,
    "awater": 129101713,
    "countyfp": "071",
    "countyns": "00659481",
    "dotregion": 5,
    "geoid": "27071",
    "lsad": "06",
    "name": "Koochiching",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 851,
    "affgeoid": "0500000US27073",
    "aland": 1981394508,
    "awater": 33643131,
    "countyfp": "073",
    "countyns": "00659482",
    "dotregion": 5,
    "geoid": "27073",
    "lsad": "06",
    "name": "Lac qui Parle",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1124,
    "affgeoid": "0500000US27075",
    "aland": 5463055323,
    "awater": 2282571712,
    "countyfp": "075",
    "countyns": "00659484",
    "dotregion": 5,
    "geoid": "27075",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1240,
    "affgeoid": "0500000US27077",
    "aland": 3361456550,
    "awater": 1234895821,
    "countyfp": "077",
    "countyns": "00659483",
    "dotregion": 5,
    "geoid": "27077",
    "lsad": "06",
    "name": "Lake of the Woods",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1173,
    "affgeoid": "0500000US27079",
    "aland": 1162373909,
    "awater": 64864995,
    "countyfp": "079",
    "countyns": "00659485",
    "dotregion": 5,
    "geoid": "27079",
    "lsad": "06",
    "name": "Le Sueur",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 556,
    "affgeoid": "0500000US27081",
    "aland": 1390193542,
    "awater": 30239352,
    "countyfp": "081",
    "countyns": "00659486",
    "dotregion": 5,
    "geoid": "27081",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1175,
    "affgeoid": "0500000US27083",
    "aland": 1850698941,
    "awater": 18410959,
    "countyfp": "083",
    "countyns": "00659487",
    "dotregion": 5,
    "geoid": "27083",
    "lsad": "06",
    "name": "Lyon",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2552,
    "affgeoid": "0500000US27087",
    "aland": 1444896345,
    "awater": 64838026,
    "countyfp": "087",
    "countyns": "00659488",
    "dotregion": 5,
    "geoid": "27087",
    "lsad": "06",
    "name": "Mahnomen",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 275,
    "affgeoid": "0500000US27089",
    "aland": 4597375135,
    "awater": 98028981,
    "countyfp": "089",
    "countyns": "00659489",
    "dotregion": 5,
    "geoid": "27089",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 360,
    "affgeoid": "0500000US27091",
    "aland": 1844976825,
    "awater": 44620594,
    "countyfp": "091",
    "countyns": "00659490",
    "dotregion": 5,
    "geoid": "27091",
    "lsad": "06",
    "name": "Martin",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3116,
    "affgeoid": "0500000US27085",
    "aland": 1272903790,
    "awater": 36406719,
    "countyfp": "085",
    "countyns": "00659491",
    "dotregion": 5,
    "geoid": "27085",
    "lsad": "06",
    "name": "McLeod",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 263,
    "affgeoid": "0500000US27093",
    "aland": 1575176560,
    "awater": 94784459,
    "countyfp": "093",
    "countyns": "00659492",
    "dotregion": 5,
    "geoid": "27093",
    "lsad": "06",
    "name": "Meeker",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 534,
    "affgeoid": "0500000US27095",
    "aland": 1482278368,
    "awater": 283009546,
    "countyfp": "095",
    "countyns": "00659493",
    "dotregion": 5,
    "geoid": "27095",
    "lsad": "06",
    "name": "Mille Lacs",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2243,
    "affgeoid": "0500000US27097",
    "aland": 2913925188,
    "awater": 73333243,
    "countyfp": "097",
    "countyns": "00659494",
    "dotregion": 5,
    "geoid": "27097",
    "lsad": "06",
    "name": "Morrison",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2770,
    "affgeoid": "0500000US27099",
    "aland": 1842332263,
    "awater": 617229,
    "countyfp": "099",
    "countyns": "00659495",
    "dotregion": 5,
    "geoid": "27099",
    "lsad": "06",
    "name": "Mower",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2890,
    "affgeoid": "0500000US27101",
    "aland": 1825169456,
    "awater": 38332607,
    "countyfp": "101",
    "countyns": "00659496",
    "dotregion": 5,
    "geoid": "27101",
    "lsad": "06",
    "name": "Murray",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 822,
    "affgeoid": "0500000US27103",
    "aland": 1161967145,
    "awater": 47389658,
    "countyfp": "103",
    "countyns": "00659497",
    "dotregion": 5,
    "geoid": "27103",
    "lsad": "06",
    "name": "Nicollet",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1685,
    "affgeoid": "0500000US27105",
    "aland": 1852113620,
    "awater": 19287326,
    "countyfp": "105",
    "countyns": "00659498",
    "dotregion": 5,
    "geoid": "27105",
    "lsad": "06",
    "name": "Nobles",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2528,
    "affgeoid": "0500000US27107",
    "aland": 2260512387,
    "awater": 10208057,
    "countyfp": "107",
    "countyns": "00659499",
    "dotregion": 5,
    "geoid": "27107",
    "lsad": "06",
    "name": "Norman",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1153,
    "affgeoid": "0500000US27109",
    "aland": 1693065091,
    "awater": 3019334,
    "countyfp": "109",
    "countyns": "00659500",
    "dotregion": 5,
    "geoid": "27109",
    "lsad": "06",
    "name": "Olmsted",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 969,
    "affgeoid": "0500000US27111",
    "aland": 5107549566,
    "awater": 653980191,
    "countyfp": "111",
    "countyns": "00659501",
    "dotregion": 5,
    "geoid": "27111",
    "lsad": "06",
    "name": "Otter Tail",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 451,
    "affgeoid": "0500000US27113",
    "aland": 1596909323,
    "awater": 4351500,
    "countyfp": "113",
    "countyns": "00659502",
    "dotregion": 5,
    "geoid": "27113",
    "lsad": "06",
    "name": "Pennington",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1766,
    "affgeoid": "0500000US27115",
    "aland": 3655226420,
    "awater": 60260112,
    "countyfp": "115",
    "countyns": "00659503",
    "dotregion": 5,
    "geoid": "27115",
    "lsad": "06",
    "name": "Pine",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 163,
    "affgeoid": "0500000US27117",
    "aland": 1204487812,
    "awater": 2349142,
    "countyfp": "117",
    "countyns": "00659504",
    "dotregion": 5,
    "geoid": "27117",
    "lsad": "06",
    "name": "Pipestone",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3166,
    "affgeoid": "0500000US27119",
    "aland": 5105112392,
    "awater": 69128487,
    "countyfp": "119",
    "countyns": "00659505",
    "dotregion": 5,
    "geoid": "27119",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 369,
    "affgeoid": "0500000US27121",
    "aland": 1734594130,
    "awater": 122696318,
    "countyfp": "121",
    "countyns": "00659506",
    "dotregion": 5,
    "geoid": "27121",
    "lsad": "06",
    "name": "Pope",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2728,
    "affgeoid": "0500000US27123",
    "aland": 394031978,
    "awater": 46466787,
    "countyfp": "123",
    "countyns": "00659507",
    "dotregion": 5,
    "geoid": "27123",
    "lsad": "06",
    "name": "Ramsey",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2404,
    "affgeoid": "0500000US27125",
    "aland": 1119929321,
    "awater": 227815,
    "countyfp": "125",
    "countyns": "00659508",
    "dotregion": 5,
    "geoid": "27125",
    "lsad": "06",
    "name": "Red Lake",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 597,
    "affgeoid": "0500000US27127",
    "aland": 2275491166,
    "awater": 8230304,
    "countyfp": "127",
    "countyns": "00659509",
    "dotregion": 5,
    "geoid": "27127",
    "lsad": "06",
    "name": "Redwood",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 824,
    "affgeoid": "0500000US27129",
    "aland": 2545711096,
    "awater": 10851894,
    "countyfp": "129",
    "countyns": "00659510",
    "dotregion": 5,
    "geoid": "27129",
    "lsad": "06",
    "name": "Renville",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 261,
    "affgeoid": "0500000US27131",
    "aland": 1284223348,
    "awater": 52062136,
    "countyfp": "131",
    "countyns": "00659511",
    "dotregion": 5,
    "geoid": "27131",
    "lsad": "06",
    "name": "Rice",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 69,
    "affgeoid": "0500000US27133",
    "aland": 1249560775,
    "awater": 698231,
    "countyfp": "133",
    "countyns": "00659512",
    "dotregion": 5,
    "geoid": "27133",
    "lsad": "06",
    "name": "Rock",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 86,
    "affgeoid": "0500000US27135",
    "aland": 4329419266,
    "awater": 16925443,
    "countyfp": "135",
    "countyns": "00659513",
    "dotregion": 5,
    "geoid": "27135",
    "lsad": "06",
    "name": "Roseau",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1263,
    "affgeoid": "0500000US27139",
    "aland": 923162097,
    "awater": 30845266,
    "countyfp": "139",
    "countyns": "00659514",
    "dotregion": 5,
    "geoid": "27139",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 521,
    "affgeoid": "0500000US27141",
    "aland": 1121268365,
    "awater": 46928398,
    "countyfp": "141",
    "countyns": "00659515",
    "dotregion": 5,
    "geoid": "27141",
    "lsad": "06",
    "name": "Sherburne",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2689,
    "affgeoid": "0500000US27143",
    "aland": 1524931183,
    "awater": 30410575,
    "countyfp": "143",
    "countyns": "00659516",
    "dotregion": 5,
    "geoid": "27143",
    "lsad": "06",
    "name": "Sibley",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3216,
    "affgeoid": "0500000US27137",
    "aland": 16181104987,
    "awater": 1584900984,
    "countyfp": "137",
    "countyns": "00662850",
    "dotregion": 5,
    "geoid": "27137",
    "lsad": "06",
    "name": "St. Louis",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1180,
    "affgeoid": "0500000US27145",
    "aland": 3478160525,
    "awater": 121797053,
    "countyfp": "145",
    "countyns": "00659517",
    "dotregion": 5,
    "geoid": "27145",
    "lsad": "06",
    "name": "Stearns",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 165,
    "affgeoid": "0500000US27147",
    "aland": 1112775709,
    "awater": 6976791,
    "countyfp": "147",
    "countyns": "00659518",
    "dotregion": 5,
    "geoid": "27147",
    "lsad": "06",
    "name": "Steele",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1151,
    "affgeoid": "0500000US27149",
    "aland": 1459724811,
    "awater": 30342343,
    "countyfp": "149",
    "countyns": "00659519",
    "dotregion": 5,
    "geoid": "27149",
    "lsad": "06",
    "name": "Stevens",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 180,
    "affgeoid": "0500000US27151",
    "aland": 1921987823,
    "awater": 26168203,
    "countyfp": "151",
    "countyns": "00659520",
    "dotregion": 5,
    "geoid": "27151",
    "lsad": "06",
    "name": "Swift",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1646,
    "affgeoid": "0500000US27153",
    "aland": 2447582000,
    "awater": 89311191,
    "countyfp": "153",
    "countyns": "00659521",
    "dotregion": 5,
    "geoid": "27153",
    "lsad": "06",
    "name": "Todd",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 396,
    "affgeoid": "0500000US27155",
    "aland": 1486399441,
    "awater": 30952301,
    "countyfp": "155",
    "countyns": "00659522",
    "dotregion": 5,
    "geoid": "27155",
    "lsad": "06",
    "name": "Traverse",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3098,
    "affgeoid": "0500000US27157",
    "aland": 1354407744,
    "awater": 68928998,
    "countyfp": "157",
    "countyns": "00659523",
    "dotregion": 5,
    "geoid": "27157",
    "lsad": "06",
    "name": "Wabasha",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 198,
    "affgeoid": "0500000US27159",
    "aland": 1388928897,
    "awater": 18038944,
    "countyfp": "159",
    "countyns": "00659524",
    "dotregion": 5,
    "geoid": "27159",
    "lsad": "06",
    "name": "Wadena",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 8,
    "affgeoid": "0500000US27161",
    "aland": 1096487832,
    "awater": 24907891,
    "countyfp": "161",
    "countyns": "00659525",
    "dotregion": 5,
    "geoid": "27161",
    "lsad": "06",
    "name": "Waseca",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1276,
    "affgeoid": "0500000US27163",
    "aland": 995605351,
    "awater": 99452475,
    "countyfp": "163",
    "countyns": "00659526",
    "dotregion": 5,
    "geoid": "27163",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2910,
    "affgeoid": "0500000US27165",
    "aland": 1126535620,
    "awater": 12360897,
    "countyfp": "165",
    "countyns": "00659527",
    "dotregion": 5,
    "geoid": "27165",
    "lsad": "06",
    "name": "Watonwan",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2844,
    "affgeoid": "0500000US27167",
    "aland": 1945038539,
    "awater": 482554,
    "countyfp": "167",
    "countyns": "00659528",
    "dotregion": 5,
    "geoid": "27167",
    "lsad": "06",
    "name": "Wilkin",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 2358,
    "affgeoid": "0500000US27169",
    "aland": 1621877146,
    "awater": 39812978,
    "countyfp": "169",
    "countyns": "00659529",
    "dotregion": 5,
    "geoid": "27169",
    "lsad": "06",
    "name": "Winona",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 1156,
    "affgeoid": "0500000US27171",
    "aland": 1713165503,
    "awater": 136780940,
    "countyfp": "171",
    "countyns": "00659530",
    "dotregion": 5,
    "geoid": "27171",
    "lsad": "06",
    "name": "Wright",
    "stateAbbreviation": "MN",
    "stateId": 16
  }, {
    "id": 3165,
    "affgeoid": "0500000US27173",
    "aland": 1966059379,
    "awater": 10689227,
    "countyfp": "173",
    "countyns": "00659531",
    "dotregion": 5,
    "geoid": "27173",
    "lsad": "06",
    "name": "Yellow Medicine",
    "stateAbbreviation": "MN",
    "stateId": 16
  }]
}, {
  "id": 25,
  "abbreviation": "MS",
  "affgeoid": "0400000US28",
  "aland": 121531969224,
  "awater": 3928386321,
  "dotregion": 4,
  "geoid": "28",
  "lsad": "00",
  "name": "Mississippi",
  "stateAbbreviation": "MS",
  "statefp": "28",
  "statens": "01779790",
  "counties": [{
    "id": 2682,
    "affgeoid": "0500000US28001",
    "aland": 1197468111,
    "awater": 65273643,
    "countyfp": "001",
    "countyns": "00695726",
    "dotregion": 4,
    "geoid": "28001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1835,
    "affgeoid": "0500000US28003",
    "aland": 1036100595,
    "awater": 3417891,
    "countyfp": "003",
    "countyns": "00711755",
    "dotregion": 4,
    "geoid": "28003",
    "lsad": "06",
    "name": "Alcorn",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2459,
    "affgeoid": "0500000US28005",
    "aland": 1890950833,
    "awater": 3877823,
    "countyfp": "005",
    "countyns": "00695727",
    "dotregion": 4,
    "geoid": "28005",
    "lsad": "06",
    "name": "Amite",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 522,
    "affgeoid": "0500000US28007",
    "aland": 1903594478,
    "awater": 4421426,
    "countyfp": "007",
    "countyns": "00695728",
    "dotregion": 4,
    "geoid": "28007",
    "lsad": "06",
    "name": "Attala",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 726,
    "affgeoid": "0500000US28009",
    "aland": 1053131400,
    "awater": 5279183,
    "countyfp": "009",
    "countyns": "00695729",
    "dotregion": 4,
    "geoid": "28009",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2683,
    "affgeoid": "0500000US28011",
    "aland": 2270314787,
    "awater": 75742137,
    "countyfp": "011",
    "countyns": "00695730",
    "dotregion": 4,
    "geoid": "28011",
    "lsad": "06",
    "name": "Bolivar",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 289,
    "affgeoid": "0500000US28013",
    "aland": 1519218200,
    "awater": 3590395,
    "countyfp": "013",
    "countyns": "00695731",
    "dotregion": 4,
    "geoid": "28013",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1980,
    "affgeoid": "0500000US28015",
    "aland": 1627140838,
    "awater": 16426880,
    "countyfp": "015",
    "countyns": "00695732",
    "dotregion": 4,
    "geoid": "28015",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 759,
    "affgeoid": "0500000US28017",
    "aland": 1299609263,
    "awater": 6380767,
    "countyfp": "017",
    "countyns": "00695733",
    "dotregion": 4,
    "geoid": "28017",
    "lsad": "06",
    "name": "Chickasaw",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 432,
    "affgeoid": "0500000US28019",
    "aland": 1083088569,
    "awater": 4331852,
    "countyfp": "019",
    "countyns": "00695734",
    "dotregion": 4,
    "geoid": "28019",
    "lsad": "06",
    "name": "Choctaw",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1662,
    "affgeoid": "0500000US28021",
    "aland": 1262400025,
    "awater": 35711133,
    "countyfp": "021",
    "countyns": "00695735",
    "dotregion": 4,
    "geoid": "28021",
    "lsad": "06",
    "name": "Claiborne",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1110,
    "affgeoid": "0500000US28023",
    "aland": 1791177222,
    "awater": 5069761,
    "countyfp": "023",
    "countyns": "00695736",
    "dotregion": 4,
    "geoid": "28023",
    "lsad": "06",
    "name": "Clarke",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1985,
    "affgeoid": "0500000US28025",
    "aland": 1062066012,
    "awater": 15393112,
    "countyfp": "025",
    "countyns": "00695737",
    "dotregion": 4,
    "geoid": "28025",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1704,
    "affgeoid": "0500000US28027",
    "aland": 1430818390,
    "awater": 79539460,
    "countyfp": "027",
    "countyns": "00695738",
    "dotregion": 4,
    "geoid": "28027",
    "lsad": "06",
    "name": "Coahoma",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 42,
    "affgeoid": "0500000US28029",
    "aland": 2013048566,
    "awater": 5754986,
    "countyfp": "029",
    "countyns": "00695739",
    "dotregion": 4,
    "geoid": "28029",
    "lsad": "06",
    "name": "Copiah",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 308,
    "affgeoid": "0500000US28031",
    "aland": 1071727825,
    "awater": 2937796,
    "countyfp": "031",
    "countyns": "00695740",
    "dotregion": 4,
    "geoid": "28031",
    "lsad": "06",
    "name": "Covington",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 935,
    "affgeoid": "0500000US28033",
    "aland": 1233556702,
    "awater": 53624068,
    "countyfp": "033",
    "countyns": "00695741",
    "dotregion": 4,
    "geoid": "28033",
    "lsad": "06",
    "name": "DeSoto",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1523,
    "affgeoid": "0500000US28035",
    "aland": 1207037241,
    "awater": 10878478,
    "countyfp": "035",
    "countyns": "00695742",
    "dotregion": 4,
    "geoid": "28035",
    "lsad": "06",
    "name": "Forrest",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 434,
    "affgeoid": "0500000US28037",
    "aland": 1460181276,
    "awater": 7728324,
    "countyfp": "037",
    "countyns": "00695743",
    "dotregion": 4,
    "geoid": "28037",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2208,
    "affgeoid": "0500000US28039",
    "aland": 1239817243,
    "awater": 12838126,
    "countyfp": "039",
    "countyns": "00695744",
    "dotregion": 4,
    "geoid": "28039",
    "lsad": "06",
    "name": "George",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 101,
    "affgeoid": "0500000US28041",
    "aland": 1846034019,
    "awater": 15380474,
    "countyfp": "041",
    "countyns": "00695745",
    "dotregion": 4,
    "geoid": "28041",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1065,
    "affgeoid": "0500000US28043",
    "aland": 1093252414,
    "awater": 70698246,
    "countyfp": "043",
    "countyns": "00695746",
    "dotregion": 4,
    "geoid": "28043",
    "lsad": "06",
    "name": "Grenada",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1126,
    "affgeoid": "0500000US28045",
    "aland": 1227561743,
    "awater": 204095060,
    "countyfp": "045",
    "countyns": "00711756",
    "dotregion": 4,
    "geoid": "28045",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 965,
    "affgeoid": "0500000US28047",
    "aland": 1486712986,
    "awater": 1063618828,
    "countyfp": "047",
    "countyns": "00695747",
    "dotregion": 4,
    "geoid": "28047",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1929,
    "affgeoid": "0500000US28049",
    "aland": 2252694221,
    "awater": 19479907,
    "countyfp": "049",
    "countyns": "00695748",
    "dotregion": 4,
    "geoid": "28049",
    "lsad": "06",
    "name": "Hinds",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2894,
    "affgeoid": "0500000US28051",
    "aland": 1959840924,
    "awater": 20509158,
    "countyfp": "051",
    "countyns": "00695749",
    "dotregion": 4,
    "geoid": "28051",
    "lsad": "06",
    "name": "Holmes",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2566,
    "affgeoid": "0500000US28053",
    "aland": 1083947281,
    "awater": 32942668,
    "countyfp": "053",
    "countyns": "00695750",
    "dotregion": 4,
    "geoid": "28053",
    "lsad": "06",
    "name": "Humphreys",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 900,
    "affgeoid": "0500000US28055",
    "aland": 1069782900,
    "awater": 73507441,
    "countyfp": "055",
    "countyns": "00695751",
    "dotregion": 4,
    "geoid": "28055",
    "lsad": "06",
    "name": "Issaquena",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 970,
    "affgeoid": "0500000US28057",
    "aland": 1379914599,
    "awater": 19843967,
    "countyfp": "057",
    "countyns": "00695752",
    "dotregion": 4,
    "geoid": "28057",
    "lsad": "06",
    "name": "Itawamba",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1746,
    "affgeoid": "0500000US28059",
    "aland": 1871922291,
    "awater": 830478571,
    "countyfp": "059",
    "countyns": "00695753",
    "dotregion": 4,
    "geoid": "28059",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 3103,
    "affgeoid": "0500000US28061",
    "aland": 1751444104,
    "awater": 3181592,
    "countyfp": "061",
    "countyns": "00695754",
    "dotregion": 4,
    "geoid": "28061",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 3108,
    "affgeoid": "0500000US28063",
    "aland": 1346611166,
    "awater": 18988092,
    "countyfp": "063",
    "countyns": "00695755",
    "dotregion": 4,
    "geoid": "28063",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 393,
    "affgeoid": "0500000US28065",
    "aland": 1057871311,
    "awater": 1791496,
    "countyfp": "065",
    "countyns": "00695756",
    "dotregion": 4,
    "geoid": "28065",
    "lsad": "06",
    "name": "Jefferson Davis",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 812,
    "affgeoid": "0500000US28067",
    "aland": 1799558903,
    "awater": 12676802,
    "countyfp": "067",
    "countyns": "00695757",
    "dotregion": 4,
    "geoid": "28067",
    "lsad": "06",
    "name": "Jones",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 941,
    "affgeoid": "0500000US28069",
    "aland": 1984360961,
    "awater": 2182350,
    "countyfp": "069",
    "countyns": "00695758",
    "dotregion": 4,
    "geoid": "28069",
    "lsad": "06",
    "name": "Kemper",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 743,
    "affgeoid": "0500000US28071",
    "aland": 1636141756,
    "awater": 123047582,
    "countyfp": "071",
    "countyns": "00695759",
    "dotregion": 4,
    "geoid": "28071",
    "lsad": "06",
    "name": "Lafayette",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1742,
    "affgeoid": "0500000US28073",
    "aland": 1287499612,
    "awater": 8599890,
    "countyfp": "073",
    "countyns": "00695760",
    "dotregion": 4,
    "geoid": "28073",
    "lsad": "06",
    "name": "Lamar",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 705,
    "affgeoid": "0500000US28075",
    "aland": 1822446741,
    "awater": 29792084,
    "countyfp": "075",
    "countyns": "00695761",
    "dotregion": 4,
    "geoid": "28075",
    "lsad": "06",
    "name": "Lauderdale",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2219,
    "affgeoid": "0500000US28077",
    "aland": 1115424609,
    "awater": 13213419,
    "countyfp": "077",
    "countyns": "00695762",
    "dotregion": 4,
    "geoid": "28077",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 799,
    "affgeoid": "0500000US28079",
    "aland": 1509966828,
    "awater": 6411187,
    "countyfp": "079",
    "countyns": "00695763",
    "dotregion": 4,
    "geoid": "28079",
    "lsad": "06",
    "name": "Leake",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1839,
    "affgeoid": "0500000US28081",
    "aland": 1165367721,
    "awater": 8349354,
    "countyfp": "081",
    "countyns": "00695764",
    "dotregion": 4,
    "geoid": "28081",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1810,
    "affgeoid": "0500000US28083",
    "aland": 1536793527,
    "awater": 33720363,
    "countyfp": "083",
    "countyns": "00695765",
    "dotregion": 4,
    "geoid": "28083",
    "lsad": "06",
    "name": "Leflore",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 63,
    "affgeoid": "0500000US28085",
    "aland": 1518059682,
    "awater": 5305564,
    "countyfp": "085",
    "countyns": "00695766",
    "dotregion": 4,
    "geoid": "28085",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 725,
    "affgeoid": "0500000US28087",
    "aland": 1309077217,
    "awater": 28560500,
    "countyfp": "087",
    "countyns": "00695767",
    "dotregion": 4,
    "geoid": "28087",
    "lsad": "06",
    "name": "Lowndes",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2230,
    "affgeoid": "0500000US28089",
    "aland": 1850054812,
    "awater": 71147926,
    "countyfp": "089",
    "countyns": "00695768",
    "dotregion": 4,
    "geoid": "28089",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1466,
    "affgeoid": "0500000US28091",
    "aland": 1404769593,
    "awater": 16149942,
    "countyfp": "091",
    "countyns": "00695769",
    "dotregion": 4,
    "geoid": "28091",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 343,
    "affgeoid": "0500000US28093",
    "aland": 1828989833,
    "awater": 9195190,
    "countyfp": "093",
    "countyns": "00695770",
    "dotregion": 4,
    "geoid": "28093",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2151,
    "affgeoid": "0500000US28095",
    "aland": 1981577561,
    "awater": 18141269,
    "countyfp": "095",
    "countyns": "00695771",
    "dotregion": 4,
    "geoid": "28095",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2492,
    "affgeoid": "0500000US28097",
    "aland": 1054074716,
    "awater": 2352280,
    "countyfp": "097",
    "countyns": "00711757",
    "dotregion": 4,
    "geoid": "28097",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 606,
    "affgeoid": "0500000US28099",
    "aland": 1476641123,
    "awater": 3830971,
    "countyfp": "099",
    "countyns": "00695772",
    "dotregion": 4,
    "geoid": "28099",
    "lsad": "06",
    "name": "Neshoba",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 93,
    "affgeoid": "0500000US28101",
    "aland": 1496636739,
    "awater": 4525334,
    "countyfp": "101",
    "countyns": "00695773",
    "dotregion": 4,
    "geoid": "28101",
    "lsad": "06",
    "name": "Newton",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1901,
    "affgeoid": "0500000US28103",
    "aland": 1800451878,
    "awater": 12487979,
    "countyfp": "103",
    "countyns": "00695774",
    "dotregion": 4,
    "geoid": "28103",
    "lsad": "06",
    "name": "Noxubee",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1096,
    "affgeoid": "0500000US28105",
    "aland": 1186750731,
    "awater": 9649656,
    "countyfp": "105",
    "countyns": "00695775",
    "dotregion": 4,
    "geoid": "28105",
    "lsad": "06",
    "name": "Oktibbeha",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2599,
    "affgeoid": "0500000US28107",
    "aland": 1774515169,
    "awater": 51767071,
    "countyfp": "107",
    "countyns": "00695776",
    "dotregion": 4,
    "geoid": "28107",
    "lsad": "06",
    "name": "Panola",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 636,
    "affgeoid": "0500000US28109",
    "aland": 2100183724,
    "awater": 20778648,
    "countyfp": "109",
    "countyns": "00695777",
    "dotregion": 4,
    "geoid": "28109",
    "lsad": "06",
    "name": "Pearl River",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 798,
    "affgeoid": "0500000US28111",
    "aland": 1676259639,
    "awater": 7754345,
    "countyfp": "111",
    "countyns": "00695778",
    "dotregion": 4,
    "geoid": "28111",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 934,
    "affgeoid": "0500000US28113",
    "aland": 1059350503,
    "awater": 4341105,
    "countyfp": "113",
    "countyns": "00711758",
    "dotregion": 4,
    "geoid": "28113",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1691,
    "affgeoid": "0500000US28115",
    "aland": 1289142874,
    "awater": 8496511,
    "countyfp": "115",
    "countyns": "00695803",
    "dotregion": 4,
    "geoid": "28115",
    "lsad": "06",
    "name": "Pontotoc",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 33,
    "affgeoid": "0500000US28117",
    "aland": 1074778137,
    "awater": 8353594,
    "countyfp": "117",
    "countyns": "00695779",
    "dotregion": 4,
    "geoid": "28117",
    "lsad": "06",
    "name": "Prentiss",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 526,
    "affgeoid": "0500000US28119",
    "aland": 1048975542,
    "awater": 3676001,
    "countyfp": "119",
    "countyns": "00695780",
    "dotregion": 4,
    "geoid": "28119",
    "lsad": "06",
    "name": "Quitman",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2053,
    "affgeoid": "0500000US28121",
    "aland": 2008321905,
    "awater": 79430254,
    "countyfp": "121",
    "countyns": "00695781",
    "dotregion": 4,
    "geoid": "28121",
    "lsad": "06",
    "name": "Rankin",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2664,
    "affgeoid": "0500000US28123",
    "aland": 1577902077,
    "awater": 3001522,
    "countyfp": "123",
    "countyns": "00695782",
    "dotregion": 4,
    "geoid": "28123",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1718,
    "affgeoid": "0500000US28125",
    "aland": 1118149660,
    "awater": 8806465,
    "countyfp": "125",
    "countyns": "00695783",
    "dotregion": 4,
    "geoid": "28125",
    "lsad": "06",
    "name": "Sharkey",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 132,
    "affgeoid": "0500000US28127",
    "aland": 1525930830,
    "awater": 3378529,
    "countyfp": "127",
    "countyns": "00695784",
    "dotregion": 4,
    "geoid": "28127",
    "lsad": "06",
    "name": "Simpson",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2331,
    "affgeoid": "0500000US28129",
    "aland": 1647926085,
    "awater": 2599432,
    "countyfp": "129",
    "countyns": "00695785",
    "dotregion": 4,
    "geoid": "28129",
    "lsad": "06",
    "name": "Smith",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 51,
    "affgeoid": "0500000US28131",
    "aland": 1153800122,
    "awater": 6712353,
    "countyfp": "131",
    "countyns": "00695786",
    "dotregion": 4,
    "geoid": "28131",
    "lsad": "06",
    "name": "Stone",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 354,
    "affgeoid": "0500000US28133",
    "aland": 1807175369,
    "awater": 23758961,
    "countyfp": "133",
    "countyns": "00695787",
    "dotregion": 4,
    "geoid": "28133",
    "lsad": "06",
    "name": "Sunflower",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1265,
    "affgeoid": "0500000US28135",
    "aland": 1671109456,
    "awater": 17929624,
    "countyfp": "135",
    "countyns": "00695788",
    "dotregion": 4,
    "geoid": "28135",
    "lsad": "06",
    "name": "Tallahatchie",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2700,
    "affgeoid": "0500000US28137",
    "aland": 1048330689,
    "awater": 16092732,
    "countyfp": "137",
    "countyns": "00695789",
    "dotregion": 4,
    "geoid": "28137",
    "lsad": "06",
    "name": "Tate",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 902,
    "affgeoid": "0500000US28139",
    "aland": 1185725577,
    "awater": 5551259,
    "countyfp": "139",
    "countyns": "00695790",
    "dotregion": 4,
    "geoid": "28139",
    "lsad": "06",
    "name": "Tippah",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2,
    "affgeoid": "0500000US28141",
    "aland": 1098939230,
    "awater": 52359814,
    "countyfp": "141",
    "countyns": "00695791",
    "dotregion": 4,
    "geoid": "28141",
    "lsad": "06",
    "name": "Tishomingo",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2159,
    "affgeoid": "0500000US28143",
    "aland": 1177602384,
    "awater": 67538891,
    "countyfp": "143",
    "countyns": "00695792",
    "dotregion": 4,
    "geoid": "28143",
    "lsad": "06",
    "name": "Tunica",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2654,
    "affgeoid": "0500000US28145",
    "aland": 1076399405,
    "awater": 3387488,
    "countyfp": "145",
    "countyns": "00695793",
    "dotregion": 4,
    "geoid": "28145",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2150,
    "affgeoid": "0500000US28147",
    "aland": 1046209912,
    "awater": 1195914,
    "countyfp": "147",
    "countyns": "00695794",
    "dotregion": 4,
    "geoid": "28147",
    "lsad": "06",
    "name": "Walthall",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 3033,
    "affgeoid": "0500000US28149",
    "aland": 1524248408,
    "awater": 77800995,
    "countyfp": "149",
    "countyns": "00695795",
    "dotregion": 4,
    "geoid": "28149",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 763,
    "affgeoid": "0500000US28151",
    "aland": 1877069901,
    "awater": 94495553,
    "countyfp": "151",
    "countyns": "00695796",
    "dotregion": 4,
    "geoid": "28151",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2942,
    "affgeoid": "0500000US28153",
    "aland": 2099745578,
    "awater": 7255476,
    "countyfp": "153",
    "countyns": "00695797",
    "dotregion": 4,
    "geoid": "28153",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1412,
    "affgeoid": "0500000US28155",
    "aland": 1090223314,
    "awater": 5935288,
    "countyfp": "155",
    "countyns": "00695798",
    "dotregion": 4,
    "geoid": "28155",
    "lsad": "06",
    "name": "Webster",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1582,
    "affgeoid": "0500000US28157",
    "aland": 1756260276,
    "awater": 25019144,
    "countyfp": "157",
    "countyns": "00695799",
    "dotregion": 4,
    "geoid": "28157",
    "lsad": "06",
    "name": "Wilkinson",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 1066,
    "affgeoid": "0500000US28159",
    "aland": 1572731671,
    "awater": 7383407,
    "countyfp": "159",
    "countyns": "00695800",
    "dotregion": 4,
    "geoid": "28159",
    "lsad": "06",
    "name": "Winston",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 3174,
    "affgeoid": "0500000US28161",
    "aland": 1209858143,
    "awater": 72197127,
    "countyfp": "161",
    "countyns": "00695801",
    "dotregion": 4,
    "geoid": "28161",
    "lsad": "06",
    "name": "Yalobusha",
    "stateAbbreviation": "MS",
    "stateId": 25
  }, {
    "id": 2375,
    "affgeoid": "0500000US28163",
    "aland": 2390421566,
    "awater": 29316435,
    "countyfp": "163",
    "countyns": "00695802",
    "dotregion": 4,
    "geoid": "28163",
    "lsad": "06",
    "name": "Yazoo",
    "stateAbbreviation": "MS",
    "stateId": 25
  }]
}, {
  "id": 21,
  "abbreviation": "MO",
  "affgeoid": "0400000US29",
  "aland": 178052626882,
  "awater": 2487589369,
  "dotregion": 7,
  "geoid": "29",
  "lsad": "00",
  "name": "Missouri",
  "stateAbbreviation": "MO",
  "statefp": "29",
  "statens": "01779791",
  "counties": [{
    "id": 2726,
    "affgeoid": "0500000US29001",
    "aland": 1469362053,
    "awater": 5468507,
    "countyfp": "001",
    "countyns": "00765805",
    "dotregion": 7,
    "geoid": "29001",
    "lsad": "06",
    "name": "Adair",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 447,
    "affgeoid": "0500000US29003",
    "aland": 1120696556,
    "awater": 9649938,
    "countyfp": "003",
    "countyns": "00758456",
    "dotregion": 7,
    "geoid": "29003",
    "lsad": "06",
    "name": "Andrew",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1449,
    "affgeoid": "0500000US29005",
    "aland": 1417462658,
    "awater": 7359184,
    "countyfp": "005",
    "countyns": "00758457",
    "dotregion": 7,
    "geoid": "29005",
    "lsad": "06",
    "name": "Atchison",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1878,
    "affgeoid": "0500000US29007",
    "aland": 1792880223,
    "awater": 11880946,
    "countyfp": "007",
    "countyns": "00758458",
    "dotregion": 7,
    "geoid": "29007",
    "lsad": "06",
    "name": "Audrain",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 157,
    "affgeoid": "0500000US29009",
    "aland": 2015659211,
    "awater": 32942044,
    "countyfp": "009",
    "countyns": "00758459",
    "dotregion": 7,
    "geoid": "29009",
    "lsad": "06",
    "name": "Barry",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 56,
    "affgeoid": "0500000US29011",
    "aland": 1533067873,
    "awater": 12434943,
    "countyfp": "011",
    "countyns": "00758460",
    "dotregion": 7,
    "geoid": "29011",
    "lsad": "06",
    "name": "Barton",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2808,
    "affgeoid": "0500000US29013",
    "aland": 2167014995,
    "awater": 38050433,
    "countyfp": "013",
    "countyns": "00758461",
    "dotregion": 7,
    "geoid": "29013",
    "lsad": "06",
    "name": "Bates",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 841,
    "affgeoid": "0500000US29015",
    "aland": 1823463547,
    "awater": 125579915,
    "countyfp": "015",
    "countyns": "00758462",
    "dotregion": 7,
    "geoid": "29015",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2768,
    "affgeoid": "0500000US29017",
    "aland": 1600366924,
    "awater": 8527783,
    "countyfp": "017",
    "countyns": "00758463",
    "dotregion": 7,
    "geoid": "29017",
    "lsad": "06",
    "name": "Bollinger",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3220,
    "affgeoid": "0500000US29019",
    "aland": 1775513856,
    "awater": 14289182,
    "countyfp": "019",
    "countyns": "00758464",
    "dotregion": 7,
    "geoid": "29019",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2279,
    "affgeoid": "0500000US29021",
    "aland": 1056782089,
    "awater": 17172315,
    "countyfp": "021",
    "countyns": "00758465",
    "dotregion": 7,
    "geoid": "29021",
    "lsad": "06",
    "name": "Buchanan",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 943,
    "affgeoid": "0500000US29023",
    "aland": 1799185154,
    "awater": 11194998,
    "countyfp": "023",
    "countyns": "00758466",
    "dotregion": 7,
    "geoid": "29023",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 302,
    "affgeoid": "0500000US29025",
    "aland": 1104350547,
    "awater": 8402198,
    "countyfp": "025",
    "countyns": "00758467",
    "dotregion": 7,
    "geoid": "29025",
    "lsad": "06",
    "name": "Caldwell",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2040,
    "affgeoid": "0500000US29027",
    "aland": 2161546513,
    "awater": 33099292,
    "countyfp": "027",
    "countyns": "00758468",
    "dotregion": 7,
    "geoid": "29027",
    "lsad": "06",
    "name": "Callaway",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1981,
    "affgeoid": "0500000US29029",
    "aland": 1699033508,
    "awater": 136347051,
    "countyfp": "029",
    "countyns": "00758469",
    "dotregion": 7,
    "geoid": "29029",
    "lsad": "06",
    "name": "Camden",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 162,
    "affgeoid": "0500000US29031",
    "aland": 1498398265,
    "awater": 20174864,
    "countyfp": "031",
    "countyns": "00758470",
    "dotregion": 7,
    "geoid": "29031",
    "lsad": "06",
    "name": "Cape Girardeau",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2719,
    "affgeoid": "0500000US29033",
    "aland": 1799061775,
    "awater": 17533485,
    "countyfp": "033",
    "countyns": "00758471",
    "dotregion": 7,
    "geoid": "29033",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2567,
    "affgeoid": "0500000US29035",
    "aland": 1314039298,
    "awater": 4305247,
    "countyfp": "035",
    "countyns": "00758472",
    "dotregion": 7,
    "geoid": "29035",
    "lsad": "06",
    "name": "Carter",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1244,
    "affgeoid": "0500000US29037",
    "aland": 1804382824,
    "awater": 15051124,
    "countyfp": "037",
    "countyns": "00758473",
    "dotregion": 7,
    "geoid": "29037",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2841,
    "affgeoid": "0500000US29039",
    "aland": 1228905198,
    "awater": 62603495,
    "countyfp": "039",
    "countyns": "00758474",
    "dotregion": 7,
    "geoid": "29039",
    "lsad": "06",
    "name": "Cedar",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 816,
    "affgeoid": "0500000US29041",
    "aland": 1945539735,
    "awater": 40354559,
    "countyfp": "041",
    "countyns": "00758475",
    "dotregion": 7,
    "geoid": "29041",
    "lsad": "06",
    "name": "Chariton",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3064,
    "affgeoid": "0500000US29043",
    "aland": 1457243636,
    "awater": 3012641,
    "countyfp": "043",
    "countyns": "00758476",
    "dotregion": 7,
    "geoid": "29043",
    "lsad": "06",
    "name": "Christian",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 485,
    "affgeoid": "0500000US29045",
    "aland": 1307147406,
    "awater": 18473317,
    "countyfp": "045",
    "countyns": "00758477",
    "dotregion": 7,
    "geoid": "29045",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 544,
    "affgeoid": "0500000US29047",
    "aland": 1029881206,
    "awater": 28568904,
    "countyfp": "047",
    "countyns": "00758478",
    "dotregion": 7,
    "geoid": "29047",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2739,
    "affgeoid": "0500000US29049",
    "aland": 1085096688,
    "awater": 11719847,
    "countyfp": "049",
    "countyns": "00758479",
    "dotregion": 7,
    "geoid": "29049",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1545,
    "affgeoid": "0500000US29051",
    "aland": 1014013382,
    "awater": 19259438,
    "countyfp": "051",
    "countyns": "00758480",
    "dotregion": 7,
    "geoid": "29051",
    "lsad": "06",
    "name": "Cole",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 840,
    "affgeoid": "0500000US29053",
    "aland": 1462738174,
    "awater": 11434007,
    "countyfp": "053",
    "countyns": "00758481",
    "dotregion": 7,
    "geoid": "29053",
    "lsad": "06",
    "name": "Cooper",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1438,
    "affgeoid": "0500000US29055",
    "aland": 1923108650,
    "awater": 3203556,
    "countyfp": "055",
    "countyns": "00758482",
    "dotregion": 7,
    "geoid": "29055",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1946,
    "affgeoid": "0500000US29057",
    "aland": 1269123308,
    "awater": 42070298,
    "countyfp": "057",
    "countyns": "00758483",
    "dotregion": 7,
    "geoid": "29057",
    "lsad": "06",
    "name": "Dade",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3100,
    "affgeoid": "0500000US29059",
    "aland": 1400578411,
    "awater": 5388338,
    "countyfp": "059",
    "countyns": "00758484",
    "dotregion": 7,
    "geoid": "29059",
    "lsad": "06",
    "name": "Dallas",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1291,
    "affgeoid": "0500000US29061",
    "aland": 1458775344,
    "awater": 15044897,
    "countyfp": "061",
    "countyns": "00758485",
    "dotregion": 7,
    "geoid": "29061",
    "lsad": "06",
    "name": "Daviess",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1067,
    "affgeoid": "0500000US29063",
    "aland": 1091311254,
    "awater": 11561078,
    "countyfp": "063",
    "countyns": "00758486",
    "dotregion": 7,
    "geoid": "29063",
    "lsad": "06",
    "name": "DeKalb",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1327,
    "affgeoid": "0500000US29065",
    "aland": 1949643142,
    "awater": 4519381,
    "countyfp": "065",
    "countyns": "00758487",
    "dotregion": 7,
    "geoid": "29065",
    "lsad": "06",
    "name": "Dent",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1299,
    "affgeoid": "0500000US29067",
    "aland": 2107295822,
    "awater": 2498258,
    "countyfp": "067",
    "countyns": "00758488",
    "dotregion": 7,
    "geoid": "29067",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 660,
    "affgeoid": "0500000US29069",
    "aland": 1401369250,
    "awater": 15831141,
    "countyfp": "069",
    "countyns": "00758489",
    "dotregion": 7,
    "geoid": "29069",
    "lsad": "06",
    "name": "Dunklin",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1593,
    "affgeoid": "0500000US29071",
    "aland": 2389734943,
    "awater": 20729139,
    "countyfp": "071",
    "countyns": "00758490",
    "dotregion": 7,
    "geoid": "29071",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1010,
    "affgeoid": "0500000US29073",
    "aland": 1344215195,
    "awater": 18009291,
    "countyfp": "073",
    "countyns": "00758491",
    "dotregion": 7,
    "geoid": "29073",
    "lsad": "06",
    "name": "Gasconade",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 108,
    "affgeoid": "0500000US29075",
    "aland": 1272776755,
    "awater": 762384,
    "countyfp": "075",
    "countyns": "00758492",
    "dotregion": 7,
    "geoid": "29075",
    "lsad": "06",
    "name": "Gentry",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1999,
    "affgeoid": "0500000US29077",
    "aland": 1749069386,
    "awater": 6631776,
    "countyfp": "077",
    "countyns": "00758493",
    "dotregion": 7,
    "geoid": "29077",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1292,
    "affgeoid": "0500000US29079",
    "aland": 1127383741,
    "awater": 7118002,
    "countyfp": "079",
    "countyns": "00758494",
    "dotregion": 7,
    "geoid": "29079",
    "lsad": "06",
    "name": "Grundy",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2430,
    "affgeoid": "0500000US29081",
    "aland": 1871276777,
    "awater": 10103762,
    "countyfp": "081",
    "countyns": "00758495",
    "dotregion": 7,
    "geoid": "29081",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2876,
    "affgeoid": "0500000US29083",
    "aland": 1805075858,
    "awater": 91636450,
    "countyfp": "083",
    "countyns": "00758496",
    "dotregion": 7,
    "geoid": "29083",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 213,
    "affgeoid": "0500000US29085",
    "aland": 1032907485,
    "awater": 33455656,
    "countyfp": "085",
    "countyns": "00758497",
    "dotregion": 7,
    "geoid": "29085",
    "lsad": "06",
    "name": "Hickory",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2564,
    "affgeoid": "0500000US29087",
    "aland": 1198369598,
    "awater": 19839056,
    "countyfp": "087",
    "countyns": "00758498",
    "dotregion": 7,
    "geoid": "29087",
    "lsad": "06",
    "name": "Holt",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 269,
    "affgeoid": "0500000US29089",
    "aland": 1201192535,
    "awater": 19893075,
    "countyfp": "089",
    "countyns": "00758499",
    "dotregion": 7,
    "geoid": "29089",
    "lsad": "06",
    "name": "Howard",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1300,
    "affgeoid": "0500000US29091",
    "aland": 2401562305,
    "awater": 2913502,
    "countyfp": "091",
    "countyns": "00758500",
    "dotregion": 7,
    "geoid": "29091",
    "lsad": "06",
    "name": "Howell",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1501,
    "affgeoid": "0500000US29093",
    "aland": 1425177705,
    "awater": 4662498,
    "countyfp": "093",
    "countyns": "00758501",
    "dotregion": 7,
    "geoid": "29093",
    "lsad": "06",
    "name": "Iron",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 789,
    "affgeoid": "0500000US29095",
    "aland": 1565587846,
    "awater": 30483965,
    "countyfp": "095",
    "countyns": "00758502",
    "dotregion": 7,
    "geoid": "29095",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3160,
    "affgeoid": "0500000US29097",
    "aland": 1653653978,
    "awater": 7233655,
    "countyfp": "097",
    "countyns": "00758503",
    "dotregion": 7,
    "geoid": "29097",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1479,
    "affgeoid": "0500000US29099",
    "aland": 1700722347,
    "awater": 19766540,
    "countyfp": "099",
    "countyns": "00758504",
    "dotregion": 7,
    "geoid": "29099",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 530,
    "affgeoid": "0500000US29101",
    "aland": 2147833554,
    "awater": 10122996,
    "countyfp": "101",
    "countyns": "00758505",
    "dotregion": 7,
    "geoid": "29101",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1391,
    "affgeoid": "0500000US29103",
    "aland": 1305376709,
    "awater": 7307012,
    "countyfp": "103",
    "countyns": "00758506",
    "dotregion": 7,
    "geoid": "29103",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1441,
    "affgeoid": "0500000US29105",
    "aland": 1980627561,
    "awater": 8515352,
    "countyfp": "105",
    "countyns": "00758507",
    "dotregion": 7,
    "geoid": "29105",
    "lsad": "06",
    "name": "Laclede",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 476,
    "affgeoid": "0500000US29107",
    "aland": 1627640380,
    "awater": 27215050,
    "countyfp": "107",
    "countyns": "00758508",
    "dotregion": 7,
    "geoid": "29107",
    "lsad": "06",
    "name": "Lafayette",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 710,
    "affgeoid": "0500000US29109",
    "aland": 1584391275,
    "awater": 4249327,
    "countyfp": "109",
    "countyns": "00758509",
    "dotregion": 7,
    "geoid": "29109",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2586,
    "affgeoid": "0500000US29111",
    "aland": 1308052630,
    "awater": 14901559,
    "countyfp": "111",
    "countyns": "00758510",
    "dotregion": 7,
    "geoid": "29111",
    "lsad": "06",
    "name": "Lewis",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1030,
    "affgeoid": "0500000US29113",
    "aland": 1622776601,
    "awater": 36014760,
    "countyfp": "113",
    "countyns": "00758511",
    "dotregion": 7,
    "geoid": "29113",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 270,
    "affgeoid": "0500000US29115",
    "aland": 1594303526,
    "awater": 15053647,
    "countyfp": "115",
    "countyns": "00758512",
    "dotregion": 7,
    "geoid": "29115",
    "lsad": "06",
    "name": "Linn",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2003,
    "affgeoid": "0500000US29117",
    "aland": 1378706292,
    "awater": 16156752,
    "countyfp": "117",
    "countyns": "00758513",
    "dotregion": 7,
    "geoid": "29117",
    "lsad": "06",
    "name": "Livingston",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1274,
    "affgeoid": "0500000US29121",
    "aland": 2075118128,
    "awater": 28912824,
    "countyfp": "121",
    "countyns": "00758514",
    "dotregion": 7,
    "geoid": "29121",
    "lsad": "06",
    "name": "Macon",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3094,
    "affgeoid": "0500000US29123",
    "aland": 1280463339,
    "awater": 8312953,
    "countyfp": "123",
    "countyns": "00758515",
    "dotregion": 7,
    "geoid": "29123",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1392,
    "affgeoid": "0500000US29125",
    "aland": 1364869337,
    "awater": 7636521,
    "countyfp": "125",
    "countyns": "00758516",
    "dotregion": 7,
    "geoid": "29125",
    "lsad": "06",
    "name": "Maries",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1725,
    "affgeoid": "0500000US29127",
    "aland": 1131627484,
    "awater": 19114157,
    "countyfp": "127",
    "countyns": "00758517",
    "dotregion": 7,
    "geoid": "29127",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 172,
    "affgeoid": "0500000US29119",
    "aland": 1397247188,
    "awater": 520251,
    "countyfp": "119",
    "countyns": "00758518",
    "dotregion": 7,
    "geoid": "29119",
    "lsad": "06",
    "name": "McDonald",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2840,
    "affgeoid": "0500000US29129",
    "aland": 1175427726,
    "awater": 3302140,
    "countyfp": "129",
    "countyns": "00758519",
    "dotregion": 7,
    "geoid": "29129",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1200,
    "affgeoid": "0500000US29131",
    "aland": 1534813237,
    "awater": 19159074,
    "countyfp": "131",
    "countyns": "00758520",
    "dotregion": 7,
    "geoid": "29131",
    "lsad": "06",
    "name": "Miller",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1393,
    "affgeoid": "0500000US29133",
    "aland": 1065995414,
    "awater": 44494832,
    "countyfp": "133",
    "countyns": "00758521",
    "dotregion": 7,
    "geoid": "29133",
    "lsad": "06",
    "name": "Mississippi",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2600,
    "affgeoid": "0500000US29135",
    "aland": 1074911082,
    "awater": 9960533,
    "countyfp": "135",
    "countyns": "00758522",
    "dotregion": 7,
    "geoid": "29135",
    "lsad": "06",
    "name": "Moniteau",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2769,
    "affgeoid": "0500000US29137",
    "aland": 1677414414,
    "awater": 58300656,
    "countyfp": "137",
    "countyns": "00758523",
    "dotregion": 7,
    "geoid": "29137",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2873,
    "affgeoid": "0500000US29139",
    "aland": 1385765326,
    "awater": 14100636,
    "countyfp": "139",
    "countyns": "00758524",
    "dotregion": 7,
    "geoid": "29139",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 904,
    "affgeoid": "0500000US29141",
    "aland": 1547854691,
    "awater": 42426936,
    "countyfp": "141",
    "countyns": "00758525",
    "dotregion": 7,
    "geoid": "29141",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2953,
    "affgeoid": "0500000US29143",
    "aland": 1747828411,
    "awater": 56291575,
    "countyfp": "143",
    "countyns": "00758526",
    "dotregion": 7,
    "geoid": "29143",
    "lsad": "06",
    "name": "New Madrid",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2465,
    "affgeoid": "0500000US29145",
    "aland": 1618104260,
    "awater": 4717267,
    "countyfp": "145",
    "countyns": "00758527",
    "dotregion": 7,
    "geoid": "29145",
    "lsad": "06",
    "name": "Newton",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2149,
    "affgeoid": "0500000US29147",
    "aland": 2271326597,
    "awater": 2361588,
    "countyfp": "147",
    "countyns": "00758528",
    "dotregion": 7,
    "geoid": "29147",
    "lsad": "06",
    "name": "Nodaway",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1363,
    "affgeoid": "0500000US29149",
    "aland": 2045561036,
    "awater": 4528610,
    "countyfp": "149",
    "countyns": "00758529",
    "dotregion": 7,
    "geoid": "29149",
    "lsad": "06",
    "name": "Oregon",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2917,
    "affgeoid": "0500000US29151",
    "aland": 1571017654,
    "awater": 17751408,
    "countyfp": "151",
    "countyns": "00758530",
    "dotregion": 7,
    "geoid": "29151",
    "lsad": "06",
    "name": "Osage",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2543,
    "affgeoid": "0500000US29153",
    "aland": 1929467345,
    "awater": 26575007,
    "countyfp": "153",
    "countyns": "00758531",
    "dotregion": 7,
    "geoid": "29153",
    "lsad": "06",
    "name": "Ozark",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3149,
    "affgeoid": "0500000US29155",
    "aland": 1275622233,
    "awater": 54164612,
    "countyfp": "155",
    "countyns": "00758532",
    "dotregion": 7,
    "geoid": "29155",
    "lsad": "06",
    "name": "Pemiscot",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3035,
    "affgeoid": "0500000US29157",
    "aland": 1228575202,
    "awater": 25393801,
    "countyfp": "157",
    "countyns": "00758533",
    "dotregion": 7,
    "geoid": "29157",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2378,
    "affgeoid": "0500000US29159",
    "aland": 1766949637,
    "awater": 10503983,
    "countyfp": "159",
    "countyns": "00758534",
    "dotregion": 7,
    "geoid": "29159",
    "lsad": "06",
    "name": "Pettis",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1686,
    "affgeoid": "0500000US29161",
    "aland": 1739898247,
    "awater": 6587832,
    "countyfp": "161",
    "countyns": "00758535",
    "dotregion": 7,
    "geoid": "29161",
    "lsad": "06",
    "name": "Phelps",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1208,
    "affgeoid": "0500000US29163",
    "aland": 1736428536,
    "awater": 36976453,
    "countyfp": "163",
    "countyns": "00758536",
    "dotregion": 7,
    "geoid": "29163",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3013,
    "affgeoid": "0500000US29165",
    "aland": 1088302650,
    "awater": 17119857,
    "countyfp": "165",
    "countyns": "00758537",
    "dotregion": 7,
    "geoid": "29165",
    "lsad": "06",
    "name": "Platte",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 321,
    "affgeoid": "0500000US29167",
    "aland": 1646005965,
    "awater": 17838300,
    "countyfp": "167",
    "countyns": "00758538",
    "dotregion": 7,
    "geoid": "29167",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2092,
    "affgeoid": "0500000US29169",
    "aland": 1416984433,
    "awater": 11342832,
    "countyfp": "169",
    "countyns": "00758539",
    "dotregion": 7,
    "geoid": "29169",
    "lsad": "06",
    "name": "Pulaski",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2966,
    "affgeoid": "0500000US29171",
    "aland": 1339843850,
    "awater": 5943333,
    "countyfp": "171",
    "countyns": "00758540",
    "dotregion": 7,
    "geoid": "29171",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1790,
    "affgeoid": "0500000US29173",
    "aland": 1216727530,
    "awater": 36396585,
    "countyfp": "173",
    "countyns": "00758541",
    "dotregion": 7,
    "geoid": "29173",
    "lsad": "06",
    "name": "Ralls",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 515,
    "affgeoid": "0500000US29175",
    "aland": 1250217889,
    "awater": 13254193,
    "countyfp": "175",
    "countyns": "00758542",
    "dotregion": 7,
    "geoid": "29175",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2184,
    "affgeoid": "0500000US29177",
    "aland": 1473200437,
    "awater": 13287170,
    "countyfp": "177",
    "countyns": "00758543",
    "dotregion": 7,
    "geoid": "29177",
    "lsad": "06",
    "name": "Ray",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 594,
    "affgeoid": "0500000US29179",
    "aland": 2093947121,
    "awater": 15372862,
    "countyfp": "179",
    "countyns": "00758544",
    "dotregion": 7,
    "geoid": "29179",
    "lsad": "06",
    "name": "Reynolds",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1364,
    "affgeoid": "0500000US29181",
    "aland": 1630498739,
    "awater": 5443027,
    "countyfp": "181",
    "countyns": "00758545",
    "dotregion": 7,
    "geoid": "29181",
    "lsad": "06",
    "name": "Ripley",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1445,
    "affgeoid": "0500000US29195",
    "aland": 1956716995,
    "awater": 29587339,
    "countyfp": "195",
    "countyns": "00758550",
    "dotregion": 7,
    "geoid": "29195",
    "lsad": "06",
    "name": "Saline",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 303,
    "affgeoid": "0500000US29197",
    "aland": 795916341,
    "awater": 2216076,
    "countyfp": "197",
    "countyns": "00758551",
    "dotregion": 7,
    "geoid": "29197",
    "lsad": "06",
    "name": "Schuyler",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2359,
    "affgeoid": "0500000US29199",
    "aland": 1130968300,
    "awater": 6797936,
    "countyfp": "199",
    "countyns": "00758552",
    "dotregion": 7,
    "geoid": "29199",
    "lsad": "06",
    "name": "Scotland",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1196,
    "affgeoid": "0500000US29201",
    "aland": 1087765676,
    "awater": 15199711,
    "countyfp": "201",
    "countyns": "00758553",
    "dotregion": 7,
    "geoid": "29201",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2608,
    "affgeoid": "0500000US29203",
    "aland": 2599881254,
    "awater": 464011,
    "countyfp": "203",
    "countyns": "00758554",
    "dotregion": 7,
    "geoid": "29203",
    "lsad": "06",
    "name": "Shannon",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1207,
    "affgeoid": "0500000US29205",
    "aland": 1297230230,
    "awater": 3764605,
    "countyfp": "205",
    "countyns": "00758555",
    "dotregion": 7,
    "geoid": "29205",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2630,
    "affgeoid": "0500000US29183",
    "aland": 1451531948,
    "awater": 83314211,
    "countyfp": "183",
    "countyns": "00758546",
    "dotregion": 7,
    "geoid": "29183",
    "lsad": "06",
    "name": "St. Charles",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 353,
    "affgeoid": "0500000US29185",
    "aland": 1748205639,
    "awater": 70124657,
    "countyfp": "185",
    "countyns": "00758547",
    "dotregion": 7,
    "geoid": "29185",
    "lsad": "06",
    "name": "St. Clair",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1332,
    "affgeoid": "0500000US29187",
    "aland": 1170437422,
    "awater": 7160607,
    "countyfp": "187",
    "countyns": "00758548",
    "dotregion": 7,
    "geoid": "29187",
    "lsad": "06",
    "name": "St. Francois",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1130,
    "affgeoid": "0500000US29189",
    "aland": 1315122143,
    "awater": 39385817,
    "countyfp": "189",
    "countyns": "00758549",
    "dotregion": 7,
    "geoid": "29189",
    "lsad": "06",
    "name": "St. Louis",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2777,
    "affgeoid": "0500000US29510",
    "aland": 160458041,
    "awater": 10670040,
    "countyfp": "510",
    "countyns": "00767557",
    "dotregion": 7,
    "geoid": "29510",
    "lsad": "25",
    "name": "St. Louis",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1926,
    "affgeoid": "0500000US29186",
    "aland": 1292800498,
    "awater": 19739775,
    "countyfp": "186",
    "countyns": "00765806",
    "dotregion": 7,
    "geoid": "29186",
    "lsad": "06",
    "name": "Ste. Genevieve",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 186,
    "affgeoid": "0500000US29207",
    "aland": 2132128413,
    "awater": 15028304,
    "countyfp": "207",
    "countyns": "00758556",
    "dotregion": 7,
    "geoid": "29207",
    "lsad": "06",
    "name": "Stoddard",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1505,
    "affgeoid": "0500000US29209",
    "aland": 1201848046,
    "awater": 121059167,
    "countyfp": "209",
    "countyns": "00758557",
    "dotregion": 7,
    "geoid": "29209",
    "lsad": "06",
    "name": "Stone",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2493,
    "affgeoid": "0500000US29211",
    "aland": 1678264468,
    "awater": 9123184,
    "countyfp": "211",
    "countyns": "00758558",
    "dotregion": 7,
    "geoid": "29211",
    "lsad": "06",
    "name": "Sullivan",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 2613,
    "affgeoid": "0500000US29213",
    "aland": 1638012284,
    "awater": 49727408,
    "countyfp": "213",
    "countyns": "00758559",
    "dotregion": 7,
    "geoid": "29213",
    "lsad": "06",
    "name": "Taney",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 598,
    "affgeoid": "0500000US29215",
    "aland": 3049104542,
    "awater": 5071080,
    "countyfp": "215",
    "countyns": "00758560",
    "dotregion": 7,
    "geoid": "29215",
    "lsad": "06",
    "name": "Texas",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 516,
    "affgeoid": "0500000US29217",
    "aland": 2140347625,
    "awater": 27016451,
    "countyfp": "217",
    "countyns": "00758561",
    "dotregion": 7,
    "geoid": "29217",
    "lsad": "06",
    "name": "Vernon",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3023,
    "affgeoid": "0500000US29219",
    "aland": 1110070577,
    "awater": 23748217,
    "countyfp": "219",
    "countyns": "00758562",
    "dotregion": 7,
    "geoid": "29219",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1481,
    "affgeoid": "0500000US29221",
    "aland": 1968056214,
    "awater": 6778977,
    "countyfp": "221",
    "countyns": "00758563",
    "dotregion": 7,
    "geoid": "29221",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 3093,
    "affgeoid": "0500000US29223",
    "aland": 1966257798,
    "awater": 38558983,
    "countyfp": "223",
    "countyns": "00758564",
    "dotregion": 7,
    "geoid": "29223",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1848,
    "affgeoid": "0500000US29225",
    "aland": 1534730221,
    "awater": 3110547,
    "countyfp": "225",
    "countyns": "00758565",
    "dotregion": 7,
    "geoid": "29225",
    "lsad": "06",
    "name": "Webster",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 486,
    "affgeoid": "0500000US29227",
    "aland": 690523564,
    "awater": 535323,
    "countyfp": "227",
    "countyns": "00758566",
    "dotregion": 7,
    "geoid": "29227",
    "lsad": "06",
    "name": "Worth",
    "stateAbbreviation": "MO",
    "stateId": 21
  }, {
    "id": 1489,
    "affgeoid": "0500000US29229",
    "aland": 1765780048,
    "awater": 3533325,
    "countyfp": "229",
    "countyns": "00758567",
    "dotregion": 7,
    "geoid": "29229",
    "lsad": "06",
    "name": "Wright",
    "stateAbbreviation": "MO",
    "stateId": 21
  }]
}, {
  "id": 15,
  "abbreviation": "MT",
  "affgeoid": "0400000US30",
  "aland": 376964776680,
  "awater": 3868193267,
  "dotregion": 8,
  "geoid": "30",
  "lsad": "00",
  "name": "Montana",
  "stateAbbreviation": "MT",
  "statefp": "30",
  "statens": "00767982",
  "counties": [{
    "id": 2899,
    "affgeoid": "0500000US30001",
    "aland": 14355471225,
    "awater": 78345572,
    "countyfp": "001",
    "countyns": "01719627",
    "dotregion": 8,
    "geoid": "30001",
    "lsad": "06",
    "name": "Beaverhead",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2509,
    "affgeoid": "0500000US30003",
    "aland": 12942492843,
    "awater": 49185856,
    "countyfp": "003",
    "countyns": "01716521",
    "dotregion": 8,
    "geoid": "30003",
    "lsad": "06",
    "name": "Big Horn",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2869,
    "affgeoid": "0500000US30005",
    "aland": 10948213994,
    "awater": 29079150,
    "countyfp": "005",
    "countyns": "01722470",
    "dotregion": 8,
    "geoid": "30005",
    "lsad": "06",
    "name": "Blaine",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1183,
    "affgeoid": "0500000US30007",
    "aland": 3087316637,
    "awater": 119289206,
    "countyfp": "007",
    "countyns": "01719625",
    "dotregion": 8,
    "geoid": "30007",
    "lsad": "06",
    "name": "Broadwater",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2177,
    "affgeoid": "0500000US30009",
    "aland": 5304126731,
    "awater": 34674674,
    "countyfp": "009",
    "countyns": "01720111",
    "dotregion": 8,
    "geoid": "30009",
    "lsad": "06",
    "name": "Carbon",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1958,
    "affgeoid": "0500000US30011",
    "aland": 8651779114,
    "awater": 19499108,
    "countyfp": "011",
    "countyns": "01688746",
    "dotregion": 8,
    "geoid": "30011",
    "lsad": "06",
    "name": "Carter",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 3025,
    "affgeoid": "0500000US30013",
    "aland": 6988361955,
    "awater": 34331733,
    "countyfp": "013",
    "countyns": "01719622",
    "dotregion": 8,
    "geoid": "30013",
    "lsad": "06",
    "name": "Cascade",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2992,
    "affgeoid": "0500000US30015",
    "aland": 10288581590,
    "awater": 62618447,
    "countyfp": "015",
    "countyns": "01719619",
    "dotregion": 8,
    "geoid": "30015",
    "lsad": "06",
    "name": "Chouteau",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1223,
    "affgeoid": "0500000US30017",
    "aland": 9798804902,
    "awater": 25523467,
    "countyfp": "017",
    "countyns": "01720109",
    "dotregion": 8,
    "geoid": "30017",
    "lsad": "06",
    "name": "Custer",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2822,
    "affgeoid": "0500000US30019",
    "aland": 3693585018,
    "awater": 1021697,
    "countyfp": "019",
    "countyns": "01637566",
    "dotregion": 8,
    "geoid": "30019",
    "lsad": "06",
    "name": "Daniels",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1930,
    "affgeoid": "0500000US30021",
    "aland": 6143899768,
    "awater": 29279964,
    "countyfp": "021",
    "countyns": "01715632",
    "dotregion": 8,
    "geoid": "30021",
    "lsad": "06",
    "name": "Dawson",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2891,
    "affgeoid": "0500000US30023",
    "aland": 1908004250,
    "awater": 12199241,
    "countyfp": "023",
    "countyns": "01719617",
    "dotregion": 8,
    "geoid": "30023",
    "lsad": "06",
    "name": "Deer Lodge",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2763,
    "affgeoid": "0500000US30025",
    "aland": 4196968853,
    "awater": 5915331,
    "countyfp": "025",
    "countyns": "01688745",
    "dotregion": 8,
    "geoid": "30025",
    "lsad": "06",
    "name": "Fallon",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1339,
    "affgeoid": "0500000US30027",
    "aland": 11238872754,
    "awater": 27700322,
    "countyfp": "027",
    "countyns": "01719614",
    "dotregion": 8,
    "geoid": "30027",
    "lsad": "06",
    "name": "Fergus",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2102,
    "affgeoid": "0500000US30029",
    "aland": 13175882902,
    "awater": 437082640,
    "countyfp": "029",
    "countyns": "01719611",
    "dotregion": 8,
    "geoid": "30029",
    "lsad": "06",
    "name": "Flathead",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2111,
    "affgeoid": "0500000US30031",
    "aland": 6746197554,
    "awater": 75237084,
    "countyfp": "031",
    "countyns": "01720053",
    "dotregion": 8,
    "geoid": "30031",
    "lsad": "06",
    "name": "Gallatin",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 712,
    "affgeoid": "0500000US30033",
    "aland": 12112207601,
    "awater": 446716183,
    "countyfp": "033",
    "countyns": "01716058",
    "dotregion": 8,
    "geoid": "30033",
    "lsad": "06",
    "name": "Garfield",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 978,
    "affgeoid": "0500000US30035",
    "aland": 7756722585,
    "awater": 106140211,
    "countyfp": "035",
    "countyns": "01719607",
    "dotregion": 8,
    "geoid": "30035",
    "lsad": "06",
    "name": "Glacier",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2485,
    "affgeoid": "0500000US30037",
    "aland": 3041743931,
    "awater": 2621792,
    "countyfp": "037",
    "countyns": "01723078",
    "dotregion": 8,
    "geoid": "30037",
    "lsad": "06",
    "name": "Golden Valley",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1666,
    "affgeoid": "0500000US30039",
    "aland": 4473268340,
    "awater": 14547083,
    "countyfp": "039",
    "countyns": "01719605",
    "dotregion": 8,
    "geoid": "30039",
    "lsad": "06",
    "name": "Granite",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 760,
    "affgeoid": "0500000US30041",
    "aland": 7509065661,
    "awater": 44201872,
    "countyfp": "041",
    "countyns": "01720048",
    "dotregion": 8,
    "geoid": "30041",
    "lsad": "06",
    "name": "Hill",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 3198,
    "affgeoid": "0500000US30043",
    "aland": 4291406516,
    "awater": 6605901,
    "countyfp": "043",
    "countyns": "01720045",
    "dotregion": 8,
    "geoid": "30043",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1134,
    "affgeoid": "0500000US30045",
    "aland": 4842662499,
    "awater": 2066731,
    "countyfp": "045",
    "countyns": "01719602",
    "dotregion": 8,
    "geoid": "30045",
    "lsad": "06",
    "name": "Judith Basin",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 3019,
    "affgeoid": "0500000US30047",
    "aland": 3860279421,
    "awater": 423557170,
    "countyfp": "047",
    "countyns": "01796943",
    "dotregion": 8,
    "geoid": "30047",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2943,
    "affgeoid": "0500000US30049",
    "aland": 8957621068,
    "awater": 101077021,
    "countyfp": "049",
    "countyns": "00793926",
    "dotregion": 8,
    "geoid": "30049",
    "lsad": "06",
    "name": "Lewis and Clark",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2648,
    "affgeoid": "0500000US30051",
    "aland": 3704088496,
    "awater": 44389510,
    "countyfp": "051",
    "countyns": "01720036",
    "dotregion": 8,
    "geoid": "30051",
    "lsad": "06",
    "name": "Liberty",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2360,
    "affgeoid": "0500000US30053",
    "aland": 9356922529,
    "awater": 161078666,
    "countyfp": "053",
    "countyns": "01720038",
    "dotregion": 8,
    "geoid": "30053",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2161,
    "affgeoid": "0500000US30057",
    "aland": 9293431729,
    "awater": 39686248,
    "countyfp": "057",
    "countyns": "01720033",
    "dotregion": 8,
    "geoid": "30057",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1787,
    "affgeoid": "0500000US30055",
    "aland": 6843602621,
    "awater": 103093129,
    "countyfp": "055",
    "countyns": "01716270",
    "dotregion": 8,
    "geoid": "30055",
    "lsad": "06",
    "name": "McCone",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1994,
    "affgeoid": "0500000US30059",
    "aland": 6194857385,
    "awater": 7404298,
    "countyfp": "059",
    "countyns": "01719600",
    "dotregion": 8,
    "geoid": "30059",
    "lsad": "06",
    "name": "Meagher",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2086,
    "affgeoid": "0500000US30061",
    "aland": 3158843928,
    "awater": 9897206,
    "countyfp": "061",
    "countyns": "01720030",
    "dotregion": 8,
    "geoid": "30061",
    "lsad": "06",
    "name": "Mineral",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 3179,
    "affgeoid": "0500000US30063",
    "aland": 6715988454,
    "awater": 64467912,
    "countyfp": "063",
    "countyns": "01719596",
    "dotregion": 8,
    "geoid": "30063",
    "lsad": "06",
    "name": "Missoula",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2163,
    "affgeoid": "0500000US30065",
    "aland": 4840652081,
    "awater": 7123215,
    "countyfp": "065",
    "countyns": "01719593",
    "dotregion": 8,
    "geoid": "30065",
    "lsad": "06",
    "name": "Musselshell",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1754,
    "affgeoid": "0500000US30067",
    "aland": 7259490989,
    "awater": 27015343,
    "countyfp": "067",
    "countyns": "01720027",
    "dotregion": 8,
    "geoid": "30067",
    "lsad": "06",
    "name": "Park",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1612,
    "affgeoid": "0500000US30069",
    "aland": 4288041275,
    "awater": 48927318,
    "countyfp": "069",
    "countyns": "01719590",
    "dotregion": 8,
    "geoid": "30069",
    "lsad": "06",
    "name": "Petroleum",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1232,
    "affgeoid": "0500000US30071",
    "aland": 13313557752,
    "awater": 185538524,
    "countyfp": "071",
    "countyns": "01720023",
    "dotregion": 8,
    "geoid": "30071",
    "lsad": "06",
    "name": "Phillips",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 607,
    "affgeoid": "0500000US30073",
    "aland": 4207497555,
    "awater": 43979774,
    "countyfp": "073",
    "countyns": "01719587",
    "dotregion": 8,
    "geoid": "30073",
    "lsad": "06",
    "name": "Pondera",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 487,
    "affgeoid": "0500000US30075",
    "aland": 8542358767,
    "awater": 1565958,
    "countyfp": "075",
    "countyns": "01719584",
    "dotregion": 8,
    "geoid": "30075",
    "lsad": "06",
    "name": "Powder River",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2332,
    "affgeoid": "0500000US30077",
    "aland": 6024437069,
    "awater": 16220808,
    "countyfp": "077",
    "countyns": "01720021",
    "dotregion": 8,
    "geoid": "30077",
    "lsad": "06",
    "name": "Powell",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1722,
    "affgeoid": "0500000US30079",
    "aland": 4497958392,
    "awater": 15092932,
    "countyfp": "079",
    "countyns": "01715847",
    "dotregion": 8,
    "geoid": "30079",
    "lsad": "06",
    "name": "Prairie",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2140,
    "affgeoid": "0500000US30081",
    "aland": 6192590028,
    "awater": 24247021,
    "countyfp": "081",
    "countyns": "01719582",
    "dotregion": 8,
    "geoid": "30081",
    "lsad": "06",
    "name": "Ravalli",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2534,
    "affgeoid": "0500000US30083",
    "aland": 5398471136,
    "awater": 49588405,
    "countyfp": "083",
    "countyns": "01715338",
    "dotregion": 8,
    "geoid": "30083",
    "lsad": "06",
    "name": "Richland",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2175,
    "affgeoid": "0500000US30085",
    "aland": 6097957344,
    "awater": 37820803,
    "countyfp": "085",
    "countyns": "01669428",
    "dotregion": 8,
    "geoid": "30085",
    "lsad": "06",
    "name": "Roosevelt",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 3132,
    "affgeoid": "0500000US30087",
    "aland": 12972748900,
    "awater": 43034238,
    "countyfp": "087",
    "countyns": "01716795",
    "dotregion": 8,
    "geoid": "30087",
    "lsad": "06",
    "name": "Rosebud",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1356,
    "affgeoid": "0500000US30089",
    "aland": 7149653471,
    "awater": 76377031,
    "countyfp": "089",
    "countyns": "01719578",
    "dotregion": 8,
    "geoid": "30089",
    "lsad": "06",
    "name": "Sanders",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 417,
    "affgeoid": "0500000US30091",
    "aland": 4340270472,
    "awater": 75077762,
    "countyfp": "091",
    "countyns": "01677577",
    "dotregion": 8,
    "geoid": "30091",
    "lsad": "06",
    "name": "Sheridan",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1171,
    "affgeoid": "0500000US30093",
    "aland": 1859598425,
    "awater": 1522160,
    "countyfp": "093",
    "countyns": "01719575",
    "dotregion": 8,
    "geoid": "30093",
    "lsad": "06",
    "name": "Silver Bow",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 3213,
    "affgeoid": "0500000US30095",
    "aland": 4653276351,
    "awater": 23988007,
    "countyfp": "095",
    "countyns": "01719572",
    "dotregion": 8,
    "geoid": "30095",
    "lsad": "06",
    "name": "Stillwater",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1011,
    "affgeoid": "0500000US30097",
    "aland": 4805558677,
    "awater": 17639847,
    "countyfp": "097",
    "countyns": "01719569",
    "dotregion": 8,
    "geoid": "30097",
    "lsad": "06",
    "name": "Sweet Grass",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2257,
    "affgeoid": "0500000US30099",
    "aland": 5883404830,
    "awater": 52657911,
    "countyfp": "099",
    "countyns": "01720018",
    "dotregion": 8,
    "geoid": "30099",
    "lsad": "06",
    "name": "Teton",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 1836,
    "affgeoid": "0500000US30101",
    "aland": 4959694374,
    "awater": 78009540,
    "countyfp": "101",
    "countyns": "01719566",
    "dotregion": 8,
    "geoid": "30101",
    "lsad": "06",
    "name": "Toole",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 3131,
    "affgeoid": "0500000US30103",
    "aland": 2532085947,
    "awater": 17149961,
    "countyfp": "103",
    "countyns": "01719563",
    "dotregion": 8,
    "geoid": "30103",
    "lsad": "06",
    "name": "Treasure",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2967,
    "affgeoid": "0500000US30105",
    "aland": 12758875092,
    "awater": 351462598,
    "countyfp": "105",
    "countyns": "01678923",
    "dotregion": 8,
    "geoid": "30105",
    "lsad": "06",
    "name": "Valley",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 164,
    "affgeoid": "0500000US30107",
    "aland": 3684213378,
    "awater": 13010925,
    "countyfp": "107",
    "countyns": "01719560",
    "dotregion": 8,
    "geoid": "30107",
    "lsad": "06",
    "name": "Wheatland",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 626,
    "affgeoid": "0500000US30109",
    "aland": 2301427764,
    "awater": 1756850,
    "countyfp": "109",
    "countyns": "01696629",
    "dotregion": 8,
    "geoid": "30109",
    "lsad": "06",
    "name": "Wibaux",
    "stateAbbreviation": "MT",
    "stateId": 15
  }, {
    "id": 2913,
    "affgeoid": "0500000US30111",
    "aland": 6819683757,
    "awater": 40851911,
    "countyfp": "111",
    "countyns": "01719558",
    "dotregion": 8,
    "geoid": "30111",
    "lsad": "06",
    "name": "Yellowstone",
    "stateAbbreviation": "MT",
    "stateId": 15
  }]
}, {
  "id": 17,
  "abbreviation": "NE",
  "affgeoid": "0400000US31",
  "aland": 198972429772,
  "awater": 1356294775,
  "dotregion": 7,
  "geoid": "31",
  "lsad": "00",
  "name": "Nebraska",
  "stateAbbreviation": "NE",
  "statefp": "31",
  "statens": "01779792",
  "counties": [{
    "id": 266,
    "affgeoid": "0500000US31001",
    "aland": 1458869089,
    "awater": 2481410,
    "countyfp": "001",
    "countyns": "00835823",
    "dotregion": 7,
    "geoid": "31001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1402,
    "affgeoid": "0500000US31003",
    "aland": 2220183811,
    "awater": 3558463,
    "countyfp": "003",
    "countyns": "00835824",
    "dotregion": 7,
    "geoid": "31003",
    "lsad": "06",
    "name": "Antelope",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 817,
    "affgeoid": "0500000US31005",
    "aland": 1852760329,
    "awater": 7644719,
    "countyfp": "005",
    "countyns": "00835825",
    "dotregion": 7,
    "geoid": "31005",
    "lsad": "06",
    "name": "Arthur",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1366,
    "affgeoid": "0500000US31007",
    "aland": 1932676935,
    "awater": 397069,
    "countyfp": "007",
    "countyns": "00835826",
    "dotregion": 7,
    "geoid": "31007",
    "lsad": "06",
    "name": "Banner",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 608,
    "affgeoid": "0500000US31009",
    "aland": 1840655370,
    "awater": 9443900,
    "countyfp": "009",
    "countyns": "00835827",
    "dotregion": 7,
    "geoid": "31009",
    "lsad": "06",
    "name": "Blaine",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 390,
    "affgeoid": "0500000US31011",
    "aland": 1778164057,
    "awater": 1718583,
    "countyfp": "011",
    "countyns": "00835828",
    "dotregion": 7,
    "geoid": "31011",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1806,
    "affgeoid": "0500000US31013",
    "aland": 2785005881,
    "awater": 6588657,
    "countyfp": "013",
    "countyns": "00835991",
    "dotregion": 7,
    "geoid": "31013",
    "lsad": "06",
    "name": "Box Butte",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 764,
    "affgeoid": "0500000US31015",
    "aland": 1398425586,
    "awater": 11890320,
    "countyfp": "015",
    "countyns": "00835829",
    "dotregion": 7,
    "geoid": "31015",
    "lsad": "06",
    "name": "Boyd",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 133,
    "affgeoid": "0500000US31017",
    "aland": 3163293928,
    "awater": 9814399,
    "countyfp": "017",
    "countyns": "00835830",
    "dotregion": 7,
    "geoid": "31017",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 666,
    "affgeoid": "0500000US31019",
    "aland": 2507357642,
    "awater": 18914607,
    "countyfp": "019",
    "countyns": "00835831",
    "dotregion": 7,
    "geoid": "31019",
    "lsad": "06",
    "name": "Buffalo",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1957,
    "affgeoid": "0500000US31021",
    "aland": 1273201441,
    "awater": 14186180,
    "countyfp": "021",
    "countyns": "00835832",
    "dotregion": 7,
    "geoid": "31021",
    "lsad": "06",
    "name": "Burt",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1031,
    "affgeoid": "0500000US31023",
    "aland": 1514884892,
    "awater": 15309110,
    "countyfp": "023",
    "countyns": "00835833",
    "dotregion": 7,
    "geoid": "31023",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1480,
    "affgeoid": "0500000US31025",
    "aland": 1443779582,
    "awater": 21872205,
    "countyfp": "025",
    "countyns": "00835834",
    "dotregion": 7,
    "geoid": "31025",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1203,
    "affgeoid": "0500000US31027",
    "aland": 1917398594,
    "awater": 14335219,
    "countyfp": "027",
    "countyns": "00835835",
    "dotregion": 7,
    "geoid": "31027",
    "lsad": "06",
    "name": "Cedar",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1427,
    "affgeoid": "0500000US31029",
    "aland": 2316533577,
    "awater": 7978174,
    "countyfp": "029",
    "countyns": "00835836",
    "dotregion": 7,
    "geoid": "31029",
    "lsad": "06",
    "name": "Chase",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2639,
    "affgeoid": "0500000US31031",
    "aland": 15437761321,
    "awater": 126677223,
    "countyfp": "031",
    "countyns": "00835837",
    "dotregion": 7,
    "geoid": "31031",
    "lsad": "06",
    "name": "Cherry",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 637,
    "affgeoid": "0500000US31033",
    "aland": 3098367773,
    "awater": 292549,
    "countyfp": "033",
    "countyns": "00835838",
    "dotregion": 7,
    "geoid": "31033",
    "lsad": "06",
    "name": "Cheyenne",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 85,
    "affgeoid": "0500000US31035",
    "aland": 1482222907,
    "awater": 3234878,
    "countyfp": "035",
    "countyns": "00835839",
    "dotregion": 7,
    "geoid": "31035",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 215,
    "affgeoid": "0500000US31037",
    "aland": 1066165102,
    "awater": 12606715,
    "countyfp": "037",
    "countyns": "00835840",
    "dotregion": 7,
    "geoid": "31037",
    "lsad": "06",
    "name": "Colfax",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1898,
    "affgeoid": "0500000US31039",
    "aland": 1477895811,
    "awater": 10447360,
    "countyfp": "039",
    "countyns": "00835841",
    "dotregion": 7,
    "geoid": "31039",
    "lsad": "06",
    "name": "Cuming",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1852,
    "affgeoid": "0500000US31041",
    "aland": 6670698531,
    "awater": 932956,
    "countyfp": "041",
    "countyns": "00835842",
    "dotregion": 7,
    "geoid": "31041",
    "lsad": "06",
    "name": "Custer",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2638,
    "affgeoid": "0500000US31043",
    "aland": 684416193,
    "awater": 8199775,
    "countyfp": "043",
    "countyns": "00835843",
    "dotregion": 7,
    "geoid": "31043",
    "lsad": "06",
    "name": "Dakota",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 37,
    "affgeoid": "0500000US31045",
    "aland": 3616823755,
    "awater": 11921995,
    "countyfp": "045",
    "countyns": "00835844",
    "dotregion": 7,
    "geoid": "31045",
    "lsad": "06",
    "name": "Dawes",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1794,
    "affgeoid": "0500000US31047",
    "aland": 2623947385,
    "awater": 16371626,
    "countyfp": "047",
    "countyns": "00835845",
    "dotregion": 7,
    "geoid": "31047",
    "lsad": "06",
    "name": "Dawson",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 491,
    "affgeoid": "0500000US31049",
    "aland": 1139208969,
    "awater": 2230956,
    "countyfp": "049",
    "countyns": "00835846",
    "dotregion": 7,
    "geoid": "31049",
    "lsad": "06",
    "name": "Deuel",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1590,
    "affgeoid": "0500000US31051",
    "aland": 1233434227,
    "awater": 17271581,
    "countyfp": "051",
    "countyns": "00835847",
    "dotregion": 7,
    "geoid": "31051",
    "lsad": "06",
    "name": "Dixon",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 219,
    "affgeoid": "0500000US31053",
    "aland": 1369377419,
    "awater": 36983845,
    "countyfp": "053",
    "countyns": "00835848",
    "dotregion": 7,
    "geoid": "31053",
    "lsad": "06",
    "name": "Dodge",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2741,
    "affgeoid": "0500000US31055",
    "aland": 850772343,
    "awater": 28132018,
    "countyfp": "055",
    "countyns": "00835849",
    "dotregion": 7,
    "geoid": "31055",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2790,
    "affgeoid": "0500000US31057",
    "aland": 2381955215,
    "awater": 3046330,
    "countyfp": "057",
    "countyns": "00835850",
    "dotregion": 7,
    "geoid": "31057",
    "lsad": "06",
    "name": "Dundy",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2238,
    "affgeoid": "0500000US31059",
    "aland": 1490202786,
    "awater": 2989990,
    "countyfp": "059",
    "countyns": "00835851",
    "dotregion": 7,
    "geoid": "31059",
    "lsad": "06",
    "name": "Fillmore",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1070,
    "affgeoid": "0500000US31061",
    "aland": 1491355770,
    "awater": 487899,
    "countyfp": "061",
    "countyns": "00835852",
    "dotregion": 7,
    "geoid": "31061",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1772,
    "affgeoid": "0500000US31063",
    "aland": 2524180468,
    "awater": 14212842,
    "countyfp": "063",
    "countyns": "00835853",
    "dotregion": 7,
    "geoid": "31063",
    "lsad": "06",
    "name": "Frontier",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1791,
    "affgeoid": "0500000US31065",
    "aland": 1862542307,
    "awater": 3915843,
    "countyfp": "065",
    "countyns": "00835854",
    "dotregion": 7,
    "geoid": "31065",
    "lsad": "06",
    "name": "Furnas",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1504,
    "affgeoid": "0500000US31067",
    "aland": 2205274215,
    "awater": 22014404,
    "countyfp": "067",
    "countyns": "00835855",
    "dotregion": 7,
    "geoid": "31067",
    "lsad": "06",
    "name": "Gage",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2327,
    "affgeoid": "0500000US31069",
    "aland": 4414047809,
    "awater": 68874632,
    "countyfp": "069",
    "countyns": "00835856",
    "dotregion": 7,
    "geoid": "31069",
    "lsad": "06",
    "name": "Garden",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 663,
    "affgeoid": "0500000US31071",
    "aland": 1475757743,
    "awater": 4125559,
    "countyfp": "071",
    "countyns": "00835857",
    "dotregion": 7,
    "geoid": "31071",
    "lsad": "06",
    "name": "Garfield",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2766,
    "affgeoid": "0500000US31073",
    "aland": 1186616236,
    "awater": 11831826,
    "countyfp": "073",
    "countyns": "00835858",
    "dotregion": 7,
    "geoid": "31073",
    "lsad": "06",
    "name": "Gosper",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 713,
    "affgeoid": "0500000US31075",
    "aland": 2010407809,
    "awater": 18130867,
    "countyfp": "075",
    "countyns": "00835859",
    "dotregion": 7,
    "geoid": "31075",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2410,
    "affgeoid": "0500000US31077",
    "aland": 1475804184,
    "awater": 2188873,
    "countyfp": "077",
    "countyns": "00835860",
    "dotregion": 7,
    "geoid": "31077",
    "lsad": "06",
    "name": "Greeley",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 356,
    "affgeoid": "0500000US31079",
    "aland": 1414817883,
    "awater": 15229247,
    "countyfp": "079",
    "countyns": "00835861",
    "dotregion": 7,
    "geoid": "31079",
    "lsad": "06",
    "name": "Hall",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 394,
    "affgeoid": "0500000US31081",
    "aland": 1403528265,
    "awater": 7341100,
    "countyfp": "081",
    "countyns": "00835862",
    "dotregion": 7,
    "geoid": "31081",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 364,
    "affgeoid": "0500000US31083",
    "aland": 1433471290,
    "awater": 53339808,
    "countyfp": "083",
    "countyns": "00835863",
    "dotregion": 7,
    "geoid": "31083",
    "lsad": "06",
    "name": "Harlan",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 510,
    "affgeoid": "0500000US31085",
    "aland": 1846821514,
    "awater": 570786,
    "countyfp": "085",
    "countyns": "00835864",
    "dotregion": 7,
    "geoid": "31085",
    "lsad": "06",
    "name": "Hayes",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1277,
    "affgeoid": "0500000US31087",
    "aland": 1838742723,
    "awater": 22103380,
    "countyfp": "087",
    "countyns": "00835865",
    "dotregion": 7,
    "geoid": "31087",
    "lsad": "06",
    "name": "Hitchcock",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1388,
    "affgeoid": "0500000US31089",
    "aland": 6248082957,
    "awater": 13201503,
    "countyfp": "089",
    "countyns": "00835866",
    "dotregion": 7,
    "geoid": "31089",
    "lsad": "06",
    "name": "Holt",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2000,
    "affgeoid": "0500000US31091",
    "aland": 1867683338,
    "awater": 882994,
    "countyfp": "091",
    "countyns": "00835867",
    "dotregion": 7,
    "geoid": "31091",
    "lsad": "06",
    "name": "Hooker",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2724,
    "affgeoid": "0500000US31093",
    "aland": 1474578442,
    "awater": 16199404,
    "countyfp": "093",
    "countyns": "00835868",
    "dotregion": 7,
    "geoid": "31093",
    "lsad": "06",
    "name": "Howard",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 501,
    "affgeoid": "0500000US31095",
    "aland": 1476728674,
    "awater": 14239894,
    "countyfp": "095",
    "countyns": "00835869",
    "dotregion": 7,
    "geoid": "31095",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 459,
    "affgeoid": "0500000US31097",
    "aland": 973968227,
    "awater": 1766531,
    "countyfp": "097",
    "countyns": "00835870",
    "dotregion": 7,
    "geoid": "31097",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2514,
    "affgeoid": "0500000US31099",
    "aland": 1337063628,
    "awater": 274634,
    "countyfp": "099",
    "countyns": "00835871",
    "dotregion": 7,
    "geoid": "31099",
    "lsad": "06",
    "name": "Kearney",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2867,
    "affgeoid": "0500000US31101",
    "aland": 2749565257,
    "awater": 124671559,
    "countyfp": "101",
    "countyns": "00835872",
    "dotregion": 7,
    "geoid": "31101",
    "lsad": "06",
    "name": "Keith",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 416,
    "affgeoid": "0500000US31103",
    "aland": 2002258342,
    "awater": 2192458,
    "countyfp": "103",
    "countyns": "00835873",
    "dotregion": 7,
    "geoid": "31103",
    "lsad": "06",
    "name": "Keya Paha",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1401,
    "affgeoid": "0500000US31105",
    "aland": 2465269098,
    "awater": 1448446,
    "countyfp": "105",
    "countyns": "00835874",
    "dotregion": 7,
    "geoid": "31105",
    "lsad": "06",
    "name": "Kimball",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2973,
    "affgeoid": "0500000US31107",
    "aland": 2870614961,
    "awater": 81251136,
    "countyfp": "107",
    "countyns": "00835875",
    "dotregion": 7,
    "geoid": "31107",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1659,
    "affgeoid": "0500000US31109",
    "aland": 2169240202,
    "awater": 22877180,
    "countyfp": "109",
    "countyns": "00835876",
    "dotregion": 7,
    "geoid": "31109",
    "lsad": "06",
    "name": "Lancaster",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2267,
    "affgeoid": "0500000US31111",
    "aland": 6640907003,
    "awater": 28630225,
    "countyfp": "111",
    "countyns": "00835877",
    "dotregion": 7,
    "geoid": "31111",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2166,
    "affgeoid": "0500000US31113",
    "aland": 1477985406,
    "awater": 1203586,
    "countyfp": "113",
    "countyns": "00835878",
    "dotregion": 7,
    "geoid": "31113",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 43,
    "affgeoid": "0500000US31115",
    "aland": 1471707073,
    "awater": 7275368,
    "countyfp": "115",
    "countyns": "00835879",
    "dotregion": 7,
    "geoid": "31115",
    "lsad": "06",
    "name": "Loup",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1395,
    "affgeoid": "0500000US31119",
    "aland": 1483396631,
    "awater": 7013730,
    "countyfp": "119",
    "countyns": "00835880",
    "dotregion": 7,
    "geoid": "31119",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1413,
    "affgeoid": "0500000US31117",
    "aland": 2224742895,
    "awater": 2680669,
    "countyfp": "117",
    "countyns": "00835881",
    "dotregion": 7,
    "geoid": "31117",
    "lsad": "06",
    "name": "McPherson",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2196,
    "affgeoid": "0500000US31121",
    "aland": 1258350314,
    "awater": 28301129,
    "countyfp": "121",
    "countyns": "00835882",
    "dotregion": 7,
    "geoid": "31121",
    "lsad": "06",
    "name": "Merrick",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 574,
    "affgeoid": "0500000US31123",
    "aland": 3687727802,
    "awater": 15598670,
    "countyfp": "123",
    "countyns": "00835883",
    "dotregion": 7,
    "geoid": "31123",
    "lsad": "06",
    "name": "Morrill",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1770,
    "affgeoid": "0500000US31125",
    "aland": 1143826264,
    "awater": 17085923,
    "countyfp": "125",
    "countyns": "00835884",
    "dotregion": 7,
    "geoid": "31125",
    "lsad": "06",
    "name": "Nance",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 357,
    "affgeoid": "0500000US31127",
    "aland": 1055100609,
    "awater": 5769943,
    "countyfp": "127",
    "countyns": "00835885",
    "dotregion": 7,
    "geoid": "31127",
    "lsad": "06",
    "name": "Nemaha",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2975,
    "affgeoid": "0500000US31129",
    "aland": 1489645187,
    "awater": 1718484,
    "countyfp": "129",
    "countyns": "00835886",
    "dotregion": 7,
    "geoid": "31129",
    "lsad": "06",
    "name": "Nuckolls",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 727,
    "affgeoid": "0500000US31131",
    "aland": 1594475628,
    "awater": 8775373,
    "countyfp": "131",
    "countyns": "00835887",
    "dotregion": 7,
    "geoid": "31131",
    "lsad": "06",
    "name": "Otoe",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1882,
    "affgeoid": "0500000US31133",
    "aland": 1116478188,
    "awater": 4852361,
    "countyfp": "133",
    "countyns": "00835888",
    "dotregion": 7,
    "geoid": "31133",
    "lsad": "06",
    "name": "Pawnee",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1476,
    "affgeoid": "0500000US31135",
    "aland": 2287828000,
    "awater": 2840176,
    "countyfp": "135",
    "countyns": "00835889",
    "dotregion": 7,
    "geoid": "31135",
    "lsad": "06",
    "name": "Perkins",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 599,
    "affgeoid": "0500000US31137",
    "aland": 1398048578,
    "awater": 1646534,
    "countyfp": "137",
    "countyns": "00835890",
    "dotregion": 7,
    "geoid": "31137",
    "lsad": "06",
    "name": "Phelps",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 178,
    "affgeoid": "0500000US31139",
    "aland": 1484707285,
    "awater": 3481943,
    "countyfp": "139",
    "countyns": "00835891",
    "dotregion": 7,
    "geoid": "31139",
    "lsad": "06",
    "name": "Pierce",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2952,
    "affgeoid": "0500000US31141",
    "aland": 1745758248,
    "awater": 27319783,
    "countyfp": "141",
    "countyns": "00835892",
    "dotregion": 7,
    "geoid": "31141",
    "lsad": "06",
    "name": "Platte",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2220,
    "affgeoid": "0500000US31143",
    "aland": 1135309850,
    "awater": 5947394,
    "countyfp": "143",
    "countyns": "00835893",
    "dotregion": 7,
    "geoid": "31143",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1727,
    "affgeoid": "0500000US31145",
    "aland": 1856984023,
    "awater": 2643458,
    "countyfp": "145",
    "countyns": "00835894",
    "dotregion": 7,
    "geoid": "31145",
    "lsad": "06",
    "name": "Red Willow",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 88,
    "affgeoid": "0500000US31147",
    "aland": 1429258642,
    "awater": 7077617,
    "countyfp": "147",
    "countyns": "00835895",
    "dotregion": 7,
    "geoid": "31147",
    "lsad": "06",
    "name": "Richardson",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2789,
    "affgeoid": "0500000US31149",
    "aland": 2611500852,
    "awater": 8807750,
    "countyfp": "149",
    "countyns": "00835896",
    "dotregion": 7,
    "geoid": "31149",
    "lsad": "06",
    "name": "Rock",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 3086,
    "affgeoid": "0500000US31151",
    "aland": 1486698708,
    "awater": 5934626,
    "countyfp": "151",
    "countyns": "00835897",
    "dotregion": 7,
    "geoid": "31151",
    "lsad": "06",
    "name": "Saline",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 728,
    "affgeoid": "0500000US31153",
    "aland": 619058303,
    "awater": 22023421,
    "countyfp": "153",
    "countyns": "00835898",
    "dotregion": 7,
    "geoid": "31153",
    "lsad": "06",
    "name": "Sarpy",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1157,
    "affgeoid": "0500000US31155",
    "aland": 1943097564,
    "awater": 24827641,
    "countyfp": "155",
    "countyns": "00835899",
    "dotregion": 7,
    "geoid": "31155",
    "lsad": "06",
    "name": "Saunders",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 57,
    "affgeoid": "0500000US31157",
    "aland": 1915039161,
    "awater": 15437668,
    "countyfp": "157",
    "countyns": "00835900",
    "dotregion": 7,
    "geoid": "31157",
    "lsad": "06",
    "name": "Scotts Bluff",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1619,
    "affgeoid": "0500000US31159",
    "aland": 1479990669,
    "awater": 11547536,
    "countyfp": "159",
    "countyns": "00835901",
    "dotregion": 7,
    "geoid": "31159",
    "lsad": "06",
    "name": "Seward",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 784,
    "affgeoid": "0500000US31161",
    "aland": 6321831894,
    "awater": 74941797,
    "countyfp": "161",
    "countyns": "00835902",
    "dotregion": 7,
    "geoid": "31161",
    "lsad": "06",
    "name": "Sheridan",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 298,
    "affgeoid": "0500000US31163",
    "aland": 1465489243,
    "awater": 15062146,
    "countyfp": "163",
    "countyns": "00835903",
    "dotregion": 7,
    "geoid": "31163",
    "lsad": "06",
    "name": "Sherman",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2450,
    "affgeoid": "0500000US31165",
    "aland": 5352525304,
    "awater": 1872668,
    "countyfp": "165",
    "countyns": "00835904",
    "dotregion": 7,
    "geoid": "31165",
    "lsad": "06",
    "name": "Sioux",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2214,
    "affgeoid": "0500000US31167",
    "aland": 1108381539,
    "awater": 7908771,
    "countyfp": "167",
    "countyns": "00835905",
    "dotregion": 7,
    "geoid": "31167",
    "lsad": "06",
    "name": "Stanton",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2255,
    "affgeoid": "0500000US31169",
    "aland": 1486153354,
    "awater": 3025340,
    "countyfp": "169",
    "countyns": "00835906",
    "dotregion": 7,
    "geoid": "31169",
    "lsad": "06",
    "name": "Thayer",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 420,
    "affgeoid": "0500000US31171",
    "aland": 1846268434,
    "awater": 2028358,
    "countyfp": "171",
    "countyns": "00835907",
    "dotregion": 7,
    "geoid": "31171",
    "lsad": "06",
    "name": "Thomas",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 228,
    "affgeoid": "0500000US31173",
    "aland": 1019377255,
    "awater": 6458660,
    "countyfp": "173",
    "countyns": "00835908",
    "dotregion": 7,
    "geoid": "31173",
    "lsad": "06",
    "name": "Thurston",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1713,
    "affgeoid": "0500000US31175",
    "aland": 1471237003,
    "awater": 6242699,
    "countyfp": "175",
    "countyns": "00835909",
    "dotregion": 7,
    "geoid": "31175",
    "lsad": "06",
    "name": "Valley",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2109,
    "affgeoid": "0500000US31177",
    "aland": 1009985946,
    "awater": 8387724,
    "countyfp": "177",
    "countyns": "00835910",
    "dotregion": 7,
    "geoid": "31177",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2850,
    "affgeoid": "0500000US31179",
    "aland": 1147143904,
    "awater": 1087702,
    "countyfp": "179",
    "countyns": "00835911",
    "dotregion": 7,
    "geoid": "31179",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 1760,
    "affgeoid": "0500000US31181",
    "aland": 1489017969,
    "awater": 337241,
    "countyfp": "181",
    "countyns": "00835912",
    "dotregion": 7,
    "geoid": "31181",
    "lsad": "06",
    "name": "Webster",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 94,
    "affgeoid": "0500000US31183",
    "aland": 1489739734,
    "awater": 1059454,
    "countyfp": "183",
    "countyns": "00835913",
    "dotregion": 7,
    "geoid": "31183",
    "lsad": "06",
    "name": "Wheeler",
    "stateAbbreviation": "NE",
    "stateId": 17
  }, {
    "id": 2851,
    "affgeoid": "0500000US31185",
    "aland": 1482793517,
    "awater": 8595590,
    "countyfp": "185",
    "countyns": "00835914",
    "dotregion": 7,
    "geoid": "31185",
    "lsad": "06",
    "name": "York",
    "stateAbbreviation": "NE",
    "stateId": 17
  }]
}, {
  "id": 34,
  "abbreviation": "NV",
  "affgeoid": "0400000US32",
  "aland": 284332114099,
  "awater": 2047841189,
  "dotregion": 9,
  "geoid": "32",
  "lsad": "00",
  "name": "Nevada",
  "stateAbbreviation": "NV",
  "statefp": "32",
  "statens": "01779793",
  "counties": [{
    "id": 2495,
    "affgeoid": "0500000US32510",
    "aland": 374669606,
    "awater": 32587484,
    "countyfp": "510",
    "countyns": "00863219",
    "dotregion": 9,
    "geoid": "32510",
    "lsad": "00",
    "name": "Carson City",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2815,
    "affgeoid": "0500000US32001",
    "aland": 12770148576,
    "awater": 242405502,
    "countyfp": "001",
    "countyns": "00858638",
    "dotregion": 9,
    "geoid": "32001",
    "lsad": "06",
    "name": "Churchill",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2152,
    "affgeoid": "0500000US32003",
    "aland": 20438834319,
    "awater": 438841388,
    "countyfp": "003",
    "countyns": "00863600",
    "dotregion": 9,
    "geoid": "32003",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 1164,
    "affgeoid": "0500000US32005",
    "aland": 1838162296,
    "awater": 72317570,
    "countyfp": "005",
    "countyns": "00858643",
    "dotregion": 9,
    "geoid": "32005",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 3161,
    "affgeoid": "0500000US32007",
    "aland": 44471193293,
    "awater": 85747701,
    "countyfp": "007",
    "countyns": "00857664",
    "dotregion": 9,
    "geoid": "32007",
    "lsad": "06",
    "name": "Elko",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2806,
    "affgeoid": "0500000US32009",
    "aland": 9277052939,
    "awater": 18552011,
    "countyfp": "009",
    "countyns": "00858641",
    "dotregion": 9,
    "geoid": "32009",
    "lsad": "06",
    "name": "Esmeralda",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 538,
    "affgeoid": "0500000US32011",
    "aland": 10814963933,
    "awater": 11082875,
    "countyfp": "011",
    "countyns": "00858640",
    "dotregion": 9,
    "geoid": "32011",
    "lsad": "06",
    "name": "Eureka",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2832,
    "affgeoid": "0500000US32013",
    "aland": 24969524844,
    "awater": 44196979,
    "countyfp": "013",
    "countyns": "00863310",
    "dotregion": 9,
    "geoid": "32013",
    "lsad": "06",
    "name": "Humboldt",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 3065,
    "affgeoid": "0500000US32015",
    "aland": 14219255502,
    "awater": 76103226,
    "countyfp": "015",
    "countyns": "00863368",
    "dotregion": 9,
    "geoid": "32015",
    "lsad": "06",
    "name": "Lander",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2372,
    "affgeoid": "0500000US32017",
    "aland": 27540364862,
    "awater": 9802713,
    "countyfp": "017",
    "countyns": "00863992",
    "dotregion": 9,
    "geoid": "32017",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2949,
    "affgeoid": "0500000US32019",
    "aland": 5183310353,
    "awater": 59602530,
    "countyfp": "019",
    "countyns": "00858645",
    "dotregion": 9,
    "geoid": "32019",
    "lsad": "06",
    "name": "Lyon",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2872,
    "affgeoid": "0500000US32021",
    "aland": 9719802099,
    "awater": 155746685,
    "countyfp": "021",
    "countyns": "00858644",
    "dotregion": 9,
    "geoid": "32021",
    "lsad": "06",
    "name": "Mineral",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2984,
    "affgeoid": "0500000US32023",
    "aland": 47091002405,
    "awater": 43207981,
    "countyfp": "023",
    "countyns": "00863599",
    "dotregion": 9,
    "geoid": "32023",
    "lsad": "06",
    "name": "Nye",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 1283,
    "affgeoid": "0500000US32027",
    "aland": 15634723159,
    "awater": 79934451,
    "countyfp": "027",
    "countyns": "00858646",
    "dotregion": 9,
    "geoid": "32027",
    "lsad": "06",
    "name": "Pershing",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 1286,
    "affgeoid": "0500000US32029",
    "aland": 680962190,
    "awater": 1871089,
    "countyfp": "029",
    "countyns": "00858642",
    "dotregion": 9,
    "geoid": "32029",
    "lsad": "06",
    "name": "Storey",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2451,
    "affgeoid": "0500000US32031",
    "aland": 16323089034,
    "awater": 621162127,
    "countyfp": "031",
    "countyns": "00858608",
    "dotregion": 9,
    "geoid": "32031",
    "lsad": "06",
    "name": "Washoe",
    "stateAbbreviation": "NV",
    "stateId": 34
  }, {
    "id": 2925,
    "affgeoid": "0500000US32033",
    "aland": 22985054689,
    "awater": 54678877,
    "countyfp": "033",
    "countyns": "00858615",
    "dotregion": 9,
    "geoid": "32033",
    "lsad": "06",
    "name": "White Pine",
    "stateAbbreviation": "NV",
    "stateId": 34
  }]
}, {
  "id": 52,
  "abbreviation": "NH",
  "affgeoid": "0400000US33",
  "aland": 23188026108,
  "awater": 1026190438,
  "dotregion": 1,
  "geoid": "33",
  "lsad": "00",
  "name": "New Hampshire",
  "stateAbbreviation": "NH",
  "statefp": "33",
  "statens": "01779794",
  "counties": [{
    "id": 175,
    "affgeoid": "0500000US33001",
    "aland": 1036582285,
    "awater": 177039289,
    "countyfp": "001",
    "countyns": "00873174",
    "dotregion": 1,
    "geoid": "33001",
    "lsad": "06",
    "name": "Belknap",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 1216,
    "affgeoid": "0500000US33003",
    "aland": 2411467696,
    "awater": 158924712,
    "countyfp": "003",
    "countyns": "00873175",
    "dotregion": 1,
    "geoid": "33003",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 3178,
    "affgeoid": "0500000US33005",
    "aland": 1830365875,
    "awater": 57990894,
    "countyfp": "005",
    "countyns": "00873176",
    "dotregion": 1,
    "geoid": "33005",
    "lsad": "06",
    "name": "Cheshire",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 1335,
    "affgeoid": "0500000US33007",
    "aland": 4648216850,
    "awater": 90773914,
    "countyfp": "007",
    "countyns": "00873177",
    "dotregion": 1,
    "geoid": "33007",
    "lsad": "06",
    "name": "Coos",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 3117,
    "affgeoid": "0500000US33009",
    "aland": 4425926973,
    "awater": 105375540,
    "countyfp": "009",
    "countyns": "00873178",
    "dotregion": 1,
    "geoid": "33009",
    "lsad": "06",
    "name": "Grafton",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 729,
    "affgeoid": "0500000US33011",
    "aland": 2269346872,
    "awater": 41478107,
    "countyfp": "011",
    "countyns": "00873179",
    "dotregion": 1,
    "geoid": "33011",
    "lsad": "06",
    "name": "Hillsborough",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 1362,
    "affgeoid": "0500000US33013",
    "aland": 2419397118,
    "awater": 57788836,
    "countyfp": "013",
    "countyns": "00873180",
    "dotregion": 1,
    "geoid": "33013",
    "lsad": "06",
    "name": "Merrimack",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 2012,
    "affgeoid": "0500000US33015",
    "aland": 1799732526,
    "awater": 259591042,
    "countyfp": "015",
    "countyns": "00873181",
    "dotregion": 1,
    "geoid": "33015",
    "lsad": "06",
    "name": "Rockingham",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 2884,
    "affgeoid": "0500000US33017",
    "aland": 955401999,
    "awater": 39157533,
    "countyfp": "017",
    "countyns": "00873182",
    "dotregion": 1,
    "geoid": "33017",
    "lsad": "06",
    "name": "Strafford",
    "stateAbbreviation": "NH",
    "stateId": 52
  }, {
    "id": 1444,
    "affgeoid": "0500000US33019",
    "aland": 1391587914,
    "awater": 38070571,
    "countyfp": "019",
    "countyns": "00873183",
    "dotregion": 1,
    "geoid": "33019",
    "lsad": "06",
    "name": "Sullivan",
    "stateAbbreviation": "NH",
    "stateId": 52
  }]
}, {
  "id": 50,
  "abbreviation": "NJ",
  "affgeoid": "0400000US34",
  "aland": 19048075783,
  "awater": 3543447118,
  "dotregion": 2,
  "geoid": "34",
  "lsad": "00",
  "name": "New Jersey",
  "stateAbbreviation": "NJ",
  "statefp": "34",
  "statens": "01779795",
  "counties": [{
    "id": 2680,
    "affgeoid": "0500000US34001",
    "aland": 1439256827,
    "awater": 300767732,
    "countyfp": "001",
    "countyns": "00882270",
    "dotregion": 2,
    "geoid": "34001",
    "lsad": "06",
    "name": "Atlantic",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 3218,
    "affgeoid": "0500000US34003",
    "aland": 603605810,
    "awater": 35276008,
    "countyfp": "003",
    "countyns": "00882271",
    "dotregion": 2,
    "geoid": "34003",
    "lsad": "06",
    "name": "Bergen",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1983,
    "affgeoid": "0500000US34005",
    "aland": 2068300220,
    "awater": 55071387,
    "countyfp": "005",
    "countyns": "00882272",
    "dotregion": 2,
    "geoid": "34005",
    "lsad": "06",
    "name": "Burlington",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2813,
    "affgeoid": "0500000US34007",
    "aland": 573077187,
    "awater": 15607750,
    "countyfp": "007",
    "countyns": "00882273",
    "dotregion": 2,
    "geoid": "34007",
    "lsad": "06",
    "name": "Camden",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 3068,
    "affgeoid": "0500000US34009",
    "aland": 651209688,
    "awater": 955666476,
    "countyfp": "009",
    "countyns": "00882274",
    "dotregion": 2,
    "geoid": "34009",
    "lsad": "06",
    "name": "Cape May",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2013,
    "affgeoid": "0500000US34011",
    "aland": 1252937239,
    "awater": 502091171,
    "countyfp": "011",
    "countyns": "00882275",
    "dotregion": 2,
    "geoid": "34011",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1982,
    "affgeoid": "0500000US34013",
    "aland": 326923172,
    "awater": 8819138,
    "countyfp": "013",
    "countyns": "00882276",
    "dotregion": 2,
    "geoid": "34013",
    "lsad": "06",
    "name": "Essex",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1442,
    "affgeoid": "0500000US34015",
    "aland": 834029457,
    "awater": 39256273,
    "countyfp": "015",
    "countyns": "00882277",
    "dotregion": 2,
    "geoid": "34015",
    "lsad": "06",
    "name": "Gloucester",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1259,
    "affgeoid": "0500000US34017",
    "aland": 119573183,
    "awater": 41957227,
    "countyfp": "017",
    "countyns": "00882278",
    "dotregion": 2,
    "geoid": "34017",
    "lsad": "06",
    "name": "Hudson",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 3051,
    "affgeoid": "0500000US34019",
    "aland": 1108086745,
    "awater": 24897574,
    "countyfp": "019",
    "countyns": "00882228",
    "dotregion": 2,
    "geoid": "34019",
    "lsad": "06",
    "name": "Hunterdon",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 3053,
    "affgeoid": "0500000US34021",
    "aland": 581629671,
    "awater": 11189320,
    "countyfp": "021",
    "countyns": "00882229",
    "dotregion": 2,
    "geoid": "34021",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1182,
    "affgeoid": "0500000US34023",
    "aland": 800430391,
    "awater": 35670780,
    "countyfp": "023",
    "countyns": "00882230",
    "dotregion": 2,
    "geoid": "34023",
    "lsad": "06",
    "name": "Middlesex",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1667,
    "affgeoid": "0500000US34025",
    "aland": 1213170996,
    "awater": 509997774,
    "countyfp": "025",
    "countyns": "00882910",
    "dotregion": 2,
    "geoid": "34025",
    "lsad": "06",
    "name": "Monmouth",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1304,
    "affgeoid": "0500000US34027",
    "aland": 1192173860,
    "awater": 55314215,
    "countyfp": "027",
    "countyns": "00882231",
    "dotregion": 2,
    "geoid": "34027",
    "lsad": "06",
    "name": "Morris",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 1971,
    "affgeoid": "0500000US34029",
    "aland": 1628693208,
    "awater": 742185053,
    "countyfp": "029",
    "countyns": "00882279",
    "dotregion": 2,
    "geoid": "34029",
    "lsad": "06",
    "name": "Ocean",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2164,
    "affgeoid": "0500000US34031",
    "aland": 480898988,
    "awater": 32017797,
    "countyfp": "031",
    "countyns": "00882232",
    "dotregion": 2,
    "geoid": "34031",
    "lsad": "06",
    "name": "Passaic",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2014,
    "affgeoid": "0500000US34033",
    "aland": 859872501,
    "awater": 104455871,
    "countyfp": "033",
    "countyns": "00882233",
    "dotregion": 2,
    "geoid": "34033",
    "lsad": "06",
    "name": "Salem",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2365,
    "affgeoid": "0500000US34035",
    "aland": 781584258,
    "awater": 7882445,
    "countyfp": "035",
    "countyns": "00882234",
    "dotregion": 2,
    "geoid": "34035",
    "lsad": "06",
    "name": "Somerset",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2463,
    "affgeoid": "0500000US34037",
    "aland": 1341722616,
    "awater": 43476185,
    "countyfp": "037",
    "countyns": "00882236",
    "dotregion": 2,
    "geoid": "34037",
    "lsad": "06",
    "name": "Sussex",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2641,
    "affgeoid": "0500000US34039",
    "aland": 266425133,
    "awater": 6573926,
    "countyfp": "039",
    "countyns": "00882235",
    "dotregion": 2,
    "geoid": "34039",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }, {
    "id": 2671,
    "affgeoid": "0500000US34041",
    "aland": 924474633,
    "awater": 15273016,
    "countyfp": "041",
    "countyns": "00882237",
    "dotregion": 2,
    "geoid": "34041",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "NJ",
    "stateId": 50
  }]
}, {
  "id": 44,
  "abbreviation": "NM",
  "affgeoid": "0400000US35",
  "aland": 314161426332,
  "awater": 755674004,
  "dotregion": 6,
  "geoid": "35",
  "lsad": "00",
  "name": "New Mexico",
  "stateAbbreviation": "NM",
  "statefp": "35",
  "statens": "00897535",
  "counties": [{
    "id": 2693,
    "affgeoid": "0500000US35001",
    "aland": 3006515443,
    "awater": 16485169,
    "countyfp": "001",
    "countyns": "01702363",
    "dotregion": 6,
    "geoid": "35001",
    "lsad": "06",
    "name": "Bernalillo",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2819,
    "affgeoid": "0500000US35003",
    "aland": 17932266958,
    "awater": 14191043,
    "countyfp": "003",
    "countyns": "00929108",
    "dotregion": 6,
    "geoid": "35003",
    "lsad": "06",
    "name": "Catron",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1338,
    "affgeoid": "0500000US35005",
    "aland": 15708996045,
    "awater": 25507630,
    "countyfp": "005",
    "countyns": "01702364",
    "dotregion": 6,
    "geoid": "35005",
    "lsad": "06",
    "name": "Chaves",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1570,
    "affgeoid": "0500000US35006",
    "aland": 11757111073,
    "awater": 5799905,
    "countyfp": "006",
    "countyns": "00933051",
    "dotregion": 6,
    "geoid": "35006",
    "lsad": "06",
    "name": "Cibola",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 765,
    "affgeoid": "0500000US35007",
    "aland": 9733541309,
    "awater": 26310385,
    "countyfp": "007",
    "countyns": "00929117",
    "dotregion": 6,
    "geoid": "35007",
    "lsad": "06",
    "name": "Colfax",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1562,
    "affgeoid": "0500000US35009",
    "aland": 3638239993,
    "awater": 8177773,
    "countyfp": "009",
    "countyns": "00933053",
    "dotregion": 6,
    "geoid": "35009",
    "lsad": "06",
    "name": "Curry",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1652,
    "affgeoid": "0500000US35011",
    "aland": 6015539696,
    "awater": 29159492,
    "countyfp": "011",
    "countyns": "00933054",
    "dotregion": 6,
    "geoid": "35011",
    "lsad": "06",
    "name": "De Baca",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1310,
    "affgeoid": "0500000US35013",
    "aland": 9862379062,
    "awater": 17584926,
    "countyfp": "013",
    "countyns": "00929109",
    "dotregion": 6,
    "geoid": "35013",
    "lsad": "06",
    "name": "Doña Ana",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 72,
    "affgeoid": "0500000US35015",
    "aland": 10815081659,
    "awater": 56440148,
    "countyfp": "015",
    "countyns": "00936829",
    "dotregion": 6,
    "geoid": "35015",
    "lsad": "06",
    "name": "Eddy",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 3055,
    "affgeoid": "0500000US35017",
    "aland": 10260552064,
    "awater": 15353565,
    "countyfp": "017",
    "countyns": "00915980",
    "dotregion": 6,
    "geoid": "35017",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1899,
    "affgeoid": "0500000US35019",
    "aland": 7848985805,
    "awater": 2890381,
    "countyfp": "019",
    "countyns": "00929111",
    "dotregion": 6,
    "geoid": "35019",
    "lsad": "06",
    "name": "Guadalupe",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 3175,
    "affgeoid": "0500000US35021",
    "aland": 5504944920,
    "awater": 1154360,
    "countyfp": "021",
    "countyns": "00933055",
    "dotregion": 6,
    "geoid": "35021",
    "lsad": "06",
    "name": "Harding",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2052,
    "affgeoid": "0500000US35023",
    "aland": 8901447444,
    "awater": 23652065,
    "countyfp": "023",
    "countyns": "00929106",
    "dotregion": 6,
    "geoid": "35023",
    "lsad": "06",
    "name": "Hidalgo",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 775,
    "affgeoid": "0500000US35025",
    "aland": 11372051343,
    "awater": 8468321,
    "countyfp": "025",
    "countyns": "01702365",
    "dotregion": 6,
    "geoid": "35025",
    "lsad": "06",
    "name": "Lea",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 3105,
    "affgeoid": "0500000US35027",
    "aland": 12512499478,
    "awater": 564282,
    "countyfp": "027",
    "countyns": "00929116",
    "dotregion": 6,
    "geoid": "35027",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 667,
    "affgeoid": "0500000US35028",
    "aland": 282741305,
    "awater": 229939,
    "countyfp": "028",
    "countyns": "01702366",
    "dotregion": 6,
    "geoid": "35028",
    "lsad": "06",
    "name": "Los Alamos",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 894,
    "affgeoid": "0500000US35029",
    "aland": 7679791940,
    "awater": 431978,
    "countyfp": "029",
    "countyns": "00933057",
    "dotregion": 6,
    "geoid": "35029",
    "lsad": "06",
    "name": "Luna",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 102,
    "affgeoid": "0500000US35031",
    "aland": 14114968741,
    "awater": 14130257,
    "countyfp": "031",
    "countyns": "00929107",
    "dotregion": 6,
    "geoid": "35031",
    "lsad": "06",
    "name": "McKinley",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1513,
    "affgeoid": "0500000US35033",
    "aland": 5001920023,
    "awater": 6079130,
    "countyfp": "033",
    "countyns": "01702367",
    "dotregion": 6,
    "geoid": "35033",
    "lsad": "06",
    "name": "Mora",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2426,
    "affgeoid": "0500000US35035",
    "aland": 17128142410,
    "awater": 37012231,
    "countyfp": "035",
    "countyns": "00929104",
    "dotregion": 6,
    "geoid": "35035",
    "lsad": "06",
    "name": "Otero",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 3115,
    "affgeoid": "0500000US35037",
    "aland": 7444355026,
    "awater": 18734849,
    "countyfp": "037",
    "countyns": "00929110",
    "dotregion": 6,
    "geoid": "35037",
    "lsad": "06",
    "name": "Quay",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2997,
    "affgeoid": "0500000US35039",
    "aland": 15179502714,
    "awater": 91455675,
    "countyfp": "039",
    "countyns": "01702368",
    "dotregion": 6,
    "geoid": "35039",
    "lsad": "06",
    "name": "Rio Arriba",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2211,
    "affgeoid": "0500000US35041",
    "aland": 6339211624,
    "awater": 18703747,
    "countyfp": "041",
    "countyns": "01702369",
    "dotregion": 6,
    "geoid": "35041",
    "lsad": "06",
    "name": "Roosevelt",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2398,
    "affgeoid": "0500000US35045",
    "aland": 14279077920,
    "awater": 65425890,
    "countyfp": "045",
    "countyns": "00936844",
    "dotregion": 6,
    "geoid": "35045",
    "lsad": "06",
    "name": "San Juan",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2701,
    "affgeoid": "0500000US35047",
    "aland": 12213734849,
    "awater": 51380262,
    "countyfp": "047",
    "countyns": "00929114",
    "dotregion": 6,
    "geoid": "35047",
    "lsad": "06",
    "name": "San Miguel",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1414,
    "affgeoid": "0500000US35043",
    "aland": 9610446197,
    "awater": 13701836,
    "countyfp": "043",
    "countyns": "00929113",
    "dotregion": 6,
    "geoid": "35043",
    "lsad": "06",
    "name": "Sandoval",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2464,
    "affgeoid": "0500000US35049",
    "aland": 4945412532,
    "awater": 3645423,
    "countyfp": "049",
    "countyns": "00933322",
    "dotregion": 6,
    "geoid": "35049",
    "lsad": "06",
    "name": "Santa Fe",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2816,
    "affgeoid": "0500000US35051",
    "aland": 10823675584,
    "awater": 148054792,
    "countyfp": "051",
    "countyns": "01702370",
    "dotregion": 6,
    "geoid": "35051",
    "lsad": "06",
    "name": "Sierra",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 801,
    "affgeoid": "0500000US35053",
    "aland": 17214577127,
    "awater": 5360180,
    "countyfp": "053",
    "countyns": "01702371",
    "dotregion": 6,
    "geoid": "35053",
    "lsad": "06",
    "name": "Socorro",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 2428,
    "affgeoid": "0500000US35055",
    "aland": 5705972272,
    "awater": 3385844,
    "countyfp": "055",
    "countyns": "00933056",
    "dotregion": 6,
    "geoid": "35055",
    "lsad": "06",
    "name": "Taos",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 3121,
    "affgeoid": "0500000US35057",
    "aland": 8662894973,
    "awater": 2301139,
    "countyfp": "057",
    "countyns": "00929112",
    "dotregion": 6,
    "geoid": "35057",
    "lsad": "06",
    "name": "Torrance",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 1365,
    "affgeoid": "0500000US35059",
    "aland": 9903448673,
    "awater": 18467790,
    "countyfp": "059",
    "countyns": "00929115",
    "dotregion": 6,
    "geoid": "35059",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "NM",
    "stateId": 44
  }, {
    "id": 600,
    "affgeoid": "0500000US35061",
    "aland": 2761400130,
    "awater": 5433597,
    "countyfp": "061",
    "countyns": "00933052",
    "dotregion": 6,
    "geoid": "35061",
    "lsad": "06",
    "name": "Valencia",
    "stateAbbreviation": "NM",
    "stateId": 44
  }]
}, {
  "id": 10,
  "abbreviation": "NY",
  "affgeoid": "0400000US36",
  "aland": 122054140553,
  "awater": 19242497698,
  "dotregion": 2,
  "geoid": "36",
  "lsad": "00",
  "name": "New York",
  "stateAbbreviation": "NY",
  "statefp": "36",
  "statens": "01779796",
  "counties": [{
    "id": 1632,
    "affgeoid": "0500000US36001",
    "aland": 1354074936,
    "awater": 27170401,
    "countyfp": "001",
    "countyns": "00974099",
    "dotregion": 2,
    "geoid": "36001",
    "lsad": "06",
    "name": "Albany",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1519,
    "affgeoid": "0500000US36003",
    "aland": 2665875175,
    "awater": 13153776,
    "countyfp": "003",
    "countyns": "00974100",
    "dotregion": 2,
    "geoid": "36003",
    "lsad": "06",
    "name": "Allegany",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1279,
    "affgeoid": "0500000US36005",
    "aland": 108910661,
    "awater": 39682657,
    "countyfp": "005",
    "countyns": "00974101",
    "dotregion": 2,
    "geoid": "36005",
    "lsad": "06",
    "name": "Bronx",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3192,
    "affgeoid": "0500000US36007",
    "aland": 1827924125,
    "awater": 25248477,
    "countyfp": "007",
    "countyns": "00974102",
    "dotregion": 2,
    "geoid": "36007",
    "lsad": "06",
    "name": "Broome",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2074,
    "affgeoid": "0500000US36009",
    "aland": 3388637065,
    "awater": 36604688,
    "countyfp": "009",
    "countyns": "00974103",
    "dotregion": 2,
    "geoid": "36009",
    "lsad": "06",
    "name": "Cattaraugus",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2361,
    "affgeoid": "0500000US36011",
    "aland": 1791214123,
    "awater": 445685237,
    "countyfp": "011",
    "countyns": "00974104",
    "dotregion": 2,
    "geoid": "36011",
    "lsad": "06",
    "name": "Cayuga",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2916,
    "affgeoid": "0500000US36013",
    "aland": 2745973929,
    "awater": 1139483687,
    "countyfp": "013",
    "countyns": "00974105",
    "dotregion": 2,
    "geoid": "36013",
    "lsad": "06",
    "name": "Chautauqua",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 785,
    "affgeoid": "0500000US36015",
    "aland": 1055038636,
    "awater": 8874334,
    "countyfp": "015",
    "countyns": "00974106",
    "dotregion": 2,
    "geoid": "36015",
    "lsad": "06",
    "name": "Chemung",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2432,
    "affgeoid": "0500000US36017",
    "aland": 2314302567,
    "awater": 13138247,
    "countyfp": "017",
    "countyns": "00974107",
    "dotregion": 2,
    "geoid": "36017",
    "lsad": "06",
    "name": "Chenango",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 638,
    "affgeoid": "0500000US36019",
    "aland": 2688025812,
    "awater": 206355551,
    "countyfp": "019",
    "countyns": "00974108",
    "dotregion": 2,
    "geoid": "36019",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2441,
    "affgeoid": "0500000US36021",
    "aland": 1643936648,
    "awater": 35063635,
    "countyfp": "021",
    "countyns": "00974109",
    "dotregion": 2,
    "geoid": "36021",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1574,
    "affgeoid": "0500000US36023",
    "aland": 1291815778,
    "awater": 7112822,
    "countyfp": "023",
    "countyns": "00974110",
    "dotregion": 2,
    "geoid": "36023",
    "lsad": "06",
    "name": "Cortland",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3217,
    "affgeoid": "0500000US36025",
    "aland": 3735954321,
    "awater": 64714610,
    "countyfp": "025",
    "countyns": "00974111",
    "dotregion": 2,
    "geoid": "36025",
    "lsad": "06",
    "name": "Delaware",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 558,
    "affgeoid": "0500000US36027",
    "aland": 2060686537,
    "awater": 76954190,
    "countyfp": "027",
    "countyns": "00974112",
    "dotregion": 2,
    "geoid": "36027",
    "lsad": "06",
    "name": "Dutchess",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 786,
    "affgeoid": "0500000US36029",
    "aland": 2700574449,
    "awater": 476962888,
    "countyfp": "029",
    "countyns": "00974113",
    "dotregion": 2,
    "geoid": "36029",
    "lsad": "06",
    "name": "Erie",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3168,
    "affgeoid": "0500000US36031",
    "aland": 4647128961,
    "awater": 315962092,
    "countyfp": "031",
    "countyns": "00974114",
    "dotregion": 2,
    "geoid": "36031",
    "lsad": "06",
    "name": "Essex",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1293,
    "affgeoid": "0500000US36033",
    "aland": 4219273083,
    "awater": 177028893,
    "countyfp": "033",
    "countyns": "00974115",
    "dotregion": 2,
    "geoid": "36033",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 281,
    "affgeoid": "0500000US36035",
    "aland": 1283235709,
    "awater": 96916405,
    "countyfp": "035",
    "countyns": "00974116",
    "dotregion": 2,
    "geoid": "36035",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3120,
    "affgeoid": "0500000US36037",
    "aland": 1276697994,
    "awater": 6142605,
    "countyfp": "037",
    "countyns": "00974117",
    "dotregion": 2,
    "geoid": "36037",
    "lsad": "06",
    "name": "Genesee",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2614,
    "affgeoid": "0500000US36039",
    "aland": 1676140490,
    "awater": 28201061,
    "countyfp": "039",
    "countyns": "00974118",
    "dotregion": 2,
    "geoid": "36039",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3209,
    "affgeoid": "0500000US36041",
    "aland": 4447998050,
    "awater": 234194434,
    "countyfp": "041",
    "countyns": "00974119",
    "dotregion": 2,
    "geoid": "36041",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2062,
    "affgeoid": "0500000US36043",
    "aland": 3655845535,
    "awater": 120374346,
    "countyfp": "043",
    "countyns": "00974120",
    "dotregion": 2,
    "geoid": "36043",
    "lsad": "06",
    "name": "Herkimer",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 698,
    "affgeoid": "0500000US36045",
    "aland": 3285858287,
    "awater": 1524359917,
    "countyfp": "045",
    "countyns": "00974121",
    "dotregion": 2,
    "geoid": "36045",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3056,
    "affgeoid": "0500000US36047",
    "aland": 180813778,
    "awater": 69955570,
    "countyfp": "047",
    "countyns": "00974122",
    "dotregion": 2,
    "geoid": "36047",
    "lsad": "06",
    "name": "Kings",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 327,
    "affgeoid": "0500000US36049",
    "aland": 3301310792,
    "awater": 39609924,
    "countyfp": "049",
    "countyns": "00974123",
    "dotregion": 2,
    "geoid": "36049",
    "lsad": "06",
    "name": "Lewis",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2333,
    "affgeoid": "0500000US36051",
    "aland": 1636256622,
    "awater": 22006106,
    "countyfp": "051",
    "countyns": "00974124",
    "dotregion": 2,
    "geoid": "36051",
    "lsad": "06",
    "name": "Livingston",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2762,
    "affgeoid": "0500000US36053",
    "aland": 1696091560,
    "awater": 16670528,
    "countyfp": "053",
    "countyns": "00974125",
    "dotregion": 2,
    "geoid": "36053",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 730,
    "affgeoid": "0500000US36055",
    "aland": 1702167181,
    "awater": 1837631519,
    "countyfp": "055",
    "countyns": "00974126",
    "dotregion": 2,
    "geoid": "36055",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1038,
    "affgeoid": "0500000US36057",
    "aland": 1044067737,
    "awater": 18598434,
    "countyfp": "057",
    "countyns": "00974127",
    "dotregion": 2,
    "geoid": "36057",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2286,
    "affgeoid": "0500000US36059",
    "aland": 737654579,
    "awater": 436841861,
    "countyfp": "059",
    "countyns": "00974128",
    "dotregion": 2,
    "geoid": "36059",
    "lsad": "06",
    "name": "Nassau",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2653,
    "affgeoid": "0500000US36061",
    "aland": 58678310,
    "awater": 28554415,
    "countyfp": "061",
    "countyns": "00974129",
    "dotregion": 2,
    "geoid": "36061",
    "lsad": "06",
    "name": "New York",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1622,
    "affgeoid": "0500000US36063",
    "aland": 1352887119,
    "awater": 1598842045,
    "countyfp": "063",
    "countyns": "00974130",
    "dotregion": 2,
    "geoid": "36063",
    "lsad": "06",
    "name": "Niagara",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2909,
    "affgeoid": "0500000US36065",
    "aland": 3140136085,
    "awater": 117113272,
    "countyfp": "065",
    "countyns": "00974131",
    "dotregion": 2,
    "geoid": "36065",
    "lsad": "06",
    "name": "Oneida",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1866,
    "affgeoid": "0500000US36067",
    "aland": 2016071016,
    "awater": 70469619,
    "countyfp": "067",
    "countyns": "00974132",
    "dotregion": 2,
    "geoid": "36067",
    "lsad": "06",
    "name": "Onondaga",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1596,
    "affgeoid": "0500000US36069",
    "aland": 1668118116,
    "awater": 47817330,
    "countyfp": "069",
    "countyns": "00974133",
    "dotregion": 2,
    "geoid": "36069",
    "lsad": "06",
    "name": "Ontario",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2750,
    "affgeoid": "0500000US36071",
    "aland": 2102290059,
    "awater": 69792820,
    "countyfp": "071",
    "countyns": "00974134",
    "dotregion": 2,
    "geoid": "36071",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2921,
    "affgeoid": "0500000US36073",
    "aland": 1013366848,
    "awater": 1103756066,
    "countyfp": "073",
    "countyns": "00974135",
    "dotregion": 2,
    "geoid": "36073",
    "lsad": "06",
    "name": "Orleans",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2535,
    "affgeoid": "0500000US36075",
    "aland": 2464745364,
    "awater": 933505961,
    "countyfp": "075",
    "countyns": "00974136",
    "dotregion": 2,
    "geoid": "36075",
    "lsad": "06",
    "name": "Oswego",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1382,
    "affgeoid": "0500000US36077",
    "aland": 2594415308,
    "awater": 36387176,
    "countyfp": "077",
    "countyns": "00974137",
    "dotregion": 2,
    "geoid": "36077",
    "lsad": "06",
    "name": "Otsego",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2581,
    "affgeoid": "0500000US36079",
    "aland": 596504170,
    "awater": 41282800,
    "countyfp": "079",
    "countyns": "00974138",
    "dotregion": 2,
    "geoid": "36079",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3184,
    "affgeoid": "0500000US36081",
    "aland": 281708062,
    "awater": 179390933,
    "countyfp": "081",
    "countyns": "00974139",
    "dotregion": 2,
    "geoid": "36081",
    "lsad": "06",
    "name": "Queens",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 949,
    "affgeoid": "0500000US36083",
    "aland": 1689791584,
    "awater": 33569458,
    "countyfp": "083",
    "countyns": "00974140",
    "dotregion": 2,
    "geoid": "36083",
    "lsad": "06",
    "name": "Rensselaer",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 838,
    "affgeoid": "0500000US36085",
    "aland": 150679985,
    "awater": 114256059,
    "countyfp": "085",
    "countyns": "00974141",
    "dotregion": 2,
    "geoid": "36085",
    "lsad": "06",
    "name": "Richmond",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 330,
    "affgeoid": "0500000US36087",
    "aland": 449372977,
    "awater": 66914608,
    "countyfp": "087",
    "countyns": "00974142",
    "dotregion": 2,
    "geoid": "36087",
    "lsad": "06",
    "name": "Rockland",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2928,
    "affgeoid": "0500000US36091",
    "aland": 2097880381,
    "awater": 87571838,
    "countyfp": "091",
    "countyns": "00974143",
    "dotregion": 2,
    "geoid": "36091",
    "lsad": "06",
    "name": "Saratoga",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3016,
    "affgeoid": "0500000US36093",
    "aland": 529856263,
    "awater": 12600388,
    "countyfp": "093",
    "countyns": "00974144",
    "dotregion": 2,
    "geoid": "36093",
    "lsad": "06",
    "name": "Schenectady",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1071,
    "affgeoid": "0500000US36095",
    "aland": 1610503573,
    "awater": 11676949,
    "countyfp": "095",
    "countyns": "00974145",
    "dotregion": 2,
    "geoid": "36095",
    "lsad": "06",
    "name": "Schoharie",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 444,
    "affgeoid": "0500000US36097",
    "aland": 850379110,
    "awater": 36246374,
    "countyfp": "097",
    "countyns": "00974146",
    "dotregion": 2,
    "geoid": "36097",
    "lsad": "06",
    "name": "Schuyler",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 668,
    "affgeoid": "0500000US36099",
    "aland": 838403626,
    "awater": 172828921,
    "countyfp": "099",
    "countyns": "00974147",
    "dotregion": 2,
    "geoid": "36099",
    "lsad": "06",
    "name": "Seneca",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3031,
    "affgeoid": "0500000US36089",
    "aland": 6942148461,
    "awater": 365344549,
    "countyfp": "089",
    "countyns": "00977309",
    "dotregion": 2,
    "geoid": "36089",
    "lsad": "06",
    "name": "St. Lawrence",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3,
    "affgeoid": "0500000US36101",
    "aland": 3601566799,
    "awater": 34993606,
    "countyfp": "101",
    "countyns": "00974148",
    "dotregion": 2,
    "geoid": "36101",
    "lsad": "06",
    "name": "Steuben",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2892,
    "affgeoid": "0500000US36103",
    "aland": 2361348753,
    "awater": 3785039071,
    "countyfp": "103",
    "countyns": "00974149",
    "dotregion": 2,
    "geoid": "36103",
    "lsad": "06",
    "name": "Suffolk",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 279,
    "affgeoid": "0500000US36105",
    "aland": 2507457324,
    "awater": 74040948,
    "countyfp": "105",
    "countyns": "00974150",
    "dotregion": 2,
    "geoid": "36105",
    "lsad": "06",
    "name": "Sullivan",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 280,
    "affgeoid": "0500000US36107",
    "aland": 1343192586,
    "awater": 11059913,
    "countyfp": "107",
    "countyns": "00974151",
    "dotregion": 2,
    "geoid": "36107",
    "lsad": "06",
    "name": "Tioga",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1009,
    "affgeoid": "0500000US36109",
    "aland": 1229335864,
    "awater": 43793070,
    "countyfp": "109",
    "countyns": "00974152",
    "dotregion": 2,
    "geoid": "36109",
    "lsad": "06",
    "name": "Tompkins",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2112,
    "affgeoid": "0500000US36111",
    "aland": 2911755155,
    "awater": 94599666,
    "countyfp": "111",
    "countyns": "00974153",
    "dotregion": 2,
    "geoid": "36111",
    "lsad": "06",
    "name": "Ulster",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 2877,
    "affgeoid": "0500000US36113",
    "aland": 2245411085,
    "awater": 167428334,
    "countyfp": "113",
    "countyns": "00974154",
    "dotregion": 2,
    "geoid": "36113",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 3193,
    "affgeoid": "0500000US36115",
    "aland": 2152712416,
    "awater": 38127086,
    "countyfp": "115",
    "countyns": "00974155",
    "dotregion": 2,
    "geoid": "36115",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1604,
    "affgeoid": "0500000US36117",
    "aland": 1563903158,
    "awater": 2018183253,
    "countyfp": "117",
    "countyns": "00974156",
    "dotregion": 2,
    "geoid": "36117",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 559,
    "affgeoid": "0500000US36119",
    "aland": 1115031350,
    "awater": 179949077,
    "countyfp": "119",
    "countyns": "00974157",
    "dotregion": 2,
    "geoid": "36119",
    "lsad": "06",
    "name": "Westchester",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 719,
    "affgeoid": "0500000US36121",
    "aland": 1535218840,
    "awater": 9158424,
    "countyfp": "121",
    "countyns": "00974158",
    "dotregion": 2,
    "geoid": "36121",
    "lsad": "06",
    "name": "Wyoming",
    "stateAbbreviation": "NY",
    "stateId": 10
  }, {
    "id": 1542,
    "affgeoid": "0500000US36123",
    "aland": 875785686,
    "awater": 97504774,
    "countyfp": "123",
    "countyns": "00974159",
    "dotregion": 2,
    "geoid": "36123",
    "lsad": "06",
    "name": "Yates",
    "stateAbbreviation": "NY",
    "stateId": 10
  }]
}, {
  "id": 27,
  "abbreviation": "NC",
  "affgeoid": "0400000US37",
  "aland": 125918092834,
  "awater": 13472548815,
  "dotregion": 4,
  "geoid": "37",
  "lsad": "00",
  "name": "North Carolina",
  "stateAbbreviation": "NC",
  "statefp": "37",
  "statens": "01027616",
  "counties": [{
    "id": 502,
    "affgeoid": "0500000US37001",
    "aland": 1098038862,
    "awater": 27933266,
    "countyfp": "001",
    "countyns": "01008531",
    "dotregion": 4,
    "geoid": "37001",
    "lsad": "06",
    "name": "Alamance",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3082,
    "affgeoid": "0500000US37003",
    "aland": 673318901,
    "awater": 9433708,
    "countyfp": "003",
    "countyns": "01008532",
    "dotregion": 4,
    "geoid": "37003",
    "lsad": "06",
    "name": "Alexander",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2878,
    "affgeoid": "0500000US37005",
    "aland": 608802906,
    "awater": 3853005,
    "countyfp": "005",
    "countyns": "01008533",
    "dotregion": 4,
    "geoid": "37005",
    "lsad": "06",
    "name": "Alleghany",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 867,
    "affgeoid": "0500000US37007",
    "aland": 1376453082,
    "awater": 14612922,
    "countyfp": "007",
    "countyns": "01008534",
    "dotregion": 4,
    "geoid": "37007",
    "lsad": "06",
    "name": "Anson",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1311,
    "affgeoid": "0500000US37009",
    "aland": 1103726590,
    "awater": 8074535,
    "countyfp": "009",
    "countyns": "01008535",
    "dotregion": 4,
    "geoid": "37009",
    "lsad": "06",
    "name": "Ashe",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2138,
    "affgeoid": "0500000US37011",
    "aland": 639940038,
    "awater": 375485,
    "countyfp": "011",
    "countyns": "01008536",
    "dotregion": 4,
    "geoid": "37011",
    "lsad": "06",
    "name": "Avery",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2335,
    "affgeoid": "0500000US37013",
    "aland": 2143053946,
    "awater": 338699480,
    "countyfp": "013",
    "countyns": "01026333",
    "dotregion": 4,
    "geoid": "37013",
    "lsad": "06",
    "name": "Beaufort",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2334,
    "affgeoid": "0500000US37015",
    "aland": 1811097685,
    "awater": 108727749,
    "countyfp": "015",
    "countyns": "01026334",
    "dotregion": 4,
    "geoid": "37015",
    "lsad": "06",
    "name": "Bertie",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2574,
    "affgeoid": "0500000US37017",
    "aland": 2264613777,
    "awater": 33109959,
    "countyfp": "017",
    "countyns": "01026336",
    "dotregion": 4,
    "geoid": "37017",
    "lsad": "06",
    "name": "Bladen",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1890,
    "affgeoid": "0500000US37019",
    "aland": 2199317866,
    "awater": 520213818,
    "countyfp": "019",
    "countyns": "01026340",
    "dotregion": 4,
    "geoid": "37019",
    "lsad": "06",
    "name": "Brunswick",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1336,
    "affgeoid": "0500000US37021",
    "aland": 1700784191,
    "awater": 8968963,
    "countyfp": "021",
    "countyns": "01008538",
    "dotregion": 4,
    "geoid": "37021",
    "lsad": "06",
    "name": "Buncombe",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1424,
    "affgeoid": "0500000US37023",
    "aland": 1313431561,
    "awater": 20607589,
    "countyfp": "023",
    "countyns": "01008539",
    "dotregion": 4,
    "geoid": "37023",
    "lsad": "06",
    "name": "Burke",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1425,
    "affgeoid": "0500000US37025",
    "aland": 936926639,
    "awater": 7005082,
    "countyfp": "025",
    "countyns": "01008540",
    "dotregion": 4,
    "geoid": "37025",
    "lsad": "06",
    "name": "Cabarrus",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 492,
    "affgeoid": "0500000US37027",
    "aland": 1221349796,
    "awater": 7115667,
    "countyfp": "027",
    "countyns": "01008541",
    "dotregion": 4,
    "geoid": "37027",
    "lsad": "06",
    "name": "Caldwell",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2385,
    "affgeoid": "0500000US37029",
    "aland": 623037914,
    "awater": 180406784,
    "countyfp": "029",
    "countyns": "01026335",
    "dotregion": 4,
    "geoid": "37029",
    "lsad": "06",
    "name": "Camden",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3088,
    "affgeoid": "0500000US37031",
    "aland": 1311157125,
    "awater": 2160964137,
    "countyfp": "031",
    "countyns": "01026337",
    "dotregion": 4,
    "geoid": "37031",
    "lsad": "06",
    "name": "Carteret",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2897,
    "affgeoid": "0500000US37033",
    "aland": 1100481969,
    "awater": 8622997,
    "countyfp": "033",
    "countyns": "01008542",
    "dotregion": 4,
    "geoid": "37033",
    "lsad": "06",
    "name": "Caswell",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1914,
    "affgeoid": "0500000US37035",
    "aland": 1032688076,
    "awater": 38052773,
    "countyfp": "035",
    "countyns": "01008543",
    "dotregion": 4,
    "geoid": "37035",
    "lsad": "06",
    "name": "Catawba",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1017,
    "affgeoid": "0500000US37037",
    "aland": 1767036794,
    "awater": 71417554,
    "countyfp": "037",
    "countyns": "01008544",
    "dotregion": 4,
    "geoid": "37037",
    "lsad": "06",
    "name": "Chatham",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1326,
    "affgeoid": "0500000US37039",
    "aland": 1179560304,
    "awater": 29250735,
    "countyfp": "039",
    "countyns": "01008545",
    "dotregion": 4,
    "geoid": "37039",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2800,
    "affgeoid": "0500000US37041",
    "aland": 446701190,
    "awater": 157537228,
    "countyfp": "041",
    "countyns": "01025822",
    "dotregion": 4,
    "geoid": "37041",
    "lsad": "06",
    "name": "Chowan",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1359,
    "affgeoid": "0500000US37043",
    "aland": 556215917,
    "awater": 15199024,
    "countyfp": "043",
    "countyns": "01008546",
    "dotregion": 4,
    "geoid": "37043",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1428,
    "affgeoid": "0500000US37045",
    "aland": 1202562646,
    "awater": 10201818,
    "countyfp": "045",
    "countyns": "01008547",
    "dotregion": 4,
    "geoid": "37045",
    "lsad": "06",
    "name": "Cleveland",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3007,
    "affgeoid": "0500000US37047",
    "aland": 2425879801,
    "awater": 43576659,
    "countyfp": "047",
    "countyns": "01026339",
    "dotregion": 4,
    "geoid": "37047",
    "lsad": "06",
    "name": "Columbus",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1970,
    "affgeoid": "0500000US37049",
    "aland": 1836193050,
    "awater": 168875961,
    "countyfp": "049",
    "countyns": "01026123",
    "dotregion": 4,
    "geoid": "37049",
    "lsad": "06",
    "name": "Craven",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3118,
    "affgeoid": "0500000US37051",
    "aland": 1689893433,
    "awater": 15269777,
    "countyfp": "051",
    "countyns": "01026124",
    "dotregion": 4,
    "geoid": "37051",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1534,
    "affgeoid": "0500000US37053",
    "aland": 678206439,
    "awater": 685661625,
    "countyfp": "053",
    "countyns": "01026125",
    "dotregion": 4,
    "geoid": "37053",
    "lsad": "06",
    "name": "Currituck",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2015,
    "affgeoid": "0500000US37055",
    "aland": 992626969,
    "awater": 3054395166,
    "countyfp": "055",
    "countyns": "01026133",
    "dotregion": 4,
    "geoid": "37055",
    "lsad": "06",
    "name": "Dare",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1079,
    "affgeoid": "0500000US37057",
    "aland": 1431435906,
    "awater": 37142820,
    "countyfp": "057",
    "countyns": "01008548",
    "dotregion": 4,
    "geoid": "37057",
    "lsad": "06",
    "name": "Davidson",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1497,
    "affgeoid": "0500000US37059",
    "aland": 683500924,
    "awater": 7616445,
    "countyfp": "059",
    "countyns": "01008549",
    "dotregion": 4,
    "geoid": "37059",
    "lsad": "06",
    "name": "Davie",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2065,
    "affgeoid": "0500000US37061",
    "aland": 2113896314,
    "awater": 14230328,
    "countyfp": "061",
    "countyns": "01026132",
    "dotregion": 4,
    "geoid": "37061",
    "lsad": "06",
    "name": "Duplin",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1635,
    "affgeoid": "0500000US37063",
    "aland": 740762056,
    "awater": 30708529,
    "countyfp": "063",
    "countyns": "01008550",
    "dotregion": 4,
    "geoid": "37063",
    "lsad": "06",
    "name": "Durham",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 573,
    "affgeoid": "0500000US37065",
    "aland": 1308595511,
    "awater": 3616270,
    "countyfp": "065",
    "countyns": "01008551",
    "dotregion": 4,
    "geoid": "37065",
    "lsad": "06",
    "name": "Edgecombe",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1202,
    "affgeoid": "0500000US37067",
    "aland": 1057167073,
    "awater": 11709671,
    "countyfp": "067",
    "countyns": "01008552",
    "dotregion": 4,
    "geoid": "37067",
    "lsad": "06",
    "name": "Forsyth",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 986,
    "affgeoid": "0500000US37069",
    "aland": 1273423252,
    "awater": 7322093,
    "countyfp": "069",
    "countyns": "01008553",
    "dotregion": 4,
    "geoid": "37069",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 950,
    "affgeoid": "0500000US37071",
    "aland": 922062221,
    "awater": 20957604,
    "countyfp": "071",
    "countyns": "01008554",
    "dotregion": 4,
    "geoid": "37071",
    "lsad": "06",
    "name": "Gaston",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1803,
    "affgeoid": "0500000US37073",
    "aland": 881747778,
    "awater": 13578051,
    "countyfp": "073",
    "countyns": "01026126",
    "dotregion": 4,
    "geoid": "37073",
    "lsad": "06",
    "name": "Gates",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 557,
    "affgeoid": "0500000US37075",
    "aland": 756452129,
    "awater": 24827675,
    "countyfp": "075",
    "countyns": "01008555",
    "dotregion": 4,
    "geoid": "37075",
    "lsad": "06",
    "name": "Graham",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2555,
    "affgeoid": "0500000US37077",
    "aland": 1374998243,
    "awater": 14526326,
    "countyfp": "077",
    "countyns": "01008556",
    "dotregion": 4,
    "geoid": "37077",
    "lsad": "06",
    "name": "Granville",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2988,
    "affgeoid": "0500000US37079",
    "aland": 688750822,
    "awater": 1220439,
    "countyfp": "079",
    "countyns": "01008557",
    "dotregion": 4,
    "geoid": "37079",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1499,
    "affgeoid": "0500000US37081",
    "aland": 1672507324,
    "awater": 30732171,
    "countyfp": "081",
    "countyns": "01008558",
    "dotregion": 4,
    "geoid": "37081",
    "lsad": "06",
    "name": "Guilford",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1318,
    "affgeoid": "0500000US37083",
    "aland": 1875375079,
    "awater": 18371242,
    "countyfp": "083",
    "countyns": "01008559",
    "dotregion": 4,
    "geoid": "37083",
    "lsad": "06",
    "name": "Halifax",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2598,
    "affgeoid": "0500000US37085",
    "aland": 1540982455,
    "awater": 16387527,
    "countyfp": "085",
    "countyns": "01008560",
    "dotregion": 4,
    "geoid": "37085",
    "lsad": "06",
    "name": "Harnett",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 976,
    "affgeoid": "0500000US37087",
    "aland": 1434071556,
    "awater": 2414518,
    "countyfp": "087",
    "countyns": "01008561",
    "dotregion": 4,
    "geoid": "37087",
    "lsad": "06",
    "name": "Haywood",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3185,
    "affgeoid": "0500000US37089",
    "aland": 966284831,
    "awater": 5559438,
    "countyfp": "089",
    "countyns": "01008562",
    "dotregion": 4,
    "geoid": "37089",
    "lsad": "06",
    "name": "Henderson",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3042,
    "affgeoid": "0500000US37091",
    "aland": 914421714,
    "awater": 18891657,
    "countyfp": "091",
    "countyns": "01026127",
    "dotregion": 4,
    "geoid": "37091",
    "lsad": "06",
    "name": "Hertford",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1888,
    "affgeoid": "0500000US37093",
    "aland": 1012029629,
    "awater": 4012386,
    "countyfp": "093",
    "countyns": "01008563",
    "dotregion": 4,
    "geoid": "37093",
    "lsad": "06",
    "name": "Hoke",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2454,
    "affgeoid": "0500000US37095",
    "aland": 1586697529,
    "awater": 2101506396,
    "countyfp": "095",
    "countyns": "01008564",
    "dotregion": 4,
    "geoid": "37095",
    "lsad": "06",
    "name": "Hyde",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2185,
    "affgeoid": "0500000US37097",
    "aland": 1487206095,
    "awater": 59953033,
    "countyfp": "097",
    "countyns": "01008565",
    "dotregion": 4,
    "geoid": "37097",
    "lsad": "06",
    "name": "Iredell",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3092,
    "affgeoid": "0500000US37099",
    "aland": 1271085173,
    "awater": 9779083,
    "countyfp": "099",
    "countyns": "01008566",
    "dotregion": 4,
    "geoid": "37099",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1778,
    "affgeoid": "0500000US37101",
    "aland": 2048950607,
    "awater": 11395639,
    "countyfp": "101",
    "countyns": "01026327",
    "dotregion": 4,
    "geoid": "37101",
    "lsad": "06",
    "name": "Johnston",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2411,
    "affgeoid": "0500000US37103",
    "aland": 1219129318,
    "awater": 6493541,
    "countyfp": "103",
    "countyns": "01026338",
    "dotregion": 4,
    "geoid": "37103",
    "lsad": "06",
    "name": "Jones",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2532,
    "affgeoid": "0500000US37105",
    "aland": 660335366,
    "awater": 10582970,
    "countyfp": "105",
    "countyns": "01008567",
    "dotregion": 4,
    "geoid": "37105",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 609,
    "affgeoid": "0500000US37107",
    "aland": 1037491246,
    "awater": 5802376,
    "countyfp": "107",
    "countyns": "01008568",
    "dotregion": 4,
    "geoid": "37107",
    "lsad": "06",
    "name": "Lenoir",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2399,
    "affgeoid": "0500000US37109",
    "aland": 771709959,
    "awater": 23522687,
    "countyfp": "109",
    "countyns": "01008569",
    "dotregion": 4,
    "geoid": "37109",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2691,
    "affgeoid": "0500000US37113",
    "aland": 1335302153,
    "awater": 10722085,
    "countyfp": "113",
    "countyns": "01025833",
    "dotregion": 4,
    "geoid": "37113",
    "lsad": "06",
    "name": "Macon",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 853,
    "affgeoid": "0500000US37115",
    "aland": 1164217335,
    "awater": 4836812,
    "countyfp": "115",
    "countyns": "01025834",
    "dotregion": 4,
    "geoid": "37115",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1154,
    "affgeoid": "0500000US37117",
    "aland": 1194550416,
    "awater": 751154,
    "countyfp": "117",
    "countyns": "01026328",
    "dotregion": 4,
    "geoid": "37117",
    "lsad": "06",
    "name": "Martin",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1360,
    "affgeoid": "0500000US37111",
    "aland": 1141169556,
    "awater": 13956785,
    "countyfp": "111",
    "countyns": "01025836",
    "dotregion": 4,
    "geoid": "37111",
    "lsad": "06",
    "name": "McDowell",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2137,
    "affgeoid": "0500000US37119",
    "aland": 1355622646,
    "awater": 58038574,
    "countyfp": "119",
    "countyns": "01008570",
    "dotregion": 4,
    "geoid": "37119",
    "lsad": "06",
    "name": "Mecklenburg",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1889,
    "affgeoid": "0500000US37121",
    "aland": 573522064,
    "awater": 1679903,
    "countyfp": "121",
    "countyns": "01008571",
    "dotregion": 4,
    "geoid": "37121",
    "lsad": "06",
    "name": "Mitchell",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1463,
    "affgeoid": "0500000US37123",
    "aland": 1273731471,
    "awater": 25909694,
    "countyfp": "123",
    "countyns": "01008572",
    "dotregion": 4,
    "geoid": "37123",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1048,
    "affgeoid": "0500000US37125",
    "aland": 1807460825,
    "awater": 20689517,
    "countyfp": "125",
    "countyns": "01008573",
    "dotregion": 4,
    "geoid": "37125",
    "lsad": "06",
    "name": "Moore",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2748,
    "affgeoid": "0500000US37127",
    "aland": 1399639558,
    "awater": 6132521,
    "countyfp": "127",
    "countyns": "01008574",
    "dotregion": 4,
    "geoid": "37127",
    "lsad": "06",
    "name": "Nash",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 153,
    "affgeoid": "0500000US37129",
    "aland": 496660826,
    "awater": 353919000,
    "countyfp": "129",
    "countyns": "01026329",
    "dotregion": 4,
    "geoid": "37129",
    "lsad": "06",
    "name": "New Hanover",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 788,
    "affgeoid": "0500000US37131",
    "aland": 1389757167,
    "awater": 36301279,
    "countyfp": "131",
    "countyns": "01008575",
    "dotregion": 4,
    "geoid": "37131",
    "lsad": "06",
    "name": "Northampton",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1583,
    "affgeoid": "0500000US37133",
    "aland": 1975580950,
    "awater": 370722552,
    "countyfp": "133",
    "countyns": "01026341",
    "dotregion": 4,
    "geoid": "37133",
    "lsad": "06",
    "name": "Onslow",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1549,
    "affgeoid": "0500000US37135",
    "aland": 1030776926,
    "awater": 8970158,
    "countyfp": "135",
    "countyns": "01008576",
    "dotregion": 4,
    "geoid": "37135",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 919,
    "affgeoid": "0500000US37137",
    "aland": 871740860,
    "awater": 596135141,
    "countyfp": "137",
    "countyns": "01023355",
    "dotregion": 4,
    "geoid": "37137",
    "lsad": "06",
    "name": "Pamlico",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1271,
    "affgeoid": "0500000US37139",
    "aland": 587633387,
    "awater": 162010040,
    "countyfp": "139",
    "countyns": "01026330",
    "dotregion": 4,
    "geoid": "37139",
    "lsad": "06",
    "name": "Pasquotank",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2300,
    "affgeoid": "0500000US37141",
    "aland": 2252361372,
    "awater": 162975112,
    "countyfp": "141",
    "countyns": "01026129",
    "dotregion": 4,
    "geoid": "37141",
    "lsad": "06",
    "name": "Pender",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2596,
    "affgeoid": "0500000US37143",
    "aland": 640243032,
    "awater": 211775431,
    "countyfp": "143",
    "countyns": "01025841",
    "dotregion": 4,
    "geoid": "37143",
    "lsad": "06",
    "name": "Perquimans",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 236,
    "affgeoid": "0500000US37145",
    "aland": 1015343286,
    "awater": 31216352,
    "countyfp": "145",
    "countyns": "01008577",
    "dotregion": 4,
    "geoid": "37145",
    "lsad": "06",
    "name": "Person",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2482,
    "affgeoid": "0500000US37147",
    "aland": 1687873422,
    "awater": 8114836,
    "countyfp": "147",
    "countyns": "01008578",
    "dotregion": 4,
    "geoid": "37147",
    "lsad": "06",
    "name": "Pitt",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 84,
    "affgeoid": "0500000US37149",
    "aland": 615839220,
    "awater": 1964035,
    "countyfp": "149",
    "countyns": "01008579",
    "dotregion": 4,
    "geoid": "37149",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1876,
    "affgeoid": "0500000US37151",
    "aland": 2024583495,
    "awater": 19823317,
    "countyfp": "151",
    "countyns": "01008580",
    "dotregion": 4,
    "geoid": "37151",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 380,
    "affgeoid": "0500000US37153",
    "aland": 1227298020,
    "awater": 15684085,
    "countyfp": "153",
    "countyns": "01008581",
    "dotregion": 4,
    "geoid": "37153",
    "lsad": "06",
    "name": "Richmond",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2993,
    "affgeoid": "0500000US37155",
    "aland": 2457924449,
    "awater": 5110085,
    "countyfp": "155",
    "countyns": "01026130",
    "dotregion": 4,
    "geoid": "37155",
    "lsad": "06",
    "name": "Robeson",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 119,
    "affgeoid": "0500000US37157",
    "aland": 1464773685,
    "awater": 18526383,
    "countyfp": "157",
    "countyns": "01008582",
    "dotregion": 4,
    "geoid": "37157",
    "lsad": "06",
    "name": "Rockingham",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 601,
    "affgeoid": "0500000US37159",
    "aland": 1324152127,
    "awater": 31929858,
    "countyfp": "159",
    "countyns": "01008583",
    "dotregion": 4,
    "geoid": "37159",
    "lsad": "06",
    "name": "Rowan",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3187,
    "affgeoid": "0500000US37161",
    "aland": 1460866914,
    "awater": 4676879,
    "countyfp": "161",
    "countyns": "01008584",
    "dotregion": 4,
    "geoid": "37161",
    "lsad": "06",
    "name": "Rutherford",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1809,
    "affgeoid": "0500000US37163",
    "aland": 2446815605,
    "awater": 4970896,
    "countyfp": "163",
    "countyns": "01026131",
    "dotregion": 4,
    "geoid": "37163",
    "lsad": "06",
    "name": "Sampson",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1820,
    "affgeoid": "0500000US37165",
    "aland": 825813447,
    "awater": 3821988,
    "countyfp": "165",
    "countyns": "01008585",
    "dotregion": 4,
    "geoid": "37165",
    "lsad": "06",
    "name": "Scotland",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1407,
    "affgeoid": "0500000US37167",
    "aland": 1023264907,
    "awater": 25262143,
    "countyfp": "167",
    "countyns": "01025844",
    "dotregion": 4,
    "geoid": "37167",
    "lsad": "06",
    "name": "Stanly",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2093,
    "affgeoid": "0500000US37169",
    "aland": 1162543117,
    "awater": 17531433,
    "countyfp": "169",
    "countyns": "01008586",
    "dotregion": 4,
    "geoid": "37169",
    "lsad": "06",
    "name": "Stokes",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2976,
    "affgeoid": "0500000US37171",
    "aland": 1378305039,
    "awater": 10715035,
    "countyfp": "171",
    "countyns": "01008587",
    "dotregion": 4,
    "geoid": "37171",
    "lsad": "06",
    "name": "Surry",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3015,
    "affgeoid": "0500000US37173",
    "aland": 1367503608,
    "awater": 32685933,
    "countyfp": "173",
    "countyns": "01008588",
    "dotregion": 4,
    "geoid": "37173",
    "lsad": "06",
    "name": "Swain",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2668,
    "affgeoid": "0500000US37175",
    "aland": 980388876,
    "awater": 5135255,
    "countyfp": "175",
    "countyns": "01008589",
    "dotregion": 4,
    "geoid": "37175",
    "lsad": "06",
    "name": "Transylvania",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1827,
    "affgeoid": "0500000US37177",
    "aland": 1007613021,
    "awater": 531404547,
    "countyfp": "177",
    "countyns": "01026332",
    "dotregion": 4,
    "geoid": "37177",
    "lsad": "06",
    "name": "Tyrrell",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2911,
    "affgeoid": "0500000US37179",
    "aland": 1635942670,
    "awater": 20601757,
    "countyfp": "179",
    "countyns": "01008590",
    "dotregion": 4,
    "geoid": "37179",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 3085,
    "affgeoid": "0500000US37181",
    "aland": 656633631,
    "awater": 42196853,
    "countyfp": "181",
    "countyns": "01008591",
    "dotregion": 4,
    "geoid": "37181",
    "lsad": "06",
    "name": "Vance",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 572,
    "affgeoid": "0500000US37183",
    "aland": 2163485080,
    "awater": 56968106,
    "countyfp": "183",
    "countyns": "01008592",
    "dotregion": 4,
    "geoid": "37183",
    "lsad": "06",
    "name": "Wake",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2779,
    "affgeoid": "0500000US37185",
    "aland": 1109696072,
    "awater": 39641550,
    "countyfp": "185",
    "countyns": "01008593",
    "dotregion": 4,
    "geoid": "37185",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1978,
    "affgeoid": "0500000US37187",
    "aland": 901664364,
    "awater": 196093082,
    "countyfp": "187",
    "countyns": "01026331",
    "dotregion": 4,
    "geoid": "37187",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1821,
    "affgeoid": "0500000US37189",
    "aland": 809500164,
    "awater": 2341456,
    "countyfp": "189",
    "countyns": "01008594",
    "dotregion": 4,
    "geoid": "37189",
    "lsad": "06",
    "name": "Watauga",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1367,
    "affgeoid": "0500000US37191",
    "aland": 1432263112,
    "awater": 9863348,
    "countyfp": "191",
    "countyns": "01026128",
    "dotregion": 4,
    "geoid": "37191",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 1020,
    "affgeoid": "0500000US37193",
    "aland": 1953561144,
    "awater": 6851576,
    "countyfp": "193",
    "countyns": "01008595",
    "dotregion": 4,
    "geoid": "37193",
    "lsad": "06",
    "name": "Wilkes",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 869,
    "affgeoid": "0500000US37195",
    "aland": 953483115,
    "awater": 14477233,
    "countyfp": "195",
    "countyns": "01008596",
    "dotregion": 4,
    "geoid": "37195",
    "lsad": "06",
    "name": "Wilson",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 138,
    "affgeoid": "0500000US37197",
    "aland": 867204123,
    "awater": 6931829,
    "countyfp": "197",
    "countyns": "01008597",
    "dotregion": 4,
    "geoid": "37197",
    "lsad": "06",
    "name": "Yadkin",
    "stateAbbreviation": "NC",
    "stateId": 27
  }, {
    "id": 2571,
    "affgeoid": "0500000US37199",
    "aland": 809619000,
    "awater": 1458826,
    "countyfp": "199",
    "countyns": "01008598",
    "dotregion": 4,
    "geoid": "37199",
    "lsad": "06",
    "name": "Yancey",
    "stateAbbreviation": "NC",
    "stateId": 27
  }]
}, {
  "id": 51,
  "abbreviation": "ND",
  "affgeoid": "0400000US38",
  "aland": 178711991307,
  "awater": 4398999691,
  "dotregion": 8,
  "geoid": "38",
  "lsad": "00",
  "name": "North Dakota",
  "stateAbbreviation": "ND",
  "statefp": "38",
  "statens": "01779797",
  "counties": [{
    "id": 2681,
    "affgeoid": "0500000US38001",
    "aland": 2557960606,
    "awater": 2833850,
    "countyfp": "001",
    "countyns": "01034210",
    "dotregion": 8,
    "geoid": "38001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 470,
    "affgeoid": "0500000US38003",
    "aland": 3863105133,
    "awater": 56593591,
    "countyfp": "003",
    "countyns": "01034225",
    "dotregion": 8,
    "geoid": "38003",
    "lsad": "06",
    "name": "Barnes",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 650,
    "affgeoid": "0500000US38005",
    "aland": 3596733569,
    "awater": 131543434,
    "countyfp": "005",
    "countyns": "01034216",
    "dotregion": 8,
    "geoid": "38005",
    "lsad": "06",
    "name": "Benson",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 126,
    "affgeoid": "0500000US38007",
    "aland": 2975505802,
    "awater": 11971658,
    "countyfp": "007",
    "countyns": "01035616",
    "dotregion": 8,
    "geoid": "38007",
    "lsad": "06",
    "name": "Billings",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1825,
    "affgeoid": "0500000US38009",
    "aland": 4321179405,
    "awater": 74882085,
    "countyfp": "009",
    "countyns": "01034227",
    "dotregion": 8,
    "geoid": "38009",
    "lsad": "06",
    "name": "Bottineau",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 442,
    "affgeoid": "0500000US38011",
    "aland": 3009306345,
    "awater": 13587978,
    "countyfp": "011",
    "countyns": "01035619",
    "dotregion": 8,
    "geoid": "38011",
    "lsad": "06",
    "name": "Bowman",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1689,
    "affgeoid": "0500000US38013",
    "aland": 2858266174,
    "awater": 65700835,
    "countyfp": "013",
    "countyns": "01034235",
    "dotregion": 8,
    "geoid": "38013",
    "lsad": "06",
    "name": "Burke",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 536,
    "affgeoid": "0500000US38015",
    "aland": 4228524439,
    "awater": 92333146,
    "countyfp": "015",
    "countyns": "01035614",
    "dotregion": 8,
    "geoid": "38015",
    "lsad": "06",
    "name": "Burleigh",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 176,
    "affgeoid": "0500000US38017",
    "aland": 4571165992,
    "awater": 7672824,
    "countyfp": "017",
    "countyns": "01034226",
    "dotregion": 8,
    "geoid": "38017",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 316,
    "affgeoid": "0500000US38019",
    "aland": 3855846151,
    "awater": 54931547,
    "countyfp": "019",
    "countyns": "01035304",
    "dotregion": 8,
    "geoid": "38019",
    "lsad": "06",
    "name": "Cavalier",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1917,
    "affgeoid": "0500000US38021",
    "aland": 2930494895,
    "awater": 27610559,
    "countyfp": "021",
    "countyns": "01035622",
    "dotregion": 8,
    "geoid": "38021",
    "lsad": "06",
    "name": "Dickey",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 731,
    "affgeoid": "0500000US38023",
    "aland": 3265339533,
    "awater": 86630779,
    "countyfp": "023",
    "countyns": "01034234",
    "dotregion": 8,
    "geoid": "38023",
    "lsad": "06",
    "name": "Divide",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2504,
    "affgeoid": "0500000US38025",
    "aland": 5201888806,
    "awater": 190576083,
    "countyfp": "025",
    "countyns": "01035623",
    "dotregion": 8,
    "geoid": "38025",
    "lsad": "06",
    "name": "Dunn",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 233,
    "affgeoid": "0500000US38027",
    "aland": 1632134243,
    "awater": 36114064,
    "countyfp": "027",
    "countyns": "01034222",
    "dotregion": 8,
    "geoid": "38027",
    "lsad": "06",
    "name": "Eddy",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2810,
    "affgeoid": "0500000US38029",
    "aland": 3912007902,
    "awater": 115480697,
    "countyfp": "029",
    "countyns": "01035615",
    "dotregion": 8,
    "geoid": "38029",
    "lsad": "06",
    "name": "Emmons",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 44,
    "affgeoid": "0500000US38031",
    "aland": 1645810433,
    "awater": 29450853,
    "countyfp": "031",
    "countyns": "01034223",
    "dotregion": 8,
    "geoid": "38031",
    "lsad": "06",
    "name": "Foster",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2588,
    "affgeoid": "0500000US38033",
    "aland": 2593902026,
    "awater": 4147471,
    "countyfp": "033",
    "countyns": "01035617",
    "dotregion": 8,
    "geoid": "38033",
    "lsad": "06",
    "name": "Golden Valley",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1429,
    "affgeoid": "0500000US38035",
    "aland": 3720196532,
    "awater": 8098091,
    "countyfp": "035",
    "countyns": "01034218",
    "dotregion": 8,
    "geoid": "38035",
    "lsad": "06",
    "name": "Grand Forks",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1163,
    "affgeoid": "0500000US38037",
    "aland": 4297180398,
    "awater": 17563263,
    "countyfp": "037",
    "countyns": "01035300",
    "dotregion": 8,
    "geoid": "38037",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 3170,
    "affgeoid": "0500000US38039",
    "aland": 1835826859,
    "awater": 19759408,
    "countyfp": "039",
    "countyns": "01034219",
    "dotregion": 8,
    "geoid": "38039",
    "lsad": "06",
    "name": "Griggs",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 411,
    "affgeoid": "0500000US38041",
    "aland": 2932411625,
    "awater": 4036912,
    "countyfp": "041",
    "countyns": "01034209",
    "dotregion": 8,
    "geoid": "38041",
    "lsad": "06",
    "name": "Hettinger",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 217,
    "affgeoid": "0500000US38043",
    "aland": 3499507645,
    "awater": 211725374,
    "countyfp": "043",
    "countyns": "01034206",
    "dotregion": 8,
    "geoid": "38043",
    "lsad": "06",
    "name": "Kidder",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1012,
    "affgeoid": "0500000US38045",
    "aland": 2967978462,
    "awater": 12813381,
    "countyfp": "045",
    "countyns": "01035621",
    "dotregion": 8,
    "geoid": "38045",
    "lsad": "06",
    "name": "LaMoure",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 52,
    "affgeoid": "0500000US38047",
    "aland": 2571370644,
    "awater": 47715597,
    "countyfp": "047",
    "countyns": "01035620",
    "dotregion": 8,
    "geoid": "38047",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 610,
    "affgeoid": "0500000US38049",
    "aland": 4853564417,
    "awater": 97373493,
    "countyfp": "049",
    "countyns": "01035305",
    "dotregion": 8,
    "geoid": "38049",
    "lsad": "06",
    "name": "McHenry",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1443,
    "affgeoid": "0500000US38051",
    "aland": 2524546351,
    "awater": 51817666,
    "countyfp": "051",
    "countyns": "01034211",
    "dotregion": 8,
    "geoid": "38051",
    "lsad": "06",
    "name": "McIntosh",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2344,
    "affgeoid": "0500000US38053",
    "aland": 7149545191,
    "awater": 260192618,
    "countyfp": "053",
    "countyns": "01035299",
    "dotregion": 8,
    "geoid": "38053",
    "lsad": "06",
    "name": "McKenzie",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1915,
    "affgeoid": "0500000US38055",
    "aland": 5466428288,
    "awater": 563110618,
    "countyfp": "055",
    "countyns": "01034232",
    "dotregion": 8,
    "geoid": "38055",
    "lsad": "06",
    "name": "McLean",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 861,
    "affgeoid": "0500000US38057",
    "aland": 2701239107,
    "awater": 180099488,
    "countyfp": "057",
    "countyns": "01034233",
    "dotregion": 8,
    "geoid": "38057",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2525,
    "affgeoid": "0500000US38059",
    "aland": 4988993798,
    "awater": 49687649,
    "countyfp": "059",
    "countyns": "01034207",
    "dotregion": 8,
    "geoid": "38059",
    "lsad": "06",
    "name": "Morton",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2751,
    "affgeoid": "0500000US38061",
    "aland": 4727470171,
    "awater": 301107657,
    "countyfp": "061",
    "countyns": "01035307",
    "dotregion": 8,
    "geoid": "38061",
    "lsad": "06",
    "name": "Mountrail",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 182,
    "affgeoid": "0500000US38063",
    "aland": 2542784454,
    "awater": 70037102,
    "countyfp": "063",
    "countyns": "01034217",
    "dotregion": 8,
    "geoid": "38063",
    "lsad": "06",
    "name": "Nelson",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2367,
    "affgeoid": "0500000US38065",
    "aland": 1871296131,
    "awater": 22476243,
    "countyfp": "065",
    "countyns": "01034205",
    "dotregion": 8,
    "geoid": "38065",
    "lsad": "06",
    "name": "Oliver",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2780,
    "affgeoid": "0500000US38067",
    "aland": 2897404229,
    "awater": 6996110,
    "countyfp": "067",
    "countyns": "01034212",
    "dotregion": 8,
    "geoid": "38067",
    "lsad": "06",
    "name": "Pembina",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 3172,
    "affgeoid": "0500000US38069",
    "aland": 2638162562,
    "awater": 165070765,
    "countyfp": "069",
    "countyns": "01034230",
    "dotregion": 8,
    "geoid": "38069",
    "lsad": "06",
    "name": "Pierce",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1369,
    "affgeoid": "0500000US38071",
    "aland": 3074171578,
    "awater": 295185090,
    "countyfp": "071",
    "countyns": "01034215",
    "dotregion": 8,
    "geoid": "38071",
    "lsad": "06",
    "name": "Ramsey",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 947,
    "affgeoid": "0500000US38073",
    "aland": 2233494175,
    "awater": 3581125,
    "countyfp": "073",
    "countyns": "01035301",
    "dotregion": 8,
    "geoid": "38073",
    "lsad": "06",
    "name": "Ransom",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 38,
    "affgeoid": "0500000US38075",
    "aland": 2271556744,
    "awater": 40648334,
    "countyfp": "075",
    "countyns": "01034229",
    "dotregion": 8,
    "geoid": "38075",
    "lsad": "06",
    "name": "Renville",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2755,
    "affgeoid": "0500000US38077",
    "aland": 3718649861,
    "awater": 25035912,
    "countyfp": "077",
    "countyns": "01035302",
    "dotregion": 8,
    "geoid": "38077",
    "lsad": "06",
    "name": "Richland",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 325,
    "affgeoid": "0500000US38079",
    "aland": 2338953788,
    "awater": 93938154,
    "countyfp": "079",
    "countyns": "01034228",
    "dotregion": 8,
    "geoid": "38079",
    "lsad": "06",
    "name": "Rolette",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 407,
    "affgeoid": "0500000US38081",
    "aland": 2223531991,
    "awater": 21728402,
    "countyfp": "081",
    "countyns": "01035303",
    "dotregion": 8,
    "geoid": "38081",
    "lsad": "06",
    "name": "Sargent",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1178,
    "affgeoid": "0500000US38083",
    "aland": 2518458052,
    "awater": 86143151,
    "countyfp": "083",
    "countyns": "01034203",
    "dotregion": 8,
    "geoid": "38083",
    "lsad": "06",
    "name": "Sheridan",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2655,
    "affgeoid": "0500000US38085",
    "aland": 2833685025,
    "awater": 88449900,
    "countyfp": "085",
    "countyns": "01034208",
    "dotregion": 8,
    "geoid": "38085",
    "lsad": "06",
    "name": "Sioux",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 658,
    "affgeoid": "0500000US38087",
    "aland": 3146674292,
    "awater": 10977977,
    "countyfp": "087",
    "countyns": "01035896",
    "dotregion": 8,
    "geoid": "38087",
    "lsad": "06",
    "name": "Slope",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 382,
    "affgeoid": "0500000US38089",
    "aland": 3456990389,
    "awater": 14119172,
    "countyfp": "089",
    "countyns": "01035618",
    "dotregion": 8,
    "geoid": "38089",
    "lsad": "06",
    "name": "Stark",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 218,
    "affgeoid": "0500000US38091",
    "aland": 1844613576,
    "awater": 8424876,
    "countyfp": "091",
    "countyns": "01034220",
    "dotregion": 8,
    "geoid": "38091",
    "lsad": "06",
    "name": "Steele",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 1260,
    "affgeoid": "0500000US38093",
    "aland": 5754255232,
    "awater": 197312589,
    "countyfp": "093",
    "countyns": "01034224",
    "dotregion": 8,
    "geoid": "38093",
    "lsad": "06",
    "name": "Stutsman",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 673,
    "affgeoid": "0500000US38095",
    "aland": 2653616948,
    "awater": 43800577,
    "countyfp": "095",
    "countyns": "01034213",
    "dotregion": 8,
    "geoid": "38095",
    "lsad": "06",
    "name": "Towner",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2182,
    "affgeoid": "0500000US38097",
    "aland": 2232438249,
    "awater": 1462184,
    "countyfp": "097",
    "countyns": "01034221",
    "dotregion": 8,
    "geoid": "38097",
    "lsad": "06",
    "name": "Traill",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 351,
    "affgeoid": "0500000US38099",
    "aland": 3319505683,
    "awater": 32184978,
    "countyfp": "099",
    "countyns": "01034214",
    "dotregion": 8,
    "geoid": "38099",
    "lsad": "06",
    "name": "Walsh",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 3133,
    "affgeoid": "0500000US38101",
    "aland": 5214106034,
    "awater": 110774753,
    "countyfp": "101",
    "countyns": "01034231",
    "dotregion": 8,
    "geoid": "38101",
    "lsad": "06",
    "name": "Ward",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 818,
    "affgeoid": "0500000US38103",
    "aland": 3291081473,
    "awater": 50967325,
    "countyfp": "103",
    "countyns": "01034204",
    "dotregion": 8,
    "geoid": "38103",
    "lsad": "06",
    "name": "Wells",
    "stateAbbreviation": "ND",
    "stateId": 51
  }, {
    "id": 2011,
    "affgeoid": "0500000US38105",
    "aland": 5381129899,
    "awater": 182522303,
    "countyfp": "105",
    "countyns": "01035306",
    "dotregion": 8,
    "geoid": "38105",
    "lsad": "06",
    "name": "Williams",
    "stateAbbreviation": "ND",
    "stateId": 51
  }]
}, {
  "id": 19,
  "abbreviation": "OH",
  "affgeoid": "0400000US39",
  "aland": 105831379985,
  "awater": 10266305761,
  "dotregion": 5,
  "geoid": "39",
  "lsad": "00",
  "name": "Ohio",
  "stateAbbreviation": "OH",
  "statefp": "39",
  "statens": "01085497",
  "counties": [{
    "id": 1155,
    "affgeoid": "0500000US39001",
    "aland": 1512208937,
    "awater": 6165939,
    "countyfp": "001",
    "countyns": "01074014",
    "dotregion": 5,
    "geoid": "39001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2496,
    "affgeoid": "0500000US39003",
    "aland": 1042470093,
    "awater": 11266164,
    "countyfp": "003",
    "countyns": "01074015",
    "dotregion": 5,
    "geoid": "39003",
    "lsad": "06",
    "name": "Allen",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2847,
    "affgeoid": "0500000US39005",
    "aland": 1095437930,
    "awater": 9969085,
    "countyfp": "005",
    "countyns": "01074016",
    "dotregion": 5,
    "geoid": "39005",
    "lsad": "06",
    "name": "Ashland",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2811,
    "affgeoid": "0500000US39007",
    "aland": 1818008353,
    "awater": 1724826028,
    "countyfp": "007",
    "countyns": "01074017",
    "dotregion": 5,
    "geoid": "39007",
    "lsad": "06",
    "name": "Ashtabula",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1103,
    "affgeoid": "0500000US39009",
    "aland": 1304383717,
    "awater": 12463892,
    "countyfp": "009",
    "countyns": "01074018",
    "dotregion": 5,
    "geoid": "39009",
    "lsad": "06",
    "name": "Athens",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1061,
    "affgeoid": "0500000US39011",
    "aland": 1039599279,
    "awater": 1345186,
    "countyfp": "011",
    "countyns": "01074019",
    "dotregion": 5,
    "geoid": "39011",
    "lsad": "06",
    "name": "Auglaize",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 3090,
    "affgeoid": "0500000US39013",
    "aland": 1378208959,
    "awater": 23686007,
    "countyfp": "013",
    "countyns": "01065575",
    "dotregion": 5,
    "geoid": "39013",
    "lsad": "06",
    "name": "Belmont",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1555,
    "affgeoid": "0500000US39015",
    "aland": 1269135571,
    "awater": 8898051,
    "countyfp": "015",
    "countyns": "01074020",
    "dotregion": 5,
    "geoid": "39015",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 257,
    "affgeoid": "0500000US39017",
    "aland": 1209528853,
    "awater": 7833380,
    "countyfp": "017",
    "countyns": "01074021",
    "dotregion": 5,
    "geoid": "39017",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 576,
    "affgeoid": "0500000US39019",
    "aland": 1022030960,
    "awater": 11192655,
    "countyfp": "019",
    "countyns": "01074022",
    "dotregion": 5,
    "geoid": "39019",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1308,
    "affgeoid": "0500000US39021",
    "aland": 1110247662,
    "awater": 3015668,
    "countyfp": "021",
    "countyns": "01074023",
    "dotregion": 5,
    "geoid": "39021",
    "lsad": "06",
    "name": "Champaign",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 177,
    "affgeoid": "0500000US39023",
    "aland": 1029469370,
    "awater": 13070242,
    "countyfp": "023",
    "countyns": "01074024",
    "dotregion": 5,
    "geoid": "39023",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2796,
    "affgeoid": "0500000US39025",
    "aland": 1170958242,
    "awater": 19831108,
    "countyfp": "025",
    "countyns": "01074025",
    "dotregion": 5,
    "geoid": "39025",
    "lsad": "06",
    "name": "Clermont",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 686,
    "affgeoid": "0500000US39027",
    "aland": 1058487158,
    "awater": 9351754,
    "countyfp": "027",
    "countyns": "01074026",
    "dotregion": 5,
    "geoid": "39027",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2252,
    "affgeoid": "0500000US39029",
    "aland": 1377697743,
    "awater": 7237745,
    "countyfp": "029",
    "countyns": "01074027",
    "dotregion": 5,
    "geoid": "39029",
    "lsad": "06",
    "name": "Columbiana",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2695,
    "affgeoid": "0500000US39031",
    "aland": 1460530890,
    "awater": 9243185,
    "countyfp": "031",
    "countyns": "01074028",
    "dotregion": 5,
    "geoid": "39031",
    "lsad": "06",
    "name": "Coshocton",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 125,
    "affgeoid": "0500000US39033",
    "aland": 1040619677,
    "awater": 2359515,
    "countyfp": "033",
    "countyns": "01074029",
    "dotregion": 5,
    "geoid": "39033",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2226,
    "affgeoid": "0500000US39035",
    "aland": 1184017002,
    "awater": 2041887878,
    "countyfp": "035",
    "countyns": "01074030",
    "dotregion": 5,
    "geoid": "39035",
    "lsad": "06",
    "name": "Cuyahoga",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 541,
    "affgeoid": "0500000US39037",
    "aland": 1549120892,
    "awater": 4245786,
    "countyfp": "037",
    "countyns": "01074031",
    "dotregion": 5,
    "geoid": "39037",
    "lsad": "06",
    "name": "Darke",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1042,
    "affgeoid": "0500000US39039",
    "aland": 1065649896,
    "awater": 7073999,
    "countyfp": "039",
    "countyns": "01074032",
    "dotregion": 5,
    "geoid": "39039",
    "lsad": "06",
    "name": "Defiance",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2601,
    "affgeoid": "0500000US39041",
    "aland": 1147867057,
    "awater": 36610531,
    "countyfp": "041",
    "countyns": "01074033",
    "dotregion": 5,
    "geoid": "39041",
    "lsad": "06",
    "name": "Delaware",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2821,
    "affgeoid": "0500000US39043",
    "aland": 651628988,
    "awater": 969639896,
    "countyfp": "043",
    "countyns": "01074034",
    "dotregion": 5,
    "geoid": "39043",
    "lsad": "06",
    "name": "Erie",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1421,
    "affgeoid": "0500000US39045",
    "aland": 1306415658,
    "awater": 10752450,
    "countyfp": "045",
    "countyns": "01074035",
    "dotregion": 5,
    "geoid": "39045",
    "lsad": "06",
    "name": "Fairfield",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 256,
    "affgeoid": "0500000US39047",
    "aland": 1052458587,
    "awater": 1705317,
    "countyfp": "047",
    "countyns": "01074036",
    "dotregion": 5,
    "geoid": "39047",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 3012,
    "affgeoid": "0500000US39049",
    "aland": 1378858535,
    "awater": 29120125,
    "countyfp": "049",
    "countyns": "01074037",
    "dotregion": 5,
    "geoid": "39049",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 305,
    "affgeoid": "0500000US39051",
    "aland": 1050089559,
    "awater": 4621138,
    "countyfp": "051",
    "countyns": "01074038",
    "dotregion": 5,
    "geoid": "39051",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2448,
    "affgeoid": "0500000US39053",
    "aland": 1208307869,
    "awater": 12085302,
    "countyfp": "053",
    "countyns": "01074039",
    "dotregion": 5,
    "geoid": "39053",
    "lsad": "06",
    "name": "Gallia",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2440,
    "affgeoid": "0500000US39055",
    "aland": 1036429794,
    "awater": 21045381,
    "countyfp": "055",
    "countyns": "01074040",
    "dotregion": 5,
    "geoid": "39055",
    "lsad": "06",
    "name": "Geauga",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 905,
    "affgeoid": "0500000US39057",
    "aland": 1071562434,
    "awater": 6534715,
    "countyfp": "057",
    "countyns": "01074041",
    "dotregion": 5,
    "geoid": "39057",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1087,
    "affgeoid": "0500000US39059",
    "aland": 1352631185,
    "awater": 15666075,
    "countyfp": "059",
    "countyns": "01074042",
    "dotregion": 5,
    "geoid": "39059",
    "lsad": "06",
    "name": "Guernsey",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 766,
    "affgeoid": "0500000US39061",
    "aland": 1051292076,
    "awater": 17412454,
    "countyfp": "061",
    "countyns": "01074043",
    "dotregion": 5,
    "geoid": "39061",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2223,
    "affgeoid": "0500000US39063",
    "aland": 1376210232,
    "awater": 5959837,
    "countyfp": "063",
    "countyns": "01074044",
    "dotregion": 5,
    "geoid": "39063",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2962,
    "affgeoid": "0500000US39065",
    "aland": 1218342693,
    "awater": 629922,
    "countyfp": "065",
    "countyns": "01074045",
    "dotregion": 5,
    "geoid": "39065",
    "lsad": "06",
    "name": "Hardin",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2670,
    "affgeoid": "0500000US39067",
    "aland": 1042034966,
    "awater": 21847164,
    "countyfp": "067",
    "countyns": "01074046",
    "dotregion": 5,
    "geoid": "39067",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1811,
    "affgeoid": "0500000US39069",
    "aland": 1077461476,
    "awater": 9687645,
    "countyfp": "069",
    "countyns": "01074047",
    "dotregion": 5,
    "geoid": "39069",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2147,
    "affgeoid": "0500000US39071",
    "aland": 1432479997,
    "awater": 12194983,
    "countyfp": "071",
    "countyns": "01074048",
    "dotregion": 5,
    "geoid": "39071",
    "lsad": "06",
    "name": "Highland",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1088,
    "affgeoid": "0500000US39073",
    "aland": 1091228516,
    "awater": 5962792,
    "countyfp": "073",
    "countyns": "01074049",
    "dotregion": 5,
    "geoid": "39073",
    "lsad": "06",
    "name": "Hocking",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2530,
    "affgeoid": "0500000US39075",
    "aland": 1094355766,
    "awater": 3745335,
    "countyfp": "075",
    "countyns": "01074050",
    "dotregion": 5,
    "geoid": "39075",
    "lsad": "06",
    "name": "Holmes",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2785,
    "affgeoid": "0500000US39077",
    "aland": 1272965337,
    "awater": 8615925,
    "countyfp": "077",
    "countyns": "01074051",
    "dotregion": 5,
    "geoid": "39077",
    "lsad": "06",
    "name": "Huron",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 946,
    "affgeoid": "0500000US39079",
    "aland": 1088581966,
    "awater": 3184785,
    "countyfp": "079",
    "countyns": "01074052",
    "dotregion": 5,
    "geoid": "39079",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1152,
    "affgeoid": "0500000US39081",
    "aland": 1057248948,
    "awater": 7120754,
    "countyfp": "081",
    "countyns": "01074053",
    "dotregion": 5,
    "geoid": "39081",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1426,
    "affgeoid": "0500000US39083",
    "aland": 1361054322,
    "awater": 10718576,
    "countyfp": "083",
    "countyns": "01074054",
    "dotregion": 5,
    "geoid": "39083",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2424,
    "affgeoid": "0500000US39085",
    "aland": 590615709,
    "awater": 1945490689,
    "countyfp": "085",
    "countyns": "01074055",
    "dotregion": 5,
    "geoid": "39085",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 767,
    "affgeoid": "0500000US39087",
    "aland": 1174224656,
    "awater": 10110032,
    "countyfp": "087",
    "countyns": "01074056",
    "dotregion": 5,
    "geoid": "39087",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1673,
    "affgeoid": "0500000US39089",
    "aland": 1767294243,
    "awater": 12967958,
    "countyfp": "089",
    "countyns": "01074057",
    "dotregion": 5,
    "geoid": "39089",
    "lsad": "06",
    "name": "Licking",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 320,
    "affgeoid": "0500000US39091",
    "aland": 1187336848,
    "awater": 21598324,
    "countyfp": "091",
    "countyns": "01074058",
    "dotregion": 5,
    "geoid": "39091",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1261,
    "affgeoid": "0500000US39093",
    "aland": 1272001920,
    "awater": 1119452696,
    "countyfp": "093",
    "countyns": "01074059",
    "dotregion": 5,
    "geoid": "39093",
    "lsad": "06",
    "name": "Lorain",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1373,
    "affgeoid": "0500000US39095",
    "aland": 882812540,
    "awater": 660501958,
    "countyfp": "095",
    "countyns": "01074060",
    "dotregion": 5,
    "geoid": "39095",
    "lsad": "06",
    "name": "Lucas",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 238,
    "affgeoid": "0500000US39097",
    "aland": 1206646146,
    "awater": 1919019,
    "countyfp": "097",
    "countyns": "01074061",
    "dotregion": 5,
    "geoid": "39097",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1705,
    "affgeoid": "0500000US39099",
    "aland": 1065799596,
    "awater": 35434368,
    "countyfp": "099",
    "countyns": "01074062",
    "dotregion": 5,
    "geoid": "39099",
    "lsad": "06",
    "name": "Mahoning",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 34,
    "affgeoid": "0500000US39101",
    "aland": 1045726876,
    "awater": 908577,
    "countyfp": "101",
    "countyns": "01074063",
    "dotregion": 5,
    "geoid": "39101",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1719,
    "affgeoid": "0500000US39103",
    "aland": 1091406445,
    "awater": 4198457,
    "countyfp": "103",
    "countyns": "01074064",
    "dotregion": 5,
    "geoid": "39103",
    "lsad": "06",
    "name": "Medina",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2585,
    "affgeoid": "0500000US39105",
    "aland": 1113958479,
    "awater": 7519824,
    "countyfp": "105",
    "countyns": "01074065",
    "dotregion": 5,
    "geoid": "39105",
    "lsad": "06",
    "name": "Meigs",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 979,
    "affgeoid": "0500000US39107",
    "aland": 1197738408,
    "awater": 28425902,
    "countyfp": "107",
    "countyns": "01074066",
    "dotregion": 5,
    "geoid": "39107",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 9,
    "affgeoid": "0500000US39109",
    "aland": 1053028413,
    "awater": 7967437,
    "countyfp": "109",
    "countyns": "01074067",
    "dotregion": 5,
    "geoid": "39109",
    "lsad": "06",
    "name": "Miami",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1349,
    "affgeoid": "0500000US39111",
    "aland": 1180317769,
    "awater": 4495382,
    "countyfp": "111",
    "countyns": "01074068",
    "dotregion": 5,
    "geoid": "39111",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1446,
    "affgeoid": "0500000US39113",
    "aland": 1195426529,
    "awater": 7203231,
    "countyfp": "113",
    "countyns": "01074069",
    "dotregion": 5,
    "geoid": "39113",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2405,
    "affgeoid": "0500000US39115",
    "aland": 1078531133,
    "awater": 13881789,
    "countyfp": "115",
    "countyns": "01074070",
    "dotregion": 5,
    "geoid": "39115",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 964,
    "affgeoid": "0500000US39117",
    "aland": 1051881046,
    "awater": 2819351,
    "countyfp": "117",
    "countyns": "01074071",
    "dotregion": 5,
    "geoid": "39117",
    "lsad": "06",
    "name": "Morrow",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 992,
    "affgeoid": "0500000US39119",
    "aland": 1721328071,
    "awater": 20657330,
    "countyfp": "119",
    "countyns": "01074072",
    "dotregion": 5,
    "geoid": "39119",
    "lsad": "06",
    "name": "Muskingum",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 993,
    "affgeoid": "0500000US39121",
    "aland": 1030845399,
    "awater": 16985543,
    "countyfp": "121",
    "countyns": "01074073",
    "dotregion": 5,
    "geoid": "39121",
    "lsad": "06",
    "name": "Noble",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 639,
    "affgeoid": "0500000US39123",
    "aland": 660275590,
    "awater": 855031761,
    "countyfp": "123",
    "countyns": "01074074",
    "dotregion": 5,
    "geoid": "39123",
    "lsad": "06",
    "name": "Ottawa",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 661,
    "affgeoid": "0500000US39125",
    "aland": 1078561242,
    "awater": 6245392,
    "countyfp": "125",
    "countyns": "01074075",
    "dotregion": 5,
    "geoid": "39125",
    "lsad": "06",
    "name": "Paulding",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2449,
    "affgeoid": "0500000US39127",
    "aland": 1056682414,
    "awater": 11653682,
    "countyfp": "127",
    "countyns": "01074076",
    "dotregion": 5,
    "geoid": "39127",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 277,
    "affgeoid": "0500000US39129",
    "aland": 1298451164,
    "awater": 13514257,
    "countyfp": "129",
    "countyns": "01074077",
    "dotregion": 5,
    "geoid": "39129",
    "lsad": "06",
    "name": "Pickaway",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 670,
    "affgeoid": "0500000US39131",
    "aland": 1140324458,
    "awater": 9567612,
    "countyfp": "131",
    "countyns": "01074078",
    "dotregion": 5,
    "geoid": "39131",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2406,
    "affgeoid": "0500000US39133",
    "aland": 1262374976,
    "awater": 43121843,
    "countyfp": "133",
    "countyns": "01074079",
    "dotregion": 5,
    "geoid": "39133",
    "lsad": "06",
    "name": "Portage",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 21,
    "affgeoid": "0500000US39135",
    "aland": 1098738402,
    "awater": 6065437,
    "countyfp": "135",
    "countyns": "01074080",
    "dotregion": 5,
    "geoid": "39135",
    "lsad": "06",
    "name": "Preble",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2115,
    "affgeoid": "0500000US39137",
    "aland": 1249724515,
    "awater": 4603964,
    "countyfp": "137",
    "countyns": "01074081",
    "dotregion": 5,
    "geoid": "39137",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 827,
    "affgeoid": "0500000US39139",
    "aland": 1282720855,
    "awater": 12470884,
    "countyfp": "139",
    "countyns": "01074082",
    "dotregion": 5,
    "geoid": "39139",
    "lsad": "06",
    "name": "Richland",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 940,
    "affgeoid": "0500000US39141",
    "aland": 1784987273,
    "awater": 9938174,
    "countyfp": "141",
    "countyns": "01074083",
    "dotregion": 5,
    "geoid": "39141",
    "lsad": "06",
    "name": "Ross",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 418,
    "affgeoid": "0500000US39143",
    "aland": 1057901466,
    "awater": 23963729,
    "countyfp": "143",
    "countyns": "01074084",
    "dotregion": 5,
    "geoid": "39143",
    "lsad": "06",
    "name": "Sandusky",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2320,
    "affgeoid": "0500000US39145",
    "aland": 1580450320,
    "awater": 15365075,
    "countyfp": "145",
    "countyns": "01074085",
    "dotregion": 5,
    "geoid": "39145",
    "lsad": "06",
    "name": "Scioto",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 252,
    "affgeoid": "0500000US39147",
    "aland": 1427135405,
    "awater": 4593158,
    "countyfp": "147",
    "countyns": "01074086",
    "dotregion": 5,
    "geoid": "39147",
    "lsad": "06",
    "name": "Seneca",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 575,
    "affgeoid": "0500000US39149",
    "aland": 1055875225,
    "awater": 7809814,
    "countyfp": "149",
    "countyns": "01074087",
    "dotregion": 5,
    "geoid": "39149",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1714,
    "affgeoid": "0500000US39151",
    "aland": 1490089712,
    "awater": 13610835,
    "countyfp": "151",
    "countyns": "01065576",
    "dotregion": 5,
    "geoid": "39151",
    "lsad": "06",
    "name": "Stark",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2134,
    "affgeoid": "0500000US39153",
    "aland": 1069244602,
    "awater": 18896599,
    "countyfp": "153",
    "countyns": "01074088",
    "dotregion": 5,
    "geoid": "39153",
    "lsad": "06",
    "name": "Summit",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 254,
    "affgeoid": "0500000US39155",
    "aland": 1601379252,
    "awater": 47321072,
    "countyfp": "155",
    "countyns": "01074089",
    "dotregion": 5,
    "geoid": "39155",
    "lsad": "06",
    "name": "Trumbull",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 826,
    "affgeoid": "0500000US39157",
    "aland": 1470181125,
    "awater": 9869084,
    "countyfp": "157",
    "countyns": "01074090",
    "dotregion": 5,
    "geoid": "39157",
    "lsad": "06",
    "name": "Tuscarawas",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1059,
    "affgeoid": "0500000US39159",
    "aland": 1118207362,
    "awater": 13286002,
    "countyfp": "159",
    "countyns": "01074091",
    "dotregion": 5,
    "geoid": "39159",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 3162,
    "affgeoid": "0500000US39161",
    "aland": 1059698928,
    "awater": 3281853,
    "countyfp": "161",
    "countyns": "01074092",
    "dotregion": 5,
    "geoid": "39161",
    "lsad": "06",
    "name": "Van Wert",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1060,
    "affgeoid": "0500000US39163",
    "aland": 1068008729,
    "awater": 6781201,
    "countyfp": "163",
    "countyns": "01074093",
    "dotregion": 5,
    "geoid": "39163",
    "lsad": "06",
    "name": "Vinton",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2121,
    "affgeoid": "0500000US39165",
    "aland": 1039437403,
    "awater": 15502858,
    "countyfp": "165",
    "countyns": "01074094",
    "dotregion": 5,
    "geoid": "39165",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 787,
    "affgeoid": "0500000US39167",
    "aland": 1636799193,
    "awater": 20784911,
    "countyfp": "167",
    "countyns": "01074095",
    "dotregion": 5,
    "geoid": "39167",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 2874,
    "affgeoid": "0500000US39169",
    "aland": 1437257218,
    "awater": 4885101,
    "countyfp": "169",
    "countyns": "01074096",
    "dotregion": 5,
    "geoid": "39169",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 1341,
    "affgeoid": "0500000US39171",
    "aland": 1090296613,
    "awater": 5507083,
    "countyfp": "171",
    "countyns": "01074097",
    "dotregion": 5,
    "geoid": "39171",
    "lsad": "06",
    "name": "Williams",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 916,
    "affgeoid": "0500000US39173",
    "aland": 1598565380,
    "awater": 8488613,
    "countyfp": "173",
    "countyns": "01074098",
    "dotregion": 5,
    "geoid": "39173",
    "lsad": "06",
    "name": "Wood",
    "stateAbbreviation": "OH",
    "stateId": 19
  }, {
    "id": 79,
    "affgeoid": "0500000US39175",
    "aland": 1053773792,
    "awater": 1783531,
    "countyfp": "175",
    "countyns": "01074099",
    "dotregion": 5,
    "geoid": "39175",
    "lsad": "06",
    "name": "Wyandot",
    "stateAbbreviation": "OH",
    "stateId": 19
  }]
}, {
  "id": 29,
  "abbreviation": "OK",
  "affgeoid": "0400000US40",
  "aland": 177663043025,
  "awater": 3374050771,
  "dotregion": 6,
  "geoid": "40",
  "lsad": "00",
  "name": "Oklahoma",
  "stateAbbreviation": "OK",
  "statefp": "40",
  "statens": "01102857",
  "counties": [{
    "id": 340,
    "affgeoid": "0500000US40001",
    "aland": 1485305065,
    "awater": 9254749,
    "countyfp": "001",
    "countyns": "01101788",
    "dotregion": 6,
    "geoid": "40001",
    "lsad": "06",
    "name": "Adair",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1490,
    "affgeoid": "0500000US40003",
    "aland": 2244107192,
    "awater": 38546675,
    "countyfp": "003",
    "countyns": "01101789",
    "dotregion": 6,
    "geoid": "40003",
    "lsad": "06",
    "name": "Alfalfa",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2584,
    "affgeoid": "0500000US40005",
    "aland": 2526579500,
    "awater": 37283827,
    "countyfp": "005",
    "countyns": "01101790",
    "dotregion": 6,
    "geoid": "40005",
    "lsad": "06",
    "name": "Atoka",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1792,
    "affgeoid": "0500000US40007",
    "aland": 4700042738,
    "awater": 7347161,
    "countyfp": "007",
    "countyns": "01101791",
    "dotregion": 6,
    "geoid": "40007",
    "lsad": "06",
    "name": "Beaver",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2556,
    "affgeoid": "0500000US40009",
    "aland": 2335665265,
    "awater": 5527154,
    "countyfp": "009",
    "countyns": "01101792",
    "dotregion": 6,
    "geoid": "40009",
    "lsad": "06",
    "name": "Beckham",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 414,
    "affgeoid": "0500000US40011",
    "aland": 2404605084,
    "awater": 26851760,
    "countyfp": "011",
    "countyns": "01101793",
    "dotregion": 6,
    "geoid": "40011",
    "lsad": "06",
    "name": "Blaine",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1386,
    "affgeoid": "0500000US40013",
    "aland": 2342539526,
    "awater": 102255715,
    "countyfp": "013",
    "countyns": "01101794",
    "dotregion": 6,
    "geoid": "40013",
    "lsad": "06",
    "name": "Bryan",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1001,
    "affgeoid": "0500000US40015",
    "aland": 3310745124,
    "awater": 30820525,
    "countyfp": "015",
    "countyns": "01101795",
    "dotregion": 6,
    "geoid": "40015",
    "lsad": "06",
    "name": "Caddo",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 612,
    "affgeoid": "0500000US40017",
    "aland": 2322263469,
    "awater": 23231531,
    "countyfp": "017",
    "countyns": "01101796",
    "dotregion": 6,
    "geoid": "40017",
    "lsad": "06",
    "name": "Canadian",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 537,
    "affgeoid": "0500000US40019",
    "aland": 2129427858,
    "awater": 30013356,
    "countyfp": "019",
    "countyns": "01101797",
    "dotregion": 6,
    "geoid": "40019",
    "lsad": "06",
    "name": "Carter",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2550,
    "affgeoid": "0500000US40021",
    "aland": 1940958254,
    "awater": 69624105,
    "countyfp": "021",
    "countyns": "01101798",
    "dotregion": 6,
    "geoid": "40021",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2803,
    "affgeoid": "0500000US40023",
    "aland": 1995215215,
    "awater": 75666999,
    "countyfp": "023",
    "countyns": "01101799",
    "dotregion": 6,
    "geoid": "40023",
    "lsad": "06",
    "name": "Choctaw",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 116,
    "affgeoid": "0500000US40025",
    "aland": 4751948060,
    "awater": 15923999,
    "countyfp": "025",
    "countyns": "01101800",
    "dotregion": 6,
    "geoid": "40025",
    "lsad": "06",
    "name": "Cimarron",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2032,
    "affgeoid": "0500000US40027",
    "aland": 1395516164,
    "awater": 49921161,
    "countyfp": "027",
    "countyns": "01101801",
    "dotregion": 6,
    "geoid": "40027",
    "lsad": "06",
    "name": "Cleveland",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1039,
    "affgeoid": "0500000US40029",
    "aland": 1338200617,
    "awater": 12079760,
    "countyfp": "029",
    "countyns": "01101802",
    "dotregion": 6,
    "geoid": "40029",
    "lsad": "06",
    "name": "Coal",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1804,
    "affgeoid": "0500000US40031",
    "aland": 2769447472,
    "awater": 37331078,
    "countyfp": "031",
    "countyns": "01101803",
    "dotregion": 6,
    "geoid": "40031",
    "lsad": "06",
    "name": "Comanche",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2346,
    "affgeoid": "0500000US40033",
    "aland": 1638566732,
    "awater": 24095321,
    "countyfp": "033",
    "countyns": "01101804",
    "dotregion": 6,
    "geoid": "40033",
    "lsad": "06",
    "name": "Cotton",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1569,
    "affgeoid": "0500000US40035",
    "aland": 1971897021,
    "awater": 3697828,
    "countyfp": "035",
    "countyns": "01101805",
    "dotregion": 6,
    "geoid": "40035",
    "lsad": "06",
    "name": "Craig",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1483,
    "affgeoid": "0500000US40037",
    "aland": 2460877092,
    "awater": 50957689,
    "countyfp": "037",
    "countyns": "01101806",
    "dotregion": 6,
    "geoid": "40037",
    "lsad": "06",
    "name": "Creek",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2497,
    "affgeoid": "0500000US40039",
    "aland": 2561032754,
    "awater": 34321688,
    "countyfp": "039",
    "countyns": "01101807",
    "dotregion": 6,
    "geoid": "40039",
    "lsad": "06",
    "name": "Custer",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2730,
    "affgeoid": "0500000US40041",
    "aland": 1911820030,
    "awater": 140253641,
    "countyfp": "041",
    "countyns": "01101808",
    "dotregion": 6,
    "geoid": "40041",
    "lsad": "06",
    "name": "Delaware",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 3158,
    "affgeoid": "0500000US40043",
    "aland": 2588642248,
    "awater": 22679881,
    "countyfp": "043",
    "countyns": "01101809",
    "dotregion": 6,
    "geoid": "40043",
    "lsad": "06",
    "name": "Dewey",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2593,
    "affgeoid": "0500000US40045",
    "aland": 3189616689,
    "awater": 952235,
    "countyfp": "045",
    "countyns": "01101810",
    "dotregion": 6,
    "geoid": "40045",
    "lsad": "06",
    "name": "Ellis",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1080,
    "affgeoid": "0500000US40047",
    "aland": 2741478921,
    "awater": 4075930,
    "countyfp": "047",
    "countyns": "01101811",
    "dotregion": 6,
    "geoid": "40047",
    "lsad": "06",
    "name": "Garfield",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2384,
    "affgeoid": "0500000US40049",
    "aland": 2077502570,
    "awater": 29941895,
    "countyfp": "049",
    "countyns": "01101812",
    "dotregion": 6,
    "geoid": "40049",
    "lsad": "06",
    "name": "Garvin",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1358,
    "affgeoid": "0500000US40051",
    "aland": 2850272904,
    "awater": 11403868,
    "countyfp": "051",
    "countyns": "01101813",
    "dotregion": 6,
    "geoid": "40051",
    "lsad": "06",
    "name": "Grady",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 496,
    "affgeoid": "0500000US40053",
    "aland": 2592245019,
    "awater": 7021951,
    "countyfp": "053",
    "countyns": "01101814",
    "dotregion": 6,
    "geoid": "40053",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2287,
    "affgeoid": "0500000US40055",
    "aland": 1655842973,
    "awater": 11157422,
    "countyfp": "055",
    "countyns": "01101815",
    "dotregion": 6,
    "geoid": "40055",
    "lsad": "06",
    "name": "Greer",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1450,
    "affgeoid": "0500000US40057",
    "aland": 1391326397,
    "awater": 3800411,
    "countyfp": "057",
    "countyns": "01101816",
    "dotregion": 6,
    "geoid": "40057",
    "lsad": "06",
    "name": "Harmon",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1105,
    "affgeoid": "0500000US40059",
    "aland": 2691041256,
    "awater": 5259447,
    "countyfp": "059",
    "countyns": "01101817",
    "dotregion": 6,
    "geoid": "40059",
    "lsad": "06",
    "name": "Harper",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2920,
    "affgeoid": "0500000US40061",
    "aland": 1493228788,
    "awater": 126266425,
    "countyfp": "061",
    "countyns": "01101818",
    "dotregion": 6,
    "geoid": "40061",
    "lsad": "06",
    "name": "Haskell",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2760,
    "affgeoid": "0500000US40063",
    "aland": 2084025884,
    "awater": 26504881,
    "countyfp": "063",
    "countyns": "01101819",
    "dotregion": 6,
    "geoid": "40063",
    "lsad": "06",
    "name": "Hughes",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1782,
    "affgeoid": "0500000US40065",
    "aland": 2078855933,
    "awater": 4114419,
    "countyfp": "065",
    "countyns": "01101820",
    "dotregion": 6,
    "geoid": "40065",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1329,
    "affgeoid": "0500000US40067",
    "aland": 1965365197,
    "awater": 39497494,
    "countyfp": "067",
    "countyns": "01101821",
    "dotregion": 6,
    "geoid": "40067",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 3047,
    "affgeoid": "0500000US40069",
    "aland": 1665212030,
    "awater": 39633300,
    "countyfp": "069",
    "countyns": "01101822",
    "dotregion": 6,
    "geoid": "40069",
    "lsad": "06",
    "name": "Johnston",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2362,
    "affgeoid": "0500000US40071",
    "aland": 2382084732,
    "awater": 65369682,
    "countyfp": "071",
    "countyns": "01101823",
    "dotregion": 6,
    "geoid": "40071",
    "lsad": "06",
    "name": "Kay",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 17,
    "affgeoid": "0500000US40073",
    "aland": 2326224062,
    "awater": 20348781,
    "countyfp": "073",
    "countyns": "01101824",
    "dotregion": 6,
    "geoid": "40073",
    "lsad": "06",
    "name": "Kingfisher",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2374,
    "affgeoid": "0500000US40075",
    "aland": 2629209766,
    "awater": 40296743,
    "countyfp": "075",
    "countyns": "01101825",
    "dotregion": 6,
    "geoid": "40075",
    "lsad": "06",
    "name": "Kiowa",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2731,
    "affgeoid": "0500000US40077",
    "aland": 1870181001,
    "awater": 18213565,
    "countyfp": "077",
    "countyns": "01101826",
    "dotregion": 6,
    "geoid": "40077",
    "lsad": "06",
    "name": "Latimer",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2031,
    "affgeoid": "0500000US40079",
    "aland": 4116177453,
    "awater": 49958614,
    "countyfp": "079",
    "countyns": "01101827",
    "dotregion": 6,
    "geoid": "40079",
    "lsad": "06",
    "name": "Le Flore",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 454,
    "affgeoid": "0500000US40081",
    "aland": 2466490650,
    "awater": 34606634,
    "countyfp": "081",
    "countyns": "01101828",
    "dotregion": 6,
    "geoid": "40081",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1568,
    "affgeoid": "0500000US40083",
    "aland": 1926521247,
    "awater": 12926653,
    "countyfp": "083",
    "countyns": "01101829",
    "dotregion": 6,
    "geoid": "40083",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2673,
    "affgeoid": "0500000US40085",
    "aland": 1331240795,
    "awater": 47492824,
    "countyfp": "085",
    "countyns": "01101830",
    "dotregion": 6,
    "geoid": "40085",
    "lsad": "06",
    "name": "Love",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2932,
    "affgeoid": "0500000US40093",
    "aland": 2473407963,
    "awater": 7651201,
    "countyfp": "093",
    "countyns": "01101831",
    "dotregion": 6,
    "geoid": "40093",
    "lsad": "06",
    "name": "Major",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1323,
    "affgeoid": "0500000US40095",
    "aland": 961304333,
    "awater": 144198701,
    "countyfp": "095",
    "countyns": "01101832",
    "dotregion": 6,
    "geoid": "40095",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 262,
    "affgeoid": "0500000US40097",
    "aland": 1697432141,
    "awater": 72855332,
    "countyfp": "097",
    "countyns": "01101833",
    "dotregion": 6,
    "geoid": "40097",
    "lsad": "06",
    "name": "Mayes",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2927,
    "affgeoid": "0500000US40087",
    "aland": 1478114521,
    "awater": 24734527,
    "countyfp": "087",
    "countyns": "01101834",
    "dotregion": 6,
    "geoid": "40087",
    "lsad": "06",
    "name": "McClain",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1881,
    "affgeoid": "0500000US40089",
    "aland": 4793135133,
    "awater": 133993589,
    "countyfp": "089",
    "countyns": "01101835",
    "dotregion": 6,
    "geoid": "40089",
    "lsad": "06",
    "name": "McCurtain",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2896,
    "affgeoid": "0500000US40091",
    "aland": 1601897950,
    "awater": 242913899,
    "countyfp": "091",
    "countyns": "01101836",
    "dotregion": 6,
    "geoid": "40091",
    "lsad": "06",
    "name": "McIntosh",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 3076,
    "affgeoid": "0500000US40099",
    "aland": 1078639097,
    "awater": 22365112,
    "countyfp": "099",
    "countyns": "01101837",
    "dotregion": 6,
    "geoid": "40099",
    "lsad": "06",
    "name": "Murray",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 3136,
    "affgeoid": "0500000US40101",
    "aland": 2099053116,
    "awater": 75966893,
    "countyfp": "101",
    "countyns": "01101838",
    "dotregion": 6,
    "geoid": "40101",
    "lsad": "06",
    "name": "Muskogee",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 907,
    "affgeoid": "0500000US40103",
    "aland": 1895593649,
    "awater": 27552185,
    "countyfp": "103",
    "countyns": "01101839",
    "dotregion": 6,
    "geoid": "40103",
    "lsad": "06",
    "name": "Noble",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1756,
    "affgeoid": "0500000US40105",
    "aland": 1465358447,
    "awater": 38869450,
    "countyfp": "105",
    "countyns": "01101840",
    "dotregion": 6,
    "geoid": "40105",
    "lsad": "06",
    "name": "Nowata",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 265,
    "affgeoid": "0500000US40107",
    "aland": 1602086607,
    "awater": 26680140,
    "countyfp": "107",
    "countyns": "01101841",
    "dotregion": 6,
    "geoid": "40107",
    "lsad": "06",
    "name": "Okfuskee",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 27,
    "affgeoid": "0500000US40109",
    "aland": 1835846205,
    "awater": 24730004,
    "countyfp": "109",
    "countyns": "01101842",
    "dotregion": 6,
    "geoid": "40109",
    "lsad": "06",
    "name": "Oklahoma",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2642,
    "affgeoid": "0500000US40111",
    "aland": 1806123423,
    "awater": 12915763,
    "countyfp": "111",
    "countyns": "01101843",
    "dotregion": 6,
    "geoid": "40111",
    "lsad": "06",
    "name": "Okmulgee",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 3038,
    "affgeoid": "0500000US40113",
    "aland": 5818041506,
    "awater": 149235864,
    "countyfp": "113",
    "countyns": "01101844",
    "dotregion": 6,
    "geoid": "40113",
    "lsad": "06",
    "name": "Osage",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1184,
    "affgeoid": "0500000US40115",
    "aland": 1219467500,
    "awater": 35708902,
    "countyfp": "115",
    "countyns": "01101845",
    "dotregion": 6,
    "geoid": "40115",
    "lsad": "06",
    "name": "Ottawa",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 3163,
    "affgeoid": "0500000US40117",
    "aland": 1471563525,
    "awater": 68852718,
    "countyfp": "117",
    "countyns": "01101846",
    "dotregion": 6,
    "geoid": "40117",
    "lsad": "06",
    "name": "Pawnee",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1041,
    "affgeoid": "0500000US40119",
    "aland": 1773393744,
    "awater": 31771425,
    "countyfp": "119",
    "countyns": "01101847",
    "dotregion": 6,
    "geoid": "40119",
    "lsad": "06",
    "name": "Payne",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1324,
    "affgeoid": "0500000US40121",
    "aland": 3381152482,
    "awater": 187399167,
    "countyfp": "121",
    "countyns": "01101848",
    "dotregion": 6,
    "geoid": "40121",
    "lsad": "06",
    "name": "Pittsburg",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1633,
    "affgeoid": "0500000US40123",
    "aland": 1865879213,
    "awater": 12413427,
    "countyfp": "123",
    "countyns": "01101849",
    "dotregion": 6,
    "geoid": "40123",
    "lsad": "06",
    "name": "Pontotoc",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2407,
    "affgeoid": "0500000US40125",
    "aland": 2040060547,
    "awater": 14842439,
    "countyfp": "125",
    "countyns": "01101850",
    "dotregion": 6,
    "geoid": "40125",
    "lsad": "06",
    "name": "Pottawatomie",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 745,
    "affgeoid": "0500000US40127",
    "aland": 3615200800,
    "awater": 69981946,
    "countyfp": "127",
    "countyns": "01101851",
    "dotregion": 6,
    "geoid": "40127",
    "lsad": "06",
    "name": "Pushmataha",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1737,
    "affgeoid": "0500000US40129",
    "aland": 2955528252,
    "awater": 13695174,
    "countyfp": "129",
    "countyns": "01101852",
    "dotregion": 6,
    "geoid": "40129",
    "lsad": "06",
    "name": "Roger Mills",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 3135,
    "affgeoid": "0500000US40131",
    "aland": 1749945931,
    "awater": 92823523,
    "countyfp": "131",
    "countyns": "01101853",
    "dotregion": 6,
    "geoid": "40131",
    "lsad": "06",
    "name": "Rogers",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 611,
    "affgeoid": "0500000US40133",
    "aland": 1639041091,
    "awater": 19778906,
    "countyfp": "133",
    "countyns": "01101854",
    "dotregion": 6,
    "geoid": "40133",
    "lsad": "06",
    "name": "Seminole",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2081,
    "affgeoid": "0500000US40135",
    "aland": 1743779423,
    "awater": 105832791,
    "countyfp": "135",
    "countyns": "01101855",
    "dotregion": 6,
    "geoid": "40135",
    "lsad": "06",
    "name": "Sequoyah",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1805,
    "affgeoid": "0500000US40137",
    "aland": 2253930696,
    "awater": 54690950,
    "countyfp": "137",
    "countyns": "01101856",
    "dotregion": 6,
    "geoid": "40137",
    "lsad": "06",
    "name": "Stephens",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1541,
    "affgeoid": "0500000US40139",
    "aland": 5286917499,
    "awater": 19215617,
    "countyfp": "139",
    "countyns": "01101857",
    "dotregion": 6,
    "geoid": "40139",
    "lsad": "06",
    "name": "Texas",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1330,
    "affgeoid": "0500000US40141",
    "aland": 2256226760,
    "awater": 20894360,
    "countyfp": "141",
    "countyns": "01101858",
    "dotregion": 6,
    "geoid": "40141",
    "lsad": "06",
    "name": "Tillman",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2431,
    "affgeoid": "0500000US40143",
    "aland": 1477021846,
    "awater": 43361072,
    "countyfp": "143",
    "countyns": "01101859",
    "dotregion": 6,
    "geoid": "40143",
    "lsad": "06",
    "name": "Tulsa",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1843,
    "affgeoid": "0500000US40145",
    "aland": 1454425174,
    "awater": 75403442,
    "countyfp": "145",
    "countyns": "01101860",
    "dotregion": 6,
    "geoid": "40145",
    "lsad": "06",
    "name": "Wagoner",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 2434,
    "affgeoid": "0500000US40147",
    "aland": 1076019506,
    "awater": 22829398,
    "countyfp": "147",
    "countyns": "01101861",
    "dotregion": 6,
    "geoid": "40147",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 1346,
    "affgeoid": "0500000US40149",
    "aland": 2598189859,
    "awater": 14579002,
    "countyfp": "149",
    "countyns": "01101862",
    "dotregion": 6,
    "geoid": "40149",
    "lsad": "06",
    "name": "Washita",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 854,
    "affgeoid": "0500000US40151",
    "aland": 3331900597,
    "awater": 9091699,
    "countyfp": "151",
    "countyns": "01101863",
    "dotregion": 6,
    "geoid": "40151",
    "lsad": "06",
    "name": "Woods",
    "stateAbbreviation": "OK",
    "stateId": 29
  }, {
    "id": 109,
    "affgeoid": "0500000US40153",
    "aland": 3217817742,
    "awater": 9693376,
    "countyfp": "153",
    "countyns": "01101864",
    "dotregion": 6,
    "geoid": "40153",
    "lsad": "06",
    "name": "Woodward",
    "stateAbbreviation": "OK",
    "stateId": 29
  }]
}, {
  "id": 6,
  "abbreviation": "OR",
  "affgeoid": "0400000US41",
  "aland": 248608778890,
  "awater": 6190771822,
  "dotregion": 10,
  "geoid": "41",
  "lsad": "00",
  "name": "Oregon",
  "stateAbbreviation": "OR",
  "statefp": "41",
  "statens": "01155107",
  "counties": [{
    "id": 2199,
    "affgeoid": "0500000US41001",
    "aland": 7946967941,
    "awater": 51825100,
    "countyfp": "001",
    "countyns": "01135845",
    "dotregion": 10,
    "geoid": "41001",
    "lsad": "06",
    "name": "Baker",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2090,
    "affgeoid": "0500000US41003",
    "aland": 1750843967,
    "awater": 6738492,
    "countyfp": "003",
    "countyns": "01155126",
    "dotregion": 10,
    "geoid": "41003",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1984,
    "affgeoid": "0500000US41005",
    "aland": 4844375769,
    "awater": 31814091,
    "countyfp": "005",
    "countyns": "01155127",
    "dotregion": 10,
    "geoid": "41005",
    "lsad": "06",
    "name": "Clackamas",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1007,
    "affgeoid": "0500000US41007",
    "aland": 2147298715,
    "awater": 661241626,
    "countyfp": "007",
    "countyns": "01135846",
    "dotregion": 10,
    "geoid": "41007",
    "lsad": "06",
    "name": "Clatsop",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1379,
    "affgeoid": "0500000US41009",
    "aland": 1702596022,
    "awater": 80170466,
    "countyfp": "009",
    "countyns": "01135847",
    "dotregion": 10,
    "geoid": "41009",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1502,
    "affgeoid": "0500000US41011",
    "aland": 4134073995,
    "awater": 544388947,
    "countyfp": "011",
    "countyns": "01135848",
    "dotregion": 10,
    "geoid": "41011",
    "lsad": "06",
    "name": "Coos",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2179,
    "affgeoid": "0500000US41013",
    "aland": 7715900050,
    "awater": 21091929,
    "countyfp": "013",
    "countyns": "01155128",
    "dotregion": 10,
    "geoid": "41013",
    "lsad": "06",
    "name": "Crook",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2363,
    "affgeoid": "0500000US41015",
    "aland": 4215134990,
    "awater": 934685387,
    "countyfp": "015",
    "countyns": "01155129",
    "dotregion": 10,
    "geoid": "41015",
    "lsad": "06",
    "name": "Curry",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2233,
    "affgeoid": "0500000US41017",
    "aland": 7817045489,
    "awater": 94746122,
    "countyfp": "017",
    "countyns": "01155130",
    "dotregion": 10,
    "geoid": "41017",
    "lsad": "06",
    "name": "Deschutes",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 3153,
    "affgeoid": "0500000US41019",
    "aland": 13044358476,
    "awater": 252043763,
    "countyfp": "019",
    "countyns": "01135849",
    "dotregion": 10,
    "geoid": "41019",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1368,
    "affgeoid": "0500000US41021",
    "aland": 3120411998,
    "awater": 46700546,
    "countyfp": "021",
    "countyns": "01135850",
    "dotregion": 10,
    "geoid": "41021",
    "lsad": "06",
    "name": "Gilliam",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 671,
    "affgeoid": "0500000US41023",
    "aland": 11728847145,
    "awater": 1893807,
    "countyfp": "023",
    "countyns": "01135851",
    "dotregion": 10,
    "geoid": "41023",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 3211,
    "affgeoid": "0500000US41025",
    "aland": 26244972196,
    "awater": 241492989,
    "countyfp": "025",
    "countyns": "01135852",
    "dotregion": 10,
    "geoid": "41025",
    "lsad": "06",
    "name": "Harney",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1520,
    "affgeoid": "0500000US41027",
    "aland": 1351717728,
    "awater": 29106865,
    "countyfp": "027",
    "countyns": "01155131",
    "dotregion": 10,
    "geoid": "41027",
    "lsad": "06",
    "name": "Hood River",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 699,
    "affgeoid": "0500000US41029",
    "aland": 7209372699,
    "awater": 46860852,
    "countyfp": "029",
    "countyns": "01135853",
    "dotregion": 10,
    "geoid": "41029",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1538,
    "affgeoid": "0500000US41031",
    "aland": 4613079593,
    "awater": 26210552,
    "countyfp": "031",
    "countyns": "01155132",
    "dotregion": 10,
    "geoid": "41031",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1225,
    "affgeoid": "0500000US41033",
    "aland": 4246697356,
    "awater": 5623906,
    "countyfp": "033",
    "countyns": "01155133",
    "dotregion": 10,
    "geoid": "41033",
    "lsad": "06",
    "name": "Josephine",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 714,
    "affgeoid": "0500000US41035",
    "aland": 15387212504,
    "awater": 503754829,
    "countyfp": "035",
    "countyns": "01155134",
    "dotregion": 10,
    "geoid": "41035",
    "lsad": "06",
    "name": "Klamath",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 3212,
    "affgeoid": "0500000US41037",
    "aland": 21079921892,
    "awater": 567916244,
    "countyfp": "037",
    "countyns": "01135854",
    "dotregion": 10,
    "geoid": "41037",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2091,
    "affgeoid": "0500000US41039",
    "aland": 11792794737,
    "awater": 436681302,
    "countyfp": "039",
    "countyns": "01135855",
    "dotregion": 10,
    "geoid": "41039",
    "lsad": "06",
    "name": "Lane",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 3009,
    "affgeoid": "0500000US41041",
    "aland": 2537576621,
    "awater": 554316199,
    "countyfp": "041",
    "countyns": "01135856",
    "dotregion": 10,
    "geoid": "41041",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1195,
    "affgeoid": "0500000US41043",
    "aland": 5932815078,
    "awater": 49654169,
    "countyfp": "043",
    "countyns": "01135857",
    "dotregion": 10,
    "geoid": "41043",
    "lsad": "06",
    "name": "Linn",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2536,
    "affgeoid": "0500000US41045",
    "aland": 25608452570,
    "awater": 109243072,
    "countyfp": "045",
    "countyns": "01135858",
    "dotregion": 10,
    "geoid": "41045",
    "lsad": "06",
    "name": "Malheur",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2418,
    "affgeoid": "0500000US41047",
    "aland": 3058841126,
    "awater": 26571700,
    "countyfp": "047",
    "countyns": "01135859",
    "dotregion": 10,
    "geoid": "41047",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 640,
    "affgeoid": "0500000US41049",
    "aland": 5261895534,
    "awater": 43778389,
    "countyfp": "049",
    "countyns": "01135860",
    "dotregion": 10,
    "geoid": "41049",
    "lsad": "06",
    "name": "Morrow",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2704,
    "affgeoid": "0500000US41051",
    "aland": 1116512314,
    "awater": 88741757,
    "countyfp": "051",
    "countyns": "01135861",
    "dotregion": 10,
    "geoid": "41051",
    "lsad": "06",
    "name": "Multnomah",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2141,
    "affgeoid": "0500000US41053",
    "aland": 1918732330,
    "awater": 8147540,
    "countyfp": "053",
    "countyns": "01135862",
    "dotregion": 10,
    "geoid": "41053",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1209,
    "affgeoid": "0500000US41055",
    "aland": 2133345227,
    "awater": 19403373,
    "countyfp": "055",
    "countyns": "01135863",
    "dotregion": 10,
    "geoid": "41055",
    "lsad": "06",
    "name": "Sherman",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1148,
    "affgeoid": "0500000US41057",
    "aland": 2855673741,
    "awater": 596174152,
    "countyfp": "057",
    "countyns": "01135864",
    "dotregion": 10,
    "geoid": "41057",
    "lsad": "06",
    "name": "Tillamook",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 1210,
    "affgeoid": "0500000US41059",
    "aland": 8328078990,
    "awater": 41193710,
    "countyfp": "059",
    "countyns": "01156673",
    "dotregion": 10,
    "geoid": "41059",
    "lsad": "06",
    "name": "Umatilla",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2371,
    "affgeoid": "0500000US41061",
    "aland": 5274790700,
    "awater": 4995926,
    "countyfp": "061",
    "countyns": "01164165",
    "dotregion": 10,
    "geoid": "41061",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 3021,
    "affgeoid": "0500000US41063",
    "aland": 8148602810,
    "awater": 14199330,
    "countyfp": "063",
    "countyns": "01155135",
    "dotregion": 10,
    "geoid": "41063",
    "lsad": "06",
    "name": "Wallowa",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2204,
    "affgeoid": "0500000US41065",
    "aland": 6168179681,
    "awater": 35948263,
    "countyfp": "065",
    "countyns": "01155136",
    "dotregion": 10,
    "geoid": "41065",
    "lsad": "06",
    "name": "Wasco",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2010,
    "affgeoid": "0500000US41067",
    "aland": 1876398292,
    "awater": 5676392,
    "countyfp": "067",
    "countyns": "01155137",
    "dotregion": 10,
    "geoid": "41067",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 2088,
    "affgeoid": "0500000US41069",
    "aland": 4441211316,
    "awater": 1242198,
    "countyfp": "069",
    "countyns": "01135865",
    "dotregion": 10,
    "geoid": "41069",
    "lsad": "06",
    "name": "Wheeler",
    "stateAbbreviation": "OR",
    "stateId": 6
  }, {
    "id": 688,
    "affgeoid": "0500000US41071",
    "aland": 1854049298,
    "awater": 6497837,
    "countyfp": "071",
    "countyns": "01135866",
    "dotregion": 10,
    "geoid": "41071",
    "lsad": "06",
    "name": "Yamhill",
    "stateAbbreviation": "OR",
    "stateId": 6
  }]
}, {
  "id": 47,
  "abbreviation": "PA",
  "affgeoid": "0400000US42",
  "aland": 115883499352,
  "awater": 3396643587,
  "dotregion": 3,
  "geoid": "42",
  "lsad": "00",
  "name": "Pennsylvania",
  "stateAbbreviation": "PA",
  "statefp": "42",
  "statens": "01779798",
  "counties": [{
    "id": 89,
    "affgeoid": "0500000US42001",
    "aland": 1343400048,
    "awater": 7883930,
    "countyfp": "001",
    "countyns": "01213656",
    "dotregion": 3,
    "geoid": "42001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2947,
    "affgeoid": "0500000US42003",
    "aland": 1890889518,
    "awater": 37411670,
    "countyfp": "003",
    "countyns": "01213657",
    "dotregion": 3,
    "geoid": "42003",
    "lsad": "06",
    "name": "Allegheny",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1867,
    "affgeoid": "0500000US42005",
    "aland": 1691786924,
    "awater": 27556957,
    "countyfp": "005",
    "countyns": "01213658",
    "dotregion": 3,
    "geoid": "42005",
    "lsad": "06",
    "name": "Armstrong",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 120,
    "affgeoid": "0500000US42007",
    "aland": 1125901160,
    "awater": 24165972,
    "countyfp": "007",
    "countyns": "01214112",
    "dotregion": 3,
    "geoid": "42007",
    "lsad": "06",
    "name": "Beaver",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1206,
    "affgeoid": "0500000US42009",
    "aland": 2621836590,
    "awater": 11935889,
    "countyfp": "009",
    "countyns": "01209171",
    "dotregion": 3,
    "geoid": "42009",
    "lsad": "06",
    "name": "Bedford",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1550,
    "affgeoid": "0500000US42011",
    "aland": 2218040257,
    "awater": 24252061,
    "countyfp": "011",
    "countyns": "01209172",
    "dotregion": 3,
    "geoid": "42011",
    "lsad": "06",
    "name": "Berks",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1529,
    "affgeoid": "0500000US42013",
    "aland": 1361815246,
    "awater": 3285511,
    "countyfp": "013",
    "countyns": "01213659",
    "dotregion": 3,
    "geoid": "42013",
    "lsad": "06",
    "name": "Blair",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2720,
    "affgeoid": "0500000US42015",
    "aland": 2971750796,
    "awater": 35275587,
    "countyfp": "015",
    "countyns": "01213660",
    "dotregion": 3,
    "geoid": "42015",
    "lsad": "06",
    "name": "Bradford",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1576,
    "affgeoid": "0500000US42017",
    "aland": 1565316699,
    "awater": 45329736,
    "countyfp": "017",
    "countyns": "01209173",
    "dotregion": 3,
    "geoid": "42017",
    "lsad": "06",
    "name": "Bucks",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1988,
    "affgeoid": "0500000US42019",
    "aland": 2042451168,
    "awater": 15948239,
    "countyfp": "019",
    "countyns": "01213661",
    "dotregion": 3,
    "geoid": "42019",
    "lsad": "06",
    "name": "Butler",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2960,
    "affgeoid": "0500000US42021",
    "aland": 1782823041,
    "awater": 13677375,
    "countyfp": "021",
    "countyns": "01213662",
    "dotregion": 3,
    "geoid": "42021",
    "lsad": "06",
    "name": "Cambria",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1116,
    "affgeoid": "0500000US42023",
    "aland": 1026231717,
    "awater": 5664033,
    "countyfp": "023",
    "countyns": "01213663",
    "dotregion": 3,
    "geoid": "42023",
    "lsad": "06",
    "name": "Cameron",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 28,
    "affgeoid": "0500000US42025",
    "aland": 987977576,
    "awater": 15349904,
    "countyfp": "025",
    "countyns": "01213664",
    "dotregion": 3,
    "geoid": "42025",
    "lsad": "06",
    "name": "Carbon",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2624,
    "affgeoid": "0500000US42027",
    "aland": 2874687362,
    "awater": 7878513,
    "countyfp": "027",
    "countyns": "01214720",
    "dotregion": 3,
    "geoid": "42027",
    "lsad": "06",
    "name": "Centre",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1145,
    "affgeoid": "0500000US42029",
    "aland": 1943821140,
    "awater": 22587331,
    "countyfp": "029",
    "countyns": "01209174",
    "dotregion": 3,
    "geoid": "42029",
    "lsad": "06",
    "name": "Chester",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1515,
    "affgeoid": "0500000US42031",
    "aland": 1556153772,
    "awater": 23335886,
    "countyfp": "031",
    "countyns": "01210234",
    "dotregion": 3,
    "geoid": "42031",
    "lsad": "06",
    "name": "Clarion",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2703,
    "affgeoid": "0500000US42033",
    "aland": 2964817439,
    "awater": 23932649,
    "countyfp": "033",
    "countyns": "01209175",
    "dotregion": 3,
    "geoid": "42033",
    "lsad": "06",
    "name": "Clearfield",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2022,
    "affgeoid": "0500000US42035",
    "aland": 2299868232,
    "awater": 23178794,
    "countyfp": "035",
    "countyns": "01214721",
    "dotregion": 3,
    "geoid": "42035",
    "lsad": "06",
    "name": "Clinton",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1494,
    "affgeoid": "0500000US42037",
    "aland": 1251240675,
    "awater": 18266325,
    "countyfp": "037",
    "countyns": "01213665",
    "dotregion": 3,
    "geoid": "42037",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1631,
    "affgeoid": "0500000US42039",
    "aland": 2621846809,
    "awater": 65303124,
    "countyfp": "039",
    "countyns": "01213666",
    "dotregion": 3,
    "geoid": "42039",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2033,
    "affgeoid": "0500000US42041",
    "aland": 1412834154,
    "awater": 12521844,
    "countyfp": "041",
    "countyns": "01209176",
    "dotregion": 3,
    "geoid": "42041",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1692,
    "affgeoid": "0500000US42043",
    "aland": 1359893290,
    "awater": 85780784,
    "countyfp": "043",
    "countyns": "01213667",
    "dotregion": 3,
    "geoid": "42043",
    "lsad": "06",
    "name": "Dauphin",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1492,
    "affgeoid": "0500000US42045",
    "aland": 476226980,
    "awater": 17433559,
    "countyfp": "045",
    "countyns": "01209177",
    "dotregion": 3,
    "geoid": "42045",
    "lsad": "06",
    "name": "Delaware",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2636,
    "affgeoid": "0500000US42047",
    "aland": 2142861754,
    "awater": 12818644,
    "countyfp": "047",
    "countyns": "01213668",
    "dotregion": 3,
    "geoid": "42047",
    "lsad": "06",
    "name": "Elk",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2045,
    "affgeoid": "0500000US42049",
    "aland": 2069952474,
    "awater": 1965847842,
    "countyfp": "049",
    "countyns": "01209178",
    "dotregion": 3,
    "geoid": "42049",
    "lsad": "06",
    "name": "Erie",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2436,
    "affgeoid": "0500000US42051",
    "aland": 2046968033,
    "awater": 20644021,
    "countyfp": "051",
    "countyns": "01209179",
    "dotregion": 3,
    "geoid": "42051",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2321,
    "affgeoid": "0500000US42053",
    "aland": 1106625250,
    "awater": 8355296,
    "countyfp": "053",
    "countyns": "01213669",
    "dotregion": 3,
    "geoid": "42053",
    "lsad": "06",
    "name": "Forest",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1227,
    "affgeoid": "0500000US42055",
    "aland": 2000052119,
    "awater": 1544300,
    "countyfp": "055",
    "countyns": "01213670",
    "dotregion": 3,
    "geoid": "42055",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2635,
    "affgeoid": "0500000US42057",
    "aland": 1133252800,
    "awater": 1305486,
    "countyfp": "057",
    "countyns": "01213671",
    "dotregion": 3,
    "geoid": "42057",
    "lsad": "06",
    "name": "Fulton",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2435,
    "affgeoid": "0500000US42059",
    "aland": 1491700970,
    "awater": 5253864,
    "countyfp": "059",
    "countyns": "01214033",
    "dotregion": 3,
    "geoid": "42059",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1998,
    "affgeoid": "0500000US42061",
    "aland": 2265337402,
    "awater": 37851955,
    "countyfp": "061",
    "countyns": "01213672",
    "dotregion": 3,
    "geoid": "42061",
    "lsad": "06",
    "name": "Huntingdon",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 3029,
    "affgeoid": "0500000US42063",
    "aland": 2141999553,
    "awater": 18812180,
    "countyfp": "063",
    "countyns": "01213673",
    "dotregion": 3,
    "geoid": "42063",
    "lsad": "06",
    "name": "Indiana",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2529,
    "affgeoid": "0500000US42065",
    "aland": 1689784200,
    "awater": 11321806,
    "countyfp": "065",
    "countyns": "01213674",
    "dotregion": 3,
    "geoid": "42065",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1389,
    "affgeoid": "0500000US42067",
    "aland": 1013592889,
    "awater": 5606074,
    "countyfp": "067",
    "countyns": "01209180",
    "dotregion": 3,
    "geoid": "42067",
    "lsad": "06",
    "name": "Juniata",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2914,
    "affgeoid": "0500000US42069",
    "aland": 1188215428,
    "awater": 15896171,
    "countyfp": "069",
    "countyns": "01213675",
    "dotregion": 3,
    "geoid": "42069",
    "lsad": "06",
    "name": "Lackawanna",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1639,
    "affgeoid": "0500000US42071",
    "aland": 2444495031,
    "awater": 103535036,
    "countyfp": "071",
    "countyns": "01209181",
    "dotregion": 3,
    "geoid": "42071",
    "lsad": "06",
    "name": "Lancaster",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1707,
    "affgeoid": "0500000US42073",
    "aland": 927644464,
    "awater": 11783868,
    "countyfp": "073",
    "countyns": "01213676",
    "dotregion": 3,
    "geoid": "42073",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 828,
    "affgeoid": "0500000US42075",
    "aland": 937138345,
    "awater": 1727921,
    "countyfp": "075",
    "countyns": "01214034",
    "dotregion": 3,
    "geoid": "42075",
    "lsad": "06",
    "name": "Lebanon",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1252,
    "affgeoid": "0500000US42077",
    "aland": 893983197,
    "awater": 7952806,
    "countyfp": "077",
    "countyns": "01209182",
    "dotregion": 3,
    "geoid": "42077",
    "lsad": "06",
    "name": "Lehigh",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1063,
    "affgeoid": "0500000US42079",
    "aland": 2305974191,
    "awater": 41240056,
    "countyfp": "079",
    "countyns": "01209183",
    "dotregion": 3,
    "geoid": "42079",
    "lsad": "06",
    "name": "Luzerne",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 908,
    "affgeoid": "0500000US42081",
    "aland": 3182060991,
    "awater": 39457017,
    "countyfp": "081",
    "countyns": "01213677",
    "dotregion": 3,
    "geoid": "42081",
    "lsad": "06",
    "name": "Lycoming",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 641,
    "affgeoid": "0500000US42083",
    "aland": 2536106035,
    "awater": 13010718,
    "countyfp": "083",
    "countyns": "01210235",
    "dotregion": 3,
    "geoid": "42083",
    "lsad": "06",
    "name": "McKean",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2002,
    "affgeoid": "0500000US42085",
    "aland": 1741978099,
    "awater": 25963051,
    "countyfp": "085",
    "countyns": "01213678",
    "dotregion": 3,
    "geoid": "42085",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1273,
    "affgeoid": "0500000US42087",
    "aland": 1064564850,
    "awater": 9544799,
    "countyfp": "087",
    "countyns": "01213679",
    "dotregion": 3,
    "geoid": "42087",
    "lsad": "06",
    "name": "Mifflin",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1831,
    "affgeoid": "0500000US42089",
    "aland": 1575560089,
    "awater": 23131029,
    "countyfp": "089",
    "countyns": "01209184",
    "dotregion": 3,
    "geoid": "42089",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1275,
    "affgeoid": "0500000US42091",
    "aland": 1251046282,
    "awater": 10791845,
    "countyfp": "091",
    "countyns": "01213680",
    "dotregion": 3,
    "geoid": "42091",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 372,
    "affgeoid": "0500000US42093",
    "aland": 337326238,
    "awater": 5407947,
    "countyfp": "093",
    "countyns": "01213681",
    "dotregion": 3,
    "geoid": "42093",
    "lsad": "06",
    "name": "Montour",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 732,
    "affgeoid": "0500000US42095",
    "aland": 957444537,
    "awater": 20005867,
    "countyfp": "095",
    "countyns": "01209185",
    "dotregion": 3,
    "geoid": "42095",
    "lsad": "06",
    "name": "Northampton",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2234,
    "affgeoid": "0500000US42097",
    "aland": 1187166422,
    "awater": 49616021,
    "countyfp": "097",
    "countyns": "01209186",
    "dotregion": 3,
    "geoid": "42097",
    "lsad": "06",
    "name": "Northumberland",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1309,
    "affgeoid": "0500000US42099",
    "aland": 1428233551,
    "awater": 10589698,
    "countyfp": "099",
    "countyns": "01213682",
    "dotregion": 3,
    "geoid": "42099",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1343,
    "affgeoid": "0500000US42101",
    "aland": 347519325,
    "awater": 22089787,
    "countyfp": "101",
    "countyns": "01209187",
    "dotregion": 3,
    "geoid": "42101",
    "lsad": "06",
    "name": "Philadelphia",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2623,
    "affgeoid": "0500000US42103",
    "aland": 1411441327,
    "awater": 56692145,
    "countyfp": "103",
    "countyns": "01213683",
    "dotregion": 3,
    "geoid": "42103",
    "lsad": "06",
    "name": "Pike",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1655,
    "affgeoid": "0500000US42105",
    "aland": 2800606026,
    "awater": 559779,
    "countyfp": "105",
    "countyns": "01213684",
    "dotregion": 3,
    "geoid": "42105",
    "lsad": "06",
    "name": "Potter",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 469,
    "affgeoid": "0500000US42107",
    "aland": 2016645898,
    "awater": 10834897,
    "countyfp": "107",
    "countyns": "01213685",
    "dotregion": 3,
    "geoid": "42107",
    "lsad": "06",
    "name": "Schuylkill",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 613,
    "affgeoid": "0500000US42109",
    "aland": 851462481,
    "awater": 7173377,
    "countyfp": "109",
    "countyns": "01213686",
    "dotregion": 3,
    "geoid": "42109",
    "lsad": "06",
    "name": "Snyder",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2782,
    "affgeoid": "0500000US42111",
    "aland": 2782597179,
    "awater": 17002814,
    "countyfp": "111",
    "countyns": "01209188",
    "dotregion": 3,
    "geoid": "42111",
    "lsad": "06",
    "name": "Somerset",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1076,
    "affgeoid": "0500000US42113",
    "aland": 1165338400,
    "awater": 6617028,
    "countyfp": "113",
    "countyns": "01213687",
    "dotregion": 3,
    "geoid": "42113",
    "lsad": "06",
    "name": "Sullivan",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1715,
    "affgeoid": "0500000US42115",
    "aland": 2132881571,
    "awater": 22356562,
    "countyfp": "115",
    "countyns": "01213688",
    "dotregion": 3,
    "geoid": "42115",
    "lsad": "06",
    "name": "Susquehanna",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 511,
    "affgeoid": "0500000US42117",
    "aland": 2936469322,
    "awater": 8257078,
    "countyfp": "117",
    "countyns": "01209189",
    "dotregion": 3,
    "geoid": "42117",
    "lsad": "06",
    "name": "Tioga",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 948,
    "affgeoid": "0500000US42119",
    "aland": 818399145,
    "awater": 4639329,
    "countyfp": "119",
    "countyns": "01213689",
    "dotregion": 3,
    "geoid": "42119",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 951,
    "affgeoid": "0500000US42121",
    "aland": 1746387420,
    "awater": 22148537,
    "countyfp": "121",
    "countyns": "01213690",
    "dotregion": 3,
    "geoid": "42121",
    "lsad": "06",
    "name": "Venango",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1668,
    "affgeoid": "0500000US42123",
    "aland": 2289914221,
    "awater": 37352304,
    "countyfp": "123",
    "countyns": "01213691",
    "dotregion": 3,
    "geoid": "42123",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2340,
    "affgeoid": "0500000US42125",
    "aland": 2219590654,
    "awater": 10147672,
    "countyfp": "125",
    "countyns": "01209190",
    "dotregion": 3,
    "geoid": "42125",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 3208,
    "affgeoid": "0500000US42127",
    "aland": 1879307105,
    "awater": 64774622,
    "countyfp": "127",
    "countyns": "01213692",
    "dotregion": 3,
    "geoid": "42127",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 746,
    "affgeoid": "0500000US42129",
    "aland": 2661370994,
    "awater": 22050456,
    "countyfp": "129",
    "countyns": "01209191",
    "dotregion": 3,
    "geoid": "42129",
    "lsad": "06",
    "name": "Westmoreland",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 1937,
    "affgeoid": "0500000US42131",
    "aland": 1029008281,
    "awater": 20034376,
    "countyfp": "131",
    "countyns": "01209192",
    "dotregion": 3,
    "geoid": "42131",
    "lsad": "06",
    "name": "Wyoming",
    "stateAbbreviation": "PA",
    "stateId": 47
  }, {
    "id": 2980,
    "affgeoid": "0500000US42133",
    "aland": 2341884216,
    "awater": 16941833,
    "countyfp": "133",
    "countyns": "01209193",
    "dotregion": 3,
    "geoid": "42133",
    "lsad": "06",
    "name": "York",
    "stateAbbreviation": "PA",
    "stateId": 47
  }]
}, {
  "id": 39,
  "abbreviation": "PR",
  "affgeoid": "0400000US72",
  "aland": 8867867645,
  "awater": 4923406204,
  "dotregion": 2,
  "geoid": "72",
  "lsad": "00",
  "name": "Puerto Rico",
  "stateAbbreviation": "PR",
  "statefp": "72",
  "statens": "01779808",
  "counties": [{
    "id": 2068,
    "affgeoid": "0500000US72013",
    "aland": 326196919,
    "awater": 117188493,
    "countyfp": "013",
    "countyns": "01804486",
    "dotregion": 2,
    "geoid": "72013",
    "lsad": "13",
    "name": "Arecibo",
    "stateAbbreviation": "PR",
    "stateId": 39
  }, {
    "id": 2379,
    "affgeoid": "0500000US72021",
    "aland": 114800037,
    "awater": 493681,
    "countyfp": "021",
    "countyns": "01804490",
    "dotregion": 2,
    "geoid": "72021",
    "lsad": "13",
    "name": "Bayamón",
    "stateAbbreviation": "PR",
    "stateId": 39
  }, {
    "id": 2249,
    "affgeoid": "0500000US72025",
    "aland": 151781126,
    "awater": 1202942,
    "countyfp": "025",
    "countyns": "01804492",
    "dotregion": 2,
    "geoid": "72025",
    "lsad": "13",
    "name": "Caguas",
    "stateAbbreviation": "PR",
    "stateId": 39
  }, {
    "id": 2054,
    "affgeoid": "0500000US72097",
    "aland": 201100448,
    "awater": 508775673,
    "countyfp": "097",
    "countyns": "01804529",
    "dotregion": 2,
    "geoid": "72097",
    "lsad": "13",
    "name": "Mayagüez",
    "stateAbbreviation": "PR",
    "stateId": 39
  }, {
    "id": 1161,
    "affgeoid": "0500000US72113",
    "aland": 297322133,
    "awater": 204114271,
    "countyfp": "113",
    "countyns": "01804537",
    "dotregion": 2,
    "geoid": "72113",
    "lsad": "13",
    "name": "Ponce",
    "stateAbbreviation": "PR",
    "stateId": 39
  }, {
    "id": 1740,
    "affgeoid": "0500000US72127",
    "aland": 123919487,
    "awater": 75388330,
    "countyfp": "127",
    "countyns": "01804544",
    "dotregion": 2,
    "geoid": "72127",
    "lsad": "13",
    "name": "San Juan",
    "stateAbbreviation": "PR",
    "stateId": 39
  }]
}, {
  "id": 37,
  "abbreviation": "RI",
  "affgeoid": "0400000US44",
  "aland": 2677759613,
  "awater": 1323474145,
  "dotregion": 1,
  "geoid": "44",
  "lsad": "00",
  "name": "Rhode Island",
  "stateAbbreviation": "RI",
  "statefp": "44",
  "statens": "01219835",
  "counties": [{
    "id": 2934,
    "affgeoid": "0500000US44001",
    "aland": 62550804,
    "awater": 53350670,
    "countyfp": "001",
    "countyns": "01219777",
    "dotregion": 1,
    "geoid": "44001",
    "lsad": "06",
    "name": "Bristol",
    "stateAbbreviation": "RI",
    "stateId": 37
  }, {
    "id": 700,
    "affgeoid": "0500000US44003",
    "aland": 436515567,
    "awater": 50720026,
    "countyfp": "003",
    "countyns": "01219778",
    "dotregion": 1,
    "geoid": "44003",
    "lsad": "06",
    "name": "Kent",
    "stateAbbreviation": "RI",
    "stateId": 37
  }, {
    "id": 1168,
    "affgeoid": "0500000US44005",
    "aland": 265220482,
    "awater": 546983257,
    "countyfp": "005",
    "countyns": "01219779",
    "dotregion": 1,
    "geoid": "44005",
    "lsad": "06",
    "name": "Newport",
    "stateAbbreviation": "RI",
    "stateId": 37
  }, {
    "id": 2758,
    "affgeoid": "0500000US44007",
    "aland": 1060637931,
    "awater": 67704263,
    "countyfp": "007",
    "countyns": "01219781",
    "dotregion": 1,
    "geoid": "44007",
    "lsad": "06",
    "name": "Providence",
    "stateAbbreviation": "RI",
    "stateId": 37
  }, {
    "id": 2044,
    "affgeoid": "0500000US44009",
    "aland": 852834829,
    "awater": 604715929,
    "countyfp": "009",
    "countyns": "01219782",
    "dotregion": 1,
    "geoid": "44009",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "RI",
    "stateId": 37
  }]
}, {
  "id": 40,
  "abbreviation": "SC",
  "affgeoid": "0400000US45",
  "aland": 77858297564,
  "awater": 5074366056,
  "dotregion": 4,
  "geoid": "45",
  "lsad": "00",
  "name": "South Carolina",
  "stateAbbreviation": "SC",
  "statefp": "45",
  "statens": "01779799",
  "counties": [{
    "id": 1081,
    "affgeoid": "0500000US45001",
    "aland": 1270343696,
    "awater": 53120004,
    "countyfp": "001",
    "countyns": "01245666",
    "dotregion": 4,
    "geoid": "45001",
    "lsad": "06",
    "name": "Abbeville",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2221,
    "affgeoid": "0500000US45003",
    "aland": 2774109824,
    "awater": 24619610,
    "countyfp": "003",
    "countyns": "01247979",
    "dotregion": 4,
    "geoid": "45003",
    "lsad": "06",
    "name": "Aiken",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 3099,
    "affgeoid": "0500000US45005",
    "aland": 1056948589,
    "awater": 11208070,
    "countyfp": "005",
    "countyns": "01247980",
    "dotregion": 4,
    "geoid": "45005",
    "lsad": "06",
    "name": "Allendale",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 205,
    "affgeoid": "0500000US45007",
    "aland": 1853026075,
    "awater": 108724190,
    "countyfp": "007",
    "countyns": "01247981",
    "dotregion": 4,
    "geoid": "45007",
    "lsad": "06",
    "name": "Anderson",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1111,
    "affgeoid": "0500000US45009",
    "aland": 1018815535,
    "awater": 5685860,
    "countyfp": "009",
    "countyns": "01247982",
    "dotregion": 4,
    "geoid": "45009",
    "lsad": "06",
    "name": "Bamberg",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1531,
    "affgeoid": "0500000US45011",
    "aland": 1420294944,
    "awater": 23008120,
    "countyfp": "011",
    "countyns": "01247983",
    "dotregion": 4,
    "geoid": "45011",
    "lsad": "06",
    "name": "Barnwell",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1928,
    "affgeoid": "0500000US45013",
    "aland": 1492521328,
    "awater": 899064436,
    "countyfp": "013",
    "countyns": "01247984",
    "dotregion": 4,
    "geoid": "45013",
    "lsad": "06",
    "name": "Beaufort",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2735,
    "affgeoid": "0500000US45015",
    "aland": 2846196019,
    "awater": 337556694,
    "countyfp": "015",
    "countyns": "01247985",
    "dotregion": 4,
    "geoid": "45015",
    "lsad": "06",
    "name": "Berkeley",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2778,
    "affgeoid": "0500000US45017",
    "aland": 987179168,
    "awater": 29350862,
    "countyfp": "017",
    "countyns": "01247986",
    "dotregion": 4,
    "geoid": "45017",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1949,
    "affgeoid": "0500000US45019",
    "aland": 2372842394,
    "awater": 1144346152,
    "countyfp": "019",
    "countyns": "01252740",
    "dotregion": 4,
    "geoid": "45019",
    "lsad": "06",
    "name": "Charleston",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1117,
    "affgeoid": "0500000US45021",
    "aland": 1016985344,
    "awater": 11701051,
    "countyfp": "021",
    "countyns": "01247987",
    "dotregion": 4,
    "geoid": "45021",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 448,
    "affgeoid": "0500000US45023",
    "aland": 1503893313,
    "awater": 14261786,
    "countyfp": "023",
    "countyns": "01247988",
    "dotregion": 4,
    "geoid": "45023",
    "lsad": "06",
    "name": "Chester",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1400,
    "affgeoid": "0500000US45025",
    "aland": 2069616247,
    "awater": 17254062,
    "countyfp": "025",
    "countyns": "01247989",
    "dotregion": 4,
    "geoid": "45025",
    "lsad": "06",
    "name": "Chesterfield",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1142,
    "affgeoid": "0500000US45027",
    "aland": 1571964065,
    "awater": 229760810,
    "countyfp": "027",
    "countyns": "01247990",
    "dotregion": 4,
    "geoid": "45027",
    "lsad": "06",
    "name": "Clarendon",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1963,
    "affgeoid": "0500000US45029",
    "aland": 2736303053,
    "awater": 198896959,
    "countyfp": "029",
    "countyns": "01247991",
    "dotregion": 4,
    "geoid": "45029",
    "lsad": "06",
    "name": "Colleton",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 977,
    "affgeoid": "0500000US45031",
    "aland": 1453362943,
    "awater": 14655104,
    "countyfp": "031",
    "countyns": "01247992",
    "dotregion": 4,
    "geoid": "45031",
    "lsad": "06",
    "name": "Darlington",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2725,
    "affgeoid": "0500000US45033",
    "aland": 1048523511,
    "awater": 4545513,
    "countyfp": "033",
    "countyns": "01247993",
    "dotregion": 4,
    "geoid": "45033",
    "lsad": "06",
    "name": "Dillon",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 3146,
    "affgeoid": "0500000US45035",
    "aland": 1484718400,
    "awater": 6618023,
    "countyfp": "035",
    "countyns": "01247998",
    "dotregion": 4,
    "geoid": "45035",
    "lsad": "06",
    "name": "Dorchester",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1700,
    "affgeoid": "0500000US45037",
    "aland": 1296025451,
    "awater": 16321055,
    "countyfp": "037",
    "countyns": "01247999",
    "dotregion": 4,
    "geoid": "45037",
    "lsad": "06",
    "name": "Edgefield",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2366,
    "affgeoid": "0500000US45039",
    "aland": 1777449360,
    "awater": 61135064,
    "countyfp": "039",
    "countyns": "01248000",
    "dotregion": 4,
    "geoid": "45039",
    "lsad": "06",
    "name": "Fairfield",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 78,
    "affgeoid": "0500000US45041",
    "aland": 2071894714,
    "awater": 9743913,
    "countyfp": "041",
    "countyns": "01248001",
    "dotregion": 4,
    "geoid": "45041",
    "lsad": "06",
    "name": "Florence",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 542,
    "affgeoid": "0500000US45043",
    "aland": 2107094125,
    "awater": 572624603,
    "countyfp": "043",
    "countyns": "01248002",
    "dotregion": 4,
    "geoid": "45043",
    "lsad": "06",
    "name": "Georgetown",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1605,
    "affgeoid": "0500000US45045",
    "aland": 2033546625,
    "awater": 25132343,
    "countyfp": "045",
    "countyns": "01245489",
    "dotregion": 4,
    "geoid": "45045",
    "lsad": "06",
    "name": "Greenville",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2240,
    "affgeoid": "0500000US45047",
    "aland": 1177746760,
    "awater": 21226293,
    "countyfp": "047",
    "countyns": "01248003",
    "dotregion": 4,
    "geoid": "45047",
    "lsad": "06",
    "name": "Greenwood",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1176,
    "affgeoid": "0500000US45049",
    "aland": 1450122571,
    "awater": 7276755,
    "countyfp": "049",
    "countyns": "01248004",
    "dotregion": 4,
    "geoid": "45049",
    "lsad": "06",
    "name": "Hampton",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1558,
    "affgeoid": "0500000US45051",
    "aland": 2936847582,
    "awater": 313594600,
    "countyfp": "051",
    "countyns": "01248005",
    "dotregion": 4,
    "geoid": "45051",
    "lsad": "06",
    "name": "Horry",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 855,
    "affgeoid": "0500000US45053",
    "aland": 1697265693,
    "awater": 114074607,
    "countyfp": "053",
    "countyns": "01248006",
    "dotregion": 4,
    "geoid": "45053",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1218,
    "affgeoid": "0500000US45055",
    "aland": 1881777521,
    "awater": 35709176,
    "countyfp": "055",
    "countyns": "01248007",
    "dotregion": 4,
    "geoid": "45055",
    "lsad": "06",
    "name": "Kershaw",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1572,
    "affgeoid": "0500000US45057",
    "aland": 1422314512,
    "awater": 15444741,
    "countyfp": "057",
    "countyns": "01248008",
    "dotregion": 4,
    "geoid": "45057",
    "lsad": "06",
    "name": "Lancaster",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2926,
    "affgeoid": "0500000US45059",
    "aland": 1848789848,
    "awater": 25942599,
    "countyfp": "059",
    "countyns": "01248009",
    "dotregion": 4,
    "geoid": "45059",
    "lsad": "06",
    "name": "Laurens",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 819,
    "affgeoid": "0500000US45061",
    "aland": 1062372381,
    "awater": 2715077,
    "countyfp": "061",
    "countyns": "01245652",
    "dotregion": 4,
    "geoid": "45061",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1408,
    "affgeoid": "0500000US45063",
    "aland": 1810575721,
    "awater": 151931453,
    "countyfp": "063",
    "countyns": "01244251",
    "dotregion": 4,
    "geoid": "45063",
    "lsad": "06",
    "name": "Lexington",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 3020,
    "affgeoid": "0500000US45067",
    "aland": 1267162776,
    "awater": 12643194,
    "countyfp": "067",
    "countyns": "01248010",
    "dotregion": 4,
    "geoid": "45067",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2817,
    "affgeoid": "0500000US45069",
    "aland": 1242378725,
    "awater": 14475689,
    "countyfp": "069",
    "countyns": "01248011",
    "dotregion": 4,
    "geoid": "45069",
    "lsad": "06",
    "name": "Marlboro",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 682,
    "affgeoid": "0500000US45065",
    "aland": 930141784,
    "awater": 89983085,
    "countyfp": "065",
    "countyns": "01248012",
    "dotregion": 4,
    "geoid": "45065",
    "lsad": "06",
    "name": "McCormick",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1166,
    "affgeoid": "0500000US45071",
    "aland": 1631805482,
    "awater": 44657974,
    "countyfp": "071",
    "countyns": "01248013",
    "dotregion": 4,
    "geoid": "45071",
    "lsad": "06",
    "name": "Newberry",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1503,
    "affgeoid": "0500000US45073",
    "aland": 1622113934,
    "awater": 122274812,
    "countyfp": "073",
    "countyns": "01244832",
    "dotregion": 4,
    "geoid": "45073",
    "lsad": "06",
    "name": "Oconee",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2004,
    "affgeoid": "0500000US45075",
    "aland": 2864676300,
    "awater": 56530748,
    "countyfp": "075",
    "countyns": "01248014",
    "dotregion": 4,
    "geoid": "45075",
    "lsad": "06",
    "name": "Orangeburg",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1141,
    "affgeoid": "0500000US45077",
    "aland": 1285536060,
    "awater": 40612589,
    "countyfp": "077",
    "countyns": "01248015",
    "dotregion": 4,
    "geoid": "45077",
    "lsad": "06",
    "name": "Pickens",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1916,
    "affgeoid": "0500000US45079",
    "aland": 1961014004,
    "awater": 37838398,
    "countyfp": "079",
    "countyns": "01249299",
    "dotregion": 4,
    "geoid": "45079",
    "lsad": "06",
    "name": "Richland",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 110,
    "affgeoid": "0500000US45081",
    "aland": 1172690624,
    "awater": 23419265,
    "countyfp": "081",
    "countyns": "01248016",
    "dotregion": 4,
    "geoid": "45081",
    "lsad": "06",
    "name": "Saluda",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2774,
    "affgeoid": "0500000US45083",
    "aland": 2092617463,
    "awater": 29211228,
    "countyfp": "083",
    "countyns": "01248592",
    "dotregion": 4,
    "geoid": "45083",
    "lsad": "06",
    "name": "Spartanburg",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 577,
    "affgeoid": "0500000US45085",
    "aland": 1722537600,
    "awater": 44054050,
    "countyfp": "085",
    "countyns": "01244717",
    "dotregion": 4,
    "geoid": "45085",
    "lsad": "06",
    "name": "Sumter",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 1167,
    "affgeoid": "0500000US45087",
    "aland": 1331696478,
    "awater": 4805061,
    "countyfp": "087",
    "countyns": "01248017",
    "dotregion": 4,
    "geoid": "45087",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 614,
    "affgeoid": "0500000US45089",
    "aland": 2419464743,
    "awater": 7469568,
    "countyfp": "089",
    "countyns": "01248018",
    "dotregion": 4,
    "geoid": "45089",
    "lsad": "06",
    "name": "Williamsburg",
    "stateAbbreviation": "SC",
    "stateId": 40
  }, {
    "id": 2568,
    "affgeoid": "0500000US45091",
    "aland": 1762994279,
    "awater": 39140810,
    "countyfp": "091",
    "countyns": "01248019",
    "dotregion": 4,
    "geoid": "45091",
    "lsad": "06",
    "name": "York",
    "stateAbbreviation": "SC",
    "stateId": 40
  }]
}, {
  "id": 23,
  "abbreviation": "SD",
  "affgeoid": "0400000US46",
  "aland": 196349394266,
  "awater": 3379810671,
  "dotregion": 8,
  "geoid": "46",
  "lsad": "00",
  "name": "South Dakota",
  "stateAbbreviation": "SD",
  "statefp": "46",
  "statens": "01785534",
  "counties": [{
    "id": 1671,
    "affgeoid": "0500000US46003",
    "aland": 1834813753,
    "awater": 11201379,
    "countyfp": "003",
    "countyns": "01266983",
    "dotregion": 8,
    "geoid": "46003",
    "lsad": "06",
    "name": "Aurora",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2871,
    "affgeoid": "0500000US46005",
    "aland": 3260033444,
    "awater": 15817538,
    "countyfp": "005",
    "countyns": "01266986",
    "dotregion": 8,
    "geoid": "46005",
    "lsad": "06",
    "name": "Beadle",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 462,
    "affgeoid": "0500000US46007",
    "aland": 3068383008,
    "awater": 15010866,
    "countyfp": "007",
    "countyns": "01265812",
    "dotregion": 8,
    "geoid": "46007",
    "lsad": "06",
    "name": "Bennett",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1399,
    "affgeoid": "0500000US46009",
    "aland": 1459978989,
    "awater": 46518944,
    "countyfp": "009",
    "countyns": "01266997",
    "dotregion": 8,
    "geoid": "46009",
    "lsad": "06",
    "name": "Bon Homme",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 504,
    "affgeoid": "0500000US46011",
    "aland": 2051807225,
    "awater": 32967600,
    "countyfp": "011",
    "countyns": "01265779",
    "dotregion": 8,
    "geoid": "46011",
    "lsad": "06",
    "name": "Brookings",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 112,
    "affgeoid": "0500000US46013",
    "aland": 4436728246,
    "awater": 46414522,
    "countyfp": "013",
    "countyns": "01265785",
    "dotregion": 8,
    "geoid": "46013",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 720,
    "affgeoid": "0500000US46015",
    "aland": 2116641196,
    "awater": 75721265,
    "countyfp": "015",
    "countyns": "01265768",
    "dotregion": 8,
    "geoid": "46015",
    "lsad": "06",
    "name": "Brule",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2882,
    "affgeoid": "0500000US46017",
    "aland": 1220893248,
    "awater": 42362357,
    "countyfp": "017",
    "countyns": "01265767",
    "dotregion": 8,
    "geoid": "46017",
    "lsad": "06",
    "name": "Buffalo",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2765,
    "affgeoid": "0500000US46019",
    "aland": 5827452687,
    "awater": 42730886,
    "countyfp": "019",
    "countyns": "01265793",
    "dotregion": 8,
    "geoid": "46019",
    "lsad": "06",
    "name": "Butte",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1005,
    "affgeoid": "0500000US46021",
    "aland": 1900214167,
    "awater": 96243721,
    "countyfp": "021",
    "countyns": "01266974",
    "dotregion": 8,
    "geoid": "46021",
    "lsad": "06",
    "name": "Campbell",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2456,
    "affgeoid": "0500000US46023",
    "aland": 2842477570,
    "awater": 136616766,
    "countyfp": "023",
    "countyns": "01266976",
    "dotregion": 8,
    "geoid": "46023",
    "lsad": "06",
    "name": "Charles Mix",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 300,
    "affgeoid": "0500000US46025",
    "aland": 2480182448,
    "awater": 25627353,
    "countyfp": "025",
    "countyns": "01266985",
    "dotregion": 8,
    "geoid": "46025",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1902,
    "affgeoid": "0500000US46027",
    "aland": 1067562649,
    "awater": 13071014,
    "countyfp": "027",
    "countyns": "01265764",
    "dotregion": 8,
    "geoid": "46027",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 830,
    "affgeoid": "0500000US46029",
    "aland": 1782118019,
    "awater": 75327853,
    "countyfp": "029",
    "countyns": "01265791",
    "dotregion": 8,
    "geoid": "46029",
    "lsad": "06",
    "name": "Codington",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 863,
    "affgeoid": "0500000US46031",
    "aland": 6396469258,
    "awater": 155287213,
    "countyfp": "031",
    "countyns": "01265811",
    "dotregion": 8,
    "geoid": "46031",
    "lsad": "06",
    "name": "Corson",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1118,
    "affgeoid": "0500000US46033",
    "aland": 4032686959,
    "awater": 5482590,
    "countyfp": "033",
    "countyns": "01265788",
    "dotregion": 8,
    "geoid": "46033",
    "lsad": "06",
    "name": "Custer",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 276,
    "affgeoid": "0500000US46035",
    "aland": 1127942825,
    "awater": 3675453,
    "countyfp": "035",
    "countyns": "01266980",
    "dotregion": 8,
    "geoid": "46035",
    "lsad": "06",
    "name": "Davison",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2315,
    "affgeoid": "0500000US46037",
    "aland": 2662165811,
    "awater": 163751128,
    "countyfp": "037",
    "countyns": "01265790",
    "dotregion": 8,
    "geoid": "46037",
    "lsad": "06",
    "name": "Day",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 207,
    "affgeoid": "0500000US46039",
    "aland": 1612750054,
    "awater": 36071554,
    "countyfp": "039",
    "countyns": "01265781",
    "dotregion": 8,
    "geoid": "46039",
    "lsad": "06",
    "name": "Deuel",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1405,
    "affgeoid": "0500000US46041",
    "aland": 5963376325,
    "awater": 369822336,
    "countyfp": "041",
    "countyns": "01266994",
    "dotregion": 8,
    "geoid": "46041",
    "lsad": "06",
    "name": "Dewey",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2273,
    "affgeoid": "0500000US46043",
    "aland": 1118359040,
    "awater": 4832944,
    "countyfp": "043",
    "countyns": "01266978",
    "dotregion": 8,
    "geoid": "46043",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 3109,
    "affgeoid": "0500000US46045",
    "aland": 2916208112,
    "awater": 65038001,
    "countyfp": "045",
    "countyns": "01266972",
    "dotregion": 8,
    "geoid": "46045",
    "lsad": "06",
    "name": "Edmunds",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 365,
    "affgeoid": "0500000US46047",
    "aland": 4506075415,
    "awater": 24080933,
    "countyfp": "047",
    "countyns": "01265787",
    "dotregion": 8,
    "geoid": "46047",
    "lsad": "06",
    "name": "Fall River",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 750,
    "affgeoid": "0500000US46049",
    "aland": 2542739467,
    "awater": 62704062,
    "countyfp": "049",
    "countyns": "01265760",
    "dotregion": 8,
    "geoid": "46049",
    "lsad": "06",
    "name": "Faulk",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2773,
    "affgeoid": "0500000US46051",
    "aland": 1764949260,
    "awater": 15746364,
    "countyfp": "051",
    "countyns": "01265782",
    "dotregion": 8,
    "geoid": "46051",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1837,
    "affgeoid": "0500000US46053",
    "aland": 2628708870,
    "awater": 99900775,
    "countyfp": "053",
    "countyns": "01265765",
    "dotregion": 8,
    "geoid": "46053",
    "lsad": "06",
    "name": "Gregory",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 874,
    "affgeoid": "0500000US46055",
    "aland": 4689275840,
    "awater": 42449688,
    "countyfp": "055",
    "countyns": "01266988",
    "dotregion": 8,
    "geoid": "46055",
    "lsad": "06",
    "name": "Haakon",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1533,
    "affgeoid": "0500000US46057",
    "aland": 1313731177,
    "awater": 79864239,
    "countyfp": "057",
    "countyns": "01265766",
    "dotregion": 8,
    "geoid": "46057",
    "lsad": "06",
    "name": "Hamlin",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2995,
    "affgeoid": "0500000US46059",
    "aland": 3720897236,
    "awater": 9241423,
    "countyfp": "059",
    "countyns": "01265783",
    "dotregion": 8,
    "geoid": "46059",
    "lsad": "06",
    "name": "Hand",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1144,
    "affgeoid": "0500000US46061",
    "aland": 1125387593,
    "awater": 2248724,
    "countyfp": "061",
    "countyns": "01266979",
    "dotregion": 8,
    "geoid": "46061",
    "lsad": "06",
    "name": "Hanson",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1106,
    "affgeoid": "0500000US46063",
    "aland": 6919138401,
    "awater": 16956320,
    "countyfp": "063",
    "countyns": "01265792",
    "dotregion": 8,
    "geoid": "46063",
    "lsad": "06",
    "name": "Harding",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2487,
    "affgeoid": "0500000US46065",
    "aland": 1920598012,
    "awater": 153253190,
    "countyfp": "065",
    "countyns": "01265774",
    "dotregion": 8,
    "geoid": "46065",
    "lsad": "06",
    "name": "Hughes",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2415,
    "affgeoid": "0500000US46067",
    "aland": 2105411241,
    "awater": 3928766,
    "countyfp": "067",
    "countyns": "01265771",
    "dotregion": 8,
    "geoid": "46067",
    "lsad": "06",
    "name": "Hutchinson",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 152,
    "affgeoid": "0500000US46069",
    "aland": 2228779060,
    "awater": 14541547,
    "countyfp": "069",
    "countyns": "01266984",
    "dotregion": 8,
    "geoid": "46069",
    "lsad": "06",
    "name": "Hyde",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2526,
    "affgeoid": "0500000US46071",
    "aland": 4827513419,
    "awater": 19097491,
    "countyfp": "071",
    "countyns": "01265794",
    "dotregion": 8,
    "geoid": "46071",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 10,
    "affgeoid": "0500000US46073",
    "aland": 1362808084,
    "awater": 16668604,
    "countyfp": "073",
    "countyns": "01265778",
    "dotregion": 8,
    "geoid": "46073",
    "lsad": "06",
    "name": "Jerauld",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1871,
    "affgeoid": "0500000US46075",
    "aland": 2511453310,
    "awater": 3147180,
    "countyfp": "075",
    "countyns": "01266981",
    "dotregion": 8,
    "geoid": "46075",
    "lsad": "06",
    "name": "Jones",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 402,
    "affgeoid": "0500000US46077",
    "aland": 2155483523,
    "awater": 81655092,
    "countyfp": "077",
    "countyns": "01265780",
    "dotregion": 8,
    "geoid": "46077",
    "lsad": "06",
    "name": "Kingsbury",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2829,
    "affgeoid": "0500000US46079",
    "aland": 1458881288,
    "awater": 30781779,
    "countyfp": "079",
    "countyns": "01265776",
    "dotregion": 8,
    "geoid": "46079",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 374,
    "affgeoid": "0500000US46081",
    "aland": 2072089202,
    "awater": 713642,
    "countyfp": "081",
    "countyns": "01266996",
    "dotregion": 8,
    "geoid": "46081",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1530,
    "affgeoid": "0500000US46083",
    "aland": 1495182379,
    "awater": 1179308,
    "countyfp": "083",
    "countyns": "01265769",
    "dotregion": 8,
    "geoid": "46083",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2987,
    "affgeoid": "0500000US46085",
    "aland": 4252921540,
    "awater": 167664800,
    "countyfp": "085",
    "countyns": "01265789",
    "dotregion": 8,
    "geoid": "46085",
    "lsad": "06",
    "name": "Lyman",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1021,
    "affgeoid": "0500000US46091",
    "aland": 2170630077,
    "awater": 124680563,
    "countyfp": "091",
    "countyns": "01265759",
    "dotregion": 8,
    "geoid": "46091",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2019,
    "affgeoid": "0500000US46087",
    "aland": 1487182081,
    "awater": 6898508,
    "countyfp": "087",
    "countyns": "01265773",
    "dotregion": 8,
    "geoid": "46087",
    "lsad": "06",
    "name": "McCook",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2460,
    "affgeoid": "0500000US46089",
    "aland": 2943892400,
    "awater": 38569612,
    "countyfp": "089",
    "countyns": "01265762",
    "dotregion": 8,
    "geoid": "46089",
    "lsad": "06",
    "name": "McPherson",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1317,
    "affgeoid": "0500000US46093",
    "aland": 8989663313,
    "awater": 30715788,
    "countyfp": "093",
    "countyns": "01266991",
    "dotregion": 8,
    "geoid": "46093",
    "lsad": "06",
    "name": "Meade",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2971,
    "affgeoid": "0500000US46095",
    "aland": 3385868832,
    "awater": 9219640,
    "countyfp": "095",
    "countyns": "01267177",
    "dotregion": 8,
    "geoid": "46095",
    "lsad": "06",
    "name": "Mellette",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 909,
    "affgeoid": "0500000US46097",
    "aland": 1476889389,
    "awater": 4382648,
    "countyfp": "097",
    "countyns": "01265777",
    "dotregion": 8,
    "geoid": "46097",
    "lsad": "06",
    "name": "Miner",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1147,
    "affgeoid": "0500000US46099",
    "aland": 2090540341,
    "awater": 17349847,
    "countyfp": "099",
    "countyns": "01265772",
    "dotregion": 8,
    "geoid": "46099",
    "lsad": "06",
    "name": "Minnehaha",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2547,
    "affgeoid": "0500000US46101",
    "aland": 1345200318,
    "awater": 3679400,
    "countyfp": "101",
    "countyns": "01265775",
    "dotregion": 8,
    "geoid": "46101",
    "lsad": "06",
    "name": "Moody",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1485,
    "affgeoid": "0500000US46102",
    "aland": 5422998821,
    "awater": 7126221,
    "countyfp": "102",
    "countyns": "01266992",
    "dotregion": 8,
    "geoid": "46102",
    "lsad": "06",
    "name": "Oglala Lakota",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1004,
    "affgeoid": "0500000US46103",
    "aland": 7191349941,
    "awater": 19944969,
    "countyfp": "103",
    "countyns": "01266995",
    "dotregion": 8,
    "geoid": "46103",
    "lsad": "06",
    "name": "Pennington",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 899,
    "affgeoid": "0500000US46105",
    "aland": 7434391982,
    "awater": 50539649,
    "countyfp": "105",
    "countyns": "01266990",
    "dotregion": 8,
    "geoid": "46105",
    "lsad": "06",
    "name": "Perkins",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2168,
    "affgeoid": "0500000US46107",
    "aland": 2230432350,
    "awater": 97171992,
    "countyfp": "107",
    "countyns": "01265761",
    "dotregion": 8,
    "geoid": "46107",
    "lsad": "06",
    "name": "Potter",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1290,
    "affgeoid": "0500000US46109",
    "aland": 2851702829,
    "awater": 89947545,
    "countyfp": "109",
    "countyns": "01265786",
    "dotregion": 8,
    "geoid": "46109",
    "lsad": "06",
    "name": "Roberts",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2502,
    "affgeoid": "0500000US46111",
    "aland": 1474586445,
    "awater": 2938339,
    "countyfp": "111",
    "countyns": "01266977",
    "dotregion": 8,
    "geoid": "46111",
    "lsad": "06",
    "name": "Sanborn",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 829,
    "affgeoid": "0500000US46115",
    "aland": 3895146617,
    "awater": 15063429,
    "countyfp": "115",
    "countyns": "01266987",
    "dotregion": 8,
    "geoid": "46115",
    "lsad": "06",
    "name": "Spink",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2772,
    "affgeoid": "0500000US46117",
    "aland": 3741062104,
    "awater": 188383615,
    "countyfp": "117",
    "countyns": "01266998",
    "dotregion": 8,
    "geoid": "46117",
    "lsad": "06",
    "name": "Stanley",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 2370,
    "affgeoid": "0500000US46119",
    "aland": 2607656307,
    "awater": 164384845,
    "countyfp": "119",
    "countyns": "01266982",
    "dotregion": 8,
    "geoid": "46119",
    "lsad": "06",
    "name": "Sully",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 3107,
    "affgeoid": "0500000US46121",
    "aland": 3596101701,
    "awater": 5854544,
    "countyfp": "121",
    "countyns": "01266989",
    "dotregion": 8,
    "geoid": "46121",
    "lsad": "06",
    "name": "Todd",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1857,
    "affgeoid": "0500000US46123",
    "aland": 4176233698,
    "awater": 13272785,
    "countyfp": "123",
    "countyns": "01265784",
    "dotregion": 8,
    "geoid": "46123",
    "lsad": "06",
    "name": "Tripp",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 445,
    "affgeoid": "0500000US46125",
    "aland": 1598174250,
    "awater": 1650289,
    "countyfp": "125",
    "countyns": "01265770",
    "dotregion": 8,
    "geoid": "46125",
    "lsad": "06",
    "name": "Turner",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1699,
    "affgeoid": "0500000US46127",
    "aland": 1193295689,
    "awater": 16562654,
    "countyfp": "127",
    "countyns": "01265763",
    "dotregion": 8,
    "geoid": "46127",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 937,
    "affgeoid": "0500000US46129",
    "aland": 1835347958,
    "awater": 93215017,
    "countyfp": "129",
    "countyns": "01266973",
    "dotregion": 8,
    "geoid": "46129",
    "lsad": "06",
    "name": "Walworth",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 401,
    "affgeoid": "0500000US46135",
    "aland": 1349811536,
    "awater": 28629259,
    "countyfp": "135",
    "countyns": "01266975",
    "dotregion": 8,
    "geoid": "46135",
    "lsad": "06",
    "name": "Yankton",
    "stateAbbreviation": "SD",
    "stateId": 23
  }, {
    "id": 1557,
    "affgeoid": "0500000US46137",
    "aland": 5079965937,
    "awater": 24212303,
    "countyfp": "137",
    "countyns": "01266993",
    "dotregion": 8,
    "geoid": "46137",
    "lsad": "06",
    "name": "Ziebach",
    "stateAbbreviation": "SD",
    "stateId": 23
  }]
}, {
  "id": 8,
  "abbreviation": "TN",
  "affgeoid": "0400000US47",
  "aland": 106800181941,
  "awater": 2352826875,
  "dotregion": 4,
  "geoid": "47",
  "lsad": "00",
  "name": "Tennessee",
  "stateAbbreviation": "TN",
  "statefp": "47",
  "statens": "01325873",
  "counties": [{
    "id": 2474,
    "affgeoid": "0500000US47001",
    "aland": 873246897,
    "awater": 19770493,
    "countyfp": "001",
    "countyns": "01639722",
    "dotregion": 4,
    "geoid": "47001",
    "lsad": "06",
    "name": "Anderson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 45,
    "affgeoid": "0500000US47003",
    "aland": 1226717421,
    "awater": 2983130,
    "countyfp": "003",
    "countyns": "01639723",
    "dotregion": 4,
    "geoid": "47003",
    "lsad": "06",
    "name": "Bedford",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1535,
    "affgeoid": "0500000US47005",
    "aland": 1021240555,
    "awater": 108591318,
    "countyfp": "005",
    "countyns": "01639724",
    "dotregion": 4,
    "geoid": "47005",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 831,
    "affgeoid": "0500000US47007",
    "aland": 1052635818,
    "awater": 838360,
    "countyfp": "007",
    "countyns": "01639725",
    "dotregion": 4,
    "geoid": "47007",
    "lsad": "06",
    "name": "Bledsoe",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2222,
    "affgeoid": "0500000US47009",
    "aland": 1447032438,
    "awater": 20308084,
    "countyfp": "009",
    "countyns": "01639726",
    "dotregion": 4,
    "geoid": "47009",
    "lsad": "06",
    "name": "Blount",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 3110,
    "affgeoid": "0500000US47011",
    "aland": 851489149,
    "awater": 6959141,
    "countyfp": "011",
    "countyns": "01639727",
    "dotregion": 4,
    "geoid": "47011",
    "lsad": "06",
    "name": "Bradley",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 560,
    "affgeoid": "0500000US47013",
    "aland": 1243580189,
    "awater": 46494677,
    "countyfp": "013",
    "countyns": "01639728",
    "dotregion": 4,
    "geoid": "47013",
    "lsad": "06",
    "name": "Campbell",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2295,
    "affgeoid": "0500000US47015",
    "aland": 687991717,
    "awater": 156872,
    "countyfp": "015",
    "countyns": "01648572",
    "dotregion": 4,
    "geoid": "47015",
    "lsad": "06",
    "name": "Cannon",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1738,
    "affgeoid": "0500000US47017",
    "aland": 1552087165,
    "awater": 2147611,
    "countyfp": "017",
    "countyns": "01639729",
    "dotregion": 4,
    "geoid": "47017",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1112,
    "affgeoid": "0500000US47019",
    "aland": 883711368,
    "awater": 16656888,
    "countyfp": "019",
    "countyns": "01639730",
    "dotregion": 4,
    "geoid": "47019",
    "lsad": "06",
    "name": "Carter",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1113,
    "affgeoid": "0500000US47021",
    "aland": 783308290,
    "awater": 11964158,
    "countyfp": "021",
    "countyns": "01639731",
    "dotregion": 4,
    "geoid": "47021",
    "lsad": "06",
    "name": "Cheatham",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 875,
    "affgeoid": "0500000US47023",
    "aland": 740052030,
    "awater": 575590,
    "countyfp": "023",
    "countyns": "01639732",
    "dotregion": 4,
    "geoid": "47023",
    "lsad": "06",
    "name": "Chester",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 3191,
    "affgeoid": "0500000US47025",
    "aland": 1125572374,
    "awater": 18099460,
    "countyfp": "025",
    "countyns": "01639733",
    "dotregion": 4,
    "geoid": "47025",
    "lsad": "06",
    "name": "Claiborne",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 864,
    "affgeoid": "0500000US47027",
    "aland": 612626437,
    "awater": 59071078,
    "countyfp": "027",
    "countyns": "01648573",
    "dotregion": 4,
    "geoid": "47027",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1114,
    "affgeoid": "0500000US47029",
    "aland": 1125573126,
    "awater": 22116606,
    "countyfp": "029",
    "countyns": "01639734",
    "dotregion": 4,
    "geoid": "47029",
    "lsad": "06",
    "name": "Cocke",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2625,
    "affgeoid": "0500000US47031",
    "aland": 1111007249,
    "awater": 14482605,
    "countyfp": "031",
    "countyns": "01639735",
    "dotregion": 4,
    "geoid": "47031",
    "lsad": "06",
    "name": "Coffee",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 385,
    "affgeoid": "0500000US47033",
    "aland": 687731412,
    "awater": 529234,
    "countyfp": "033",
    "countyns": "01648574",
    "dotregion": 4,
    "geoid": "47033",
    "lsad": "06",
    "name": "Crockett",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2519,
    "affgeoid": "0500000US47035",
    "aland": 1763849866,
    "awater": 9823729,
    "countyfp": "035",
    "countyns": "01639736",
    "dotregion": 4,
    "geoid": "47035",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1415,
    "affgeoid": "0500000US47037",
    "aland": 1304946912,
    "awater": 56655850,
    "countyfp": "037",
    "countyns": "01639737",
    "dotregion": 4,
    "geoid": "47037",
    "lsad": "06",
    "name": "Davidson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 709,
    "affgeoid": "0500000US47041",
    "aland": 788261385,
    "awater": 63808936,
    "countyfp": "041",
    "countyns": "01639738",
    "dotregion": 4,
    "geoid": "47041",
    "lsad": "06",
    "name": "DeKalb",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1950,
    "affgeoid": "0500000US47039",
    "aland": 864654132,
    "awater": 28588648,
    "countyfp": "039",
    "countyns": "01639739",
    "dotregion": 4,
    "geoid": "47039",
    "lsad": "06",
    "name": "Decatur",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1532,
    "affgeoid": "0500000US47043",
    "aland": 1268824237,
    "awater": 3689043,
    "countyfp": "043",
    "countyns": "01639740",
    "dotregion": 4,
    "geoid": "47043",
    "lsad": "06",
    "name": "Dickson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2957,
    "affgeoid": "0500000US47045",
    "aland": 1326922856,
    "awater": 36778051,
    "countyfp": "045",
    "countyns": "01639741",
    "dotregion": 4,
    "geoid": "47045",
    "lsad": "06",
    "name": "Dyer",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 446,
    "affgeoid": "0500000US47047",
    "aland": 1825374169,
    "awater": 3774866,
    "countyfp": "047",
    "countyns": "01639742",
    "dotregion": 4,
    "geoid": "47047",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1509,
    "affgeoid": "0500000US47049",
    "aland": 1291421150,
    "awater": 829331,
    "countyfp": "049",
    "countyns": "01639743",
    "dotregion": 4,
    "geoid": "47049",
    "lsad": "06",
    "name": "Fentress",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 583,
    "affgeoid": "0500000US47051",
    "aland": 1436108253,
    "awater": 55079773,
    "countyfp": "051",
    "countyns": "01639744",
    "dotregion": 4,
    "geoid": "47051",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1083,
    "affgeoid": "0500000US47053",
    "aland": 1561106503,
    "awater": 2341447,
    "countyfp": "053",
    "countyns": "01639745",
    "dotregion": 4,
    "geoid": "47053",
    "lsad": "06",
    "name": "Gibson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2489,
    "affgeoid": "0500000US47055",
    "aland": 1582295000,
    "awater": 642572,
    "countyfp": "055",
    "countyns": "01639746",
    "dotregion": 4,
    "geoid": "47055",
    "lsad": "06",
    "name": "Giles",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2554,
    "affgeoid": "0500000US47057",
    "aland": 726729365,
    "awater": 56637201,
    "countyfp": "057",
    "countyns": "01648575",
    "dotregion": 4,
    "geoid": "47057",
    "lsad": "06",
    "name": "Grainger",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2478,
    "affgeoid": "0500000US47059",
    "aland": 1611346226,
    "awater": 5099735,
    "countyfp": "059",
    "countyns": "01639747",
    "dotregion": 4,
    "geoid": "47059",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2429,
    "affgeoid": "0500000US47061",
    "aland": 933549065,
    "awater": 1752165,
    "countyfp": "061",
    "countyns": "01639748",
    "dotregion": 4,
    "geoid": "47061",
    "lsad": "06",
    "name": "Grundy",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1951,
    "affgeoid": "0500000US47063",
    "aland": 417437884,
    "awater": 37890943,
    "countyfp": "063",
    "countyns": "01648576",
    "dotregion": 4,
    "geoid": "47063",
    "lsad": "06",
    "name": "Hamblen",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1679,
    "affgeoid": "0500000US47065",
    "aland": 1404937551,
    "awater": 86586076,
    "countyfp": "065",
    "countyns": "01639749",
    "dotregion": 4,
    "geoid": "47065",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 209,
    "affgeoid": "0500000US47067",
    "aland": 575820509,
    "awater": 2984310,
    "countyfp": "067",
    "countyns": "01648577",
    "dotregion": 4,
    "geoid": "47067",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 398,
    "affgeoid": "0500000US47069",
    "aland": 1729454850,
    "awater": 6823705,
    "countyfp": "069",
    "countyns": "01639750",
    "dotregion": 4,
    "geoid": "47069",
    "lsad": "06",
    "name": "Hardeman",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2239,
    "affgeoid": "0500000US47071",
    "aland": 1495289678,
    "awater": 49111069,
    "countyfp": "071",
    "countyns": "01639751",
    "dotregion": 4,
    "geoid": "47071",
    "lsad": "06",
    "name": "Hardin",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1828,
    "affgeoid": "0500000US47073",
    "aland": 1261443215,
    "awater": 32545400,
    "countyfp": "073",
    "countyns": "01639752",
    "dotregion": 4,
    "geoid": "47073",
    "lsad": "06",
    "name": "Hawkins",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1484,
    "affgeoid": "0500000US47075",
    "aland": 1380737639,
    "awater": 2472509,
    "countyfp": "075",
    "countyns": "01639753",
    "dotregion": 4,
    "geoid": "47075",
    "lsad": "06",
    "name": "Haywood",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2018,
    "affgeoid": "0500000US47077",
    "aland": 1346816694,
    "awater": 15219341,
    "countyfp": "077",
    "countyns": "01639754",
    "dotregion": 4,
    "geoid": "47077",
    "lsad": "06",
    "name": "Henderson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 581,
    "affgeoid": "0500000US47079",
    "aland": 1455159581,
    "awater": 81742881,
    "countyfp": "079",
    "countyns": "01639755",
    "dotregion": 4,
    "geoid": "47079",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1701,
    "affgeoid": "0500000US47081",
    "aland": 1586315572,
    "awater": 382861,
    "countyfp": "081",
    "countyns": "01639756",
    "dotregion": 4,
    "geoid": "47081",
    "lsad": "06",
    "name": "Hickman",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1146,
    "affgeoid": "0500000US47083",
    "aland": 518749052,
    "awater": 17312555,
    "countyfp": "083",
    "countyns": "01648578",
    "dotregion": 4,
    "geoid": "47083",
    "lsad": "06",
    "name": "Houston",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 210,
    "affgeoid": "0500000US47085",
    "aland": 1374665923,
    "awater": 67186918,
    "countyfp": "085",
    "countyns": "01639757",
    "dotregion": 4,
    "geoid": "47085",
    "lsad": "06",
    "name": "Humphreys",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2791,
    "affgeoid": "0500000US47087",
    "aland": 799338036,
    "awater": 28227391,
    "countyfp": "087",
    "countyns": "01639758",
    "dotregion": 4,
    "geoid": "47087",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2020,
    "affgeoid": "0500000US47089",
    "aland": 711854966,
    "awater": 102190541,
    "countyfp": "089",
    "countyns": "01639759",
    "dotregion": 4,
    "geoid": "47089",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 3072,
    "affgeoid": "0500000US47091",
    "aland": 773046196,
    "awater": 11001626,
    "countyfp": "091",
    "countyns": "01639760",
    "dotregion": 4,
    "geoid": "47091",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 648,
    "affgeoid": "0500000US47093",
    "aland": 1316273990,
    "awater": 45712672,
    "countyfp": "093",
    "countyns": "01639761",
    "dotregion": 4,
    "geoid": "47093",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 872,
    "affgeoid": "0500000US47095",
    "aland": 429381245,
    "awater": 72799687,
    "countyfp": "095",
    "countyns": "01639762",
    "dotregion": 4,
    "geoid": "47095",
    "lsad": "06",
    "name": "Lake",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2618,
    "affgeoid": "0500000US47097",
    "aland": 1222389175,
    "awater": 92233934,
    "countyfp": "097",
    "countyns": "01639763",
    "dotregion": 4,
    "geoid": "47097",
    "lsad": "06",
    "name": "Lauderdale",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 938,
    "affgeoid": "0500000US47099",
    "aland": 1598356717,
    "awater": 2228109,
    "countyfp": "099",
    "countyns": "01639764",
    "dotregion": 4,
    "geoid": "47099",
    "lsad": "06",
    "name": "Lawrence",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 3202,
    "affgeoid": "0500000US47101",
    "aland": 730608074,
    "awater": 1031592,
    "countyfp": "101",
    "countyns": "01639765",
    "dotregion": 4,
    "geoid": "47101",
    "lsad": "06",
    "name": "Lewis",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 3045,
    "affgeoid": "0500000US47103",
    "aland": 1477169472,
    "awater": 990351,
    "countyfp": "103",
    "countyns": "01639766",
    "dotregion": 4,
    "geoid": "47103",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 421,
    "affgeoid": "0500000US47105",
    "aland": 593758833,
    "awater": 46926070,
    "countyfp": "105",
    "countyns": "01639767",
    "dotregion": 4,
    "geoid": "47105",
    "lsad": "06",
    "name": "Loudon",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 345,
    "affgeoid": "0500000US47111",
    "aland": 795498386,
    "awater": 246690,
    "countyfp": "111",
    "countyns": "01639768",
    "dotregion": 4,
    "geoid": "47111",
    "lsad": "06",
    "name": "Macon",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 514,
    "affgeoid": "0500000US47113",
    "aland": 1442905034,
    "awater": 3930429,
    "countyfp": "113",
    "countyns": "01639769",
    "dotregion": 4,
    "geoid": "47113",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1344,
    "affgeoid": "0500000US47115",
    "aland": 1290227365,
    "awater": 36501982,
    "countyfp": "115",
    "countyns": "01639770",
    "dotregion": 4,
    "geoid": "47115",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2633,
    "affgeoid": "0500000US47117",
    "aland": 972442313,
    "awater": 1801922,
    "countyfp": "117",
    "countyns": "01639771",
    "dotregion": 4,
    "geoid": "47117",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 64,
    "affgeoid": "0500000US47119",
    "aland": 1588021146,
    "awater": 6319196,
    "countyfp": "119",
    "countyns": "01639772",
    "dotregion": 4,
    "geoid": "47119",
    "lsad": "06",
    "name": "Maury",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2809,
    "affgeoid": "0500000US47107",
    "aland": 1114009043,
    "awater": 5340572,
    "countyfp": "107",
    "countyns": "01639773",
    "dotregion": 4,
    "geoid": "47107",
    "lsad": "06",
    "name": "McMinn",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 506,
    "affgeoid": "0500000US47109",
    "aland": 1457754792,
    "awater": 1994987,
    "countyfp": "109",
    "countyns": "01639774",
    "dotregion": 4,
    "geoid": "47109",
    "lsad": "06",
    "name": "McNairy",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 870,
    "affgeoid": "0500000US47121",
    "aland": 505379349,
    "awater": 55995294,
    "countyfp": "121",
    "countyns": "01639775",
    "dotregion": 4,
    "geoid": "47121",
    "lsad": "06",
    "name": "Meigs",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2029,
    "affgeoid": "0500000US47123",
    "aland": 1646119060,
    "awater": 44007085,
    "countyfp": "123",
    "countyns": "01639776",
    "dotregion": 4,
    "geoid": "47123",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 3145,
    "affgeoid": "0500000US47125",
    "aland": 1396435233,
    "awater": 12076781,
    "countyfp": "125",
    "countyns": "01639777",
    "dotregion": 4,
    "geoid": "47125",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1294,
    "affgeoid": "0500000US47127",
    "aland": 334684864,
    "awater": 3093435,
    "countyfp": "127",
    "countyns": "01648579",
    "dotregion": 4,
    "geoid": "47127",
    "lsad": "06",
    "name": "Moore",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 921,
    "affgeoid": "0500000US47129",
    "aland": 1352427852,
    "awater": 823017,
    "countyfp": "129",
    "countyns": "01639778",
    "dotregion": 4,
    "geoid": "47129",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1084,
    "affgeoid": "0500000US47131",
    "aland": 1411321417,
    "awater": 27434034,
    "countyfp": "131",
    "countyns": "01639779",
    "dotregion": 4,
    "geoid": "47131",
    "lsad": "06",
    "name": "Obion",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2500,
    "affgeoid": "0500000US47133",
    "aland": 1122721249,
    "awater": 3492728,
    "countyfp": "133",
    "countyns": "01639780",
    "dotregion": 4,
    "geoid": "47133",
    "lsad": "06",
    "name": "Overton",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1177,
    "affgeoid": "0500000US47135",
    "aland": 1074195267,
    "awater": 21037070,
    "countyfp": "135",
    "countyns": "01639781",
    "dotregion": 4,
    "geoid": "47135",
    "lsad": "06",
    "name": "Perry",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2322,
    "affgeoid": "0500000US47137",
    "aland": 422113187,
    "awater": 29822859,
    "countyfp": "137",
    "countyns": "01648580",
    "dotregion": 4,
    "geoid": "47137",
    "lsad": "06",
    "name": "Pickett",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 751,
    "affgeoid": "0500000US47139",
    "aland": 1125794510,
    "awater": 19834175,
    "countyfp": "139",
    "countyns": "01639782",
    "dotregion": 4,
    "geoid": "47139",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 231,
    "affgeoid": "0500000US47141",
    "aland": 1038860605,
    "awater": 3777709,
    "countyfp": "141",
    "countyns": "01639783",
    "dotregion": 4,
    "geoid": "47141",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 535,
    "affgeoid": "0500000US47143",
    "aland": 816823020,
    "awater": 54463362,
    "countyfp": "143",
    "countyns": "01639784",
    "dotregion": 4,
    "geoid": "47143",
    "lsad": "06",
    "name": "Rhea",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 579,
    "affgeoid": "0500000US47145",
    "aland": 934278752,
    "awater": 88706711,
    "countyfp": "145",
    "countyns": "01639785",
    "dotregion": 4,
    "geoid": "47145",
    "lsad": "06",
    "name": "Roane",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 156,
    "affgeoid": "0500000US47147",
    "aland": 1233581423,
    "awater": 451691,
    "countyfp": "147",
    "countyns": "01639786",
    "dotregion": 4,
    "geoid": "47147",
    "lsad": "06",
    "name": "Robertson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 901,
    "affgeoid": "0500000US47149",
    "aland": 1604138771,
    "awater": 12142432,
    "countyfp": "149",
    "countyns": "01639787",
    "dotregion": 4,
    "geoid": "47149",
    "lsad": "06",
    "name": "Rutherford",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2339,
    "affgeoid": "0500000US47151",
    "aland": 1378627287,
    "awater": 2414254,
    "countyfp": "151",
    "countyns": "01639788",
    "dotregion": 4,
    "geoid": "47151",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2687,
    "affgeoid": "0500000US47153",
    "aland": 688550858,
    "awater": 498314,
    "countyfp": "153",
    "countyns": "01652643",
    "dotregion": 4,
    "geoid": "47153",
    "lsad": "06",
    "name": "Sequatchie",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2386,
    "affgeoid": "0500000US47155",
    "aland": 1534597705,
    "awater": 13491682,
    "countyfp": "155",
    "countyns": "01639789",
    "dotregion": 4,
    "geoid": "47155",
    "lsad": "06",
    "name": "Sevier",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 988,
    "affgeoid": "0500000US47157",
    "aland": 1976744583,
    "awater": 56444531,
    "countyfp": "157",
    "countyns": "01639790",
    "dotregion": 4,
    "geoid": "47157",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2710,
    "affgeoid": "0500000US47159",
    "aland": 814004435,
    "awater": 28706410,
    "countyfp": "159",
    "countyns": "01639791",
    "dotregion": 4,
    "geoid": "47159",
    "lsad": "06",
    "name": "Smith",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 3183,
    "affgeoid": "0500000US47161",
    "aland": 1189665041,
    "awater": 87232349,
    "countyfp": "161",
    "countyns": "01639792",
    "dotregion": 4,
    "geoid": "47161",
    "lsad": "06",
    "name": "Stewart",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1143,
    "affgeoid": "0500000US47163",
    "aland": 1070725096,
    "awater": 42209201,
    "countyfp": "163",
    "countyns": "01639793",
    "dotregion": 4,
    "geoid": "47163",
    "lsad": "06",
    "name": "Sullivan",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2865,
    "affgeoid": "0500000US47165",
    "aland": 1371031078,
    "awater": 35892221,
    "countyfp": "165",
    "countyns": "01639794",
    "dotregion": 4,
    "geoid": "47165",
    "lsad": "06",
    "name": "Sumner",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1577,
    "affgeoid": "0500000US47167",
    "aland": 1187267201,
    "awater": 38609227,
    "countyfp": "167",
    "countyns": "01639795",
    "dotregion": 4,
    "geoid": "47167",
    "lsad": "06",
    "name": "Tipton",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 362,
    "affgeoid": "0500000US47169",
    "aland": 295758960,
    "awater": 6345337,
    "countyfp": "169",
    "countyns": "01648581",
    "dotregion": 4,
    "geoid": "47169",
    "lsad": "06",
    "name": "Trousdale",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1136,
    "affgeoid": "0500000US47171",
    "aland": 482165204,
    "awater": 850687,
    "countyfp": "171",
    "countyns": "01648582",
    "dotregion": 4,
    "geoid": "47171",
    "lsad": "06",
    "name": "Unicoi",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 672,
    "affgeoid": "0500000US47173",
    "aland": 578990166,
    "awater": 61092920,
    "countyfp": "173",
    "countyns": "01648583",
    "dotregion": 4,
    "geoid": "47173",
    "lsad": "06",
    "name": "Union",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2632,
    "affgeoid": "0500000US47175",
    "aland": 708142403,
    "awater": 2893455,
    "countyfp": "175",
    "countyns": "01648584",
    "dotregion": 4,
    "geoid": "47175",
    "lsad": "06",
    "name": "Van Buren",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 115,
    "affgeoid": "0500000US47177",
    "aland": 1120635693,
    "awater": 3508325,
    "countyfp": "177",
    "countyns": "01639796",
    "dotregion": 4,
    "geoid": "47177",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1137,
    "affgeoid": "0500000US47179",
    "aland": 845537289,
    "awater": 8635314,
    "countyfp": "179",
    "countyns": "01639797",
    "dotregion": 4,
    "geoid": "47179",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 2296,
    "affgeoid": "0500000US47181",
    "aland": 1901321676,
    "awater": 4023416,
    "countyfp": "181",
    "countyns": "01639798",
    "dotregion": 4,
    "geoid": "47181",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 508,
    "affgeoid": "0500000US47183",
    "aland": 1503105587,
    "awater": 3709396,
    "countyfp": "183",
    "countyns": "01639799",
    "dotregion": 4,
    "geoid": "47183",
    "lsad": "06",
    "name": "Weakley",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 685,
    "affgeoid": "0500000US47185",
    "aland": 975592099,
    "awater": 7113368,
    "countyfp": "185",
    "countyns": "01639800",
    "dotregion": 4,
    "geoid": "47185",
    "lsad": "06",
    "name": "White",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1139,
    "affgeoid": "0500000US47187",
    "aland": 1508936096,
    "awater": 3012751,
    "countyfp": "187",
    "countyns": "01639801",
    "dotregion": 4,
    "geoid": "47187",
    "lsad": "06",
    "name": "Williamson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }, {
    "id": 1841,
    "affgeoid": "0500000US47189",
    "aland": 1479053240,
    "awater": 32002363,
    "countyfp": "189",
    "countyns": "01639802",
    "dotregion": 4,
    "geoid": "47189",
    "lsad": "06",
    "name": "Wilson",
    "stateAbbreviation": "TN",
    "stateId": 8
  }]
}, {
  "id": 1,
  "abbreviation": "TX",
  "affgeoid": "0400000US48",
  "aland": 676634395761,
  "awater": 19027462392,
  "dotregion": 6,
  "geoid": "48",
  "lsad": "00",
  "name": "Texas",
  "stateAbbreviation": "TX",
  "statefp": "48",
  "statens": "01779801",
  "counties": [{
    "id": 1855,
    "affgeoid": "0500000US48001",
    "aland": 2752130046,
    "awater": 39879877,
    "countyfp": "001",
    "countyns": "01383786",
    "dotregion": 6,
    "geoid": "48001",
    "lsad": "06",
    "name": "Anderson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 906,
    "affgeoid": "0500000US48003",
    "aland": 3886770077,
    "awater": 957039,
    "countyfp": "003",
    "countyns": "01383787",
    "dotregion": 6,
    "geoid": "48003",
    "lsad": "06",
    "name": "Andrews",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2933,
    "affgeoid": "0500000US48005",
    "aland": 2066240093,
    "awater": 173369611,
    "countyfp": "005",
    "countyns": "01383788",
    "dotregion": 6,
    "geoid": "48005",
    "lsad": "06",
    "name": "Angelina",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1506,
    "affgeoid": "0500000US48007",
    "aland": 652895326,
    "awater": 714592846,
    "countyfp": "007",
    "countyns": "01383789",
    "dotregion": 6,
    "geoid": "48007",
    "lsad": "06",
    "name": "Aransas",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 206,
    "affgeoid": "0500000US48009",
    "aland": 2339055582,
    "awater": 57765519,
    "countyfp": "009",
    "countyns": "01383790",
    "dotregion": 6,
    "geoid": "48009",
    "lsad": "06",
    "name": "Archer",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1757,
    "affgeoid": "0500000US48011",
    "aland": 2354581764,
    "awater": 12219587,
    "countyfp": "011",
    "countyns": "01383791",
    "dotregion": 6,
    "geoid": "48011",
    "lsad": "06",
    "name": "Armstrong",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2604,
    "affgeoid": "0500000US48013",
    "aland": 3158593195,
    "awater": 4995711,
    "countyfp": "013",
    "countyns": "01383792",
    "dotregion": 6,
    "geoid": "48013",
    "lsad": "06",
    "name": "Atascosa",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1115,
    "affgeoid": "0500000US48015",
    "aland": 1674400698,
    "awater": 25611066,
    "countyfp": "015",
    "countyns": "01383793",
    "dotregion": 6,
    "geoid": "48015",
    "lsad": "06",
    "name": "Austin",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2793,
    "affgeoid": "0500000US48017",
    "aland": 2141566431,
    "awater": 1771774,
    "countyfp": "017",
    "countyns": "01383794",
    "dotregion": 6,
    "geoid": "48017",
    "lsad": "06",
    "name": "Bailey",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1104,
    "affgeoid": "0500000US48019",
    "aland": 2048649340,
    "awater": 17288354,
    "countyfp": "019",
    "countyns": "01383795",
    "dotregion": 6,
    "geoid": "48019",
    "lsad": "06",
    "name": "Bandera",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 223,
    "affgeoid": "0500000US48021",
    "aland": 2300343165,
    "awater": 19109836,
    "countyfp": "021",
    "countyns": "01383796",
    "dotregion": 6,
    "geoid": "48021",
    "lsad": "06",
    "name": "Bastrop",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1675,
    "affgeoid": "0500000US48023",
    "aland": 2246765475,
    "awater": 86991848,
    "countyfp": "023",
    "countyns": "01383797",
    "dotregion": 6,
    "geoid": "48023",
    "lsad": "06",
    "name": "Baylor",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 649,
    "affgeoid": "0500000US48025",
    "aland": 2279809514,
    "awater": 246409,
    "countyfp": "025",
    "countyns": "01383798",
    "dotregion": 6,
    "geoid": "48025",
    "lsad": "06",
    "name": "Bee",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2355,
    "affgeoid": "0500000US48027",
    "aland": 2722150391,
    "awater": 95333156,
    "countyfp": "027",
    "countyns": "01383799",
    "dotregion": 6,
    "geoid": "48027",
    "lsad": "06",
    "name": "Bell",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1404,
    "affgeoid": "0500000US48029",
    "aland": 3211263825,
    "awater": 41958323,
    "countyfp": "029",
    "countyns": "01383800",
    "dotregion": 6,
    "geoid": "48029",
    "lsad": "06",
    "name": "Bexar",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 329,
    "affgeoid": "0500000US48031",
    "aland": 1836948312,
    "awater": 10818399,
    "countyfp": "031",
    "countyns": "01383801",
    "dotregion": 6,
    "geoid": "48031",
    "lsad": "06",
    "name": "Blanco",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2170,
    "affgeoid": "0500000US48033",
    "aland": 2324366073,
    "awater": 22297610,
    "countyfp": "033",
    "countyns": "01383802",
    "dotregion": 6,
    "geoid": "48033",
    "lsad": "06",
    "name": "Borden",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2194,
    "affgeoid": "0500000US48035",
    "aland": 2545904361,
    "awater": 50670002,
    "countyfp": "035",
    "countyns": "01383803",
    "dotregion": 6,
    "geoid": "48035",
    "lsad": "06",
    "name": "Bosque",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2889,
    "affgeoid": "0500000US48037",
    "aland": 2292153737,
    "awater": 98319961,
    "countyfp": "037",
    "countyns": "01383804",
    "dotregion": 6,
    "geoid": "48037",
    "lsad": "06",
    "name": "Bowie",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1306,
    "affgeoid": "0500000US48039",
    "aland": 3516716918,
    "awater": 649539513,
    "countyfp": "039",
    "countyns": "01383805",
    "dotregion": 6,
    "geoid": "48039",
    "lsad": "06",
    "name": "Brazoria",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1296,
    "affgeoid": "0500000US48041",
    "aland": 1516568117,
    "awater": 14728310,
    "countyfp": "041",
    "countyns": "01383806",
    "dotregion": 6,
    "geoid": "48041",
    "lsad": "06",
    "name": "Brazos",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1996,
    "affgeoid": "0500000US48043",
    "aland": 16015846743,
    "awater": 22063764,
    "countyfp": "043",
    "countyns": "01383807",
    "dotregion": 6,
    "geoid": "48043",
    "lsad": "06",
    "name": "Brewster",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 346,
    "affgeoid": "0500000US48045",
    "aland": 2330991080,
    "awater": 4068657,
    "countyfp": "045",
    "countyns": "01383808",
    "dotregion": 6,
    "geoid": "48045",
    "lsad": "06",
    "name": "Briscoe",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1138,
    "affgeoid": "0500000US48047",
    "aland": 2443273797,
    "awater": 741627,
    "countyfp": "047",
    "countyns": "01383809",
    "dotregion": 6,
    "geoid": "48047",
    "lsad": "06",
    "name": "Brooks",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 222,
    "affgeoid": "0500000US48049",
    "aland": 2446081829,
    "awater": 32417771,
    "countyfp": "049",
    "countyns": "01383810",
    "dotregion": 6,
    "geoid": "48049",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 580,
    "affgeoid": "0500000US48051",
    "aland": 1706884775,
    "awater": 46050488,
    "countyfp": "051",
    "countyns": "01383811",
    "dotregion": 6,
    "geoid": "48051",
    "lsad": "06",
    "name": "Burleson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1908,
    "affgeoid": "0500000US48053",
    "aland": 2575116286,
    "awater": 69940865,
    "countyfp": "053",
    "countyns": "01383812",
    "dotregion": 6,
    "geoid": "48053",
    "lsad": "06",
    "name": "Burnet",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1637,
    "affgeoid": "0500000US48055",
    "aland": 1412142115,
    "awater": 4976645,
    "countyfp": "055",
    "countyns": "01383813",
    "dotregion": 6,
    "geoid": "48055",
    "lsad": "06",
    "name": "Caldwell",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1934,
    "affgeoid": "0500000US48057",
    "aland": 1312707083,
    "awater": 1361903486,
    "countyfp": "057",
    "countyns": "01383814",
    "dotregion": 6,
    "geoid": "48057",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3154,
    "affgeoid": "0500000US48059",
    "aland": 2329363247,
    "awater": 4898783,
    "countyfp": "059",
    "countyns": "01383815",
    "dotregion": 6,
    "geoid": "48059",
    "lsad": "06",
    "name": "Callahan",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2804,
    "affgeoid": "0500000US48061",
    "aland": 2307839892,
    "awater": 998169935,
    "countyfp": "061",
    "countyns": "01383816",
    "dotregion": 6,
    "geoid": "48061",
    "lsad": "06",
    "name": "Cameron",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1385,
    "affgeoid": "0500000US48063",
    "aland": 507188431,
    "awater": 19183294,
    "countyfp": "063",
    "countyns": "01383817",
    "dotregion": 6,
    "geoid": "48063",
    "lsad": "06",
    "name": "Camp",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 747,
    "affgeoid": "0500000US48065",
    "aland": 2383359750,
    "awater": 10064086,
    "countyfp": "065",
    "countyns": "01383818",
    "dotregion": 6,
    "geoid": "48065",
    "lsad": "06",
    "name": "Carson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1895,
    "affgeoid": "0500000US48067",
    "aland": 2426724487,
    "awater": 60499731,
    "countyfp": "067",
    "countyns": "01383819",
    "dotregion": 6,
    "geoid": "48067",
    "lsad": "06",
    "name": "Cass",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 358,
    "affgeoid": "0500000US48069",
    "aland": 2316573414,
    "awater": 12584396,
    "countyfp": "069",
    "countyns": "01383820",
    "dotregion": 6,
    "geoid": "48069",
    "lsad": "06",
    "name": "Castro",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 561,
    "affgeoid": "0500000US48071",
    "aland": 1546604745,
    "awater": 709764011,
    "countyfp": "071",
    "countyns": "01383821",
    "dotregion": 6,
    "geoid": "48071",
    "lsad": "06",
    "name": "Chambers",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2005,
    "affgeoid": "0500000US48073",
    "aland": 2727190094,
    "awater": 23873001,
    "countyfp": "073",
    "countyns": "01383822",
    "dotregion": 6,
    "geoid": "48073",
    "lsad": "06",
    "name": "Cherokee",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 188,
    "affgeoid": "0500000US48075",
    "aland": 1803680231,
    "awater": 44835076,
    "countyfp": "075",
    "countyns": "01383823",
    "dotregion": 6,
    "geoid": "48075",
    "lsad": "06",
    "name": "Childress",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 768,
    "affgeoid": "0500000US48077",
    "aland": 2819780889,
    "awater": 72591143,
    "countyfp": "077",
    "countyns": "01383824",
    "dotregion": 6,
    "geoid": "48077",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1420,
    "affgeoid": "0500000US48079",
    "aland": 2007614621,
    "awater": 229068,
    "countyfp": "079",
    "countyns": "01383825",
    "dotregion": 6,
    "geoid": "48079",
    "lsad": "06",
    "name": "Cochran",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2621,
    "affgeoid": "0500000US48081",
    "aland": 2360705920,
    "awater": 42788774,
    "countyfp": "081",
    "countyns": "01383826",
    "dotregion": 6,
    "geoid": "48081",
    "lsad": "06",
    "name": "Coke",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 617,
    "affgeoid": "0500000US48083",
    "aland": 3268424415,
    "awater": 50472148,
    "countyfp": "083",
    "countyns": "01383827",
    "dotregion": 6,
    "geoid": "48083",
    "lsad": "06",
    "name": "Coleman",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 955,
    "affgeoid": "0500000US48085",
    "aland": 2178964322,
    "awater": 116134650,
    "countyfp": "085",
    "countyns": "01383828",
    "dotregion": 6,
    "geoid": "48085",
    "lsad": "06",
    "name": "Collin",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 889,
    "affgeoid": "0500000US48087",
    "aland": 2378749933,
    "awater": 2279193,
    "countyfp": "087",
    "countyns": "01383829",
    "dotregion": 6,
    "geoid": "48087",
    "lsad": "06",
    "name": "Collingsworth",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2236,
    "affgeoid": "0500000US48089",
    "aland": 2487151628,
    "awater": 34682260,
    "countyfp": "089",
    "countyns": "01383830",
    "dotregion": 6,
    "geoid": "48089",
    "lsad": "06",
    "name": "Colorado",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 956,
    "affgeoid": "0500000US48091",
    "aland": 1449127335,
    "awater": 39800429,
    "countyfp": "091",
    "countyns": "01383831",
    "dotregion": 6,
    "geoid": "48091",
    "lsad": "06",
    "name": "Comal",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2531,
    "affgeoid": "0500000US48093",
    "aland": 2428770461,
    "awater": 25718009,
    "countyfp": "093",
    "countyns": "01383832",
    "dotregion": 6,
    "geoid": "48093",
    "lsad": "06",
    "name": "Comanche",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2764,
    "affgeoid": "0500000US48095",
    "aland": 2548139855,
    "awater": 25740027,
    "countyfp": "095",
    "countyns": "01383833",
    "dotregion": 6,
    "geoid": "48095",
    "lsad": "06",
    "name": "Concho",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2684,
    "affgeoid": "0500000US48097",
    "aland": 2265775271,
    "awater": 61333916,
    "countyfp": "097",
    "countyns": "01383834",
    "dotregion": 6,
    "geoid": "48097",
    "lsad": "06",
    "name": "Cooke",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2030,
    "affgeoid": "0500000US48099",
    "aland": 2725136393,
    "awater": 11847509,
    "countyfp": "099",
    "countyns": "01383835",
    "dotregion": 6,
    "geoid": "48099",
    "lsad": "06",
    "name": "Coryell",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 189,
    "affgeoid": "0500000US48101",
    "aland": 2332448562,
    "awater": 2723996,
    "countyfp": "101",
    "countyns": "01383836",
    "dotregion": 6,
    "geoid": "48101",
    "lsad": "06",
    "name": "Cottle",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2989,
    "affgeoid": "0500000US48103",
    "aland": 2033319717,
    "awater": 1695980,
    "countyfp": "103",
    "countyns": "01383837",
    "dotregion": 6,
    "geoid": "48103",
    "lsad": "06",
    "name": "Crane",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2677,
    "affgeoid": "0500000US48105",
    "aland": 7270834113,
    "awater": 53329,
    "countyfp": "105",
    "countyns": "01383838",
    "dotregion": 6,
    "geoid": "48105",
    "lsad": "06",
    "name": "Crockett",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1475,
    "affgeoid": "0500000US48107",
    "aland": 2331504872,
    "awater": 3873557,
    "countyfp": "107",
    "countyns": "01383839",
    "dotregion": 6,
    "geoid": "48107",
    "lsad": "06",
    "name": "Crosby",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1073,
    "affgeoid": "0500000US48109",
    "aland": 9875068369,
    "awater": 556184,
    "countyfp": "109",
    "countyns": "01383840",
    "dotregion": 6,
    "geoid": "48109",
    "lsad": "06",
    "name": "Culberson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 16,
    "affgeoid": "0500000US48111",
    "aland": 3893418641,
    "awater": 5182865,
    "countyfp": "111",
    "countyns": "01383841",
    "dotregion": 6,
    "geoid": "48111",
    "lsad": "06",
    "name": "Dallam",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1992,
    "affgeoid": "0500000US48113",
    "aland": 2261192991,
    "awater": 92106631,
    "countyfp": "113",
    "countyns": "01383842",
    "dotregion": 6,
    "geoid": "48113",
    "lsad": "06",
    "name": "Dallas",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 627,
    "affgeoid": "0500000US48115",
    "aland": 2331781557,
    "awater": 4720730,
    "countyfp": "115",
    "countyns": "01383843",
    "dotregion": 6,
    "geoid": "48115",
    "lsad": "06",
    "name": "Dawson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 453,
    "affgeoid": "0500000US48123",
    "aland": 2354237904,
    "awater": 3919919,
    "countyfp": "123",
    "countyns": "01383844",
    "dotregion": 6,
    "geoid": "48123",
    "lsad": "06",
    "name": "DeWitt",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2743,
    "affgeoid": "0500000US48117",
    "aland": 3876866567,
    "awater": 3926557,
    "countyfp": "117",
    "countyns": "01383845",
    "dotregion": 6,
    "geoid": "48117",
    "lsad": "06",
    "name": "Deaf Smith",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 989,
    "affgeoid": "0500000US48119",
    "aland": 665174300,
    "awater": 54666016,
    "countyfp": "119",
    "countyns": "01383846",
    "dotregion": 6,
    "geoid": "48119",
    "lsad": "06",
    "name": "Delta",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 676,
    "affgeoid": "0500000US48121",
    "aland": 2275328170,
    "awater": 192671841,
    "countyfp": "121",
    "countyns": "01383847",
    "dotregion": 6,
    "geoid": "48121",
    "lsad": "06",
    "name": "Denton",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 134,
    "affgeoid": "0500000US48125",
    "aland": 2335454749,
    "awater": 9057732,
    "countyfp": "125",
    "countyns": "01383848",
    "dotregion": 6,
    "geoid": "48125",
    "lsad": "06",
    "name": "Dickens",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2864,
    "affgeoid": "0500000US48127",
    "aland": 3441795366,
    "awater": 14576538,
    "countyfp": "127",
    "countyns": "01383849",
    "dotregion": 6,
    "geoid": "48127",
    "lsad": "06",
    "name": "Dimmit",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1579,
    "affgeoid": "0500000US48129",
    "aland": 2400623971,
    "awater": 15954005,
    "countyfp": "129",
    "countyns": "01383850",
    "dotregion": 6,
    "geoid": "48129",
    "lsad": "06",
    "name": "Donley",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 513,
    "affgeoid": "0500000US48131",
    "aland": 4645082837,
    "awater": 5478267,
    "countyfp": "131",
    "countyns": "01383851",
    "dotregion": 6,
    "geoid": "48131",
    "lsad": "06",
    "name": "Duval",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 111,
    "affgeoid": "0500000US48133",
    "aland": 2399587755,
    "awater": 14047795,
    "countyfp": "133",
    "countyns": "01383852",
    "dotregion": 6,
    "geoid": "48133",
    "lsad": "06",
    "name": "Eastland",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3059,
    "affgeoid": "0500000US48135",
    "aland": 2325094451,
    "awater": 10597923,
    "countyfp": "135",
    "countyns": "01383853",
    "dotregion": 6,
    "geoid": "48135",
    "lsad": "06",
    "name": "Ector",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1849,
    "affgeoid": "0500000US48137",
    "aland": 5485228672,
    "awater": 5199800,
    "countyfp": "137",
    "countyns": "01383854",
    "dotregion": 6,
    "geoid": "48137",
    "lsad": "06",
    "name": "Edwards",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2056,
    "affgeoid": "0500000US48141",
    "aland": 2623292317,
    "awater": 5443531,
    "countyfp": "141",
    "countyns": "01383855",
    "dotregion": 6,
    "geoid": "48141",
    "lsad": "06",
    "name": "El Paso",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1313,
    "affgeoid": "0500000US48139",
    "aland": 2423336009,
    "awater": 41679023,
    "countyfp": "139",
    "countyns": "01383856",
    "dotregion": 6,
    "geoid": "48139",
    "lsad": "06",
    "name": "Ellis",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 981,
    "affgeoid": "0500000US48143",
    "aland": 2805141640,
    "awater": 17445013,
    "countyfp": "143",
    "countyns": "01383857",
    "dotregion": 6,
    "geoid": "48143",
    "lsad": "06",
    "name": "Erath",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 46,
    "affgeoid": "0500000US48145",
    "aland": 1982592892,
    "awater": 21645980,
    "countyfp": "145",
    "countyns": "01383858",
    "dotregion": 6,
    "geoid": "48145",
    "lsad": "06",
    "name": "Falls",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1337,
    "affgeoid": "0500000US48147",
    "aland": 2307244931,
    "awater": 20853016,
    "countyfp": "147",
    "countyns": "01383859",
    "dotregion": 6,
    "geoid": "48147",
    "lsad": "06",
    "name": "Fannin",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1398,
    "affgeoid": "0500000US48149",
    "aland": 2460509745,
    "awater": 25381859,
    "countyfp": "149",
    "countyns": "01383860",
    "dotregion": 6,
    "geoid": "48149",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 803,
    "affgeoid": "0500000US48151",
    "aland": 2328246699,
    "awater": 7283896,
    "countyfp": "151",
    "countyns": "01383861",
    "dotregion": 6,
    "geoid": "48151",
    "lsad": "06",
    "name": "Fisher",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 888,
    "affgeoid": "0500000US48153",
    "aland": 2569637276,
    "awater": 983737,
    "countyfp": "153",
    "countyns": "01383862",
    "dotregion": 6,
    "geoid": "48153",
    "lsad": "06",
    "name": "Floyd",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2369,
    "affgeoid": "0500000US48155",
    "aland": 1824378275,
    "awater": 8514740,
    "countyfp": "155",
    "countyns": "01383863",
    "dotregion": 6,
    "geoid": "48155",
    "lsad": "06",
    "name": "Foard",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1911,
    "affgeoid": "0500000US48157",
    "aland": 2232145033,
    "awater": 60902474,
    "countyfp": "157",
    "countyns": "01383864",
    "dotregion": 6,
    "geoid": "48157",
    "lsad": "06",
    "name": "Fort Bend",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 65,
    "affgeoid": "0500000US48159",
    "aland": 736570306,
    "awater": 26874743,
    "countyfp": "159",
    "countyns": "01383865",
    "dotregion": 6,
    "geoid": "48159",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1230,
    "affgeoid": "0500000US48161",
    "aland": 2273333001,
    "awater": 36915831,
    "countyfp": "161",
    "countyns": "01383866",
    "dotregion": 6,
    "geoid": "48161",
    "lsad": "06",
    "name": "Freestone",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1551,
    "affgeoid": "0500000US48163",
    "aland": 2935753509,
    "awater": 2193620,
    "countyfp": "163",
    "countyns": "01383867",
    "dotregion": 6,
    "geoid": "48163",
    "lsad": "06",
    "name": "Frio",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 629,
    "affgeoid": "0500000US48165",
    "aland": 3891129569,
    "awater": 1262946,
    "countyfp": "165",
    "countyns": "01383868",
    "dotregion": 6,
    "geoid": "48165",
    "lsad": "06",
    "name": "Gaines",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3171,
    "affgeoid": "0500000US48167",
    "aland": 981463497,
    "awater": 1281651787,
    "countyfp": "167",
    "countyns": "01383869",
    "dotregion": 6,
    "geoid": "48167",
    "lsad": "06",
    "name": "Galveston",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2611,
    "affgeoid": "0500000US48169",
    "aland": 2313930843,
    "awater": 7215530,
    "countyfp": "169",
    "countyns": "01383870",
    "dotregion": 6,
    "geoid": "48169",
    "lsad": "06",
    "name": "Garza",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 687,
    "affgeoid": "0500000US48171",
    "aland": 2740756101,
    "awater": 8982856,
    "countyfp": "171",
    "countyns": "01383871",
    "dotregion": 6,
    "geoid": "48171",
    "lsad": "06",
    "name": "Gillespie",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 11,
    "affgeoid": "0500000US48173",
    "aland": 2331552809,
    "awater": 2245298,
    "countyfp": "173",
    "countyns": "01383872",
    "dotregion": 6,
    "geoid": "48173",
    "lsad": "06",
    "name": "Glasscock",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3026,
    "affgeoid": "0500000US48175",
    "aland": 2206695364,
    "awater": 19049508,
    "countyfp": "175",
    "countyns": "01383873",
    "dotregion": 6,
    "geoid": "48175",
    "lsad": "06",
    "name": "Goliad",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1249,
    "affgeoid": "0500000US48177",
    "aland": 2762704864,
    "awater": 8204086,
    "countyfp": "177",
    "countyns": "01383874",
    "dotregion": 6,
    "geoid": "48177",
    "lsad": "06",
    "name": "Gonzales",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 185,
    "affgeoid": "0500000US48179",
    "aland": 2398261671,
    "awater": 8700791,
    "countyfp": "179",
    "countyns": "01383875",
    "dotregion": 6,
    "geoid": "48179",
    "lsad": "06",
    "name": "Gray",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1798,
    "affgeoid": "0500000US48181",
    "aland": 2415989108,
    "awater": 120124595,
    "countyfp": "181",
    "countyns": "01383876",
    "dotregion": 6,
    "geoid": "48181",
    "lsad": "06",
    "name": "Grayson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2825,
    "affgeoid": "0500000US48183",
    "aland": 708030599,
    "awater": 6227994,
    "countyfp": "183",
    "countyns": "01383877",
    "dotregion": 6,
    "geoid": "48183",
    "lsad": "06",
    "name": "Gregg",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 615,
    "affgeoid": "0500000US48185",
    "aland": 2039539025,
    "awater": 36603913,
    "countyfp": "185",
    "countyns": "01383878",
    "dotregion": 6,
    "geoid": "48185",
    "lsad": "06",
    "name": "Grimes",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2057,
    "affgeoid": "0500000US48187",
    "aland": 1842193219,
    "awater": 9105133,
    "countyfp": "187",
    "countyns": "01383879",
    "dotregion": 6,
    "geoid": "48187",
    "lsad": "06",
    "name": "Guadalupe",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1830,
    "affgeoid": "0500000US48189",
    "aland": 2602115649,
    "awater": 246678,
    "countyfp": "189",
    "countyns": "01383880",
    "dotregion": 6,
    "geoid": "48189",
    "lsad": "06",
    "name": "Hale",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 953,
    "affgeoid": "0500000US48191",
    "aland": 2288233622,
    "awater": 53366404,
    "countyfp": "191",
    "countyns": "01383881",
    "dotregion": 6,
    "geoid": "48191",
    "lsad": "06",
    "name": "Hall",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 216,
    "affgeoid": "0500000US48193",
    "aland": 2165008338,
    "awater": 1238628,
    "countyfp": "193",
    "countyns": "01383882",
    "dotregion": 6,
    "geoid": "48193",
    "lsad": "06",
    "name": "Hamilton",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 748,
    "affgeoid": "0500000US48195",
    "aland": 2382296529,
    "awater": 1548341,
    "countyfp": "195",
    "countyns": "01383883",
    "dotregion": 6,
    "geoid": "48195",
    "lsad": "06",
    "name": "Hansford",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1656,
    "affgeoid": "0500000US48197",
    "aland": 1800337387,
    "awater": 4548860,
    "countyfp": "197",
    "countyns": "01383884",
    "dotregion": 6,
    "geoid": "48197",
    "lsad": "06",
    "name": "Hardeman",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1748,
    "affgeoid": "0500000US48199",
    "aland": 2306607919,
    "awater": 18042331,
    "countyfp": "199",
    "countyns": "01383885",
    "dotregion": 6,
    "geoid": "48199",
    "lsad": "06",
    "name": "Hardin",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2999,
    "affgeoid": "0500000US48201",
    "aland": 4415554759,
    "awater": 188073713,
    "countyfp": "201",
    "countyns": "01383886",
    "dotregion": 6,
    "geoid": "48201",
    "lsad": "06",
    "name": "Harris",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1381,
    "affgeoid": "0500000US48203",
    "aland": 2330820875,
    "awater": 40969486,
    "countyfp": "203",
    "countyns": "01383887",
    "dotregion": 6,
    "geoid": "48203",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 404,
    "affgeoid": "0500000US48205",
    "aland": 3786647725,
    "awater": 3024080,
    "countyfp": "205",
    "countyns": "01383888",
    "dotregion": 6,
    "geoid": "48205",
    "lsad": "06",
    "name": "Hartley",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1918,
    "affgeoid": "0500000US48207",
    "aland": 2339103809,
    "awater": 18465208,
    "countyfp": "207",
    "countyns": "01383889",
    "dotregion": 6,
    "geoid": "48207",
    "lsad": "06",
    "name": "Haskell",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 832,
    "affgeoid": "0500000US48209",
    "aland": 1755978884,
    "awater": 5037780,
    "countyfp": "209",
    "countyns": "01383890",
    "dotregion": 6,
    "geoid": "48209",
    "lsad": "06",
    "name": "Hays",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2144,
    "affgeoid": "0500000US48211",
    "aland": 2347272199,
    "awater": 15205585,
    "countyfp": "211",
    "countyns": "01383891",
    "dotregion": 6,
    "geoid": "48211",
    "lsad": "06",
    "name": "Hemphill",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1812,
    "affgeoid": "0500000US48213",
    "aland": 2262941927,
    "awater": 193237889,
    "countyfp": "213",
    "countyns": "01383892",
    "dotregion": 6,
    "geoid": "48213",
    "lsad": "06",
    "name": "Henderson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 562,
    "affgeoid": "0500000US48215",
    "aland": 4068610100,
    "awater": 31102596,
    "countyfp": "215",
    "countyns": "01383893",
    "dotregion": 6,
    "geoid": "48215",
    "lsad": "06",
    "name": "Hidalgo",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 911,
    "affgeoid": "0500000US48217",
    "aland": 2483455107,
    "awater": 69547485,
    "countyfp": "217",
    "countyns": "01383894",
    "dotregion": 6,
    "geoid": "48217",
    "lsad": "06",
    "name": "Hill",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 437,
    "affgeoid": "0500000US48219",
    "aland": 2352723913,
    "awater": 446119,
    "countyfp": "219",
    "countyns": "01383895",
    "dotregion": 6,
    "geoid": "48219",
    "lsad": "06",
    "name": "Hockley",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1615,
    "affgeoid": "0500000US48221",
    "aland": 1089485204,
    "awater": 41921581,
    "countyfp": "221",
    "countyns": "01383896",
    "dotregion": 6,
    "geoid": "48221",
    "lsad": "06",
    "name": "Hood",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 278,
    "affgeoid": "0500000US48223",
    "aland": 1987018121,
    "awater": 66250826,
    "countyfp": "223",
    "countyns": "01383897",
    "dotregion": 6,
    "geoid": "48223",
    "lsad": "06",
    "name": "Hopkins",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1002,
    "affgeoid": "0500000US48225",
    "aland": 3188288246,
    "awater": 14426022,
    "countyfp": "225",
    "countyns": "01383898",
    "dotregion": 6,
    "geoid": "48225",
    "lsad": "06",
    "name": "Houston",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2612,
    "affgeoid": "0500000US48227",
    "aland": 2333038989,
    "awater": 8841781,
    "countyfp": "227",
    "countyns": "01383899",
    "dotregion": 6,
    "geoid": "48227",
    "lsad": "06",
    "name": "Howard",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 998,
    "affgeoid": "0500000US48229",
    "aland": 11838354409,
    "awater": 2191007,
    "countyfp": "229",
    "countyns": "01383900",
    "dotregion": 6,
    "geoid": "48229",
    "lsad": "06",
    "name": "Hudspeth",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2991,
    "affgeoid": "0500000US48231",
    "aland": 2176414828,
    "awater": 108013726,
    "countyfp": "231",
    "countyns": "01383901",
    "dotregion": 6,
    "geoid": "48231",
    "lsad": "06",
    "name": "Hunt",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2524,
    "affgeoid": "0500000US48233",
    "aland": 2298404017,
    "awater": 19511582,
    "countyfp": "233",
    "countyns": "01383902",
    "dotregion": 6,
    "geoid": "48233",
    "lsad": "06",
    "name": "Hutchinson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 493,
    "affgeoid": "0500000US48235",
    "aland": 2723485993,
    "awater": 176317,
    "countyfp": "235",
    "countyns": "01383903",
    "dotregion": 6,
    "geoid": "48235",
    "lsad": "06",
    "name": "Irion",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 95,
    "affgeoid": "0500000US48237",
    "aland": 2358612574,
    "awater": 24503194,
    "countyfp": "237",
    "countyns": "01383904",
    "dotregion": 6,
    "geoid": "48237",
    "lsad": "06",
    "name": "Jack",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 259,
    "affgeoid": "0500000US48239",
    "aland": 2148246647,
    "awater": 71039573,
    "countyfp": "239",
    "countyns": "01383905",
    "dotregion": 6,
    "geoid": "48239",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2021,
    "affgeoid": "0500000US48241",
    "aland": 2431621507,
    "awater": 79883776,
    "countyfp": "241",
    "countyns": "01383906",
    "dotregion": 6,
    "geoid": "48241",
    "lsad": "06",
    "name": "Jasper",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2227,
    "affgeoid": "0500000US48243",
    "aland": 5865089584,
    "awater": 206206,
    "countyfp": "243",
    "countyns": "01383907",
    "dotregion": 6,
    "geoid": "48243",
    "lsad": "06",
    "name": "Jeff Davis",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 616,
    "affgeoid": "0500000US48245",
    "aland": 2269596850,
    "awater": 612148954,
    "countyfp": "245",
    "countyns": "01383908",
    "dotregion": 6,
    "geoid": "48245",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2488,
    "affgeoid": "0500000US48247",
    "aland": 2942597110,
    "awater": 92565,
    "countyfp": "247",
    "countyns": "01383909",
    "dotregion": 6,
    "geoid": "48247",
    "lsad": "06",
    "name": "Jim Hogg",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2143,
    "affgeoid": "0500000US48249",
    "aland": 2240778092,
    "awater": 8739522,
    "countyfp": "249",
    "countyns": "01383910",
    "dotregion": 6,
    "geoid": "48249",
    "lsad": "06",
    "name": "Jim Wells",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1947,
    "affgeoid": "0500000US48251",
    "aland": 1877186503,
    "awater": 25039412,
    "countyfp": "251",
    "countyns": "01383911",
    "dotregion": 6,
    "geoid": "48251",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2470,
    "affgeoid": "0500000US48253",
    "aland": 2404946726,
    "awater": 22227413,
    "countyfp": "253",
    "countyns": "01383912",
    "dotregion": 6,
    "geoid": "48253",
    "lsad": "06",
    "name": "Jones",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 214,
    "affgeoid": "0500000US48255",
    "aland": 1936189585,
    "awater": 15490412,
    "countyfp": "255",
    "countyns": "01383913",
    "dotregion": 6,
    "geoid": "48255",
    "lsad": "06",
    "name": "Karnes",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3155,
    "affgeoid": "0500000US48257",
    "aland": 2022009515,
    "awater": 69821252,
    "countyfp": "257",
    "countyns": "01383914",
    "dotregion": 6,
    "geoid": "48257",
    "lsad": "06",
    "name": "Kaufman",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2419,
    "affgeoid": "0500000US48259",
    "aland": 1715732847,
    "awater": 1496797,
    "countyfp": "259",
    "countyns": "01383915",
    "dotregion": 6,
    "geoid": "48259",
    "lsad": "06",
    "name": "Kendall",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2590,
    "affgeoid": "0500000US48261",
    "aland": 3777420465,
    "awater": 1262127135,
    "countyfp": "261",
    "countyns": "01383916",
    "dotregion": 6,
    "geoid": "48261",
    "lsad": "06",
    "name": "Kenedy",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 338,
    "affgeoid": "0500000US48263",
    "aland": 2337522504,
    "awater": 1065195,
    "countyfp": "263",
    "countyns": "01383917",
    "dotregion": 6,
    "geoid": "48263",
    "lsad": "06",
    "name": "Kent",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2006,
    "affgeoid": "0500000US48265",
    "aland": 2857583413,
    "awater": 10247343,
    "countyfp": "265",
    "countyns": "01383918",
    "dotregion": 6,
    "geoid": "48265",
    "lsad": "06",
    "name": "Kerr",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1272,
    "affgeoid": "0500000US48267",
    "aland": 3240116505,
    "awater": 493584,
    "countyfp": "267",
    "countyns": "01383919",
    "dotregion": 6,
    "geoid": "48267",
    "lsad": "06",
    "name": "Kimble",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 376,
    "affgeoid": "0500000US48269",
    "aland": 2359148816,
    "awater": 6398045,
    "countyfp": "269",
    "countyns": "01383920",
    "dotregion": 6,
    "geoid": "48269",
    "lsad": "06",
    "name": "King",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 348,
    "affgeoid": "0500000US48271",
    "aland": 3522534792,
    "awater": 13124946,
    "countyfp": "271",
    "countyns": "01383921",
    "dotregion": 6,
    "geoid": "48271",
    "lsad": "06",
    "name": "Kinney",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 733,
    "affgeoid": "0500000US48273",
    "aland": 2282582851,
    "awater": 541042646,
    "countyfp": "273",
    "countyns": "01383922",
    "dotregion": 6,
    "geoid": "48273",
    "lsad": "06",
    "name": "Kleberg",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1948,
    "affgeoid": "0500000US48275",
    "aland": 2203098613,
    "awater": 12577261,
    "countyfp": "275",
    "countyns": "01383923",
    "dotregion": 6,
    "geoid": "48275",
    "lsad": "06",
    "name": "Knox",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2842,
    "affgeoid": "0500000US48283",
    "aland": 3850511983,
    "awater": 19537502,
    "countyfp": "283",
    "countyns": "01383924",
    "dotregion": 6,
    "geoid": "48283",
    "lsad": "06",
    "name": "La Salle",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1730,
    "affgeoid": "0500000US48277",
    "aland": 2349622228,
    "awater": 67103153,
    "countyfp": "277",
    "countyns": "01383925",
    "dotregion": 6,
    "geoid": "48277",
    "lsad": "06",
    "name": "Lamar",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 651,
    "affgeoid": "0500000US48279",
    "aland": 2631897575,
    "awater": 3973764,
    "countyfp": "279",
    "countyns": "01383926",
    "dotregion": 6,
    "geoid": "48279",
    "lsad": "06",
    "name": "Lamb",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2753,
    "affgeoid": "0500000US48281",
    "aland": 1846249311,
    "awater": 2833490,
    "countyfp": "281",
    "countyns": "01383927",
    "dotregion": 6,
    "geoid": "48281",
    "lsad": "06",
    "name": "Lampasas",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2350,
    "affgeoid": "0500000US48285",
    "aland": 2511535241,
    "awater": 1882216,
    "countyfp": "285",
    "countyns": "01383928",
    "dotregion": 6,
    "geoid": "48285",
    "lsad": "06",
    "name": "Lavaca",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2443,
    "affgeoid": "0500000US48287",
    "aland": 1629156479,
    "awater": 13155033,
    "countyfp": "287",
    "countyns": "01383929",
    "dotregion": 6,
    "geoid": "48287",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 961,
    "affgeoid": "0500000US48289",
    "aland": 2779463148,
    "awater": 19328383,
    "countyfp": "289",
    "countyns": "01383930",
    "dotregion": 6,
    "geoid": "48289",
    "lsad": "06",
    "name": "Leon",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2433,
    "affgeoid": "0500000US48291",
    "aland": 3000360928,
    "awater": 46356323,
    "countyfp": "291",
    "countyns": "01383931",
    "dotregion": 6,
    "geoid": "48291",
    "lsad": "06",
    "name": "Liberty",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 805,
    "affgeoid": "0500000US48293",
    "aland": 2344685543,
    "awater": 72197849,
    "countyfp": "293",
    "countyns": "01383932",
    "dotregion": 6,
    "geoid": "48293",
    "lsad": "06",
    "name": "Limestone",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1478,
    "affgeoid": "0500000US48295",
    "aland": 2414327232,
    "awater": 298741,
    "countyfp": "295",
    "countyns": "01383933",
    "dotregion": 6,
    "geoid": "48295",
    "lsad": "06",
    "name": "Lipscomb",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3083,
    "affgeoid": "0500000US48297",
    "aland": 2692796907,
    "awater": 101483817,
    "countyfp": "297",
    "countyns": "01383934",
    "dotregion": 6,
    "geoid": "48297",
    "lsad": "06",
    "name": "Live Oak",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2345,
    "affgeoid": "0500000US48299",
    "aland": 2419183503,
    "awater": 82373071,
    "countyfp": "299",
    "countyns": "01383935",
    "dotregion": 6,
    "geoid": "48299",
    "lsad": "06",
    "name": "Llano",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1761,
    "affgeoid": "0500000US48301",
    "aland": 1732508024,
    "awater": 20151852,
    "countyfp": "301",
    "countyns": "01383936",
    "dotregion": 6,
    "geoid": "48301",
    "lsad": "06",
    "name": "Loving",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1092,
    "affgeoid": "0500000US48303",
    "aland": 2319585100,
    "awater": 13217278,
    "countyfp": "303",
    "countyns": "01383937",
    "dotregion": 6,
    "geoid": "48303",
    "lsad": "06",
    "name": "Lubbock",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 53,
    "affgeoid": "0500000US48305",
    "aland": 2309924845,
    "awater": 4169719,
    "countyfp": "305",
    "countyns": "01383938",
    "dotregion": 6,
    "geoid": "48305",
    "lsad": "06",
    "name": "Lynn",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 842,
    "affgeoid": "0500000US48313",
    "aland": 1207103466,
    "awater": 16493254,
    "countyfp": "313",
    "countyns": "01383939",
    "dotregion": 6,
    "geoid": "48313",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 543,
    "affgeoid": "0500000US48315",
    "aland": 986503063,
    "awater": 102126745,
    "countyfp": "315",
    "countyns": "01383940",
    "dotregion": 6,
    "geoid": "48315",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2582,
    "affgeoid": "0500000US48317",
    "aland": 2369894740,
    "awater": 1931832,
    "countyfp": "317",
    "countyns": "01383941",
    "dotregion": 6,
    "geoid": "48317",
    "lsad": "06",
    "name": "Martin",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1779,
    "affgeoid": "0500000US48319",
    "aland": 2405590978,
    "awater": 8833381,
    "countyfp": "319",
    "countyns": "01383942",
    "dotregion": 6,
    "geoid": "48319",
    "lsad": "06",
    "name": "Mason",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1953,
    "affgeoid": "0500000US48321",
    "aland": 2830586533,
    "awater": 1345793612,
    "countyfp": "321",
    "countyns": "01383943",
    "dotregion": 6,
    "geoid": "48321",
    "lsad": "06",
    "name": "Matagorda",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2326,
    "affgeoid": "0500000US48323",
    "aland": 3313824009,
    "awater": 31864676,
    "countyfp": "323",
    "countyns": "01383944",
    "dotregion": 6,
    "geoid": "48323",
    "lsad": "06",
    "name": "Maverick",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1108,
    "affgeoid": "0500000US48307",
    "aland": 2759887000,
    "awater": 20284770,
    "countyfp": "307",
    "countyns": "01383945",
    "dotregion": 6,
    "geoid": "48307",
    "lsad": "06",
    "name": "McCulloch",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1897,
    "affgeoid": "0500000US48309",
    "aland": 2686101579,
    "awater": 59883892,
    "countyfp": "309",
    "countyns": "01383946",
    "dotregion": 6,
    "geoid": "48309",
    "lsad": "06",
    "name": "McLennan",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1512,
    "affgeoid": "0500000US48311",
    "aland": 2952084694,
    "awater": 43985815,
    "countyfp": "311",
    "countyns": "01383947",
    "dotregion": 6,
    "geoid": "48311",
    "lsad": "06",
    "name": "McMullen",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1018,
    "affgeoid": "0500000US48325",
    "aland": 3432663606,
    "awater": 23762579,
    "countyfp": "325",
    "countyns": "01383948",
    "dotregion": 6,
    "geoid": "48325",
    "lsad": "06",
    "name": "Medina",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 333,
    "affgeoid": "0500000US48327",
    "aland": 2336245914,
    "awater": 613559,
    "countyfp": "327",
    "countyns": "01383949",
    "dotregion": 6,
    "geoid": "48327",
    "lsad": "06",
    "name": "Menard",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 334,
    "affgeoid": "0500000US48329",
    "aland": 2331648904,
    "awater": 4520751,
    "countyfp": "329",
    "countyns": "01383950",
    "dotregion": 6,
    "geoid": "48329",
    "lsad": "06",
    "name": "Midland",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 843,
    "affgeoid": "0500000US48331",
    "aland": 2633655781,
    "awater": 12720745,
    "countyfp": "331",
    "countyns": "01383951",
    "dotregion": 6,
    "geoid": "48331",
    "lsad": "06",
    "name": "Milam",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3141,
    "affgeoid": "0500000US48333",
    "aland": 1937987420,
    "awater": 3902625,
    "countyfp": "333",
    "countyns": "01383952",
    "dotregion": 6,
    "geoid": "48333",
    "lsad": "06",
    "name": "Mills",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 415,
    "affgeoid": "0500000US48335",
    "aland": 2359711005,
    "awater": 12489774,
    "countyfp": "335",
    "countyns": "01383953",
    "dotregion": 6,
    "geoid": "48335",
    "lsad": "06",
    "name": "Mitchell",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1931,
    "affgeoid": "0500000US48337",
    "aland": 2411034616,
    "awater": 19087361,
    "countyfp": "337",
    "countyns": "01383954",
    "dotregion": 6,
    "geoid": "48337",
    "lsad": "06",
    "name": "Montague",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2626,
    "affgeoid": "0500000US48339",
    "aland": 2698558994,
    "awater": 90549587,
    "countyfp": "339",
    "countyns": "01383955",
    "dotregion": 6,
    "geoid": "48339",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1795,
    "affgeoid": "0500000US48341",
    "aland": 2330188757,
    "awater": 25718180,
    "countyfp": "341",
    "countyns": "01383956",
    "dotregion": 6,
    "geoid": "48341",
    "lsad": "06",
    "name": "Moore",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2616,
    "affgeoid": "0500000US48343",
    "aland": 652637707,
    "awater": 17393790,
    "countyfp": "343",
    "countyns": "01383957",
    "dotregion": 6,
    "geoid": "48343",
    "lsad": "06",
    "name": "Morris",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1037,
    "affgeoid": "0500000US48345",
    "aland": 2562949310,
    "awater": 642801,
    "countyfp": "345",
    "countyns": "01383958",
    "dotregion": 6,
    "geoid": "48345",
    "lsad": "06",
    "name": "Motley",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 99,
    "affgeoid": "0500000US48347",
    "aland": 2451523994,
    "awater": 89758782,
    "countyfp": "347",
    "countyns": "01383959",
    "dotregion": 6,
    "geoid": "48347",
    "lsad": "06",
    "name": "Nacogdoches",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 582,
    "affgeoid": "0500000US48349",
    "aland": 2614935760,
    "awater": 197625966,
    "countyfp": "349",
    "countyns": "01383960",
    "dotregion": 6,
    "geoid": "48349",
    "lsad": "06",
    "name": "Navarro",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2245,
    "affgeoid": "0500000US48351",
    "aland": 2418212545,
    "awater": 15672146,
    "countyfp": "351",
    "countyns": "01383961",
    "dotregion": 6,
    "geoid": "48351",
    "lsad": "06",
    "name": "Newton",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2607,
    "affgeoid": "0500000US48353",
    "aland": 2362061740,
    "awater": 5052158,
    "countyfp": "353",
    "countyns": "01383962",
    "dotregion": 6,
    "geoid": "48353",
    "lsad": "06",
    "name": "Nolan",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2026,
    "affgeoid": "0500000US48355",
    "aland": 2171223719,
    "awater": 847212402,
    "countyfp": "355",
    "countyns": "01383963",
    "dotregion": 6,
    "geoid": "48355",
    "lsad": "06",
    "name": "Nueces",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1800,
    "affgeoid": "0500000US48357",
    "aland": 2376792100,
    "awater": 1331778,
    "countyfp": "357",
    "countyns": "01383964",
    "dotregion": 6,
    "geoid": "48357",
    "lsad": "06",
    "name": "Ochiltree",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 366,
    "affgeoid": "0500000US48359",
    "aland": 3886363536,
    "awater": 2338010,
    "countyfp": "359",
    "countyns": "01383965",
    "dotregion": 6,
    "geoid": "48359",
    "lsad": "06",
    "name": "Oldham",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 29,
    "affgeoid": "0500000US48361",
    "aland": 864487617,
    "awater": 118489888,
    "countyfp": "361",
    "countyns": "01383966",
    "dotregion": 6,
    "geoid": "48361",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 431,
    "affgeoid": "0500000US48363",
    "aland": 2465126936,
    "awater": 87327888,
    "countyfp": "363",
    "countyns": "01383967",
    "dotregion": 6,
    "geoid": "48363",
    "lsad": "06",
    "name": "Palo Pinto",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1054,
    "affgeoid": "0500000US48365",
    "aland": 2101400463,
    "awater": 25810852,
    "countyfp": "365",
    "countyns": "01383968",
    "dotregion": 6,
    "geoid": "48365",
    "lsad": "06",
    "name": "Panola",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 68,
    "affgeoid": "0500000US48367",
    "aland": 2339994800,
    "awater": 17138909,
    "countyfp": "367",
    "countyns": "01383969",
    "dotregion": 6,
    "geoid": "48367",
    "lsad": "06",
    "name": "Parker",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1003,
    "affgeoid": "0500000US48369",
    "aland": 2281212181,
    "awater": 11355762,
    "countyfp": "369",
    "countyns": "01383970",
    "dotregion": 6,
    "geoid": "48369",
    "lsad": "06",
    "name": "Parmer",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1599,
    "affgeoid": "0500000US48371",
    "aland": 12338323514,
    "awater": 2532275,
    "countyfp": "371",
    "countyns": "01383971",
    "dotregion": 6,
    "geoid": "48371",
    "lsad": "06",
    "name": "Pecos",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3077,
    "affgeoid": "0500000US48373",
    "aland": 2737855946,
    "awater": 136148898,
    "countyfp": "373",
    "countyns": "01383972",
    "dotregion": 6,
    "geoid": "48373",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 142,
    "affgeoid": "0500000US48375",
    "aland": 2352680373,
    "awater": 35261526,
    "countyfp": "375",
    "countyns": "01383973",
    "dotregion": 6,
    "geoid": "48375",
    "lsad": "06",
    "name": "Potter",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1022,
    "affgeoid": "0500000US48377",
    "aland": 9985023570,
    "awater": 1773188,
    "countyfp": "377",
    "countyns": "01383974",
    "dotregion": 6,
    "geoid": "48377",
    "lsad": "06",
    "name": "Presidio",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1743,
    "affgeoid": "0500000US48379",
    "aland": 594280566,
    "awater": 76080003,
    "countyfp": "379",
    "countyns": "01383975",
    "dotregion": 6,
    "geoid": "48379",
    "lsad": "06",
    "name": "Rains",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3142,
    "affgeoid": "0500000US48381",
    "aland": 2361843619,
    "awater": 27235707,
    "countyfp": "381",
    "countyns": "01383976",
    "dotregion": 6,
    "geoid": "48381",
    "lsad": "06",
    "name": "Randall",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2846,
    "affgeoid": "0500000US48383",
    "aland": 3044012007,
    "awater": 1792716,
    "countyfp": "383",
    "countyns": "01383977",
    "dotregion": 6,
    "geoid": "48383",
    "lsad": "06",
    "name": "Reagan",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1732,
    "affgeoid": "0500000US48385",
    "aland": 1810772281,
    "awater": 2346258,
    "countyfp": "385",
    "countyns": "01383978",
    "dotregion": 6,
    "geoid": "48385",
    "lsad": "06",
    "name": "Real",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1891,
    "affgeoid": "0500000US48387",
    "aland": 2703628975,
    "awater": 33305608,
    "countyfp": "387",
    "countyns": "01383979",
    "dotregion": 6,
    "geoid": "48387",
    "lsad": "06",
    "name": "Red River",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3095,
    "affgeoid": "0500000US48389",
    "aland": 6825586561,
    "awater": 17396681,
    "countyfp": "389",
    "countyns": "01383980",
    "dotregion": 6,
    "geoid": "48389",
    "lsad": "06",
    "name": "Reeves",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2318,
    "affgeoid": "0500000US48391",
    "aland": 1995524251,
    "awater": 123702955,
    "countyfp": "391",
    "countyns": "01383981",
    "dotregion": 6,
    "geoid": "48391",
    "lsad": "06",
    "name": "Refugio",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2298,
    "affgeoid": "0500000US48393",
    "aland": 2393298484,
    "awater": 346846,
    "countyfp": "393",
    "countyns": "01383982",
    "dotregion": 6,
    "geoid": "48393",
    "lsad": "06",
    "name": "Roberts",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1763,
    "affgeoid": "0500000US48395",
    "aland": 2216227839,
    "awater": 25046151,
    "countyfp": "395",
    "countyns": "01383983",
    "dotregion": 6,
    "geoid": "48395",
    "lsad": "06",
    "name": "Robertson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 264,
    "affgeoid": "0500000US48397",
    "aland": 329204539,
    "awater": 56077414,
    "countyfp": "397",
    "countyns": "01383984",
    "dotregion": 6,
    "geoid": "48397",
    "lsad": "06",
    "name": "Rockwall",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 427,
    "affgeoid": "0500000US48399",
    "aland": 2721934014,
    "awater": 15930084,
    "countyfp": "399",
    "countyns": "01383985",
    "dotregion": 6,
    "geoid": "48399",
    "lsad": "06",
    "name": "Runnels",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2694,
    "affgeoid": "0500000US48401",
    "aland": 2393244478,
    "awater": 37217197,
    "countyfp": "401",
    "countyns": "01383986",
    "dotregion": 6,
    "geoid": "48401",
    "lsad": "06",
    "name": "Rusk",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 587,
    "affgeoid": "0500000US48403",
    "aland": 1272739767,
    "awater": 220725858,
    "countyfp": "403",
    "countyns": "01383987",
    "dotregion": 6,
    "geoid": "48403",
    "lsad": "06",
    "name": "Sabine",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1702,
    "affgeoid": "0500000US48405",
    "aland": 1374395180,
    "awater": 159612923,
    "countyfp": "405",
    "countyns": "01383988",
    "dotregion": 6,
    "geoid": "48405",
    "lsad": "06",
    "name": "San Augustine",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2637,
    "affgeoid": "0500000US48407",
    "aland": 1474332266,
    "awater": 151949239,
    "countyfp": "407",
    "countyns": "01383989",
    "dotregion": 6,
    "geoid": "48407",
    "lsad": "06",
    "name": "San Jacinto",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1150,
    "affgeoid": "0500000US48409",
    "aland": 1795990942,
    "awater": 37577388,
    "countyfp": "409",
    "countyns": "01383990",
    "dotregion": 6,
    "geoid": "48409",
    "lsad": "06",
    "name": "San Patricio",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3039,
    "affgeoid": "0500000US48411",
    "aland": 2940486012,
    "awater": 8072142,
    "countyfp": "411",
    "countyns": "01383991",
    "dotregion": 6,
    "geoid": "48411",
    "lsad": "06",
    "name": "San Saba",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1125,
    "affgeoid": "0500000US48413",
    "aland": 3394564110,
    "awater": 87401,
    "countyfp": "413",
    "countyns": "01383992",
    "dotregion": 6,
    "geoid": "48413",
    "lsad": "06",
    "name": "Schleicher",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 802,
    "affgeoid": "0500000US48415",
    "aland": 2345090493,
    "awater": 5436958,
    "countyfp": "415",
    "countyns": "01383993",
    "dotregion": 6,
    "geoid": "48415",
    "lsad": "06",
    "name": "Scurry",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2852,
    "affgeoid": "0500000US48417",
    "aland": 2367989257,
    "awater": 3268209,
    "countyfp": "417",
    "countyns": "01383994",
    "dotregion": 6,
    "geoid": "48417",
    "lsad": "06",
    "name": "Shackelford",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1221,
    "affgeoid": "0500000US48419",
    "aland": 2060566160,
    "awater": 101081674,
    "countyfp": "419",
    "countyns": "01383995",
    "dotregion": 6,
    "geoid": "48419",
    "lsad": "06",
    "name": "Shelby",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1028,
    "affgeoid": "0500000US48421",
    "aland": 2390648957,
    "awater": 428754,
    "countyfp": "421",
    "countyns": "01383996",
    "dotregion": 6,
    "geoid": "48421",
    "lsad": "06",
    "name": "Sherman",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2798,
    "affgeoid": "0500000US48423",
    "aland": 2386700344,
    "awater": 73067567,
    "countyfp": "423",
    "countyns": "01383997",
    "dotregion": 6,
    "geoid": "48423",
    "lsad": "06",
    "name": "Smith",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 267,
    "affgeoid": "0500000US48425",
    "aland": 482937177,
    "awater": 14222693,
    "countyfp": "425",
    "countyns": "01383998",
    "dotregion": 6,
    "geoid": "48425",
    "lsad": "06",
    "name": "Somervell",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1029,
    "affgeoid": "0500000US48427",
    "aland": 3168016109,
    "awater": 15346370,
    "countyfp": "427",
    "countyns": "01383999",
    "dotregion": 6,
    "geoid": "48427",
    "lsad": "06",
    "name": "Starr",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 355,
    "affgeoid": "0500000US48429",
    "aland": 2322492642,
    "awater": 64132926,
    "countyfp": "429",
    "countyns": "01384000",
    "dotregion": 6,
    "geoid": "48429",
    "lsad": "06",
    "name": "Stephens",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 675,
    "affgeoid": "0500000US48431",
    "aland": 2391739055,
    "awater": 167451,
    "countyfp": "431",
    "countyns": "01384001",
    "dotregion": 6,
    "geoid": "48431",
    "lsad": "06",
    "name": "Sterling",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2603,
    "affgeoid": "0500000US48433",
    "aland": 2373238706,
    "awater": 10177387,
    "countyfp": "433",
    "countyns": "01384002",
    "dotregion": 6,
    "geoid": "48433",
    "lsad": "06",
    "name": "Stonewall",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 227,
    "affgeoid": "0500000US48435",
    "aland": 3765525014,
    "awater": 1277066,
    "countyfp": "435",
    "countyns": "01384003",
    "dotregion": 6,
    "geoid": "48435",
    "lsad": "06",
    "name": "Sutton",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 47,
    "affgeoid": "0500000US48437",
    "aland": 2305502705,
    "awater": 27277987,
    "countyfp": "437",
    "countyns": "01384004",
    "dotregion": 6,
    "geoid": "48437",
    "lsad": "06",
    "name": "Swisher",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2476,
    "affgeoid": "0500000US48439",
    "aland": 2236761455,
    "awater": 100196999,
    "countyfp": "439",
    "countyns": "01384005",
    "dotregion": 6,
    "geoid": "48439",
    "lsad": "06",
    "name": "Tarrant",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1355,
    "affgeoid": "0500000US48441",
    "aland": 2371267399,
    "awater": 9721167,
    "countyfp": "441",
    "countyns": "01384006",
    "dotregion": 6,
    "geoid": "48441",
    "lsad": "06",
    "name": "Taylor",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1055,
    "affgeoid": "0500000US48443",
    "aland": 6107208523,
    "awater": 105866,
    "countyfp": "443",
    "countyns": "01384007",
    "dotregion": 6,
    "geoid": "48443",
    "lsad": "06",
    "name": "Terrell",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 253,
    "affgeoid": "0500000US48445",
    "aland": 2302083227,
    "awater": 5443860,
    "countyfp": "445",
    "countyns": "01384008",
    "dotregion": 6,
    "geoid": "48445",
    "lsad": "06",
    "name": "Terry",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3102,
    "affgeoid": "0500000US48447",
    "aland": 2363499438,
    "awater": 7586186,
    "countyfp": "447",
    "countyns": "01384009",
    "dotregion": 6,
    "geoid": "48447",
    "lsad": "06",
    "name": "Throckmorton",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 461,
    "affgeoid": "0500000US48449",
    "aland": 1051677550,
    "awater": 50735385,
    "countyfp": "449",
    "countyns": "01384010",
    "dotregion": 6,
    "geoid": "48449",
    "lsad": "06",
    "name": "Titus",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3050,
    "affgeoid": "0500000US48451",
    "aland": 3941920273,
    "awater": 48105043,
    "countyfp": "451",
    "countyns": "01384011",
    "dotregion": 6,
    "geoid": "48451",
    "lsad": "06",
    "name": "Tom Green",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1734,
    "affgeoid": "0500000US48453",
    "aland": 2568577738,
    "awater": 81082261,
    "countyfp": "453",
    "countyns": "01384012",
    "dotregion": 6,
    "geoid": "48453",
    "lsad": "06",
    "name": "Travis",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2475,
    "affgeoid": "0500000US48455",
    "aland": 1796490532,
    "awater": 52677462,
    "countyfp": "455",
    "countyns": "01384013",
    "dotregion": 6,
    "geoid": "48455",
    "lsad": "06",
    "name": "Trinity",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2905,
    "affgeoid": "0500000US48457",
    "aland": 2394445965,
    "awater": 28806207,
    "countyfp": "457",
    "countyns": "01384014",
    "dotregion": 6,
    "geoid": "48457",
    "lsad": "06",
    "name": "Tyler",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2792,
    "affgeoid": "0500000US48459",
    "aland": 1509791536,
    "awater": 24997461,
    "countyfp": "459",
    "countyns": "01384015",
    "dotregion": 6,
    "geoid": "48459",
    "lsad": "06",
    "name": "Upshur",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1613,
    "affgeoid": "0500000US48461",
    "aland": 3215009899,
    "awater": 464309,
    "countyfp": "461",
    "countyns": "01384016",
    "dotregion": 6,
    "geoid": "48461",
    "lsad": "06",
    "name": "Upton",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1606,
    "affgeoid": "0500000US48463",
    "aland": 4019519389,
    "awater": 17321923,
    "countyfp": "463",
    "countyns": "01384017",
    "dotregion": 6,
    "geoid": "48463",
    "lsad": "06",
    "name": "Uvalde",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2387,
    "affgeoid": "0500000US48465",
    "aland": 8144863832,
    "awater": 227711349,
    "countyfp": "465",
    "countyns": "01384018",
    "dotregion": 6,
    "geoid": "48465",
    "lsad": "06",
    "name": "Val Verde",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1625,
    "affgeoid": "0500000US48467",
    "aland": 2182215964,
    "awater": 44161895,
    "countyfp": "467",
    "countyns": "01384019",
    "dotregion": 6,
    "geoid": "48467",
    "lsad": "06",
    "name": "Van Zandt",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2122,
    "affgeoid": "0500000US48469",
    "aland": 2284737171,
    "awater": 17334133,
    "countyfp": "469",
    "countyns": "01384020",
    "dotregion": 6,
    "geoid": "48469",
    "lsad": "06",
    "name": "Victoria",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1321,
    "affgeoid": "0500000US48471",
    "aland": 2031033544,
    "awater": 44852084,
    "countyfp": "471",
    "countyns": "01384021",
    "dotregion": 6,
    "geoid": "48471",
    "lsad": "06",
    "name": "Walker",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 625,
    "affgeoid": "0500000US48473",
    "aland": 1329535286,
    "awater": 11622560,
    "countyfp": "473",
    "countyns": "01384022",
    "dotregion": 6,
    "geoid": "48473",
    "lsad": "06",
    "name": "Waller",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 336,
    "affgeoid": "0500000US48475",
    "aland": 2164200429,
    "awater": 624206,
    "countyfp": "475",
    "countyns": "01384023",
    "dotregion": 6,
    "geoid": "48475",
    "lsad": "06",
    "name": "Ward",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3075,
    "affgeoid": "0500000US48477",
    "aland": 1564237466,
    "awater": 46089329,
    "countyfp": "477",
    "countyns": "01384024",
    "dotregion": 6,
    "geoid": "48477",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 3066,
    "affgeoid": "0500000US48479",
    "aland": 8706200257,
    "awater": 36536159,
    "countyfp": "479",
    "countyns": "01384025",
    "dotregion": 6,
    "geoid": "48479",
    "lsad": "06",
    "name": "Webb",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1086,
    "affgeoid": "0500000US48481",
    "aland": 2813116863,
    "awater": 21288266,
    "countyfp": "481",
    "countyns": "01384026",
    "dotregion": 6,
    "geoid": "48481",
    "lsad": "06",
    "name": "Wharton",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 429,
    "affgeoid": "0500000US48483",
    "aland": 2368603567,
    "awater": 2481258,
    "countyfp": "483",
    "countyns": "01384027",
    "dotregion": 6,
    "geoid": "48483",
    "lsad": "06",
    "name": "Wheeler",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2827,
    "affgeoid": "0500000US48485",
    "aland": 1625943401,
    "awater": 13820243,
    "countyfp": "485",
    "countyns": "01384028",
    "dotregion": 6,
    "geoid": "48485",
    "lsad": "06",
    "name": "Wichita",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2165,
    "affgeoid": "0500000US48487",
    "aland": 2514474407,
    "awater": 18257915,
    "countyfp": "487",
    "countyns": "01384029",
    "dotregion": 6,
    "geoid": "48487",
    "lsad": "06",
    "name": "Wilbarger",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2749,
    "affgeoid": "0500000US48489",
    "aland": 1529529800,
    "awater": 501714702,
    "countyfp": "489",
    "countyns": "01384030",
    "dotregion": 6,
    "geoid": "48489",
    "lsad": "06",
    "name": "Willacy",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1868,
    "affgeoid": "0500000US48491",
    "aland": 2896454930,
    "awater": 41649745,
    "countyfp": "491",
    "countyns": "01384031",
    "dotregion": 6,
    "geoid": "48491",
    "lsad": "06",
    "name": "Williamson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1747,
    "affgeoid": "0500000US48493",
    "aland": 2081662846,
    "awater": 12111366,
    "countyfp": "493",
    "countyns": "01384032",
    "dotregion": 6,
    "geoid": "48493",
    "lsad": "06",
    "name": "Wilson",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 373,
    "affgeoid": "0500000US48495",
    "aland": 2178493584,
    "awater": 414369,
    "countyfp": "495",
    "countyns": "01384033",
    "dotregion": 6,
    "geoid": "48495",
    "lsad": "06",
    "name": "Winkler",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1614,
    "affgeoid": "0500000US48497",
    "aland": 2342376357,
    "awater": 47038988,
    "countyfp": "497",
    "countyns": "01384034",
    "dotregion": 6,
    "geoid": "48497",
    "lsad": "06",
    "name": "Wise",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 1384,
    "affgeoid": "0500000US48499",
    "aland": 1671154357,
    "awater": 130748986,
    "countyfp": "499",
    "countyns": "01384035",
    "dotregion": 6,
    "geoid": "48499",
    "lsad": "06",
    "name": "Wood",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2264,
    "affgeoid": "0500000US48501",
    "aland": 2071235519,
    "awater": 34329,
    "countyfp": "501",
    "countyns": "01384036",
    "dotregion": 6,
    "geoid": "48501",
    "lsad": "06",
    "name": "Yoakum",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2325,
    "affgeoid": "0500000US48503",
    "aland": 2368463888,
    "awater": 42447708,
    "countyfp": "503",
    "countyns": "01384037",
    "dotregion": 6,
    "geoid": "48503",
    "lsad": "06",
    "name": "Young",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2906,
    "affgeoid": "0500000US48505",
    "aland": 2585876159,
    "awater": 154370982,
    "countyfp": "505",
    "countyns": "01384038",
    "dotregion": 6,
    "geoid": "48505",
    "lsad": "06",
    "name": "Zapata",
    "stateAbbreviation": "TX",
    "stateId": 1
  }, {
    "id": 2368,
    "affgeoid": "0500000US48507",
    "aland": 3360268387,
    "awater": 11209416,
    "countyfp": "507",
    "countyns": "01384039",
    "dotregion": 6,
    "geoid": "48507",
    "lsad": "06",
    "name": "Zavala",
    "stateAbbreviation": "TX",
    "stateId": 1
  }]
}, {
  "id": 56,
  "abbreviation": "VI",
  "dotregion": 2,
  "geoid": "78",
  "name": "United States Virgin Islands",
  "stateAbbreviation": "VI",
  "statefp": "78",
  "counties": [{
    "id": 3226,
    "countyfp": "010",
    "countyns": "02378248",
    "dotregion": 2,
    "geoid": "78010",
    "name": "St. Croix",
    "stateAbbreviation": "VI",
    "stateId": 56
  }, {
    "id": 3227,
    "countyfp": "020",
    "countyns": "02378249",
    "dotregion": 2,
    "geoid": "78020",
    "name": "St. John",
    "stateAbbreviation": "VI",
    "stateId": 56
  }, {
    "id": 3221,
    "countyfp": "030",
    "countyns": "02378250",
    "dotregion": 2,
    "geoid": "78030",
    "name": "St. Thomas",
    "stateAbbreviation": "VI",
    "stateId": 56
  }]
}, {
  "id": 28,
  "abbreviation": "UT",
  "affgeoid": "0400000US49",
  "aland": 212885012434,
  "awater": 6999936465,
  "dotregion": 8,
  "geoid": "49",
  "lsad": "00",
  "name": "Utah",
  "stateAbbreviation": "UT",
  "statefp": "49",
  "statens": "01455989",
  "counties": [{
    "id": 1493,
    "affgeoid": "0500000US49001",
    "aland": 6689371467,
    "awater": 5298466,
    "countyfp": "001",
    "countyns": "01448015",
    "dotregion": 8,
    "geoid": "49001",
    "lsad": "06",
    "name": "Beaver",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2303,
    "affgeoid": "0500000US49003",
    "aland": 14880833504,
    "awater": 2547784400,
    "countyfp": "003",
    "countyns": "01455966",
    "dotregion": 8,
    "geoid": "49003",
    "lsad": "06",
    "name": "Box Elder",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2108,
    "affgeoid": "0500000US49005",
    "aland": 3016617785,
    "awater": 21153919,
    "countyfp": "005",
    "countyns": "01448017",
    "dotregion": 8,
    "geoid": "49005",
    "lsad": "06",
    "name": "Cache",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1233,
    "affgeoid": "0500000US49007",
    "aland": 3830974536,
    "awater": 15891973,
    "countyfp": "007",
    "countyns": "01448018",
    "dotregion": 8,
    "geoid": "49007",
    "lsad": "06",
    "name": "Carbon",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 387,
    "affgeoid": "0500000US49009",
    "aland": 1804943545,
    "awater": 61445336,
    "countyfp": "009",
    "countyns": "01448019",
    "dotregion": 8,
    "geoid": "49009",
    "lsad": "06",
    "name": "Daggett",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2775,
    "affgeoid": "0500000US49011",
    "aland": 774432531,
    "awater": 870761758,
    "countyfp": "011",
    "countyns": "01448020",
    "dotregion": 8,
    "geoid": "49011",
    "lsad": "06",
    "name": "Davis",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2863,
    "affgeoid": "0500000US49013",
    "aland": 8379461042,
    "awater": 38798289,
    "countyfp": "013",
    "countyns": "01448021",
    "dotregion": 8,
    "geoid": "49013",
    "lsad": "06",
    "name": "Duchesne",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1932,
    "affgeoid": "0500000US49015",
    "aland": 11557280470,
    "awater": 24843843,
    "countyfp": "015",
    "countyns": "01448022",
    "dotregion": 8,
    "geoid": "49015",
    "lsad": "06",
    "name": "Emery",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2274,
    "affgeoid": "0500000US49017",
    "aland": 13403500715,
    "awater": 85796666,
    "countyfp": "017",
    "countyns": "01448023",
    "dotregion": 8,
    "geoid": "49017",
    "lsad": "06",
    "name": "Garfield",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1234,
    "affgeoid": "0500000US49019",
    "aland": 9512638635,
    "awater": 31266643,
    "countyfp": "019",
    "countyns": "01448024",
    "dotregion": 8,
    "geoid": "49019",
    "lsad": "06",
    "name": "Grand",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2506,
    "affgeoid": "0500000US49021",
    "aland": 8537573733,
    "awater": 11390956,
    "countyfp": "021",
    "countyns": "01448025",
    "dotregion": 8,
    "geoid": "49021",
    "lsad": "06",
    "name": "Iron",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1933,
    "affgeoid": "0500000US49023",
    "aland": 8784471158,
    "awater": 36542088,
    "countyfp": "023",
    "countyns": "01455158",
    "dotregion": 8,
    "geoid": "49023",
    "lsad": "06",
    "name": "Juab",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2705,
    "affgeoid": "0500000US49025",
    "aland": 10333973705,
    "awater": 306158362,
    "countyfp": "025",
    "countyns": "01448026",
    "dotregion": 8,
    "geoid": "49025",
    "lsad": "06",
    "name": "Kane",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1235,
    "affgeoid": "0500000US49027",
    "aland": 17106720226,
    "awater": 600823890,
    "countyfp": "027",
    "countyns": "01448027",
    "dotregion": 8,
    "geoid": "49027",
    "lsad": "06",
    "name": "Millard",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 3027,
    "affgeoid": "0500000US49029",
    "aland": 1577750990,
    "awater": 4437369,
    "countyfp": "029",
    "countyns": "01448028",
    "dotregion": 8,
    "geoid": "49029",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1780,
    "affgeoid": "0500000US49031",
    "aland": 1964346244,
    "awater": 20285697,
    "countyfp": "031",
    "countyns": "01448029",
    "dotregion": 8,
    "geoid": "49031",
    "lsad": "06",
    "name": "Piute",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 856,
    "affgeoid": "0500000US49033",
    "aland": 2664700973,
    "awater": 149109879,
    "countyfp": "033",
    "countyns": "01448030",
    "dotregion": 8,
    "geoid": "49033",
    "lsad": "06",
    "name": "Rich",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2293,
    "affgeoid": "0500000US49035",
    "aland": 1921958791,
    "awater": 164897207,
    "countyfp": "035",
    "countyns": "01448031",
    "dotregion": 8,
    "geoid": "49035",
    "lsad": "06",
    "name": "Salt Lake",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1966,
    "affgeoid": "0500000US49037",
    "aland": 20253930400,
    "awater": 292840510,
    "countyfp": "037",
    "countyns": "01448032",
    "dotregion": 8,
    "geoid": "49037",
    "lsad": "06",
    "name": "San Juan",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1861,
    "affgeoid": "0500000US49039",
    "aland": 4117768225,
    "awater": 32049371,
    "countyfp": "039",
    "countyns": "01448033",
    "dotregion": 8,
    "geoid": "49039",
    "lsad": "06",
    "name": "Sanpete",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1816,
    "affgeoid": "0500000US49041",
    "aland": 4948102439,
    "awater": 20260738,
    "countyfp": "041",
    "countyns": "01448034",
    "dotregion": 8,
    "geoid": "49041",
    "lsad": "06",
    "name": "Sevier",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2605,
    "affgeoid": "0500000US49043",
    "aland": 4844755736,
    "awater": 26612845,
    "countyfp": "043",
    "countyns": "01448035",
    "dotregion": 8,
    "geoid": "49043",
    "lsad": "06",
    "name": "Summit",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 3006,
    "affgeoid": "0500000US49045",
    "aland": 17979656909,
    "awater": 891043070,
    "countyfp": "045",
    "countyns": "01448036",
    "dotregion": 8,
    "geoid": "49045",
    "lsad": "06",
    "name": "Tooele",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 735,
    "affgeoid": "0500000US49047",
    "aland": 11609285613,
    "awater": 56154091,
    "countyfp": "047",
    "countyns": "01448037",
    "dotregion": 8,
    "geoid": "49047",
    "lsad": "06",
    "name": "Uintah",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1019,
    "affgeoid": "0500000US49049",
    "aland": 5189230995,
    "awater": 364305802,
    "countyfp": "049",
    "countyns": "01448038",
    "dotregion": 8,
    "geoid": "49049",
    "lsad": "06",
    "name": "Utah",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1955,
    "affgeoid": "0500000US49051",
    "aland": 3048429878,
    "awater": 79148299,
    "countyfp": "051",
    "countyns": "01448039",
    "dotregion": 8,
    "geoid": "49051",
    "lsad": "06",
    "name": "Wasatch",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 2996,
    "affgeoid": "0500000US49053",
    "aland": 6285672118,
    "awater": 9134289,
    "countyfp": "053",
    "countyns": "01448040",
    "dotregion": 8,
    "geoid": "49053",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1170,
    "affgeoid": "0500000US49055",
    "aland": 6374186210,
    "awater": 15154124,
    "countyfp": "055",
    "countyns": "01448041",
    "dotregion": 8,
    "geoid": "49055",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "UT",
    "stateId": 28
  }, {
    "id": 1461,
    "affgeoid": "0500000US49057",
    "aland": 1492443861,
    "awater": 216546585,
    "countyfp": "057",
    "countyns": "01448042",
    "dotregion": 8,
    "geoid": "49057",
    "lsad": "06",
    "name": "Weber",
    "stateAbbreviation": "UT",
    "stateId": 28
  }]
}, {
  "id": 49,
  "abbreviation": "VT",
  "affgeoid": "0400000US50",
  "aland": 23872224593,
  "awater": 1034382802,
  "dotregion": 1,
  "geoid": "50",
  "lsad": "00",
  "name": "Vermont",
  "stateAbbreviation": "VT",
  "statefp": "50",
  "statens": "01779802",
  "counties": [{
    "id": 1172,
    "affgeoid": "0500000US50001",
    "aland": 1984779894,
    "awater": 107303299,
    "countyfp": "001",
    "countyns": "01461757",
    "dotregion": 1,
    "geoid": "50001",
    "lsad": "06",
    "name": "Addison",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 790,
    "affgeoid": "0500000US50003",
    "aland": 1748198169,
    "awater": 6926826,
    "countyfp": "003",
    "countyns": "01461758",
    "dotregion": 1,
    "geoid": "50003",
    "lsad": "06",
    "name": "Bennington",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 1257,
    "affgeoid": "0500000US50005",
    "aland": 1680879242,
    "awater": 22456093,
    "countyfp": "005",
    "countyns": "01461759",
    "dotregion": 1,
    "geoid": "50005",
    "lsad": "06",
    "name": "Caledonia",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 1282,
    "affgeoid": "0500000US50007",
    "aland": 1389740227,
    "awater": 214237435,
    "countyfp": "007",
    "countyns": "01461760",
    "dotregion": 1,
    "geoid": "50007",
    "lsad": "06",
    "name": "Chittenden",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 1197,
    "affgeoid": "0500000US50009",
    "aland": 1718707340,
    "awater": 30285614,
    "countyfp": "009",
    "countyns": "01461761",
    "dotregion": 1,
    "geoid": "50009",
    "lsad": "06",
    "name": "Essex",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 3210,
    "affgeoid": "0500000US50011",
    "aland": 1641633750,
    "awater": 150930318,
    "countyfp": "011",
    "countyns": "01461762",
    "dotregion": 1,
    "geoid": "50011",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 4,
    "affgeoid": "0500000US50013",
    "aland": 211894597,
    "awater": 292303559,
    "countyfp": "013",
    "countyns": "01461763",
    "dotregion": 1,
    "geoid": "50013",
    "lsad": "06",
    "name": "Grand Isle",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 3001,
    "affgeoid": "0500000US50015",
    "aland": 1188473311,
    "awater": 12658077,
    "countyfp": "015",
    "countyns": "01461764",
    "dotregion": 1,
    "geoid": "50015",
    "lsad": "06",
    "name": "Lamoille",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 2831,
    "affgeoid": "0500000US50017",
    "aland": 1779409624,
    "awater": 13549371,
    "countyfp": "017",
    "countyns": "01461765",
    "dotregion": 1,
    "geoid": "50017",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 2027,
    "affgeoid": "0500000US50019",
    "aland": 1796376593,
    "awater": 71442197,
    "countyfp": "019",
    "countyns": "01461766",
    "dotregion": 1,
    "geoid": "50019",
    "lsad": "06",
    "name": "Orleans",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 2935,
    "affgeoid": "0500000US50021",
    "aland": 2408211831,
    "awater": 38758591,
    "countyfp": "021",
    "countyns": "01461767",
    "dotregion": 1,
    "geoid": "50021",
    "lsad": "06",
    "name": "Rutland",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 3203,
    "affgeoid": "0500000US50023",
    "aland": 1779419614,
    "awater": 21187618,
    "countyfp": "023",
    "countyns": "01461768",
    "dotregion": 1,
    "geoid": "50023",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 642,
    "affgeoid": "0500000US50025",
    "aland": 2033922469,
    "awater": 33064491,
    "countyfp": "025",
    "countyns": "01461769",
    "dotregion": 1,
    "geoid": "50025",
    "lsad": "06",
    "name": "Windham",
    "stateAbbreviation": "VT",
    "stateId": 49
  }, {
    "id": 2594,
    "affgeoid": "0500000US50027",
    "aland": 2510577932,
    "awater": 19279313,
    "countyfp": "027",
    "countyns": "01461770",
    "dotregion": 1,
    "geoid": "50027",
    "lsad": "06",
    "name": "Windsor",
    "stateAbbreviation": "VT",
    "stateId": 49
  }]
}, {
  "id": 7,
  "abbreviation": "VA",
  "affgeoid": "0400000US51",
  "aland": 102282988386,
  "awater": 8503553482,
  "dotregion": 3,
  "geoid": "51",
  "lsad": "00",
  "name": "Virginia",
  "stateAbbreviation": "VA",
  "statefp": "51",
  "statens": "01779803",
  "counties": [{
    "id": 3087,
    "affgeoid": "0500000US51001",
    "aland": 1164222686,
    "awater": 2228759089,
    "countyfp": "001",
    "countyns": "01480091",
    "dotregion": 3,
    "geoid": "51001",
    "lsad": "06",
    "name": "Accomack",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2354,
    "affgeoid": "0500000US51003",
    "aland": 1866869127,
    "awater": 14032748,
    "countyfp": "003",
    "countyns": "01675170",
    "dotregion": 3,
    "geoid": "51003",
    "lsad": "06",
    "name": "Albemarle",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1594,
    "affgeoid": "0500000US51510",
    "aland": 38977689,
    "awater": 1127171,
    "countyfp": "510",
    "countyns": "01498415",
    "dotregion": 3,
    "geoid": "51510",
    "lsad": "25",
    "name": "Alexandria",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2248,
    "affgeoid": "0500000US51005",
    "aland": 1153734179,
    "awater": 8510738,
    "countyfp": "005",
    "countyns": "01673675",
    "dotregion": 3,
    "geoid": "51005",
    "lsad": "06",
    "name": "Alleghany",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 924,
    "affgeoid": "0500000US51007",
    "aland": 920142764,
    "awater": 8424800,
    "countyfp": "007",
    "countyns": "01497770",
    "dotregion": 3,
    "geoid": "51007",
    "lsad": "06",
    "name": "Amelia",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3074,
    "affgeoid": "0500000US51009",
    "aland": 1227484902,
    "awater": 12729826,
    "countyfp": "009",
    "countyns": "01480095",
    "dotregion": 3,
    "geoid": "51009",
    "lsad": "06",
    "name": "Amherst",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1496,
    "affgeoid": "0500000US51011",
    "aland": 863689281,
    "awater": 3204692,
    "countyfp": "011",
    "countyns": "01497238",
    "dotregion": 3,
    "geoid": "51011",
    "lsad": "06",
    "name": "Appomattox",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1636,
    "affgeoid": "0500000US51013",
    "aland": 67318428,
    "awater": 244142,
    "countyfp": "013",
    "countyns": "01480097",
    "dotregion": 3,
    "geoid": "51013",
    "lsad": "06",
    "name": "Arlington",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1069,
    "affgeoid": "0500000US51015",
    "aland": 2504602442,
    "awater": 9972877,
    "countyfp": "015",
    "countyns": "01480098",
    "dotregion": 3,
    "geoid": "51015",
    "lsad": "06",
    "name": "Augusta",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2341,
    "affgeoid": "0500000US51017",
    "aland": 1370514973,
    "awater": 14044111,
    "countyfp": "017",
    "countyns": "01673638",
    "dotregion": 3,
    "geoid": "51017",
    "lsad": "06",
    "name": "Bath",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2674,
    "affgeoid": "0500000US51019",
    "aland": 1968133960,
    "awater": 42100195,
    "countyfp": "019",
    "countyns": "01674818",
    "dotregion": 3,
    "geoid": "51019",
    "lsad": "06",
    "name": "Bedford",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 397,
    "affgeoid": "0500000US51021",
    "aland": 926515823,
    "awater": 2585515,
    "countyfp": "021",
    "countyns": "01494613",
    "dotregion": 3,
    "geoid": "51021",
    "lsad": "06",
    "name": "Bland",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 715,
    "affgeoid": "0500000US51023",
    "aland": 1401713911,
    "awater": 12188503,
    "countyfp": "023",
    "countyns": "01674418",
    "dotregion": 3,
    "geoid": "51023",
    "lsad": "06",
    "name": "Botetourt",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 488,
    "affgeoid": "0500000US51520",
    "aland": 33745565,
    "awater": 322409,
    "countyfp": "520",
    "countyns": "01498416",
    "dotregion": 3,
    "geoid": "51520",
    "lsad": "25",
    "name": "Bristol",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2314,
    "affgeoid": "0500000US51025",
    "aland": 1466384563,
    "awater": 8314712,
    "countyfp": "025",
    "countyns": "01493961",
    "dotregion": 3,
    "geoid": "51025",
    "lsad": "06",
    "name": "Brunswick",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1658,
    "affgeoid": "0500000US51027",
    "aland": 1302149875,
    "awater": 2797157,
    "countyfp": "027",
    "countyns": "01497431",
    "dotregion": 3,
    "geoid": "51027",
    "lsad": "06",
    "name": "Buchanan",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2412,
    "affgeoid": "0500000US51029",
    "aland": 1501303548,
    "awater": 10099804,
    "countyfp": "029",
    "countyns": "01501502",
    "dotregion": 3,
    "geoid": "51029",
    "lsad": "06",
    "name": "Buckingham",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1498,
    "affgeoid": "0500000US51530",
    "aland": 17350500,
    "awater": 222803,
    "countyfp": "530",
    "countyns": "01498417",
    "dotregion": 3,
    "geoid": "51530",
    "lsad": "25",
    "name": "Buena Vista",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2595,
    "affgeoid": "0500000US51031",
    "aland": 1305049383,
    "awater": 9002937,
    "countyfp": "031",
    "countyns": "01674917",
    "dotregion": 3,
    "geoid": "51031",
    "lsad": "06",
    "name": "Campbell",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3140,
    "affgeoid": "0500000US51033",
    "aland": 1366270763,
    "awater": 24228168,
    "countyfp": "033",
    "countyns": "01480107",
    "dotregion": 3,
    "geoid": "51033",
    "lsad": "06",
    "name": "Caroline",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 927,
    "affgeoid": "0500000US51035",
    "aland": 1229441999,
    "awater": 7647531,
    "countyfp": "035",
    "countyns": "01480108",
    "dotregion": 3,
    "geoid": "51035",
    "lsad": "06",
    "name": "Carroll",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 90,
    "affgeoid": "0500000US51036",
    "aland": 473493984,
    "awater": 55490600,
    "countyfp": "036",
    "countyns": "01480109",
    "dotregion": 3,
    "geoid": "51036",
    "lsad": "06",
    "name": "Charles City",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1879,
    "affgeoid": "0500000US51037",
    "aland": 1231001549,
    "awater": 5824992,
    "countyfp": "037",
    "countyns": "01492442",
    "dotregion": 3,
    "geoid": "51037",
    "lsad": "06",
    "name": "Charlotte",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1495,
    "affgeoid": "0500000US51540",
    "aland": 26516183,
    "awater": 52974,
    "countyfp": "540",
    "countyns": "01789068",
    "dotregion": 3,
    "geoid": "51540",
    "lsad": "25",
    "name": "Charlottesville",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2069,
    "affgeoid": "0500000US51550",
    "aland": 882668771,
    "awater": 26057053,
    "countyfp": "550",
    "countyns": "01498558",
    "dotregion": 3,
    "geoid": "51550",
    "lsad": "25",
    "name": "Chesapeake",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2628,
    "affgeoid": "0500000US51041",
    "aland": 1096531675,
    "awater": 35172847,
    "countyfp": "041",
    "countyns": "01480111",
    "dotregion": 3,
    "geoid": "51041",
    "lsad": "06",
    "name": "Chesterfield",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3197,
    "affgeoid": "0500000US51043",
    "aland": 455565957,
    "awater": 5649744,
    "countyfp": "043",
    "countyns": "01690562",
    "dotregion": 3,
    "geoid": "51043",
    "lsad": "06",
    "name": "Clarke",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2272,
    "affgeoid": "0500000US51570",
    "aland": 19481043,
    "awater": 757290,
    "countyfp": "570",
    "countyns": "01498420",
    "dotregion": 3,
    "geoid": "51570",
    "lsad": "25",
    "name": "Colonial Heights",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1729,
    "affgeoid": "0500000US51580",
    "aland": 14163308,
    "awater": 522024,
    "countyfp": "580",
    "countyns": "01789069",
    "dotregion": 3,
    "geoid": "51580",
    "lsad": "25",
    "name": "Covington",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2824,
    "affgeoid": "0500000US51045",
    "aland": 853490643,
    "awater": 2797724,
    "countyfp": "045",
    "countyns": "01673664",
    "dotregion": 3,
    "geoid": "51045",
    "lsad": "06",
    "name": "Craig",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3017,
    "affgeoid": "0500000US51047",
    "aland": 982232458,
    "awater": 8550409,
    "countyfp": "047",
    "countyns": "01497831",
    "dotregion": 3,
    "geoid": "51047",
    "lsad": "06",
    "name": "Culpeper",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1995,
    "affgeoid": "0500000US51049",
    "aland": 770419327,
    "awater": 5931686,
    "countyfp": "049",
    "countyns": "01494109",
    "dotregion": 3,
    "geoid": "51049",
    "lsad": "06",
    "name": "Cumberland",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1773,
    "affgeoid": "0500000US51590",
    "aland": 111287882,
    "awater": 2538056,
    "countyfp": "590",
    "countyns": "01498421",
    "dotregion": 3,
    "geoid": "51590",
    "lsad": "25",
    "name": "Danville",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 135,
    "affgeoid": "0500000US51051",
    "aland": 856108125,
    "awater": 8073687,
    "countyfp": "051",
    "countyns": "01497376",
    "dotregion": 3,
    "geoid": "51051",
    "lsad": "06",
    "name": "Dickenson",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1796,
    "affgeoid": "0500000US51053",
    "aland": 1304626416,
    "awater": 8999965,
    "countyfp": "053",
    "countyns": "01690739",
    "dotregion": 3,
    "geoid": "51053",
    "lsad": "06",
    "name": "Dinwiddie",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 377,
    "affgeoid": "0500000US51595",
    "aland": 17871525,
    "awater": 165621,
    "countyfp": "595",
    "countyns": "01498422",
    "dotregion": 3,
    "geoid": "51595",
    "lsad": "25",
    "name": "Emporia",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 945,
    "affgeoid": "0500000US51057",
    "aland": 665858937,
    "awater": 74793668,
    "countyfp": "057",
    "countyns": "01480118",
    "dotregion": 3,
    "geoid": "51057",
    "lsad": "06",
    "name": "Essex",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2017,
    "affgeoid": "0500000US51059",
    "aland": 1012303733,
    "awater": 39435616,
    "countyfp": "059",
    "countyns": "01480119",
    "dotregion": 3,
    "geoid": "51059",
    "lsad": "06",
    "name": "Fairfax",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2288,
    "affgeoid": "0500000US51600",
    "aland": 16162121,
    "awater": 90056,
    "countyfp": "600",
    "countyns": "01789070",
    "dotregion": 3,
    "geoid": "51600",
    "lsad": "25",
    "name": "Fairfax",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2771,
    "affgeoid": "0500000US51610",
    "aland": 5311307,
    "awater": 6,
    "countyfp": "610",
    "countyns": "01498423",
    "dotregion": 3,
    "geoid": "51610",
    "lsad": "25",
    "name": "Falls Church",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1297,
    "affgeoid": "0500000US51061",
    "aland": 1677403404,
    "awater": 9775559,
    "countyfp": "061",
    "countyns": "01480120",
    "dotregion": 3,
    "geoid": "51061",
    "lsad": "06",
    "name": "Fauquier",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 769,
    "affgeoid": "0500000US51063",
    "aland": 986590282,
    "awater": 2270014,
    "countyfp": "063",
    "countyns": "01494354",
    "dotregion": 3,
    "geoid": "51063",
    "lsad": "06",
    "name": "Floyd",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1723,
    "affgeoid": "0500000US51065",
    "aland": 740762872,
    "awater": 10718670,
    "countyfp": "065",
    "countyns": "01494061",
    "dotregion": 3,
    "geoid": "51065",
    "lsad": "06",
    "name": "Fluvanna",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1284,
    "affgeoid": "0500000US51067",
    "aland": 1788231299,
    "awater": 54670666,
    "countyfp": "067",
    "countyns": "01494434",
    "dotregion": 3,
    "geoid": "51067",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2201,
    "affgeoid": "0500000US51620",
    "aland": 21295862,
    "awater": 369820,
    "countyfp": "620",
    "countyns": "01498424",
    "dotregion": 3,
    "geoid": "51620",
    "lsad": "25",
    "name": "Franklin",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2951,
    "affgeoid": "0500000US51069",
    "aland": 1070958657,
    "awater": 5194171,
    "countyfp": "069",
    "countyns": "01480124",
    "dotregion": 3,
    "geoid": "51069",
    "lsad": "06",
    "name": "Frederick",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 183,
    "affgeoid": "0500000US51630",
    "aland": 27042222,
    "awater": 178255,
    "countyfp": "630",
    "countyns": "01498425",
    "dotregion": 3,
    "geoid": "51630",
    "lsad": "25",
    "name": "Fredericksburg",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 96,
    "affgeoid": "0500000US51640",
    "aland": 21340444,
    "awater": 103782,
    "countyfp": "640",
    "countyns": "01498426",
    "dotregion": 3,
    "geoid": "51640",
    "lsad": "25",
    "name": "Galax",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1097,
    "affgeoid": "0500000US51071",
    "aland": 921560258,
    "awater": 11925828,
    "countyfp": "071",
    "countyns": "01494551",
    "dotregion": 3,
    "geoid": "51071",
    "lsad": "06",
    "name": "Giles",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 248,
    "affgeoid": "0500000US51073",
    "aland": 564116916,
    "awater": 181754412,
    "countyfp": "073",
    "countyns": "01480126",
    "dotregion": 3,
    "geoid": "51073",
    "lsad": "06",
    "name": "Gloucester",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3004,
    "affgeoid": "0500000US51075",
    "aland": 728886866,
    "awater": 21963100,
    "countyfp": "075",
    "countyns": "01674271",
    "dotregion": 3,
    "geoid": "51075",
    "lsad": "06",
    "name": "Goochland",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 957,
    "affgeoid": "0500000US51077",
    "aland": 1145220897,
    "awater": 9797891,
    "countyfp": "077",
    "countyns": "01501196",
    "dotregion": 3,
    "geoid": "51077",
    "lsad": "06",
    "name": "Grayson",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 12,
    "affgeoid": "0500000US51079",
    "aland": 404411500,
    "awater": 1706090,
    "countyfp": "079",
    "countyns": "01480129",
    "dotregion": 3,
    "geoid": "51079",
    "lsad": "06",
    "name": "Greene",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 349,
    "affgeoid": "0500000US51081",
    "aland": 764649954,
    "awater": 4086108,
    "countyfp": "081",
    "countyns": "01501122",
    "dotregion": 3,
    "geoid": "51081",
    "lsad": "06",
    "name": "Greensville",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2622,
    "affgeoid": "0500000US51083",
    "aland": 2118209785,
    "awater": 30531356,
    "countyfp": "083",
    "countyns": "01496705",
    "dotregion": 3,
    "geoid": "51083",
    "lsad": "06",
    "name": "Halifax",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1298,
    "affgeoid": "0500000US51650",
    "aland": 133308914,
    "awater": 219683212,
    "countyfp": "650",
    "countyns": "01498554",
    "dotregion": 3,
    "geoid": "51650",
    "lsad": "25",
    "name": "Hampton",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2317,
    "affgeoid": "0500000US51085",
    "aland": 1213582999,
    "awater": 13568383,
    "countyfp": "085",
    "countyns": "01480132",
    "dotregion": 3,
    "geoid": "51085",
    "lsad": "06",
    "name": "Hanover",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1205,
    "affgeoid": "0500000US51660",
    "aland": 44889777,
    "awater": 149942,
    "countyfp": "660",
    "countyns": "01498563",
    "dotregion": 3,
    "geoid": "51660",
    "lsad": "25",
    "name": "Harrisonburg",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2041,
    "affgeoid": "0500000US51087",
    "aland": 605287712,
    "awater": 28969984,
    "countyfp": "087",
    "countyns": "01480133",
    "dotregion": 3,
    "geoid": "51087",
    "lsad": "06",
    "name": "Henrico",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 734,
    "affgeoid": "0500000US51089",
    "aland": 990258085,
    "awater": 5281696,
    "countyfp": "089",
    "countyns": "01502770",
    "dotregion": 3,
    "geoid": "51089",
    "lsad": "06",
    "name": "Henry",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2437,
    "affgeoid": "0500000US51091",
    "aland": 1075249033,
    "awater": 1805613,
    "countyfp": "091",
    "countyns": "01673774",
    "dotregion": 3,
    "geoid": "51091",
    "lsad": "06",
    "name": "Highland",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2202,
    "affgeoid": "0500000US51670",
    "aland": 26655077,
    "awater": 1324078,
    "countyfp": "670",
    "countyns": "01498428",
    "dotregion": 3,
    "geoid": "51670",
    "lsad": "25",
    "name": "Hopewell",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3126,
    "affgeoid": "0500000US51093",
    "aland": 817464437,
    "awater": 122256199,
    "countyfp": "093",
    "countyns": "01702378",
    "dotregion": 3,
    "geoid": "51093",
    "lsad": "06",
    "name": "Isle of Wight",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1976,
    "affgeoid": "0500000US51095",
    "aland": 368966992,
    "awater": 95299777,
    "countyfp": "095",
    "countyns": "01480135",
    "dotregion": 3,
    "geoid": "51095",
    "lsad": "06",
    "name": "James City",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 858,
    "affgeoid": "0500000US51099",
    "aland": 465260573,
    "awater": 21031824,
    "countyfp": "099",
    "countyns": "01480137",
    "dotregion": 3,
    "geoid": "51099",
    "lsad": "06",
    "name": "King George",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 39,
    "affgeoid": "0500000US51101",
    "aland": 709504125,
    "awater": 30286031,
    "countyfp": "101",
    "countyns": "01480138",
    "dotregion": 3,
    "geoid": "51101",
    "lsad": "06",
    "name": "King William",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1858,
    "affgeoid": "0500000US51097",
    "aland": 816287771,
    "awater": 28874439,
    "countyfp": "097",
    "countyns": "01480136",
    "dotregion": 3,
    "geoid": "51097",
    "lsad": "06",
    "name": "King and Queen",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2807,
    "affgeoid": "0500000US51103",
    "aland": 345223678,
    "awater": 254112331,
    "countyfp": "103",
    "countyns": "01480139",
    "dotregion": 3,
    "geoid": "51103",
    "lsad": "06",
    "name": "Lancaster",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2162,
    "affgeoid": "0500000US51105",
    "aland": 1127988664,
    "awater": 4896425,
    "countyfp": "105",
    "countyns": "01496538",
    "dotregion": 3,
    "geoid": "51105",
    "lsad": "06",
    "name": "Lee",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1739,
    "affgeoid": "0500000US51678",
    "aland": 6467874,
    "awater": 68429,
    "countyfp": "678",
    "countyns": "01789071",
    "dotregion": 3,
    "geoid": "51678",
    "lsad": "25",
    "name": "Lexington",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 857,
    "affgeoid": "0500000US51107",
    "aland": 1335804259,
    "awater": 14448944,
    "countyfp": "107",
    "countyns": "01480141",
    "dotregion": 3,
    "geoid": "51107",
    "lsad": "06",
    "name": "Loudoun",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 58,
    "affgeoid": "0500000US51109",
    "aland": 1285413687,
    "awater": 37737584,
    "countyfp": "109",
    "countyns": "01494707",
    "dotregion": 3,
    "geoid": "51109",
    "lsad": "06",
    "name": "Louisa",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2723,
    "affgeoid": "0500000US51111",
    "aland": 1118063299,
    "awater": 1795027,
    "countyfp": "111",
    "countyns": "01492239",
    "dotregion": 3,
    "geoid": "51111",
    "lsad": "06",
    "name": "Lunenburg",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 383,
    "affgeoid": "0500000US51680",
    "aland": 127241541,
    "awater": 1343203,
    "countyfp": "680",
    "countyns": "01498429",
    "dotregion": 3,
    "geoid": "51680",
    "lsad": "25",
    "name": "Lynchburg",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1516,
    "affgeoid": "0500000US51113",
    "aland": 830565358,
    "awater": 3085774,
    "countyfp": "113",
    "countyns": "01494590",
    "dotregion": 3,
    "geoid": "51113",
    "lsad": "06",
    "name": "Madison",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 468,
    "affgeoid": "0500000US51683",
    "aland": 25594690,
    "awater": 134901,
    "countyfp": "683",
    "countyns": "01498430",
    "dotregion": 3,
    "geoid": "51683",
    "lsad": "25",
    "name": "Manassas",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 30,
    "affgeoid": "0500000US51685",
    "aland": 6575876,
    "awater": 956,
    "countyfp": "685",
    "countyns": "01498431",
    "dotregion": 3,
    "geoid": "51685",
    "lsad": "25",
    "name": "Manassas Park",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 674,
    "affgeoid": "0500000US51690",
    "aland": 28376605,
    "awater": 133615,
    "countyfp": "690",
    "countyns": "01789072",
    "dotregion": 3,
    "geoid": "51690",
    "lsad": "25",
    "name": "Martinsville",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1853,
    "affgeoid": "0500000US51115",
    "aland": 222555391,
    "awater": 430023700,
    "countyfp": "115",
    "countyns": "01480145",
    "dotregion": 3,
    "geoid": "51115",
    "lsad": "06",
    "name": "Mathews",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 140,
    "affgeoid": "0500000US51117",
    "aland": 1620003221,
    "awater": 139190905,
    "countyfp": "117",
    "countyns": "01500747",
    "dotregion": 3,
    "geoid": "51117",
    "lsad": "06",
    "name": "Mecklenburg",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1910,
    "affgeoid": "0500000US51119",
    "aland": 337507715,
    "awater": 208357022,
    "countyfp": "119",
    "countyns": "01480147",
    "dotregion": 3,
    "geoid": "51119",
    "lsad": "06",
    "name": "Middlesex",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3138,
    "affgeoid": "0500000US51121",
    "aland": 1001065265,
    "awater": 5807436,
    "countyfp": "121",
    "countyns": "01674630",
    "dotregion": 3,
    "geoid": "51121",
    "lsad": "06",
    "name": "Montgomery",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1224,
    "affgeoid": "0500000US51125",
    "aland": 1219509578,
    "awater": 8935054,
    "countyfp": "125",
    "countyns": "01500936",
    "dotregion": 3,
    "geoid": "51125",
    "lsad": "06",
    "name": "Nelson",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1822,
    "affgeoid": "0500000US51127",
    "aland": 543211673,
    "awater": 35577224,
    "countyfp": "127",
    "countyns": "01480150",
    "dotregion": 3,
    "geoid": "51127",
    "lsad": "06",
    "name": "New Kent",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 545,
    "affgeoid": "0500000US51700",
    "aland": 178332756,
    "awater": 131488033,
    "countyfp": "700",
    "countyns": "01498555",
    "dotregion": 3,
    "geoid": "51700",
    "lsad": "25",
    "name": "Newport News",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 331,
    "affgeoid": "0500000US51710",
    "aland": 140080307,
    "awater": 109452507,
    "countyfp": "710",
    "countyns": "01498557",
    "dotregion": 3,
    "geoid": "51710",
    "lsad": "25",
    "name": "Norfolk",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1716,
    "affgeoid": "0500000US51131",
    "aland": 548279228,
    "awater": 1511404265,
    "countyfp": "131",
    "countyns": "01480151",
    "dotregion": 3,
    "geoid": "51131",
    "lsad": "06",
    "name": "Northampton",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1439,
    "affgeoid": "0500000US51133",
    "aland": 495425667,
    "awater": 244310208,
    "countyfp": "133",
    "countyns": "01480152",
    "dotregion": 3,
    "geoid": "51133",
    "lsad": "06",
    "name": "Northumberland",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2580,
    "affgeoid": "0500000US51720",
    "aland": 19375326,
    "awater": 89169,
    "countyfp": "720",
    "countyns": "01498434",
    "dotregion": 3,
    "geoid": "51720",
    "lsad": "25",
    "name": "Norton",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1229,
    "affgeoid": "0500000US51135",
    "aland": 814265581,
    "awater": 4297829,
    "countyfp": "135",
    "countyns": "01493928",
    "dotregion": 3,
    "geoid": "51135",
    "lsad": "06",
    "name": "Nottoway",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1320,
    "affgeoid": "0500000US51137",
    "aland": 882616763,
    "awater": 6431171,
    "countyfp": "137",
    "countyns": "01494761",
    "dotregion": 3,
    "geoid": "51137",
    "lsad": "06",
    "name": "Orange",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3091,
    "affgeoid": "0500000US51139",
    "aland": 805020081,
    "awater": 8431094,
    "countyfp": "139",
    "countyns": "01500440",
    "dotregion": 3,
    "geoid": "51139",
    "lsad": "06",
    "name": "Page",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1440,
    "affgeoid": "0500000US51141",
    "aland": 1251234938,
    "awater": 7142556,
    "countyfp": "141",
    "countyns": "01497999",
    "dotregion": 3,
    "geoid": "51141",
    "lsad": "06",
    "name": "Patrick",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 690,
    "affgeoid": "0500000US51730",
    "aland": 59430127,
    "awater": 614559,
    "countyfp": "730",
    "countyns": "01498435",
    "dotregion": 3,
    "geoid": "51730",
    "lsad": "25",
    "name": "Petersburg",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2001,
    "affgeoid": "0500000US51143",
    "aland": 2509525953,
    "awater": 23857387,
    "countyfp": "143",
    "countyns": "01480157",
    "dotregion": 3,
    "geoid": "51143",
    "lsad": "06",
    "name": "Pittsylvania",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1556,
    "affgeoid": "0500000US51735",
    "aland": 39850781,
    "awater": 163450029,
    "countyfp": "735",
    "countyns": "01498436",
    "dotregion": 3,
    "geoid": "51735",
    "lsad": "25",
    "name": "Poquoson",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1919,
    "affgeoid": "0500000US51740",
    "aland": 87547975,
    "awater": 33488196,
    "countyfp": "740",
    "countyns": "01498556",
    "dotregion": 3,
    "geoid": "51740",
    "lsad": "25",
    "name": "Portsmouth",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 578,
    "affgeoid": "0500000US51145",
    "aland": 674021190,
    "awater": 5453788,
    "countyfp": "145",
    "countyns": "01674225",
    "dotregion": 3,
    "geoid": "51145",
    "lsad": "06",
    "name": "Powhatan",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1813,
    "affgeoid": "0500000US51147",
    "aland": 906385569,
    "awater": 10040117,
    "countyfp": "147",
    "countyns": "01492359",
    "dotregion": 3,
    "geoid": "51147",
    "lsad": "06",
    "name": "Prince Edward",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1591,
    "affgeoid": "0500000US51149",
    "aland": 686758306,
    "awater": 43184668,
    "countyfp": "149",
    "countyns": "01480160",
    "dotregion": 3,
    "geoid": "51149",
    "lsad": "06",
    "name": "Prince George",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2706,
    "affgeoid": "0500000US51153",
    "aland": 871305997,
    "awater": 31236810,
    "countyfp": "153",
    "countyns": "01480161",
    "dotregion": 3,
    "geoid": "51153",
    "lsad": "06",
    "name": "Prince William",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2491,
    "affgeoid": "0500000US51155",
    "aland": 828438965,
    "awater": 25204366,
    "countyfp": "155",
    "countyns": "01501465",
    "dotregion": 3,
    "geoid": "51155",
    "lsad": "06",
    "name": "Pulaski",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1068,
    "affgeoid": "0500000US51750",
    "aland": 25567009,
    "awater": 867992,
    "countyfp": "750",
    "countyns": "01498438",
    "dotregion": 3,
    "geoid": "51750",
    "lsad": "25",
    "name": "Radford",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2845,
    "affgeoid": "0500000US51157",
    "aland": 689883410,
    "awater": 2064342,
    "countyfp": "157",
    "countyns": "01673976",
    "dotregion": 3,
    "geoid": "51157",
    "lsad": "06",
    "name": "Rappahannock",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2747,
    "affgeoid": "0500000US51159",
    "aland": 495962797,
    "awater": 64400138,
    "countyfp": "159",
    "countyns": "01480164",
    "dotregion": 3,
    "geoid": "51159",
    "lsad": "06",
    "name": "Richmond",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1696,
    "affgeoid": "0500000US51760",
    "aland": 154942137,
    "awater": 6879776,
    "countyfp": "760",
    "countyns": "01789073",
    "dotregion": 3,
    "geoid": "51760",
    "lsad": "25",
    "name": "Richmond",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2125,
    "affgeoid": "0500000US51161",
    "aland": 649014935,
    "awater": 1795151,
    "countyfp": "161",
    "countyns": "01480165",
    "dotregion": 3,
    "geoid": "51161",
    "lsad": "06",
    "name": "Roanoke",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1470,
    "affgeoid": "0500000US51770",
    "aland": 110141396,
    "awater": 882886,
    "countyfp": "770",
    "countyns": "01498439",
    "dotregion": 3,
    "geoid": "51770",
    "lsad": "25",
    "name": "Roanoke",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3052,
    "affgeoid": "0500000US51163",
    "aland": 1547664064,
    "awater": 8845046,
    "countyfp": "163",
    "countyns": "01480166",
    "dotregion": 3,
    "geoid": "51163",
    "lsad": "06",
    "name": "Rockbridge",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2157,
    "affgeoid": "0500000US51165",
    "aland": 2199284791,
    "awater": 11120615,
    "countyfp": "165",
    "countyns": "01488970",
    "dotregion": 3,
    "geoid": "51165",
    "lsad": "06",
    "name": "Rockingham",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1312,
    "affgeoid": "0500000US51167",
    "aland": 1227192283,
    "awater": 7593493,
    "countyfp": "167",
    "countyns": "01497573",
    "dotregion": 3,
    "geoid": "51167",
    "lsad": "06",
    "name": "Russell",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 473,
    "affgeoid": "0500000US51775",
    "aland": 37400253,
    "awater": 263080,
    "countyfp": "775",
    "countyns": "01789074",
    "dotregion": 3,
    "geoid": "51775",
    "lsad": "25",
    "name": "Salem",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2983,
    "affgeoid": "0500000US51169",
    "aland": 1387008821,
    "awater": 8060238,
    "countyfp": "169",
    "countyns": "01498172",
    "dotregion": 3,
    "geoid": "51169",
    "lsad": "06",
    "name": "Scott",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1644,
    "affgeoid": "0500000US51171",
    "aland": 1316396213,
    "awater": 8870600,
    "countyfp": "171",
    "countyns": "01673918",
    "dotregion": 3,
    "geoid": "51171",
    "lsad": "06",
    "name": "Shenandoah",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 181,
    "affgeoid": "0500000US51173",
    "aland": 1167904202,
    "awater": 3519357,
    "countyfp": "173",
    "countyns": "01500545",
    "dotregion": 3,
    "geoid": "51173",
    "lsad": "06",
    "name": "Smyth",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1856,
    "affgeoid": "0500000US51175",
    "aland": 1551739851,
    "awater": 8242331,
    "countyfp": "175",
    "countyns": "01480171",
    "dotregion": 3,
    "geoid": "51175",
    "lsad": "06",
    "name": "Southampton",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1361,
    "affgeoid": "0500000US51177",
    "aland": 1039865449,
    "awater": 33044472,
    "countyfp": "177",
    "countyns": "01480172",
    "dotregion": 3,
    "geoid": "51177",
    "lsad": "06",
    "name": "Spotsylvania",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2486,
    "affgeoid": "0500000US51179",
    "aland": 696835101,
    "awater": 28176074,
    "countyfp": "179",
    "countyns": "01480173",
    "dotregion": 3,
    "geoid": "51179",
    "lsad": "06",
    "name": "Stafford",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 137,
    "affgeoid": "0500000US51790",
    "aland": 51705587,
    "awater": 153023,
    "countyfp": "790",
    "countyns": "01789075",
    "dotregion": 3,
    "geoid": "51790",
    "lsad": "25",
    "name": "Staunton",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 392,
    "affgeoid": "0500000US51800",
    "aland": 1036489945,
    "awater": 74848803,
    "countyfp": "800",
    "countyns": "01498560",
    "dotregion": 3,
    "geoid": "51800",
    "lsad": "25",
    "name": "Suffolk",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 749,
    "affgeoid": "0500000US51181",
    "aland": 722475755,
    "awater": 81216907,
    "countyfp": "181",
    "countyns": "01480174",
    "dotregion": 3,
    "geoid": "51181",
    "lsad": "06",
    "name": "Surry",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1573,
    "affgeoid": "0500000US51183",
    "aland": 1269664385,
    "awater": 6755317,
    "countyfp": "183",
    "countyns": "01690257",
    "dotregion": 3,
    "geoid": "51183",
    "lsad": "06",
    "name": "Sussex",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2169,
    "affgeoid": "0500000US51185",
    "aland": 1343806837,
    "awater": 2913086,
    "countyfp": "185",
    "countyns": "01497748",
    "dotregion": 3,
    "geoid": "51185",
    "lsad": "06",
    "name": "Tazewell",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1131,
    "affgeoid": "0500000US51810",
    "aland": 646847466,
    "awater": 641272088,
    "countyfp": "810",
    "countyns": "01498559",
    "dotregion": 3,
    "geoid": "51810",
    "lsad": "25",
    "name": "Virginia Beach",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2420,
    "affgeoid": "0500000US51187",
    "aland": 553639842,
    "awater": 8554784,
    "countyfp": "187",
    "countyns": "01674058",
    "dotregion": 3,
    "geoid": "51187",
    "lsad": "06",
    "name": "Warren",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2304,
    "affgeoid": "0500000US51191",
    "aland": 1452917761,
    "awater": 12999433,
    "countyfp": "191",
    "countyns": "01498359",
    "dotregion": 3,
    "geoid": "51191",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1674,
    "affgeoid": "0500000US51820",
    "aland": 38927994,
    "awater": 410156,
    "countyfp": "820",
    "countyns": "01498443",
    "dotregion": 3,
    "geoid": "51820",
    "lsad": "25",
    "name": "Waynesboro",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 563,
    "affgeoid": "0500000US51193",
    "aland": 594075379,
    "awater": 61102382,
    "countyfp": "193",
    "countyns": "01480179",
    "dotregion": 3,
    "geoid": "51193",
    "lsad": "06",
    "name": "Westmoreland",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 3147,
    "affgeoid": "0500000US51830",
    "aland": 23098592,
    "awater": 416082,
    "countyfp": "830",
    "countyns": "01789076",
    "dotregion": 3,
    "geoid": "51830",
    "lsad": "25",
    "name": "Williamsburg",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 2866,
    "affgeoid": "0500000US51840",
    "aland": 23918428,
    "awater": 53195,
    "countyfp": "840",
    "countyns": "01789077",
    "dotregion": 3,
    "geoid": "51840",
    "lsad": "25",
    "name": "Winchester",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 839,
    "affgeoid": "0500000US51195",
    "aland": 1044260774,
    "awater": 5277225,
    "countyfp": "195",
    "countyns": "01496656",
    "dotregion": 3,
    "geoid": "51195",
    "lsad": "06",
    "name": "Wise",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1663,
    "affgeoid": "0500000US51197",
    "aland": 1196123390,
    "awater": 7310964,
    "countyfp": "197",
    "countyns": "01501379",
    "dotregion": 3,
    "geoid": "51197",
    "lsad": "06",
    "name": "Wythe",
    "stateAbbreviation": "VA",
    "stateId": 7
  }, {
    "id": 1451,
    "affgeoid": "0500000US51199",
    "aland": 271061637,
    "awater": 285378318,
    "countyfp": "199",
    "countyns": "01480182",
    "dotregion": 3,
    "geoid": "51199",
    "lsad": "06",
    "name": "York",
    "stateAbbreviation": "VA",
    "stateId": 7
  }]
}, {
  "id": 18,
  "abbreviation": "WA",
  "affgeoid": "0400000US53",
  "aland": 172121026344,
  "awater": 12540093192,
  "dotregion": 10,
  "geoid": "53",
  "lsad": "00",
  "name": "Washington",
  "stateAbbreviation": "WA",
  "statefp": "53",
  "statens": "01779804",
  "counties": [{
    "id": 1693,
    "affgeoid": "0500000US53001",
    "aland": 4985669170,
    "awater": 12622959,
    "countyfp": "001",
    "countyns": "01531601",
    "dotregion": 10,
    "geoid": "53001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2073,
    "affgeoid": "0500000US53003",
    "aland": 1647780262,
    "awater": 11450405,
    "countyfp": "003",
    "countyns": "01533502",
    "dotregion": 10,
    "geoid": "53003",
    "lsad": "06",
    "name": "Asotin",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2702,
    "affgeoid": "0500000US53005",
    "aland": 4404062589,
    "awater": 154325799,
    "countyfp": "005",
    "countyns": "01513302",
    "dotregion": 10,
    "geoid": "53005",
    "lsad": "06",
    "name": "Benton",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1375,
    "affgeoid": "0500000US53007",
    "aland": 7564215806,
    "awater": 189987285,
    "countyfp": "007",
    "countyns": "01531932",
    "dotregion": 10,
    "geoid": "53007",
    "lsad": "06",
    "name": "Chelan",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2281,
    "affgeoid": "0500000US53009",
    "aland": 4503157983,
    "awater": 2413675940,
    "countyfp": "009",
    "countyns": "01531341",
    "dotregion": 10,
    "geoid": "53009",
    "lsad": "06",
    "name": "Clallam",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1623,
    "affgeoid": "0500000US53011",
    "aland": 1629176428,
    "awater": 70459294,
    "countyfp": "011",
    "countyns": "01531820",
    "dotregion": 10,
    "geoid": "53011",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1907,
    "affgeoid": "0500000US53013",
    "aland": 2249793858,
    "awater": 12566846,
    "countyfp": "013",
    "countyns": "01513273",
    "dotregion": 10,
    "geoid": "53013",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2392,
    "affgeoid": "0500000US53015",
    "aland": 2953144614,
    "awater": 67322784,
    "countyfp": "015",
    "countyns": "01529156",
    "dotregion": 10,
    "geoid": "53015",
    "lsad": "06",
    "name": "Cowlitz",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2275,
    "affgeoid": "0500000US53017",
    "aland": 4711893019,
    "awater": 76102869,
    "countyfp": "017",
    "countyns": "01531818",
    "dotregion": 10,
    "geoid": "53017",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2649,
    "affgeoid": "0500000US53019",
    "aland": 5706169065,
    "awater": 140280414,
    "countyfp": "019",
    "countyns": "01531821",
    "dotregion": 10,
    "geoid": "53019",
    "lsad": "06",
    "name": "Ferry",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2089,
    "affgeoid": "0500000US53021",
    "aland": 3216927336,
    "awater": 60193373,
    "countyfp": "021",
    "countyns": "01531822",
    "dotregion": 10,
    "geoid": "53021",
    "lsad": "06",
    "name": "Franklin",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 752,
    "affgeoid": "0500000US53023",
    "aland": 1840672367,
    "awater": 19490299,
    "countyfp": "023",
    "countyns": "01533500",
    "dotregion": 10,
    "geoid": "53023",
    "lsad": "06",
    "name": "Garfield",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 622,
    "affgeoid": "0500000US53025",
    "aland": 6939890129,
    "awater": 289550821,
    "countyfp": "025",
    "countyns": "01531924",
    "dotregion": 10,
    "geoid": "53025",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2058,
    "affgeoid": "0500000US53027",
    "aland": 4926218548,
    "awater": 834956830,
    "countyfp": "027",
    "countyns": "01531823",
    "dotregion": 10,
    "geoid": "53027",
    "lsad": "06",
    "name": "Grays Harbor",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1258,
    "affgeoid": "0500000US53029",
    "aland": 539898564,
    "awater": 800096272,
    "countyfp": "029",
    "countyns": "01513272",
    "dotregion": 10,
    "geoid": "53029",
    "lsad": "06",
    "name": "Island",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2064,
    "affgeoid": "0500000US53031",
    "aland": 4671386491,
    "awater": 982867075,
    "countyfp": "031",
    "countyns": "01531936",
    "dotregion": 10,
    "geoid": "53031",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2541,
    "affgeoid": "0500000US53033",
    "aland": 5479235795,
    "awater": 495559529,
    "countyfp": "033",
    "countyns": "01531933",
    "dotregion": 10,
    "geoid": "53033",
    "lsad": "06",
    "name": "King",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1544,
    "affgeoid": "0500000US53035",
    "aland": 1022895431,
    "awater": 442827362,
    "countyfp": "035",
    "countyns": "01529223",
    "dotregion": 10,
    "geoid": "53035",
    "lsad": "06",
    "name": "Kitsap",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2978,
    "affgeoid": "0500000US53037",
    "aland": 5950707492,
    "awater": 92362094,
    "countyfp": "037",
    "countyns": "01531926",
    "dotregion": 10,
    "geoid": "53037",
    "lsad": "06",
    "name": "Kittitas",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 3180,
    "affgeoid": "0500000US53039",
    "aland": 4846657594,
    "awater": 85063424,
    "countyfp": "039",
    "countyns": "01529219",
    "dotregion": 10,
    "geoid": "53039",
    "lsad": "06",
    "name": "Klickitat",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 290,
    "affgeoid": "0500000US53041",
    "aland": 6223223859,
    "awater": 86636988,
    "countyfp": "041",
    "countyns": "01531927",
    "dotregion": 10,
    "geoid": "53041",
    "lsad": "06",
    "name": "Lewis",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1253,
    "affgeoid": "0500000US53043",
    "aland": 5984151839,
    "awater": 74744194,
    "countyfp": "043",
    "countyns": "01514052",
    "dotregion": 10,
    "geoid": "53043",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2197,
    "affgeoid": "0500000US53045",
    "aland": 2484997453,
    "awater": 237129431,
    "countyfp": "045",
    "countyns": "01529221",
    "dotregion": 10,
    "geoid": "53045",
    "lsad": "06",
    "name": "Mason",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2023,
    "affgeoid": "0500000US53047",
    "aland": 13644015302,
    "awater": 121223380,
    "countyfp": "047",
    "countyns": "01531928",
    "dotregion": 10,
    "geoid": "53047",
    "lsad": "06",
    "name": "Okanogan",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2513,
    "affgeoid": "0500000US53049",
    "aland": 2415577406,
    "awater": 752974465,
    "countyfp": "049",
    "countyns": "01513274",
    "dotregion": 10,
    "geoid": "53049",
    "lsad": "06",
    "name": "Pacific",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 744,
    "affgeoid": "0500000US53051",
    "aland": 3626035232,
    "awater": 65404066,
    "countyfp": "051",
    "countyns": "01529157",
    "dotregion": 10,
    "geoid": "53051",
    "lsad": "06",
    "name": "Pend Oreille",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2627,
    "affgeoid": "0500000US53053",
    "aland": 4323920389,
    "awater": 354552489,
    "countyfp": "053",
    "countyns": "01529159",
    "dotregion": 10,
    "geoid": "53053",
    "lsad": "06",
    "name": "Pierce",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1430,
    "affgeoid": "0500000US53055",
    "aland": 450415360,
    "awater": 1158133253,
    "countyfp": "055",
    "countyns": "01531931",
    "dotregion": 10,
    "geoid": "53055",
    "lsad": "06",
    "name": "San Juan",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1254,
    "affgeoid": "0500000US53057",
    "aland": 4483833372,
    "awater": 489315214,
    "countyfp": "057",
    "countyns": "01531402",
    "dotregion": 10,
    "geoid": "53057",
    "lsad": "06",
    "name": "Skagit",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2569,
    "affgeoid": "0500000US53059",
    "aland": 4288205007,
    "awater": 72853073,
    "countyfp": "059",
    "countyns": "01529220",
    "dotregion": 10,
    "geoid": "53059",
    "lsad": "06",
    "name": "Skamania",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2007,
    "affgeoid": "0500000US53061",
    "aland": 5405954767,
    "awater": 282423436,
    "countyfp": "061",
    "countyns": "01529222",
    "dotregion": 10,
    "geoid": "53061",
    "lsad": "06",
    "name": "Snohomish",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 225,
    "affgeoid": "0500000US53063",
    "aland": 4568197031,
    "awater": 43789502,
    "countyfp": "063",
    "countyns": "01529225",
    "dotregion": 10,
    "geoid": "53063",
    "lsad": "06",
    "name": "Spokane",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2024,
    "affgeoid": "0500000US53065",
    "aland": 6417280894,
    "awater": 163101755,
    "countyfp": "065",
    "countyns": "01531930",
    "dotregion": 10,
    "geoid": "53065",
    "lsad": "06",
    "name": "Stevens",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1255,
    "affgeoid": "0500000US53067",
    "aland": 1869969897,
    "awater": 133393179,
    "countyfp": "067",
    "countyns": "01529226",
    "dotregion": 10,
    "geoid": "53067",
    "lsad": "06",
    "name": "Thurston",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 931,
    "affgeoid": "0500000US53069",
    "aland": 682138871,
    "awater": 61658258,
    "countyfp": "069",
    "countyns": "01513275",
    "dotregion": 10,
    "geoid": "53069",
    "lsad": "06",
    "name": "Wahkiakum",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1199,
    "affgeoid": "0500000US53071",
    "aland": 3289614893,
    "awater": 74827782,
    "countyfp": "071",
    "countyns": "01531819",
    "dotregion": 10,
    "geoid": "53071",
    "lsad": "06",
    "name": "Walla Walla",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 1256,
    "affgeoid": "0500000US53073",
    "aland": 5456492712,
    "awater": 1027129526,
    "countyfp": "073",
    "countyns": "01529224",
    "dotregion": 10,
    "geoid": "53073",
    "lsad": "06",
    "name": "Whatcom",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2181,
    "affgeoid": "0500000US53075",
    "aland": 5591999422,
    "awater": 47939386,
    "countyfp": "075",
    "countyns": "01533501",
    "dotregion": 10,
    "geoid": "53075",
    "lsad": "06",
    "name": "Whitman",
    "stateAbbreviation": "WA",
    "stateId": 18
  }, {
    "id": 2477,
    "affgeoid": "0500000US53077",
    "aland": 11125450097,
    "awater": 41102141,
    "countyfp": "077",
    "countyns": "01531929",
    "dotregion": 10,
    "geoid": "53077",
    "lsad": "06",
    "name": "Yakima",
    "stateAbbreviation": "WA",
    "stateId": 18
  }]
}, {
  "id": 31,
  "abbreviation": "WV",
  "affgeoid": "0400000US54",
  "aland": 62266577599,
  "awater": 489469489,
  "dotregion": 3,
  "geoid": "54",
  "lsad": "00",
  "name": "West Virginia",
  "stateAbbreviation": "WV",
  "statefp": "54",
  "statens": "01779805",
  "counties": [{
    "id": 1149,
    "affgeoid": "0500000US54001",
    "aland": 883338731,
    "awater": 4639232,
    "countyfp": "001",
    "countyns": "01696996",
    "dotregion": 3,
    "geoid": "54001",
    "lsad": "06",
    "name": "Barbour",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 758,
    "affgeoid": "0500000US54003",
    "aland": 831766636,
    "awater": 1061824,
    "countyfp": "003",
    "countyns": "01550008",
    "dotregion": 3,
    "geoid": "54003",
    "lsad": "06",
    "name": "Berkeley",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2250,
    "affgeoid": "0500000US54005",
    "aland": 1298993469,
    "awater": 4284345,
    "countyfp": "005",
    "countyns": "01550009",
    "dotregion": 3,
    "geoid": "54005",
    "lsad": "06",
    "name": "Boone",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1464,
    "affgeoid": "0500000US54007",
    "aland": 1322996693,
    "awater": 14144661,
    "countyfp": "007",
    "countyns": "01550010",
    "dotregion": 3,
    "geoid": "54007",
    "lsad": "06",
    "name": "Braxton",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 523,
    "affgeoid": "0500000US54009",
    "aland": 231034166,
    "awater": 8714144,
    "countyfp": "009",
    "countyns": "01558262",
    "dotregion": 3,
    "geoid": "54009",
    "lsad": "06",
    "name": "Brooke",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 433,
    "affgeoid": "0500000US54011",
    "aland": 727838068,
    "awater": 18122000,
    "countyfp": "011",
    "countyns": "01550012",
    "dotregion": 3,
    "geoid": "54011",
    "lsad": "06",
    "name": "Cabell",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1781,
    "affgeoid": "0500000US54013",
    "aland": 723252434,
    "awater": 3704539,
    "countyfp": "013",
    "countyns": "01696945",
    "dotregion": 3,
    "geoid": "54013",
    "lsad": "06",
    "name": "Calhoun",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1920,
    "affgeoid": "0500000US54015",
    "aland": 885617251,
    "awater": 4862445,
    "countyfp": "015",
    "countyns": "01550014",
    "dotregion": 3,
    "geoid": "54015",
    "lsad": "06",
    "name": "Clay",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 456,
    "affgeoid": "0500000US54017",
    "aland": 828070481,
    "awater": 1958441,
    "countyfp": "017",
    "countyns": "01689476",
    "dotregion": 3,
    "geoid": "54017",
    "lsad": "06",
    "name": "Doddridge",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1100,
    "affgeoid": "0500000US54019",
    "aland": 1713485858,
    "awater": 17527378,
    "countyfp": "019",
    "countyns": "01560095",
    "dotregion": 3,
    "geoid": "54019",
    "lsad": "06",
    "name": "Fayette",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 804,
    "affgeoid": "0500000US54021",
    "aland": 876717634,
    "awater": 4082111,
    "countyfp": "021",
    "countyns": "01689673",
    "dotregion": 3,
    "geoid": "54021",
    "lsad": "06",
    "name": "Gilmer",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2356,
    "affgeoid": "0500000US54023",
    "aland": 1236390743,
    "awater": 7545524,
    "countyfp": "023",
    "countyns": "01697238",
    "dotregion": 3,
    "geoid": "54023",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 659,
    "affgeoid": "0500000US54025",
    "aland": 2640888946,
    "awater": 12578876,
    "countyfp": "025",
    "countyns": "01557518",
    "dotregion": 3,
    "geoid": "54025",
    "lsad": "06",
    "name": "Greenbrier",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1095,
    "affgeoid": "0500000US54027",
    "aland": 1658559627,
    "awater": 10969233,
    "countyfp": "027",
    "countyns": "01718644",
    "dotregion": 3,
    "geoid": "54027",
    "lsad": "06",
    "name": "Hampshire",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1909,
    "affgeoid": "0500000US54029",
    "aland": 213957141,
    "awater": 13879330,
    "countyfp": "029",
    "countyns": "01560574",
    "dotregion": 3,
    "geoid": "54029",
    "lsad": "06",
    "name": "Hancock",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1771,
    "affgeoid": "0500000US54031",
    "aland": 1508195534,
    "awater": 5617193,
    "countyfp": "031",
    "countyns": "01718557",
    "dotregion": 3,
    "geoid": "54031",
    "lsad": "06",
    "name": "Hardy",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2539,
    "affgeoid": "0500000US54033",
    "aland": 1077454953,
    "awater": 1320319,
    "countyfp": "033",
    "countyns": "01718426",
    "dotregion": 3,
    "geoid": "54033",
    "lsad": "06",
    "name": "Harrison",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2210,
    "affgeoid": "0500000US54035",
    "aland": 1202677931,
    "awater": 18836096,
    "countyfp": "035",
    "countyns": "01559963",
    "dotregion": 3,
    "geoid": "54035",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2297,
    "affgeoid": "0500000US54037",
    "aland": 542732146,
    "awater": 5491067,
    "countyfp": "037",
    "countyns": "01550025",
    "dotregion": 3,
    "geoid": "54037",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1869,
    "affgeoid": "0500000US54039",
    "aland": 2335953946,
    "awater": 23318622,
    "countyfp": "039",
    "countyns": "01550026",
    "dotregion": 3,
    "geoid": "54039",
    "lsad": "06",
    "name": "Kanawha",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 618,
    "affgeoid": "0500000US54041",
    "aland": 1002099077,
    "awater": 7081051,
    "countyfp": "041",
    "countyns": "01550027",
    "dotregion": 3,
    "geoid": "54041",
    "lsad": "06",
    "name": "Lewis",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2783,
    "affgeoid": "0500000US54043",
    "aland": 1131925075,
    "awater": 4023478,
    "countyfp": "043",
    "countyns": "01550028",
    "dotregion": 3,
    "geoid": "54043",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2887,
    "affgeoid": "0500000US54045",
    "aland": 1175209714,
    "awater": 4830097,
    "countyfp": "045",
    "countyns": "01550029",
    "dotregion": 3,
    "geoid": "54045",
    "lsad": "06",
    "name": "Logan",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 304,
    "affgeoid": "0500000US54049",
    "aland": 799642465,
    "awater": 7186184,
    "countyfp": "049",
    "countyns": "01718173",
    "dotregion": 3,
    "geoid": "54049",
    "lsad": "06",
    "name": "Marion",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2617,
    "affgeoid": "0500000US54051",
    "aland": 791063504,
    "awater": 17411500,
    "countyfp": "051",
    "countyns": "01717539",
    "dotregion": 3,
    "geoid": "54051",
    "lsad": "06",
    "name": "Marshall",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1657,
    "affgeoid": "0500000US54053",
    "aland": 1115633604,
    "awater": 36174216,
    "countyfp": "053",
    "countyns": "01560254",
    "dotregion": 3,
    "geoid": "54053",
    "lsad": "06",
    "name": "Mason",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1094,
    "affgeoid": "0500000US54047",
    "aland": 1381646920,
    "awater": 3733264,
    "countyfp": "047",
    "countyns": "01689162",
    "dotregion": 3,
    "geoid": "54047",
    "lsad": "06",
    "name": "McDowell",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1768,
    "affgeoid": "0500000US54055",
    "aland": 1085127232,
    "awater": 4432913,
    "countyfp": "055",
    "countyns": "01557645",
    "dotregion": 3,
    "geoid": "54055",
    "lsad": "06",
    "name": "Mercer",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 524,
    "affgeoid": "0500000US54057",
    "aland": 849080971,
    "awater": 3595062,
    "countyfp": "057",
    "countyns": "01717890",
    "dotregion": 3,
    "geoid": "54057",
    "lsad": "06",
    "name": "Mineral",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 3151,
    "affgeoid": "0500000US54059",
    "aland": 1095914379,
    "awater": 2190076,
    "countyfp": "059",
    "countyns": "01550036",
    "dotregion": 3,
    "geoid": "54059",
    "lsad": "06",
    "name": "Mingo",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1552,
    "affgeoid": "0500000US54061",
    "aland": 932572492,
    "awater": 15051916,
    "countyfp": "061",
    "countyns": "01550037",
    "dotregion": 3,
    "geoid": "54061",
    "lsad": "06",
    "name": "Monongalia",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 936,
    "affgeoid": "0500000US54063",
    "aland": 1224422315,
    "awater": 2298715,
    "countyfp": "063",
    "countyns": "01557702",
    "dotregion": 3,
    "geoid": "54063",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1064,
    "affgeoid": "0500000US54065",
    "aland": 593295476,
    "awater": 1401570,
    "countyfp": "065",
    "countyns": "01557950",
    "dotregion": 3,
    "geoid": "54065",
    "lsad": "06",
    "name": "Morgan",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2461,
    "affgeoid": "0500000US54067",
    "aland": 1675296013,
    "awater": 19608975,
    "countyfp": "067",
    "countyns": "01550040",
    "dotregion": 3,
    "geoid": "54067",
    "lsad": "06",
    "name": "Nicholas",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 103,
    "affgeoid": "0500000US54069",
    "aland": 274098955,
    "awater": 8274300,
    "countyfp": "069",
    "countyns": "01717163",
    "dotregion": 3,
    "geoid": "54069",
    "lsad": "06",
    "name": "Ohio",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 301,
    "affgeoid": "0500000US54071",
    "aland": 1802790562,
    "awater": 5437237,
    "countyfp": "071",
    "countyns": "01550042",
    "dotregion": 3,
    "geoid": "54071",
    "lsad": "06",
    "name": "Pendleton",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 891,
    "affgeoid": "0500000US54073",
    "aland": 336965609,
    "awater": 11510007,
    "countyfp": "073",
    "countyns": "01678557",
    "dotregion": 3,
    "geoid": "54073",
    "lsad": "06",
    "name": "Pleasants",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2939,
    "affgeoid": "0500000US54075",
    "aland": 2435344905,
    "awater": 3978619,
    "countyfp": "075",
    "countyns": "01550044",
    "dotregion": 3,
    "geoid": "54075",
    "lsad": "06",
    "name": "Pocahontas",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 871,
    "affgeoid": "0500000US54077",
    "aland": 1680406635,
    "awater": 6681831,
    "countyfp": "077",
    "countyns": "01558642",
    "dotregion": 3,
    "geoid": "54077",
    "lsad": "06",
    "name": "Preston",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 352,
    "affgeoid": "0500000US54079",
    "aland": 895440742,
    "awater": 12088530,
    "countyfp": "079",
    "countyns": "01550046",
    "dotregion": 3,
    "geoid": "54079",
    "lsad": "06",
    "name": "Putnam",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2050,
    "affgeoid": "0500000US54081",
    "aland": 1567864571,
    "awater": 10336249,
    "countyfp": "081",
    "countyns": "01550047",
    "dotregion": 3,
    "geoid": "54081",
    "lsad": "06",
    "name": "Raleigh",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2158,
    "affgeoid": "0500000US54083",
    "aland": 2692796583,
    "awater": 667359,
    "countyfp": "083",
    "countyns": "01550048",
    "dotregion": 3,
    "geoid": "54083",
    "lsad": "06",
    "name": "Randolph",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2173,
    "affgeoid": "0500000US54085",
    "aland": 1170648310,
    "awater": 4425143,
    "countyfp": "085",
    "countyns": "01689049",
    "dotregion": 3,
    "geoid": "54085",
    "lsad": "06",
    "name": "Ritchie",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2956,
    "affgeoid": "0500000US54087",
    "aland": 1252422376,
    "awater": 404682,
    "countyfp": "087",
    "countyns": "01550050",
    "dotregion": 3,
    "geoid": "54087",
    "lsad": "06",
    "name": "Roane",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1563,
    "affgeoid": "0500000US54089",
    "aland": 933832340,
    "awater": 18575981,
    "countyfp": "089",
    "countyns": "01557805",
    "dotregion": 3,
    "geoid": "54089",
    "lsad": "06",
    "name": "Summers",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 409,
    "affgeoid": "0500000US54091",
    "aland": 447475066,
    "awater": 7532835,
    "countyfp": "091",
    "countyns": "01689856",
    "dotregion": 3,
    "geoid": "54091",
    "lsad": "06",
    "name": "Taylor",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 677,
    "affgeoid": "0500000US54093",
    "aland": 1085589879,
    "awater": 5528932,
    "countyfp": "093",
    "countyns": "01689423",
    "dotregion": 3,
    "geoid": "54093",
    "lsad": "06",
    "name": "Tucker",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2174,
    "affgeoid": "0500000US54095",
    "aland": 663797704,
    "awater": 11403003,
    "countyfp": "095",
    "countyns": "01678706",
    "dotregion": 3,
    "geoid": "54095",
    "lsad": "06",
    "name": "Tyler",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2515,
    "affgeoid": "0500000US54097",
    "aland": 918506896,
    "awater": 302703,
    "countyfp": "097",
    "countyns": "01696800",
    "dotregion": 3,
    "geoid": "54097",
    "lsad": "06",
    "name": "Upshur",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2716,
    "affgeoid": "0500000US54099",
    "aland": 1310504123,
    "awater": 15860720,
    "countyfp": "099",
    "countyns": "01550056",
    "dotregion": 3,
    "geoid": "54099",
    "lsad": "06",
    "name": "Wayne",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1755,
    "affgeoid": "0500000US54101",
    "aland": 1433475688,
    "awater": 7148637,
    "countyfp": "101",
    "countyns": "01550057",
    "dotregion": 3,
    "geoid": "54101",
    "lsad": "06",
    "name": "Webster",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2572,
    "affgeoid": "0500000US54103",
    "aland": 927380674,
    "awater": 8458366,
    "countyfp": "103",
    "countyns": "01717836",
    "dotregion": 3,
    "geoid": "54103",
    "lsad": "06",
    "name": "Wetzel",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 1546,
    "affgeoid": "0500000US54105",
    "aland": 602201080,
    "awater": 5839706,
    "countyfp": "105",
    "countyns": "01678877",
    "dotregion": 3,
    "geoid": "54105",
    "lsad": "06",
    "name": "Wirt",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2246,
    "affgeoid": "0500000US54107",
    "aland": 948609303,
    "awater": 27211266,
    "countyfp": "107",
    "countyns": "01560558",
    "dotregion": 3,
    "geoid": "54107",
    "lsad": "06",
    "name": "Wood",
    "stateAbbreviation": "WV",
    "stateId": 31
  }, {
    "id": 2445,
    "affgeoid": "0500000US54109",
    "aland": 1293573973,
    "awater": 6126986,
    "countyfp": "109",
    "countyns": "01550061",
    "dotregion": 3,
    "geoid": "54109",
    "lsad": "06",
    "name": "Wyoming",
    "stateAbbreviation": "WV",
    "stateId": 31
  }]
}, {
  "id": 5,
  "abbreviation": "WI",
  "affgeoid": "0400000US55",
  "aland": 140269484183,
  "awater": 29365442607,
  "dotregion": 5,
  "geoid": "55",
  "lsad": "00",
  "name": "Wisconsin",
  "stateAbbreviation": "WI",
  "statefp": "55",
  "statens": "01779806",
  "counties": [{
    "id": 1241,
    "affgeoid": "0500000US55001",
    "aland": 1672075271,
    "awater": 108497596,
    "countyfp": "001",
    "countyns": "01581060",
    "dotregion": 5,
    "geoid": "55001",
    "lsad": "06",
    "name": "Adams",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1960,
    "affgeoid": "0500000US55003",
    "aland": 2706634043,
    "awater": 3230599745,
    "countyfp": "003",
    "countyns": "01581061",
    "dotregion": 5,
    "geoid": "55003",
    "lsad": "06",
    "name": "Ashland",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1626,
    "affgeoid": "0500000US55005",
    "aland": 2234504161,
    "awater": 69971721,
    "countyfp": "005",
    "countyns": "01581062",
    "dotregion": 5,
    "geoid": "55005",
    "lsad": "06",
    "name": "Barron",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2998,
    "affgeoid": "0500000US55007",
    "aland": 3827658037,
    "awater": 1460277087,
    "countyfp": "007",
    "countyns": "01581063",
    "dotregion": 5,
    "geoid": "55007",
    "lsad": "06",
    "name": "Bayfield",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1431,
    "affgeoid": "0500000US55009",
    "aland": 1372050858,
    "awater": 222684564,
    "countyfp": "009",
    "countyns": "01581064",
    "dotregion": 5,
    "geoid": "55009",
    "lsad": "06",
    "name": "Brown",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2447,
    "affgeoid": "0500000US55011",
    "aland": 1739529647,
    "awater": 98310701,
    "countyfp": "011",
    "countyns": "01581065",
    "dotregion": 5,
    "geoid": "55011",
    "lsad": "06",
    "name": "Buffalo",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1045,
    "affgeoid": "0500000US55013",
    "aland": 2127856270,
    "awater": 151932127,
    "countyfp": "013",
    "countyns": "01581066",
    "dotregion": 5,
    "geoid": "55013",
    "lsad": "06",
    "name": "Burnett",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 441,
    "affgeoid": "0500000US55015",
    "aland": 824227645,
    "awater": 204196301,
    "countyfp": "015",
    "countyns": "01581067",
    "dotregion": 5,
    "geoid": "55015",
    "lsad": "06",
    "name": "Calumet",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2071,
    "affgeoid": "0500000US55017",
    "aland": 2611621270,
    "awater": 85230105,
    "countyfp": "017",
    "countyns": "01581068",
    "dotregion": 5,
    "geoid": "55017",
    "lsad": "06",
    "name": "Chippewa",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1416,
    "affgeoid": "0500000US55019",
    "aland": 3133129659,
    "awater": 23233358,
    "countyfp": "019",
    "countyns": "01581069",
    "dotregion": 5,
    "geoid": "55019",
    "lsad": "06",
    "name": "Clark",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2557,
    "affgeoid": "0500000US55021",
    "aland": 1982720552,
    "awater": 78837129,
    "countyfp": "021",
    "countyns": "01581070",
    "dotregion": 5,
    "geoid": "55021",
    "lsad": "06",
    "name": "Columbia",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1818,
    "affgeoid": "0500000US55023",
    "aland": 1478001881,
    "awater": 73945441,
    "countyfp": "023",
    "countyns": "01581071",
    "dotregion": 5,
    "geoid": "55023",
    "lsad": "06",
    "name": "Crawford",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 326,
    "affgeoid": "0500000US55025",
    "aland": 3100366665,
    "awater": 106833618,
    "countyfp": "025",
    "countyns": "01581072",
    "dotregion": 5,
    "geoid": "55025",
    "lsad": "06",
    "name": "Dane",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2191,
    "affgeoid": "0500000US55027",
    "aland": 2267985235,
    "awater": 81403926,
    "countyfp": "027",
    "countyns": "01581073",
    "dotregion": 5,
    "geoid": "55027",
    "lsad": "06",
    "name": "Dodge",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 588,
    "affgeoid": "0500000US55029",
    "aland": 1248281608,
    "awater": 4890609333,
    "countyfp": "029",
    "countyns": "01581074",
    "dotregion": 5,
    "geoid": "55029",
    "lsad": "06",
    "name": "Door",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 3122,
    "affgeoid": "0500000US55031",
    "aland": 3377703789,
    "awater": 454647734,
    "countyfp": "031",
    "countyns": "01581075",
    "dotregion": 5,
    "geoid": "55031",
    "lsad": "06",
    "name": "Douglas",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1880,
    "affgeoid": "0500000US55033",
    "aland": 2201842348,
    "awater": 35644676,
    "countyfp": "033",
    "countyns": "01581076",
    "dotregion": 5,
    "geoid": "55033",
    "lsad": "06",
    "name": "Dunn",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 31,
    "affgeoid": "0500000US55035",
    "aland": 1652211316,
    "awater": 18848512,
    "countyfp": "035",
    "countyns": "01581077",
    "dotregion": 5,
    "geoid": "55035",
    "lsad": "06",
    "name": "Eau Claire",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2253,
    "affgeoid": "0500000US55037",
    "aland": 1264230429,
    "awater": 24111640,
    "countyfp": "037",
    "countyns": "01581078",
    "dotregion": 5,
    "geoid": "55037",
    "lsad": "06",
    "name": "Florence",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 653,
    "affgeoid": "0500000US55039",
    "aland": 1863635376,
    "awater": 119885405,
    "countyfp": "039",
    "countyns": "01581079",
    "dotregion": 5,
    "geoid": "55039",
    "lsad": "06",
    "name": "Fond du Lac",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1211,
    "affgeoid": "0500000US55041",
    "aland": 2626856569,
    "awater": 83589370,
    "countyfp": "041",
    "countyns": "01581080",
    "dotregion": 5,
    "geoid": "55041",
    "lsad": "06",
    "name": "Forest",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2577,
    "affgeoid": "0500000US55043",
    "aland": 2970368436,
    "awater": 94555361,
    "countyfp": "043",
    "countyns": "01581081",
    "dotregion": 5,
    "geoid": "55043",
    "lsad": "06",
    "name": "Grant",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1285,
    "affgeoid": "0500000US55045",
    "aland": 1512664667,
    "awater": 1315749,
    "countyfp": "045",
    "countyns": "01581082",
    "dotregion": 5,
    "geoid": "55045",
    "lsad": "06",
    "name": "Green",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1307,
    "affgeoid": "0500000US55047",
    "aland": 904775232,
    "awater": 79762102,
    "countyfp": "047",
    "countyns": "01581083",
    "dotregion": 5,
    "geoid": "55047",
    "lsad": "06",
    "name": "Green Lake",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2982,
    "affgeoid": "0500000US55049",
    "aland": 1975380661,
    "awater": 13869508,
    "countyfp": "049",
    "countyns": "01581084",
    "dotregion": 5,
    "geoid": "55049",
    "lsad": "06",
    "name": "Iowa",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1189,
    "affgeoid": "0500000US55051",
    "aland": 1963698875,
    "awater": 416925915,
    "countyfp": "051",
    "countyns": "01581085",
    "dotregion": 5,
    "geoid": "55051",
    "lsad": "06",
    "name": "Iron",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1215,
    "affgeoid": "0500000US55053",
    "aland": 2558228002,
    "awater": 32986244,
    "countyfp": "053",
    "countyns": "01581086",
    "dotregion": 5,
    "geoid": "55053",
    "lsad": "06",
    "name": "Jackson",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1683,
    "affgeoid": "0500000US55055",
    "aland": 1441234317,
    "awater": 68110734,
    "countyfp": "055",
    "countyns": "01581087",
    "dotregion": 5,
    "geoid": "55055",
    "lsad": "06",
    "name": "Jefferson",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2402,
    "affgeoid": "0500000US55057",
    "aland": 1986636007,
    "awater": 98723935,
    "countyfp": "057",
    "countyns": "01581088",
    "dotregion": 5,
    "geoid": "55057",
    "lsad": "06",
    "name": "Juneau",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 179,
    "affgeoid": "0500000US55059",
    "aland": 704493821,
    "awater": 1248425296,
    "countyfp": "059",
    "countyns": "01581089",
    "dotregion": 5,
    "geoid": "55059",
    "lsad": "06",
    "name": "Kenosha",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 920,
    "affgeoid": "0500000US55061",
    "aland": 886870601,
    "awater": 1921417623,
    "countyfp": "061",
    "countyns": "01581090",
    "dotregion": 5,
    "geoid": "55061",
    "lsad": "06",
    "name": "Kewaunee",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1977,
    "affgeoid": "0500000US55063",
    "aland": 1170030641,
    "awater": 73154543,
    "countyfp": "063",
    "countyns": "01581091",
    "dotregion": 5,
    "geoid": "55063",
    "lsad": "06",
    "name": "La Crosse",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2409,
    "affgeoid": "0500000US55065",
    "aland": 1640985284,
    "awater": 2539100,
    "countyfp": "065",
    "countyns": "01581092",
    "dotregion": 5,
    "geoid": "55065",
    "lsad": "06",
    "name": "Lafayette",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1422,
    "affgeoid": "0500000US55067",
    "aland": 2254927630,
    "awater": 44652794,
    "countyfp": "067",
    "countyns": "01581093",
    "dotregion": 5,
    "geoid": "55067",
    "lsad": "06",
    "name": "Langlade",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 97,
    "affgeoid": "0500000US55069",
    "aland": 2276237353,
    "awater": 72470204,
    "countyfp": "069",
    "countyns": "01581094",
    "dotregion": 5,
    "geoid": "55069",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2849,
    "affgeoid": "0500000US55071",
    "aland": 1526310981,
    "awater": 2343326774,
    "countyfp": "071",
    "countyns": "01581095",
    "dotregion": 5,
    "geoid": "55071",
    "lsad": "06",
    "name": "Manitowoc",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 273,
    "affgeoid": "0500000US55073",
    "aland": 4001539245,
    "awater": 81145909,
    "countyfp": "073",
    "countyns": "01581096",
    "dotregion": 5,
    "geoid": "55073",
    "lsad": "06",
    "name": "Marathon",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2573,
    "affgeoid": "0500000US55075",
    "aland": 3624315200,
    "awater": 390129874,
    "countyfp": "075",
    "countyns": "01581097",
    "dotregion": 5,
    "geoid": "55075",
    "lsad": "06",
    "name": "Marinette",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2690,
    "affgeoid": "0500000US55077",
    "aland": 1180277802,
    "awater": 22682653,
    "countyfp": "077",
    "countyns": "01581098",
    "dotregion": 5,
    "geoid": "55077",
    "lsad": "06",
    "name": "Marquette",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1607,
    "affgeoid": "0500000US55078",
    "aland": 926201113,
    "awater": 19038372,
    "countyfp": "078",
    "countyns": "01581099",
    "dotregion": 5,
    "geoid": "55078",
    "lsad": "06",
    "name": "Menominee",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1630,
    "affgeoid": "0500000US55079",
    "aland": 625449547,
    "awater": 2455428024,
    "countyfp": "079",
    "countyns": "01581100",
    "dotregion": 5,
    "geoid": "55079",
    "lsad": "06",
    "name": "Milwaukee",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2562,
    "affgeoid": "0500000US55081",
    "aland": 2333352184,
    "awater": 18578102,
    "countyfp": "081",
    "countyns": "01581101",
    "dotregion": 5,
    "geoid": "55081",
    "lsad": "06",
    "name": "Monroe",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2229,
    "affgeoid": "0500000US55083",
    "aland": 2584775999,
    "awater": 390589537,
    "countyfp": "083",
    "countyns": "01581102",
    "dotregion": 5,
    "geoid": "55083",
    "lsad": "06",
    "name": "Oconto",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 890,
    "affgeoid": "0500000US55085",
    "aland": 2883897877,
    "awater": 318619308,
    "countyfp": "085",
    "countyns": "01581103",
    "dotregion": 5,
    "geoid": "55085",
    "lsad": "06",
    "name": "Oneida",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 150,
    "affgeoid": "0500000US55087",
    "aland": 1651266427,
    "awater": 18259071,
    "countyfp": "087",
    "countyns": "01581104",
    "dotregion": 5,
    "geoid": "55087",
    "lsad": "06",
    "name": "Outagamie",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 465,
    "affgeoid": "0500000US55089",
    "aland": 603613255,
    "awater": 2287313798,
    "countyfp": "089",
    "countyns": "01581105",
    "dotregion": 5,
    "geoid": "55089",
    "lsad": "06",
    "name": "Ozaukee",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 498,
    "affgeoid": "0500000US55091",
    "aland": 600853204,
    "awater": 43282752,
    "countyfp": "091",
    "countyns": "01581106",
    "dotregion": 5,
    "geoid": "55091",
    "lsad": "06",
    "name": "Pepin",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1107,
    "affgeoid": "0500000US55093",
    "aland": 1486002475,
    "awater": 46945741,
    "countyfp": "093",
    "countyns": "01581107",
    "dotregion": 5,
    "geoid": "55093",
    "lsad": "06",
    "name": "Pierce",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2421,
    "affgeoid": "0500000US55095",
    "aland": 2367154216,
    "awater": 109929781,
    "countyfp": "095",
    "countyns": "01581108",
    "dotregion": 5,
    "geoid": "55095",
    "lsad": "06",
    "name": "Polk",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2213,
    "affgeoid": "0500000US55097",
    "aland": 2074117686,
    "awater": 56938029,
    "countyfp": "097",
    "countyns": "01581109",
    "dotregion": 5,
    "geoid": "55097",
    "lsad": "06",
    "name": "Portage",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1135,
    "affgeoid": "0500000US55099",
    "aland": 3247940162,
    "awater": 62268240,
    "countyfp": "099",
    "countyns": "01581110",
    "dotregion": 5,
    "geoid": "55099",
    "lsad": "06",
    "name": "Price",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1281,
    "affgeoid": "0500000US55101",
    "aland": 861267826,
    "awater": 1190381792,
    "countyfp": "101",
    "countyns": "01581111",
    "dotregion": 5,
    "geoid": "55101",
    "lsad": "06",
    "name": "Racine",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2579,
    "affgeoid": "0500000US55103",
    "aland": 1518123765,
    "awater": 8153427,
    "countyfp": "103",
    "countyns": "01581112",
    "dotregion": 5,
    "geoid": "55103",
    "lsad": "06",
    "name": "Richland",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 158,
    "affgeoid": "0500000US55105",
    "aland": 1859887390,
    "awater": 20681629,
    "countyfp": "105",
    "countyns": "01581113",
    "dotregion": 5,
    "geoid": "55105",
    "lsad": "06",
    "name": "Rock",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 159,
    "affgeoid": "0500000US55107",
    "aland": 2366213487,
    "awater": 44800510,
    "countyfp": "107",
    "countyns": "01581114",
    "dotregion": 5,
    "geoid": "55107",
    "lsad": "06",
    "name": "Rusk",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1212,
    "affgeoid": "0500000US55111",
    "aland": 2152007753,
    "awater": 45296336,
    "countyfp": "111",
    "countyns": "01581115",
    "dotregion": 5,
    "geoid": "55111",
    "lsad": "06",
    "name": "Sauk",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 391,
    "affgeoid": "0500000US55113",
    "aland": 3256416500,
    "awater": 240690443,
    "countyfp": "113",
    "countyns": "01581116",
    "dotregion": 5,
    "geoid": "55113",
    "lsad": "06",
    "name": "Sawyer",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2551,
    "affgeoid": "0500000US55115",
    "aland": 2312909682,
    "awater": 42507999,
    "countyfp": "115",
    "countyns": "01581117",
    "dotregion": 5,
    "geoid": "55115",
    "lsad": "06",
    "name": "Shawano",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2016,
    "affgeoid": "0500000US55117",
    "aland": 1324200980,
    "awater": 1968279272,
    "countyfp": "117",
    "countyns": "01581118",
    "dotregion": 5,
    "geoid": "55117",
    "lsad": "06",
    "name": "Sheboygan",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 584,
    "affgeoid": "0500000US55109",
    "aland": 1871216493,
    "awater": 34193343,
    "countyfp": "109",
    "countyns": "01581833",
    "dotregion": 5,
    "geoid": "55109",
    "lsad": "06",
    "name": "St. Croix",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 160,
    "affgeoid": "0500000US55119",
    "aland": 2524953482,
    "awater": 24687534,
    "countyfp": "119",
    "countyns": "01581119",
    "dotregion": 5,
    "geoid": "55119",
    "lsad": "06",
    "name": "Taylor",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 678,
    "affgeoid": "0500000US55121",
    "aland": 1898472851,
    "awater": 23370972,
    "countyfp": "121",
    "countyns": "01581120",
    "dotregion": 5,
    "geoid": "55121",
    "lsad": "06",
    "name": "Trempealeau",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1708,
    "affgeoid": "0500000US55123",
    "aland": 2050126416,
    "awater": 64295958,
    "countyfp": "123",
    "countyns": "01581121",
    "dotregion": 5,
    "geoid": "55123",
    "lsad": "06",
    "name": "Vernon",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2442,
    "affgeoid": "0500000US55125",
    "aland": 2218383962,
    "awater": 417645337,
    "countyfp": "125",
    "countyns": "01581122",
    "dotregion": 5,
    "geoid": "55125",
    "lsad": "06",
    "name": "Vilas",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2948,
    "affgeoid": "0500000US55127",
    "aland": 1438080813,
    "awater": 55247228,
    "countyfp": "127",
    "countyns": "01581123",
    "dotregion": 5,
    "geoid": "55127",
    "lsad": "06",
    "name": "Walworth",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 1862,
    "affgeoid": "0500000US55129",
    "aland": 2064513282,
    "awater": 145566487,
    "countyfp": "129",
    "countyns": "01581124",
    "dotregion": 5,
    "geoid": "55129",
    "lsad": "06",
    "name": "Washburn",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2087,
    "affgeoid": "0500000US55131",
    "aland": 1115332519,
    "awater": 13000033,
    "countyfp": "131",
    "countyns": "01581125",
    "dotregion": 5,
    "geoid": "55131",
    "lsad": "06",
    "name": "Washington",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 161,
    "affgeoid": "0500000US55133",
    "aland": 1423469305,
    "awater": 80118638,
    "countyfp": "133",
    "countyns": "01581126",
    "dotregion": 5,
    "geoid": "55133",
    "lsad": "06",
    "name": "Waukesha",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 48,
    "affgeoid": "0500000US55135",
    "aland": 1936326592,
    "awater": 45301382,
    "countyfp": "135",
    "countyns": "01581127",
    "dotregion": 5,
    "geoid": "55135",
    "lsad": "06",
    "name": "Waupaca",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2049,
    "affgeoid": "0500000US55137",
    "aland": 1621822272,
    "awater": 29076012,
    "countyfp": "137",
    "countyns": "01581128",
    "dotregion": 5,
    "geoid": "55137",
    "lsad": "06",
    "name": "Waushara",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2656,
    "affgeoid": "0500000US55139",
    "aland": 1125314828,
    "awater": 373176432,
    "countyfp": "139",
    "countyns": "01581129",
    "dotregion": 5,
    "geoid": "55139",
    "lsad": "06",
    "name": "Winnebago",
    "stateAbbreviation": "WI",
    "stateId": 5
  }, {
    "id": 2403,
    "affgeoid": "0500000US55141",
    "aland": 2053722456,
    "awater": 42296681,
    "countyfp": "141",
    "countyns": "01581130",
    "dotregion": 5,
    "geoid": "55141",
    "lsad": "06",
    "name": "Wood",
    "stateAbbreviation": "WI",
    "stateId": 5
  }]
}, {
  "id": 30,
  "abbreviation": "WY",
  "affgeoid": "0400000US56",
  "aland": 251465042238,
  "awater": 1861255811,
  "dotregion": 8,
  "geoid": "56",
  "lsad": "00",
  "name": "Wyoming",
  "stateAbbreviation": "WY",
  "statefp": "56",
  "statens": "01779807",
  "counties": [{
    "id": 1592,
    "affgeoid": "0500000US56001",
    "aland": 11070466383,
    "awater": 89161368,
    "countyfp": "001",
    "countyns": "01605066",
    "dotregion": 8,
    "geoid": "56001",
    "lsad": "06",
    "name": "Albany",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 3005,
    "affgeoid": "0500000US56003",
    "aland": 8123483829,
    "awater": 56428287,
    "countyfp": "003",
    "countyns": "01605067",
    "dotregion": 8,
    "geoid": "56003",
    "lsad": "06",
    "name": "Big Horn",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 507,
    "affgeoid": "0500000US56005",
    "aland": 12437852902,
    "awater": 10357549,
    "countyfp": "005",
    "countyns": "01605068",
    "dotregion": 8,
    "geoid": "56005",
    "lsad": "06",
    "name": "Campbell",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 1174,
    "affgeoid": "0500000US56007",
    "aland": 20454562375,
    "awater": 172002531,
    "countyfp": "007",
    "countyns": "01605069",
    "dotregion": 8,
    "geoid": "56007",
    "lsad": "06",
    "name": "Carbon",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 654,
    "affgeoid": "0500000US56009",
    "aland": 11020068482,
    "awater": 26384811,
    "countyfp": "009",
    "countyns": "01605070",
    "dotregion": 8,
    "geoid": "56009",
    "lsad": "06",
    "name": "Converse",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 1724,
    "affgeoid": "0500000US56011",
    "aland": 7393036956,
    "awater": 28186053,
    "countyfp": "011",
    "countyns": "01605071",
    "dotregion": 8,
    "geoid": "56011",
    "lsad": "06",
    "name": "Crook",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 3106,
    "affgeoid": "0500000US56013",
    "aland": 23786090581,
    "awater": 212125873,
    "countyfp": "013",
    "countyns": "01605072",
    "dotregion": 8,
    "geoid": "56013",
    "lsad": "06",
    "name": "Fremont",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 1584,
    "affgeoid": "0500000US56015",
    "aland": 5763721693,
    "awater": 17580887,
    "countyfp": "015",
    "countyns": "01605073",
    "dotregion": 8,
    "geoid": "56015",
    "lsad": "06",
    "name": "Goshen",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 619,
    "affgeoid": "0500000US56017",
    "aland": 5190598635,
    "awater": 5964358,
    "countyfp": "017",
    "countyns": "01605074",
    "dotregion": 8,
    "geoid": "56017",
    "lsad": "06",
    "name": "Hot Springs",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 1140,
    "affgeoid": "0500000US56019",
    "aland": 10759203372,
    "awater": 52947545,
    "countyfp": "019",
    "countyns": "01609191",
    "dotregion": 8,
    "geoid": "56019",
    "lsad": "06",
    "name": "Johnson",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2110,
    "affgeoid": "0500000US56021",
    "aland": 6956499752,
    "awater": 4269804,
    "countyfp": "021",
    "countyns": "01605075",
    "dotregion": 8,
    "geoid": "56021",
    "lsad": "06",
    "name": "Laramie",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2542,
    "affgeoid": "0500000US56023",
    "aland": 10557370099,
    "awater": 49925437,
    "countyfp": "023",
    "countyns": "01605076",
    "dotregion": 8,
    "geoid": "56023",
    "lsad": "06",
    "name": "Lincoln",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 1906,
    "affgeoid": "0500000US56025",
    "aland": 13831870242,
    "awater": 91060478,
    "countyfp": "025",
    "countyns": "01605077",
    "dotregion": 8,
    "geoid": "56025",
    "lsad": "06",
    "name": "Natrona",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2651,
    "affgeoid": "0500000US56027",
    "aland": 6801350403,
    "awater": 4969450,
    "countyfp": "027",
    "countyns": "01605078",
    "dotregion": 8,
    "geoid": "56027",
    "lsad": "06",
    "name": "Niobrara",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2422,
    "affgeoid": "0500000US56029",
    "aland": 17973868777,
    "awater": 65646894,
    "countyfp": "029",
    "countyns": "01605079",
    "dotregion": 8,
    "geoid": "56029",
    "lsad": "06",
    "name": "Park",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2323,
    "affgeoid": "0500000US56031",
    "aland": 5398028543,
    "awater": 69035952,
    "countyfp": "031",
    "countyns": "01605080",
    "dotregion": 8,
    "geoid": "56031",
    "lsad": "06",
    "name": "Platte",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2232,
    "affgeoid": "0500000US56033",
    "aland": 6535552388,
    "awater": 7986323,
    "countyfp": "033",
    "countyns": "01605081",
    "dotregion": 8,
    "geoid": "56033",
    "lsad": "06",
    "name": "Sheridan",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2945,
    "affgeoid": "0500000US56035",
    "aland": 12655989775,
    "awater": 127353628,
    "countyfp": "035",
    "countyns": "01605082",
    "dotregion": 8,
    "geoid": "56035",
    "lsad": "06",
    "name": "Sublette",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 3060,
    "affgeoid": "0500000US56037",
    "aland": 27005056306,
    "awater": 166887297,
    "countyfp": "037",
    "countyns": "01609192",
    "dotregion": 8,
    "geoid": "56037",
    "lsad": "06",
    "name": "Sweetwater",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 1409,
    "affgeoid": "0500000US56039",
    "aland": 10349561687,
    "awater": 570879628,
    "countyfp": "039",
    "countyns": "01605083",
    "dotregion": 8,
    "geoid": "56039",
    "lsad": "06",
    "name": "Teton",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2801,
    "affgeoid": "0500000US56041",
    "aland": 5391916735,
    "awater": 16345637,
    "countyfp": "041",
    "countyns": "01605084",
    "dotregion": 8,
    "geoid": "56041",
    "lsad": "06",
    "name": "Uinta",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 1817,
    "affgeoid": "0500000US56043",
    "aland": 5797822374,
    "awater": 10754321,
    "countyfp": "043",
    "countyns": "01605085",
    "dotregion": 8,
    "geoid": "56043",
    "lsad": "06",
    "name": "Washakie",
    "stateAbbreviation": "WY",
    "stateId": 30
  }, {
    "id": 2990,
    "affgeoid": "0500000US56045",
    "aland": 6211069949,
    "awater": 5001700,
    "countyfp": "045",
    "countyns": "01605086",
    "dotregion": 8,
    "geoid": "56045",
    "lsad": "06",
    "name": "Weston",
    "stateAbbreviation": "WY",
    "stateId": 30
  }]
}];
var TabIndexes;
(function (TabIndexes) {
  TabIndexes[TabIndexes["States"] = 0] = "States";
  TabIndexes[TabIndexes["Counties"] = 1] = "Counties";
  TabIndexes[TabIndexes["Zip"] = 2] = "Zip";
})(TabIndexes || (TabIndexes = {}));
class VulcanLocationFilterComponent {
  constructor() {
    this.tabGroup = viewChild.required('tabGroup');
    /**
     * Track when the component is performing an operation. Iterating through counties can get expensive and you may want to employ a loading indicator
     */
    this.loading = output();
    /**
     * Track the selected options as they change
     */
    this.dataChange = output();
    this.locationData = {
      codes: [],
      aggregationLevel: null
    };
    /**
     * Show the aggregation level selection
     */
    this.showAggregationLevels = input(true);
    /**
     * Manually set the aggregation level.
     * If `showAggregationLevels === false` but you still want the aggregation level to be "county" then you can default it here.
     */
    this.autoSelectAggregationLevel = input();
    /**
     * The different aggregation levels you want to use.
     * Default: ['state', 'county', 'zip', 'utility']
     */
    this.aggregationLevels = input(VULCAN_DEFAULT_AGGREGATION_LEVELS);
    this.namesTooLongRegex = new RegExp(/Commonwealth of the Northern |United States /i);
    /**
     * The mapped array containing the states and their respective counties
     */
    this.statesAndCounties = input(VULCAN_DEFAULT_STATE_AND_COUNTIES.map(s => {
      if (this.namesTooLongRegex.test(s.name)) {
        s.name = s.name.replace(this.namesTooLongRegex, '');
      }
      return s;
    }));
    /**
     * Show the counties toolbar
     */
    this.showCounties = input(true);
    /**
     * The FEMA regions you want to include.
     * Default: FEMA Regions 1 - 10
     */
    this.femaRegions = input(VULCAN_DEFAULT_FEMA_REGIONS);
    /**
     * Show the FEMA Regions options toolbar
     */
    this.showFemaRegions = input(true);
    /**
     * Manually set which codes are selected.
     * How its applied will be based on the aggregation level
     */
    this.autoSelectCodes = input();
    /**
     * Set the desired palette color of the checkboxes. Only works for
     * M2.
     *
     * Default: 'primary'
     */
    this.m2CheckboxColor = input('primary');
    this.fb = inject(NonNullableFormBuilder);
    this.locationForm = this.fb.group({
      level: this.fb.control(null, Validators.required),
      stateSearch: this.fb.control(''),
      countiesSearch: this.fb.control(''),
      regions: this.fb.array(this.buildFemaControls(this.femaRegions())),
      states: this.fb.array(this.buildStateControls(this.statesAndCounties()), Validators.minLength(1))
    });
    this.aggregationChangeSubscription$ = this.aggregationLevelControl.valueChanges.pipe(debounceTime(500), takeUntilDestroyed()).subscribe(() => {
      this.handleUpdatingBasedOnAggregationLevelChange();
      this.updateLocationData();
    });
    this.stateControlsChangesSubscription$ = this.stateControls.valueChanges.pipe(debounceTime(500), takeUntilDestroyed()).subscribe(() => {
      this.updateLocationData();
    });
    /**
     * If the user is on the counties tab and the aggregation level changes to "state"
     * make the switch back on the tabs
     */
    this.updateTabOnLevelChangesSubscription$ = this.aggregationLevelControl.valueChanges.pipe(debounceTime(500), takeUntilDestroyed()).subscribe(level => {
      if (level !== 'county' && this.tabIndex === TabIndexes.Counties) {
        this.tabGroup().selectedIndex = TabIndexes.States;
      }
    });
    this.tabIndex = TabIndexes.States;
  }
  get countiesDisabled() {
    return this.locationForm.controls.level.value !== 'county' && this.autoSelectAggregationLevel() !== 'county';
  }
  get stateControls() {
    return this.locationForm.controls.states;
  }
  get selectedStateControlsCount() {
    return this.stateControls.controls.filter(c => c.value.checked).length;
  }
  get femaControls() {
    return this.locationForm.controls.regions;
  }
  get countiesThatMatchSearch() {
    return this.stateControls.controls.filter(s => this.showStateName(s));
  }
  get statesThatMatchSearch() {
    return this.stateControls.controls.filter(s => this.matchesSearch(s.value.name));
  }
  get stateSearchValue() {
    return this.locationForm.controls.stateSearch.value || '';
  }
  get countySearchValue() {
    return this.locationForm.controls.countiesSearch.value || '';
  }
  get aggregationLevelControl() {
    return this.locationForm.controls.level;
  }
  get aggregationLevel() {
    return this.locationForm.controls.level.value || null;
  }
  ngOnInit() {}
  /**
   * These actions should only occur when a bound input changes. Most of them _should_ run
   * only once. The autoSelectAggregationLevel and autoSelectCodes could potentially
   * run more than once.
   */
  ngOnChanges(changes) {
    if (changes.statesAndCounties?.currentValue && !changes.statesAndCounties?.isFirstChange()) {
      this.handleUpdateStateControlsFromInputs(changes.statesAndCounties?.currentValue);
    }
    if (changes.femaRegions?.currentValue && !changes.femaRegions?.isFirstChange()) {
      this.handleUpdateFemaRegionsFromInputs(changes.femaRegions?.currentValue);
    }
    if (changes.autoSelectAggregationLevel?.currentValue !== undefined) {
      this.locationForm.patchValue({
        level: changes.autoSelectAggregationLevel?.currentValue
      });
    }
    if (changes.autoSelectCodes?.currentValue) {
      this.handleUpdatingBasedOnAutoSelectedCodes();
    }
  }
  /**
   * Update the selected counties based on what the new aggregation level is
   * exe: you checked Alabama, then selected "States". Then you selected "counties".
   * We then need to check or uncheck the relevant counties.
   *
   * I'd like to find a better way to do this since it can be expensive
   */
  handleUpdatingBasedOnAggregationLevelChange() {
    const level = this.aggregationLevel;
    this.stateControls.controls.forEach(stateControl => {
      const stateIsSelected = stateControl.value.checked;
      stateControl.controls.counties?.controls.forEach(countyControl => {
        countyControl.patchValue({
          checked: level === 'county' && stateIsSelected
        }, {
          emitEvent: false
        });
      });
    });
  }
  /**
   * Should only update when the auto selected codes or the auto selected aggregation level changes.
   * Updates what is selected based off of those two data points
   */
  handleUpdatingBasedOnAutoSelectedCodes() {
    const selectedCodes = this.autoSelectCodes() || this.setCodes();
    const level = this.aggregationLevel;
    this.stateControls.controls.forEach(stateControl => {
      let newSelectedValue = false;
      let stateSelected = false;
      const countyControls = stateControl.controls.counties;
      if (level !== 'county') {
        newSelectedValue = selectedCodes.includes(stateControl.value.geoid);
        stateSelected = newSelectedValue;
      }
      countyControls?.controls.forEach(countyControl => {
        if (level !== 'county') {
          // Make sure all counties are unchecked if the aggregation level is state
          countyControl.patchValue({
            checked: false
          });
          // If the selected codes include county codes even though we want state values
          if (selectedCodes.includes(countyControl.value.geoid)) {
            newSelectedValue = true;
          }
        }
        if (level === 'county') {
          if (selectedCodes.includes(countyControl.value.geoid) || stateSelected) {
            newSelectedValue = true;
          }
        }
      });
      // Only update the stateControl here, not the county. The county control will be updated
      // in handleStateToggle()
      stateControl.patchValue({
        checked: newSelectedValue
      });
      this.handleStateToggle(newSelectedValue, stateControl);
    });
  }
  /**
   *
   * @param states
   * This is only called onChanges if the user sets a different list of states
   */
  handleUpdateStateControlsFromInputs(states) {
    while (this.stateControls.controls.length) {
      this.stateControls.removeAt(0);
    }
    const sortedStates = states.sort((a, b) => a?.name > b?.name ? 1 : -1);
    const stateControls = this.buildStateControls(sortedStates);
    stateControls.forEach(control => {
      this.stateControls.push(control, {
        emitEvent: false
      });
    });
  }
  /**
   *
   * @param regions
   * Only called from onChanges if the user sets a specific set of fema regions
   */
  handleUpdateFemaRegionsFromInputs(regions) {
    while (this.femaControls.length) {
      this.femaControls.removeAt(0);
    }
    const sortedRegions = (regions ? regions : this.femaRegions()).sort((a, b) => a.id > b.id ? 1 : -1);
    const femaControls = this.buildFemaControls(sortedRegions);
    femaControls.forEach(control => this.femaControls.push(control, {
      emitEvent: false
    }));
  }
  /**
   *
   * @param regions
   * @returns
   *
   * Builds the fema region controls based on inputs or defaults
   */
  buildFemaControls(regions) {
    const controls = [];
    regions.forEach(region => {
      controls.push(new FormGroup({
        id: this.fb.control(region.id),
        name: this.fb.control(region.name),
        checked: this.fb.control(false),
        region: this.fb.control(region)
      }));
    });
    return controls;
  }
  /**
   *
   * @param states
   * @returns
   *
   * Build state and their county controls based on input or defaults
   */
  buildStateControls(states) {
    const controls = states?.map(state => {
      return new FormGroup({
        id: this.fb.control(state.id),
        geoid: this.fb.control(state.geoid),
        name: this.fb.control(state.name),
        checked: this.fb.control(false),
        state: this.fb.control(state),
        counties: this.fb.array(state.counties?.map(c => {
          return this.fb.group({
            id: this.fb.control(c.id),
            geoid: this.fb.control(c.geoid),
            name: this.fb.control(c.name),
            checked: this.fb.control(false),
            county: this.fb.control(c)
          });
        }) || [])
      });
    });
    return controls;
  }
  /**
   * Update controls if a FEMA region is toggled
   */
  handleFemaToggle(event, region) {
    this.stateControls.controls.forEach(control => {
      const state = control.value.state;
      if (state.dotregion === region?.id) {
        control.patchValue({
          checked: event.checked
        }, {
          emitEvent: false
        });
        control.controls.counties.controls.forEach(county => {
          county.patchValue({
            checked: event.checked
          }, {
            emitEvent: false
          });
        });
      }
    });
    this.stateControls.updateValueAndValidity();
    this.stateControls.markAsTouched();
  }
  /**
   *
   * @param event
   * @param state
   * @param updateCounties
   *
   * Update a state control either by the user selecting it or if its passed in as an input
   * When called manually, the selected state's value must be set before hand because thats how the
   * template will react
   */
  handleStateToggle(checked, state) {
    const updateCounties = this.aggregationLevel === 'county';
    // Update wether or not the FEMA region checkbox is also checked
    const allFemaRegionsMatch = this.stateControls.value.filter(value => value.state?.dotregion === state.value.state?.dotregion).every(value => value.checked === checked);
    const regionControlIndex = this.femaControls.controls.findIndex(control => control.value.id === state.value.state?.dotregion);
    this.femaControls.at(regionControlIndex).patchValue({
      checked: allFemaRegionsMatch ? checked : false
    });
    // Update the counties if its checked AND the aggregation level is county
    state.controls.counties?.controls.forEach(county => {
      county.patchValue({
        checked: checked && updateCounties
      }, {
        emitEvent: false
      });
    });
    this.stateControls.updateValueAndValidity();
    this.stateControls.markAsTouched();
  }
  /**
   *
   * @param checked
   * @param stateForCounties
   *
   * Toggle the selection of all counties
   */
  toggleAll(checked, stateForCounties) {
    this.loading.emit(true);
    if (this.tabIndex === TabIndexes.States) {
      this.femaControls.controls.forEach(region => {
        region.patchValue({
          checked
        }, {
          emitEvent: false
        });
      });
    }
    this.stateControls.controls.forEach(state => {
      if (this.tabIndex === TabIndexes.States) {
        state.patchValue({
          checked
        });
        // If the aggregation level is set to counties AND we are on the state tab, we want to silently update all the
        // counties for each state or there will be know emitted values
        if (this.aggregationLevel === 'county') {
          state.controls.counties?.controls.forEach(county => {
            county.patchValue({
              checked: checked
            }, {
              emitEvent: false
            });
          });
        }
      } else {
        if (stateForCounties) {
          if (state.value.id === stateForCounties.id) {
            state.controls.counties.controls.forEach(county => {
              county.patchValue({
                checked
              }, {
                emitEvent: false
              });
            });
          }
        } else {
          state.controls.counties.controls.forEach(county => {
            county.patchValue({
              checked
            }, {
              emitEvent: false
            });
          });
        }
      }
    });
    this.stateControls.updateValueAndValidity();
    this.stateControls.markAsTouched();
    setTimeout(() => {
      this.loading.emit(false);
    }, 500);
  }
  /**
   *
   * @param name
   * @param forCounties If this is filtering states or counties
   * @returns boolean
   *
   * Returns true if the a state or county's name matches the search
   */
  matchesSearch(name, forCounties = false) {
    const filter = this.locationForm.get(forCounties ? 'countiesSearch' : 'stateSearch')?.value?.toLowerCase().replace(' ', '');
    if (filter) {
      return new RegExp(filter).test(name?.toLowerCase().replace(' ', '') || '');
    }
    return true;
  }
  /**
   *
   * @param state FormGroup<StateControl>
   * @returns
   *
   * Returns the counties for a specific state control
   */
  getCounties(state) {
    return state.controls.counties;
  }
  /**
   *
   * @returns
   * Build out which codes are sent to the consuming component based off of the aggregation level
   */
  setCodes() {
    const rawCodes = this.stateControls.getRawValue();
    let codes = [];
    const selectedStates = rawCodes.filter(state => state.checked);
    const level = this.aggregationLevel;
    if (level !== 'county') {
      codes = selectedStates.map(state => state.state?.statefp || '');
    } else if (level === 'county') {
      selectedStates.forEach(state => {
        const selectedCounties = state.counties?.filter(county => county.checked).map(county => county.county?.geoid) || [];
        codes = codes.concat(selectedCounties);
      });
    }
    return codes;
  }
  /**
   * Emit a change in the location data
   * Should only emit if there is a change but it should emit for every change, even if
   * data is invalid or null
   */
  updateLocationData() {
    const codes = this.setCodes();
    const form = this.locationForm.value;
    const oldCodes = JSON.stringify(this.locationData.codes.sort());
    const oldLevel = this.locationData.aggregationLevel;
    this.locationData = {
      codes,
      aggregationLevel: form.level
    };
    this.dataChange.emit(this.locationData);
  }
  showStateName(state) {
    const value = state.getRawValue();
    if (!value.checked) {
      return false;
    }
    return value.counties?.some(c => this.matchesSearch(c.name, true)) || false;
  }
  static {
    this.ɵfac = function VulcanLocationFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VulcanLocationFilterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VulcanLocationFilterComponent,
      selectors: [["vulcan-location-filter"]],
      viewQuery: function VulcanLocationFilterComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.tabGroup, _c3, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      inputs: {
        showAggregationLevels: [1, "showAggregationLevels"],
        autoSelectAggregationLevel: [1, "autoSelectAggregationLevel"],
        aggregationLevels: [1, "aggregationLevels"],
        statesAndCounties: [1, "statesAndCounties"],
        showCounties: [1, "showCounties"],
        femaRegions: [1, "femaRegions"],
        showFemaRegions: [1, "showFemaRegions"],
        autoSelectCodes: [1, "autoSelectCodes"],
        m2CheckboxColor: [1, "m2CheckboxColor"]
      },
      outputs: {
        loading: "loading",
        dataChange: "dataChange"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 7,
      vars: 4,
      consts: [["states", ""], ["tabGroup", ""], [3, "formGroup"], [1, "aggregation-info"], [3, "selectedIndex"], [3, "ngTemplateOutlet"], [1, "controls"], ["appearance", "outline", 1, "filter-select"], ["id", "aggregation-level-select", "placeholder", "Aggregation Level", "formControlName", "level"], [3, "value", "id"], [3, "selectedIndexChange", "selectedIndex"], ["label", "States"], ["label", "Counties", 3, "disabled"], [1, "header"], ["appearance", "outline"], ["matInput", "", "formControlName", "countiesSearch"], [1, "actions"], ["id", "select-all-counties-btn", "mat-flat-button", "", "color", "primary", 3, "click"], ["mat-flat-button", "", "id", "clear-all-counties-btn", 3, "click"], ["id", "min-selection-err"], [1, "checkbox-list"], ["formArrayName", "states"], [1, "state-wrapper"], [1, "county-header"], ["mat-mini-fab", "", "color", "primary", 3, "click", "id", "matTooltip"], ["mat-mini-fab", "", 3, "click", "id", "matTooltip"], ["formArrayName", "counties"], ["formControlName", "checked", 3, "color", "id"], ["matInput", "", "formControlName", "stateSearch", "id", "search-state-names-input"], ["mat-flat-button", "", "color", "primary", "id", "select-all-states-btn", 3, "click"], ["mat-flat-button", "", "id", "clear-all-states-btn", 3, "click"], [1, "fema-regions-container"], [1, "states-container"], ["id", "total-selected-states"], ["formArrayName", "regions"], ["formControlName", "checked", 3, "change", "color", "id"]],
      template: function VulcanLocationFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div")(1, "form", 2);
          i0.ɵɵtemplate(2, VulcanLocationFilterComponent_Conditional_2_Template, 12, 0, "div", 3)(3, VulcanLocationFilterComponent_Conditional_3_Template, 25, 5, "mat-tab-group", 4)(4, VulcanLocationFilterComponent_Conditional_4_Template, 1, 1, "ng-container", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(5, VulcanLocationFilterComponent_ng_template_5_Template, 21, 5, "ng-template", 2, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.locationForm);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showAggregationLevels() ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showCounties() ? 3 : 4);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.locationForm);
        }
      },
      dependencies: [CommonModule, i1.NgTemplateOutlet, i1.DecimalPipe, i1.TitleCasePipe, FormsModule, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, MatFormFieldModule, i3.MatFormField, i3.MatLabel, i3.MatError, MatIconModule, i4$1.MatIcon, MatSelectModule, i5$1.MatSelect, i6.MatOption, ReactiveFormsModule, i2.FormGroupDirective, i2.FormControlName, i2.FormArrayName, MatTabsModule, i7.MatTab, i7.MatTabGroup, MatCheckboxModule, i8.MatCheckbox, MatButtonModule, i9.MatButton, i9.MatMiniFabButton, MatTooltipModule, i10.MatTooltip, MatInputModule, i11.MatInput],
      styles: [".state-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:100%}.aggregation-info[_ngcontent-%COMP%]{display:flex;justify-content:space-between;flex-wrap:wrap;gap:1rem;margin-bottom:1.5rem}.aggregation-info[_ngcontent-%COMP%]   .controls[_ngcontent-%COMP%]{display:flex;flex-direction:column}.aggregation-info[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{width:60%;margin:0}.checkbox-list[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;flex-wrap:wrap}.checkbox-list[_ngcontent-%COMP%]   mat-checkbox[_ngcontent-%COMP%]{flex-basis:18%;flex-grow:1;margin:.5rem 0;max-width:160px}.checkbox-list[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-of-type{margin-left:1rem}.header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin-top:1rem;gap:1rem}.header[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{flex-grow:1}.header[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex;gap:1rem;height:3.65rem}.county-header[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;margin-right:1rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VulcanLocationFilterComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-location-filter',
      imports: [CommonModule, FormsModule, MatFormFieldModule, MatIconModule, MatSelectModule, ReactiveFormsModule, MatTabsModule, MatCheckboxModule, MatButtonModule, MatTooltipModule, MatInputModule],
      standalone: true,
      template: "<div>\n  <form [formGroup]=\"locationForm\">\n    @if (showAggregationLevels()) {\n      <div class=\"aggregation-info\">\n        <div class=\"controls\">\n          <mat-form-field class=\"filter-select\" appearance=\"outline\">\n            <mat-label> Aggregation Level</mat-label>\n            <mat-select\n              id=\"aggregation-level-select\"\n              placeholder=\"Aggregation Level\"\n              formControlName=\"level\">\n              @for (level of aggregationLevels(); track level) {\n                <mat-option [value]=\"level\" [id]=\"'aggregation-level-option-' + level\"\n                  >{{ level.toString() | titlecase }}\n                </mat-option>\n              }\n            </mat-select>\n            <mat-error> An aggregation level is required.</mat-error>\n          </mat-form-field>\n        </div>\n\n        <p>\n          Aggregation Level will determine which codes are used to get data. All levels will utilize\n          a state's FIPS Code except County, which uses its own code.\n        </p>\n      </div>\n    }\n\n    @if (showCounties()) {\n      <mat-tab-group #tabGroup [(selectedIndex)]=\"tabIndex\">\n        <mat-tab label=\"States\">\n          <ng-container [ngTemplateOutlet]=\"states\"></ng-container>\n        </mat-tab>\n\n        <mat-tab label=\"Counties\" [disabled]=\"countiesDisabled\">\n          <div class=\"header\">\n            <mat-form-field appearance=\"outline\">\n              <mat-label>Search County Names</mat-label>\n              <input matInput formControlName=\"countiesSearch\" />\n            </mat-form-field>\n\n            <div class=\"actions\">\n              <button\n                id=\"select-all-counties-btn\"\n                mat-flat-button\n                color=\"primary\"\n                (click)=\"toggleAll(true)\">\n                Select All\n                <mat-icon>done_all</mat-icon>\n              </button>\n              <button mat-flat-button (click)=\"toggleAll(false)\" id=\"clear-all-counties-btn\">\n                Clear All\n                <mat-icon>cancel</mat-icon>\n              </button>\n            </div>\n          </div>\n          <div>\n            <h2>States/Territories</h2>\n\n            @if (selectedStateControlsCount === 0) {\n              <h3 id=\"min-selection-err\">At least one state must be selected</h3>\n            }\n\n            @if (countiesThatMatchSearch.length) {\n              <div class=\"checkbox-list\">\n                <ng-container formArrayName=\"states\">\n                  @for (state of countiesThatMatchSearch; track state; let i = $index) {\n                    <ng-container [formGroup]=\"state\">\n                      <div class=\"state-wrapper\">\n                        <div class=\"county-header\">\n                          <h3>{{ state.value.name }}</h3>\n                          <div class=\"actions\">\n                            <button\n                              [id]=\"'select-all-for-state-' + state.value.name\"\n                              mat-mini-fab\n                              color=\"primary\"\n                              [matTooltip]=\"'Select All: ' + state.value.name\"\n                              (click)=\"toggleAll(true, state.value.state)\">\n                              <mat-icon>done_all</mat-icon>\n                            </button>\n                            <button\n                              [id]=\"'clear-all-for-state-' + state.value.name\"\n                              mat-mini-fab\n                              [matTooltip]=\"'Clear All: ' + state.value.name\"\n                              (click)=\"toggleAll(false, state.value.state)\">\n                              <mat-icon>cancel</mat-icon>\n                            </button>\n                          </div>\n                        </div>\n\n                        <div class=\"checkbox-list\">\n                          <ng-container formArrayName=\"counties\">\n                            @for (county of getCounties(state).controls; track county) {\n                              <ng-container [formGroup]=\"county\">\n                                @if (matchesSearch(county.value.name, true)) {\n                                  <mat-checkbox\n                                    [color]=\"m2CheckboxColor()\"\n                                    formControlName=\"checked\"\n                                    [id]=\"'county-checkbox-' + county.value.geoid\">\n                                    {{ county.value.name }}\n                                  </mat-checkbox>\n                                }\n                              </ng-container>\n                            }\n                          </ng-container>\n                        </div>\n                      </div>\n                    </ng-container>\n                  }\n                </ng-container>\n              </div>\n            } @else {\n              <h3>No county names match \"{{ countySearchValue }}\"</h3>\n            }\n          </div>\n        </mat-tab>\n      </mat-tab-group>\n    } @else {\n      <ng-container [ngTemplateOutlet]=\"states\"></ng-container>\n    }\n  </form>\n</div>\n\n<ng-template #states [formGroup]=\"locationForm\">\n  <div class=\"header\">\n    <mat-form-field appearance=\"outline\">\n      <mat-label>Search State Names</mat-label>\n      <input matInput formControlName=\"stateSearch\" id=\"search-state-names-input\" />\n    </mat-form-field>\n\n    <div class=\"actions\">\n      <button mat-flat-button color=\"primary\" (click)=\"toggleAll(true)\" id=\"select-all-states-btn\">\n        Select All\n        <mat-icon>done_all</mat-icon>\n      </button>\n      <button mat-flat-button (click)=\"toggleAll(false)\" id=\"clear-all-states-btn\">\n        Clear All\n        <mat-icon>cancel</mat-icon>\n      </button>\n    </div>\n  </div>\n  @if (showFemaRegions()) {\n    <div class=\"fema-regions-container\">\n      <h2>FEMA Regions</h2>\n      <div class=\"checkbox-list\">\n        <ng-container formArrayName=\"regions\">\n          @for (region of femaControls.controls; track region; let i = $index) {\n            <ng-container [formGroup]=\"region\">\n              <mat-checkbox\n                [color]=\"m2CheckboxColor()\"\n                [id]=\"'fema-region-checkbox-' + region.value.id\"\n                formControlName=\"checked\"\n                (change)=\"handleFemaToggle($event, region.value.region)\">\n                {{ region.value.name }}\n              </mat-checkbox>\n            </ng-container>\n          }\n        </ng-container>\n      </div>\n    </div>\n  }\n  <div class=\"states-container\">\n    <h2 id=\"total-selected-states\">\n      States/Territories\n      {{\n        selectedStateControlsCount > 0\n          ? \"(\" + (selectedStateControlsCount | number) + \" selected)\"\n          : \"\"\n      }}\n    </h2>\n\n    @if (statesThatMatchSearch.length) {\n      <div class=\"checkbox-list\">\n        <ng-container formArrayName=\"states\">\n          @for (state of statesThatMatchSearch; track state; let i = $index) {\n            <ng-container [formGroup]=\"state\">\n              <mat-checkbox\n                [color]=\"m2CheckboxColor()\"\n                [id]=\"'state-checkbox-' + state.value.geoid\"\n                formControlName=\"checked\"\n                (change)=\"handleStateToggle($event.checked, state)\">\n                {{ state.value.name }}\n              </mat-checkbox>\n            </ng-container>\n          }\n        </ng-container>\n      </div>\n    } @else {\n      <h3>No states match \"{{ stateSearchValue }}\"</h3>\n    }\n  </div>\n</ng-template>\n",
      styles: [".state-wrapper{display:flex;flex-direction:column;width:100%}.aggregation-info{display:flex;justify-content:space-between;flex-wrap:wrap;gap:1rem;margin-bottom:1.5rem}.aggregation-info .controls{display:flex;flex-direction:column}.aggregation-info p{width:60%;margin:0}.checkbox-list{display:flex;justify-content:flex-start;flex-wrap:wrap}.checkbox-list mat-checkbox{flex-basis:18%;flex-grow:1;margin:.5rem 0;max-width:160px}.checkbox-list button:last-of-type{margin-left:1rem}.header{display:flex;justify-content:space-between;align-items:center;margin-top:1rem;gap:1rem}.header mat-form-field{flex-grow:1}.header .actions{display:flex;gap:1rem;height:3.65rem}.county-header{display:flex;align-items:center;justify-content:space-between;margin-right:1rem}\n"]
    }]
  }], null, null);
})();
/**
 * @deprecated
 * Switch to the `VulcanLocationFilterComponent`
 */
class LocationFilterComponent extends VulcanLocationFilterComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵLocationFilterComponent_BaseFactory;
      return function LocationFilterComponent_Factory(__ngFactoryType__) {
        return (ɵLocationFilterComponent_BaseFactory || (ɵLocationFilterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(LocationFilterComponent)))(__ngFactoryType__ || LocationFilterComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LocationFilterComponent,
      selectors: [["vulcan-location-filter"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 4,
      consts: [["states", ""], ["tabGroup", ""], [3, "formGroup"], [1, "aggregation-info"], [3, "selectedIndex"], [3, "ngTemplateOutlet"], [1, "controls"], ["appearance", "outline", 1, "filter-select"], ["id", "aggregation-level-select", "placeholder", "Aggregation Level", "formControlName", "level"], [3, "value", "id"], [3, "selectedIndexChange", "selectedIndex"], ["label", "States"], ["label", "Counties", 3, "disabled"], [1, "header"], ["appearance", "outline"], ["matInput", "", "formControlName", "countiesSearch"], [1, "actions"], ["id", "select-all-counties-btn", "mat-flat-button", "", "color", "primary", 3, "click"], ["mat-flat-button", "", "id", "clear-all-counties-btn", 3, "click"], ["id", "min-selection-err"], [1, "checkbox-list"], ["formArrayName", "states"], [1, "state-wrapper"], [1, "county-header"], ["mat-mini-fab", "", "color", "primary", 3, "click", "id", "matTooltip"], ["mat-mini-fab", "", 3, "click", "id", "matTooltip"], ["formArrayName", "counties"], ["formControlName", "checked", 3, "color", "id"], ["matInput", "", "formControlName", "stateSearch", "id", "search-state-names-input"], ["mat-flat-button", "", "color", "primary", "id", "select-all-states-btn", 3, "click"], ["mat-flat-button", "", "id", "clear-all-states-btn", 3, "click"], [1, "fema-regions-container"], [1, "states-container"], ["id", "total-selected-states"], ["formArrayName", "regions"], ["formControlName", "checked", 3, "change", "color", "id"]],
      template: function LocationFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div")(1, "form", 2);
          i0.ɵɵtemplate(2, LocationFilterComponent_Conditional_2_Template, 12, 0, "div", 3)(3, LocationFilterComponent_Conditional_3_Template, 25, 5, "mat-tab-group", 4)(4, LocationFilterComponent_Conditional_4_Template, 1, 1, "ng-container", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(5, LocationFilterComponent_ng_template_5_Template, 21, 5, "ng-template", 2, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.locationForm);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showAggregationLevels() ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showCounties() ? 3 : 4);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.locationForm);
        }
      },
      dependencies: [CommonModule, i1.NgTemplateOutlet, i1.DecimalPipe, i1.TitleCasePipe, FormsModule, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, MatFormFieldModule, i3.MatFormField, i3.MatLabel, i3.MatError, MatIconModule, i4$1.MatIcon, MatSelectModule, i5$1.MatSelect, i6.MatOption, ReactiveFormsModule, i2.FormGroupDirective, i2.FormControlName, i2.FormArrayName, MatTabsModule, i7.MatTab, i7.MatTabGroup, MatCheckboxModule, i8.MatCheckbox, MatButtonModule, i9.MatButton, i9.MatMiniFabButton, MatTooltipModule, i10.MatTooltip, MatInputModule, i11.MatInput],
      styles: [_c4]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationFilterComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-location-filter',
      standalone: true,
      imports: [CommonModule, FormsModule, MatFormFieldModule, MatIconModule, MatSelectModule, ReactiveFormsModule, MatTabsModule, MatCheckboxModule, MatButtonModule, MatTooltipModule, MatInputModule],
      template: "<div>\n  <form [formGroup]=\"locationForm\">\n    @if (showAggregationLevels()) {\n      <div class=\"aggregation-info\">\n        <div class=\"controls\">\n          <mat-form-field class=\"filter-select\" appearance=\"outline\">\n            <mat-label> Aggregation Level</mat-label>\n            <mat-select\n              id=\"aggregation-level-select\"\n              placeholder=\"Aggregation Level\"\n              formControlName=\"level\">\n              @for (level of aggregationLevels(); track level) {\n                <mat-option [value]=\"level\" [id]=\"'aggregation-level-option-' + level\"\n                  >{{ level.toString() | titlecase }}\n                </mat-option>\n              }\n            </mat-select>\n            <mat-error> An aggregation level is required.</mat-error>\n          </mat-form-field>\n        </div>\n\n        <p>\n          Aggregation Level will determine which codes are used to get data. All levels will utilize\n          a state's FIPS Code except County, which uses its own code.\n        </p>\n      </div>\n    }\n\n    @if (showCounties()) {\n      <mat-tab-group #tabGroup [(selectedIndex)]=\"tabIndex\">\n        <mat-tab label=\"States\">\n          <ng-container [ngTemplateOutlet]=\"states\"></ng-container>\n        </mat-tab>\n\n        <mat-tab label=\"Counties\" [disabled]=\"countiesDisabled\">\n          <div class=\"header\">\n            <mat-form-field appearance=\"outline\">\n              <mat-label>Search County Names</mat-label>\n              <input matInput formControlName=\"countiesSearch\" />\n            </mat-form-field>\n\n            <div class=\"actions\">\n              <button\n                id=\"select-all-counties-btn\"\n                mat-flat-button\n                color=\"primary\"\n                (click)=\"toggleAll(true)\">\n                Select All\n                <mat-icon>done_all</mat-icon>\n              </button>\n              <button mat-flat-button (click)=\"toggleAll(false)\" id=\"clear-all-counties-btn\">\n                Clear All\n                <mat-icon>cancel</mat-icon>\n              </button>\n            </div>\n          </div>\n          <div>\n            <h2>States/Territories</h2>\n\n            @if (selectedStateControlsCount === 0) {\n              <h3 id=\"min-selection-err\">At least one state must be selected</h3>\n            }\n\n            @if (countiesThatMatchSearch.length) {\n              <div class=\"checkbox-list\">\n                <ng-container formArrayName=\"states\">\n                  @for (state of countiesThatMatchSearch; track state; let i = $index) {\n                    <ng-container [formGroup]=\"state\">\n                      <div class=\"state-wrapper\">\n                        <div class=\"county-header\">\n                          <h3>{{ state.value.name }}</h3>\n                          <div class=\"actions\">\n                            <button\n                              [id]=\"'select-all-for-state-' + state.value.name\"\n                              mat-mini-fab\n                              color=\"primary\"\n                              [matTooltip]=\"'Select All: ' + state.value.name\"\n                              (click)=\"toggleAll(true, state.value.state)\">\n                              <mat-icon>done_all</mat-icon>\n                            </button>\n                            <button\n                              [id]=\"'clear-all-for-state-' + state.value.name\"\n                              mat-mini-fab\n                              [matTooltip]=\"'Clear All: ' + state.value.name\"\n                              (click)=\"toggleAll(false, state.value.state)\">\n                              <mat-icon>cancel</mat-icon>\n                            </button>\n                          </div>\n                        </div>\n\n                        <div class=\"checkbox-list\">\n                          <ng-container formArrayName=\"counties\">\n                            @for (county of getCounties(state).controls; track county) {\n                              <ng-container [formGroup]=\"county\">\n                                @if (matchesSearch(county.value.name, true)) {\n                                  <mat-checkbox\n                                    [color]=\"m2CheckboxColor()\"\n                                    formControlName=\"checked\"\n                                    [id]=\"'county-checkbox-' + county.value.geoid\">\n                                    {{ county.value.name }}\n                                  </mat-checkbox>\n                                }\n                              </ng-container>\n                            }\n                          </ng-container>\n                        </div>\n                      </div>\n                    </ng-container>\n                  }\n                </ng-container>\n              </div>\n            } @else {\n              <h3>No county names match \"{{ countySearchValue }}\"</h3>\n            }\n          </div>\n        </mat-tab>\n      </mat-tab-group>\n    } @else {\n      <ng-container [ngTemplateOutlet]=\"states\"></ng-container>\n    }\n  </form>\n</div>\n\n<ng-template #states [formGroup]=\"locationForm\">\n  <div class=\"header\">\n    <mat-form-field appearance=\"outline\">\n      <mat-label>Search State Names</mat-label>\n      <input matInput formControlName=\"stateSearch\" id=\"search-state-names-input\" />\n    </mat-form-field>\n\n    <div class=\"actions\">\n      <button mat-flat-button color=\"primary\" (click)=\"toggleAll(true)\" id=\"select-all-states-btn\">\n        Select All\n        <mat-icon>done_all</mat-icon>\n      </button>\n      <button mat-flat-button (click)=\"toggleAll(false)\" id=\"clear-all-states-btn\">\n        Clear All\n        <mat-icon>cancel</mat-icon>\n      </button>\n    </div>\n  </div>\n  @if (showFemaRegions()) {\n    <div class=\"fema-regions-container\">\n      <h2>FEMA Regions</h2>\n      <div class=\"checkbox-list\">\n        <ng-container formArrayName=\"regions\">\n          @for (region of femaControls.controls; track region; let i = $index) {\n            <ng-container [formGroup]=\"region\">\n              <mat-checkbox\n                [color]=\"m2CheckboxColor()\"\n                [id]=\"'fema-region-checkbox-' + region.value.id\"\n                formControlName=\"checked\"\n                (change)=\"handleFemaToggle($event, region.value.region)\">\n                {{ region.value.name }}\n              </mat-checkbox>\n            </ng-container>\n          }\n        </ng-container>\n      </div>\n    </div>\n  }\n  <div class=\"states-container\">\n    <h2 id=\"total-selected-states\">\n      States/Territories\n      {{\n        selectedStateControlsCount > 0\n          ? \"(\" + (selectedStateControlsCount | number) + \" selected)\"\n          : \"\"\n      }}\n    </h2>\n\n    @if (statesThatMatchSearch.length) {\n      <div class=\"checkbox-list\">\n        <ng-container formArrayName=\"states\">\n          @for (state of statesThatMatchSearch; track state; let i = $index) {\n            <ng-container [formGroup]=\"state\">\n              <mat-checkbox\n                [color]=\"m2CheckboxColor()\"\n                [id]=\"'state-checkbox-' + state.value.geoid\"\n                formControlName=\"checked\"\n                (change)=\"handleStateToggle($event.checked, state)\">\n                {{ state.value.name }}\n              </mat-checkbox>\n            </ng-container>\n          }\n        </ng-container>\n      </div>\n    } @else {\n      <h3>No states match \"{{ stateSearchValue }}\"</h3>\n    }\n  </div>\n</ng-template>\n",
      styles: [".state-wrapper{display:flex;flex-direction:column;width:100%}.aggregation-info{display:flex;justify-content:space-between;flex-wrap:wrap;gap:1rem;margin-bottom:1.5rem}.aggregation-info .controls{display:flex;flex-direction:column}.aggregation-info p{width:60%;margin:0}.checkbox-list{display:flex;justify-content:flex-start;flex-wrap:wrap}.checkbox-list mat-checkbox{flex-basis:18%;flex-grow:1;margin:.5rem 0;max-width:160px}.checkbox-list button:last-of-type{margin-left:1rem}.header{display:flex;justify-content:space-between;align-items:center;margin-top:1rem;gap:1rem}.header mat-form-field{flex-grow:1}.header .actions{display:flex;gap:1rem;height:3.65rem}.county-header{display:flex;align-items:center;justify-content:space-between;margin-right:1rem}\n"]
    }]
  }], null, null);
})();
class ContentComponent {
  static {
    this.ɵfac = function ContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ContentComponent,
      selectors: [["vulcan-content"]],
      standalone: false,
      ngContentSelectors: _c5,
      decls: 1,
      vars: 0,
      template: function ContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContentComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-content',
      standalone: false,
      template: "<ng-content></ng-content>\n",
      styles: [":host{display:flex;flex-direction:column;height:100%}\n"]
    }]
  }], null, null);
})();
class SideNavService {
  constructor() {
    this._config = signal(undefined);
    this.config = this._config;
    this._sideNavOpen = signal(true);
    this.sideNavOpen = this._sideNavOpen;
  }
  toggleSideNav() {
    this._sideNavOpen.set(!this._sideNavOpen());
  }
  setConfig(config) {
    this._config.set(config);
    switch (config?.mode) {
      case 'open':
        this._sideNavOpen.set(true);
        break;
      case 'closed':
        this._sideNavOpen.set(false);
        break;
      case 'toggle':
        this._sideNavOpen.set(config?.initialToggleState === 'open');
        break;
    }
  }
  static {
    this.ɵfac = function SideNavService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SideNavService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SideNavService,
      factory: SideNavService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SideNavService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class BaseFeatureComponent {
  constructor() {
    this.sideNavService = inject(SideNavService);
    this.config = this.sideNavService.config;
    this.open = this.sideNavService.sideNavOpen;
  }
  static {
    this.ɵfac = function BaseFeatureComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BaseFeatureComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BaseFeatureComponent,
      selectors: [["vulcan-base-feature"]],
      standalone: false,
      decls: 0,
      vars: 0,
      template: function BaseFeatureComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFeatureComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-base-feature',
      template: ``,
      standalone: false
    }]
  }], null, null);
})();
class BaseFeatureWithIconComponent extends BaseFeatureComponent {
  constructor() {
    super(...arguments);
    this.icon = input();
    this.iconWeight = input('regular');
    this.hasIcon = computed(() => {
      return !!this.icon();
    });
    this.iconFontSize = computed(() => {
      return this.config()?.iconFontSize || '1.75rem';
    });
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵBaseFeatureWithIconComponent_BaseFactory;
      return function BaseFeatureWithIconComponent_Factory(__ngFactoryType__) {
        return (ɵBaseFeatureWithIconComponent_BaseFactory || (ɵBaseFeatureWithIconComponent_BaseFactory = i0.ɵɵgetInheritedFactory(BaseFeatureWithIconComponent)))(__ngFactoryType__ || BaseFeatureWithIconComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BaseFeatureWithIconComponent,
      selectors: [["vulcan-base-feature-with-icon"]],
      inputs: {
        icon: [1, "icon"],
        iconWeight: [1, "iconWeight"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function BaseFeatureWithIconComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFeatureWithIconComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-base-feature-with-icon',
      template: ``,
      standalone: false
    }]
  }], null, null);
})();
class BaseFeatureWithTextComponent extends BaseFeatureComponent {
  constructor() {
    super(...arguments);
    this.fontSize = computed(() => {
      return this.config()?.baseFontSize || '1rem';
    });
    this.displayText = input();
    this.textInitial = computed(() => {
      return this.displayText()?.[0];
    });
    this.toolTipText = computed(() => {
      return this.open() ? '' : this.displayText();
    });
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵBaseFeatureWithTextComponent_BaseFactory;
      return function BaseFeatureWithTextComponent_Factory(__ngFactoryType__) {
        return (ɵBaseFeatureWithTextComponent_BaseFactory || (ɵBaseFeatureWithTextComponent_BaseFactory = i0.ɵɵgetInheritedFactory(BaseFeatureWithTextComponent)))(__ngFactoryType__ || BaseFeatureWithTextComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BaseFeatureWithTextComponent,
      selectors: [["vulcan-base-feature-with-text"]],
      inputs: {
        displayText: [1, "displayText"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function BaseFeatureWithTextComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFeatureWithTextComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-base-feature-with-text',
      template: ``,
      standalone: false
    }]
  }], null, null);
})();
class BaseFeatureWithTextAndIconComponent extends BaseFeatureWithIconComponent {
  constructor() {
    super(...arguments);
    this.fontSize = computed(() => {
      return this.config()?.baseFontSize || '1rem';
    });
    this.displayText = input();
    this.textInitial = computed(() => {
      return this.displayText()?.[0];
    });
    this.toolTipText = computed(() => {
      return this.open() ? '' : this.displayText();
    });
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵBaseFeatureWithTextAndIconComponent_BaseFactory;
      return function BaseFeatureWithTextAndIconComponent_Factory(__ngFactoryType__) {
        return (ɵBaseFeatureWithTextAndIconComponent_BaseFactory || (ɵBaseFeatureWithTextAndIconComponent_BaseFactory = i0.ɵɵgetInheritedFactory(BaseFeatureWithTextAndIconComponent)))(__ngFactoryType__ || BaseFeatureWithTextAndIconComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BaseFeatureWithTextAndIconComponent,
      selectors: [["vulcan-base-feature-with-text-and-icon"]],
      inputs: {
        displayText: [1, "displayText"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function BaseFeatureWithTextAndIconComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFeatureWithTextAndIconComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-base-feature-with-text-and-icon',
      template: ``,
      standalone: false
    }]
  }], null, null);
})();
class HeaderComponent extends BaseFeatureWithTextAndIconComponent {
  constructor() {
    super(...arguments);
    this.headerImagePath = input();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵHeaderComponent_BaseFactory;
      return function HeaderComponent_Factory(__ngFactoryType__) {
        return (ɵHeaderComponent_BaseFactory || (ɵHeaderComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HeaderComponent)))(__ngFactoryType__ || HeaderComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HeaderComponent,
      selectors: [["vulcan-side-nav-header"]],
      inputs: {
        headerImagePath: [1, "headerImagePath"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 8,
      consts: [[3, "ngClass", "matTooltip"], [3, "src", "ngClass"]],
      template: function HeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "header", 0);
          i0.ɵɵtemplate(1, HeaderComponent_Conditional_1_Template, 1, 5, "img", 1)(2, HeaderComponent_Conditional_2_Template, 1, 1)(3, HeaderComponent_Conditional_3_Template, 1, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(4, "vulcan-divider");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c6, ctx.open(), !ctx.displayText()))("matTooltip", ctx.toolTipText());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.headerImagePath() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.open() && ctx.displayText() ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.open() && !ctx.hasIcon() && !ctx.headerImagePath() ? 3 : -1);
        }
      },
      dependencies: [i1.NgClass, VulcanDividerComponent, i10.MatTooltip],
      styles: ["header[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center;justify-content:center;padding:1rem .5rem 0;font-size:1.5rem;font-weight:700}header.open[_ngcontent-%COMP%]{justify-content:flex-start}header.icon-only[_ngcontent-%COMP%]{justify-content:center}header[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:2rem;height:2rem}header[_ngcontent-%COMP%]   img.icon-only[_ngcontent-%COMP%]{width:3rem;height:3rem}header[_ngcontent-%COMP%]   img.open[_ngcontent-%COMP%]{width:2.5rem;height:2.5rem;margin-right:.5rem}header[_ngcontent-%COMP%]   img.open.icon-only[_ngcontent-%COMP%]{width:4rem;height:4rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-side-nav-header',
      standalone: false,
      template: "<header [ngClass]=\"{ open: open(), 'icon-only': !displayText() }\" [matTooltip]=\"toolTipText()\">\n  @if (headerImagePath()) {\n    <img [src]=\"headerImagePath()\" [ngClass]=\"{ open: open(), 'icon-only': !displayText() }\" />\n  }\n  @if (open() && displayText()) {\n    {{ displayText() }}\n  }\n  @if (!open() && !hasIcon() && !headerImagePath()) {\n    {{ textInitial() }}\n  }\n</header>\n\n<vulcan-divider></vulcan-divider>\n",
      styles: ["header{display:flex;justify-content:flex-start;align-items:center;justify-content:center;padding:1rem .5rem 0;font-size:1.5rem;font-weight:700}header.open{justify-content:flex-start}header.icon-only{justify-content:center}header img{width:2rem;height:2rem}header img.icon-only{width:3rem;height:3rem}header img.open{width:2.5rem;height:2.5rem;margin-right:.5rem}header img.open.icon-only{width:4rem;height:4rem}\n"]
    }]
  }], null, null);
})();
class MenuNavHeaderComponent extends BaseFeatureWithTextAndIconComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMenuNavHeaderComponent_BaseFactory;
      return function MenuNavHeaderComponent_Factory(__ngFactoryType__) {
        return (ɵMenuNavHeaderComponent_BaseFactory || (ɵMenuNavHeaderComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MenuNavHeaderComponent)))(__ngFactoryType__ || MenuNavHeaderComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MenuNavHeaderComponent,
      selectors: [["vulcan-menu-nav-header"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 7,
      consts: [[1, "menu-nav-header", 3, "ngClass", "matTooltip"], [3, "icon", "weight", "size"]],
      template: function MenuNavHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, MenuNavHeaderComponent_Conditional_1_Template, 1, 3, "vulcan-icon", 1)(2, MenuNavHeaderComponent_Conditional_2_Template, 1, 1)(3, MenuNavHeaderComponent_Conditional_3_Template, 1, 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c7, ctx.open()))("matTooltip", ctx.toolTipText());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.hasIcon() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.open() ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.hasIcon() && !ctx.open() ? 3 : -1);
        }
      },
      dependencies: [i1.NgClass, VulcanIconComponent, i10.MatTooltip],
      styles: ["a[_ngcontent-%COMP%], .nav-item-context[_ngcontent-%COMP%], button[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;font-family:Mulish,Roboto,sans-serif;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);font-size:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) + .15rem);font-weight:700;background-color:transparent}a[_ngcontent-%COMP%]{width:100%;text-decoration:none;height:100%}a[_ngcontent-%COMP%]   vulcan-icon[_ngcontent-%COMP%]{margin-right:.5rem}a.open[_ngcontent-%COMP%]   vulcan-icon[_ngcontent-%COMP%]{margin-right:0;margin-left:.25rem}.nav-item-context[_ngcontent-%COMP%], button[_ngcontent-%COMP%]{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);margin:.5rem 0;width:100%;text-align:left;border:none;cursor:pointer;border:1px solid transparent;transition:background-color .25s ease}.nav-item-context[_ngcontent-%COMP%]:hover, button[_ngcontent-%COMP%]:hover{border-radius:0 5px 5px 0;background-color:var(--vulcan-side-nav-hover-color, --vulcan-secondary-subtle);--border: 1px solid var(--vulcan-side-nav-hover-border-color, --vulcan-secondary-gentle)}.nav-item-context[_ngcontent-%COMP%]:hover:not(.active-nav), button[_ngcontent-%COMP%]:hover:not(.active-nav){border:var(--border)}.nav-item-context[_ngcontent-%COMP%]:hover:has(.active-nav), button[_ngcontent-%COMP%]:hover:has(.active-nav){border-top:var(--border);border-bottom:var(--border);border-right:var(--border)}", ".menu-nav-header[_ngcontent-%COMP%]{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);display:flex;align-items:center;gap:.5rem;margin-left:0}.menu-nav-header.open[_ngcontent-%COMP%]{margin-left:.25rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuNavHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-menu-nav-header',
      standalone: false,
      template: "<div class=\"menu-nav-header\" [ngClass]=\"{ open: open() }\" [matTooltip]=\"toolTipText()\">\n  @if (hasIcon()) {\n    <vulcan-icon [icon]=\"icon()\" [weight]=\"iconWeight()\" [size]=\"iconFontSize()\"></vulcan-icon>\n  }\n  @if (open()) {\n    {{ displayText() }}\n  }\n  @if (!hasIcon() && !open()) {\n    {{ textInitial() }}\n  }\n</div>\n",
      styles: ["a,.nav-item-context,button{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;font-family:Mulish,Roboto,sans-serif;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);font-size:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) + .15rem);font-weight:700;background-color:transparent}a{width:100%;text-decoration:none;height:100%}a vulcan-icon{margin-right:.5rem}a.open vulcan-icon{margin-right:0;margin-left:.25rem}.nav-item-context,button{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);margin:.5rem 0;width:100%;text-align:left;border:none;cursor:pointer;border:1px solid transparent;transition:background-color .25s ease}.nav-item-context:hover,button:hover{border-radius:0 5px 5px 0;background-color:var(--vulcan-side-nav-hover-color, --vulcan-secondary-subtle);--border: 1px solid var(--vulcan-side-nav-hover-border-color, --vulcan-secondary-gentle)}.nav-item-context:hover:not(.active-nav),button:hover:not(.active-nav){border:var(--border)}.nav-item-context:hover:has(.active-nav),button:hover:has(.active-nav){border-top:var(--border);border-bottom:var(--border);border-right:var(--border)}\n", ".menu-nav-header{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);display:flex;align-items:center;gap:.5rem;margin-left:0}.menu-nav-header.open{margin-left:.25rem}\n"]
    }]
  }], null, null);
})();
class MenuNavComponent extends BaseFeatureComponent {
  constructor() {
    super(...arguments);
    this.parentRoute = input.required();
    this.parentRouteActive = signal(false);
    this.route = inject(Router);
    this.menuOpen = signal(false);
  }
  ngOnInit() {
    this.route.events.subscribe(c => {
      if (c instanceof NavigationEnd) {
        const route = c.url.split('/');
        this.parentRouteActive.set(route[1] === this.parentRoute());
      }
    });
  }
  toggleMenu() {
    this.menuOpen.set(!this.menuOpen());
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMenuNavComponent_BaseFactory;
      return function MenuNavComponent_Factory(__ngFactoryType__) {
        return (ɵMenuNavComponent_BaseFactory || (ɵMenuNavComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MenuNavComponent)))(__ngFactoryType__ || MenuNavComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MenuNavComponent,
      selectors: [["vulcan-menu-nav"]],
      inputs: {
        parentRoute: [1, "parentRoute"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c9,
      decls: 6,
      vars: 1,
      consts: [["menuHeader", ""], ["navItems", ""], ["menuItems", "matMenu"], [3, "click", "ngClass"], [4, "ngTemplateOutlet"], [3, "icon"], [1, "menu-items", 3, "ngClass"], [3, "ngClass", "matMenuTriggerFor"], ["xPosition", "after", 1, "menu-items"]],
      template: function MenuNavComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c8);
          i0.ɵɵtemplate(0, MenuNavComponent_Conditional_0_Template, 5, 9)(1, MenuNavComponent_Conditional_1_Template, 5, 6)(2, MenuNavComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, MenuNavComponent_ng_template_4_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.open() ? 0 : 1);
        }
      },
      dependencies: [i1.NgClass, i1.NgTemplateOutlet, i2$1.MatMenu, i2$1.MatMenuTrigger, VulcanIconComponent],
      styles: [_c11, "button[_ngcontent-%COMP%]{width:100%;justify-content:flex-start;padding-left:1rem;border-radius:0;height:fit-content}button[_ngcontent-%COMP%]   vulcan-icon[_ngcontent-%COMP%]{margin-left:auto;margin-right:1rem}.active-nav[_ngcontent-%COMP%]{--padding-left: 1rem;--active-border-width: 5px;border-left:var(--active-border-width) solid var(--vulcan-side-nav-active-route-color, --vulcan-secondary-strong);padding-left:calc(var(--padding-left) - var(--active-border-width))}.menu-items[_ngcontent-%COMP%]{display:none}.menu-items.open[_ngcontent-%COMP%]{display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuNavComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-menu-nav',
      standalone: false,
      template: "@if (open()) {\n  <button [ngClass]=\"{ 'active-nav': parentRouteActive() }\" (click)=\"toggleMenu()\">\n    <ng-container *ngTemplateOutlet=\"menuHeader\"></ng-container>\n    <vulcan-icon [icon]=\"menuOpen() ? 'caret-up' : 'caret-down'\"></vulcan-icon>\n  </button>\n\n  <div class=\"menu-items\" [ngClass]=\"{ open: menuOpen() }\">\n    <ng-container *ngTemplateOutlet=\"navItems\"></ng-container>\n  </div>\n} @else {\n  <button [ngClass]=\"{ 'active-nav': parentRouteActive() }\" [matMenuTriggerFor]=\"menuItems\">\n    <ng-container *ngTemplateOutlet=\"menuHeader\"></ng-container>\n  </button>\n\n  <mat-menu #menuItems=\"matMenu\" class=\"menu-items\" xPosition=\"after\">\n    <ng-container *ngTemplateOutlet=\"navItems\"></ng-container>\n  </mat-menu>\n}\n\n<ng-template #menuHeader>\n  <ng-content select=\"vulcan-menu-nav-header\"></ng-content>\n</ng-template>\n\n<ng-template #navItems>\n  <ng-content select=\"vulcan-nav-menu-item\"></ng-content>\n</ng-template>\n",
      styles: ["a,.nav-item-context,button{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;font-family:Mulish,Roboto,sans-serif;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);font-size:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) + .15rem);font-weight:700;background-color:transparent}a{width:100%;text-decoration:none;height:100%}a vulcan-icon{margin-right:.5rem}a.open vulcan-icon{margin-right:0;margin-left:.25rem}.nav-item-context,button{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);margin:.5rem 0;width:100%;text-align:left;border:none;cursor:pointer;border:1px solid transparent;transition:background-color .25s ease}.nav-item-context:hover,button:hover{border-radius:0 5px 5px 0;background-color:var(--vulcan-side-nav-hover-color, --vulcan-secondary-subtle);--border: 1px solid var(--vulcan-side-nav-hover-border-color, --vulcan-secondary-gentle)}.nav-item-context:hover:not(.active-nav),button:hover:not(.active-nav){border:var(--border)}.nav-item-context:hover:has(.active-nav),button:hover:has(.active-nav){border-top:var(--border);border-bottom:var(--border);border-right:var(--border)}\n", "button{width:100%;justify-content:flex-start;padding-left:1rem;border-radius:0;height:fit-content}button vulcan-icon{margin-left:auto;margin-right:1rem}.active-nav{--padding-left: 1rem;--active-border-width: 5px;border-left:var(--active-border-width) solid var(--vulcan-side-nav-active-route-color, --vulcan-secondary-strong);padding-left:calc(var(--padding-left) - var(--active-border-width))}.menu-items{display:none}.menu-items.open{display:block}\n"]
    }]
  }], null, null);
})();
class NavItemComponent extends BaseFeatureWithTextAndIconComponent {
  constructor() {
    super(...arguments);
    /**
     * The path passed to the `routerLink` directive
     */
    this.route = input();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵNavItemComponent_BaseFactory;
      return function NavItemComponent_Factory(__ngFactoryType__) {
        return (ɵNavItemComponent_BaseFactory || (ɵNavItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(NavItemComponent)))(__ngFactoryType__ || NavItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavItemComponent,
      selectors: [["vulcan-nav-item"]],
      inputs: {
        route: [1, "route"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 6,
      vars: 13,
      consts: [[1, "nav-item-context", 3, "ngClass", "matTooltip"], ["routerLinkActive", "active-nav", 3, "routerLink", "ngClass"], [3, "icon", "weight", "size"], [3, "ngClass"]],
      template: function NavItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
          i0.ɵɵtemplate(2, NavItemComponent_Conditional_2_Template, 1, 3, "vulcan-icon", 2);
          i0.ɵɵelementStart(3, "span", 3);
          i0.ɵɵtemplate(4, NavItemComponent_Conditional_4_Template, 1, 1)(5, NavItemComponent_Conditional_5_Template, 1, 1);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c12, ctx.hasIcon()))("matTooltip", ctx.toolTipText());
          i0.ɵɵadvance();
          i0.ɵɵproperty("routerLink", ctx.route())("ngClass", i0.ɵɵpureFunction1(9, _c7, ctx.open()));
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.hasIcon() ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c13, !ctx.hasIcon()));
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.open() ? 4 : !ctx.open() && !ctx.hasIcon() ? 5 : -1);
        }
      },
      dependencies: [i1.NgClass, i2$2.RouterLink, i2$2.RouterLinkActive, VulcanIconComponent, i10.MatTooltip],
      styles: [_c11, ".nav-item-context[_ngcontent-%COMP%]{--padding-left: 1rem;--active-border-width: 5px}.nav-item-context[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{border-radius:0;padding-left:var(--padding-left)}.nav-item-context[_ngcontent-%COMP%]   span.no-icon[_ngcontent-%COMP%]{margin-left:.25rem}.nav-item-context[_ngcontent-%COMP%]   .active-nav[_ngcontent-%COMP%]{border-left:var(--active-border-width) solid var(--vulcan-side-nav-active-route-color, --vulcan-secondary-strong);padding-left:calc(var(--padding-left) - var(--active-border-width))!important}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavItemComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-nav-item',
      standalone: false,
      template: "<div class=\"nav-item-context\" [ngClass]=\"{ 'has-icon': hasIcon() }\" [matTooltip]=\"toolTipText()\">\n  <a [routerLink]=\"route()\" routerLinkActive=\"active-nav\" [ngClass]=\"{ open: open() }\">\n    @if (hasIcon()) {\n      <vulcan-icon [icon]=\"icon()\" [weight]=\"iconWeight()\" [size]=\"iconFontSize()\"></vulcan-icon>\n    }\n    <span [ngClass]=\"{ 'no-icon': !hasIcon() }\">\n      @if (open()) {\n        {{ displayText() }}\n      } @else if (!open() && !hasIcon()) {\n        {{ textInitial() }}\n      }\n    </span>\n  </a>\n</div>\n",
      styles: ["a,.nav-item-context,button{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;font-family:Mulish,Roboto,sans-serif;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);font-size:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) + .15rem);font-weight:700;background-color:transparent}a{width:100%;text-decoration:none;height:100%}a vulcan-icon{margin-right:.5rem}a.open vulcan-icon{margin-right:0;margin-left:.25rem}.nav-item-context,button{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);margin:.5rem 0;width:100%;text-align:left;border:none;cursor:pointer;border:1px solid transparent;transition:background-color .25s ease}.nav-item-context:hover,button:hover{border-radius:0 5px 5px 0;background-color:var(--vulcan-side-nav-hover-color, --vulcan-secondary-subtle);--border: 1px solid var(--vulcan-side-nav-hover-border-color, --vulcan-secondary-gentle)}.nav-item-context:hover:not(.active-nav),button:hover:not(.active-nav){border:var(--border)}.nav-item-context:hover:has(.active-nav),button:hover:has(.active-nav){border-top:var(--border);border-bottom:var(--border);border-right:var(--border)}\n", ".nav-item-context{--padding-left: 1rem;--active-border-width: 5px}.nav-item-context a{border-radius:0;padding-left:var(--padding-left)}.nav-item-context span.no-icon{margin-left:.25rem}.nav-item-context .active-nav{border-left:var(--active-border-width) solid var(--vulcan-side-nav-active-route-color, --vulcan-secondary-strong);padding-left:calc(var(--padding-left) - var(--active-border-width))!important}\n"]
    }]
  }], null, null);
})();
class NavMenuItemComponent extends BaseFeatureWithTextAndIconComponent {
  constructor() {
    super(...arguments);
    /**
     * The path passed to the `routerLink` directive
     */
    this.route = input();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵNavMenuItemComponent_BaseFactory;
      return function NavMenuItemComponent_Factory(__ngFactoryType__) {
        return (ɵNavMenuItemComponent_BaseFactory || (ɵNavMenuItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(NavMenuItemComponent)))(__ngFactoryType__ || NavMenuItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavMenuItemComponent,
      selectors: [["vulcan-nav-menu-item"]],
      inputs: {
        route: [1, "route"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 3,
      consts: [[1, "nav-item-context"], ["routerLinkActive", "active-nav", 3, "routerLink"], [3, "weight", "size", "icon"]],
      template: function NavMenuItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
          i0.ɵɵtemplate(2, NavMenuItemComponent_Conditional_2_Template, 1, 3, "vulcan-icon", 2);
          i0.ɵɵelementStart(3, "span");
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("routerLink", ctx.route());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.hasIcon() ? 2 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.displayText());
        }
      },
      dependencies: [i2$2.RouterLink, i2$2.RouterLinkActive, VulcanIconComponent],
      styles: [_c11, ".nav-item-context[_ngcontent-%COMP%]{height:1.5rem;--padding-left: 1rem;--active-border-width: 2px}.nav-item-context[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:.75rem;margin-left:2rem;width:calc(var(--vulcan-side-nav-side-nav-open-width) - 2.5rem);padding:.25rem 0 -1px}.nav-item-context[_ngcontent-%COMP%]   .active-nav[_ngcontent-%COMP%]{border-bottom:var(--active-border-width) solid var(--vulcan-side-nav-active-route-color, --vulcan-secondary-strong)}.nav-item-context[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:calc(var(--max-width) - 3rem)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavMenuItemComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-nav-menu-item',
      standalone: false,
      template: "<div class=\"nav-item-context\">\n  <a [routerLink]=\"route()\" routerLinkActive=\"active-nav\">\n    @if (hasIcon()) {\n      <vulcan-icon [weight]=\"iconWeight()\" [size]=\"iconFontSize()\" [icon]=\"icon()\"></vulcan-icon>\n    }\n\n    <span>{{ displayText() }}</span>\n  </a>\n</div>\n",
      styles: ["a,.nav-item-context,button{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;font-family:Mulish,Roboto,sans-serif;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);font-size:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) + .15rem);font-weight:700;background-color:transparent}a{width:100%;text-decoration:none;height:100%}a vulcan-icon{margin-right:.5rem}a.open vulcan-icon{margin-right:0;margin-left:.25rem}.nav-item-context,button{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);margin:.5rem 0;width:100%;text-align:left;border:none;cursor:pointer;border:1px solid transparent;transition:background-color .25s ease}.nav-item-context:hover,button:hover{border-radius:0 5px 5px 0;background-color:var(--vulcan-side-nav-hover-color, --vulcan-secondary-subtle);--border: 1px solid var(--vulcan-side-nav-hover-border-color, --vulcan-secondary-gentle)}.nav-item-context:hover:not(.active-nav),button:hover:not(.active-nav){border:var(--border)}.nav-item-context:hover:has(.active-nav),button:hover:has(.active-nav){border-top:var(--border);border-bottom:var(--border);border-right:var(--border)}\n", ".nav-item-context{height:1.5rem;--padding-left: 1rem;--active-border-width: 2px}.nav-item-context a{font-size:.75rem;margin-left:2rem;width:calc(var(--vulcan-side-nav-side-nav-open-width) - 2.5rem);padding:.25rem 0 -1px}.nav-item-context .active-nav{border-bottom:var(--active-border-width) solid var(--vulcan-side-nav-active-route-color, --vulcan-secondary-strong)}.nav-item-context span{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:calc(var(--max-width) - 3rem)}\n"]
    }]
  }], null, null);
})();
class SideNavComponent {
  toggleSideNav() {
    this.sideNavService.toggleSideNav();
  }
  constructor() {
    this.config = input();
    this.sideNavService = inject(SideNavService);
    this.open = this.sideNavService.sideNavOpen;
    this.mode = computed(() => {
      return this.config()?.mode || 'toggle';
    });
    effect(() => {
      this.sideNavService.setConfig(this.config());
    });
  }
  static {
    this.ɵfac = function SideNavComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SideNavComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SideNavComponent,
      selectors: [["vulcan-side-nav"]],
      inputs: {
        config: [1, "config"]
      },
      standalone: false,
      ngContentSelectors: _c15,
      decls: 8,
      vars: 13,
      consts: [[1, "vulcan-side-nav-container", 3, "ngStyle"], [1, "vulcan-side-nav", 3, "ngClass"], ["role", "button", "tabindex", "0", 1, "toggle"], ["id", "vulcan-side-nav"], [1, "vulcan-side-nav-content"], ["role", "button", "tabindex", "0", 1, "toggle", 3, "click"], ["size", "2rem", 3, "icon"]],
      template: function SideNavComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c14);
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, SideNavComponent_Conditional_2_Template, 2, 1, "div", 2);
          i0.ɵɵprojection(3);
          i0.ɵɵelementStart(4, "nav", 3);
          i0.ɵɵprojection(5, 1);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 4);
          i0.ɵɵprojection(7, 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction7(3, _c16, (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.baseFontSize, (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.backgroundColor, (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.activeRouteColor, (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.fontColor, (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.openWidth, (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.hoverColor, (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.hoverBorderColor));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c17, ctx.open()));
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.mode() === "toggle" ? 2 : -1);
        }
      },
      dependencies: [i1.NgClass, i1.NgStyle, VulcanIconComponent],
      styles: [_c11, ".vulcan-side-nav-container[_ngcontent-%COMP%]{--vulcan-side-nav-side-nav-open-width: 200px;display:flex;height:100%}.vulcan-side-nav-container[_ngcontent-%COMP%]   .vulcan-side-nav[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:relative;background-color:var(--vulcan-side-nav-background-color, --vulcan-secondary-weak);box-shadow:0 2px 12px #00000080;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);--closed-width: calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 4);--divider-width: calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);width:var(--closed-width);min-width:var(--closed-width);max-width:var(--closed-width)}.vulcan-side-nav-container[_ngcontent-%COMP%]   .vulcan-side-nav.nav-open[_ngcontent-%COMP%]{--divider-width: var(--vulcan-side-nav-side-nav-open-width);width:var(--vulcan-side-nav-side-nav-open-width);min-width:var(--vulcan-side-nav-side-nav-open-width);max-width:var(--vulcan-side-nav-side-nav-open-width)}.vulcan-side-nav-container[_ngcontent-%COMP%]   .vulcan-side-nav[_ngcontent-%COMP%]   nav[_ngcontent-%COMP%]{display:flex;flex-direction:column}.vulcan-side-nav-container[_ngcontent-%COMP%]   .vulcan-side-nav[_ngcontent-%COMP%]   vulcan-divider[_ngcontent-%COMP%]{width:calc(var(--vulcan-side-nav-side-nav-open-width) * .8)}.vulcan-side-nav-container[_ngcontent-%COMP%]   .vulcan-side-nav[_ngcontent-%COMP%]   .toggle[_ngcontent-%COMP%]{cursor:pointer;position:absolute;right:-1.5rem;top:1.5rem;background-color:var(--vulcan-side-nav-background-color);border-radius:5px}.vulcan-side-nav-container[_ngcontent-%COMP%]   .vulcan-side-nav-content[_ngcontent-%COMP%]{flex-grow:1}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SideNavComponent, [{
    type: Component,
    args: [{
      selector: 'vulcan-side-nav',
      standalone: false,
      template: "<div\n  class=\"vulcan-side-nav-container\"\n  [ngStyle]=\"{\n    '--vulcan-side-nav-base-font-size': config()?.baseFontSize,\n    '--vulcan-side-nav-background-color': config()?.backgroundColor,\n    '--vulcan-side-nav-active-route-color': config()?.activeRouteColor,\n    '--vulcan-side-nav-font-color': config()?.fontColor,\n    '--vulcan-side-nav-side-nav-open-width': config()?.openWidth,\n    '--vulcan-side-nav-hover-color': config()?.hoverColor,\n    '--vulcan-side-nav-hover-border-color': config()?.hoverBorderColor,\n  }\">\n  <div class=\"vulcan-side-nav\" [ngClass]=\"{ 'nav-open': open() }\">\n    @if (mode() === \"toggle\") {\n      <div class=\"toggle\" role=\"button\" tabindex=\"0\" (click)=\"toggleSideNav()\">\n        <vulcan-icon [icon]=\"open() ? 'caret-left' : 'caret-right'\" size=\"2rem\"></vulcan-icon>\n      </div>\n    }\n\n    <ng-content select=\"vulcan-side-nav-header\"></ng-content>\n\n    <nav id=\"vulcan-side-nav\">\n      <ng-content></ng-content>\n    </nav>\n  </div>\n\n  <div class=\"vulcan-side-nav-content\">\n    <ng-content select=\"vulcan-content\"></ng-content>\n  </div>\n</div>\n",
      styles: ["a,.nav-item-context,button{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;font-family:Mulish,Roboto,sans-serif;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);font-size:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) + .15rem);font-weight:700;background-color:transparent}a{width:100%;text-decoration:none;height:100%}a vulcan-icon{margin-right:.5rem}a.open vulcan-icon{margin-right:0;margin-left:.25rem}.nav-item-context,button{height:calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);margin:.5rem 0;width:100%;text-align:left;border:none;cursor:pointer;border:1px solid transparent;transition:background-color .25s ease}.nav-item-context:hover,button:hover{border-radius:0 5px 5px 0;background-color:var(--vulcan-side-nav-hover-color, --vulcan-secondary-subtle);--border: 1px solid var(--vulcan-side-nav-hover-border-color, --vulcan-secondary-gentle)}.nav-item-context:hover:not(.active-nav),button:hover:not(.active-nav){border:var(--border)}.nav-item-context:hover:has(.active-nav),button:hover:has(.active-nav){border-top:var(--border);border-bottom:var(--border);border-right:var(--border)}\n", ".vulcan-side-nav-container{--vulcan-side-nav-side-nav-open-width: 200px;display:flex;height:100%}.vulcan-side-nav-container .vulcan-side-nav{display:flex;flex-direction:column;position:relative;background-color:var(--vulcan-side-nav-background-color, --vulcan-secondary-weak);box-shadow:0 2px 12px #00000080;color:var(--vulcan-side-nav-font-color, --vulcan-text-black);--closed-width: calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 4);--divider-width: calc(var(--vulcan-side-nav-base-font-size, --ornl-font-size) * 2);width:var(--closed-width);min-width:var(--closed-width);max-width:var(--closed-width)}.vulcan-side-nav-container .vulcan-side-nav.nav-open{--divider-width: var(--vulcan-side-nav-side-nav-open-width);width:var(--vulcan-side-nav-side-nav-open-width);min-width:var(--vulcan-side-nav-side-nav-open-width);max-width:var(--vulcan-side-nav-side-nav-open-width)}.vulcan-side-nav-container .vulcan-side-nav nav{display:flex;flex-direction:column}.vulcan-side-nav-container .vulcan-side-nav vulcan-divider{width:calc(var(--vulcan-side-nav-side-nav-open-width) * .8)}.vulcan-side-nav-container .vulcan-side-nav .toggle{cursor:pointer;position:absolute;right:-1.5rem;top:1.5rem;background-color:var(--vulcan-side-nav-background-color);border-radius:5px}.vulcan-side-nav-container .vulcan-side-nav-content{flex-grow:1}\n"]
    }]
  }], () => [], null);
})();
class SideNavModule {
  static {
    this.ɵfac = function SideNavModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SideNavModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SideNavModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
        useValue: {
          showDelay: 500,
          position: 'right'
        }
      }],
      imports: [CommonModule, RouterModule, MatMenuModule, MatButtonModule, MatSidenavModule, VulcanDividerComponent, VulcanIconComponent, MatTooltipModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SideNavModule, [{
    type: NgModule,
    args: [{
      declarations: [SideNavComponent, MenuNavComponent, MenuNavHeaderComponent, NavItemComponent, ContentComponent, HeaderComponent, NavMenuItemComponent, BaseFeatureComponent],
      imports: [CommonModule, RouterModule, MatMenuModule, MatButtonModule, MatSidenavModule, VulcanDividerComponent, VulcanIconComponent, MatTooltipModule],
      exports: [SideNavComponent, MenuNavComponent, MenuNavHeaderComponent, NavItemComponent, ContentComponent, HeaderComponent, NavMenuItemComponent],
      providers: [{
        provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
        useValue: {
          showDelay: 500,
          position: 'right'
        }
      }]
    }]
  }], null, null);
})();
class VulcanLogPipe {
  transform(value, label) {
    console.log(label ? label : 'Vulcan Log: ', value);
  }
  static {
    this.ɵfac = function VulcanLogPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VulcanLogPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "log",
      type: VulcanLogPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VulcanLogPipe, [{
    type: Pipe,
    args: [{
      name: 'log',
      standalone: true
    }]
  }], null, null);
})();

/*
 * Public API Surface of Vulcan
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ContentComponent, HeaderComponent, LocationFilterComponent, MaxLogLevel, MenuNavComponent, MenuNavHeaderComponent, NavItemComponent, NavMenuItemComponent, SideNavComponent, SideNavModule, SideNavService, TabIndexes, UtilsService, VULCAN_DEFAULT_AGGREGATION_LEVELS, VULCAN_DEFAULT_DATE_TIME_PICKER_CONFIG, VULCAN_DEFAULT_FEMA_REGIONS, VULCAN_DEFAULT_STATE_AND_COUNTIES, VulcanDateTimePickerComponent, VulcanDividerComponent, VulcanIconComponent, VulcanLocationFilterComponent, VulcanLogPipe, VulcanLoggerModule, VulcanLoggerService };
